import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AiSearchAutoEval = {
  __typename?: 'AiSearchAutoEval';
  actualArgs?: Maybe<Scalars['Json']['output']>;
  actualCallCount?: Maybe<Scalars['Int']['output']>;
  actualEntity?: Maybe<Scalars['String']['output']>;
  actualTool?: Maybe<Scalars['String']['output']>;
  condition: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  disambiguationResponse?: Maybe<Scalars['String']['output']>;
  disambiguationType?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  errorType?: Maybe<Scalars['String']['output']>;
  evaluatedAt: Scalars['DateTime']['output'];
  expectedEntity: Scalars['String']['output'];
  expectedTool: Scalars['String']['output'];
  hadDisambiguation: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  includeExamples: Scalars['Boolean']['output'];
  includeSchema: Scalars['Boolean']['output'];
  judgeEvaluation?: Maybe<Scalars['Json']['output']>;
  l1Pass: Scalars['Boolean']['output'];
  l2Pass?: Maybe<Scalars['Boolean']['output']>;
  l3Efficiency?: Maybe<Scalars['Int']['output']>;
  l4Redundancy?: Maybe<Scalars['Int']['output']>;
  l5Disambiguation?: Maybe<Scalars['Int']['output']>;
  l6ResponseQuality?: Maybe<Scalars['Int']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  llmCallCount: Scalars['Int']['output'];
  llmResponse?: Maybe<Scalars['String']['output']>;
  optimalCallCount?: Maybe<Scalars['Int']['output']>;
  overallScore?: Maybe<Scalars['Int']['output']>;
  pathType?: Maybe<Scalars['String']['output']>;
  patternsApplied?: Maybe<Array<Scalars['String']['output']>>;
  query: Scalars['String']['output'];
  queryIndex: Scalars['Int']['output'];
  redundantCalls?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  runId: Scalars['String']['output'];
  sequenceMatchedOptimal?: Maybe<Scalars['Boolean']['output']>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  tokenCount?: Maybe<Scalars['Int']['output']>;
  toolCallCount: Scalars['Int']['output'];
  toolCalls?: Maybe<Scalars['Json']['output']>;
  totalTimeMs: Scalars['Int']['output'];
  version_: Scalars['String']['output'];
};

export type AiSearchAutoEval_Filter = {
  AND?: InputMaybe<Array<AiSearchAutoEval_Filter>>;
  NOT?: InputMaybe<Array<AiSearchAutoEval_Filter>>;
  OR?: InputMaybe<Array<AiSearchAutoEval_Filter>>;
  actualArgs?: InputMaybe<FilterJson>;
  actualCallCount?: InputMaybe<FilterInt>;
  actualEntity?: InputMaybe<FilterString>;
  actualTool?: InputMaybe<FilterString>;
  condition?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  disambiguationResponse?: InputMaybe<FilterString>;
  disambiguationType?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  errorType?: InputMaybe<FilterString>;
  evaluatedAt?: InputMaybe<FilterDateTime>;
  expectedEntity?: InputMaybe<FilterString>;
  expectedTool?: InputMaybe<FilterString>;
  hadDisambiguation?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  includeExamples?: InputMaybe<FilterBoolean>;
  includeSchema?: InputMaybe<FilterBoolean>;
  judgeEvaluation?: InputMaybe<FilterJson>;
  l1Pass?: InputMaybe<FilterBoolean>;
  l2Pass?: InputMaybe<FilterBoolean>;
  l3Efficiency?: InputMaybe<FilterInt>;
  l4Redundancy?: InputMaybe<FilterInt>;
  l5Disambiguation?: InputMaybe<FilterInt>;
  l6ResponseQuality?: InputMaybe<FilterInt>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  llmCallCount?: InputMaybe<FilterInt>;
  llmResponse?: InputMaybe<FilterString>;
  optimalCallCount?: InputMaybe<FilterInt>;
  overallScore?: InputMaybe<FilterInt>;
  pathType?: InputMaybe<FilterString>;
  patternsApplied?: InputMaybe<FilterStringList>;
  query?: InputMaybe<FilterString>;
  queryIndex?: InputMaybe<FilterInt>;
  redundantCalls?: InputMaybe<FilterInt>;
  response?: InputMaybe<FilterString>;
  runId?: InputMaybe<FilterString>;
  sequenceMatchedOptimal?: InputMaybe<FilterBoolean>;
  tokenCount?: InputMaybe<FilterInt>;
  toolCallCount?: InputMaybe<FilterInt>;
  toolCalls?: InputMaybe<FilterJson>;
  totalTimeMs?: InputMaybe<FilterInt>;
  version_?: InputMaybe<FilterString>;
};

export type AiSearchAutoEval_OrderBy = {
  actualArgs?: InputMaybe<SortOrder>;
  actualCallCount?: InputMaybe<SortOrder>;
  actualEntity?: InputMaybe<SortOrder>;
  actualTool?: InputMaybe<SortOrder>;
  condition?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  disambiguationResponse?: InputMaybe<SortOrder>;
  disambiguationType?: InputMaybe<SortOrder>;
  errorType?: InputMaybe<SortOrder>;
  evaluatedAt?: InputMaybe<SortOrder>;
  expectedEntity?: InputMaybe<SortOrder>;
  expectedTool?: InputMaybe<SortOrder>;
  hadDisambiguation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  includeExamples?: InputMaybe<SortOrder>;
  includeSchema?: InputMaybe<SortOrder>;
  judgeEvaluation?: InputMaybe<SortOrder>;
  l1Pass?: InputMaybe<SortOrder>;
  l2Pass?: InputMaybe<SortOrder>;
  l3Efficiency?: InputMaybe<SortOrder>;
  l4Redundancy?: InputMaybe<SortOrder>;
  l5Disambiguation?: InputMaybe<SortOrder>;
  l6ResponseQuality?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  llmCallCount?: InputMaybe<SortOrder>;
  llmResponse?: InputMaybe<SortOrder>;
  optimalCallCount?: InputMaybe<SortOrder>;
  overallScore?: InputMaybe<SortOrder>;
  pathType?: InputMaybe<SortOrder>;
  patternsApplied?: InputMaybe<SortOrder>;
  query?: InputMaybe<SortOrder>;
  queryIndex?: InputMaybe<SortOrder>;
  redundantCalls?: InputMaybe<SortOrder>;
  response?: InputMaybe<SortOrder>;
  runId?: InputMaybe<SortOrder>;
  sequenceMatchedOptimal?: InputMaybe<SortOrder>;
  tokenCount?: InputMaybe<SortOrder>;
  toolCallCount?: InputMaybe<SortOrder>;
  toolCalls?: InputMaybe<SortOrder>;
  totalTimeMs?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type AiSearchAutoEval_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AiSearchConversation = {
  __typename?: 'AiSearchConversation';
  context?: Maybe<Scalars['Json']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  messageCount: Scalars['Int']['output'];
  messages: Scalars['Json']['output'];
  startedAt: Scalars['DateTime']['output'];
  version_: Scalars['String']['output'];
};

export type AiSearchConversation_Filter = {
  AND?: InputMaybe<Array<AiSearchConversation_Filter>>;
  NOT?: InputMaybe<Array<AiSearchConversation_Filter>>;
  OR?: InputMaybe<Array<AiSearchConversation_Filter>>;
  context?: InputMaybe<FilterJson>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastMessageAt?: InputMaybe<FilterDateTime>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  messageCount?: InputMaybe<FilterInt>;
  messages?: InputMaybe<FilterJson>;
  startedAt?: InputMaybe<FilterDateTime>;
  version_?: InputMaybe<FilterString>;
};

export type AiSearchConversation_OrderBy = {
  context?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastMessageAt?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  messageCount?: InputMaybe<SortOrder>;
  messages?: InputMaybe<SortOrder>;
  startedAt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type AiSearchConversation_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AiSearchPattern = {
  __typename?: 'AiSearchPattern';
  active: Scalars['Boolean']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description: Scalars['String']['output'];
  displayId: Scalars['String']['output'];
  effectiveness?: Maybe<Scalars['Decimal']['output']>;
  evaluationCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  pathTypes?: Maybe<Array<Scalars['String']['output']>>;
  pattern: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  proposedBy?: Maybe<Scalars['String']['output']>;
  sourceEvalIds?: Maybe<Array<Scalars['String']['output']>>;
  successCount: Scalars['Int']['output'];
  tools?: Maybe<Array<Scalars['String']['output']>>;
  version_: Scalars['String']['output'];
};

export type AiSearchPattern_CreateInput = {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  effectiveness?: InputMaybe<Scalars['Decimal']['input']>;
  evaluationCount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  pathTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pattern: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  proposedBy?: InputMaybe<Scalars['String']['input']>;
  sourceEvalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  successCount: Scalars['Int']['input'];
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AiSearchPattern_Filter = {
  AND?: InputMaybe<Array<AiSearchPattern_Filter>>;
  NOT?: InputMaybe<Array<AiSearchPattern_Filter>>;
  OR?: InputMaybe<Array<AiSearchPattern_Filter>>;
  active?: InputMaybe<FilterBoolean>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  effectiveness?: InputMaybe<FilterDecimal>;
  evaluationCount?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  pathTypes?: InputMaybe<FilterStringList>;
  pattern?: InputMaybe<FilterString>;
  priority?: InputMaybe<FilterInt>;
  proposedBy?: InputMaybe<FilterString>;
  sourceEvalIds?: InputMaybe<FilterStringList>;
  successCount?: InputMaybe<FilterInt>;
  tools?: InputMaybe<FilterStringList>;
  version_?: InputMaybe<FilterString>;
};

export type AiSearchPattern_OrderBy = {
  active?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description?: InputMaybe<SortOrder>;
  effectiveness?: InputMaybe<SortOrder>;
  evaluationCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  pathTypes?: InputMaybe<SortOrder>;
  pattern?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  proposedBy?: InputMaybe<SortOrder>;
  sourceEvalIds?: InputMaybe<SortOrder>;
  successCount?: InputMaybe<SortOrder>;
  tools?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type AiSearchPattern_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type AiSearchPattern_UpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveness?: InputMaybe<Scalars['Decimal']['input']>;
  evaluationCount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pathTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  proposedBy?: InputMaybe<Scalars['String']['input']>;
  sourceEvalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  successCount?: InputMaybe<Scalars['Int']['input']>;
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
  version_: Scalars['String']['input'];
};

export type AiSearchResponse = {
  __typename?: 'AiSearchResponse';
  conversation: AiSearchConversation;
  createdAt: Scalars['DateTime']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  evaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  evaluatedBy?: Maybe<User>;
  explanation?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  query: Scalars['String']['output'];
  rating?: Maybe<EvaluationRating>;
  response: Scalars['String']['output'];
  sources?: Maybe<Scalars['Json']['output']>;
  tokenUsage?: Maybe<Scalars['Json']['output']>;
  toolCalls: Array<AiSearchToolCall>;
  version_: Scalars['String']['output'];
};

export type AiSearchResponse_CreateInput = {
  conversationId: Scalars['String']['input'];
  evaluatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  evaluatedById?: InputMaybe<Scalars['String']['input']>;
  explanation?: InputMaybe<Scalars['Json']['input']>;
  query: Scalars['String']['input'];
  rating?: InputMaybe<EvaluationRating>;
  response: Scalars['String']['input'];
  sources?: InputMaybe<Scalars['Json']['input']>;
  tokenUsage?: InputMaybe<Scalars['Json']['input']>;
  toolCalls: Array<AiSearchToolCall_CreateInput>;
};

export type AiSearchResponse_Filter = {
  AND?: InputMaybe<Array<AiSearchResponse_Filter>>;
  NOT?: InputMaybe<Array<AiSearchResponse_Filter>>;
  OR?: InputMaybe<Array<AiSearchResponse_Filter>>;
  conversation?: InputMaybe<AiSearchConversation_Filter>;
  createdAt?: InputMaybe<FilterDateTime>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  evaluatedAt?: InputMaybe<FilterDateTime>;
  evaluatedBy?: InputMaybe<User_Filter>;
  explanation?: InputMaybe<FilterJson>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  query?: InputMaybe<FilterString>;
  rating?: InputMaybe<FilterString>;
  response?: InputMaybe<FilterString>;
  sources?: InputMaybe<FilterJson>;
  tokenUsage?: InputMaybe<FilterJson>;
  toolCalls?: InputMaybe<AiSearchResponse_ToolCalls_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type AiSearchResponse_OrderBy = {
  conversation?: InputMaybe<AiSearchConversation_OrderBy>;
  createdAt?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  evaluatedAt?: InputMaybe<SortOrder>;
  evaluatedBy?: InputMaybe<User_OrderBy>;
  explanation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  query?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  response?: InputMaybe<SortOrder>;
  sources?: InputMaybe<SortOrder>;
  tokenUsage?: InputMaybe<SortOrder>;
  toolCalls?: InputMaybe<OrderByMultiple>;
  version_?: InputMaybe<SortOrder>;
};

export type AiSearchResponse_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AiSearchResponse_ToolCalls_Filter = {
  every?: InputMaybe<AiSearchToolCall_Filter>;
  none?: InputMaybe<AiSearchToolCall_Filter>;
  some?: InputMaybe<AiSearchToolCall_Filter>;
};

export type AiSearchResponse_ToolCalls_UpdateInput = {
  create?: InputMaybe<Array<AiSearchToolCall_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<AiSearchToolCall_UpdateInput>>;
};

export type AiSearchToolCall = {
  __typename?: 'AiSearchToolCall';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  navigationPath?: Maybe<Scalars['String']['output']>;
  parent_AiSearchResponse_toolCalls: AiSearchResponse;
  pattern?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Json']['output']>;
  sequence: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  toolArguments: Scalars['Json']['output'];
  toolName: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type AiSearchToolCall_CreateInput = {
  durationMs: Scalars['Int']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  navigationPath?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['Json']['input']>;
  sequence: Scalars['Int']['input'];
  success: Scalars['Boolean']['input'];
  toolArguments: Scalars['Json']['input'];
  toolName: Scalars['String']['input'];
};

export type AiSearchToolCall_Filter = {
  AND?: InputMaybe<Array<AiSearchToolCall_Filter>>;
  NOT?: InputMaybe<Array<AiSearchToolCall_Filter>>;
  OR?: InputMaybe<Array<AiSearchToolCall_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  durationMs?: InputMaybe<FilterInt>;
  errorMessage?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  navigationPath?: InputMaybe<FilterString>;
  parent_AiSearchResponse_toolCalls?: InputMaybe<AiSearchResponse_Filter>;
  pattern?: InputMaybe<FilterString>;
  result?: InputMaybe<FilterJson>;
  sequence?: InputMaybe<FilterInt>;
  success?: InputMaybe<FilterBoolean>;
  toolArguments?: InputMaybe<FilterJson>;
  toolName?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type AiSearchToolCall_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  durationMs?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  navigationPath?: InputMaybe<SortOrder>;
  pattern?: InputMaybe<SortOrder>;
  result?: InputMaybe<SortOrder>;
  sequence?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
  toolArguments?: InputMaybe<SortOrder>;
  toolName?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type AiSearchToolCall_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AiSearchToolCall_UpdateInput = {
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  navigationPath?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['Json']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  toolArguments?: InputMaybe<Scalars['Json']['input']>;
  toolName?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type AlertParamSpecInfo = {
  __typename?: 'AlertParamSpecInfo';
  default?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  labelEn: Scalars['String']['output'];
  labelEs: Scalars['String']['output'];
  labelPt: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type AlertRule = {
  __typename?: 'AlertRule';
  alertType: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  params?: Maybe<Scalars['Json']['output']>;
  version_: Scalars['String']['output'];
};

export type AlertRule_CreateInput = {
  alertType: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  params?: InputMaybe<Scalars['Json']['input']>;
};

export type AlertRule_Filter = {
  AND?: InputMaybe<Array<AlertRule_Filter>>;
  NOT?: InputMaybe<Array<AlertRule_Filter>>;
  OR?: InputMaybe<Array<AlertRule_Filter>>;
  alertType?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  params?: InputMaybe<FilterJson>;
  version_?: InputMaybe<FilterString>;
};

export type AlertRule_OrderBy = {
  alertType?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  params?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type AlertRule_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AlertRule_UpdateInput = {
  alertType?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  params?: InputMaybe<Scalars['Json']['input']>;
  version_: Scalars['String']['input'];
};

export type AlertSubscription = {
  __typename?: 'AlertSubscription';
  alertRule: AlertRule;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  version_: Scalars['String']['output'];
};

export type AlertSubscription_CreateInput = {
  alertRuleId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type AlertSubscription_Filter = {
  AND?: InputMaybe<Array<AlertSubscription_Filter>>;
  NOT?: InputMaybe<Array<AlertSubscription_Filter>>;
  OR?: InputMaybe<Array<AlertSubscription_Filter>>;
  alertRule?: InputMaybe<AlertRule_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type AlertSubscription_OrderBy = {
  alertRule?: InputMaybe<AlertRule_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type AlertSubscription_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AlertSubscription_UpdateInput = {
  alertRuleId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
};

export type AlertTypeInfo = {
  __typename?: 'AlertTypeInfo';
  cadence: Scalars['String']['output'];
  descriptionEn?: Maybe<Scalars['String']['output']>;
  descriptionEs?: Maybe<Scalars['String']['output']>;
  descriptionPt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  labelEn: Scalars['String']['output'];
  labelEs: Scalars['String']['output'];
  labelPt: Scalars['String']['output'];
  params: Array<AlertParamSpecInfo>;
};

export type AssociatedDocumentEdition = {
  __typename?: 'AssociatedDocumentEdition';
  authorsDisplay?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  file: Scalars['String']['output'];
  file_data: FileData;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  parent_Edition_associatedDocuments: Edition;
  publisherConfigurationDisplay?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EditionDocumentType>;
  version_: Scalars['String']['output'];
};

export type AssociatedDocumentEdition_Filter = {
  AND?: InputMaybe<Array<AssociatedDocumentEdition_Filter>>;
  NOT?: InputMaybe<Array<AssociatedDocumentEdition_Filter>>;
  OR?: InputMaybe<Array<AssociatedDocumentEdition_Filter>>;
  authorsDisplay?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  file?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  notes?: InputMaybe<FilterString>;
  parent_Edition_associatedDocuments?: InputMaybe<Edition_Filter>;
  publisherConfigurationDisplay?: InputMaybe<FilterString>;
  type?: InputMaybe<EditionDocumentType_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type AssociatedDocumentEdition_OrderBy = {
  authorsDisplay?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  file?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  publisherConfigurationDisplay?: InputMaybe<SortOrder>;
  type?: InputMaybe<EditionDocumentType_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type AssociatedDocumentEdition_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AssociatedDocumentSignedEdition = {
  __typename?: 'AssociatedDocumentSignedEdition';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  file: Scalars['String']['output'];
  file_data: FileData;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  parent_SignedEdition_dndaDocuments: SignedEdition;
  version_: Scalars['String']['output'];
};

export type AssociatedDocumentSignedEdition_Filter = {
  AND?: InputMaybe<Array<AssociatedDocumentSignedEdition_Filter>>;
  NOT?: InputMaybe<Array<AssociatedDocumentSignedEdition_Filter>>;
  OR?: InputMaybe<Array<AssociatedDocumentSignedEdition_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  file?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  parent_SignedEdition_dndaDocuments?: InputMaybe<SignedEdition_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type AssociatedDocumentSignedEdition_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  file?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type AssociatedDocumentSignedEdition_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AuthenticateResponse = {
  __typename?: 'AuthenticateResponse';
  accessExpiresIn: Scalars['Int']['output'];
  accessToken: Scalars['String']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AuthorCollectingSociety = {
  __typename?: 'AuthorCollectingSociety';
  collectingSociety: CollectiveManagementSociety;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  memberNumber: Scalars['String']['output'];
  parent_AuthorComposer_managementSocieties: AuthorComposer;
  territories: Array<Territory>;
  version_: Scalars['String']['output'];
};

export type AuthorCollectingSociety_CreateInput = {
  collectingSocietyId: Scalars['String']['input'];
  memberNumber: Scalars['String']['input'];
  territoriesIds: Array<Scalars['String']['input']>;
};

export type AuthorCollectingSociety_Filter = {
  AND?: InputMaybe<Array<AuthorCollectingSociety_Filter>>;
  NOT?: InputMaybe<Array<AuthorCollectingSociety_Filter>>;
  OR?: InputMaybe<Array<AuthorCollectingSociety_Filter>>;
  collectingSociety?: InputMaybe<CollectiveManagementSociety_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  memberNumber?: InputMaybe<FilterString>;
  parent_AuthorComposer_managementSocieties?: InputMaybe<AuthorComposer_Filter>;
  territories?: InputMaybe<AuthorCollectingSociety_Territories_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type AuthorCollectingSociety_OrderBy = {
  collectingSociety?: InputMaybe<CollectiveManagementSociety_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  memberNumber?: InputMaybe<SortOrder>;
  territories?: InputMaybe<OrderByMultiple>;
  version_?: InputMaybe<SortOrder>;
};

export type AuthorCollectingSociety_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AuthorCollectingSociety_UpdateInput = {
  collectingSocietyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  memberNumber?: InputMaybe<Scalars['String']['input']>;
  territoriesIds?: InputMaybe<InputMultipleRef>;
  version_: Scalars['String']['input'];
};

export type AuthorCollectingSociety_Territories_Filter = {
  every?: InputMaybe<Territory_Filter>;
  none?: InputMaybe<Territory_Filter>;
  some?: InputMaybe<Territory_Filter>;
};

export type AuthorComposer = {
  __typename?: 'AuthorComposer';
  aka?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  cuitCertificate?: Maybe<Scalars['String']['output']>;
  cuitCertificateError?: Maybe<Scalars['String']['output']>;
  cuitCertificateErrorType?: Maybe<CuitCertificateErrorType>;
  cuitCertificateIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  cuitCertificate_data?: Maybe<FileData>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  displayId: Scalars['String']['output'];
  dniDeliveredToSadaicAt?: Maybe<Scalars['DateTime']['output']>;
  dniValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  dniValidatedFields?: Maybe<Scalars['Json']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['String']['output'];
  ipi?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  managementSocieties?: Maybe<Array<AuthorCollectingSociety>>;
  nationality?: Maybe<Country>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<ProvinceState>;
  publishers?: Maybe<Array<AuthorPublisher>>;
  streetAndNumber?: Maybe<Scalars['String']['output']>;
  suite?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxIdType?: Maybe<TaxIdType>;
  version_: Scalars['String']['output'];
};

export type AuthorComposerPublic = {
  __typename?: 'AuthorComposerPublic';
  aka?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  displayId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['String']['output'];
  ipi?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  nationality?: Maybe<Country>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<ProvinceState>;
  streetAndNumber?: Maybe<Scalars['String']['output']>;
  suite?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxIdType?: Maybe<TaxIdType>;
  version_: Scalars['String']['output'];
};

export type AuthorComposerPublic_CreateInput = {
  aka?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  ipi?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
};

export type AuthorComposerPublic_UpdateInput = {
  aka?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  ipi?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
  version_: Scalars['String']['input'];
};

export type AuthorComposer_CreateInput = {
  aka?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  ipi?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  managementSocieties?: InputMaybe<Array<AuthorCollectingSociety_CreateInput>>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  publishers?: InputMaybe<Array<AuthorPublisher_CreateInput>>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
};

export type AuthorComposer_Filter = {
  AND?: InputMaybe<Array<AuthorComposer_Filter>>;
  NOT?: InputMaybe<Array<AuthorComposer_Filter>>;
  OR?: InputMaybe<Array<AuthorComposer_Filter>>;
  aka?: InputMaybe<FilterString>;
  city?: InputMaybe<FilterString>;
  country?: InputMaybe<Country_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  cuitCertificate?: InputMaybe<FilterString>;
  cuitCertificateError?: InputMaybe<FilterString>;
  cuitCertificateErrorType?: InputMaybe<FilterString>;
  cuitCertificateIssuedAt?: InputMaybe<FilterDateTime>;
  dateOfBirth?: InputMaybe<FilterDate>;
  displayId?: InputMaybe<FilterString>;
  dniDeliveredToSadaicAt?: InputMaybe<FilterDateTime>;
  dniValidatedAt?: InputMaybe<FilterDateTime>;
  dniValidatedFields?: InputMaybe<FilterJson>;
  email?: InputMaybe<FilterString>;
  firstName?: InputMaybe<FilterString>;
  floor?: InputMaybe<FilterString>;
  gender?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  ipi?: InputMaybe<FilterString>;
  lastName?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  managementSocieties?: InputMaybe<AuthorComposer_ManagementSocieties_Filter>;
  nationality?: InputMaybe<Country_Filter>;
  phone?: InputMaybe<FilterString>;
  postalCode?: InputMaybe<FilterString>;
  province?: InputMaybe<ProvinceState_Filter>;
  publishers?: InputMaybe<AuthorComposer_Publishers_Filter>;
  streetAndNumber?: InputMaybe<FilterString>;
  suite?: InputMaybe<FilterString>;
  taxId?: InputMaybe<FilterString>;
  taxIdType?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type AuthorComposer_OrderBy = {
  aka?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<Country_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  cuitCertificate?: InputMaybe<SortOrder>;
  cuitCertificateError?: InputMaybe<SortOrder>;
  cuitCertificateErrorType?: InputMaybe<SortOrder>;
  cuitCertificateIssuedAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  dniDeliveredToSadaicAt?: InputMaybe<SortOrder>;
  dniValidatedAt?: InputMaybe<SortOrder>;
  dniValidatedFields?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  floor?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ipi?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  managementSocieties?: InputMaybe<OrderByMultiple>;
  nationality?: InputMaybe<Country_OrderBy>;
  phone?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  province?: InputMaybe<ProvinceState_OrderBy>;
  publishers?: InputMaybe<OrderByMultiple>;
  streetAndNumber?: InputMaybe<SortOrder>;
  suite?: InputMaybe<SortOrder>;
  taxId?: InputMaybe<SortOrder>;
  taxIdType?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type AuthorComposer_OrderByCursor = {
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ipi?: InputMaybe<SortOrder>;
  taxId?: InputMaybe<SortOrder>;
};

export type AuthorComposer_UpdateInput = {
  aka?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  ipi?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  managementSocieties?: InputMaybe<AuthorComposer_ManagementSocieties_UpdateInput>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  publishers?: InputMaybe<AuthorComposer_Publishers_UpdateInput>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
  version_: Scalars['String']['input'];
};

export type AuthorComposer_ManagementSocieties_Filter = {
  every?: InputMaybe<AuthorCollectingSociety_Filter>;
  none?: InputMaybe<AuthorCollectingSociety_Filter>;
  some?: InputMaybe<AuthorCollectingSociety_Filter>;
};

export type AuthorComposer_ManagementSocieties_UpdateInput = {
  create?: InputMaybe<Array<AuthorCollectingSociety_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<AuthorCollectingSociety_UpdateInput>>;
};

export type AuthorComposer_Publishers_Filter = {
  every?: InputMaybe<AuthorPublisher_Filter>;
  none?: InputMaybe<AuthorPublisher_Filter>;
  some?: InputMaybe<AuthorPublisher_Filter>;
};

export type AuthorComposer_Publishers_UpdateInput = {
  create?: InputMaybe<Array<AuthorPublisher_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<AuthorPublisher_UpdateInput>>;
};

export type AuthorDocumentationIssues = {
  __typename?: 'AuthorDocumentationIssues';
  authorId: Scalars['String']['output'];
  missingFields: Array<Scalars['String']['output']>;
  withoutIpiOrDni: Scalars['Boolean']['output'];
};

export type AuthorPublisher = {
  __typename?: 'AuthorPublisher';
  autoRenewalYears?: Maybe<Scalars['Int']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  durationInYears?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_AuthorComposer_publishers: AuthorComposer;
  percentage: Scalars['Decimal']['output'];
  publisher: Publisher;
  version_: Scalars['String']['output'];
};

export type AuthorPublisher_CreateInput = {
  autoRenewalYears?: InputMaybe<Scalars['Int']['input']>;
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  percentage: Scalars['Decimal']['input'];
  publisherId: Scalars['String']['input'];
};

export type AuthorPublisher_Filter = {
  AND?: InputMaybe<Array<AuthorPublisher_Filter>>;
  NOT?: InputMaybe<Array<AuthorPublisher_Filter>>;
  OR?: InputMaybe<Array<AuthorPublisher_Filter>>;
  autoRenewalYears?: InputMaybe<FilterInt>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  durationInYears?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_AuthorComposer_publishers?: InputMaybe<AuthorComposer_Filter>;
  percentage?: InputMaybe<FilterDecimal>;
  publisher?: InputMaybe<Publisher_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type AuthorPublisher_OrderBy = {
  autoRenewalYears?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  durationInYears?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  percentage?: InputMaybe<SortOrder>;
  publisher?: InputMaybe<Publisher_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type AuthorPublisher_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type AuthorPublisher_UpdateInput = {
  autoRenewalYears?: InputMaybe<Scalars['Int']['input']>;
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type BotError = {
  __typename?: 'BotError';
  context: Scalars['Json']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  domSnapshot?: Maybe<Scalars['String']['output']>;
  domSnapshot_data?: Maybe<FileData>;
  errorType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  message: Scalars['String']['output'];
  parent_BotRun_errors: BotRun;
  recoverable: Scalars['Boolean']['output'];
  requiresHumanIntervention: Scalars['Boolean']['output'];
  screenshot?: Maybe<Scalars['String']['output']>;
  screenshot_data?: Maybe<FileData>;
  severity: Scalars['String']['output'];
  stackTrace?: Maybe<Scalars['String']['output']>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
};

export type BotError_Filter = {
  AND?: InputMaybe<Array<BotError_Filter>>;
  NOT?: InputMaybe<Array<BotError_Filter>>;
  OR?: InputMaybe<Array<BotError_Filter>>;
  context?: InputMaybe<FilterJson>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  domSnapshot?: InputMaybe<FilterString>;
  errorType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  message?: InputMaybe<FilterString>;
  parent_BotRun_errors?: InputMaybe<BotRun_Filter>;
  recoverable?: InputMaybe<FilterBoolean>;
  requiresHumanIntervention?: InputMaybe<FilterBoolean>;
  screenshot?: InputMaybe<FilterString>;
  severity?: InputMaybe<FilterString>;
  stackTrace?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type BotError_OrderBy = {
  context?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  domSnapshot?: InputMaybe<SortOrder>;
  errorType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  message?: InputMaybe<SortOrder>;
  recoverable?: InputMaybe<SortOrder>;
  requiresHumanIntervention?: InputMaybe<SortOrder>;
  screenshot?: InputMaybe<SortOrder>;
  severity?: InputMaybe<SortOrder>;
  stackTrace?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type BotError_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type BotPhase = {
  __typename?: 'BotPhase';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_BotRun_phases: BotRun;
  phaseId: Scalars['String']['output'];
  phaseName: Scalars['String']['output'];
  phaseNumber: Scalars['Int']['output'];
  screenshot?: Maybe<Scalars['String']['output']>;
  screenshot_data?: Maybe<FileData>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  steps?: Maybe<Array<BotStep>>;
  stepsCompleted: Scalars['Int']['output'];
  stepsLogPath?: Maybe<Scalars['String']['output']>;
  stepsTotal: Scalars['Int']['output'];
  tenant_id_?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
};

export type BotPhase_Filter = {
  AND?: InputMaybe<Array<BotPhase_Filter>>;
  NOT?: InputMaybe<Array<BotPhase_Filter>>;
  OR?: InputMaybe<Array<BotPhase_Filter>>;
  completedAt?: InputMaybe<FilterDateTime>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterInt>;
  error?: InputMaybe<FilterJson>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_BotRun_phases?: InputMaybe<BotRun_Filter>;
  phaseId?: InputMaybe<FilterString>;
  phaseName?: InputMaybe<FilterString>;
  phaseNumber?: InputMaybe<FilterInt>;
  screenshot?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterString>;
  steps?: InputMaybe<BotPhase_Steps_Filter>;
  stepsCompleted?: InputMaybe<FilterInt>;
  stepsLogPath?: InputMaybe<FilterString>;
  stepsTotal?: InputMaybe<FilterInt>;
  version_?: InputMaybe<FilterString>;
};

export type BotPhase_OrderBy = {
  completedAt?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  duration?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  phaseId?: InputMaybe<SortOrder>;
  phaseName?: InputMaybe<SortOrder>;
  phaseNumber?: InputMaybe<SortOrder>;
  screenshot?: InputMaybe<SortOrder>;
  startedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  steps?: InputMaybe<OrderByMultiple>;
  stepsCompleted?: InputMaybe<SortOrder>;
  stepsLogPath?: InputMaybe<SortOrder>;
  stepsTotal?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type BotPhase_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type BotPhase_Steps_Filter = {
  every?: InputMaybe<BotStep_Filter>;
  none?: InputMaybe<BotStep_Filter>;
  some?: InputMaybe<BotStep_Filter>;
};

export type BotPhase_Steps_UpdateInput = {
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BotRun = {
  __typename?: 'BotRun';
  botType: BotType;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancellationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  cancellationRequestedBy?: Maybe<User>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedPhases: Scalars['Int']['output'];
  correlationId: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  currentPhase?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['Json']['output']>;
  errors?: Maybe<Array<BotError>>;
  id: Scalars['String']['output'];
  interventionReason?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  logsPath?: Maybe<Scalars['String']['output']>;
  params: Scalars['Json']['output'];
  phases?: Maybe<Array<BotPhase>>;
  relatedEntityId?: Maybe<Scalars['String']['output']>;
  relatedEntityLabel?: Maybe<Scalars['String']['output']>;
  relatedEntityType?: Maybe<Scalars['String']['output']>;
  requiresHumanIntervention: Scalars['Boolean']['output'];
  result?: Maybe<Scalars['Json']['output']>;
  runNumber: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  tenant_id_?: Maybe<Scalars['String']['output']>;
  totalPhases: Scalars['Int']['output'];
  triggeredBy: User;
  version_: Scalars['String']['output'];
  workerEvent?: Maybe<WorkerEvent>;
};

export type BotRun_Filter = {
  AND?: InputMaybe<Array<BotRun_Filter>>;
  NOT?: InputMaybe<Array<BotRun_Filter>>;
  OR?: InputMaybe<Array<BotRun_Filter>>;
  botType?: InputMaybe<FilterString>;
  cancellationReason?: InputMaybe<FilterString>;
  cancellationRequestedAt?: InputMaybe<FilterDateTime>;
  cancellationRequestedBy?: InputMaybe<User_Filter>;
  completedAt?: InputMaybe<FilterDateTime>;
  completedPhases?: InputMaybe<FilterInt>;
  correlationId?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  currentPhase?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterInt>;
  error?: InputMaybe<FilterJson>;
  errors?: InputMaybe<BotRun_Errors_Filter>;
  id?: InputMaybe<FilterString>;
  interventionReason?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  logsPath?: InputMaybe<FilterString>;
  params?: InputMaybe<FilterJson>;
  phases?: InputMaybe<BotRun_Phases_Filter>;
  relatedEntityId?: InputMaybe<FilterString>;
  relatedEntityLabel?: InputMaybe<FilterString>;
  relatedEntityType?: InputMaybe<FilterString>;
  requiresHumanIntervention?: InputMaybe<FilterBoolean>;
  result?: InputMaybe<FilterJson>;
  runNumber?: InputMaybe<FilterInt>;
  startedAt?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterString>;
  totalPhases?: InputMaybe<FilterInt>;
  triggeredBy?: InputMaybe<User_Filter>;
  version_?: InputMaybe<FilterString>;
  workerEvent?: InputMaybe<WorkerEvent_Filter>;
};

export type BotRun_OrderBy = {
  botType?: InputMaybe<SortOrder>;
  cancellationReason?: InputMaybe<SortOrder>;
  cancellationRequestedAt?: InputMaybe<SortOrder>;
  cancellationRequestedBy?: InputMaybe<User_OrderBy>;
  completedAt?: InputMaybe<SortOrder>;
  completedPhases?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  currentPhase?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  errors?: InputMaybe<OrderByMultiple>;
  id?: InputMaybe<SortOrder>;
  interventionReason?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  logsPath?: InputMaybe<SortOrder>;
  params?: InputMaybe<SortOrder>;
  phases?: InputMaybe<OrderByMultiple>;
  relatedEntityId?: InputMaybe<SortOrder>;
  relatedEntityLabel?: InputMaybe<SortOrder>;
  relatedEntityType?: InputMaybe<SortOrder>;
  requiresHumanIntervention?: InputMaybe<SortOrder>;
  result?: InputMaybe<SortOrder>;
  runNumber?: InputMaybe<SortOrder>;
  startedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  totalPhases?: InputMaybe<SortOrder>;
  triggeredBy?: InputMaybe<User_OrderBy>;
  version_?: InputMaybe<SortOrder>;
  workerEvent?: InputMaybe<WorkerEvent_OrderBy>;
};

export type BotRun_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type BotRun_Errors_Filter = {
  every?: InputMaybe<BotError_Filter>;
  none?: InputMaybe<BotError_Filter>;
  some?: InputMaybe<BotError_Filter>;
};

export type BotRun_Errors_UpdateInput = {
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BotRun_Phases_Filter = {
  every?: InputMaybe<BotPhase_Filter>;
  none?: InputMaybe<BotPhase_Filter>;
  some?: InputMaybe<BotPhase_Filter>;
};

export type BotRun_Phases_UpdateInput = {
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BotStep = {
  __typename?: 'BotStep';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  downloadedFile?: Maybe<Scalars['String']['output']>;
  downloadedFile_data?: Maybe<FileData>;
  duration?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_BotPhase_steps: BotPhase;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  stepId: Scalars['String']['output'];
  stepNumber: Scalars['Int']['output'];
  tenant_id_?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
};

export type BotStep_Filter = {
  AND?: InputMaybe<Array<BotStep_Filter>>;
  NOT?: InputMaybe<Array<BotStep_Filter>>;
  OR?: InputMaybe<Array<BotStep_Filter>>;
  completedAt?: InputMaybe<FilterDateTime>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  downloadedFile?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterInt>;
  error?: InputMaybe<FilterJson>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_BotPhase_steps?: InputMaybe<BotPhase_Filter>;
  startedAt?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterString>;
  stepId?: InputMaybe<FilterString>;
  stepNumber?: InputMaybe<FilterInt>;
  version_?: InputMaybe<FilterString>;
};

export type BotStep_OrderBy = {
  completedAt?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  downloadedFile?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  startedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  stepId?: InputMaybe<SortOrder>;
  stepNumber?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type BotStep_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export enum BotType {
  ComprobanteDnda = 'comprobanteDnda',
  ConstanciaCuil = 'constanciaCuil',
  DniSadaic = 'dniSadaic',
  EmailDnda = 'emailDnda',
  RegistroDnda = 'registroDnda',
  UploadDnda = 'uploadDnda',
  UploadSadaic = 'uploadSadaic'
}

export enum ChunkingStrategy {
  Auto = 'auto',
  ByLegal = 'by_legal',
  ByRegex = 'by_regex',
  ByStructure = 'by_structure',
  ByTokens = 'by_tokens'
}

export type CollectiveManagementSociety = {
  __typename?: 'CollectiveManagementSociety';
  acronym: Scalars['String']['output'];
  country: Country;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type CollectiveManagementSociety_CreateInput = {
  acronym: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CollectiveManagementSociety_Filter = {
  AND?: InputMaybe<Array<CollectiveManagementSociety_Filter>>;
  NOT?: InputMaybe<Array<CollectiveManagementSociety_Filter>>;
  OR?: InputMaybe<Array<CollectiveManagementSociety_Filter>>;
  acronym?: InputMaybe<FilterString>;
  country?: InputMaybe<Country_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type CollectiveManagementSociety_OrderBy = {
  acronym?: InputMaybe<SortOrder>;
  country?: InputMaybe<Country_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type CollectiveManagementSociety_OrderByCursor = {
  acronym?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CollectiveManagementSociety_UpdateInput = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Company = {
  __typename?: 'Company';
  extra?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logo_data?: Maybe<FileData>;
  name: Scalars['String']['output'];
};

export type ContractObservation = {
  __typename?: 'ContractObservation';
  authors?: Maybe<Array<AuthorComposer>>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  observation: Scalars['String']['output'];
  publishers?: Maybe<Array<Publisher>>;
  requireAll?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type ContractObservation_CreateInput = {
  authorsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  observation: Scalars['String']['input'];
  publishersIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requireAll?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type ContractObservation_Filter = {
  AND?: InputMaybe<Array<ContractObservation_Filter>>;
  NOT?: InputMaybe<Array<ContractObservation_Filter>>;
  OR?: InputMaybe<Array<ContractObservation_Filter>>;
  authors?: InputMaybe<ContractObservation_Authors_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  observation?: InputMaybe<FilterString>;
  publishers?: InputMaybe<ContractObservation_Publishers_Filter>;
  requireAll?: InputMaybe<FilterBoolean>;
  title?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type ContractObservation_OrderBy = {
  authors?: InputMaybe<OrderByMultiple>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  observation?: InputMaybe<SortOrder>;
  publishers?: InputMaybe<OrderByMultiple>;
  requireAll?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type ContractObservation_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type ContractObservation_UpdateInput = {
  authorsIds?: InputMaybe<InputMultipleRef>;
  id: Scalars['String']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
  publishersIds?: InputMaybe<InputMultipleRef>;
  requireAll?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type ContractObservation_Authors_Filter = {
  every?: InputMaybe<AuthorComposer_Filter>;
  none?: InputMaybe<AuthorComposer_Filter>;
  some?: InputMaybe<AuthorComposer_Filter>;
};

export type ContractObservation_Publishers_Filter = {
  every?: InputMaybe<Publisher_Filter>;
  none?: InputMaybe<Publisher_Filter>;
  some?: InputMaybe<Publisher_Filter>;
};

export type ContractSignatureStatus = {
  __typename?: 'ContractSignatureStatus';
  contractName: Scalars['String']['output'];
  contractNumber: Scalars['String']['output'];
  documentStatus?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  editionDocumentationId: Scalars['String']['output'];
  recipients: Array<RecipientSignatureStatus>;
  signaturePhase?: Maybe<Scalars['String']['output']>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  currency: Scalars['String']['output'];
  demonym_en?: Maybe<Scalars['String']['output']>;
  demonym_es?: Maybe<Scalars['String']['output']>;
  demonym_pt?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type Country_CreateInput = {
  code: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  demonym_en?: InputMaybe<Scalars['String']['input']>;
  demonym_es?: InputMaybe<Scalars['String']['input']>;
  demonym_pt?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type Country_Filter = {
  AND?: InputMaybe<Array<Country_Filter>>;
  NOT?: InputMaybe<Array<Country_Filter>>;
  OR?: InputMaybe<Array<Country_Filter>>;
  code?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  currency?: InputMaybe<FilterString>;
  demonym_en?: InputMaybe<FilterString>;
  demonym_es?: InputMaybe<FilterString>;
  demonym_pt?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Country_OrderBy = {
  code?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  currency?: InputMaybe<SortOrder>;
  demonym_en?: InputMaybe<SortOrder>;
  demonym_es?: InputMaybe<SortOrder>;
  demonym_pt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Country_OrderByCursor = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type Country_UpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  demonym_en?: InputMaybe<Scalars['String']['input']>;
  demonym_es?: InputMaybe<Scalars['String']['input']>;
  demonym_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type CreateSatelliteMachineInput = {
  botEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  botMaxConcurrent?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  machineCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  proxyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  proxyPort?: InputMaybe<Scalars['Int']['input']>;
  proxyProtocols?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  satelliteType?: InputMaybe<Scalars['String']['input']>;
  workerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreditAccount = {
  __typename?: 'CreditAccount';
  balance: Scalars['Int']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  movements?: Maybe<Array<CreditMovement>>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<CreditTier>;
  version_: Scalars['String']['output'];
};

export type CreditAccount_Filter = {
  AND?: InputMaybe<Array<CreditAccount_Filter>>;
  NOT?: InputMaybe<Array<CreditAccount_Filter>>;
  OR?: InputMaybe<Array<CreditAccount_Filter>>;
  balance?: InputMaybe<FilterInt>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  movements?: InputMaybe<CreditAccount_Movements_Filter>;
  tier?: InputMaybe<CreditTier_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type CreditAccount_OrderBy = {
  balance?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  movements?: InputMaybe<OrderByMultiple>;
  tier?: InputMaybe<CreditTier_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type CreditAccount_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type CreditAccount_UpdateInput = {
  id: Scalars['String']['input'];
  tierId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type CreditAccount_Movements_Filter = {
  every?: InputMaybe<CreditMovement_Filter>;
  none?: InputMaybe<CreditMovement_Filter>;
  some?: InputMaybe<CreditMovement_Filter>;
};

export type CreditMovement = {
  __typename?: 'CreditMovement';
  balanceAfter: Scalars['Int']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  delta: Scalars['Int']['output'];
  detail: Scalars['String']['output'];
  displayId: Scalars['String']['output'];
  editionKey?: Maybe<Scalars['String']['output']>;
  editionName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  movementAt: Scalars['DateTime']['output'];
  parent_CreditAccount_movements: CreditAccount;
  purchase?: Maybe<CreditPurchase>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  type: CreditMovementType;
  version_: Scalars['String']['output'];
};

export enum CreditMovementType {
  Adjustment = 'adjustment',
  Consumption = 'consumption',
  Expiration = 'expiration',
  Purchase = 'purchase',
  Refund = 'refund'
}

export type CreditMovement_Filter = {
  AND?: InputMaybe<Array<CreditMovement_Filter>>;
  NOT?: InputMaybe<Array<CreditMovement_Filter>>;
  OR?: InputMaybe<Array<CreditMovement_Filter>>;
  balanceAfter?: InputMaybe<FilterInt>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  delta?: InputMaybe<FilterInt>;
  detail?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  editionKey?: InputMaybe<FilterString>;
  editionName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  movementAt?: InputMaybe<FilterDateTime>;
  parent_CreditAccount_movements?: InputMaybe<CreditAccount_Filter>;
  purchase?: InputMaybe<CreditPurchase_Filter>;
  type?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type CreditMovement_OrderBy = {
  balanceAfter?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  delta?: InputMaybe<SortOrder>;
  detail?: InputMaybe<SortOrder>;
  editionKey?: InputMaybe<SortOrder>;
  editionName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  movementAt?: InputMaybe<SortOrder>;
  purchase?: InputMaybe<CreditPurchase_OrderBy>;
  type?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type CreditMovement_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type CreditPurchase = {
  __typename?: 'CreditPurchase';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  notes?: Maybe<Scalars['String']['output']>;
  purchaseDate: Scalars['Date']['output'];
  quantity: Scalars['Int']['output'];
  tenant?: Maybe<Tenant>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  version_: Scalars['String']['output'];
};

export type CreditPurchase_CreateInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  purchaseDate: Scalars['Date']['input'];
  quantity: Scalars['Int']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreditPurchase_Filter = {
  AND?: InputMaybe<Array<CreditPurchase_Filter>>;
  NOT?: InputMaybe<Array<CreditPurchase_Filter>>;
  OR?: InputMaybe<Array<CreditPurchase_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  expirationDate?: InputMaybe<FilterDate>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  notes?: InputMaybe<FilterString>;
  purchaseDate?: InputMaybe<FilterDate>;
  quantity?: InputMaybe<FilterInt>;
  tenant?: InputMaybe<Tenant_Filter>;
  unitPrice?: InputMaybe<FilterDecimal>;
  version_?: InputMaybe<FilterString>;
};

export type CreditPurchase_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  expirationDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  notes?: InputMaybe<SortOrder>;
  purchaseDate?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<Tenant_OrderBy>;
  unitPrice?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type CreditPurchase_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type CreditTier = {
  __typename?: 'CreditTier';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  monthlyCredits: Scalars['Int']['output'];
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  pricePerCredit: Scalars['Decimal']['output'];
  pricePerExtraCredit: Scalars['Decimal']['output'];
  version_: Scalars['String']['output'];
};

export type CreditTier_CreateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  monthlyCredits: Scalars['Int']['input'];
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  pricePerCredit: Scalars['Decimal']['input'];
  pricePerExtraCredit: Scalars['Decimal']['input'];
};

export type CreditTier_Filter = {
  AND?: InputMaybe<Array<CreditTier_Filter>>;
  NOT?: InputMaybe<Array<CreditTier_Filter>>;
  OR?: InputMaybe<Array<CreditTier_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description_en?: InputMaybe<FilterString>;
  description_es?: InputMaybe<FilterString>;
  description_pt?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  monthlyCredits?: InputMaybe<FilterInt>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  pricePerCredit?: InputMaybe<FilterDecimal>;
  pricePerExtraCredit?: InputMaybe<FilterDecimal>;
  version_?: InputMaybe<FilterString>;
};

export type CreditTier_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description_en?: InputMaybe<SortOrder>;
  description_es?: InputMaybe<SortOrder>;
  description_pt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  monthlyCredits?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  pricePerCredit?: InputMaybe<SortOrder>;
  pricePerExtraCredit?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type CreditTier_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type CreditTier_UpdateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  monthlyCredits?: InputMaybe<Scalars['Int']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  pricePerCredit?: InputMaybe<Scalars['Decimal']['input']>;
  pricePerExtraCredit?: InputMaybe<Scalars['Decimal']['input']>;
  version_: Scalars['String']['input'];
};

export enum CuitCertificateErrorType {
  IncompleteData = 'incompleteData',
  InvalidData = 'invalidData',
  Technical = 'technical'
}

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type Currency_CreateInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Currency_Filter = {
  AND?: InputMaybe<Array<Currency_Filter>>;
  NOT?: InputMaybe<Array<Currency_Filter>>;
  OR?: InputMaybe<Array<Currency_Filter>>;
  code?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Currency_OrderBy = {
  code?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Currency_OrderByCursor = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type Currency_UpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type DashboardLayoutTemplate = {
  __typename?: 'DashboardLayoutTemplate';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  forRole?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  isForAllTenants: Scalars['Boolean']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
  widgets: Scalars['Json']['output'];
};

export type DashboardLayoutTemplate_CreateInput = {
  enabled: Scalars['Boolean']['input'];
  forRole?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  isForAllTenants: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  widgets: Scalars['Json']['input'];
};

export type DashboardLayoutTemplate_Filter = {
  AND?: InputMaybe<Array<DashboardLayoutTemplate_Filter>>;
  NOT?: InputMaybe<Array<DashboardLayoutTemplate_Filter>>;
  OR?: InputMaybe<Array<DashboardLayoutTemplate_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  forRole?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  isDefault?: InputMaybe<FilterBoolean>;
  isForAllTenants?: InputMaybe<FilterBoolean>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
  widgets?: InputMaybe<FilterJson>;
};

export type DashboardLayoutTemplate_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  enabled?: InputMaybe<SortOrder>;
  forRole?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  isForAllTenants?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
  widgets?: InputMaybe<SortOrder>;
};

export type DashboardLayoutTemplate_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type DashboardLayoutTemplate_UpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  forRole?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isForAllTenants?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
  widgets?: InputMaybe<Scalars['Json']['input']>;
};

export type DashboardWidget = {
  __typename?: 'DashboardWidget';
  category: Scalars['String']['output'];
  component: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  dataFetcherKey: Scalars['String']['output'];
  defaultConfig: Scalars['Json']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  minHeight: Scalars['Int']['output'];
  minWidth: Scalars['Int']['output'];
  refreshInterval?: Maybe<Scalars['Int']['output']>;
  requiredPermissions: Scalars['String']['output'];
  title: Scalars['String']['output'];
  version_: Scalars['String']['output'];
  widgetKey: Scalars['String']['output'];
};

export type DashboardWidget_Filter = {
  AND?: InputMaybe<Array<DashboardWidget_Filter>>;
  NOT?: InputMaybe<Array<DashboardWidget_Filter>>;
  OR?: InputMaybe<Array<DashboardWidget_Filter>>;
  category?: InputMaybe<FilterString>;
  component?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  dataFetcherKey?: InputMaybe<FilterString>;
  defaultConfig?: InputMaybe<FilterJson>;
  description?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  icon?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  minHeight?: InputMaybe<FilterInt>;
  minWidth?: InputMaybe<FilterInt>;
  refreshInterval?: InputMaybe<FilterInt>;
  requiredPermissions?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
  widgetKey?: InputMaybe<FilterString>;
};

export type DashboardWidget_OrderBy = {
  category?: InputMaybe<SortOrder>;
  component?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  dataFetcherKey?: InputMaybe<SortOrder>;
  defaultConfig?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  minHeight?: InputMaybe<SortOrder>;
  minWidth?: InputMaybe<SortOrder>;
  refreshInterval?: InputMaybe<SortOrder>;
  requiredPermissions?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
  widgetKey?: InputMaybe<SortOrder>;
};

export type DashboardWidget_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  widgetKey?: InputMaybe<SortOrder>;
};

export type DeletionBlockerItem = {
  __typename?: 'DeletionBlockerItem';
  id: Scalars['ID']['output'];
  nameI18n?: Maybe<Scalars['Json']['output']>;
  nameText?: Maybe<Scalars['String']['output']>;
};

export type DeletionBlockerReason = {
  __typename?: 'DeletionBlockerReason';
  hiddenInTenant?: Maybe<Scalars['Int']['output']>;
  kind: Scalars['String']['output'];
  otherTenants?: Maybe<Scalars['Int']['output']>;
  relations: Array<Scalars['String']['output']>;
  rootEntity: Scalars['String']['output'];
  visible?: Maybe<DeletionBlockerVisible>;
};

export type DeletionBlockerVisible = {
  __typename?: 'DeletionBlockerVisible';
  count: Scalars['Int']['output'];
  items: Array<DeletionBlockerItem>;
};

export type DeletionBlockers = {
  __typename?: 'DeletionBlockers';
  blocked: Scalars['Boolean']['output'];
  entity: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reasons: Array<DeletionBlockerReason>;
};

export type DesignShowcase = {
  __typename?: 'DesignShowcase';
  active: Scalars['Boolean']['output'];
  amount: Scalars['Decimal']['output'];
  anyFile?: Maybe<Scalars['String']['output']>;
  anyFile_data?: Maybe<FileData>;
  apiKeyHasValue: Scalars['Boolean']['output'];
  appliedStatuses?: Maybe<Array<ShowcaseStatus>>;
  attachment?: Maybe<Scalars['String']['output']>;
  attachment_data?: Maybe<FileData>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatar_data?: Maybe<FileData>;
  body?: Maybe<Scalars['String']['output']>;
  category: ShowcaseCategory;
  code: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  durationInYears?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  highlighted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  lifecycle: ShowcaseWorkflowState;
  lifecycle_transitions_: Array<Scalars['String']['output']>;
  lines?: Maybe<Array<ShowcaseLine>>;
  metadata?: Maybe<Scalars['Json']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  ratio?: Maybe<Scalars['Decimal']['output']>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  relatedCategories?: Maybe<Array<ShowcaseCategory>>;
  serverLabel?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  status: ShowcaseStatus;
  summary?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
};

export type DesignShowcase_CreateInput = {
  active: Scalars['Boolean']['input'];
  amount: Scalars['Decimal']['input'];
  anyFile?: InputMaybe<UploadedFile>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  appliedStatuses?: InputMaybe<Array<ShowcaseStatus>>;
  attachment?: InputMaybe<UploadedFile>;
  avatar?: InputMaybe<UploadedFile>;
  body?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  highlighted: Scalars['Boolean']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  lines?: InputMaybe<Array<ShowcaseLine_CreateInput>>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  ratio?: InputMaybe<Scalars['Decimal']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedCategoriesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['Date']['input'];
  status: ShowcaseStatus;
  summary?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type DesignShowcase_Filter = {
  AND?: InputMaybe<Array<DesignShowcase_Filter>>;
  NOT?: InputMaybe<Array<DesignShowcase_Filter>>;
  OR?: InputMaybe<Array<DesignShowcase_Filter>>;
  active?: InputMaybe<FilterBoolean>;
  amount?: InputMaybe<FilterDecimal>;
  anyFile?: InputMaybe<FilterString>;
  appliedStatuses?: InputMaybe<FilterString>;
  attachment?: InputMaybe<FilterString>;
  avatar?: InputMaybe<FilterString>;
  body?: InputMaybe<FilterString>;
  category?: InputMaybe<ShowcaseCategory_Filter>;
  code?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  durationInYears?: InputMaybe<FilterInt>;
  expiresAt?: InputMaybe<FilterDateTime>;
  highlighted?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  internalNote?: InputMaybe<FilterString>;
  keywords?: InputMaybe<FilterStringList>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  lifecycle?: InputMaybe<ShowcaseWorkflowState_Filter>;
  lifecycle_transitions_?: InputMaybe<FilterStringList>;
  lines?: InputMaybe<DesignShowcase_Lines_Filter>;
  metadata?: InputMaybe<FilterJson>;
  name?: InputMaybe<FilterString>;
  phone?: InputMaybe<FilterString>;
  quantity?: InputMaybe<FilterInt>;
  ratio?: InputMaybe<FilterDecimal>;
  registeredAt?: InputMaybe<FilterDateTime>;
  relatedCategories?: InputMaybe<DesignShowcase_RelatedCategories_Filter>;
  serverLabel?: InputMaybe<FilterString>;
  startDate?: InputMaybe<FilterDate>;
  status?: InputMaybe<FilterString>;
  summary?: InputMaybe<FilterString>;
  taxId?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type DesignShowcase_OrderBy = {
  active?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  anyFile?: InputMaybe<SortOrder>;
  appliedStatuses?: InputMaybe<SortOrder>;
  attachment?: InputMaybe<SortOrder>;
  avatar?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  category?: InputMaybe<ShowcaseCategory_OrderBy>;
  code?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  durationInYears?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  highlighted?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalNote?: InputMaybe<SortOrder>;
  keywords?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  lifecycle?: InputMaybe<ShowcaseWorkflowState_OrderBy>;
  lifecycle_transitions_?: InputMaybe<SortOrder>;
  lines?: InputMaybe<OrderByMultiple>;
  metadata?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  ratio?: InputMaybe<SortOrder>;
  registeredAt?: InputMaybe<SortOrder>;
  relatedCategories?: InputMaybe<OrderByMultiple>;
  serverLabel?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  summary?: InputMaybe<SortOrder>;
  taxId?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type DesignShowcase_OrderByCursor = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DesignShowcase_UpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  anyFile?: InputMaybe<UploadedFile>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  appliedStatuses?: InputMaybe<Array<ShowcaseStatus>>;
  attachment?: InputMaybe<UploadedFile>;
  avatar?: InputMaybe<UploadedFile>;
  body?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  lines?: InputMaybe<DesignShowcase_Lines_UpdateInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  ratio?: InputMaybe<Scalars['Decimal']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedCategoriesIds?: InputMaybe<InputMultipleRef>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<ShowcaseStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type DesignShowcase_Lines_Filter = {
  every?: InputMaybe<ShowcaseLine_Filter>;
  none?: InputMaybe<ShowcaseLine_Filter>;
  some?: InputMaybe<ShowcaseLine_Filter>;
};

export type DesignShowcase_Lines_UpdateInput = {
  create?: InputMaybe<Array<ShowcaseLine_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<ShowcaseLine_UpdateInput>>;
};

export type DesignShowcase_RelatedCategories_Filter = {
  every?: InputMaybe<ShowcaseCategory_Filter>;
  none?: InputMaybe<ShowcaseCategory_Filter>;
  some?: InputMaybe<ShowcaseCategory_Filter>;
};

export type DocumentGenerationParams = {
  __typename?: 'DocumentGenerationParams';
  contractEffectiveDate: Scalars['Date']['output'];
  contractEndDate?: Maybe<Scalars['Date']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  version_: Scalars['String']['output'];
};

export type DocumentGenerationParams_CreateInput = {
  contractEffectiveDate: Scalars['Date']['input'];
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
};

export type DocumentGenerationParams_Filter = {
  AND?: InputMaybe<Array<DocumentGenerationParams_Filter>>;
  NOT?: InputMaybe<Array<DocumentGenerationParams_Filter>>;
  OR?: InputMaybe<Array<DocumentGenerationParams_Filter>>;
  contractEffectiveDate?: InputMaybe<FilterDate>;
  contractEndDate?: InputMaybe<FilterDate>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type DocumentGenerationParams_OrderBy = {
  contractEffectiveDate?: InputMaybe<SortOrder>;
  contractEndDate?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type DocumentGenerationParams_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type DocumentGenerationParams_UpdateInput = {
  contractEffectiveDate?: InputMaybe<Scalars['Date']['input']>;
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
};

export enum DocumentProcessingStatus {
  Error = 'error',
  Pending = 'pending',
  Processing = 'processing',
  Ready = 'ready'
}

export type Edition = {
  __typename?: 'Edition';
  associatedDocuments?: Maybe<Array<AssociatedDocumentEdition>>;
  contentType: EditionContentType;
  contractObservation?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  dndaExpedienteNumber?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Array<EditionDocumentation>>;
  documentationLastOperationalError?: Maybe<Scalars['String']['output']>;
  documentationState: EditionDocumentationWorkflowState;
  documentationState_transitions_: Array<Scalars['String']['output']>;
  editionNumber: Scalars['Int']['output'];
  editionType: EditionType;
  ejemplarPdf?: Maybe<Scalars['String']['output']>;
  ejemplarPdf_data?: Maybe<FileData>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  publicationDate?: Maybe<Scalars['Date']['output']>;
  publicationLink?: Maybe<Scalars['String']['output']>;
  userAttachments?: Maybe<Array<UserAttachmentEdition>>;
  version_: Scalars['String']['output'];
  works: Array<MusicalWork>;
};

export enum EditionContentType {
  Audios = 'audios',
  Scores = 'scores',
  ScoresAndAudios = 'scoresAndAudios'
}

export type EditionContractPublisher = {
  __typename?: 'EditionContractPublisher';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_EditionDocumentation_publishers: EditionDocumentation;
  percentage: Scalars['Decimal']['output'];
  publisher: Publisher;
  version_: Scalars['String']['output'];
};

export type EditionContractPublisher_Filter = {
  AND?: InputMaybe<Array<EditionContractPublisher_Filter>>;
  NOT?: InputMaybe<Array<EditionContractPublisher_Filter>>;
  OR?: InputMaybe<Array<EditionContractPublisher_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_EditionDocumentation_publishers?: InputMaybe<EditionDocumentation_Filter>;
  percentage?: InputMaybe<FilterDecimal>;
  publisher?: InputMaybe<Publisher_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type EditionContractPublisher_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  percentage?: InputMaybe<SortOrder>;
  publisher?: InputMaybe<Publisher_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type EditionContractPublisher_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type EditionDocumentType = {
  __typename?: 'EditionDocumentType';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type EditionDocumentType_CreateInput = {
  name: Scalars['String']['input'];
};

export type EditionDocumentType_Filter = {
  AND?: InputMaybe<Array<EditionDocumentType_Filter>>;
  NOT?: InputMaybe<Array<EditionDocumentType_Filter>>;
  OR?: InputMaybe<Array<EditionDocumentType_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type EditionDocumentType_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type EditionDocumentType_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type EditionDocumentType_UpdateInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type EditionDocumentation = {
  __typename?: 'EditionDocumentation';
  authors?: Maybe<Array<AuthorComposer>>;
  authorsDisplay?: Maybe<Scalars['String']['output']>;
  contractDuration?: Maybe<Scalars['Int']['output']>;
  contractNumber: Scalars['String']['output'];
  contractRenewal?: Maybe<Scalars['Int']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  documentName?: Maybe<Scalars['String']['output']>;
  finalDocumentPdf?: Maybe<Scalars['String']['output']>;
  finalDocumentPdf_data?: Maybe<FileData>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_Edition_documentation: Edition;
  publisherConfiguration?: Maybe<Scalars['String']['output']>;
  publisherConfigurationDisplay?: Maybe<Scalars['String']['output']>;
  publishers?: Maybe<Array<EditionContractPublisher>>;
  territories?: Maybe<Array<Territory>>;
  territoriesDisplay?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
  works: Array<MusicalWork>;
};

export type EditionDocumentationWorkflowState = {
  __typename?: 'EditionDocumentationWorkflowState';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type EditionDocumentationWorkflowState_CreateInput = {
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type EditionDocumentationWorkflowState_Filter = {
  AND?: InputMaybe<Array<EditionDocumentationWorkflowState_Filter>>;
  NOT?: InputMaybe<Array<EditionDocumentationWorkflowState_Filter>>;
  OR?: InputMaybe<Array<EditionDocumentationWorkflowState_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type EditionDocumentationWorkflowState_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type EditionDocumentationWorkflowState_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type EditionDocumentationWorkflowState_UpdateInput = {
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type EditionDocumentationWorkflow_BackToDocsFromSignatureFailedResult = {
  __typename?: 'EditionDocumentationWorkflow_BackToDocsFromSignatureFailedResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctResult = {
  __typename?: 'EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarResult = {
  __typename?: 'EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_BorrarDocumentacionFromFalloResult = {
  __typename?: 'EditionDocumentationWorkflow_BorrarDocumentacionFromFalloResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_CancelGenerationResult = {
  __typename?: 'EditionDocumentationWorkflow_CancelGenerationResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_CancelSendingResult = {
  __typename?: 'EditionDocumentationWorkflow_CancelSendingResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_DeleteAndRestartFromFailedResult = {
  __typename?: 'EditionDocumentationWorkflow_DeleteAndRestartFromFailedResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedResult = {
  __typename?: 'EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_DeleteAndRestartFromSignatureResult = {
  __typename?: 'EditionDocumentationWorkflow_DeleteAndRestartFromSignatureResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_GenerateDocumentationResult = {
  __typename?: 'EditionDocumentationWorkflow_GenerateDocumentationResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_ReintentarCierreFirmasResult = {
  __typename?: 'EditionDocumentationWorkflow_ReintentarCierreFirmasResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_RetryGenerateDocumentationResult = {
  __typename?: 'EditionDocumentationWorkflow_RetryGenerateDocumentationResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_RetrySendForSignatureResult = {
  __typename?: 'EditionDocumentationWorkflow_RetrySendForSignatureResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentationWorkflow_SendForSignatureResult = {
  __typename?: 'EditionDocumentationWorkflow_SendForSignatureResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type EditionDocumentation_Filter = {
  AND?: InputMaybe<Array<EditionDocumentation_Filter>>;
  NOT?: InputMaybe<Array<EditionDocumentation_Filter>>;
  OR?: InputMaybe<Array<EditionDocumentation_Filter>>;
  authors?: InputMaybe<EditionDocumentation_Authors_Filter>;
  authorsDisplay?: InputMaybe<FilterString>;
  contractDuration?: InputMaybe<FilterInt>;
  contractNumber?: InputMaybe<FilterString>;
  contractRenewal?: InputMaybe<FilterInt>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  documentName?: InputMaybe<FilterString>;
  finalDocumentPdf?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_Edition_documentation?: InputMaybe<Edition_Filter>;
  publisherConfiguration?: InputMaybe<FilterString>;
  publisherConfigurationDisplay?: InputMaybe<FilterString>;
  publishers?: InputMaybe<EditionDocumentation_Publishers_Filter>;
  territories?: InputMaybe<EditionDocumentation_Territories_Filter>;
  territoriesDisplay?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
  works?: InputMaybe<EditionDocumentation_Works_Filter>;
};

export type EditionDocumentation_OrderBy = {
  authors?: InputMaybe<OrderByMultiple>;
  authorsDisplay?: InputMaybe<SortOrder>;
  contractDuration?: InputMaybe<SortOrder>;
  contractNumber?: InputMaybe<SortOrder>;
  contractRenewal?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  documentName?: InputMaybe<SortOrder>;
  finalDocumentPdf?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  publisherConfiguration?: InputMaybe<SortOrder>;
  publisherConfigurationDisplay?: InputMaybe<SortOrder>;
  publishers?: InputMaybe<OrderByMultiple>;
  territories?: InputMaybe<OrderByMultiple>;
  territoriesDisplay?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
  works?: InputMaybe<OrderByMultiple>;
};

export type EditionDocumentation_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type EditionDocumentation_Authors_Filter = {
  every?: InputMaybe<AuthorComposer_Filter>;
  none?: InputMaybe<AuthorComposer_Filter>;
  some?: InputMaybe<AuthorComposer_Filter>;
};

export type EditionDocumentation_Publishers_Filter = {
  every?: InputMaybe<EditionContractPublisher_Filter>;
  none?: InputMaybe<EditionContractPublisher_Filter>;
  some?: InputMaybe<EditionContractPublisher_Filter>;
};

export type EditionDocumentation_Territories_Filter = {
  every?: InputMaybe<Territory_Filter>;
  none?: InputMaybe<Territory_Filter>;
  some?: InputMaybe<Territory_Filter>;
};

export type EditionDocumentation_Works_Filter = {
  every?: InputMaybe<MusicalWork_Filter>;
  none?: InputMaybe<MusicalWork_Filter>;
  some?: InputMaybe<MusicalWork_Filter>;
};

export type EditionPendingCompletion = {
  __typename?: 'EditionPendingCompletion';
  allComplete: Scalars['Boolean']['output'];
  completedDocs: Scalars['Int']['output'];
  editionId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  totalDocs: Scalars['Int']['output'];
  unlinkedSignatures: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type EditionSignatureCheckResult = {
  __typename?: 'EditionSignatureCheckResult';
  pendingDocs: Array<EditionSignaturePendingDoc>;
  reason?: Maybe<Scalars['String']['output']>;
  signedEditionId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
};

export type EditionSignaturePendingDoc = {
  __typename?: 'EditionSignaturePendingDoc';
  contractNumber?: Maybe<Scalars['String']['output']>;
  editionDocumentationId: Scalars['ID']['output'];
  signatureFoundButUnlinked: Scalars['Boolean']['output'];
};

export type EditionType = {
  __typename?: 'EditionType';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type EditionType_CreateInput = {
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type EditionType_Filter = {
  AND?: InputMaybe<Array<EditionType_Filter>>;
  NOT?: InputMaybe<Array<EditionType_Filter>>;
  OR?: InputMaybe<Array<EditionType_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type EditionType_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type EditionType_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type EditionType_UpdateInput = {
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Edition_CreateInput = {
  contentType: EditionContentType;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  editionTypeId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
  publicationLink?: InputMaybe<Scalars['String']['input']>;
  userAttachments?: InputMaybe<Array<UserAttachmentEdition_CreateInput>>;
  worksIds: Array<Scalars['String']['input']>;
};

export type Edition_Filter = {
  AND?: InputMaybe<Array<Edition_Filter>>;
  NOT?: InputMaybe<Array<Edition_Filter>>;
  OR?: InputMaybe<Array<Edition_Filter>>;
  associatedDocuments?: InputMaybe<Edition_AssociatedDocuments_Filter>;
  contentType?: InputMaybe<FilterString>;
  contractObservation?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  dndaExpedienteNumber?: InputMaybe<FilterString>;
  documentation?: InputMaybe<Edition_Documentation_Filter>;
  documentationLastOperationalError?: InputMaybe<FilterString>;
  documentationState?: InputMaybe<EditionDocumentationWorkflowState_Filter>;
  documentationState_transitions_?: InputMaybe<FilterStringList>;
  editionNumber?: InputMaybe<FilterInt>;
  editionType?: InputMaybe<EditionType_Filter>;
  ejemplarPdf?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  notes?: InputMaybe<FilterString>;
  price?: InputMaybe<FilterDecimal>;
  publicationDate?: InputMaybe<FilterDate>;
  publicationLink?: InputMaybe<FilterString>;
  userAttachments?: InputMaybe<Edition_UserAttachments_Filter>;
  version_?: InputMaybe<FilterString>;
  works?: InputMaybe<Edition_Works_Filter>;
};

export type Edition_OrderBy = {
  associatedDocuments?: InputMaybe<OrderByMultiple>;
  contentType?: InputMaybe<SortOrder>;
  contractObservation?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  dndaExpedienteNumber?: InputMaybe<SortOrder>;
  documentation?: InputMaybe<OrderByMultiple>;
  documentationLastOperationalError?: InputMaybe<SortOrder>;
  documentationState?: InputMaybe<EditionDocumentationWorkflowState_OrderBy>;
  documentationState_transitions_?: InputMaybe<SortOrder>;
  editionNumber?: InputMaybe<SortOrder>;
  editionType?: InputMaybe<EditionType_OrderBy>;
  ejemplarPdf?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  publicationDate?: InputMaybe<SortOrder>;
  publicationLink?: InputMaybe<SortOrder>;
  userAttachments?: InputMaybe<OrderByMultiple>;
  version_?: InputMaybe<SortOrder>;
  works?: InputMaybe<OrderByMultiple>;
};

export type Edition_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type Edition_UpdateInput = {
  contentType?: InputMaybe<EditionContentType>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  editionTypeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publicationLink?: InputMaybe<Scalars['String']['input']>;
  userAttachments?: InputMaybe<Edition_UserAttachments_UpdateInput>;
  version_: Scalars['String']['input'];
  worksIds?: InputMaybe<InputMultipleRef>;
};

export type Edition_AssociatedDocuments_Filter = {
  every?: InputMaybe<AssociatedDocumentEdition_Filter>;
  none?: InputMaybe<AssociatedDocumentEdition_Filter>;
  some?: InputMaybe<AssociatedDocumentEdition_Filter>;
};

export type Edition_Documentation_Filter = {
  every?: InputMaybe<EditionDocumentation_Filter>;
  none?: InputMaybe<EditionDocumentation_Filter>;
  some?: InputMaybe<EditionDocumentation_Filter>;
};

export type Edition_UserAttachments_Filter = {
  every?: InputMaybe<UserAttachmentEdition_Filter>;
  none?: InputMaybe<UserAttachmentEdition_Filter>;
  some?: InputMaybe<UserAttachmentEdition_Filter>;
};

export type Edition_UserAttachments_UpdateInput = {
  create?: InputMaybe<Array<UserAttachmentEdition_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<UserAttachmentEdition_UpdateInput>>;
};

export type Edition_Works_Filter = {
  every?: InputMaybe<MusicalWork_Filter>;
  none?: InputMaybe<MusicalWork_Filter>;
  some?: InputMaybe<MusicalWork_Filter>;
};

export enum EmailFrequency {
  DailyDigest = 'daily_digest',
  Immediate = 'immediate',
  WeeklyDigest = 'weekly_digest'
}

export type EmailVerification = {
  __typename?: 'EmailVerification';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  requestedBy: User;
  scope?: Maybe<EmailVerificationScope>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentCount: Scalars['Int']['output'];
  sourceEntity?: Maybe<Scalars['String']['output']>;
  sourceRecordId?: Maybe<Scalars['String']['output']>;
  status: EmailVerificationStatus;
  validationChanges?: Maybe<Scalars['Json']['output']>;
  validationSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  version_: Scalars['String']['output'];
};

export enum EmailVerificationScope {
  Data = 'data',
  Email = 'email'
}

export enum EmailVerificationStatus {
  Expired = 'expired',
  Pending = 'pending',
  Revoked = 'revoked',
  Verified = 'verified'
}

export type EmailVerification_CreateInput = {
  email: Scalars['String']['input'];
};

export type EmailVerification_Filter = {
  AND?: InputMaybe<Array<EmailVerification_Filter>>;
  NOT?: InputMaybe<Array<EmailVerification_Filter>>;
  OR?: InputMaybe<Array<EmailVerification_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  email?: InputMaybe<FilterString>;
  expiresAt?: InputMaybe<FilterDateTime>;
  id?: InputMaybe<FilterString>;
  lastSentAt?: InputMaybe<FilterDateTime>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  requestedBy?: InputMaybe<User_Filter>;
  scope?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterDateTime>;
  sentCount?: InputMaybe<FilterInt>;
  sourceEntity?: InputMaybe<FilterString>;
  sourceRecordId?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterString>;
  validationChanges?: InputMaybe<FilterJson>;
  validationSubmittedAt?: InputMaybe<FilterDateTime>;
  verifiedAt?: InputMaybe<FilterDateTime>;
  version_?: InputMaybe<FilterString>;
};

export type EmailVerification_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  email?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastSentAt?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  requestedBy?: InputMaybe<User_OrderBy>;
  scope?: InputMaybe<SortOrder>;
  sentAt?: InputMaybe<SortOrder>;
  sentCount?: InputMaybe<SortOrder>;
  sourceEntity?: InputMaybe<SortOrder>;
  sourceRecordId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validationChanges?: InputMaybe<SortOrder>;
  validationSubmittedAt?: InputMaybe<SortOrder>;
  verifiedAt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type EmailVerification_OrderByCursor = {
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EmailVerification_UpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
};

export type EsignatureConfig = {
  __typename?: 'EsignatureConfig';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  credentials: Scalars['Json']['output'];
  displayId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  provider: EsignatureProvider;
  sandboxMode: Scalars['Boolean']['output'];
  version_: Scalars['String']['output'];
  webhookSecret?: Maybe<Scalars['String']['output']>;
};

export type EsignatureConfig_CreateInput = {
  credentials: Scalars['Json']['input'];
  enabled: Scalars['Boolean']['input'];
  provider: EsignatureProvider;
  sandboxMode: Scalars['Boolean']['input'];
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

export type EsignatureConfig_Filter = {
  AND?: InputMaybe<Array<EsignatureConfig_Filter>>;
  NOT?: InputMaybe<Array<EsignatureConfig_Filter>>;
  OR?: InputMaybe<Array<EsignatureConfig_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  credentials?: InputMaybe<FilterJson>;
  displayId?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  provider?: InputMaybe<FilterString>;
  sandboxMode?: InputMaybe<FilterBoolean>;
  version_?: InputMaybe<FilterString>;
  webhookSecret?: InputMaybe<FilterString>;
};

export type EsignatureConfig_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  credentials?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  provider?: InputMaybe<SortOrder>;
  sandboxMode?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
  webhookSecret?: InputMaybe<SortOrder>;
};

export type EsignatureConfig_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type EsignatureConfig_UpdateInput = {
  credentials?: InputMaybe<Scalars['Json']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  provider?: InputMaybe<EsignatureProvider>;
  sandboxMode?: InputMaybe<Scalars['Boolean']['input']>;
  version_: Scalars['String']['input'];
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

export type EsignatureDocument = {
  __typename?: 'EsignatureDocument';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  provider: EsignatureProvider;
  recipients: Array<EsignatureRecipient>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signedDocument?: Maybe<Scalars['String']['output']>;
  signedDocument_data?: Maybe<FileData>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
  status: EsignatureDocumentStatus;
  version_: Scalars['String']['output'];
};

export enum EsignatureDocumentStatus {
  Completed = 'completed',
  Declined = 'declined',
  Delivered = 'delivered',
  Draft = 'draft',
  Error = 'error',
  Expired = 'expired',
  Sent = 'sent',
  Voided = 'voided'
}

export type EsignatureDocument_Filter = {
  AND?: InputMaybe<Array<EsignatureDocument_Filter>>;
  NOT?: InputMaybe<Array<EsignatureDocument_Filter>>;
  OR?: InputMaybe<Array<EsignatureDocument_Filter>>;
  completedAt?: InputMaybe<FilterDateTime>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  externalId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  provider?: InputMaybe<FilterString>;
  recipients?: InputMaybe<EsignatureDocument_Recipients_Filter>;
  sentAt?: InputMaybe<FilterDateTime>;
  signedDocument?: InputMaybe<FilterString>;
  sourceEntityId?: InputMaybe<FilterString>;
  sourceEntityType?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type EsignatureDocument_OrderBy = {
  completedAt?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  recipients?: InputMaybe<OrderByMultiple>;
  sentAt?: InputMaybe<SortOrder>;
  signedDocument?: InputMaybe<SortOrder>;
  sourceEntityId?: InputMaybe<SortOrder>;
  sourceEntityType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type EsignatureDocument_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type EsignatureDocument_Recipients_Filter = {
  every?: InputMaybe<EsignatureRecipient_Filter>;
  none?: InputMaybe<EsignatureRecipient_Filter>;
  some?: InputMaybe<EsignatureRecipient_Filter>;
};

export enum EsignatureProvider {
  AgilSign = 'agilSign',
  DocuSign = 'docuSign',
  PandaDoc = 'pandaDoc',
  SignNow = 'signNow'
}

export type EsignatureRecipient = {
  __typename?: 'EsignatureRecipient';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  document: EsignatureDocument;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parent_EsignatureDocument_recipients: EsignatureDocument;
  role: Scalars['String']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status: EsignatureRecipientStatus;
  version_: Scalars['String']['output'];
};

export enum EsignatureRecipientStatus {
  AuthFailed = 'authFailed',
  Bounced = 'bounced',
  Declined = 'declined',
  Delivered = 'delivered',
  Pending = 'pending',
  Sent = 'sent',
  Signed = 'signed'
}

export type EsignatureRecipient_Filter = {
  AND?: InputMaybe<Array<EsignatureRecipient_Filter>>;
  NOT?: InputMaybe<Array<EsignatureRecipient_Filter>>;
  OR?: InputMaybe<Array<EsignatureRecipient_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  document?: InputMaybe<EsignatureDocument_Filter>;
  email?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  order?: InputMaybe<FilterInt>;
  parent_EsignatureDocument_recipients?: InputMaybe<EsignatureDocument_Filter>;
  role?: InputMaybe<FilterString>;
  signedAt?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type EsignatureRecipient_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  document?: InputMaybe<EsignatureDocument_OrderBy>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  signedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type EsignatureRecipient_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type EsignatureWebhookEvent = {
  __typename?: 'EsignatureWebhookEvent';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  documentExternalId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  externalEventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  provider: EsignatureProvider;
  version_: Scalars['String']['output'];
};

export type EsignatureWebhookEvent_Filter = {
  AND?: InputMaybe<Array<EsignatureWebhookEvent_Filter>>;
  NOT?: InputMaybe<Array<EsignatureWebhookEvent_Filter>>;
  OR?: InputMaybe<Array<EsignatureWebhookEvent_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  documentExternalId?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterString>;
  externalEventId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  processedAt?: InputMaybe<FilterDateTime>;
  provider?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type EsignatureWebhookEvent_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  documentExternalId?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  eventType?: InputMaybe<SortOrder>;
  externalEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  processedAt?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type EsignatureWebhookEvent_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export enum EvaluationAmbiguityType {
  ChartGrouping = 'chart_grouping',
  ColumnAmbiguity = 'column_ambiguity',
  OperationAmbiguity = 'operation_ambiguity',
  UnknownTerm = 'unknown_term',
  ValueAmbiguity = 'value_ambiguity'
}

export enum EvaluationDifficulty {
  Easy = 'easy',
  Hard = 'hard',
  Medium = 'medium'
}

export enum EvaluationPathType {
  DirectRef = 'direct_ref',
  DirectSet = 'direct_set',
  EntityOnly = 'entity_only',
  InverseJunction = 'inverse_junction',
  InverseParent = 'inverse_parent',
  InverseRef = 'inverse_ref',
  Junction = 'junction',
  NestedSet = 'nested_set'
}

export type EvaluationQuery = {
  __typename?: 'EvaluationQuery';
  acceptableTools: Scalars['Json']['output'];
  ambiguityType?: Maybe<EvaluationAmbiguityType>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  difficulty: EvaluationDifficulty;
  disambiguationResponse?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  expectedArgs: Scalars['Json']['output'];
  expectedResponsePattern?: Maybe<Scalars['String']['output']>;
  expectedTool: Scalars['String']['output'];
  generatedFrom: Scalars['Json']['output'];
  id: Scalars['String']['output'];
  isAmbiguous: Scalars['Boolean']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  notes?: Maybe<Scalars['String']['output']>;
  pathType: EvaluationPathType;
  query: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type EvaluationQuery_CreateInput = {
  acceptableTools: Scalars['Json']['input'];
  ambiguityType?: InputMaybe<EvaluationAmbiguityType>;
  difficulty: EvaluationDifficulty;
  disambiguationResponse?: InputMaybe<Scalars['String']['input']>;
  expectedArgs: Scalars['Json']['input'];
  expectedResponsePattern?: InputMaybe<Scalars['String']['input']>;
  expectedTool: Scalars['String']['input'];
  generatedFrom: Scalars['Json']['input'];
  isAmbiguous: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pathType: EvaluationPathType;
  query: Scalars['String']['input'];
};

export type EvaluationQuery_Filter = {
  AND?: InputMaybe<Array<EvaluationQuery_Filter>>;
  NOT?: InputMaybe<Array<EvaluationQuery_Filter>>;
  OR?: InputMaybe<Array<EvaluationQuery_Filter>>;
  acceptableTools?: InputMaybe<FilterJson>;
  ambiguityType?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  difficulty?: InputMaybe<FilterString>;
  disambiguationResponse?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  expectedArgs?: InputMaybe<FilterJson>;
  expectedResponsePattern?: InputMaybe<FilterString>;
  expectedTool?: InputMaybe<FilterString>;
  generatedFrom?: InputMaybe<FilterJson>;
  id?: InputMaybe<FilterString>;
  isAmbiguous?: InputMaybe<FilterBoolean>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  notes?: InputMaybe<FilterString>;
  pathType?: InputMaybe<FilterString>;
  query?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type EvaluationQuery_OrderBy = {
  acceptableTools?: InputMaybe<SortOrder>;
  ambiguityType?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  difficulty?: InputMaybe<SortOrder>;
  disambiguationResponse?: InputMaybe<SortOrder>;
  expectedArgs?: InputMaybe<SortOrder>;
  expectedResponsePattern?: InputMaybe<SortOrder>;
  expectedTool?: InputMaybe<SortOrder>;
  generatedFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAmbiguous?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  notes?: InputMaybe<SortOrder>;
  pathType?: InputMaybe<SortOrder>;
  query?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type EvaluationQuery_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type EvaluationQuery_UpdateInput = {
  acceptableTools?: InputMaybe<Scalars['Json']['input']>;
  ambiguityType?: InputMaybe<EvaluationAmbiguityType>;
  difficulty?: InputMaybe<EvaluationDifficulty>;
  disambiguationResponse?: InputMaybe<Scalars['String']['input']>;
  expectedArgs?: InputMaybe<Scalars['Json']['input']>;
  expectedResponsePattern?: InputMaybe<Scalars['String']['input']>;
  expectedTool?: InputMaybe<Scalars['String']['input']>;
  generatedFrom?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['String']['input'];
  isAmbiguous?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pathType?: InputMaybe<EvaluationPathType>;
  query?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export enum EvaluationRating {
  Partial = 'partial',
  ThumbsDown = 'thumbs_down',
  ThumbsUp = 'thumbs_up'
}

export type FileData = {
  __typename?: 'FileData';
  description?: Maybe<Scalars['String']['output']>;
  mimetype: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  thumbnails?: Maybe<Array<Maybe<Thumbnail>>>;
  url: Scalars['String']['output'];
};

export type FileData_UpdateInput = {
  create?: InputMaybe<Array<UploadedFile>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<UploadedFile>>;
};

export type FilterBoolean = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterDate = {
  equals?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterDateTime = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  range?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type FilterDecimal = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<Scalars['Decimal']['input']>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type FilterFloat = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FilterInt = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilterJson = {
  byPath?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
};

export enum FilterMode {
  Insensitive = 'insensitive'
}

export type FilterString = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<FilterMode>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  range?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type FilterStringList = {
  equals?: InputMaybe<Scalars['String']['input']>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasNone?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum Gender {
  Female = 'female',
  Male = 'male',
  NonBinary = 'nonBinary'
}

export type GrossReceiptsStatus = {
  __typename?: 'GrossReceiptsStatus';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type GrossReceiptsStatus_CreateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type GrossReceiptsStatus_Filter = {
  AND?: InputMaybe<Array<GrossReceiptsStatus_Filter>>;
  NOT?: InputMaybe<Array<GrossReceiptsStatus_Filter>>;
  OR?: InputMaybe<Array<GrossReceiptsStatus_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description_en?: InputMaybe<FilterString>;
  description_es?: InputMaybe<FilterString>;
  description_pt?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type GrossReceiptsStatus_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description_en?: InputMaybe<SortOrder>;
  description_es?: InputMaybe<SortOrder>;
  description_pt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type GrossReceiptsStatus_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type GrossReceiptsStatus_UpdateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export enum IdCardType {
  AnyIdCard = 'anyIdCard',
  CuitCuil = 'cuitCuil',
  Dni = 'dni'
}

export type InputMultipleRef = {
  add?: InputMaybe<Array<Scalars['String']['input']>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Interpreter = {
  __typename?: 'Interpreter';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type Interpreter_CreateInput = {
  name: Scalars['String']['input'];
};

export type Interpreter_Filter = {
  AND?: InputMaybe<Array<Interpreter_Filter>>;
  NOT?: InputMaybe<Array<Interpreter_Filter>>;
  OR?: InputMaybe<Array<Interpreter_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Interpreter_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Interpreter_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type Interpreter_UpdateInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export enum Language {
  En = 'en',
  Es = 'es',
  Pt = 'pt'
}

export type LlmProvider = {
  __typename?: 'LlmProvider';
  code: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  defaultModels: Array<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiresApiKey: Scalars['Boolean']['output'];
  requiresBaseUrl: Scalars['Boolean']['output'];
  version_: Scalars['String']['output'];
};

export type LlmProvider_CreateInput = {
  code: Scalars['String']['input'];
  defaultModels: Array<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requiresApiKey: Scalars['Boolean']['input'];
  requiresBaseUrl: Scalars['Boolean']['input'];
};

export type LlmProvider_Filter = {
  AND?: InputMaybe<Array<LlmProvider_Filter>>;
  NOT?: InputMaybe<Array<LlmProvider_Filter>>;
  OR?: InputMaybe<Array<LlmProvider_Filter>>;
  code?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  defaultModels?: InputMaybe<FilterStringList>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  logoUrl?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  requiresApiKey?: InputMaybe<FilterBoolean>;
  requiresBaseUrl?: InputMaybe<FilterBoolean>;
  version_?: InputMaybe<FilterString>;
};

export type LlmProvider_OrderBy = {
  code?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  defaultModels?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  logoUrl?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  requiresApiKey?: InputMaybe<SortOrder>;
  requiresBaseUrl?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type LlmProvider_OrderByCursor = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type LlmProvider_UpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  defaultModels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresApiKey?: InputMaybe<Scalars['Boolean']['input']>;
  requiresBaseUrl?: InputMaybe<Scalars['Boolean']['input']>;
  version_: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessExpiresIn?: Maybe<Scalars['Int']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  refreshExpiresIn?: Maybe<Scalars['Int']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tempToken?: Maybe<Scalars['String']['output']>;
  twoFaAction?: Maybe<Scalars['String']['output']>;
  twoFaRequired: Scalars['Boolean']['output'];
};

export enum MaritalStatus {
  CivilUnion = 'civilUnion',
  CommonLawUnion = 'commonLawUnion',
  Divorced = 'divorced',
  Married = 'married',
  NotDeclared = 'notDeclared',
  Separated = 'separated',
  Single = 'single',
  Widowed = 'widowed'
}

export type MusicalGenre = {
  __typename?: 'MusicalGenre';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type MusicalGenre_CreateInput = {
  name: Scalars['String']['input'];
};

export type MusicalGenre_Filter = {
  AND?: InputMaybe<Array<MusicalGenre_Filter>>;
  NOT?: InputMaybe<Array<MusicalGenre_Filter>>;
  OR?: InputMaybe<Array<MusicalGenre_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type MusicalGenre_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type MusicalGenre_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type MusicalGenre_UpdateInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type MusicalWork = {
  __typename?: 'MusicalWork';
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  authors: Array<WorkAuthor>;
  cmsId?: Maybe<Scalars['String']['output']>;
  contractObservation?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  iswc?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  musicalGenre: MusicalGenre;
  notes?: Maybe<Scalars['String']['output']>;
  originalLyrics?: Maybe<Scalars['String']['output']>;
  performers?: Maybe<Array<Interpreter>>;
  phonograms?: Maybe<Array<Phonogram>>;
  score?: Maybe<Scalars['String']['output']>;
  score_data?: Maybe<FileData>;
  territories: Array<Territory>;
  title: Scalars['String']['output'];
  version_: Scalars['String']['output'];
  workNumber: Scalars['Int']['output'];
};

export type MusicalWorkLink = {
  __typename?: 'MusicalWorkLink';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_Phonogram_links: Phonogram;
  platform?: Maybe<Platform>;
  type?: Maybe<PlatformLinkType>;
  url: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type MusicalWorkLink_CreateInput = {
  platformId?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type MusicalWorkLink_Filter = {
  AND?: InputMaybe<Array<MusicalWorkLink_Filter>>;
  NOT?: InputMaybe<Array<MusicalWorkLink_Filter>>;
  OR?: InputMaybe<Array<MusicalWorkLink_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_Phonogram_links?: InputMaybe<Phonogram_Filter>;
  platform?: InputMaybe<Platform_Filter>;
  type?: InputMaybe<PlatformLinkType_Filter>;
  url?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type MusicalWorkLink_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  platform?: InputMaybe<Platform_OrderBy>;
  type?: InputMaybe<PlatformLinkType_OrderBy>;
  url?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type MusicalWorkLink_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type MusicalWorkLink_UpdateInput = {
  id: Scalars['String']['input'];
  platformId?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type MusicalWork_CreateInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  authors: Array<WorkAuthor_CreateInput>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  iswc?: InputMaybe<Scalars['String']['input']>;
  musicalGenreId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLyrics?: InputMaybe<Scalars['String']['input']>;
  performersIds?: InputMaybe<Array<Scalars['String']['input']>>;
  phonograms?: InputMaybe<Array<Phonogram_CreateInput>>;
  score?: InputMaybe<UploadedFile>;
  territoriesIds: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type MusicalWork_Filter = {
  AND?: InputMaybe<Array<MusicalWork_Filter>>;
  NOT?: InputMaybe<Array<MusicalWork_Filter>>;
  OR?: InputMaybe<Array<MusicalWork_Filter>>;
  alternativeTitles?: InputMaybe<FilterStringList>;
  authors?: InputMaybe<MusicalWork_Authors_Filter>;
  cmsId?: InputMaybe<FilterString>;
  contractObservation?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  iswc?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  musicalGenre?: InputMaybe<MusicalGenre_Filter>;
  notes?: InputMaybe<FilterString>;
  originalLyrics?: InputMaybe<FilterString>;
  performers?: InputMaybe<MusicalWork_Performers_Filter>;
  phonograms?: InputMaybe<MusicalWork_Phonograms_Filter>;
  score?: InputMaybe<FilterString>;
  territories?: InputMaybe<MusicalWork_Territories_Filter>;
  title?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
  workNumber?: InputMaybe<FilterInt>;
};

export type MusicalWork_OrderBy = {
  alternativeTitles?: InputMaybe<SortOrder>;
  authors?: InputMaybe<OrderByMultiple>;
  cmsId?: InputMaybe<SortOrder>;
  contractObservation?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  iswc?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  musicalGenre?: InputMaybe<MusicalGenre_OrderBy>;
  notes?: InputMaybe<SortOrder>;
  originalLyrics?: InputMaybe<SortOrder>;
  performers?: InputMaybe<OrderByMultiple>;
  phonograms?: InputMaybe<OrderByMultiple>;
  score?: InputMaybe<SortOrder>;
  territories?: InputMaybe<OrderByMultiple>;
  title?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
  workNumber?: InputMaybe<SortOrder>;
};

export type MusicalWork_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  iswc?: InputMaybe<SortOrder>;
};

export type MusicalWork_UpdateInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  authors?: InputMaybe<MusicalWork_Authors_UpdateInput>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  iswc?: InputMaybe<Scalars['String']['input']>;
  musicalGenreId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLyrics?: InputMaybe<Scalars['String']['input']>;
  performersIds?: InputMaybe<InputMultipleRef>;
  phonograms?: InputMaybe<MusicalWork_Phonograms_UpdateInput>;
  score?: InputMaybe<UploadedFile>;
  territoriesIds?: InputMaybe<InputMultipleRef>;
  title?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type MusicalWork_Authors_Filter = {
  every?: InputMaybe<WorkAuthor_Filter>;
  none?: InputMaybe<WorkAuthor_Filter>;
  some?: InputMaybe<WorkAuthor_Filter>;
};

export type MusicalWork_Authors_UpdateInput = {
  create?: InputMaybe<Array<WorkAuthor_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<WorkAuthor_UpdateInput>>;
};

export type MusicalWork_Performers_Filter = {
  every?: InputMaybe<Interpreter_Filter>;
  none?: InputMaybe<Interpreter_Filter>;
  some?: InputMaybe<Interpreter_Filter>;
};

export type MusicalWork_Phonograms_Filter = {
  every?: InputMaybe<Phonogram_Filter>;
  none?: InputMaybe<Phonogram_Filter>;
  some?: InputMaybe<Phonogram_Filter>;
};

export type MusicalWork_Phonograms_UpdateInput = {
  create?: InputMaybe<Array<Phonogram_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<Phonogram_UpdateInput>>;
};

export type MusicalWork_Territories_Filter = {
  every?: InputMaybe<Territory_Filter>;
  none?: InputMaybe<Territory_Filter>;
  some?: InputMaybe<Territory_Filter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  aiSearchAutoEvalDelete: AiSearchAutoEval;
  aiSearchConversationDelete: AiSearchConversation;
  aiSearchPatternCreate: AiSearchPattern;
  aiSearchPatternDelete: AiSearchPattern;
  aiSearchPatternUpdate: AiSearchPattern;
  aiSearchResponseCreate: AiSearchResponse;
  aiSearchResponseDelete: AiSearchResponse;
  alertRuleCreate: AlertRule;
  alertRuleDelete: AlertRule;
  alertRuleUpdate: AlertRule;
  alertSubscriptionCreate: AlertSubscription;
  alertSubscriptionDelete: AlertSubscription;
  alertSubscriptionUpdate: AlertSubscription;
  applyTheme: Theme;
  /** Archive a notification (soft delete) */
  archiveNotification: UserNotificationResult;
  authorComposerCreate: AuthorComposer;
  authorComposerDelete: AuthorComposer;
  authorComposerPublicCreate: AuthorComposerPublic;
  authorComposerPublicDelete: AuthorComposerPublic;
  authorComposerPublicUpdate: AuthorComposerPublic;
  authorComposerUpdate: AuthorComposer;
  /** Authorize a pending satellite, allowing it to connect. */
  authorizeSatellite: SatelliteAdminResult;
  botRunCancel: Scalars['String']['output'];
  botRunDelete: BotRun;
  broadcastMaintenance: Scalars['Int']['output'];
  collectiveManagementSocietyCreate: CollectiveManagementSociety;
  collectiveManagementSocietyDelete: CollectiveManagementSociety;
  collectiveManagementSocietyUpdate: CollectiveManagementSociety;
  confirmTwoFaSetup: AuthenticateResponse;
  contractObservationCreate: ContractObservation;
  contractObservationDelete: ContractObservation;
  contractObservationUpdate: ContractObservation;
  countryCreate: Country;
  countryDelete: Country;
  countryUpdate: Country;
  /**
   * Create a new satellite machine and generate its initial token.
   * The plainToken is only returned once - store it securely.
   */
  createSatelliteMachine: SatelliteAdminResult;
  creditAccountUpdate: CreditAccount;
  creditPurchaseCreate: CreditPurchase;
  creditPurchaseDelete: CreditPurchase;
  creditTierCreate: CreditTier;
  creditTierDelete: CreditTier;
  creditTierUpdate: CreditTier;
  currencyCreate: Currency;
  currencyDelete: Currency;
  currencyUpdate: Currency;
  dashboardLayoutTemplateCreate: DashboardLayoutTemplate;
  dashboardLayoutTemplateDelete: DashboardLayoutTemplate;
  dashboardLayoutTemplateUpdate: DashboardLayoutTemplate;
  deactivateTheme: Scalars['Boolean']['output'];
  deleteTheme: Scalars['Boolean']['output'];
  deleteUploadedFile: Scalars['String']['output'];
  designShowcaseCreate: DesignShowcase;
  designShowcaseDelete: DesignShowcase;
  designShowcaseUpdate: DesignShowcase;
  /** Force disconnect a connected satellite. */
  disconnectSatellite: SatelliteAdminResult;
  documentGenerationParamsCreate: DocumentGenerationParams;
  documentGenerationParamsDelete: DocumentGenerationParams;
  documentGenerationParamsUpdate: DocumentGenerationParams;
  editionCreate: Edition;
  editionDelete: Edition;
  editionDocumentTypeCreate: EditionDocumentType;
  editionDocumentTypeDelete: EditionDocumentType;
  editionDocumentTypeUpdate: EditionDocumentType;
  editionDocumentationWorkflowStateCreate: EditionDocumentationWorkflowState;
  editionDocumentationWorkflowStateDelete: EditionDocumentationWorkflowState;
  editionDocumentationWorkflowStateUpdate: EditionDocumentationWorkflowState;
  editionDocumentationWorkflow_BackToDocsFromSignatureFailed: EditionDocumentationWorkflow_BackToDocsFromSignatureFailedResult;
  editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct: EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctResult;
  editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar: EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarResult;
  editionDocumentationWorkflow_BorrarDocumentacionFromFallo: EditionDocumentationWorkflow_BorrarDocumentacionFromFalloResult;
  editionDocumentationWorkflow_CancelGeneration: EditionDocumentationWorkflow_CancelGenerationResult;
  editionDocumentationWorkflow_CancelSending: EditionDocumentationWorkflow_CancelSendingResult;
  editionDocumentationWorkflow_DeleteAndRestartFromFailed: EditionDocumentationWorkflow_DeleteAndRestartFromFailedResult;
  editionDocumentationWorkflow_DeleteAndRestartFromGenerated: EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedResult;
  editionDocumentationWorkflow_DeleteAndRestartFromSignature: EditionDocumentationWorkflow_DeleteAndRestartFromSignatureResult;
  editionDocumentationWorkflow_GenerateDocumentation: EditionDocumentationWorkflow_GenerateDocumentationResult;
  editionDocumentationWorkflow_ReintentarCierreFirmas: EditionDocumentationWorkflow_ReintentarCierreFirmasResult;
  editionDocumentationWorkflow_RetryGenerateDocumentation: EditionDocumentationWorkflow_RetryGenerateDocumentationResult;
  editionDocumentationWorkflow_RetrySendForSignature: EditionDocumentationWorkflow_RetrySendForSignatureResult;
  editionDocumentationWorkflow_SendForSignature: EditionDocumentationWorkflow_SendForSignatureResult;
  editionTypeCreate: EditionType;
  editionTypeDelete: EditionType;
  editionTypeUpdate: EditionType;
  editionUpdate: Edition;
  emailVerificationCreate: EmailVerification;
  emailVerificationDelete: EmailVerification;
  emailVerificationUpdate: EmailVerification;
  esignatureConfigCreate: EsignatureConfig;
  esignatureConfigUpdate: EsignatureConfig;
  evaluationQueryCreate: EvaluationQuery;
  evaluationQueryDelete: EvaluationQuery;
  evaluationQueryUpdate: EvaluationQuery;
  grossReceiptsStatusCreate: GrossReceiptsStatus;
  grossReceiptsStatusDelete: GrossReceiptsStatus;
  grossReceiptsStatusUpdate: GrossReceiptsStatus;
  interpreterCreate: Interpreter;
  interpreterDelete: Interpreter;
  interpreterUpdate: Interpreter;
  llmProviderCreate: LlmProvider;
  llmProviderDelete: LlmProvider;
  llmProviderUpdate: LlmProvider;
  login: LoginResponse;
  logout: Scalars['Boolean']['output'];
  /**
   * Mark all notifications as read
   * Returns the number of notifications marked as read
   */
  markAllNotificationsRead: Scalars['Int']['output'];
  /** Mark a single notification as read */
  markNotificationRead: UserNotificationResult;
  musicalGenreCreate: MusicalGenre;
  musicalGenreDelete: MusicalGenre;
  musicalGenreUpdate: MusicalGenre;
  musicalWorkCreate: MusicalWork;
  musicalWorkDelete: MusicalWork;
  musicalWorkUpdate: MusicalWork;
  paymentReceiptBatchCreate: PaymentReceiptBatchCreateResult;
  paymentReceiptCreate: PaymentReceipt;
  paymentReceiptDelete: PaymentReceipt;
  paymentReceiptTypeCreate: PaymentReceiptType;
  paymentReceiptTypeDelete: PaymentReceiptType;
  paymentReceiptTypeUpdate: PaymentReceiptType;
  paymentReceiptUpdate: PaymentReceipt;
  permissionCreate: Permission;
  permissionDelete: Permission;
  permissionUpdate: Permission;
  platformCreate: Platform;
  platformDelete: Platform;
  platformLinkTypeCreate: PlatformLinkType;
  platformLinkTypeDelete: PlatformLinkType;
  platformLinkTypeUpdate: PlatformLinkType;
  platformUpdate: Platform;
  previewTheme: ThemePreviewResult;
  provinceStateCreate: ProvinceState;
  provinceStateDelete: ProvinceState;
  provinceStateUpdate: ProvinceState;
  publisherCreate: Publisher;
  publisherDelete: Publisher;
  publisherUpdate: Publisher;
  queryPatternCreate: QueryPattern;
  queryPatternDelete: QueryPattern;
  queryPatternUpdate: QueryPattern;
  /** Reactivate a suspended satellite. */
  reactivateSatellite: SatelliteAdminResult;
  recheckEditionSignatures: EditionSignatureCheckResult;
  refreshToken: AuthenticateResponse;
  reportCreate: Report;
  reportDelete: Report;
  reportTypeCreate: ReportType;
  reportTypeDelete: ReportType;
  reportTypeUpdate: ReportType;
  reportUpdate: Report;
  resendSignatureEmail: Scalars['Boolean']['output'];
  revokeAllTokens: Scalars['Boolean']['output'];
  revokeAllTrustedDevices: Scalars['Boolean']['output'];
  /** Revoke a satellite permanently. Cannot be undone. */
  revokeSatellite: SatelliteAdminResult;
  revokeTrustedDevice: Scalars['Boolean']['output'];
  roleCreate: Role;
  roleDelete: Role;
  roleUpdate: Role;
  /**
   * Rotate the satellite's authentication token.
   * Returns the new plainToken - only shown once.
   */
  rotateSatelliteToken: SatelliteAdminResult;
  satelliteHeartbeatDelete: SatelliteHeartbeat;
  satelliteMachineCreate: SatelliteMachine;
  satelliteMachineDelete: SatelliteMachine;
  satelliteMachineUpdate: SatelliteMachine;
  saveProfile: Scalars['Boolean']['output'];
  saveTheme: Theme;
  setMyLanguage: User;
  /** Toggle the enabled flag without changing status. */
  setSatelliteEnabled: SatelliteAdminResult;
  setupTwoFa: TwoFaSetupResponse;
  showcaseCategoryCreate: ShowcaseCategory;
  showcaseCategoryDelete: ShowcaseCategory;
  showcaseCategoryUpdate: ShowcaseCategory;
  showcaseWorkflowStateCreate: ShowcaseWorkflowState;
  showcaseWorkflowStateDelete: ShowcaseWorkflowState;
  showcaseWorkflowStateUpdate: ShowcaseWorkflowState;
  showcaseWorkflow_Approve: ShowcaseWorkflow_ApproveResult;
  showcaseWorkflow_Close: ShowcaseWorkflow_CloseResult;
  showcaseWorkflow_Fail: ShowcaseWorkflow_FailResult;
  showcaseWorkflow_Reject: ShowcaseWorkflow_RejectResult;
  showcaseWorkflow_Reopen: ShowcaseWorkflow_ReopenResult;
  showcaseWorkflow_Retry: ShowcaseWorkflow_RetryResult;
  showcaseWorkflow_Submit: ShowcaseWorkflow_SubmitResult;
  signedEditionDndaWorkflowStateCreate: SignedEditionDndaWorkflowState;
  signedEditionDndaWorkflowStateDelete: SignedEditionDndaWorkflowState;
  signedEditionDndaWorkflowStateUpdate: SignedEditionDndaWorkflowState;
  signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload: SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadResult;
  signedEditionDndaWorkflow_ReintentarAvanceRegistro: SignedEditionDndaWorkflow_ReintentarAvanceRegistroResult;
  signedEditionDndaWorkflow_ReintentarAvanceUpload: SignedEditionDndaWorkflow_ReintentarAvanceUploadResult;
  signedEditionDndaWorkflow_ReintentarGeneracionEjemplar: SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarResult;
  signedEditionDndaWorkflow_ReintentarRegistroDnda: SignedEditionDndaWorkflow_ReintentarRegistroDndaResult;
  signedEditionDndaWorkflow_ReintentarUploadEjemplar: SignedEditionDndaWorkflow_ReintentarUploadEjemplarResult;
  signedEditionSadaicWorkflowStateCreate: SignedEditionSadaicWorkflowState;
  signedEditionSadaicWorkflowStateDelete: SignedEditionSadaicWorkflowState;
  signedEditionSadaicWorkflowStateUpdate: SignedEditionSadaicWorkflowState;
  signedEditionSadaicWorkflow_ReintentarSubidaSadaic: SignedEditionSadaicWorkflow_ReintentarSubidaSadaicResult;
  simulationControl: SimulationControlResult;
  simulationReset: SimulationResetResult;
  simulationSessionDelete: SimulationSession;
  simulationStart: SimulationStartResult;
  singleUpload: UploadedFileData;
  siteUserCreate: SiteUser;
  siteUserDelete: SiteUser;
  siteUserUpdate: SiteUser;
  snapshotOverrideCreate: SnapshotOverride;
  snapshotOverrideDelete: SnapshotOverride;
  snapshotOverrideUpdate: SnapshotOverride;
  /** Suspend a satellite temporarily. Can be reactivated later. */
  suspendSatellite: SatelliteAdminResult;
  tadManagerConfigUpdate: TadManagerConfig;
  tenantCreate: Tenant;
  tenantDelete: Tenant;
  tenantDocumentCreate: TenantDocument;
  tenantDocumentDelete: TenantDocument;
  tenantDocumentUpdate: TenantDocument;
  tenantLlmConfigCreate: TenantLlmConfig;
  tenantLlmConfigDelete: TenantLlmConfig;
  tenantLlmConfigUpdate: TenantLlmConfig;
  tenantPlanCreate: TenantPlan;
  tenantPlanDelete: TenantPlan;
  tenantPlanUpdate: TenantPlan;
  tenantProfileCreate: TenantProfile;
  tenantProfileDelete: TenantProfile;
  tenantProfileUpdate: TenantProfile;
  tenantStatusCreate: TenantStatus;
  tenantStatusDelete: TenantStatus;
  tenantStatusUpdate: TenantStatus;
  tenantTypeCreate: TenantType;
  tenantTypeDelete: TenantType;
  tenantTypeUpdate: TenantType;
  tenantUpdate: Tenant;
  tenantWidgetAccessCreate: TenantWidgetAccess;
  tenantWidgetAccessDelete: TenantWidgetAccess;
  tenantWidgetAccessUpdate: TenantWidgetAccess;
  territoryCreate: Territory;
  territoryDelete: Territory;
  territoryUpdate: Territory;
  updateMyAvatar: User;
  userChangePassword: User;
  userCreate: User;
  userDelete: User;
  userNotificationDelete: UserNotification;
  userNotificationPreferenceCreate: UserNotificationPreference;
  userNotificationPreferenceDelete: UserNotificationPreference;
  userNotificationPreferenceUpdate: UserNotificationPreference;
  userResetPassword: User;
  userUpdate: User;
  userWidgetConfigCreate: UserWidgetConfig;
  userWidgetConfigDelete: UserWidgetConfig;
  userWidgetConfigUpdate: UserWidgetConfig;
  vatStatusCreate: VatStatus;
  vatStatusDelete: VatStatus;
  vatStatusUpdate: VatStatus;
  verifyTwoFa: AuthenticateResponse;
  verifyTwoFaBackupCode: AuthenticateResponse;
  workerEventDelete: WorkerEvent;
  workerEventRetry: WorkerEventRetryResult;
};


export type MutationAiSearchAutoEvalDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAiSearchConversationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAiSearchPatternCreateArgs = {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  effectiveness?: InputMaybe<Scalars['Decimal']['input']>;
  evaluationCount: Scalars['Int']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pathTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pattern: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  proposedBy?: InputMaybe<Scalars['String']['input']>;
  sourceEvalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  successCount: Scalars['Int']['input'];
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAiSearchPatternDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAiSearchPatternUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveness?: InputMaybe<Scalars['Decimal']['input']>;
  evaluationCount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pathTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  proposedBy?: InputMaybe<Scalars['String']['input']>;
  sourceEvalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  successCount?: InputMaybe<Scalars['Int']['input']>;
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
  version_: Scalars['String']['input'];
};


export type MutationAiSearchResponseCreateArgs = {
  conversationId: Scalars['String']['input'];
  evaluatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  evaluatedById?: InputMaybe<Scalars['String']['input']>;
  explanation?: InputMaybe<Scalars['Json']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  rating?: InputMaybe<EvaluationRating>;
  response: Scalars['String']['input'];
  sources?: InputMaybe<Scalars['Json']['input']>;
  tokenUsage?: InputMaybe<Scalars['Json']['input']>;
  toolCalls: Array<AiSearchToolCall_CreateInput>;
};


export type MutationAiSearchResponseDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAlertRuleCreateArgs = {
  alertType: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['Json']['input']>;
};


export type MutationAlertRuleDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAlertRuleUpdateArgs = {
  alertType?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['Json']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationAlertSubscriptionCreateArgs = {
  alertRuleId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAlertSubscriptionDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAlertSubscriptionUpdateArgs = {
  alertRuleId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationApplyThemeArgs = {
  authoring: Scalars['Json']['input'];
  name: Scalars['String']['input'];
};


export type MutationArchiveNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAuthorComposerCreateArgs = {
  aka?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  ipi?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  managementSocieties?: InputMaybe<Array<AuthorCollectingSociety_CreateInput>>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  publishers?: InputMaybe<Array<AuthorPublisher_CreateInput>>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
};


export type MutationAuthorComposerDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAuthorComposerPublicCreateArgs = {
  aka?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  ipi?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
};


export type MutationAuthorComposerPublicDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationAuthorComposerPublicUpdateArgs = {
  aka?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  ipi?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
  version_: Scalars['String']['input'];
};


export type MutationAuthorComposerUpdateArgs = {
  aka?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  ipi?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  managementSocieties?: InputMaybe<AuthorComposer_ManagementSocieties_UpdateInput>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  publishers?: InputMaybe<AuthorComposer_Publishers_UpdateInput>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxIdType?: InputMaybe<TaxIdType>;
  version_: Scalars['String']['input'];
};


export type MutationAuthorizeSatelliteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBotRunCancelArgs = {
  botRunId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBotRunDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationBroadcastMaintenanceArgs = {
  active: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCollectiveManagementSocietyCreateArgs = {
  acronym: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCollectiveManagementSocietyDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationCollectiveManagementSocietyUpdateArgs = {
  acronym?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationConfirmTwoFaSetupArgs = {
  code: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
  tempToken: Scalars['String']['input'];
};


export type MutationContractObservationCreateArgs = {
  authorsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  observation: Scalars['String']['input'];
  publishersIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requireAll?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};


export type MutationContractObservationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationContractObservationUpdateArgs = {
  authorsIds?: InputMaybe<InputMultipleRef>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  publishersIds?: InputMaybe<InputMultipleRef>;
  requireAll?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationCountryCreateArgs = {
  code: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  demonym_en?: InputMaybe<Scalars['String']['input']>;
  demonym_es?: InputMaybe<Scalars['String']['input']>;
  demonym_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationCountryDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationCountryUpdateArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  demonym_en?: InputMaybe<Scalars['String']['input']>;
  demonym_es?: InputMaybe<Scalars['String']['input']>;
  demonym_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationCreateSatelliteMachineArgs = {
  input: CreateSatelliteMachineInput;
};


export type MutationCreditAccountUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  tierId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationCreditPurchaseCreateArgs = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  purchaseDate: Scalars['Date']['input'];
  quantity: Scalars['Int']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationCreditPurchaseDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreditTierCreateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  monthlyCredits: Scalars['Int']['input'];
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  pricePerCredit: Scalars['Decimal']['input'];
  pricePerExtraCredit: Scalars['Decimal']['input'];
};


export type MutationCreditTierDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreditTierUpdateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  monthlyCredits?: InputMaybe<Scalars['Int']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  pricePerCredit?: InputMaybe<Scalars['Decimal']['input']>;
  pricePerExtraCredit?: InputMaybe<Scalars['Decimal']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationCurrencyCreateArgs = {
  code: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCurrencyDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationCurrencyUpdateArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationDashboardLayoutTemplateCreateArgs = {
  enabled: Scalars['Boolean']['input'];
  forRole?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  isForAllTenants: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  widgets: Scalars['Json']['input'];
};


export type MutationDashboardLayoutTemplateDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDashboardLayoutTemplateUpdateArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  forRole?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isForAllTenants?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
  widgets?: InputMaybe<Scalars['Json']['input']>;
};


export type MutationDeleteThemeArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteUploadedFileArgs = {
  ticket: Scalars['String']['input'];
};


export type MutationDesignShowcaseCreateArgs = {
  active: Scalars['Boolean']['input'];
  amount: Scalars['Decimal']['input'];
  anyFile?: InputMaybe<UploadedFile>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  appliedStatuses?: InputMaybe<Array<ShowcaseStatus>>;
  attachment?: InputMaybe<UploadedFile>;
  avatar?: InputMaybe<UploadedFile>;
  body?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  highlighted: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  lines?: InputMaybe<Array<ShowcaseLine_CreateInput>>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  ratio?: InputMaybe<Scalars['Decimal']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedCategoriesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['Date']['input'];
  status: ShowcaseStatus;
  summary?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDesignShowcaseDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDesignShowcaseUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  anyFile?: InputMaybe<UploadedFile>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  appliedStatuses?: InputMaybe<Array<ShowcaseStatus>>;
  attachment?: InputMaybe<UploadedFile>;
  avatar?: InputMaybe<UploadedFile>;
  body?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  lines?: InputMaybe<DesignShowcase_Lines_UpdateInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  ratio?: InputMaybe<Scalars['Decimal']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedCategoriesIds?: InputMaybe<InputMultipleRef>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<ShowcaseStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationDisconnectSatelliteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDocumentGenerationParamsCreateArgs = {
  contractEffectiveDate: Scalars['Date']['input'];
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDocumentGenerationParamsDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDocumentGenerationParamsUpdateArgs = {
  contractEffectiveDate?: InputMaybe<Scalars['Date']['input']>;
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationEditionCreateArgs = {
  contentType: EditionContentType;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  editionTypeId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
  publicationLink?: InputMaybe<Scalars['String']['input']>;
  userAttachments?: InputMaybe<Array<UserAttachmentEdition_CreateInput>>;
  worksIds: Array<Scalars['String']['input']>;
};


export type MutationEditionDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationEditionDocumentTypeCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationEditionDocumentTypeDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationEditionDocumentTypeUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflowStateCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflowStateDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflowStateUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_BackToDocsFromSignatureFailedArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_BorrarDocumentacionFromFalloArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_CancelGenerationArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_CancelSendingArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_DeleteAndRestartFromFailedArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_DeleteAndRestartFromGeneratedArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_DeleteAndRestartFromSignatureArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_GenerateDocumentationArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_ReintentarCierreFirmasArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_RetryGenerateDocumentationArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_RetrySendForSignatureArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionDocumentationWorkflow_SendForSignatureArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationEditionTypeCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationEditionTypeDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationEditionTypeUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationEditionUpdateArgs = {
  contentType?: InputMaybe<EditionContentType>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  editionTypeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  publicationLink?: InputMaybe<Scalars['String']['input']>;
  userAttachments?: InputMaybe<Edition_UserAttachments_UpdateInput>;
  version_: Scalars['String']['input'];
  worksIds?: InputMaybe<InputMultipleRef>;
};


export type MutationEmailVerificationCreateArgs = {
  email: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEmailVerificationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationEmailVerificationUpdateArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationEsignatureConfigCreateArgs = {
  credentials: Scalars['Json']['input'];
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  provider: EsignatureProvider;
  sandboxMode: Scalars['Boolean']['input'];
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEsignatureConfigUpdateArgs = {
  credentials?: InputMaybe<Scalars['Json']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<EsignatureProvider>;
  sandboxMode?: InputMaybe<Scalars['Boolean']['input']>;
  version_: Scalars['String']['input'];
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEvaluationQueryCreateArgs = {
  acceptableTools: Scalars['Json']['input'];
  ambiguityType?: InputMaybe<EvaluationAmbiguityType>;
  difficulty: EvaluationDifficulty;
  disambiguationResponse?: InputMaybe<Scalars['String']['input']>;
  expectedArgs: Scalars['Json']['input'];
  expectedResponsePattern?: InputMaybe<Scalars['String']['input']>;
  expectedTool: Scalars['String']['input'];
  generatedFrom: Scalars['Json']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  isAmbiguous: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pathType: EvaluationPathType;
  query: Scalars['String']['input'];
};


export type MutationEvaluationQueryDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationEvaluationQueryUpdateArgs = {
  acceptableTools?: InputMaybe<Scalars['Json']['input']>;
  ambiguityType?: InputMaybe<EvaluationAmbiguityType>;
  difficulty?: InputMaybe<EvaluationDifficulty>;
  disambiguationResponse?: InputMaybe<Scalars['String']['input']>;
  expectedArgs?: InputMaybe<Scalars['Json']['input']>;
  expectedResponsePattern?: InputMaybe<Scalars['String']['input']>;
  expectedTool?: InputMaybe<Scalars['String']['input']>;
  generatedFrom?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  isAmbiguous?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pathType?: InputMaybe<EvaluationPathType>;
  query?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationGrossReceiptsStatusCreateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationGrossReceiptsStatusDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationGrossReceiptsStatusUpdateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationInterpreterCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationInterpreterDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationInterpreterUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationLlmProviderCreateArgs = {
  code: Scalars['String']['input'];
  defaultModels: Array<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requiresApiKey: Scalars['Boolean']['input'];
  requiresBaseUrl: Scalars['Boolean']['input'];
};


export type MutationLlmProviderDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationLlmProviderUpdateArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  defaultModels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresApiKey?: InputMaybe<Scalars['Boolean']['input']>;
  requiresBaseUrl?: InputMaybe<Scalars['Boolean']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMusicalGenreCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationMusicalGenreDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationMusicalGenreUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationMusicalWorkCreateArgs = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  authors: Array<WorkAuthor_CreateInput>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  iswc?: InputMaybe<Scalars['String']['input']>;
  musicalGenreId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLyrics?: InputMaybe<Scalars['String']['input']>;
  performersIds?: InputMaybe<Array<Scalars['String']['input']>>;
  phonograms?: InputMaybe<Array<Phonogram_CreateInput>>;
  score?: InputMaybe<UploadedFile>;
  territoriesIds: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationMusicalWorkDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationMusicalWorkUpdateArgs = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  authors?: InputMaybe<MusicalWork_Authors_UpdateInput>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  iswc?: InputMaybe<Scalars['String']['input']>;
  musicalGenreId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalLyrics?: InputMaybe<Scalars['String']['input']>;
  performersIds?: InputMaybe<InputMultipleRef>;
  phonograms?: InputMaybe<MusicalWork_Phonograms_UpdateInput>;
  score?: InputMaybe<UploadedFile>;
  territoriesIds?: InputMaybe<InputMultipleRef>;
  title?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationPaymentReceiptBatchCreateArgs = {
  amount: Scalars['Decimal']['input'];
  files: Array<UploadedFile>;
  issueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  typeId: Scalars['String']['input'];
};


export type MutationPaymentReceiptCreateArgs = {
  amount: Scalars['Decimal']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  issueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  paymentReceipt: UploadedFile;
  typeId: Scalars['String']['input'];
};


export type MutationPaymentReceiptDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationPaymentReceiptTypeCreateArgs = {
  currencyId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
};


export type MutationPaymentReceiptTypeDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationPaymentReceiptTypeUpdateArgs = {
  currencyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationPaymentReceiptUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  issueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  paymentReceipt?: InputMaybe<UploadedFile>;
  version_: Scalars['String']['input'];
};


export type MutationPermissionCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationPermissionDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationPermissionUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationPlatformCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationPlatformDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationPlatformLinkTypeCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationPlatformLinkTypeDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationPlatformLinkTypeUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationPlatformUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationPreviewThemeArgs = {
  authoring: Scalars['Json']['input'];
};


export type MutationProvinceStateCreateArgs = {
  countryId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationProvinceStateDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationProvinceStateUpdateArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationPublisherCreateArgs = {
  caeIpi: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  managementSocieties?: InputMaybe<Array<PublisherCollectingSociety_CreateInput>>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  name: Scalars['String']['input'];
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  personType: PersonType;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['String']['input'];
  pseudonym?: InputMaybe<Scalars['String']['input']>;
  representatives: Array<PublisherRepresentative_CreateInput>;
  streetAndNumber: Scalars['String']['input'];
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId: Scalars['String']['input'];
};


export type MutationPublisherDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationPublisherUpdateArgs = {
  caeIpi?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  managementSocieties?: InputMaybe<Publisher_ManagementSocieties_UpdateInput>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<PersonType>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  pseudonym?: InputMaybe<Scalars['String']['input']>;
  representatives?: InputMaybe<Publisher_Representatives_UpdateInput>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationQueryPatternCreateArgs = {
  argsTemplate: Scalars['Json']['input'];
  exampleInstantiation: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pathType: EvaluationPathType;
  pattern: Scalars['String']['input'];
  qualityScore: Scalars['Int']['input'];
  source: QueryPatternSource;
  toolTemplate: Scalars['String']['input'];
  usageCount: Scalars['Int']['input'];
  variables: Scalars['Json']['input'];
  variations: Scalars['Json']['input'];
};


export type MutationQueryPatternDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationQueryPatternUpdateArgs = {
  argsTemplate?: InputMaybe<Scalars['Json']['input']>;
  exampleInstantiation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pathType?: InputMaybe<EvaluationPathType>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  qualityScore?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<QueryPatternSource>;
  toolTemplate?: InputMaybe<Scalars['String']['input']>;
  usageCount?: InputMaybe<Scalars['Int']['input']>;
  variables?: InputMaybe<Scalars['Json']['input']>;
  variations?: InputMaybe<Scalars['Json']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationReactivateSatelliteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRecheckEditionSignaturesArgs = {
  editionId: Scalars['ID']['input'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationReportCreateArgs = {
  constants?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reportTypeId: Scalars['String']['input'];
  template: Scalars['String']['input'];
};


export type MutationReportDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationReportTypeCreateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationReportTypeDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationReportTypeUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationReportUpdateArgs = {
  constants?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationResendSignatureEmailArgs = {
  editionDocumentationId: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
};


export type MutationRevokeSatelliteArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRevokeTrustedDeviceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRoleCreateArgs = {
  audience: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  isForAllTenants: Scalars['Boolean']['input'];
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  permissionsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRoleDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationRoleUpdateArgs = {
  audience?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  isForAllTenants?: InputMaybe<Scalars['Boolean']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  permissionsIds?: InputMaybe<InputMultipleRef>;
  version_: Scalars['String']['input'];
};


export type MutationRotateSatelliteTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSatelliteHeartbeatDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationSatelliteMachineCreateArgs = {
  allowedTenantIds?: InputMaybe<Scalars['String']['input']>;
  authTokenCreatedAt: Scalars['DateTime']['input'];
  authTokenHash: Scalars['String']['input'];
  authTokenLastFour: Scalars['String']['input'];
  authTokenRotatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedById?: InputMaybe<Scalars['String']['input']>;
  botEnabled: Scalars['Boolean']['input'];
  botMaxConcurrent?: InputMaybe<Scalars['Int']['input']>;
  certificateExpiresAt: Scalars['DateTime']['input'];
  certificateFingerprint: Scalars['String']['input'];
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  disconnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  lastHeartbeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastHeartbeatMetrics?: InputMaybe<Scalars['Json']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  machineCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  proxyEnabled: Scalars['Boolean']['input'];
  proxyPort?: InputMaybe<Scalars['Int']['input']>;
  proxyProtocols?: InputMaybe<Scalars['String']['input']>;
  publicIp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  satelliteType: Scalars['String']['input'];
  status: Scalars['String']['input'];
  suspendedAt?: InputMaybe<Scalars['DateTime']['input']>;
  suspendedById?: InputMaybe<Scalars['String']['input']>;
  suspensionReason?: InputMaybe<Scalars['String']['input']>;
  tunnelConnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerEnabled: Scalars['Boolean']['input'];
};


export type MutationSatelliteMachineDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationSatelliteMachineUpdateArgs = {
  allowedTenantIds?: InputMaybe<Scalars['String']['input']>;
  authTokenCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authTokenHash?: InputMaybe<Scalars['String']['input']>;
  authTokenLastFour?: InputMaybe<Scalars['String']['input']>;
  authTokenRotatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedById?: InputMaybe<Scalars['String']['input']>;
  botEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  botMaxConcurrent?: InputMaybe<Scalars['Int']['input']>;
  certificateExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  certificateFingerprint?: InputMaybe<Scalars['String']['input']>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  disconnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  lastHeartbeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastHeartbeatMetrics?: InputMaybe<Scalars['Json']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  machineCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proxyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  proxyPort?: InputMaybe<Scalars['Int']['input']>;
  proxyProtocols?: InputMaybe<Scalars['String']['input']>;
  publicIp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  satelliteType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suspendedAt?: InputMaybe<Scalars['DateTime']['input']>;
  suspendedById?: InputMaybe<Scalars['String']['input']>;
  suspensionReason?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<SatelliteMachine_Tasks_UpdateInput>;
  tunnelConnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version_: Scalars['String']['input'];
  workerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSaveProfileArgs = {
  key: Array<Scalars['String']['input']>;
  value: Scalars['Json']['input'];
};


export type MutationSaveThemeArgs = {
  authoring: Scalars['Json']['input'];
  name: Scalars['String']['input'];
};


export type MutationSetMyLanguageArgs = {
  language: Language;
};


export type MutationSetSatelliteEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetupTwoFaArgs = {
  tempToken: Scalars['String']['input'];
};


export type MutationShowcaseCategoryCreateArgs = {
  code: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationShowcaseCategoryDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationShowcaseCategoryUpdateArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationShowcaseWorkflowStateCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationShowcaseWorkflowStateDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationShowcaseWorkflowStateUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationShowcaseWorkflow_ApproveArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationShowcaseWorkflow_CloseArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationShowcaseWorkflow_FailArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationShowcaseWorkflow_RejectArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationShowcaseWorkflow_ReopenArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationShowcaseWorkflow_RetryArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationShowcaseWorkflow_SubmitArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflowStateCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflowStateDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflowStateUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflow_ReintentarAvanceRegistroArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflow_ReintentarAvanceUploadArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflow_ReintentarGeneracionEjemplarArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflow_ReintentarRegistroDndaArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationSignedEditionDndaWorkflow_ReintentarUploadEjemplarArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationSignedEditionSadaicWorkflowStateCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationSignedEditionSadaicWorkflowStateDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationSignedEditionSadaicWorkflowStateUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationSignedEditionSadaicWorkflow_ReintentarSubidaSadaicArgs = {
  instanceEntity: Scalars['String']['input'];
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
};


export type MutationSimulationControlArgs = {
  action: Scalars['String']['input'];
  faultType?: InputMaybe<Scalars['String']['input']>;
  gate?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type MutationSimulationResetArgs = {
  relatedEntityId: Scalars['ID']['input'];
  relatedEntityType: Scalars['String']['input'];
};


export type MutationSimulationSessionDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationSimulationStartArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
  mode: Scalars['String']['input'];
  relatedEntityId: Scalars['ID']['input'];
  relatedEntityType: Scalars['String']['input'];
  scenario?: InputMaybe<Scalars['Json']['input']>;
};


export type MutationSingleUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationSiteUserCreateArgs = {
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<UploadedFile>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  language: Language;
  name: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSiteUserDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationSiteUserUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<UploadedFile>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  language?: InputMaybe<Language>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationSnapshotOverrideCreateArgs = {
  active: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  path: Scalars['String']['input'];
  relatedEntityId: Scalars['String']['input'];
  relatedEntityType: Scalars['String']['input'];
  value: Scalars['Json']['input'];
};


export type MutationSnapshotOverrideDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationSnapshotOverrideUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  relatedEntityId?: InputMaybe<Scalars['String']['input']>;
  relatedEntityType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Json']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationSuspendSatelliteArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationTadManagerConfigUpdateArgs = {
  ansesPassword?: InputMaybe<Scalars['String']['input']>;
  arcaPassword?: InputMaybe<Scalars['String']['input']>;
  authProvider?: InputMaybe<TadAuthProvider>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  miArgentinaPassword?: InputMaybe<Scalars['String']['input']>;
  procedureNumber?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationTenantCreateArgs = {
  currentMonthTokens: Scalars['Int']['input'];
  currentStorageBytes: Scalars['Int']['input'];
  eSignatureProvider?: InputMaybe<EsignatureProvider>;
  idCRM?: InputMaybe<Scalars['String']['input']>;
  idERP?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  lastTokenResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  logo?: InputMaybe<UploadedFile>;
  monthlyTokenLimit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['String']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  ragLlmModel?: InputMaybe<Scalars['String']['input']>;
  ragLlmProviderId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  storageByteLimit?: InputMaybe<Scalars['Int']['input']>;
  tenantTypeId?: InputMaybe<Scalars['String']['input']>;
  tokenLimitResetDay: Scalars['Int']['input'];
};


export type MutationTenantDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTenantDocumentCreateArgs = {
  chunkingMaxTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingOverlapTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingSeparatorRegex?: InputMaybe<Scalars['String']['input']>;
  chunkingStrategy: ChunkingStrategy;
  contentType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file: UploadedFile;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  processingError?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTenantDocumentDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTenantDocumentUpdateArgs = {
  chunkingMaxTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingOverlapTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingSeparatorRegex?: InputMaybe<Scalars['String']['input']>;
  chunkingStrategy?: InputMaybe<ChunkingStrategy>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<UploadedFile>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processingError?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationTenantLlmConfigCreateArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  debugFullMode: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  providerId: Scalars['String']['input'];
  temperature?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationTenantLlmConfigDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTenantLlmConfigUpdateArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  debugFullMode?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Decimal']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationTenantPlanCreateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<Scalars['Json']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationTenantPlanDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTenantPlanUpdateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<Scalars['Json']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationTenantProfileCreateArgs = {
  billingCurrencyId?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsId?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsStatusId?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  legalEmail?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownPublisherId?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<PersonType>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  printerCity?: InputMaybe<Scalars['String']['input']>;
  printerCountryId?: InputMaybe<Scalars['String']['input']>;
  printerFloor?: InputMaybe<Scalars['String']['input']>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  printerPostalCode?: InputMaybe<Scalars['String']['input']>;
  printerProvinceId?: InputMaybe<Scalars['String']['input']>;
  printerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  printerSuite?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  sadaicEmail?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpPassword?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUrl?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUser?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatStatusId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTenantProfileDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTenantProfileUpdateArgs = {
  billingCurrencyId?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsId?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsStatusId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  legalEmail?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownPublisherId?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<PersonType>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  printerCity?: InputMaybe<Scalars['String']['input']>;
  printerCountryId?: InputMaybe<Scalars['String']['input']>;
  printerFloor?: InputMaybe<Scalars['String']['input']>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  printerPostalCode?: InputMaybe<Scalars['String']['input']>;
  printerProvinceId?: InputMaybe<Scalars['String']['input']>;
  printerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  printerSuite?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  sadaicEmail?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpPassword?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUrl?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUser?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatStatusId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationTenantStatusCreateArgs = {
  blocksAccess: Scalars['Boolean']['input'];
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationTenantStatusDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTenantStatusUpdateArgs = {
  blocksAccess?: InputMaybe<Scalars['Boolean']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationTenantTypeCreateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationTenantTypeDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTenantTypeUpdateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationTenantUpdateArgs = {
  currentMonthTokens?: InputMaybe<Scalars['Int']['input']>;
  currentStorageBytes?: InputMaybe<Scalars['Int']['input']>;
  eSignatureProvider?: InputMaybe<EsignatureProvider>;
  id: Scalars['String']['input'];
  idCRM?: InputMaybe<Scalars['String']['input']>;
  idERP?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  lastTokenResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  logo?: InputMaybe<UploadedFile>;
  monthlyTokenLimit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  ragLlmModel?: InputMaybe<Scalars['String']['input']>;
  ragLlmProviderId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  storageByteLimit?: InputMaybe<Scalars['Int']['input']>;
  tenantTypeId?: InputMaybe<Scalars['String']['input']>;
  tokenLimitResetDay?: InputMaybe<Scalars['Int']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationTenantWidgetAccessCreateArgs = {
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};


export type MutationTenantWidgetAccessDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTenantWidgetAccessUpdateArgs = {
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTerritoryCreateArgs = {
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationTerritoryDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationTerritoryUpdateArgs = {
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationUpdateMyAvatarArgs = {
  avatar?: InputMaybe<UploadedFile>;
};


export type MutationUserChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUserCreateArgs = {
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<UploadedFile>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  language: Language;
  name: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  targetTenantId?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUserDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationUserNotificationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationUserNotificationPreferenceCreateArgs = {
  emailEnabled: Scalars['Boolean']['input'];
  emailFrequency: EmailFrequency;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  inAppEnabled: Scalars['Boolean']['input'];
  notificationType: NotificationType;
};


export type MutationUserNotificationPreferenceDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationUserNotificationPreferenceUpdateArgs = {
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailFrequency?: InputMaybe<EmailFrequency>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  inAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationType?: InputMaybe<NotificationType>;
  version_: Scalars['String']['input'];
};


export type MutationUserResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationUserUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<UploadedFile>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationUserWidgetConfigCreateArgs = {
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Json']['input'];
  userId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};


export type MutationUserWidgetConfigDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationUserWidgetConfigUpdateArgs = {
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Json']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVatStatusCreateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};


export type MutationVatStatusDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationVatStatusUpdateArgs = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};


export type MutationVerifyTwoFaArgs = {
  code: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
  tempToken: Scalars['String']['input'];
};


export type MutationVerifyTwoFaBackupCodeArgs = {
  code: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
  tempToken: Scalars['String']['input'];
};


export type MutationWorkerEventDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationWorkerEventRetryArgs = {
  id: Scalars['ID']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
};

export type MyCreditPurchases = {
  __typename?: 'MyCreditPurchases';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  notes?: Maybe<Scalars['String']['output']>;
  purchaseDate: Scalars['Date']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  version_: Scalars['String']['output'];
};

export type NotificationActorUser = {
  __typename?: 'NotificationActorUser';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** Whether there are more notifications available */
  hasMore: Scalars['Boolean']['output'];
  /** List of notifications */
  notifications: Array<UserNotificationItem>;
  /** Total count of notifications matching the filter */
  totalCount: Scalars['Int']['output'];
};

export enum NotificationPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum NotificationType {
  Alert = 'alert',
  Assignment = 'assignment',
  Comment = 'comment',
  CreditsInsufficient = 'credits_insufficient',
  Mention = 'mention',
  System = 'system',
  TokenLimitReached = 'token_limit_reached'
}

export enum NotificationTypeFilter {
  Alert = 'alert',
  Assignment = 'assignment',
  Comment = 'comment',
  Mention = 'mention',
  System = 'system',
  TokenLimitReached = 'token_limit_reached'
}

export type OrderByMultiple = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentReceipt = {
  __typename?: 'PaymentReceipt';
  amount: Scalars['Decimal']['output'];
  crc: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issueDateTime?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  paymentReceipt: Scalars['String']['output'];
  paymentReceipt_data: FileData;
  remainingUses: Scalars['Int']['output'];
  signedEdition?: Maybe<SignedEdition>;
  status: PaymentReceiptStatus;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  totalUses: Scalars['Int']['output'];
  type: PaymentReceiptType;
  usedDate?: Maybe<Scalars['DateTime']['output']>;
  uses?: Maybe<Array<PaymentReceiptUse>>;
  version_: Scalars['String']['output'];
};

export type PaymentReceiptBatchCreateResult = {
  __typename?: 'PaymentReceiptBatchCreateResult';
  created: Scalars['Int']['output'];
  results: Array<PaymentReceipt>;
};

export enum PaymentReceiptStatus {
  Available = 'available',
  Used = 'used'
}

export type PaymentReceiptType = {
  __typename?: 'PaymentReceiptType';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  currency: Currency;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  version_: Scalars['String']['output'];
};

export type PaymentReceiptType_CreateInput = {
  currencyId: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
};

export type PaymentReceiptType_Filter = {
  AND?: InputMaybe<Array<PaymentReceiptType_Filter>>;
  NOT?: InputMaybe<Array<PaymentReceiptType_Filter>>;
  OR?: InputMaybe<Array<PaymentReceiptType_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  currency?: InputMaybe<Currency_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  price?: InputMaybe<FilterDecimal>;
  version_?: InputMaybe<FilterString>;
};

export type PaymentReceiptType_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  currency?: InputMaybe<Currency_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type PaymentReceiptType_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type PaymentReceiptType_UpdateInput = {
  currencyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  version_: Scalars['String']['input'];
};

export type PaymentReceiptUse = {
  __typename?: 'PaymentReceiptUse';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  detail: Scalars['String']['output'];
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_PaymentReceipt_uses: PaymentReceipt;
  signedEdition?: Maybe<SignedEdition>;
  usedAt: Scalars['DateTime']['output'];
  version_: Scalars['String']['output'];
};

export type PaymentReceiptUse_Filter = {
  AND?: InputMaybe<Array<PaymentReceiptUse_Filter>>;
  NOT?: InputMaybe<Array<PaymentReceiptUse_Filter>>;
  OR?: InputMaybe<Array<PaymentReceiptUse_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  detail?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_PaymentReceipt_uses?: InputMaybe<PaymentReceipt_Filter>;
  signedEdition?: InputMaybe<SignedEdition_Filter>;
  usedAt?: InputMaybe<FilterDateTime>;
  version_?: InputMaybe<FilterString>;
};

export type PaymentReceiptUse_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  detail?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  signedEdition?: InputMaybe<SignedEdition_OrderBy>;
  usedAt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type PaymentReceiptUse_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type PaymentReceipt_CreateInput = {
  amount: Scalars['Decimal']['input'];
  issueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  paymentReceipt: UploadedFile;
  typeId: Scalars['String']['input'];
};

export type PaymentReceipt_Filter = {
  AND?: InputMaybe<Array<PaymentReceipt_Filter>>;
  NOT?: InputMaybe<Array<PaymentReceipt_Filter>>;
  OR?: InputMaybe<Array<PaymentReceipt_Filter>>;
  amount?: InputMaybe<FilterDecimal>;
  crc?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  issueDateTime?: InputMaybe<FilterDateTime>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  paymentReceipt?: InputMaybe<FilterString>;
  remainingUses?: InputMaybe<FilterInt>;
  signedEdition?: InputMaybe<SignedEdition_Filter>;
  status?: InputMaybe<FilterString>;
  totalUses?: InputMaybe<FilterInt>;
  type?: InputMaybe<PaymentReceiptType_Filter>;
  usedDate?: InputMaybe<FilterDateTime>;
  uses?: InputMaybe<PaymentReceipt_Uses_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type PaymentReceipt_OrderBy = {
  amount?: InputMaybe<SortOrder>;
  crc?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  issueDateTime?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  paymentReceipt?: InputMaybe<SortOrder>;
  remainingUses?: InputMaybe<SortOrder>;
  signedEdition?: InputMaybe<SignedEdition_OrderBy>;
  status?: InputMaybe<SortOrder>;
  totalUses?: InputMaybe<SortOrder>;
  type?: InputMaybe<PaymentReceiptType_OrderBy>;
  usedDate?: InputMaybe<SortOrder>;
  uses?: InputMaybe<OrderByMultiple>;
  version_?: InputMaybe<SortOrder>;
};

export type PaymentReceipt_OrderByCursor = {
  crc?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type PaymentReceipt_UpdateInput = {
  id: Scalars['String']['input'];
  issueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  paymentReceipt?: InputMaybe<UploadedFile>;
  version_: Scalars['String']['input'];
};

export type PaymentReceipt_Uses_Filter = {
  every?: InputMaybe<PaymentReceiptUse_Filter>;
  none?: InputMaybe<PaymentReceiptUse_Filter>;
  some?: InputMaybe<PaymentReceiptUse_Filter>;
};

export type Permission = {
  __typename?: 'Permission';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type Permission_CreateInput = {
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type Permission_Filter = {
  AND?: InputMaybe<Array<Permission_Filter>>;
  NOT?: InputMaybe<Array<Permission_Filter>>;
  OR?: InputMaybe<Array<Permission_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Permission_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Permission_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type Permission_UpdateInput = {
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export enum PersonType {
  LegalEntity = 'legalEntity',
  NaturalPerson = 'naturalPerson'
}

export type Phonogram = {
  __typename?: 'Phonogram';
  albumName?: Maybe<Scalars['String']['output']>;
  audioFile: Scalars['String']['output'];
  audioFile_data: FileData;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isrc?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  links?: Maybe<Array<MusicalWorkLink>>;
  mainAudio: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  originalProducer?: Maybe<Scalars['String']['output']>;
  parent_MusicalWork_phonograms: MusicalWork;
  performers?: Maybe<Array<Interpreter>>;
  publicationYear?: Maybe<Scalars['Int']['output']>;
  trackName: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type Phonogram_CreateInput = {
  albumName?: InputMaybe<Scalars['String']['input']>;
  audioFile: UploadedFile;
  isrc?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<MusicalWorkLink_CreateInput>>;
  mainAudio: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originalProducer?: InputMaybe<Scalars['String']['input']>;
  performersIds?: InputMaybe<Array<Scalars['String']['input']>>;
  publicationYear?: InputMaybe<Scalars['Int']['input']>;
  trackName: Scalars['String']['input'];
};

export type Phonogram_Filter = {
  AND?: InputMaybe<Array<Phonogram_Filter>>;
  NOT?: InputMaybe<Array<Phonogram_Filter>>;
  OR?: InputMaybe<Array<Phonogram_Filter>>;
  albumName?: InputMaybe<FilterString>;
  audioFile?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  isrc?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  links?: InputMaybe<Phonogram_Links_Filter>;
  mainAudio?: InputMaybe<FilterBoolean>;
  notes?: InputMaybe<FilterString>;
  originalProducer?: InputMaybe<FilterString>;
  parent_MusicalWork_phonograms?: InputMaybe<MusicalWork_Filter>;
  performers?: InputMaybe<Phonogram_Performers_Filter>;
  publicationYear?: InputMaybe<FilterInt>;
  trackName?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Phonogram_OrderBy = {
  albumName?: InputMaybe<SortOrder>;
  audioFile?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  isrc?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  links?: InputMaybe<OrderByMultiple>;
  mainAudio?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  originalProducer?: InputMaybe<SortOrder>;
  performers?: InputMaybe<OrderByMultiple>;
  publicationYear?: InputMaybe<SortOrder>;
  trackName?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Phonogram_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  isrc?: InputMaybe<SortOrder>;
};

export type Phonogram_UpdateInput = {
  albumName?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<UploadedFile>;
  id: Scalars['String']['input'];
  isrc?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Phonogram_Links_UpdateInput>;
  mainAudio?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  originalProducer?: InputMaybe<Scalars['String']['input']>;
  performersIds?: InputMaybe<InputMultipleRef>;
  publicationYear?: InputMaybe<Scalars['Int']['input']>;
  trackName?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Phonogram_Links_Filter = {
  every?: InputMaybe<MusicalWorkLink_Filter>;
  none?: InputMaybe<MusicalWorkLink_Filter>;
  some?: InputMaybe<MusicalWorkLink_Filter>;
};

export type Phonogram_Links_UpdateInput = {
  create?: InputMaybe<Array<MusicalWorkLink_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<MusicalWorkLink_UpdateInput>>;
};

export type Phonogram_Performers_Filter = {
  every?: InputMaybe<Interpreter_Filter>;
  none?: InputMaybe<Interpreter_Filter>;
  some?: InputMaybe<Interpreter_Filter>;
};

export type Platform = {
  __typename?: 'Platform';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type PlatformLinkType = {
  __typename?: 'PlatformLinkType';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type PlatformLinkType_CreateInput = {
  name: Scalars['String']['input'];
};

export type PlatformLinkType_Filter = {
  AND?: InputMaybe<Array<PlatformLinkType_Filter>>;
  NOT?: InputMaybe<Array<PlatformLinkType_Filter>>;
  OR?: InputMaybe<Array<PlatformLinkType_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type PlatformLinkType_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type PlatformLinkType_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type PlatformLinkType_UpdateInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Platform_CreateInput = {
  name: Scalars['String']['input'];
};

export type Platform_Filter = {
  AND?: InputMaybe<Array<Platform_Filter>>;
  NOT?: InputMaybe<Array<Platform_Filter>>;
  OR?: InputMaybe<Array<Platform_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Platform_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Platform_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type Platform_UpdateInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type ProvinceState = {
  __typename?: 'ProvinceState';
  country: Country;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type ProvinceState_CreateInput = {
  countryId: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type ProvinceState_Filter = {
  AND?: InputMaybe<Array<ProvinceState_Filter>>;
  NOT?: InputMaybe<Array<ProvinceState_Filter>>;
  OR?: InputMaybe<Array<ProvinceState_Filter>>;
  country?: InputMaybe<Country_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type ProvinceState_OrderBy = {
  country?: InputMaybe<Country_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type ProvinceState_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type ProvinceState_UpdateInput = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Publisher = {
  __typename?: 'Publisher';
  caeIpi: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Country;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  managementSocieties?: Maybe<Array<PublisherCollectingSociety>>;
  maritalStatus?: Maybe<MaritalStatus>;
  name: Scalars['String']['output'];
  nationality?: Maybe<Country>;
  personType: PersonType;
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  province: ProvinceState;
  pseudonym?: Maybe<Scalars['String']['output']>;
  representatives: Array<PublisherRepresentative>;
  streetAndNumber: Scalars['String']['output'];
  suite?: Maybe<Scalars['String']['output']>;
  taxId: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type PublisherCollectingSociety = {
  __typename?: 'PublisherCollectingSociety';
  cmsAccountNumber: Scalars['String']['output'];
  collectingSociety: CollectiveManagementSociety;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_Publisher_managementSocieties: Publisher;
  version_: Scalars['String']['output'];
};

export type PublisherCollectingSociety_CreateInput = {
  cmsAccountNumber: Scalars['String']['input'];
  collectingSocietyId: Scalars['String']['input'];
};

export type PublisherCollectingSociety_Filter = {
  AND?: InputMaybe<Array<PublisherCollectingSociety_Filter>>;
  NOT?: InputMaybe<Array<PublisherCollectingSociety_Filter>>;
  OR?: InputMaybe<Array<PublisherCollectingSociety_Filter>>;
  cmsAccountNumber?: InputMaybe<FilterString>;
  collectingSociety?: InputMaybe<CollectiveManagementSociety_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_Publisher_managementSocieties?: InputMaybe<Publisher_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type PublisherCollectingSociety_OrderBy = {
  cmsAccountNumber?: InputMaybe<SortOrder>;
  collectingSociety?: InputMaybe<CollectiveManagementSociety_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type PublisherCollectingSociety_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type PublisherCollectingSociety_UpdateInput = {
  cmsAccountNumber?: InputMaybe<Scalars['String']['input']>;
  collectingSocietyId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
};

export type PublisherRepresentative = {
  __typename?: 'PublisherRepresentative';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSigner?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  parent_Publisher_representatives: Publisher;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
};

export type PublisherRepresentative_CreateInput = {
  email: Scalars['String']['input'];
  isSigner?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type PublisherRepresentative_Filter = {
  AND?: InputMaybe<Array<PublisherRepresentative_Filter>>;
  NOT?: InputMaybe<Array<PublisherRepresentative_Filter>>;
  OR?: InputMaybe<Array<PublisherRepresentative_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  email?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  isSigner?: InputMaybe<FilterBoolean>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  parent_Publisher_representatives?: InputMaybe<Publisher_Filter>;
  phone?: InputMaybe<FilterString>;
  role?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type PublisherRepresentative_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSigner?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type PublisherRepresentative_OrderByCursor = {
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type PublisherRepresentative_UpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isSigner?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Publisher_CreateInput = {
  caeIpi: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  managementSocieties?: InputMaybe<Array<PublisherCollectingSociety_CreateInput>>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  name: Scalars['String']['input'];
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  personType: PersonType;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  provinceId: Scalars['String']['input'];
  pseudonym?: InputMaybe<Scalars['String']['input']>;
  representatives: Array<PublisherRepresentative_CreateInput>;
  streetAndNumber: Scalars['String']['input'];
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId: Scalars['String']['input'];
};

export type Publisher_Filter = {
  AND?: InputMaybe<Array<Publisher_Filter>>;
  NOT?: InputMaybe<Array<Publisher_Filter>>;
  OR?: InputMaybe<Array<Publisher_Filter>>;
  caeIpi?: InputMaybe<FilterString>;
  city?: InputMaybe<FilterString>;
  country?: InputMaybe<Country_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  email?: InputMaybe<FilterString>;
  floor?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  managementSocieties?: InputMaybe<Publisher_ManagementSocieties_Filter>;
  maritalStatus?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  nationality?: InputMaybe<Country_Filter>;
  personType?: InputMaybe<FilterString>;
  phone?: InputMaybe<FilterString>;
  postalCode?: InputMaybe<FilterString>;
  province?: InputMaybe<ProvinceState_Filter>;
  pseudonym?: InputMaybe<FilterString>;
  representatives?: InputMaybe<Publisher_Representatives_Filter>;
  streetAndNumber?: InputMaybe<FilterString>;
  suite?: InputMaybe<FilterString>;
  taxId?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Publisher_OrderBy = {
  caeIpi?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<Country_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  email?: InputMaybe<SortOrder>;
  floor?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  managementSocieties?: InputMaybe<OrderByMultiple>;
  maritalStatus?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nationality?: InputMaybe<Country_OrderBy>;
  personType?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  province?: InputMaybe<ProvinceState_OrderBy>;
  pseudonym?: InputMaybe<SortOrder>;
  representatives?: InputMaybe<OrderByMultiple>;
  streetAndNumber?: InputMaybe<SortOrder>;
  suite?: InputMaybe<SortOrder>;
  taxId?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Publisher_OrderByCursor = {
  caeIpi?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pseudonym?: InputMaybe<SortOrder>;
};

export type Publisher_UpdateInput = {
  caeIpi?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  managementSocieties?: InputMaybe<Publisher_ManagementSocieties_UpdateInput>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<PersonType>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  pseudonym?: InputMaybe<Scalars['String']['input']>;
  representatives?: InputMaybe<Publisher_Representatives_UpdateInput>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Publisher_ManagementSocieties_Filter = {
  every?: InputMaybe<PublisherCollectingSociety_Filter>;
  none?: InputMaybe<PublisherCollectingSociety_Filter>;
  some?: InputMaybe<PublisherCollectingSociety_Filter>;
};

export type Publisher_ManagementSocieties_UpdateInput = {
  create?: InputMaybe<Array<PublisherCollectingSociety_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<PublisherCollectingSociety_UpdateInput>>;
};

export type Publisher_Representatives_Filter = {
  every?: InputMaybe<PublisherRepresentative_Filter>;
  none?: InputMaybe<PublisherRepresentative_Filter>;
  some?: InputMaybe<PublisherRepresentative_Filter>;
};

export type Publisher_Representatives_UpdateInput = {
  create?: InputMaybe<Array<PublisherRepresentative_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<PublisherRepresentative_UpdateInput>>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  aiSearchAutoEvalListWithCursor: Array<Maybe<AiSearchAutoEval>>;
  aiSearchAutoEvalListWithOffset: Array<Maybe<AiSearchAutoEval>>;
  aiSearchAutoEvalOne: AiSearchAutoEval;
  aiSearchConversationListWithCursor: Array<Maybe<AiSearchConversation>>;
  aiSearchConversationListWithOffset: Array<Maybe<AiSearchConversation>>;
  aiSearchConversationOne: AiSearchConversation;
  aiSearchPatternListWithCursor: Array<Maybe<AiSearchPattern>>;
  aiSearchPatternListWithOffset: Array<Maybe<AiSearchPattern>>;
  aiSearchPatternOne: AiSearchPattern;
  aiSearchResponseListWithCursor: Array<Maybe<AiSearchResponse>>;
  aiSearchResponseListWithOffset: Array<Maybe<AiSearchResponse>>;
  aiSearchResponseOne: AiSearchResponse;
  aiSearchToolCallListWithCursor: Array<Maybe<AiSearchToolCall>>;
  aiSearchToolCallListWithOffset: Array<Maybe<AiSearchToolCall>>;
  aiSearchToolCallOne: AiSearchToolCall;
  alertRuleListWithCursor: Array<Maybe<AlertRule>>;
  alertRuleListWithOffset: Array<Maybe<AlertRule>>;
  alertRuleOne: AlertRule;
  alertSubscriptionListWithCursor: Array<Maybe<AlertSubscription>>;
  alertSubscriptionListWithOffset: Array<Maybe<AlertSubscription>>;
  alertSubscriptionOne: AlertSubscription;
  associatedDocumentEditionListWithCursor: Array<Maybe<AssociatedDocumentEdition>>;
  associatedDocumentEditionListWithOffset: Array<Maybe<AssociatedDocumentEdition>>;
  associatedDocumentEditionOne: AssociatedDocumentEdition;
  associatedDocumentSignedEditionListWithCursor: Array<Maybe<AssociatedDocumentSignedEdition>>;
  associatedDocumentSignedEditionListWithOffset: Array<Maybe<AssociatedDocumentSignedEdition>>;
  associatedDocumentSignedEditionOne: AssociatedDocumentSignedEdition;
  authorCollectingSocietyListWithCursor: Array<Maybe<AuthorCollectingSociety>>;
  authorCollectingSocietyListWithOffset: Array<Maybe<AuthorCollectingSociety>>;
  authorCollectingSocietyOne: AuthorCollectingSociety;
  authorComposerDocumentationIssues: Array<AuthorDocumentationIssues>;
  authorComposerListWithCursor: Array<Maybe<AuthorComposer>>;
  authorComposerListWithOffset: Array<Maybe<AuthorComposer>>;
  authorComposerOne: AuthorComposer;
  authorComposerPublicListWithCursor: Array<Maybe<AuthorComposerPublic>>;
  authorComposerPublicListWithOffset: Array<Maybe<AuthorComposerPublic>>;
  authorComposerPublicOne: AuthorComposerPublic;
  authorPublisherListWithCursor: Array<Maybe<AuthorPublisher>>;
  authorPublisherListWithOffset: Array<Maybe<AuthorPublisher>>;
  authorPublisherOne: AuthorPublisher;
  availableAlertTypes: Array<AlertTypeInfo>;
  botErrorListWithCursor: Array<Maybe<BotError>>;
  botErrorListWithOffset: Array<Maybe<BotError>>;
  botErrorOne: BotError;
  botPhaseListWithCursor: Array<Maybe<BotPhase>>;
  botPhaseListWithOffset: Array<Maybe<BotPhase>>;
  botPhaseOne: BotPhase;
  botRunListWithCursor: Array<Maybe<BotRun>>;
  botRunListWithOffset: Array<Maybe<BotRun>>;
  botRunOne: BotRun;
  botStepListWithCursor: Array<Maybe<BotStep>>;
  botStepListWithOffset: Array<Maybe<BotStep>>;
  botStepOne: BotStep;
  collectiveManagementSocietyListWithCursor: Array<Maybe<CollectiveManagementSociety>>;
  collectiveManagementSocietyListWithOffset: Array<Maybe<CollectiveManagementSociety>>;
  collectiveManagementSocietyOne: CollectiveManagementSociety;
  /** List all connected satellites with their status. */
  connectedSatellites: Array<SatelliteMachine>;
  contractObservationListWithCursor: Array<Maybe<ContractObservation>>;
  contractObservationListWithOffset: Array<Maybe<ContractObservation>>;
  contractObservationOne: ContractObservation;
  countryListWithCursor: Array<Maybe<Country>>;
  countryListWithOffset: Array<Maybe<Country>>;
  countryOne: Country;
  creditAccountListWithCursor: Array<Maybe<CreditAccount>>;
  creditAccountListWithOffset: Array<Maybe<CreditAccount>>;
  creditAccountOne: CreditAccount;
  creditMovementListWithCursor: Array<Maybe<CreditMovement>>;
  creditMovementListWithOffset: Array<Maybe<CreditMovement>>;
  creditMovementOne: CreditMovement;
  creditPurchaseListWithCursor: Array<Maybe<CreditPurchase>>;
  creditPurchaseListWithOffset: Array<Maybe<CreditPurchase>>;
  creditPurchaseOne: CreditPurchase;
  creditTierListWithCursor: Array<Maybe<CreditTier>>;
  creditTierListWithOffset: Array<Maybe<CreditTier>>;
  creditTierOne: CreditTier;
  currencyListWithCursor: Array<Maybe<Currency>>;
  currencyListWithOffset: Array<Maybe<Currency>>;
  currencyOne: Currency;
  dashboardLayoutTemplateListWithCursor: Array<Maybe<DashboardLayoutTemplate>>;
  dashboardLayoutTemplateListWithOffset: Array<Maybe<DashboardLayoutTemplate>>;
  dashboardLayoutTemplateOne: DashboardLayoutTemplate;
  dashboardWidgetListWithCursor: Array<Maybe<DashboardWidget>>;
  dashboardWidgetListWithOffset: Array<Maybe<DashboardWidget>>;
  dashboardWidgetOne: DashboardWidget;
  deletionBlockers: DeletionBlockers;
  designShowcaseListWithCursor: Array<Maybe<DesignShowcase>>;
  designShowcaseListWithOffset: Array<Maybe<DesignShowcase>>;
  designShowcaseOne: DesignShowcase;
  documentGenerationParamsListWithCursor: Array<Maybe<DocumentGenerationParams>>;
  documentGenerationParamsListWithOffset: Array<Maybe<DocumentGenerationParams>>;
  documentGenerationParamsOne: DocumentGenerationParams;
  editionContractPublisherListWithCursor: Array<Maybe<EditionContractPublisher>>;
  editionContractPublisherListWithOffset: Array<Maybe<EditionContractPublisher>>;
  editionContractPublisherOne: EditionContractPublisher;
  editionDocumentTypeListWithCursor: Array<Maybe<EditionDocumentType>>;
  editionDocumentTypeListWithOffset: Array<Maybe<EditionDocumentType>>;
  editionDocumentTypeOne: EditionDocumentType;
  editionDocumentationListWithCursor: Array<Maybe<EditionDocumentation>>;
  editionDocumentationListWithOffset: Array<Maybe<EditionDocumentation>>;
  editionDocumentationOne: EditionDocumentation;
  editionDocumentationWorkflowStateListWithCursor: Array<Maybe<EditionDocumentationWorkflowState>>;
  editionDocumentationWorkflowStateListWithOffset: Array<Maybe<EditionDocumentationWorkflowState>>;
  editionDocumentationWorkflowStateOne: EditionDocumentationWorkflowState;
  editionListWithCursor: Array<Maybe<Edition>>;
  editionListWithOffset: Array<Maybe<Edition>>;
  editionOne: Edition;
  editionSignatureStatus: Array<ContractSignatureStatus>;
  editionTypeListWithCursor: Array<Maybe<EditionType>>;
  editionTypeListWithOffset: Array<Maybe<EditionType>>;
  editionTypeOne: EditionType;
  editionsPendingSignatureCompletion: Array<EditionPendingCompletion>;
  emailVerificationListWithCursor: Array<Maybe<EmailVerification>>;
  emailVerificationListWithOffset: Array<Maybe<EmailVerification>>;
  emailVerificationOne: EmailVerification;
  esignatureConfigListWithCursor: Array<Maybe<EsignatureConfig>>;
  esignatureConfigListWithOffset: Array<Maybe<EsignatureConfig>>;
  esignatureConfigOne: EsignatureConfig;
  esignatureDocumentListWithCursor: Array<Maybe<EsignatureDocument>>;
  esignatureDocumentListWithOffset: Array<Maybe<EsignatureDocument>>;
  esignatureDocumentOne: EsignatureDocument;
  esignatureRecipientListWithCursor: Array<Maybe<EsignatureRecipient>>;
  esignatureRecipientListWithOffset: Array<Maybe<EsignatureRecipient>>;
  esignatureRecipientOne: EsignatureRecipient;
  esignatureWebhookEventListWithCursor: Array<Maybe<EsignatureWebhookEvent>>;
  esignatureWebhookEventListWithOffset: Array<Maybe<EsignatureWebhookEvent>>;
  esignatureWebhookEventOne: EsignatureWebhookEvent;
  evaluationQueryListWithCursor: Array<Maybe<EvaluationQuery>>;
  evaluationQueryListWithOffset: Array<Maybe<EvaluationQuery>>;
  evaluationQueryOne: EvaluationQuery;
  grossReceiptsStatusListWithCursor: Array<Maybe<GrossReceiptsStatus>>;
  grossReceiptsStatusListWithOffset: Array<Maybe<GrossReceiptsStatus>>;
  grossReceiptsStatusOne: GrossReceiptsStatus;
  interpreterListWithCursor: Array<Maybe<Interpreter>>;
  interpreterListWithOffset: Array<Maybe<Interpreter>>;
  interpreterOne: Interpreter;
  listThemes: Array<Theme>;
  llmProviderListWithCursor: Array<Maybe<LlmProvider>>;
  llmProviderListWithOffset: Array<Maybe<LlmProvider>>;
  llmProviderOne: LlmProvider;
  me: User;
  musicalGenreListWithCursor: Array<Maybe<MusicalGenre>>;
  musicalGenreListWithOffset: Array<Maybe<MusicalGenre>>;
  musicalGenreOne: MusicalGenre;
  musicalWorkLinkListWithCursor: Array<Maybe<MusicalWorkLink>>;
  musicalWorkLinkListWithOffset: Array<Maybe<MusicalWorkLink>>;
  musicalWorkLinkOne: MusicalWorkLink;
  musicalWorkListWithCursor: Array<Maybe<MusicalWork>>;
  musicalWorkListWithOffset: Array<Maybe<MusicalWork>>;
  musicalWorkOne: MusicalWork;
  myCreditPurchasesListWithCursor: Array<Maybe<MyCreditPurchases>>;
  myCreditPurchasesListWithOffset: Array<Maybe<MyCreditPurchases>>;
  myCreditPurchasesOne: MyCreditPurchases;
  /** Get current user's notifications with optional filters */
  myNotifications: NotificationConnection;
  mySessions: Array<SessionInfo>;
  myTrustedDevices: Array<TrustedDeviceInfo>;
  paymentReceiptListWithCursor: Array<Maybe<PaymentReceipt>>;
  paymentReceiptListWithOffset: Array<Maybe<PaymentReceipt>>;
  paymentReceiptOne: PaymentReceipt;
  paymentReceiptTypeListWithCursor: Array<Maybe<PaymentReceiptType>>;
  paymentReceiptTypeListWithOffset: Array<Maybe<PaymentReceiptType>>;
  paymentReceiptTypeOne: PaymentReceiptType;
  paymentReceiptUseListWithCursor: Array<Maybe<PaymentReceiptUse>>;
  paymentReceiptUseListWithOffset: Array<Maybe<PaymentReceiptUse>>;
  paymentReceiptUseOne: PaymentReceiptUse;
  permissionListWithCursor: Array<Maybe<Permission>>;
  permissionListWithOffset: Array<Maybe<Permission>>;
  permissionOne: Permission;
  phonogramListWithCursor: Array<Maybe<Phonogram>>;
  phonogramListWithOffset: Array<Maybe<Phonogram>>;
  phonogramOne: Phonogram;
  platformLinkTypeListWithCursor: Array<Maybe<PlatformLinkType>>;
  platformLinkTypeListWithOffset: Array<Maybe<PlatformLinkType>>;
  platformLinkTypeOne: PlatformLinkType;
  platformListWithCursor: Array<Maybe<Platform>>;
  platformListWithOffset: Array<Maybe<Platform>>;
  platformOne: Platform;
  provinceStateListWithCursor: Array<Maybe<ProvinceState>>;
  provinceStateListWithOffset: Array<Maybe<ProvinceState>>;
  provinceStateOne: ProvinceState;
  publisherCollectingSocietyListWithCursor: Array<Maybe<PublisherCollectingSociety>>;
  publisherCollectingSocietyListWithOffset: Array<Maybe<PublisherCollectingSociety>>;
  publisherCollectingSocietyOne: PublisherCollectingSociety;
  publisherListWithCursor: Array<Maybe<Publisher>>;
  publisherListWithOffset: Array<Maybe<Publisher>>;
  publisherOne: Publisher;
  publisherRepresentativeListWithCursor: Array<Maybe<PublisherRepresentative>>;
  publisherRepresentativeListWithOffset: Array<Maybe<PublisherRepresentative>>;
  publisherRepresentativeOne: PublisherRepresentative;
  queryPatternListWithCursor: Array<Maybe<QueryPattern>>;
  queryPatternListWithOffset: Array<Maybe<QueryPattern>>;
  queryPatternOne: QueryPattern;
  reportListWithCursor: Array<Maybe<Report>>;
  reportListWithOffset: Array<Maybe<Report>>;
  reportOne: Report;
  reportTypeListWithCursor: Array<Maybe<ReportType>>;
  reportTypeListWithOffset: Array<Maybe<ReportType>>;
  reportTypeOne: ReportType;
  roleListWithCursor: Array<Maybe<Role>>;
  roleListWithOffset: Array<Maybe<Role>>;
  roleOne: Role;
  /** Get connection info for a satellite. */
  satelliteConnectionInfo?: Maybe<SatelliteConnectionInfo>;
  satelliteHeartbeatListWithCursor: Array<Maybe<SatelliteHeartbeat>>;
  satelliteHeartbeatListWithOffset: Array<Maybe<SatelliteHeartbeat>>;
  satelliteHeartbeatOne: SatelliteHeartbeat;
  satelliteMachineListWithCursor: Array<Maybe<SatelliteMachine>>;
  satelliteMachineListWithOffset: Array<Maybe<SatelliteMachine>>;
  satelliteMachineOne: SatelliteMachine;
  satelliteTaskListWithCursor: Array<Maybe<SatelliteTask>>;
  satelliteTaskListWithOffset: Array<Maybe<SatelliteTask>>;
  satelliteTaskOne: SatelliteTask;
  showcaseCategoryListWithCursor: Array<Maybe<ShowcaseCategory>>;
  showcaseCategoryListWithOffset: Array<Maybe<ShowcaseCategory>>;
  showcaseCategoryOne: ShowcaseCategory;
  showcaseLineListWithCursor: Array<Maybe<ShowcaseLine>>;
  showcaseLineListWithOffset: Array<Maybe<ShowcaseLine>>;
  showcaseLineOne: ShowcaseLine;
  showcaseWorkflowStateListWithCursor: Array<Maybe<ShowcaseWorkflowState>>;
  showcaseWorkflowStateListWithOffset: Array<Maybe<ShowcaseWorkflowState>>;
  showcaseWorkflowStateOne: ShowcaseWorkflowState;
  signedContractListWithCursor: Array<Maybe<SignedContract>>;
  signedContractListWithOffset: Array<Maybe<SignedContract>>;
  signedContractOne: SignedContract;
  signedEditionBlockchainCertListWithCursor: Array<Maybe<SignedEditionBlockchainCert>>;
  signedEditionBlockchainCertListWithOffset: Array<Maybe<SignedEditionBlockchainCert>>;
  signedEditionBlockchainCertOne: SignedEditionBlockchainCert;
  signedEditionDndaWorkflowStateListWithCursor: Array<Maybe<SignedEditionDndaWorkflowState>>;
  signedEditionDndaWorkflowStateListWithOffset: Array<Maybe<SignedEditionDndaWorkflowState>>;
  signedEditionDndaWorkflowStateOne: SignedEditionDndaWorkflowState;
  signedEditionListWithCursor: Array<Maybe<SignedEdition>>;
  signedEditionListWithOffset: Array<Maybe<SignedEdition>>;
  signedEditionOne: SignedEdition;
  signedEditionSadaicWorkflowStateListWithCursor: Array<Maybe<SignedEditionSadaicWorkflowState>>;
  signedEditionSadaicWorkflowStateListWithOffset: Array<Maybe<SignedEditionSadaicWorkflowState>>;
  signedEditionSadaicWorkflowStateOne: SignedEditionSadaicWorkflowState;
  simulationSessionListWithCursor: Array<Maybe<SimulationSession>>;
  simulationSessionListWithOffset: Array<Maybe<SimulationSession>>;
  simulationSessionOne: SimulationSession;
  siteUserListWithCursor: Array<Maybe<SiteUser>>;
  siteUserListWithOffset: Array<Maybe<SiteUser>>;
  siteUserOne: SiteUser;
  snapshotOverrideListWithCursor: Array<Maybe<SnapshotOverride>>;
  snapshotOverrideListWithOffset: Array<Maybe<SnapshotOverride>>;
  snapshotOverrideOne: SnapshotOverride;
  tadManagerConfigListWithCursor: Array<Maybe<TadManagerConfig>>;
  tadManagerConfigListWithOffset: Array<Maybe<TadManagerConfig>>;
  tadManagerConfigOne: TadManagerConfig;
  tenantDocumentListWithCursor: Array<Maybe<TenantDocument>>;
  tenantDocumentListWithOffset: Array<Maybe<TenantDocument>>;
  tenantDocumentOne: TenantDocument;
  tenantListWithCursor: Array<Maybe<Tenant>>;
  tenantListWithOffset: Array<Maybe<Tenant>>;
  tenantLlmConfigListWithCursor: Array<Maybe<TenantLlmConfig>>;
  tenantLlmConfigListWithOffset: Array<Maybe<TenantLlmConfig>>;
  tenantLlmConfigOne: TenantLlmConfig;
  tenantOne: Tenant;
  tenantPlanListWithCursor: Array<Maybe<TenantPlan>>;
  tenantPlanListWithOffset: Array<Maybe<TenantPlan>>;
  tenantPlanOne: TenantPlan;
  tenantProfileListWithCursor: Array<Maybe<TenantProfile>>;
  tenantProfileListWithOffset: Array<Maybe<TenantProfile>>;
  tenantProfileOne: TenantProfile;
  tenantStatusListWithCursor: Array<Maybe<TenantStatus>>;
  tenantStatusListWithOffset: Array<Maybe<TenantStatus>>;
  tenantStatusOne: TenantStatus;
  tenantStorageUsageListWithCursor: Array<Maybe<TenantStorageUsage>>;
  tenantStorageUsageListWithOffset: Array<Maybe<TenantStorageUsage>>;
  tenantStorageUsageOne: TenantStorageUsage;
  tenantTokenUsageListWithCursor: Array<Maybe<TenantTokenUsage>>;
  tenantTokenUsageListWithOffset: Array<Maybe<TenantTokenUsage>>;
  tenantTokenUsageOne: TenantTokenUsage;
  tenantTypeListWithCursor: Array<Maybe<TenantType>>;
  tenantTypeListWithOffset: Array<Maybe<TenantType>>;
  tenantTypeOne: TenantType;
  tenantWidgetAccessListWithCursor: Array<Maybe<TenantWidgetAccess>>;
  tenantWidgetAccessListWithOffset: Array<Maybe<TenantWidgetAccess>>;
  tenantWidgetAccessOne: TenantWidgetAccess;
  territoryListWithCursor: Array<Maybe<Territory>>;
  territoryListWithOffset: Array<Maybe<Territory>>;
  territoryOne: Territory;
  themeListWithCursor: Array<Maybe<Theme>>;
  themeListWithOffset: Array<Maybe<Theme>>;
  themeOne: Theme;
  /** Get count of unread notifications for current user */
  unreadNotificationCount: Scalars['Int']['output'];
  userAttachmentEditionListWithCursor: Array<Maybe<UserAttachmentEdition>>;
  userAttachmentEditionListWithOffset: Array<Maybe<UserAttachmentEdition>>;
  userAttachmentEditionOne: UserAttachmentEdition;
  userListWithCursor: Array<Maybe<User>>;
  userListWithOffset: Array<Maybe<User>>;
  userNotificationListWithCursor: Array<Maybe<UserNotification>>;
  userNotificationListWithOffset: Array<Maybe<UserNotification>>;
  userNotificationOne: UserNotification;
  userNotificationPreferenceListWithCursor: Array<Maybe<UserNotificationPreference>>;
  userNotificationPreferenceListWithOffset: Array<Maybe<UserNotificationPreference>>;
  userNotificationPreferenceOne: UserNotificationPreference;
  userOne: User;
  userWidgetConfigListWithCursor: Array<Maybe<UserWidgetConfig>>;
  userWidgetConfigListWithOffset: Array<Maybe<UserWidgetConfig>>;
  userWidgetConfigOne: UserWidgetConfig;
  vatStatusListWithCursor: Array<Maybe<VatStatus>>;
  vatStatusListWithOffset: Array<Maybe<VatStatus>>;
  vatStatusOne: VatStatus;
  workAuthorListWithCursor: Array<Maybe<WorkAuthor>>;
  workAuthorListWithOffset: Array<Maybe<WorkAuthor>>;
  workAuthorOne: WorkAuthor;
  workAuthorPublisherListWithCursor: Array<Maybe<WorkAuthorPublisher>>;
  workAuthorPublisherListWithOffset: Array<Maybe<WorkAuthorPublisher>>;
  workAuthorPublisherOne: WorkAuthorPublisher;
  workerEventListWithCursor: Array<Maybe<WorkerEvent>>;
  workerEventListWithOffset: Array<Maybe<WorkerEvent>>;
  workerEventOne: WorkerEvent;
  workerEventRetryInfo: WorkerEventRetryInfo;
};


export type QueryAiSearchAutoEvalListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AiSearchAutoEval_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchAutoEval_Filter>;
};


export type QueryAiSearchAutoEvalListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AiSearchAutoEval_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchAutoEval_Filter>;
};


export type QueryAiSearchAutoEvalOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAiSearchConversationListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AiSearchConversation_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchConversation_Filter>;
};


export type QueryAiSearchConversationListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AiSearchConversation_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchConversation_Filter>;
};


export type QueryAiSearchConversationOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAiSearchPatternListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AiSearchPattern_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchPattern_Filter>;
};


export type QueryAiSearchPatternListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AiSearchPattern_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchPattern_Filter>;
};


export type QueryAiSearchPatternOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAiSearchResponseListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AiSearchResponse_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchResponse_Filter>;
};


export type QueryAiSearchResponseListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AiSearchResponse_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchResponse_Filter>;
};


export type QueryAiSearchResponseOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAiSearchToolCallListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AiSearchToolCall_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchToolCall_Filter>;
};


export type QueryAiSearchToolCallListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AiSearchToolCall_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AiSearchToolCall_Filter>;
};


export type QueryAiSearchToolCallOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAlertRuleListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AlertRule_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AlertRule_Filter>;
};


export type QueryAlertRuleListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AlertRule_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AlertRule_Filter>;
};


export type QueryAlertRuleOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAlertSubscriptionListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AlertSubscription_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AlertSubscription_Filter>;
};


export type QueryAlertSubscriptionListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AlertSubscription_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AlertSubscription_Filter>;
};


export type QueryAlertSubscriptionOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAssociatedDocumentEditionListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AssociatedDocumentEdition_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AssociatedDocumentEdition_Filter>;
};


export type QueryAssociatedDocumentEditionListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AssociatedDocumentEdition_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AssociatedDocumentEdition_Filter>;
};


export type QueryAssociatedDocumentEditionOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAssociatedDocumentSignedEditionListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AssociatedDocumentSignedEdition_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AssociatedDocumentSignedEdition_Filter>;
};


export type QueryAssociatedDocumentSignedEditionListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AssociatedDocumentSignedEdition_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AssociatedDocumentSignedEdition_Filter>;
};


export type QueryAssociatedDocumentSignedEditionOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAuthorCollectingSocietyListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AuthorCollectingSociety_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AuthorCollectingSociety_Filter>;
};


export type QueryAuthorCollectingSocietyListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorCollectingSociety_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AuthorCollectingSociety_Filter>;
};


export type QueryAuthorCollectingSocietyOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAuthorComposerDocumentationIssuesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryAuthorComposerListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AuthorComposer_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AuthorComposer_Filter>;
};


export type QueryAuthorComposerListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorComposer_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AuthorComposer_Filter>;
};


export type QueryAuthorComposerOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAuthorComposerPublicListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AuthorComposer_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AuthorComposer_Filter>;
};


export type QueryAuthorComposerPublicListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorComposer_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AuthorComposer_Filter>;
};


export type QueryAuthorComposerPublicOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryAuthorPublisherListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: AuthorPublisher_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AuthorPublisher_Filter>;
};


export type QueryAuthorPublisherListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AuthorPublisher_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<AuthorPublisher_Filter>;
};


export type QueryAuthorPublisherOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryBotErrorListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: BotError_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<BotError_Filter>;
};


export type QueryBotErrorListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<BotError_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<BotError_Filter>;
};


export type QueryBotErrorOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryBotPhaseListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: BotPhase_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<BotPhase_Filter>;
};


export type QueryBotPhaseListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<BotPhase_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<BotPhase_Filter>;
};


export type QueryBotPhaseOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryBotRunListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: BotRun_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<BotRun_Filter>;
};


export type QueryBotRunListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<BotRun_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<BotRun_Filter>;
};


export type QueryBotRunOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryBotStepListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: BotStep_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<BotStep_Filter>;
};


export type QueryBotStepListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<BotStep_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<BotStep_Filter>;
};


export type QueryBotStepOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryCollectiveManagementSocietyListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: CollectiveManagementSociety_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CollectiveManagementSociety_Filter>;
};


export type QueryCollectiveManagementSocietyListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CollectiveManagementSociety_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CollectiveManagementSociety_Filter>;
};


export type QueryCollectiveManagementSocietyOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractObservationListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: ContractObservation_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ContractObservation_Filter>;
};


export type QueryContractObservationListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ContractObservation_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ContractObservation_Filter>;
};


export type QueryContractObservationOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryCountryListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Country_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Country_Filter>;
};


export type QueryCountryListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Country_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Country_Filter>;
};


export type QueryCountryOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryCreditAccountListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: CreditAccount_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditAccount_Filter>;
};


export type QueryCreditAccountListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CreditAccount_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditAccount_Filter>;
};


export type QueryCreditAccountOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryCreditMovementListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: CreditMovement_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditMovement_Filter>;
};


export type QueryCreditMovementListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CreditMovement_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditMovement_Filter>;
};


export type QueryCreditMovementOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryCreditPurchaseListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: CreditPurchase_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditPurchase_Filter>;
};


export type QueryCreditPurchaseListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CreditPurchase_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditPurchase_Filter>;
};


export type QueryCreditPurchaseOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryCreditTierListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: CreditTier_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditTier_Filter>;
};


export type QueryCreditTierListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CreditTier_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditTier_Filter>;
};


export type QueryCreditTierOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryCurrencyListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Currency_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Currency_Filter>;
};


export type QueryCurrencyListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Currency_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Currency_Filter>;
};


export type QueryCurrencyOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryDashboardLayoutTemplateListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: DashboardLayoutTemplate_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<DashboardLayoutTemplate_Filter>;
};


export type QueryDashboardLayoutTemplateListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DashboardLayoutTemplate_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<DashboardLayoutTemplate_Filter>;
};


export type QueryDashboardLayoutTemplateOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryDashboardWidgetListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: DashboardWidget_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<DashboardWidget_Filter>;
};


export type QueryDashboardWidgetListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DashboardWidget_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<DashboardWidget_Filter>;
};


export type QueryDashboardWidgetOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryDeletionBlockersArgs = {
  entity: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryDesignShowcaseListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: DesignShowcase_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<DesignShowcase_Filter>;
};


export type QueryDesignShowcaseListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DesignShowcase_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<DesignShowcase_Filter>;
};


export type QueryDesignShowcaseOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocumentGenerationParamsListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: DocumentGenerationParams_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<DocumentGenerationParams_Filter>;
};


export type QueryDocumentGenerationParamsListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DocumentGenerationParams_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<DocumentGenerationParams_Filter>;
};


export type QueryDocumentGenerationParamsOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEditionContractPublisherListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EditionContractPublisher_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionContractPublisher_Filter>;
};


export type QueryEditionContractPublisherListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EditionContractPublisher_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionContractPublisher_Filter>;
};


export type QueryEditionContractPublisherOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEditionDocumentTypeListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EditionDocumentType_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionDocumentType_Filter>;
};


export type QueryEditionDocumentTypeListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EditionDocumentType_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionDocumentType_Filter>;
};


export type QueryEditionDocumentTypeOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEditionDocumentationListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EditionDocumentation_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionDocumentation_Filter>;
};


export type QueryEditionDocumentationListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EditionDocumentation_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionDocumentation_Filter>;
};


export type QueryEditionDocumentationOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEditionDocumentationWorkflowStateListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EditionDocumentationWorkflowState_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionDocumentationWorkflowState_Filter>;
};


export type QueryEditionDocumentationWorkflowStateListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EditionDocumentationWorkflowState_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionDocumentationWorkflowState_Filter>;
};


export type QueryEditionDocumentationWorkflowStateOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEditionListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Edition_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Edition_Filter>;
};


export type QueryEditionListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Edition_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Edition_Filter>;
};


export type QueryEditionOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEditionSignatureStatusArgs = {
  editionId: Scalars['String']['input'];
};


export type QueryEditionTypeListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EditionType_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionType_Filter>;
};


export type QueryEditionTypeListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EditionType_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EditionType_Filter>;
};


export type QueryEditionTypeOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmailVerificationListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EmailVerification_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EmailVerification_Filter>;
};


export type QueryEmailVerificationListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EmailVerification_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EmailVerification_Filter>;
};


export type QueryEmailVerificationOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEsignatureConfigListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EsignatureConfig_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EsignatureConfig_Filter>;
};


export type QueryEsignatureConfigListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EsignatureConfig_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EsignatureConfig_Filter>;
};


export type QueryEsignatureConfigOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEsignatureDocumentListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EsignatureDocument_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EsignatureDocument_Filter>;
};


export type QueryEsignatureDocumentListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EsignatureDocument_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EsignatureDocument_Filter>;
};


export type QueryEsignatureDocumentOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEsignatureRecipientListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EsignatureRecipient_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EsignatureRecipient_Filter>;
};


export type QueryEsignatureRecipientListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EsignatureRecipient_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EsignatureRecipient_Filter>;
};


export type QueryEsignatureRecipientOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEsignatureWebhookEventListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EsignatureWebhookEvent_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EsignatureWebhookEvent_Filter>;
};


export type QueryEsignatureWebhookEventListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EsignatureWebhookEvent_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EsignatureWebhookEvent_Filter>;
};


export type QueryEsignatureWebhookEventOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryEvaluationQueryListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: EvaluationQuery_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EvaluationQuery_Filter>;
};


export type QueryEvaluationQueryListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<EvaluationQuery_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<EvaluationQuery_Filter>;
};


export type QueryEvaluationQueryOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryGrossReceiptsStatusListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: GrossReceiptsStatus_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<GrossReceiptsStatus_Filter>;
};


export type QueryGrossReceiptsStatusListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<GrossReceiptsStatus_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<GrossReceiptsStatus_Filter>;
};


export type QueryGrossReceiptsStatusOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryInterpreterListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Interpreter_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Interpreter_Filter>;
};


export type QueryInterpreterListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Interpreter_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Interpreter_Filter>;
};


export type QueryInterpreterOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryLlmProviderListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: LlmProvider_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<LlmProvider_Filter>;
};


export type QueryLlmProviderListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<LlmProvider_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<LlmProvider_Filter>;
};


export type QueryLlmProviderOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryMusicalGenreListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: MusicalGenre_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<MusicalGenre_Filter>;
};


export type QueryMusicalGenreListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MusicalGenre_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<MusicalGenre_Filter>;
};


export type QueryMusicalGenreOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryMusicalWorkLinkListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: MusicalWorkLink_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<MusicalWorkLink_Filter>;
};


export type QueryMusicalWorkLinkListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MusicalWorkLink_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<MusicalWorkLink_Filter>;
};


export type QueryMusicalWorkLinkOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryMusicalWorkListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: MusicalWork_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<MusicalWork_Filter>;
};


export type QueryMusicalWorkListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MusicalWork_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<MusicalWork_Filter>;
};


export type QueryMusicalWorkOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyCreditPurchasesListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: CreditPurchase_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditPurchase_Filter>;
};


export type QueryMyCreditPurchasesListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CreditPurchase_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<CreditPurchase_Filter>;
};


export type QueryMyCreditPurchasesOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<NotificationTypeFilter>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentReceiptListWithCursorArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: PaymentReceipt_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PaymentReceipt_Filter>;
};


export type QueryPaymentReceiptListWithOffsetArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PaymentReceipt_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PaymentReceipt_Filter>;
};


export type QueryPaymentReceiptOneArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};


export type QueryPaymentReceiptTypeListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: PaymentReceiptType_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PaymentReceiptType_Filter>;
};


export type QueryPaymentReceiptTypeListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PaymentReceiptType_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PaymentReceiptType_Filter>;
};


export type QueryPaymentReceiptTypeOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryPaymentReceiptUseListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: PaymentReceiptUse_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PaymentReceiptUse_Filter>;
};


export type QueryPaymentReceiptUseListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PaymentReceiptUse_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PaymentReceiptUse_Filter>;
};


export type QueryPaymentReceiptUseOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryPermissionListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Permission_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Permission_Filter>;
};


export type QueryPermissionListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Permission_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Permission_Filter>;
};


export type QueryPermissionOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryPhonogramListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Phonogram_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Phonogram_Filter>;
};


export type QueryPhonogramListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Phonogram_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Phonogram_Filter>;
};


export type QueryPhonogramOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryPlatformLinkTypeListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: PlatformLinkType_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PlatformLinkType_Filter>;
};


export type QueryPlatformLinkTypeListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PlatformLinkType_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PlatformLinkType_Filter>;
};


export type QueryPlatformLinkTypeOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryPlatformListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Platform_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Platform_Filter>;
};


export type QueryPlatformListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Platform_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Platform_Filter>;
};


export type QueryPlatformOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryProvinceStateListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: ProvinceState_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ProvinceState_Filter>;
};


export type QueryProvinceStateListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ProvinceState_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ProvinceState_Filter>;
};


export type QueryProvinceStateOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherCollectingSocietyListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: PublisherCollectingSociety_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PublisherCollectingSociety_Filter>;
};


export type QueryPublisherCollectingSocietyListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PublisherCollectingSociety_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PublisherCollectingSociety_Filter>;
};


export type QueryPublisherCollectingSocietyOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Publisher_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Publisher_Filter>;
};


export type QueryPublisherListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Publisher_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Publisher_Filter>;
};


export type QueryPublisherOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublisherRepresentativeListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: PublisherRepresentative_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PublisherRepresentative_Filter>;
};


export type QueryPublisherRepresentativeListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PublisherRepresentative_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<PublisherRepresentative_Filter>;
};


export type QueryPublisherRepresentativeOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryQueryPatternListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: QueryPattern_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<QueryPattern_Filter>;
};


export type QueryQueryPatternListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryPattern_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<QueryPattern_Filter>;
};


export type QueryQueryPatternOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryReportListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Report_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Report_Filter>;
};


export type QueryReportListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Report_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Report_Filter>;
};


export type QueryReportOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryReportTypeListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: ReportType_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ReportType_Filter>;
};


export type QueryReportTypeListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ReportType_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ReportType_Filter>;
};


export type QueryReportTypeOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryRoleListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Role_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Role_Filter>;
};


export type QueryRoleListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Role_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Role_Filter>;
};


export type QueryRoleOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySatelliteConnectionInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySatelliteHeartbeatListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SatelliteHeartbeat_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SatelliteHeartbeat_Filter>;
};


export type QuerySatelliteHeartbeatListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SatelliteHeartbeat_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SatelliteHeartbeat_Filter>;
};


export type QuerySatelliteHeartbeatOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySatelliteMachineListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SatelliteMachine_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SatelliteMachine_Filter>;
};


export type QuerySatelliteMachineListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SatelliteMachine_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SatelliteMachine_Filter>;
};


export type QuerySatelliteMachineOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySatelliteTaskListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SatelliteTask_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SatelliteTask_Filter>;
};


export type QuerySatelliteTaskListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SatelliteTask_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SatelliteTask_Filter>;
};


export type QuerySatelliteTaskOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryShowcaseCategoryListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: ShowcaseCategory_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ShowcaseCategory_Filter>;
};


export type QueryShowcaseCategoryListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ShowcaseCategory_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ShowcaseCategory_Filter>;
};


export type QueryShowcaseCategoryOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryShowcaseLineListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: ShowcaseLine_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ShowcaseLine_Filter>;
};


export type QueryShowcaseLineListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ShowcaseLine_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ShowcaseLine_Filter>;
};


export type QueryShowcaseLineOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryShowcaseWorkflowStateListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: ShowcaseWorkflowState_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ShowcaseWorkflowState_Filter>;
};


export type QueryShowcaseWorkflowStateListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ShowcaseWorkflowState_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<ShowcaseWorkflowState_Filter>;
};


export type QueryShowcaseWorkflowStateOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySignedContractListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SignedContract_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedContract_Filter>;
};


export type QuerySignedContractListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SignedContract_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedContract_Filter>;
};


export type QuerySignedContractOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySignedEditionBlockchainCertListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SignedEditionBlockchainCert_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedEditionBlockchainCert_Filter>;
};


export type QuerySignedEditionBlockchainCertListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SignedEditionBlockchainCert_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedEditionBlockchainCert_Filter>;
};


export type QuerySignedEditionBlockchainCertOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySignedEditionDndaWorkflowStateListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SignedEditionDndaWorkflowState_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedEditionDndaWorkflowState_Filter>;
};


export type QuerySignedEditionDndaWorkflowStateListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SignedEditionDndaWorkflowState_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedEditionDndaWorkflowState_Filter>;
};


export type QuerySignedEditionDndaWorkflowStateOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySignedEditionListWithCursorArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SignedEdition_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedEdition_Filter>;
};


export type QuerySignedEditionListWithOffsetArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SignedEdition_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedEdition_Filter>;
};


export type QuerySignedEditionOneArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};


export type QuerySignedEditionSadaicWorkflowStateListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SignedEditionSadaicWorkflowState_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedEditionSadaicWorkflowState_Filter>;
};


export type QuerySignedEditionSadaicWorkflowStateListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SignedEditionSadaicWorkflowState_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SignedEditionSadaicWorkflowState_Filter>;
};


export type QuerySignedEditionSadaicWorkflowStateOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySimulationSessionListWithCursorArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SimulationSession_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SimulationSession_Filter>;
};


export type QuerySimulationSessionListWithOffsetArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SimulationSession_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SimulationSession_Filter>;
};


export type QuerySimulationSessionOneArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};


export type QuerySiteUserListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: User_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<User_Filter>;
};


export type QuerySiteUserListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<User_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<User_Filter>;
};


export type QuerySiteUserOneArgs = {
  id: Scalars['String']['input'];
};


export type QuerySnapshotOverrideListWithCursorArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: SnapshotOverride_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SnapshotOverride_Filter>;
};


export type QuerySnapshotOverrideListWithOffsetArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<SnapshotOverride_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<SnapshotOverride_Filter>;
};


export type QuerySnapshotOverrideOneArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};


export type QueryTadManagerConfigListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TadManagerConfig_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TadManagerConfig_Filter>;
};


export type QueryTadManagerConfigListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TadManagerConfig_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TadManagerConfig_Filter>;
};


export type QueryTadManagerConfigOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantDocumentListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantDocument_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantDocument_Filter>;
};


export type QueryTenantDocumentListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantDocument_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantDocument_Filter>;
};


export type QueryTenantDocumentOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Tenant_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Tenant_Filter>;
};


export type QueryTenantListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Tenant_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Tenant_Filter>;
};


export type QueryTenantLlmConfigListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantLlmConfig_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantLlmConfig_Filter>;
};


export type QueryTenantLlmConfigListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantLlmConfig_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantLlmConfig_Filter>;
};


export type QueryTenantLlmConfigOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantPlanListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantPlan_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantPlan_Filter>;
};


export type QueryTenantPlanListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantPlan_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantPlan_Filter>;
};


export type QueryTenantPlanOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantProfileListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantProfile_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantProfile_Filter>;
};


export type QueryTenantProfileListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantProfile_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantProfile_Filter>;
};


export type QueryTenantProfileOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantStatusListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantStatus_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantStatus_Filter>;
};


export type QueryTenantStatusListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantStatus_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantStatus_Filter>;
};


export type QueryTenantStatusOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantStorageUsageListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantStorageUsage_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantStorageUsage_Filter>;
};


export type QueryTenantStorageUsageListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantStorageUsage_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantStorageUsage_Filter>;
};


export type QueryTenantStorageUsageOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantTokenUsageListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantTokenUsage_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantTokenUsage_Filter>;
};


export type QueryTenantTokenUsageListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantTokenUsage_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantTokenUsage_Filter>;
};


export type QueryTenantTokenUsageOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantTypeListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantType_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantType_Filter>;
};


export type QueryTenantTypeListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantType_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantType_Filter>;
};


export type QueryTenantTypeOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantWidgetAccessListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: TenantWidgetAccess_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantWidgetAccess_Filter>;
};


export type QueryTenantWidgetAccessListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TenantWidgetAccess_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<TenantWidgetAccess_Filter>;
};


export type QueryTenantWidgetAccessOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryTerritoryListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Territory_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Territory_Filter>;
};


export type QueryTerritoryListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Territory_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Territory_Filter>;
};


export type QueryTerritoryOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryThemeListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: Theme_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Theme_Filter>;
};


export type QueryThemeListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Theme_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<Theme_Filter>;
};


export type QueryThemeOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserAttachmentEditionListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: UserAttachmentEdition_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<UserAttachmentEdition_Filter>;
};


export type QueryUserAttachmentEditionListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<UserAttachmentEdition_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<UserAttachmentEdition_Filter>;
};


export type QueryUserAttachmentEditionOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: User_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<User_Filter>;
};


export type QueryUserListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<User_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<User_Filter>;
};


export type QueryUserNotificationListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: UserNotification_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<UserNotification_Filter>;
};


export type QueryUserNotificationListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<UserNotification_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<UserNotification_Filter>;
};


export type QueryUserNotificationOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserNotificationPreferenceListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: UserNotificationPreference_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<UserNotificationPreference_Filter>;
};


export type QueryUserNotificationPreferenceListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<UserNotificationPreference_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<UserNotificationPreference_Filter>;
};


export type QueryUserNotificationPreferenceOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserWidgetConfigListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: UserWidgetConfig_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<UserWidgetConfig_Filter>;
};


export type QueryUserWidgetConfigListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<UserWidgetConfig_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<UserWidgetConfig_Filter>;
};


export type QueryUserWidgetConfigOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryVatStatusListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: VatStatus_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<VatStatus_Filter>;
};


export type QueryVatStatusListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<VatStatus_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<VatStatus_Filter>;
};


export type QueryVatStatusOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkAuthorListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: WorkAuthor_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<WorkAuthor_Filter>;
};


export type QueryWorkAuthorListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<WorkAuthor_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<WorkAuthor_Filter>;
};


export type QueryWorkAuthorOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkAuthorPublisherListWithCursorArgs = {
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: WorkAuthorPublisher_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<WorkAuthorPublisher_Filter>;
};


export type QueryWorkAuthorPublisherListWithOffsetArgs = {
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<WorkAuthorPublisher_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<WorkAuthorPublisher_Filter>;
};


export type QueryWorkAuthorPublisherOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkerEventListWithCursorArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  orderBy: WorkerEvent_OrderByCursor;
  take: Scalars['Int']['input'];
  where?: InputMaybe<WorkerEvent_Filter>;
};


export type QueryWorkerEventListWithOffsetArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<WorkerEvent_OrderBy>>;
  take: Scalars['Int']['input'];
  where?: InputMaybe<WorkerEvent_Filter>;
};


export type QueryWorkerEventOneArgs = {
  allTenants?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};


export type QueryWorkerEventRetryInfoArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPattern = {
  __typename?: 'QueryPattern';
  argsTemplate: Scalars['Json']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  exampleInstantiation: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pathType: EvaluationPathType;
  pattern: Scalars['String']['output'];
  qualityScore: Scalars['Int']['output'];
  source: QueryPatternSource;
  toolTemplate: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
  variables: Scalars['Json']['output'];
  variations: Scalars['Json']['output'];
  version_: Scalars['String']['output'];
};

export enum QueryPatternSource {
  AutoGenerated = 'auto_generated',
  HumanCurated = 'human_curated',
  LlmSuggested = 'llm_suggested'
}

export enum QueryPatternVariableType {
  CatalogValue = 'catalog_value',
  Entity = 'entity',
  Number = 'number',
  RefField = 'ref_field',
  ScalarField = 'scalar_field',
  SetField = 'set_field'
}

export type QueryPattern_CreateInput = {
  argsTemplate: Scalars['Json']['input'];
  exampleInstantiation: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pathType: EvaluationPathType;
  pattern: Scalars['String']['input'];
  qualityScore: Scalars['Int']['input'];
  source: QueryPatternSource;
  toolTemplate: Scalars['String']['input'];
  usageCount: Scalars['Int']['input'];
  variables: Scalars['Json']['input'];
  variations: Scalars['Json']['input'];
};

export type QueryPattern_Filter = {
  AND?: InputMaybe<Array<QueryPattern_Filter>>;
  NOT?: InputMaybe<Array<QueryPattern_Filter>>;
  OR?: InputMaybe<Array<QueryPattern_Filter>>;
  argsTemplate?: InputMaybe<FilterJson>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  exampleInstantiation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  isActive?: InputMaybe<FilterBoolean>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  notes?: InputMaybe<FilterString>;
  pathType?: InputMaybe<FilterString>;
  pattern?: InputMaybe<FilterString>;
  qualityScore?: InputMaybe<FilterInt>;
  source?: InputMaybe<FilterString>;
  toolTemplate?: InputMaybe<FilterString>;
  usageCount?: InputMaybe<FilterInt>;
  variables?: InputMaybe<FilterJson>;
  variations?: InputMaybe<FilterJson>;
  version_?: InputMaybe<FilterString>;
};

export type QueryPattern_OrderBy = {
  argsTemplate?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  exampleInstantiation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  pathType?: InputMaybe<SortOrder>;
  pattern?: InputMaybe<SortOrder>;
  qualityScore?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  toolTemplate?: InputMaybe<SortOrder>;
  usageCount?: InputMaybe<SortOrder>;
  variables?: InputMaybe<SortOrder>;
  variations?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type QueryPattern_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type QueryPattern_UpdateInput = {
  argsTemplate?: InputMaybe<Scalars['Json']['input']>;
  exampleInstantiation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pathType?: InputMaybe<EvaluationPathType>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  qualityScore?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<QueryPatternSource>;
  toolTemplate?: InputMaybe<Scalars['String']['input']>;
  usageCount?: InputMaybe<Scalars['Int']['input']>;
  variables?: InputMaybe<Scalars['Json']['input']>;
  variations?: InputMaybe<Scalars['Json']['input']>;
  version_: Scalars['String']['input'];
};

export type RecipientSignatureStatus = {
  __typename?: 'RecipientSignatureStatus';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  role: Scalars['String']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type Report = {
  __typename?: 'Report';
  constants?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  reportType: ReportType;
  template: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type ReportType = {
  __typename?: 'ReportType';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type ReportType_CreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ReportType_Filter = {
  AND?: InputMaybe<Array<ReportType_Filter>>;
  NOT?: InputMaybe<Array<ReportType_Filter>>;
  OR?: InputMaybe<Array<ReportType_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type ReportType_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type ReportType_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ReportType_UpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Report_CreateInput = {
  constants?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reportTypeId: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type Report_Filter = {
  AND?: InputMaybe<Array<Report_Filter>>;
  NOT?: InputMaybe<Array<Report_Filter>>;
  OR?: InputMaybe<Array<Report_Filter>>;
  constants?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  reportType?: InputMaybe<ReportType_Filter>;
  template?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Report_OrderBy = {
  constants?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  reportType?: InputMaybe<ReportType_OrderBy>;
  template?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Report_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type Report_UpdateInput = {
  constants?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reportTypeId?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Role = {
  __typename?: 'Role';
  audience: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isForAllTenants: Scalars['Boolean']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  permissions?: Maybe<Array<Permission>>;
  version_: Scalars['String']['output'];
};

export type Role_CreateInput = {
  audience: Scalars['String']['input'];
  isForAllTenants: Scalars['Boolean']['input'];
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  permissionsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Role_Filter = {
  AND?: InputMaybe<Array<Role_Filter>>;
  NOT?: InputMaybe<Array<Role_Filter>>;
  OR?: InputMaybe<Array<Role_Filter>>;
  audience?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  isForAllTenants?: InputMaybe<FilterBoolean>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  permissions?: InputMaybe<Role_Permissions_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type Role_OrderBy = {
  audience?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  isForAllTenants?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<OrderByMultiple>;
  version_?: InputMaybe<SortOrder>;
};

export type Role_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type Role_UpdateInput = {
  audience?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isForAllTenants?: InputMaybe<Scalars['Boolean']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  permissionsIds?: InputMaybe<InputMultipleRef>;
  version_: Scalars['String']['input'];
};

export type Role_Permissions_Filter = {
  every?: InputMaybe<Permission_Filter>;
  none?: InputMaybe<Permission_Filter>;
  some?: InputMaybe<Permission_Filter>;
};

export type SatelliteAdminResult = {
  __typename?: 'SatelliteAdminResult';
  error?: Maybe<Scalars['String']['output']>;
  plainToken?: Maybe<Scalars['String']['output']>;
  satellite?: Maybe<SatelliteMachine>;
  success: Scalars['Boolean']['output'];
};

export type SatelliteConnectionInfo = {
  __typename?: 'SatelliteConnectionInfo';
  activeTasks?: Maybe<Scalars['Int']['output']>;
  connected: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  lastHeartbeat?: Maybe<Scalars['DateTime']['output']>;
  publicIp?: Maybe<Scalars['String']['output']>;
};

export type SatelliteHeartbeat = {
  __typename?: 'SatelliteHeartbeat';
  activeTasksCount?: Maybe<Scalars['Int']['output']>;
  cpuUsage?: Maybe<Scalars['Decimal']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  diskUsage?: Maybe<Scalars['Decimal']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  latency?: Maybe<Scalars['Int']['output']>;
  memoryUsage?: Maybe<Scalars['Decimal']['output']>;
  proxyStats?: Maybe<Scalars['Json']['output']>;
  publicIp: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  satelliteMachine: SatelliteMachine;
  systemInfo?: Maybe<Scalars['Json']['output']>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
};

export type SatelliteHeartbeat_Filter = {
  AND?: InputMaybe<Array<SatelliteHeartbeat_Filter>>;
  NOT?: InputMaybe<Array<SatelliteHeartbeat_Filter>>;
  OR?: InputMaybe<Array<SatelliteHeartbeat_Filter>>;
  activeTasksCount?: InputMaybe<FilterInt>;
  cpuUsage?: InputMaybe<FilterDecimal>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  diskUsage?: InputMaybe<FilterDecimal>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  latency?: InputMaybe<FilterInt>;
  memoryUsage?: InputMaybe<FilterDecimal>;
  proxyStats?: InputMaybe<FilterJson>;
  publicIp?: InputMaybe<FilterString>;
  receivedAt?: InputMaybe<FilterDateTime>;
  satelliteMachine?: InputMaybe<SatelliteMachine_Filter>;
  systemInfo?: InputMaybe<FilterJson>;
  version_?: InputMaybe<FilterString>;
};

export type SatelliteHeartbeat_OrderBy = {
  activeTasksCount?: InputMaybe<SortOrder>;
  cpuUsage?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  diskUsage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  latency?: InputMaybe<SortOrder>;
  memoryUsage?: InputMaybe<SortOrder>;
  proxyStats?: InputMaybe<SortOrder>;
  publicIp?: InputMaybe<SortOrder>;
  receivedAt?: InputMaybe<SortOrder>;
  satelliteMachine?: InputMaybe<SatelliteMachine_OrderBy>;
  systemInfo?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type SatelliteHeartbeat_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type SatelliteMachine = {
  __typename?: 'SatelliteMachine';
  allowedTenantIds?: Maybe<Scalars['String']['output']>;
  authTokenCreatedAt: Scalars['DateTime']['output'];
  authTokenHashHasValue: Scalars['Boolean']['output'];
  authTokenLastFour: Scalars['String']['output'];
  authTokenRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  authorizedAt?: Maybe<Scalars['DateTime']['output']>;
  authorizedBy?: Maybe<User>;
  botEnabled: Scalars['Boolean']['output'];
  botMaxConcurrent?: Maybe<Scalars['Int']['output']>;
  certificateExpiresAt: Scalars['DateTime']['output'];
  certificateFingerprintHasValue: Scalars['Boolean']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  disconnectedAt?: Maybe<Scalars['DateTime']['output']>;
  displayId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastHeartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  lastHeartbeatMetrics?: Maybe<Scalars['Json']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  location?: Maybe<Scalars['String']['output']>;
  machineCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  proxyEnabled: Scalars['Boolean']['output'];
  proxyPort?: Maybe<Scalars['Int']['output']>;
  proxyProtocols?: Maybe<Scalars['String']['output']>;
  publicIp?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  satelliteType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  suspendedAt?: Maybe<Scalars['DateTime']['output']>;
  suspendedBy?: Maybe<User>;
  suspensionReason?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<SatelliteTask>>;
  tunnelConnectedAt?: Maybe<Scalars['DateTime']['output']>;
  version_: Scalars['String']['output'];
  workerEnabled: Scalars['Boolean']['output'];
};

export type SatelliteMachine_CreateInput = {
  allowedTenantIds?: InputMaybe<Scalars['String']['input']>;
  authTokenCreatedAt: Scalars['DateTime']['input'];
  authTokenHash: Scalars['String']['input'];
  authTokenLastFour: Scalars['String']['input'];
  authTokenRotatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedById?: InputMaybe<Scalars['String']['input']>;
  botEnabled: Scalars['Boolean']['input'];
  botMaxConcurrent?: InputMaybe<Scalars['Int']['input']>;
  certificateExpiresAt: Scalars['DateTime']['input'];
  certificateFingerprint: Scalars['String']['input'];
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  disconnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled: Scalars['Boolean']['input'];
  lastHeartbeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastHeartbeatMetrics?: InputMaybe<Scalars['Json']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  machineCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  proxyEnabled: Scalars['Boolean']['input'];
  proxyPort?: InputMaybe<Scalars['Int']['input']>;
  proxyProtocols?: InputMaybe<Scalars['String']['input']>;
  publicIp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  satelliteType: Scalars['String']['input'];
  status: Scalars['String']['input'];
  suspendedAt?: InputMaybe<Scalars['DateTime']['input']>;
  suspendedById?: InputMaybe<Scalars['String']['input']>;
  suspensionReason?: InputMaybe<Scalars['String']['input']>;
  tunnelConnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerEnabled: Scalars['Boolean']['input'];
};

export type SatelliteMachine_Filter = {
  AND?: InputMaybe<Array<SatelliteMachine_Filter>>;
  NOT?: InputMaybe<Array<SatelliteMachine_Filter>>;
  OR?: InputMaybe<Array<SatelliteMachine_Filter>>;
  allowedTenantIds?: InputMaybe<FilterString>;
  authTokenCreatedAt?: InputMaybe<FilterDateTime>;
  authTokenLastFour?: InputMaybe<FilterString>;
  authTokenRotatedAt?: InputMaybe<FilterDateTime>;
  authorizedAt?: InputMaybe<FilterDateTime>;
  authorizedBy?: InputMaybe<User_Filter>;
  botEnabled?: InputMaybe<FilterBoolean>;
  botMaxConcurrent?: InputMaybe<FilterInt>;
  certificateExpiresAt?: InputMaybe<FilterDateTime>;
  connectedAt?: InputMaybe<FilterDateTime>;
  countryCode?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  disconnectedAt?: InputMaybe<FilterDateTime>;
  displayId?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  lastHeartbeatAt?: InputMaybe<FilterDateTime>;
  lastHeartbeatMetrics?: InputMaybe<FilterJson>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  location?: InputMaybe<FilterString>;
  machineCode?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  proxyEnabled?: InputMaybe<FilterBoolean>;
  proxyPort?: InputMaybe<FilterInt>;
  proxyProtocols?: InputMaybe<FilterString>;
  publicIp?: InputMaybe<FilterString>;
  region?: InputMaybe<FilterString>;
  satelliteType?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterString>;
  suspendedAt?: InputMaybe<FilterDateTime>;
  suspendedBy?: InputMaybe<User_Filter>;
  suspensionReason?: InputMaybe<FilterString>;
  tasks?: InputMaybe<SatelliteMachine_Tasks_Filter>;
  tunnelConnectedAt?: InputMaybe<FilterDateTime>;
  version_?: InputMaybe<FilterString>;
  workerEnabled?: InputMaybe<FilterBoolean>;
};

export type SatelliteMachine_OrderBy = {
  allowedTenantIds?: InputMaybe<SortOrder>;
  authTokenCreatedAt?: InputMaybe<SortOrder>;
  authTokenLastFour?: InputMaybe<SortOrder>;
  authTokenRotatedAt?: InputMaybe<SortOrder>;
  authorizedAt?: InputMaybe<SortOrder>;
  authorizedBy?: InputMaybe<User_OrderBy>;
  botEnabled?: InputMaybe<SortOrder>;
  botMaxConcurrent?: InputMaybe<SortOrder>;
  certificateExpiresAt?: InputMaybe<SortOrder>;
  connectedAt?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  disconnectedAt?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastHeartbeatAt?: InputMaybe<SortOrder>;
  lastHeartbeatMetrics?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  location?: InputMaybe<SortOrder>;
  machineCode?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  proxyEnabled?: InputMaybe<SortOrder>;
  proxyPort?: InputMaybe<SortOrder>;
  proxyProtocols?: InputMaybe<SortOrder>;
  publicIp?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  satelliteType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  suspendedAt?: InputMaybe<SortOrder>;
  suspendedBy?: InputMaybe<User_OrderBy>;
  suspensionReason?: InputMaybe<SortOrder>;
  tasks?: InputMaybe<OrderByMultiple>;
  tunnelConnectedAt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
  workerEnabled?: InputMaybe<SortOrder>;
};

export type SatelliteMachine_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  machineCode?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type SatelliteMachine_UpdateInput = {
  allowedTenantIds?: InputMaybe<Scalars['String']['input']>;
  authTokenCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authTokenHash?: InputMaybe<Scalars['String']['input']>;
  authTokenLastFour?: InputMaybe<Scalars['String']['input']>;
  authTokenRotatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedById?: InputMaybe<Scalars['String']['input']>;
  botEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  botMaxConcurrent?: InputMaybe<Scalars['Int']['input']>;
  certificateExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  certificateFingerprint?: InputMaybe<Scalars['String']['input']>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  disconnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  lastHeartbeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastHeartbeatMetrics?: InputMaybe<Scalars['Json']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  machineCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proxyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  proxyPort?: InputMaybe<Scalars['Int']['input']>;
  proxyProtocols?: InputMaybe<Scalars['String']['input']>;
  publicIp?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  satelliteType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suspendedAt?: InputMaybe<Scalars['DateTime']['input']>;
  suspendedById?: InputMaybe<Scalars['String']['input']>;
  suspensionReason?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<SatelliteMachine_Tasks_UpdateInput>;
  tunnelConnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version_: Scalars['String']['input'];
  workerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SatelliteMachine_Tasks_Filter = {
  every?: InputMaybe<SatelliteTask_Filter>;
  none?: InputMaybe<SatelliteTask_Filter>;
  some?: InputMaybe<SatelliteTask_Filter>;
};

export type SatelliteMachine_Tasks_UpdateInput = {
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SatelliteTask = {
  __typename?: 'SatelliteTask';
  botRun?: Maybe<BotRun>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  correlationId: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  input: Scalars['Json']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  maxRetries: Scalars['Int']['output'];
  output?: Maybe<Scalars['Json']['output']>;
  parent_SatelliteMachine_tasks: SatelliteMachine;
  priority: Scalars['Int']['output'];
  queuedAt: Scalars['DateTime']['output'];
  retryCount: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
  tenant_id_?: Maybe<Scalars['String']['output']>;
  timeoutMs: Scalars['Int']['output'];
  version_: Scalars['String']['output'];
};

export type SatelliteTask_Filter = {
  AND?: InputMaybe<Array<SatelliteTask_Filter>>;
  NOT?: InputMaybe<Array<SatelliteTask_Filter>>;
  OR?: InputMaybe<Array<SatelliteTask_Filter>>;
  botRun?: InputMaybe<BotRun_Filter>;
  completedAt?: InputMaybe<FilterDateTime>;
  correlationId?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterInt>;
  error?: InputMaybe<FilterJson>;
  id?: InputMaybe<FilterString>;
  input?: InputMaybe<FilterJson>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  maxRetries?: InputMaybe<FilterInt>;
  output?: InputMaybe<FilterJson>;
  parent_SatelliteMachine_tasks?: InputMaybe<SatelliteMachine_Filter>;
  priority?: InputMaybe<FilterInt>;
  queuedAt?: InputMaybe<FilterDateTime>;
  retryCount?: InputMaybe<FilterInt>;
  sentAt?: InputMaybe<FilterDateTime>;
  startedAt?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterString>;
  taskType?: InputMaybe<FilterString>;
  timeoutMs?: InputMaybe<FilterInt>;
  version_?: InputMaybe<FilterString>;
};

export type SatelliteTask_OrderBy = {
  botRun?: InputMaybe<BotRun_OrderBy>;
  completedAt?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  duration?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  input?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  maxRetries?: InputMaybe<SortOrder>;
  output?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  queuedAt?: InputMaybe<SortOrder>;
  retryCount?: InputMaybe<SortOrder>;
  sentAt?: InputMaybe<SortOrder>;
  startedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  taskType?: InputMaybe<SortOrder>;
  timeoutMs?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type SatelliteTask_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type SessionInfo = {
  __typename?: 'SessionInfo';
  browserName?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  osName?: Maybe<Scalars['String']['output']>;
};

export type ShowcaseCategory = {
  __typename?: 'ShowcaseCategory';
  code: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type ShowcaseCategory_CreateInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ShowcaseCategory_Filter = {
  AND?: InputMaybe<Array<ShowcaseCategory_Filter>>;
  NOT?: InputMaybe<Array<ShowcaseCategory_Filter>>;
  OR?: InputMaybe<Array<ShowcaseCategory_Filter>>;
  code?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type ShowcaseCategory_OrderBy = {
  code?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type ShowcaseCategory_OrderByCursor = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ShowcaseCategory_UpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type ShowcaseLine = {
  __typename?: 'ShowcaseLine';
  concept: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  note?: Maybe<Scalars['String']['output']>;
  parent_DesignShowcase_lines: DesignShowcase;
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Decimal']['output'];
  version_: Scalars['String']['output'];
};

export type ShowcaseLine_CreateInput = {
  concept: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  unitPrice: Scalars['Decimal']['input'];
};

export type ShowcaseLine_Filter = {
  AND?: InputMaybe<Array<ShowcaseLine_Filter>>;
  NOT?: InputMaybe<Array<ShowcaseLine_Filter>>;
  OR?: InputMaybe<Array<ShowcaseLine_Filter>>;
  concept?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  note?: InputMaybe<FilterString>;
  parent_DesignShowcase_lines?: InputMaybe<DesignShowcase_Filter>;
  quantity?: InputMaybe<FilterInt>;
  unitPrice?: InputMaybe<FilterDecimal>;
  version_?: InputMaybe<FilterString>;
};

export type ShowcaseLine_OrderBy = {
  concept?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  note?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  unitPrice?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type ShowcaseLine_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type ShowcaseLine_UpdateInput = {
  concept?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  version_: Scalars['String']['input'];
};

export enum ShowcaseStatus {
  Active = 'active',
  Archived = 'archived',
  Draft = 'draft'
}

export type ShowcaseWorkflowState = {
  __typename?: 'ShowcaseWorkflowState';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type ShowcaseWorkflowState_CreateInput = {
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type ShowcaseWorkflowState_Filter = {
  AND?: InputMaybe<Array<ShowcaseWorkflowState_Filter>>;
  NOT?: InputMaybe<Array<ShowcaseWorkflowState_Filter>>;
  OR?: InputMaybe<Array<ShowcaseWorkflowState_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type ShowcaseWorkflowState_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type ShowcaseWorkflowState_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type ShowcaseWorkflowState_UpdateInput = {
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type ShowcaseWorkflow_ApproveResult = {
  __typename?: 'ShowcaseWorkflow_ApproveResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type ShowcaseWorkflow_CloseResult = {
  __typename?: 'ShowcaseWorkflow_CloseResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type ShowcaseWorkflow_FailResult = {
  __typename?: 'ShowcaseWorkflow_FailResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type ShowcaseWorkflow_RejectResult = {
  __typename?: 'ShowcaseWorkflow_RejectResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type ShowcaseWorkflow_ReopenResult = {
  __typename?: 'ShowcaseWorkflow_ReopenResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type ShowcaseWorkflow_RetryResult = {
  __typename?: 'ShowcaseWorkflow_RetryResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type ShowcaseWorkflow_SubmitResult = {
  __typename?: 'ShowcaseWorkflow_SubmitResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type SignedContract = {
  __typename?: 'SignedContract';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  data_: SignedContractData;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  originalId_: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type SignedContractData = {
  __typename?: 'SignedContractData';
  authors: Array<SignedContractData_Authors>;
  authorsDisplay?: Maybe<Scalars['String']['output']>;
  contractDuration?: Maybe<Scalars['Int']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractRenewal?: Maybe<Scalars['Int']['output']>;
  finalDocumentPdf?: Maybe<SnapshotFileData>;
  publisherConfigurationDisplay?: Maybe<Scalars['String']['output']>;
  publishers: Array<SignedContractData_Publishers>;
  territories: Array<SignedContractData_Territories>;
  territoriesDisplay?: Maybe<Scalars['String']['output']>;
  works: Array<SignedContractData_Works>;
};

export type SignedContractData_Authors = {
  __typename?: 'SignedContractData_Authors';
  firstName?: Maybe<Scalars['String']['output']>;
  ipi?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxIdType?: Maybe<TaxIdType>;
};

export type SignedContractData_Publishers = {
  __typename?: 'SignedContractData_Publishers';
  percentage?: Maybe<Scalars['Float']['output']>;
  publisher?: Maybe<SignedContractData_Publishers_Publisher>;
};

export type SignedContractData_Publishers_Publisher = {
  __typename?: 'SignedContractData_Publishers_Publisher';
  caeIpi?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<PersonType>;
  pseudonym?: Maybe<Scalars['String']['output']>;
  representatives: Array<SignedContractData_Publishers_Publisher_Representatives>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type SignedContractData_Publishers_Publisher_Representatives = {
  __typename?: 'SignedContractData_Publishers_Publisher_Representatives';
  email?: Maybe<Scalars['String']['output']>;
  isSigner?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type SignedContractData_Territories = {
  __typename?: 'SignedContractData_Territories';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedContractData_Works = {
  __typename?: 'SignedContractData_Works';
  title?: Maybe<Scalars['String']['output']>;
};

export type SignedContract_Filter = {
  AND?: InputMaybe<Array<SignedContract_Filter>>;
  NOT?: InputMaybe<Array<SignedContract_Filter>>;
  OR?: InputMaybe<Array<SignedContract_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  data_?: InputMaybe<FilterJson>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  originalId_?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type SignedContract_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  data_?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  originalId_?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type SignedContract_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type SignedEdition = {
  __typename?: 'SignedEdition';
  blockchainCertificates?: Maybe<Array<SignedEditionBlockchainCert>>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  data_: SignedEditionData;
  displayId: Scalars['String']['output'];
  dndaComprobantePdf?: Maybe<Scalars['String']['output']>;
  dndaComprobantePdf_data?: Maybe<FileData>;
  dndaComprobanteReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  dndaDocuments?: Maybe<Array<AssociatedDocumentSignedEdition>>;
  dndaExpedienteNumber?: Maybe<Scalars['String']['output']>;
  dndaLastComprobantePollAt?: Maybe<Scalars['DateTime']['output']>;
  dndaLastOperationalError?: Maybe<Scalars['String']['output']>;
  dndaRegistroAttempts: Scalars['Int']['output'];
  dndaState: SignedEditionDndaWorkflowState;
  dndaState_transitions_: Array<Scalars['String']['output']>;
  dndaUploadAttempts: Scalars['Int']['output'];
  dndaUploadKeyExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  dndaUploadKeyReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  dndaUploadLink?: Maybe<Scalars['String']['output']>;
  dndaUploadPasswordHasValue: Scalars['Boolean']['output'];
  editionNumber?: Maybe<Scalars['Int']['output']>;
  ejemplarGenerationAttempts: Scalars['Int']['output'];
  ejemplarPdf?: Maybe<Scalars['String']['output']>;
  ejemplarPdf_data?: Maybe<FileData>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name?: Maybe<Scalars['String']['output']>;
  originalId_: Scalars['String']['output'];
  publicationDate?: Maybe<Scalars['Date']['output']>;
  sadaicDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  sadaicLastOperationalError?: Maybe<Scalars['String']['output']>;
  sadaicLastPolledAt?: Maybe<Scalars['DateTime']['output']>;
  sadaicState: SignedEditionSadaicWorkflowState;
  sadaicState_transitions_: Array<Scalars['String']['output']>;
  sadaicUploadAttempts: Scalars['Int']['output'];
  tenant_id_?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
  works: Array<MusicalWork>;
};

export type SignedEditionBlockchainCert = {
  __typename?: 'SignedEditionBlockchainCert';
  confirmedAt: Scalars['DateTime']['output'];
  contractNumber: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  file: Scalars['String']['output'];
  file_data: FileData;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  parent_SignedEdition_blockchainCertificates: SignedEdition;
  version_: Scalars['String']['output'];
};

export type SignedEditionBlockchainCert_Filter = {
  AND?: InputMaybe<Array<SignedEditionBlockchainCert_Filter>>;
  NOT?: InputMaybe<Array<SignedEditionBlockchainCert_Filter>>;
  OR?: InputMaybe<Array<SignedEditionBlockchainCert_Filter>>;
  confirmedAt?: InputMaybe<FilterDateTime>;
  contractNumber?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  file?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  parent_SignedEdition_blockchainCertificates?: InputMaybe<SignedEdition_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type SignedEditionBlockchainCert_OrderBy = {
  confirmedAt?: InputMaybe<SortOrder>;
  contractNumber?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  file?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type SignedEditionBlockchainCert_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type SignedEditionData = {
  __typename?: 'SignedEditionData';
  associatedDocuments: Array<SignedEditionData_AssociatedDocuments>;
  contentType?: Maybe<EditionContentType>;
  documentation: Array<SignedEditionData_Documentation>;
  editionNumber?: Maybe<Scalars['Int']['output']>;
  editionType?: Maybe<SignedEditionData_EditionType>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  publicationLink?: Maybe<Scalars['String']['output']>;
  userAttachments: Array<SignedEditionData_UserAttachments>;
  works: Array<SignedEditionData_Works>;
};

export type SignedEditionData_AssociatedDocuments = {
  __typename?: 'SignedEditionData_AssociatedDocuments';
  authorsDisplay?: Maybe<Scalars['String']['output']>;
  file?: Maybe<SnapshotFileData>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  publisherConfigurationDisplay?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SignedEditionData_AssociatedDocuments_Type>;
};

export type SignedEditionData_AssociatedDocuments_Type = {
  __typename?: 'SignedEditionData_AssociatedDocuments_Type';
  name?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Documentation = {
  __typename?: 'SignedEditionData_Documentation';
  authors: Array<SignedEditionData_Documentation_Authors>;
  authorsDisplay?: Maybe<Scalars['String']['output']>;
  contractDuration?: Maybe<Scalars['Int']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractRenewal?: Maybe<Scalars['Int']['output']>;
  finalDocumentPdf?: Maybe<SnapshotFileData>;
  publisherConfigurationDisplay?: Maybe<Scalars['String']['output']>;
  publishers: Array<SignedEditionData_Documentation_Publishers>;
  territories: Array<SignedEditionData_Documentation_Territories>;
  territoriesDisplay?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Documentation_Authors = {
  __typename?: 'SignedEditionData_Documentation_Authors';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Documentation_Publishers = {
  __typename?: 'SignedEditionData_Documentation_Publishers';
  percentage?: Maybe<Scalars['Float']['output']>;
  publisher?: Maybe<SignedEditionData_Documentation_Publishers_Publisher>;
};

export type SignedEditionData_Documentation_Publishers_Publisher = {
  __typename?: 'SignedEditionData_Documentation_Publishers_Publisher';
  name?: Maybe<Scalars['String']['output']>;
  pseudonym?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Documentation_Territories = {
  __typename?: 'SignedEditionData_Documentation_Territories';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_EditionType = {
  __typename?: 'SignedEditionData_EditionType';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_UserAttachments = {
  __typename?: 'SignedEditionData_UserAttachments';
  file?: Maybe<SnapshotFileData>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works = {
  __typename?: 'SignedEditionData_Works';
  authors: Array<SignedEditionData_Works_Authors>;
  cmsId?: Maybe<Scalars['String']['output']>;
  iswc?: Maybe<Scalars['String']['output']>;
  musicalGenre?: Maybe<SignedEditionData_Works_MusicalGenre>;
  notes?: Maybe<Scalars['String']['output']>;
  originalLyrics?: Maybe<Scalars['String']['output']>;
  performers: Array<SignedEditionData_Works_Performers>;
  phonograms: Array<SignedEditionData_Works_Phonograms>;
  score?: Maybe<SnapshotFileData>;
  territories: Array<SignedEditionData_Works_Territories>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors = {
  __typename?: 'SignedEditionData_Works_Authors';
  author?: Maybe<SignedEditionData_Works_Authors_Author>;
  lyricsPercentage?: Maybe<Scalars['Float']['output']>;
  musicPercentage?: Maybe<Scalars['Float']['output']>;
  publishers: Array<SignedEditionData_Works_Authors_Publishers>;
};

export type SignedEditionData_Works_Authors_Author = {
  __typename?: 'SignedEditionData_Works_Authors_Author';
  aka?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<SignedEditionData_Works_Authors_Author_Country>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  ipi?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  managementSocieties: Array<SignedEditionData_Works_Authors_Author_ManagementSocieties>;
  nationality?: Maybe<SignedEditionData_Works_Authors_Author_Nationality>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<SignedEditionData_Works_Authors_Author_Province>;
  streetAndNumber?: Maybe<Scalars['String']['output']>;
  suite?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxIdType?: Maybe<TaxIdType>;
};

export type SignedEditionData_Works_Authors_Author_Country = {
  __typename?: 'SignedEditionData_Works_Authors_Author_Country';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Author_ManagementSocieties = {
  __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties';
  collectingSociety?: Maybe<SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety>;
  memberNumber?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety = {
  __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety';
  acronym?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Author_Nationality = {
  __typename?: 'SignedEditionData_Works_Authors_Author_Nationality';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Author_Province = {
  __typename?: 'SignedEditionData_Works_Authors_Author_Province';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Publishers = {
  __typename?: 'SignedEditionData_Works_Authors_Publishers';
  autoRenewalYears?: Maybe<Scalars['Int']['output']>;
  durationInYears?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  publisher?: Maybe<SignedEditionData_Works_Authors_Publishers_Publisher>;
};

export type SignedEditionData_Works_Authors_Publishers_Publisher = {
  __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher';
  caeIpi?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<SignedEditionData_Works_Authors_Publishers_Publisher_Country>;
  email?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  managementSocieties: Array<SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties>;
  maritalStatus?: Maybe<MaritalStatus>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<SignedEditionData_Works_Authors_Publishers_Publisher_Nationality>;
  personType?: Maybe<PersonType>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<SignedEditionData_Works_Authors_Publishers_Publisher_Province>;
  pseudonym?: Maybe<Scalars['String']['output']>;
  representatives: Array<SignedEditionData_Works_Authors_Publishers_Publisher_Representatives>;
  streetAndNumber?: Maybe<Scalars['String']['output']>;
  suite?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Publishers_Publisher_Country = {
  __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties = {
  __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties';
  cmsAccountNumber?: Maybe<Scalars['String']['output']>;
  collectingSociety?: Maybe<SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety>;
};

export type SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety = {
  __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety';
  acronym?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Publishers_Publisher_Nationality = {
  __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Publishers_Publisher_Province = {
  __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Authors_Publishers_Publisher_Representatives = {
  __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives';
  email?: Maybe<Scalars['String']['output']>;
  isSigner?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_MusicalGenre = {
  __typename?: 'SignedEditionData_Works_MusicalGenre';
  name?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Performers = {
  __typename?: 'SignedEditionData_Works_Performers';
  name?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Phonograms = {
  __typename?: 'SignedEditionData_Works_Phonograms';
  albumName?: Maybe<Scalars['String']['output']>;
  audioFile?: Maybe<SnapshotFileData>;
  isrc?: Maybe<Scalars['String']['output']>;
  links: Array<SignedEditionData_Works_Phonograms_Links>;
  mainAudio?: Maybe<Scalars['Boolean']['output']>;
  publicationYear?: Maybe<Scalars['Int']['output']>;
  trackName?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Phonograms_Links = {
  __typename?: 'SignedEditionData_Works_Phonograms_Links';
  platform?: Maybe<SignedEditionData_Works_Phonograms_Links_Platform>;
  type?: Maybe<SignedEditionData_Works_Phonograms_Links_Type>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Phonograms_Links_Platform = {
  __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform';
  name?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Phonograms_Links_Type = {
  __typename?: 'SignedEditionData_Works_Phonograms_Links_Type';
  name?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionData_Works_Territories = {
  __typename?: 'SignedEditionData_Works_Territories';
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
};

export type SignedEditionDndaWorkflowState = {
  __typename?: 'SignedEditionDndaWorkflowState';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type SignedEditionDndaWorkflowState_CreateInput = {
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type SignedEditionDndaWorkflowState_Filter = {
  AND?: InputMaybe<Array<SignedEditionDndaWorkflowState_Filter>>;
  NOT?: InputMaybe<Array<SignedEditionDndaWorkflowState_Filter>>;
  OR?: InputMaybe<Array<SignedEditionDndaWorkflowState_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type SignedEditionDndaWorkflowState_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type SignedEditionDndaWorkflowState_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type SignedEditionDndaWorkflowState_UpdateInput = {
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadResult = {
  __typename?: 'SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type SignedEditionDndaWorkflow_ReintentarAvanceRegistroResult = {
  __typename?: 'SignedEditionDndaWorkflow_ReintentarAvanceRegistroResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type SignedEditionDndaWorkflow_ReintentarAvanceUploadResult = {
  __typename?: 'SignedEditionDndaWorkflow_ReintentarAvanceUploadResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarResult = {
  __typename?: 'SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type SignedEditionDndaWorkflow_ReintentarRegistroDndaResult = {
  __typename?: 'SignedEditionDndaWorkflow_ReintentarRegistroDndaResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type SignedEditionDndaWorkflow_ReintentarUploadEjemplarResult = {
  __typename?: 'SignedEditionDndaWorkflow_ReintentarUploadEjemplarResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type SignedEditionSadaicWorkflowState = {
  __typename?: 'SignedEditionSadaicWorkflowState';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type SignedEditionSadaicWorkflowState_CreateInput = {
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type SignedEditionSadaicWorkflowState_Filter = {
  AND?: InputMaybe<Array<SignedEditionSadaicWorkflowState_Filter>>;
  NOT?: InputMaybe<Array<SignedEditionSadaicWorkflowState_Filter>>;
  OR?: InputMaybe<Array<SignedEditionSadaicWorkflowState_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type SignedEditionSadaicWorkflowState_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type SignedEditionSadaicWorkflowState_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type SignedEditionSadaicWorkflowState_UpdateInput = {
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type SignedEditionSadaicWorkflow_ReintentarSubidaSadaicResult = {
  __typename?: 'SignedEditionSadaicWorkflow_ReintentarSubidaSadaicResult';
  instanceId: Scalars['String']['output'];
  instanceState: Scalars['String']['output'];
  instanceVersion: Scalars['String']['output'];
  nextTransitions: Array<Maybe<Scalars['String']['output']>>;
};

export type SignedEdition_Filter = {
  AND?: InputMaybe<Array<SignedEdition_Filter>>;
  NOT?: InputMaybe<Array<SignedEdition_Filter>>;
  OR?: InputMaybe<Array<SignedEdition_Filter>>;
  blockchainCertificates?: InputMaybe<SignedEdition_BlockchainCertificates_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  data_?: InputMaybe<FilterJson>;
  displayId?: InputMaybe<FilterString>;
  dndaComprobantePdf?: InputMaybe<FilterString>;
  dndaComprobanteReceivedAt?: InputMaybe<FilterDateTime>;
  dndaDocuments?: InputMaybe<SignedEdition_DndaDocuments_Filter>;
  dndaExpedienteNumber?: InputMaybe<FilterString>;
  dndaLastComprobantePollAt?: InputMaybe<FilterDateTime>;
  dndaLastOperationalError?: InputMaybe<FilterString>;
  dndaRegistroAttempts?: InputMaybe<FilterInt>;
  dndaState?: InputMaybe<SignedEditionDndaWorkflowState_Filter>;
  dndaState_transitions_?: InputMaybe<FilterStringList>;
  dndaUploadAttempts?: InputMaybe<FilterInt>;
  dndaUploadKeyExpiresAt?: InputMaybe<FilterDateTime>;
  dndaUploadKeyReceivedAt?: InputMaybe<FilterDateTime>;
  dndaUploadLink?: InputMaybe<FilterString>;
  editionNumber?: InputMaybe<FilterInt>;
  ejemplarGenerationAttempts?: InputMaybe<FilterInt>;
  ejemplarPdf?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  originalId_?: InputMaybe<FilterString>;
  publicationDate?: InputMaybe<FilterDate>;
  sadaicDeliveredAt?: InputMaybe<FilterDateTime>;
  sadaicLastOperationalError?: InputMaybe<FilterString>;
  sadaicLastPolledAt?: InputMaybe<FilterDateTime>;
  sadaicState?: InputMaybe<SignedEditionSadaicWorkflowState_Filter>;
  sadaicState_transitions_?: InputMaybe<FilterStringList>;
  sadaicUploadAttempts?: InputMaybe<FilterInt>;
  version_?: InputMaybe<FilterString>;
  works?: InputMaybe<SignedEdition_Works_Filter>;
};

export type SignedEdition_OrderBy = {
  blockchainCertificates?: InputMaybe<OrderByMultiple>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  data_?: InputMaybe<SortOrder>;
  dndaComprobantePdf?: InputMaybe<SortOrder>;
  dndaComprobanteReceivedAt?: InputMaybe<SortOrder>;
  dndaDocuments?: InputMaybe<OrderByMultiple>;
  dndaExpedienteNumber?: InputMaybe<SortOrder>;
  dndaLastComprobantePollAt?: InputMaybe<SortOrder>;
  dndaLastOperationalError?: InputMaybe<SortOrder>;
  dndaRegistroAttempts?: InputMaybe<SortOrder>;
  dndaState?: InputMaybe<SignedEditionDndaWorkflowState_OrderBy>;
  dndaState_transitions_?: InputMaybe<SortOrder>;
  dndaUploadAttempts?: InputMaybe<SortOrder>;
  dndaUploadKeyExpiresAt?: InputMaybe<SortOrder>;
  dndaUploadKeyReceivedAt?: InputMaybe<SortOrder>;
  dndaUploadLink?: InputMaybe<SortOrder>;
  editionNumber?: InputMaybe<SortOrder>;
  ejemplarGenerationAttempts?: InputMaybe<SortOrder>;
  ejemplarPdf?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  originalId_?: InputMaybe<SortOrder>;
  publicationDate?: InputMaybe<SortOrder>;
  sadaicDeliveredAt?: InputMaybe<SortOrder>;
  sadaicLastOperationalError?: InputMaybe<SortOrder>;
  sadaicLastPolledAt?: InputMaybe<SortOrder>;
  sadaicState?: InputMaybe<SignedEditionSadaicWorkflowState_OrderBy>;
  sadaicState_transitions_?: InputMaybe<SortOrder>;
  sadaicUploadAttempts?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
  works?: InputMaybe<OrderByMultiple>;
};

export type SignedEdition_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type SignedEdition_BlockchainCertificates_Filter = {
  every?: InputMaybe<SignedEditionBlockchainCert_Filter>;
  none?: InputMaybe<SignedEditionBlockchainCert_Filter>;
  some?: InputMaybe<SignedEditionBlockchainCert_Filter>;
};

export type SignedEdition_DndaDocuments_Filter = {
  every?: InputMaybe<AssociatedDocumentSignedEdition_Filter>;
  none?: InputMaybe<AssociatedDocumentSignedEdition_Filter>;
  some?: InputMaybe<AssociatedDocumentSignedEdition_Filter>;
};

export type SignedEdition_Works_Filter = {
  every?: InputMaybe<MusicalWork_Filter>;
  none?: InputMaybe<MusicalWork_Filter>;
  some?: InputMaybe<MusicalWork_Filter>;
};

export type SimulationControlResult = {
  __typename?: 'SimulationControlResult';
  ok: Scalars['Boolean']['output'];
};

export type SimulationResetResult = {
  __typename?: 'SimulationResetResult';
  ok: Scalars['Boolean']['output'];
};

export type SimulationSession = {
  __typename?: 'SimulationSession';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  correlationId: Scalars['String']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  currentGate?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  entryPipeline: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  mode: Scalars['String']['output'];
  relatedEntityId?: Maybe<Scalars['String']['output']>;
  relatedEntityType?: Maybe<Scalars['String']['output']>;
  resolvedGates?: Maybe<Scalars['Json']['output']>;
  scenario?: Maybe<Scalars['Json']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  tenant_id_?: Maybe<Scalars['String']['output']>;
  triggeredBy: User;
  version_: Scalars['String']['output'];
};

export type SimulationSession_Filter = {
  AND?: InputMaybe<Array<SimulationSession_Filter>>;
  NOT?: InputMaybe<Array<SimulationSession_Filter>>;
  OR?: InputMaybe<Array<SimulationSession_Filter>>;
  completedAt?: InputMaybe<FilterDateTime>;
  correlationId?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  currentGate?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  entryPipeline?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  label?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  mode?: InputMaybe<FilterString>;
  relatedEntityId?: InputMaybe<FilterString>;
  relatedEntityType?: InputMaybe<FilterString>;
  resolvedGates?: InputMaybe<FilterJson>;
  scenario?: InputMaybe<FilterJson>;
  startedAt?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterString>;
  triggeredBy?: InputMaybe<User_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type SimulationSession_OrderBy = {
  completedAt?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  currentGate?: InputMaybe<SortOrder>;
  entryPipeline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  mode?: InputMaybe<SortOrder>;
  relatedEntityId?: InputMaybe<SortOrder>;
  relatedEntityType?: InputMaybe<SortOrder>;
  resolvedGates?: InputMaybe<SortOrder>;
  scenario?: InputMaybe<SortOrder>;
  startedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  triggeredBy?: InputMaybe<User_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type SimulationSession_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type SimulationStartResult = {
  __typename?: 'SimulationStartResult';
  sessionId: Scalars['ID']['output'];
};

export type SiteUser = {
  __typename?: 'SiteUser';
  active: Scalars['Boolean']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  avatar_data?: Maybe<FileData>;
  cellphone?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id: Scalars['String']['output'];
  idCard?: Maybe<Scalars['String']['output']>;
  idCardType?: Maybe<IdCardType>;
  language: Language;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  role?: Maybe<Role>;
  twoFaseAuth?: Maybe<Scalars['Boolean']['output']>;
  version_: Scalars['String']['output'];
};

export type SiteUser_CreateInput = {
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<UploadedFile>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  language: Language;
  name: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteUser_UpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<UploadedFile>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  language?: InputMaybe<Language>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
  version_: Scalars['String']['input'];
};

export type SnapshotFileData = {
  __typename?: 'SnapshotFileData';
  baseName?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SnapshotOverride = {
  __typename?: 'SnapshotOverride';
  active: Scalars['Boolean']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  note: Scalars['String']['output'];
  path: Scalars['String']['output'];
  relatedEntityId: Scalars['String']['output'];
  relatedEntityType: Scalars['String']['output'];
  tenant_id_?: Maybe<Scalars['String']['output']>;
  value: Scalars['Json']['output'];
  version_: Scalars['String']['output'];
};

export type SnapshotOverride_CreateInput = {
  active: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  path: Scalars['String']['input'];
  relatedEntityId: Scalars['String']['input'];
  relatedEntityType: Scalars['String']['input'];
  value: Scalars['Json']['input'];
};

export type SnapshotOverride_Filter = {
  AND?: InputMaybe<Array<SnapshotOverride_Filter>>;
  NOT?: InputMaybe<Array<SnapshotOverride_Filter>>;
  OR?: InputMaybe<Array<SnapshotOverride_Filter>>;
  active?: InputMaybe<FilterBoolean>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  note?: InputMaybe<FilterString>;
  path?: InputMaybe<FilterString>;
  relatedEntityId?: InputMaybe<FilterString>;
  relatedEntityType?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterJson>;
  version_?: InputMaybe<FilterString>;
};

export type SnapshotOverride_OrderBy = {
  active?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  note?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  relatedEntityId?: InputMaybe<SortOrder>;
  relatedEntityType?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type SnapshotOverride_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type SnapshotOverride_UpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  relatedEntityId?: InputMaybe<Scalars['String']['input']>;
  relatedEntityType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Json']['input']>;
  version_: Scalars['String']['input'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum StorageOperation {
  Delete = 'Delete',
  Upload = 'Upload'
}

export enum TadAuthProvider {
  Anses = 'anses',
  Arca = 'arca',
  MiArgentina = 'miArgentina',
  Renaper = 'renaper'
}

export type TadManagerConfig = {
  __typename?: 'TadManagerConfig';
  ansesPasswordHasValue: Scalars['Boolean']['output'];
  arcaPasswordHasValue: Scalars['Boolean']['output'];
  authProvider?: Maybe<TadAuthProvider>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id: Scalars['String']['output'];
  idCard?: Maybe<Scalars['String']['output']>;
  idCardType?: Maybe<IdCardType>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  miArgentinaPasswordHasValue: Scalars['Boolean']['output'];
  procedureNumberHasValue: Scalars['Boolean']['output'];
  version_: Scalars['String']['output'];
};

export type TadManagerConfig_Filter = {
  AND?: InputMaybe<Array<TadManagerConfig_Filter>>;
  NOT?: InputMaybe<Array<TadManagerConfig_Filter>>;
  OR?: InputMaybe<Array<TadManagerConfig_Filter>>;
  authProvider?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  gender?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  idCard?: InputMaybe<FilterString>;
  idCardType?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type TadManagerConfig_OrderBy = {
  authProvider?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idCard?: InputMaybe<SortOrder>;
  idCardType?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type TadManagerConfig_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type TadManagerConfig_UpdateInput = {
  ansesPassword?: InputMaybe<Scalars['String']['input']>;
  arcaPassword?: InputMaybe<Scalars['String']['input']>;
  authProvider?: InputMaybe<TadAuthProvider>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  miArgentinaPassword?: InputMaybe<Scalars['String']['input']>;
  procedureNumber?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export enum TaxIdType {
  CuitCuil = 'cuitCuil',
  Du = 'du',
  TaxId = 'taxId'
}

export type Tenant = {
  __typename?: 'Tenant';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  currentMonthTokens: Scalars['Int']['output'];
  currentStorageBytes: Scalars['Int']['output'];
  displayId: Scalars['String']['output'];
  eSignatureProvider?: Maybe<EsignatureProvider>;
  id: Scalars['String']['output'];
  idCRM?: Maybe<Scalars['String']['output']>;
  idERP?: Maybe<Scalars['String']['output']>;
  lastTokenResetDate?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  logo?: Maybe<Scalars['String']['output']>;
  logo_data?: Maybe<FileData>;
  monthlyTokenLimit?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  plan?: Maybe<TenantPlan>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  ragLlmModel?: Maybe<Scalars['String']['output']>;
  ragLlmProvider?: Maybe<LlmProvider>;
  status?: Maybe<TenantStatus>;
  storageByteLimit?: Maybe<Scalars['Int']['output']>;
  tenantType?: Maybe<TenantType>;
  tokenLimitResetDay: Scalars['Int']['output'];
  version_: Scalars['String']['output'];
};

export type TenantDocument = {
  __typename?: 'TenantDocument';
  chunkCount?: Maybe<Scalars['Int']['output']>;
  chunkingMaxTokens?: Maybe<Scalars['Int']['output']>;
  chunkingOverlapTokens?: Maybe<Scalars['Int']['output']>;
  chunkingSeparatorRegex?: Maybe<Scalars['String']['output']>;
  chunkingStrategy: ChunkingStrategy;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  file: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  fileType: Scalars['String']['output'];
  file_data: FileData;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  processingError?: Maybe<Scalars['String']['output']>;
  status: DocumentProcessingStatus;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  version_: Scalars['String']['output'];
};

export type TenantDocument_CreateInput = {
  chunkingMaxTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingOverlapTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingSeparatorRegex?: InputMaybe<Scalars['String']['input']>;
  chunkingStrategy: ChunkingStrategy;
  contentType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file: UploadedFile;
  name: Scalars['String']['input'];
  processingError?: InputMaybe<Scalars['String']['input']>;
};

export type TenantDocument_Filter = {
  AND?: InputMaybe<Array<TenantDocument_Filter>>;
  NOT?: InputMaybe<Array<TenantDocument_Filter>>;
  OR?: InputMaybe<Array<TenantDocument_Filter>>;
  chunkCount?: InputMaybe<FilterInt>;
  chunkingMaxTokens?: InputMaybe<FilterInt>;
  chunkingOverlapTokens?: InputMaybe<FilterInt>;
  chunkingSeparatorRegex?: InputMaybe<FilterString>;
  chunkingStrategy?: InputMaybe<FilterString>;
  contentType?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  file?: InputMaybe<FilterString>;
  fileSize?: InputMaybe<FilterInt>;
  fileType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  processedAt?: InputMaybe<FilterDateTime>;
  processingError?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterString>;
  uploadedAt?: InputMaybe<FilterDateTime>;
  version_?: InputMaybe<FilterString>;
};

export type TenantDocument_OrderBy = {
  chunkCount?: InputMaybe<SortOrder>;
  chunkingMaxTokens?: InputMaybe<SortOrder>;
  chunkingOverlapTokens?: InputMaybe<SortOrder>;
  chunkingSeparatorRegex?: InputMaybe<SortOrder>;
  chunkingStrategy?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description?: InputMaybe<SortOrder>;
  file?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrder>;
  processingError?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  uploadedAt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type TenantDocument_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type TenantDocument_UpdateInput = {
  chunkingMaxTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingOverlapTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingSeparatorRegex?: InputMaybe<Scalars['String']['input']>;
  chunkingStrategy?: InputMaybe<ChunkingStrategy>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<UploadedFile>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  processingError?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type TenantLlmConfig = {
  __typename?: 'TenantLlmConfig';
  apiKeyHasValue: Scalars['Boolean']['output'];
  baseUrl?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  debugFullMode: Scalars['Boolean']['output'];
  displayId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  maxTokens?: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  provider: LlmProvider;
  temperature?: Maybe<Scalars['Decimal']['output']>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
};

export type TenantLlmConfig_CreateInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  debugFullMode: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  providerId: Scalars['String']['input'];
  temperature?: InputMaybe<Scalars['Decimal']['input']>;
};

export type TenantLlmConfig_Filter = {
  AND?: InputMaybe<Array<TenantLlmConfig_Filter>>;
  NOT?: InputMaybe<Array<TenantLlmConfig_Filter>>;
  OR?: InputMaybe<Array<TenantLlmConfig_Filter>>;
  baseUrl?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  debugFullMode?: InputMaybe<FilterBoolean>;
  displayId?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  maxTokens?: InputMaybe<FilterInt>;
  model?: InputMaybe<FilterString>;
  priority?: InputMaybe<FilterInt>;
  provider?: InputMaybe<LlmProvider_Filter>;
  temperature?: InputMaybe<FilterDecimal>;
  version_?: InputMaybe<FilterString>;
};

export type TenantLlmConfig_OrderBy = {
  baseUrl?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  debugFullMode?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  maxTokens?: InputMaybe<SortOrder>;
  model?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  provider?: InputMaybe<LlmProvider_OrderBy>;
  temperature?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type TenantLlmConfig_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type TenantLlmConfig_UpdateInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  debugFullMode?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Decimal']['input']>;
  version_: Scalars['String']['input'];
};

export type TenantPlan = {
  __typename?: 'TenantPlan';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  limits?: Maybe<Scalars['Json']['output']>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type TenantPlan_CreateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<Scalars['Json']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type TenantPlan_Filter = {
  AND?: InputMaybe<Array<TenantPlan_Filter>>;
  NOT?: InputMaybe<Array<TenantPlan_Filter>>;
  OR?: InputMaybe<Array<TenantPlan_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description_en?: InputMaybe<FilterString>;
  description_es?: InputMaybe<FilterString>;
  description_pt?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  limits?: InputMaybe<FilterJson>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type TenantPlan_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description_en?: InputMaybe<SortOrder>;
  description_es?: InputMaybe<SortOrder>;
  description_pt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  limits?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type TenantPlan_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type TenantPlan_UpdateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  limits?: InputMaybe<Scalars['Json']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type TenantProfile = {
  __typename?: 'TenantProfile';
  billingCurrency?: Maybe<Currency>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  grossReceiptsId?: Maybe<Scalars['String']['output']>;
  grossReceiptsStatus?: Maybe<GrossReceiptsStatus>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  legalEmail?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  ownPublisher?: Maybe<Publisher>;
  personType?: Maybe<PersonType>;
  postalCode?: Maybe<Scalars['String']['output']>;
  printerCity?: Maybe<Scalars['String']['output']>;
  printerCountry?: Maybe<Country>;
  printerFloor?: Maybe<Scalars['String']['output']>;
  printerName?: Maybe<Scalars['String']['output']>;
  printerPostalCode?: Maybe<Scalars['String']['output']>;
  printerProvince?: Maybe<ProvinceState>;
  printerStreetAndNumber?: Maybe<Scalars['String']['output']>;
  printerSuite?: Maybe<Scalars['String']['output']>;
  province?: Maybe<ProvinceState>;
  sadaicEmail?: Maybe<Scalars['String']['output']>;
  sadaicFtpPasswordHasValue: Scalars['Boolean']['output'];
  sadaicFtpUrl?: Maybe<Scalars['String']['output']>;
  sadaicFtpUser?: Maybe<Scalars['String']['output']>;
  streetAndNumber?: Maybe<Scalars['String']['output']>;
  suite?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  vatStatus?: Maybe<VatStatus>;
  version_: Scalars['String']['output'];
};

export type TenantProfile_CreateInput = {
  billingCurrencyId?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsId?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsStatusId?: InputMaybe<Scalars['String']['input']>;
  legalEmail?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownPublisherId?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<PersonType>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  printerCity?: InputMaybe<Scalars['String']['input']>;
  printerCountryId?: InputMaybe<Scalars['String']['input']>;
  printerFloor?: InputMaybe<Scalars['String']['input']>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  printerPostalCode?: InputMaybe<Scalars['String']['input']>;
  printerProvinceId?: InputMaybe<Scalars['String']['input']>;
  printerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  printerSuite?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  sadaicEmail?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpPassword?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUrl?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUser?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatStatusId?: InputMaybe<Scalars['String']['input']>;
};

export type TenantProfile_Filter = {
  AND?: InputMaybe<Array<TenantProfile_Filter>>;
  NOT?: InputMaybe<Array<TenantProfile_Filter>>;
  OR?: InputMaybe<Array<TenantProfile_Filter>>;
  billingCurrency?: InputMaybe<Currency_Filter>;
  billingEmail?: InputMaybe<FilterString>;
  businessId?: InputMaybe<FilterString>;
  city?: InputMaybe<FilterString>;
  country?: InputMaybe<Country_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  floor?: InputMaybe<FilterString>;
  grossReceiptsId?: InputMaybe<FilterString>;
  grossReceiptsStatus?: InputMaybe<GrossReceiptsStatus_Filter>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  legalEmail?: InputMaybe<FilterString>;
  legalName?: InputMaybe<FilterString>;
  ownPublisher?: InputMaybe<Publisher_Filter>;
  personType?: InputMaybe<FilterString>;
  postalCode?: InputMaybe<FilterString>;
  printerCity?: InputMaybe<FilterString>;
  printerCountry?: InputMaybe<Country_Filter>;
  printerFloor?: InputMaybe<FilterString>;
  printerName?: InputMaybe<FilterString>;
  printerPostalCode?: InputMaybe<FilterString>;
  printerProvince?: InputMaybe<ProvinceState_Filter>;
  printerStreetAndNumber?: InputMaybe<FilterString>;
  printerSuite?: InputMaybe<FilterString>;
  province?: InputMaybe<ProvinceState_Filter>;
  sadaicEmail?: InputMaybe<FilterString>;
  sadaicFtpUrl?: InputMaybe<FilterString>;
  sadaicFtpUser?: InputMaybe<FilterString>;
  streetAndNumber?: InputMaybe<FilterString>;
  suite?: InputMaybe<FilterString>;
  taxId?: InputMaybe<FilterString>;
  vatStatus?: InputMaybe<VatStatus_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type TenantProfile_OrderBy = {
  billingCurrency?: InputMaybe<Currency_OrderBy>;
  billingEmail?: InputMaybe<SortOrder>;
  businessId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<Country_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  floor?: InputMaybe<SortOrder>;
  grossReceiptsId?: InputMaybe<SortOrder>;
  grossReceiptsStatus?: InputMaybe<GrossReceiptsStatus_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  legalEmail?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
  ownPublisher?: InputMaybe<Publisher_OrderBy>;
  personType?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  printerCity?: InputMaybe<SortOrder>;
  printerCountry?: InputMaybe<Country_OrderBy>;
  printerFloor?: InputMaybe<SortOrder>;
  printerName?: InputMaybe<SortOrder>;
  printerPostalCode?: InputMaybe<SortOrder>;
  printerProvince?: InputMaybe<ProvinceState_OrderBy>;
  printerStreetAndNumber?: InputMaybe<SortOrder>;
  printerSuite?: InputMaybe<SortOrder>;
  province?: InputMaybe<ProvinceState_OrderBy>;
  sadaicEmail?: InputMaybe<SortOrder>;
  sadaicFtpUrl?: InputMaybe<SortOrder>;
  sadaicFtpUser?: InputMaybe<SortOrder>;
  streetAndNumber?: InputMaybe<SortOrder>;
  suite?: InputMaybe<SortOrder>;
  taxId?: InputMaybe<SortOrder>;
  vatStatus?: InputMaybe<VatStatus_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type TenantProfile_OrderByCursor = {
  businessId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legalName?: InputMaybe<SortOrder>;
};

export type TenantProfile_UpdateInput = {
  billingCurrencyId?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsId?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsStatusId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  legalEmail?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownPublisherId?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<PersonType>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  printerCity?: InputMaybe<Scalars['String']['input']>;
  printerCountryId?: InputMaybe<Scalars['String']['input']>;
  printerFloor?: InputMaybe<Scalars['String']['input']>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  printerPostalCode?: InputMaybe<Scalars['String']['input']>;
  printerProvinceId?: InputMaybe<Scalars['String']['input']>;
  printerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  printerSuite?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  sadaicEmail?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpPassword?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUrl?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUser?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatStatusId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type TenantStatus = {
  __typename?: 'TenantStatus';
  blocksAccess: Scalars['Boolean']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type TenantStatus_CreateInput = {
  blocksAccess: Scalars['Boolean']['input'];
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TenantStatus_Filter = {
  AND?: InputMaybe<Array<TenantStatus_Filter>>;
  NOT?: InputMaybe<Array<TenantStatus_Filter>>;
  OR?: InputMaybe<Array<TenantStatus_Filter>>;
  blocksAccess?: InputMaybe<FilterBoolean>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description_en?: InputMaybe<FilterString>;
  description_es?: InputMaybe<FilterString>;
  description_pt?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type TenantStatus_OrderBy = {
  blocksAccess?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description_en?: InputMaybe<SortOrder>;
  description_es?: InputMaybe<SortOrder>;
  description_pt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type TenantStatus_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TenantStatus_UpdateInput = {
  blocksAccess?: InputMaybe<Scalars['Boolean']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type TenantStorageUsage = {
  __typename?: 'TenantStorageUsage';
  balanceAfter: Scalars['Int']['output'];
  bytes: Scalars['Int']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  documentName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  operation: StorageOperation;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  version_: Scalars['String']['output'];
};

export type TenantStorageUsage_Filter = {
  AND?: InputMaybe<Array<TenantStorageUsage_Filter>>;
  NOT?: InputMaybe<Array<TenantStorageUsage_Filter>>;
  OR?: InputMaybe<Array<TenantStorageUsage_Filter>>;
  balanceAfter?: InputMaybe<FilterInt>;
  bytes?: InputMaybe<FilterInt>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  documentId?: InputMaybe<FilterString>;
  documentName?: InputMaybe<FilterString>;
  fileType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  operation?: InputMaybe<FilterString>;
  timestamp?: InputMaybe<FilterDateTime>;
  version_?: InputMaybe<FilterString>;
};

export type TenantStorageUsage_OrderBy = {
  balanceAfter?: InputMaybe<SortOrder>;
  bytes?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  documentId?: InputMaybe<SortOrder>;
  documentName?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  operation?: InputMaybe<SortOrder>;
  timestamp?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type TenantStorageUsage_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type TenantTokenUsage = {
  __typename?: 'TenantTokenUsage';
  abTestCondition?: Maybe<Scalars['String']['output']>;
  completionTokens: Scalars['Int']['output'];
  conversation?: Maybe<AiSearchConversation>;
  conversationUser: User;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  firstTokenMs?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  llmCallCount: Scalars['Int']['output'];
  llmTimeMs: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  promptTokens: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  ragChunksCount?: Maybe<Scalars['Int']['output']>;
  ragTimeMs?: Maybe<Scalars['Int']['output']>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  toolCallCount: Scalars['Int']['output'];
  toolsTimeMs: Scalars['Int']['output'];
  totalTimeMs: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
  version_: Scalars['String']['output'];
};

export type TenantTokenUsage_Filter = {
  AND?: InputMaybe<Array<TenantTokenUsage_Filter>>;
  NOT?: InputMaybe<Array<TenantTokenUsage_Filter>>;
  OR?: InputMaybe<Array<TenantTokenUsage_Filter>>;
  abTestCondition?: InputMaybe<FilterString>;
  completionTokens?: InputMaybe<FilterInt>;
  conversation?: InputMaybe<AiSearchConversation_Filter>;
  conversationUser?: InputMaybe<User_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  firstTokenMs?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  llmCallCount?: InputMaybe<FilterInt>;
  llmTimeMs?: InputMaybe<FilterInt>;
  model?: InputMaybe<FilterString>;
  promptTokens?: InputMaybe<FilterInt>;
  provider?: InputMaybe<FilterString>;
  ragChunksCount?: InputMaybe<FilterInt>;
  ragTimeMs?: InputMaybe<FilterInt>;
  timestamp?: InputMaybe<FilterDateTime>;
  toolCallCount?: InputMaybe<FilterInt>;
  toolsTimeMs?: InputMaybe<FilterInt>;
  totalTimeMs?: InputMaybe<FilterInt>;
  totalTokens?: InputMaybe<FilterInt>;
  version_?: InputMaybe<FilterString>;
};

export type TenantTokenUsage_OrderBy = {
  abTestCondition?: InputMaybe<SortOrder>;
  completionTokens?: InputMaybe<SortOrder>;
  conversation?: InputMaybe<AiSearchConversation_OrderBy>;
  conversationUser?: InputMaybe<User_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  firstTokenMs?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  llmCallCount?: InputMaybe<SortOrder>;
  llmTimeMs?: InputMaybe<SortOrder>;
  model?: InputMaybe<SortOrder>;
  promptTokens?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  ragChunksCount?: InputMaybe<SortOrder>;
  ragTimeMs?: InputMaybe<SortOrder>;
  timestamp?: InputMaybe<SortOrder>;
  toolCallCount?: InputMaybe<SortOrder>;
  toolsTimeMs?: InputMaybe<SortOrder>;
  totalTimeMs?: InputMaybe<SortOrder>;
  totalTokens?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type TenantTokenUsage_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type TenantType = {
  __typename?: 'TenantType';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type TenantType_CreateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type TenantType_Filter = {
  AND?: InputMaybe<Array<TenantType_Filter>>;
  NOT?: InputMaybe<Array<TenantType_Filter>>;
  OR?: InputMaybe<Array<TenantType_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description_en?: InputMaybe<FilterString>;
  description_es?: InputMaybe<FilterString>;
  description_pt?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type TenantType_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description_en?: InputMaybe<SortOrder>;
  description_es?: InputMaybe<SortOrder>;
  description_pt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type TenantType_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type TenantType_UpdateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type TenantWidgetAccess = {
  __typename?: 'TenantWidgetAccess';
  configOverride?: Maybe<Scalars['Json']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  tenant: Tenant;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  version_: Scalars['String']['output'];
  widget: DashboardWidget;
};

export type TenantWidgetAccess_CreateInput = {
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  enabled: Scalars['Boolean']['input'];
  tenantId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};

export type TenantWidgetAccess_Filter = {
  AND?: InputMaybe<Array<TenantWidgetAccess_Filter>>;
  NOT?: InputMaybe<Array<TenantWidgetAccess_Filter>>;
  OR?: InputMaybe<Array<TenantWidgetAccess_Filter>>;
  configOverride?: InputMaybe<FilterJson>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  tenant?: InputMaybe<Tenant_Filter>;
  version_?: InputMaybe<FilterString>;
  widget?: InputMaybe<DashboardWidget_Filter>;
};

export type TenantWidgetAccess_OrderBy = {
  configOverride?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  tenant?: InputMaybe<Tenant_OrderBy>;
  version_?: InputMaybe<SortOrder>;
  widget?: InputMaybe<DashboardWidget_OrderBy>;
};

export type TenantWidgetAccess_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type TenantWidgetAccess_UpdateInput = {
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
};

export type Tenant_CreateInput = {
  currentMonthTokens: Scalars['Int']['input'];
  currentStorageBytes: Scalars['Int']['input'];
  eSignatureProvider?: InputMaybe<EsignatureProvider>;
  idCRM?: InputMaybe<Scalars['String']['input']>;
  idERP?: InputMaybe<Scalars['String']['input']>;
  lastTokenResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  logo?: InputMaybe<UploadedFile>;
  monthlyTokenLimit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['String']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  ragLlmModel?: InputMaybe<Scalars['String']['input']>;
  ragLlmProviderId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  storageByteLimit?: InputMaybe<Scalars['Int']['input']>;
  tenantTypeId?: InputMaybe<Scalars['String']['input']>;
  tokenLimitResetDay: Scalars['Int']['input'];
};

export type Tenant_Filter = {
  AND?: InputMaybe<Array<Tenant_Filter>>;
  NOT?: InputMaybe<Array<Tenant_Filter>>;
  OR?: InputMaybe<Array<Tenant_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  currentMonthTokens?: InputMaybe<FilterInt>;
  currentStorageBytes?: InputMaybe<FilterInt>;
  displayId?: InputMaybe<FilterString>;
  eSignatureProvider?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  idCRM?: InputMaybe<FilterString>;
  idERP?: InputMaybe<FilterString>;
  lastTokenResetDate?: InputMaybe<FilterDateTime>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  logo?: InputMaybe<FilterString>;
  monthlyTokenLimit?: InputMaybe<FilterInt>;
  name?: InputMaybe<FilterString>;
  plan?: InputMaybe<TenantPlan_Filter>;
  publicUrl?: InputMaybe<FilterString>;
  ragLlmModel?: InputMaybe<FilterString>;
  ragLlmProvider?: InputMaybe<LlmProvider_Filter>;
  status?: InputMaybe<TenantStatus_Filter>;
  storageByteLimit?: InputMaybe<FilterInt>;
  tenantType?: InputMaybe<TenantType_Filter>;
  tokenLimitResetDay?: InputMaybe<FilterInt>;
  version_?: InputMaybe<FilterString>;
};

export type Tenant_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  currentMonthTokens?: InputMaybe<SortOrder>;
  currentStorageBytes?: InputMaybe<SortOrder>;
  eSignatureProvider?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idCRM?: InputMaybe<SortOrder>;
  idERP?: InputMaybe<SortOrder>;
  lastTokenResetDate?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  logo?: InputMaybe<SortOrder>;
  monthlyTokenLimit?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  plan?: InputMaybe<TenantPlan_OrderBy>;
  publicUrl?: InputMaybe<SortOrder>;
  ragLlmModel?: InputMaybe<SortOrder>;
  ragLlmProvider?: InputMaybe<LlmProvider_OrderBy>;
  status?: InputMaybe<TenantStatus_OrderBy>;
  storageByteLimit?: InputMaybe<SortOrder>;
  tenantType?: InputMaybe<TenantType_OrderBy>;
  tokenLimitResetDay?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Tenant_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type Tenant_UpdateInput = {
  currentMonthTokens?: InputMaybe<Scalars['Int']['input']>;
  currentStorageBytes?: InputMaybe<Scalars['Int']['input']>;
  eSignatureProvider?: InputMaybe<EsignatureProvider>;
  id: Scalars['String']['input'];
  idCRM?: InputMaybe<Scalars['String']['input']>;
  idERP?: InputMaybe<Scalars['String']['input']>;
  lastTokenResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  logo?: InputMaybe<UploadedFile>;
  monthlyTokenLimit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  ragLlmModel?: InputMaybe<Scalars['String']['input']>;
  ragLlmProviderId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  storageByteLimit?: InputMaybe<Scalars['Int']['input']>;
  tenantTypeId?: InputMaybe<Scalars['String']['input']>;
  tokenLimitResetDay?: InputMaybe<Scalars['Int']['input']>;
  version_: Scalars['String']['input'];
};

export type Territory = {
  __typename?: 'Territory';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type Territory_CreateInput = {
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type Territory_Filter = {
  AND?: InputMaybe<Array<Territory_Filter>>;
  NOT?: InputMaybe<Array<Territory_Filter>>;
  OR?: InputMaybe<Array<Territory_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type Territory_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Territory_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type Territory_UpdateInput = {
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type Theme = {
  __typename?: 'Theme';
  active: Scalars['Boolean']['output'];
  authoring: Scalars['Json']['output'];
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  resolved: Scalars['Json']['output'];
  version_: Scalars['String']['output'];
};

export type ThemePreviewResult = {
  __typename?: 'ThemePreviewResult';
  resolved: Scalars['Json']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type Theme_Filter = {
  AND?: InputMaybe<Array<Theme_Filter>>;
  NOT?: InputMaybe<Array<Theme_Filter>>;
  OR?: InputMaybe<Array<Theme_Filter>>;
  active?: InputMaybe<FilterBoolean>;
  authoring?: InputMaybe<FilterJson>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  resolved?: InputMaybe<FilterJson>;
  version_?: InputMaybe<FilterString>;
};

export type Theme_OrderBy = {
  active?: InputMaybe<SortOrder>;
  authoring?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  resolved?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type Theme_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  size: ThumbnailSize;
  url: Scalars['String']['output'];
};

export enum ThumbnailSize {
  Width256 = 'width256',
  Width512 = 'width512',
  Width1280 = 'width1280'
}

export type TrustedDeviceInfo = {
  __typename?: 'TrustedDeviceInfo';
  browserName?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  osName?: Maybe<Scalars['String']['output']>;
};

export type TwoFaSetupResponse = {
  __typename?: 'TwoFaSetupResponse';
  backupCodes: Array<Scalars['String']['output']>;
  qrCodeDataUrl: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type UploadedFile = {
  encoding?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  ticket: Scalars['String']['input'];
};

export type UploadedFileData = {
  __typename?: 'UploadedFileData';
  encoding?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  ticket: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  avatar_data?: Maybe<FileData>;
  cellphone?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id: Scalars['String']['output'];
  idCard?: Maybe<Scalars['String']['output']>;
  idCardType?: Maybe<IdCardType>;
  language: Language;
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  profile?: Maybe<Scalars['Json']['output']>;
  role?: Maybe<Role>;
  targetTenant?: Maybe<Tenant>;
  tenantDisplayName?: Maybe<Scalars['String']['output']>;
  tenant_id_?: Maybe<Scalars['String']['output']>;
  twoFaseAuth?: Maybe<Scalars['Boolean']['output']>;
  version_: Scalars['String']['output'];
};

export type UserAttachmentEdition = {
  __typename?: 'UserAttachmentEdition';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  file: Scalars['String']['output'];
  file_data: FileData;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  parent_Edition_userAttachments: Edition;
  version_: Scalars['String']['output'];
};

export type UserAttachmentEdition_CreateInput = {
  file: UploadedFile;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UserAttachmentEdition_Filter = {
  AND?: InputMaybe<Array<UserAttachmentEdition_Filter>>;
  NOT?: InputMaybe<Array<UserAttachmentEdition_Filter>>;
  OR?: InputMaybe<Array<UserAttachmentEdition_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  file?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  notes?: InputMaybe<FilterString>;
  parent_Edition_userAttachments?: InputMaybe<Edition_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type UserAttachmentEdition_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  file?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type UserAttachmentEdition_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type UserAttachmentEdition_UpdateInput = {
  file?: InputMaybe<UploadedFile>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type UserNotification = {
  __typename?: 'UserNotification';
  actionUrl?: Maybe<Scalars['String']['output']>;
  actorUser?: Maybe<User>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  metadata?: Maybe<Scalars['Json']['output']>;
  notificationCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<NotificationPriority>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: NotificationType;
  version_: Scalars['String']['output'];
};

export type UserNotificationItem = {
  __typename?: 'UserNotificationItem';
  actionUrl?: Maybe<Scalars['String']['output']>;
  actorUser?: Maybe<NotificationActorUser>;
  archivedAt?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  objectId?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  priority: Scalars['String']['output'];
  readAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserNotificationPreference = {
  __typename?: 'UserNotificationPreference';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  emailFrequency: EmailFrequency;
  id: Scalars['String']['output'];
  inAppEnabled: Scalars['Boolean']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  notificationType: NotificationType;
  version_: Scalars['String']['output'];
};

export type UserNotificationPreference_CreateInput = {
  emailEnabled: Scalars['Boolean']['input'];
  emailFrequency: EmailFrequency;
  inAppEnabled: Scalars['Boolean']['input'];
  notificationType: NotificationType;
};

export type UserNotificationPreference_Filter = {
  AND?: InputMaybe<Array<UserNotificationPreference_Filter>>;
  NOT?: InputMaybe<Array<UserNotificationPreference_Filter>>;
  OR?: InputMaybe<Array<UserNotificationPreference_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  emailEnabled?: InputMaybe<FilterBoolean>;
  emailFrequency?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  inAppEnabled?: InputMaybe<FilterBoolean>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  notificationType?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type UserNotificationPreference_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  emailEnabled?: InputMaybe<SortOrder>;
  emailFrequency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inAppEnabled?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  notificationType?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type UserNotificationPreference_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type UserNotificationPreference_UpdateInput = {
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailFrequency?: InputMaybe<EmailFrequency>;
  id: Scalars['String']['input'];
  inAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationType?: InputMaybe<NotificationType>;
  version_: Scalars['String']['input'];
};

export type UserNotificationResult = {
  __typename?: 'UserNotificationResult';
  error?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<UserNotificationItem>;
  success: Scalars['Boolean']['output'];
};

export type UserNotification_Filter = {
  AND?: InputMaybe<Array<UserNotification_Filter>>;
  NOT?: InputMaybe<Array<UserNotification_Filter>>;
  OR?: InputMaybe<Array<UserNotification_Filter>>;
  actionUrl?: InputMaybe<FilterString>;
  actorUser?: InputMaybe<User_Filter>;
  archivedAt?: InputMaybe<FilterDateTime>;
  body?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  metadata?: InputMaybe<FilterJson>;
  notificationCreatedAt?: InputMaybe<FilterDateTime>;
  objectId?: InputMaybe<FilterString>;
  objectType?: InputMaybe<FilterString>;
  priority?: InputMaybe<FilterString>;
  readAt?: InputMaybe<FilterDateTime>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type UserNotification_OrderBy = {
  actionUrl?: InputMaybe<SortOrder>;
  actorUser?: InputMaybe<User_OrderBy>;
  archivedAt?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  metadata?: InputMaybe<SortOrder>;
  notificationCreatedAt?: InputMaybe<SortOrder>;
  objectId?: InputMaybe<SortOrder>;
  objectType?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  readAt?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type UserNotification_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type UserWidgetConfig = {
  __typename?: 'UserWidgetConfig';
  configOverride?: Maybe<Scalars['Json']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  position: Scalars['Json']['output'];
  user: User;
  version_: Scalars['String']['output'];
  widget: DashboardWidget;
};

export type UserWidgetConfig_CreateInput = {
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  position: Scalars['Json']['input'];
  userId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};

export type UserWidgetConfig_Filter = {
  AND?: InputMaybe<Array<UserWidgetConfig_Filter>>;
  NOT?: InputMaybe<Array<UserWidgetConfig_Filter>>;
  OR?: InputMaybe<Array<UserWidgetConfig_Filter>>;
  configOverride?: InputMaybe<FilterJson>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  displayOrder?: InputMaybe<FilterInt>;
  enabled?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  position?: InputMaybe<FilterJson>;
  user?: InputMaybe<User_Filter>;
  version_?: InputMaybe<FilterString>;
  widget?: InputMaybe<DashboardWidget_Filter>;
};

export type UserWidgetConfig_OrderBy = {
  configOverride?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  displayOrder?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  position?: InputMaybe<SortOrder>;
  user?: InputMaybe<User_OrderBy>;
  version_?: InputMaybe<SortOrder>;
  widget?: InputMaybe<DashboardWidget_OrderBy>;
};

export type UserWidgetConfig_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type UserWidgetConfig_UpdateInput = {
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Json']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
  widgetId?: InputMaybe<Scalars['String']['input']>;
};

export type User_CreateInput = {
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<UploadedFile>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  language: Language;
  name: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  targetTenantId?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User_Filter = {
  AND?: InputMaybe<Array<User_Filter>>;
  NOT?: InputMaybe<Array<User_Filter>>;
  OR?: InputMaybe<Array<User_Filter>>;
  active?: InputMaybe<FilterBoolean>;
  avatar?: InputMaybe<FilterString>;
  cellphone?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  email?: InputMaybe<FilterString>;
  gender?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  idCard?: InputMaybe<FilterString>;
  idCardType?: InputMaybe<FilterString>;
  language?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name?: InputMaybe<FilterString>;
  profile?: InputMaybe<FilterJson>;
  role?: InputMaybe<Role_Filter>;
  targetTenant?: InputMaybe<Tenant_Filter>;
  tenantDisplayName?: InputMaybe<FilterString>;
  twoFaseAuth?: InputMaybe<FilterBoolean>;
  version_?: InputMaybe<FilterString>;
};

export type User_OrderBy = {
  active?: InputMaybe<SortOrder>;
  avatar?: InputMaybe<SortOrder>;
  cellphone?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  email?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idCard?: InputMaybe<SortOrder>;
  idCardType?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name?: InputMaybe<SortOrder>;
  profile?: InputMaybe<SortOrder>;
  role?: InputMaybe<Role_OrderBy>;
  targetTenant?: InputMaybe<Tenant_OrderBy>;
  tenantDisplayName?: InputMaybe<SortOrder>;
  twoFaseAuth?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type User_OrderByCursor = {
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type User_UpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<UploadedFile>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  idCard?: InputMaybe<Scalars['String']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  language?: InputMaybe<Language>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
  version_: Scalars['String']['input'];
};

export type VatStatus = {
  __typename?: 'VatStatus';
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  name_en: Scalars['String']['output'];
  name_es: Scalars['String']['output'];
  name_pt: Scalars['String']['output'];
  version_: Scalars['String']['output'];
};

export type VatStatus_CreateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  name_en: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
};

export type VatStatus_Filter = {
  AND?: InputMaybe<Array<VatStatus_Filter>>;
  NOT?: InputMaybe<Array<VatStatus_Filter>>;
  OR?: InputMaybe<Array<VatStatus_Filter>>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  description_en?: InputMaybe<FilterString>;
  description_es?: InputMaybe<FilterString>;
  description_pt?: InputMaybe<FilterString>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  version_?: InputMaybe<FilterString>;
};

export type VatStatus_OrderBy = {
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  description_en?: InputMaybe<SortOrder>;
  description_es?: InputMaybe<SortOrder>;
  description_pt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
  version_?: InputMaybe<SortOrder>;
};

export type VatStatus_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type VatStatus_UpdateInput = {
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type WorkAuthor = {
  __typename?: 'WorkAuthor';
  author: AuthorComposer;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  lyricsPercentage: Scalars['Decimal']['output'];
  musicPercentage: Scalars['Decimal']['output'];
  parent_MusicalWork_authors: MusicalWork;
  publishers?: Maybe<Array<WorkAuthorPublisher>>;
  version_: Scalars['String']['output'];
};

export type WorkAuthorPublisher = {
  __typename?: 'WorkAuthorPublisher';
  autoRenewalYears?: Maybe<Scalars['Int']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  durationInYears?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  parent_WorkAuthor_publishers: WorkAuthor;
  percentage: Scalars['Decimal']['output'];
  publisher: Publisher;
  version_: Scalars['String']['output'];
};

export type WorkAuthorPublisher_CreateInput = {
  autoRenewalYears?: InputMaybe<Scalars['Int']['input']>;
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  percentage: Scalars['Decimal']['input'];
  publisherId: Scalars['String']['input'];
};

export type WorkAuthorPublisher_Filter = {
  AND?: InputMaybe<Array<WorkAuthorPublisher_Filter>>;
  NOT?: InputMaybe<Array<WorkAuthorPublisher_Filter>>;
  OR?: InputMaybe<Array<WorkAuthorPublisher_Filter>>;
  autoRenewalYears?: InputMaybe<FilterInt>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  durationInYears?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  parent_WorkAuthor_publishers?: InputMaybe<WorkAuthor_Filter>;
  percentage?: InputMaybe<FilterDecimal>;
  publisher?: InputMaybe<Publisher_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type WorkAuthorPublisher_OrderBy = {
  autoRenewalYears?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  durationInYears?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  percentage?: InputMaybe<SortOrder>;
  publisher?: InputMaybe<Publisher_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type WorkAuthorPublisher_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type WorkAuthorPublisher_UpdateInput = {
  autoRenewalYears?: InputMaybe<Scalars['Int']['input']>;
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
  publisherId?: InputMaybe<Scalars['String']['input']>;
  version_: Scalars['String']['input'];
};

export type WorkAuthor_CreateInput = {
  authorId: Scalars['String']['input'];
  lyricsPercentage: Scalars['Decimal']['input'];
  musicPercentage: Scalars['Decimal']['input'];
  publishers?: InputMaybe<Array<WorkAuthorPublisher_CreateInput>>;
};

export type WorkAuthor_Filter = {
  AND?: InputMaybe<Array<WorkAuthor_Filter>>;
  NOT?: InputMaybe<Array<WorkAuthor_Filter>>;
  OR?: InputMaybe<Array<WorkAuthor_Filter>>;
  author?: InputMaybe<AuthorComposer_Filter>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  lyricsPercentage?: InputMaybe<FilterDecimal>;
  musicPercentage?: InputMaybe<FilterDecimal>;
  parent_MusicalWork_authors?: InputMaybe<MusicalWork_Filter>;
  publishers?: InputMaybe<WorkAuthor_Publishers_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type WorkAuthor_OrderBy = {
  author?: InputMaybe<AuthorComposer_OrderBy>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  id?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  lyricsPercentage?: InputMaybe<SortOrder>;
  musicPercentage?: InputMaybe<SortOrder>;
  publishers?: InputMaybe<OrderByMultiple>;
  version_?: InputMaybe<SortOrder>;
};

export type WorkAuthor_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type WorkAuthor_UpdateInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lyricsPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  musicPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  publishers?: InputMaybe<WorkAuthor_Publishers_UpdateInput>;
  version_: Scalars['String']['input'];
};

export type WorkAuthor_Publishers_Filter = {
  every?: InputMaybe<WorkAuthorPublisher_Filter>;
  none?: InputMaybe<WorkAuthorPublisher_Filter>;
  some?: InputMaybe<WorkAuthorPublisher_Filter>;
};

export type WorkAuthor_Publishers_UpdateInput = {
  create?: InputMaybe<Array<WorkAuthorPublisher_CreateInput>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  update?: InputMaybe<Array<WorkAuthorPublisher_UpdateInput>>;
};

export type WorkerEvent = {
  __typename?: 'WorkerEvent';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  createdAt_: Scalars['DateTime']['output'];
  createdBy_: User;
  displayId: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  enqueuedAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  lastUpdatedAt_?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy_?: Maybe<User>;
  manualRetryCount: Scalars['Int']['output'];
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  payload: Scalars['Json']['output'];
  queueName: Scalars['String']['output'];
  result?: Maybe<Scalars['Json']['output']>;
  retryCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  tenant_id_?: Maybe<Scalars['String']['output']>;
  triggerUserId: User;
  version_: Scalars['String']['output'];
};

export type WorkerEventRetryInfo = {
  __typename?: 'WorkerEventRetryInfo';
  canRetry: Scalars['Boolean']['output'];
  currentValues?: Maybe<Scalars['Json']['output']>;
  editableFields: Array<Scalars['String']['output']>;
  modes: Array<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type WorkerEventRetryResult = {
  __typename?: 'WorkerEventRetryResult';
  newWorkerEventId: Scalars['ID']['output'];
};

export type WorkerEvent_Filter = {
  AND?: InputMaybe<Array<WorkerEvent_Filter>>;
  NOT?: InputMaybe<Array<WorkerEvent_Filter>>;
  OR?: InputMaybe<Array<WorkerEvent_Filter>>;
  completedAt?: InputMaybe<FilterDateTime>;
  correlationId?: InputMaybe<FilterString>;
  createdAt_?: InputMaybe<FilterDateTime>;
  createdBy_?: InputMaybe<User_Filter>;
  displayId?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterInt>;
  enqueuedAt?: InputMaybe<FilterDateTime>;
  error?: InputMaybe<FilterJson>;
  id?: InputMaybe<FilterString>;
  jobType?: InputMaybe<FilterString>;
  lastUpdatedAt_?: InputMaybe<FilterDateTime>;
  lastUpdatedBy_?: InputMaybe<User_Filter>;
  manualRetryCount?: InputMaybe<FilterInt>;
  nextRetryAt?: InputMaybe<FilterDateTime>;
  payload?: InputMaybe<FilterJson>;
  queueName?: InputMaybe<FilterString>;
  result?: InputMaybe<FilterJson>;
  retryCount?: InputMaybe<FilterInt>;
  startedAt?: InputMaybe<FilterDateTime>;
  status?: InputMaybe<FilterString>;
  triggerUserId?: InputMaybe<User_Filter>;
  version_?: InputMaybe<FilterString>;
};

export type WorkerEvent_OrderBy = {
  completedAt?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt_?: InputMaybe<SortOrder>;
  createdBy_?: InputMaybe<User_OrderBy>;
  duration?: InputMaybe<SortOrder>;
  enqueuedAt?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  jobType?: InputMaybe<SortOrder>;
  lastUpdatedAt_?: InputMaybe<SortOrder>;
  lastUpdatedBy_?: InputMaybe<User_OrderBy>;
  manualRetryCount?: InputMaybe<SortOrder>;
  nextRetryAt?: InputMaybe<SortOrder>;
  payload?: InputMaybe<SortOrder>;
  queueName?: InputMaybe<SortOrder>;
  result?: InputMaybe<SortOrder>;
  retryCount?: InputMaybe<SortOrder>;
  startedAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  triggerUserId?: InputMaybe<User_OrderBy>;
  version_?: InputMaybe<SortOrder>;
};

export type WorkerEvent_OrderByCursor = {
  id?: InputMaybe<SortOrder>;
};

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', accessToken?: string | null, refreshToken?: string | null, accessExpiresIn?: number | null, refreshExpiresIn?: number | null, twoFaRequired: boolean, twoFaAction?: string | null, tempToken?: string | null } };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'AuthenticateResponse', accessToken: string, refreshToken: string, accessExpiresIn: number, refreshExpiresIn: number } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type SaveProfileMutationVariables = Exact<{
  key: Array<Scalars['String']['input']> | Scalars['String']['input'];
  value: Scalars['Json']['input'];
}>;


export type SaveProfileMutation = { __typename?: 'Mutation', saveProfile: boolean };

export type SetMyLanguageMutationVariables = Exact<{
  language: Language;
}>;


export type SetMyLanguageMutation = { __typename?: 'Mutation', setMyLanguage: { __typename?: 'User', id: string, language: Language } };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', userChangePassword: { __typename?: 'User', id: string } };

export type UserResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserResetPasswordMutation = { __typename?: 'Mutation', userResetPassword: { __typename?: 'User', id: string } };

export type SetupTwoFaMutationVariables = Exact<{
  tempToken: Scalars['String']['input'];
}>;


export type SetupTwoFaMutation = { __typename?: 'Mutation', setupTwoFa: { __typename?: 'TwoFaSetupResponse', qrCodeDataUrl: string, secret: string, backupCodes: Array<string> } };

export type ConfirmTwoFaSetupMutationVariables = Exact<{
  tempToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConfirmTwoFaSetupMutation = { __typename?: 'Mutation', confirmTwoFaSetup: { __typename?: 'AuthenticateResponse', accessToken: string, refreshToken: string, accessExpiresIn: number, refreshExpiresIn: number } };

export type VerifyTwoFaMutationVariables = Exact<{
  tempToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VerifyTwoFaMutation = { __typename?: 'Mutation', verifyTwoFa: { __typename?: 'AuthenticateResponse', accessToken: string, refreshToken: string, accessExpiresIn: number, refreshExpiresIn: number } };

export type VerifyTwoFaBackupCodeMutationVariables = Exact<{
  tempToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  rememberDevice?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VerifyTwoFaBackupCodeMutation = { __typename?: 'Mutation', verifyTwoFaBackupCode: { __typename?: 'AuthenticateResponse', accessToken: string, refreshToken: string, accessExpiresIn: number, refreshExpiresIn: number } };

export type UpdateMyAvatarMutationVariables = Exact<{
  avatar?: InputMaybe<UploadedFile>;
}>;


export type UpdateMyAvatarMutation = { __typename?: 'Mutation', updateMyAvatar: { __typename?: 'User', id: string, avatar?: string | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null } | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, email: string, language: Language, profile?: any | null, avatar?: string | null, role?: { __typename?: 'Role', id: string, audience: string, name_es: string, name_en: string, name_pt: string, permissions?: Array<{ __typename?: 'Permission', id: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null } | null, company?: { __typename?: 'Company', id: string, name: string, logo?: string | null, extra?: any | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null } | null } | null } };

export type MyTrustedDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTrustedDevicesQuery = { __typename?: 'Query', myTrustedDevices: Array<{ __typename?: 'TrustedDeviceInfo', id: string, browserName?: string | null, browserVersion?: string | null, osName?: string | null, deviceType?: string | null, ipAddress?: string | null, lastUsedAt?: any | null, createdAt: any, expiresAt: any }> };

export type RevokeTrustedDeviceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevokeTrustedDeviceMutation = { __typename?: 'Mutation', revokeTrustedDevice: boolean };

export type RevokeAllTrustedDevicesMutationVariables = Exact<{ [key: string]: never; }>;


export type RevokeAllTrustedDevicesMutation = { __typename?: 'Mutation', revokeAllTrustedDevices: boolean };

export type DeletionBlockersQueryVariables = Exact<{
  entity: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeletionBlockersQuery = { __typename?: 'Query', deletionBlockers: { __typename?: 'DeletionBlockers', entity: string, id: string, blocked: boolean, reasons: Array<{ __typename?: 'DeletionBlockerReason', kind: string, rootEntity: string, relations: Array<string>, hiddenInTenant?: number | null, otherTenants?: number | null, visible?: { __typename?: 'DeletionBlockerVisible', count: number, items: Array<{ __typename?: 'DeletionBlockerItem', id: string, nameText?: string | null, nameI18n?: any | null }> } | null }> } };

export type FileUploadMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type FileUploadMutation = { __typename?: 'Mutation', singleUpload: { __typename?: 'UploadedFileData', ticket: string, filename: string, mimetype: string, encoding?: string | null } };

export type DeleteUploadedFileMutationVariables = Exact<{
  ticket: Scalars['String']['input'];
}>;


export type DeleteUploadedFileMutation = { __typename?: 'Mutation', deleteUploadedFile: string };

export type MarkNotificationReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkNotificationReadMutation = { __typename?: 'Mutation', markNotificationRead: { __typename?: 'UserNotificationResult', success: boolean, error?: string | null } };

export type MarkAllNotificationsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsReadMutation = { __typename?: 'Mutation', markAllNotificationsRead: number };

export type ArchiveNotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveNotificationMutation = { __typename?: 'Mutation', archiveNotification: { __typename?: 'UserNotificationResult', success: boolean, error?: string | null } };

export type PreviewThemeMutationVariables = Exact<{
  authoring: Scalars['Json']['input'];
}>;


export type PreviewThemeMutation = { __typename?: 'Mutation', previewTheme: { __typename?: 'ThemePreviewResult', warnings: Array<string> } };

export type ApplyThemeMutationVariables = Exact<{
  authoring: Scalars['Json']['input'];
  name: Scalars['String']['input'];
}>;


export type ApplyThemeMutation = { __typename?: 'Mutation', applyTheme: { __typename?: 'Theme', id: string, name: string, active: boolean } };

export type DeactivateThemeMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateThemeMutation = { __typename?: 'Mutation', deactivateTheme: boolean };

export type ListThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListThemesQuery = { __typename?: 'Query', listThemes: Array<{ __typename?: 'Theme', id: string, name: string, active: boolean, authoring: any }> };

export type SaveThemeMutationVariables = Exact<{
  authoring: Scalars['Json']['input'];
  name: Scalars['String']['input'];
}>;


export type SaveThemeMutation = { __typename?: 'Mutation', saveTheme: { __typename?: 'Theme', id: string, name: string, active: boolean } };

export type DeleteThemeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteThemeMutation = { __typename?: 'Mutation', deleteTheme: boolean };

export type WorkerEventRetryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['Json']['input']>;
}>;


export type WorkerEventRetryMutation = { __typename?: 'Mutation', workerEventRetry: { __typename?: 'WorkerEventRetryResult', newWorkerEventId: string } };

export type WorkerEventRetryInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkerEventRetryInfoQuery = { __typename?: 'Query', workerEventRetryInfo: { __typename?: 'WorkerEventRetryInfo', canRetry: boolean, reason?: string | null, modes: Array<string>, editableFields: Array<string>, currentValues?: any | null } };

export type AiSearchAutoEvalDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchAutoEvalDeleteMutation = { __typename?: 'Mutation', aiSearchAutoEvalDelete: { __typename?: 'AiSearchAutoEval', id: string } };

export type AiSearchAutoEvalOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchAutoEvalOneQuery = { __typename?: 'Query', aiSearchAutoEvalOne: { __typename?: 'AiSearchAutoEval', id: string, version_: string, runId: string, queryIndex: number, condition: string, includeSchema: boolean, includeExamples: boolean, query: string, pathType?: string | null, expectedTool: string, expectedEntity: string, actualTool?: string | null, actualEntity?: string | null, actualArgs?: any | null, l1Pass: boolean, l2Pass?: boolean | null, errorType?: string | null, totalTimeMs: number, llmCallCount: number, toolCallCount: number, tokenCount?: number | null, llmResponse?: string | null, toolCalls?: any | null, evaluatedAt: any, hadDisambiguation: boolean, disambiguationType?: string | null, disambiguationResponse?: string | null, patternsApplied?: Array<string> | null, l3Efficiency?: number | null, l4Redundancy?: number | null, l5Disambiguation?: number | null, l6ResponseQuality?: number | null, overallScore?: number | null, judgeEvaluation?: any | null, redundantCalls?: number | null, actualCallCount?: number | null, optimalCallCount?: number | null, sequenceMatchedOptimal?: boolean | null, response?: string | null } };

export type AiSearchAutoEvalListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AiSearchAutoEval_Filter>;
  orderBy?: InputMaybe<Array<AiSearchAutoEval_OrderBy> | AiSearchAutoEval_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AiSearchAutoEvalListWithOffsetQuery = { __typename?: 'Query', aiSearchAutoEvalListWithOffset: Array<{ __typename?: 'AiSearchAutoEval', id: string, version_: string, runId: string, queryIndex: number, condition: string, includeSchema: boolean, includeExamples: boolean, query: string, pathType?: string | null, expectedTool: string, expectedEntity: string, actualTool?: string | null, actualEntity?: string | null, actualArgs?: any | null, l1Pass: boolean, l2Pass?: boolean | null, errorType?: string | null, totalTimeMs: number, llmCallCount: number, toolCallCount: number, tokenCount?: number | null, llmResponse?: string | null, toolCalls?: any | null, evaluatedAt: any, hadDisambiguation: boolean, disambiguationType?: string | null, disambiguationResponse?: string | null, patternsApplied?: Array<string> | null, l3Efficiency?: number | null, l4Redundancy?: number | null, l5Disambiguation?: number | null, l6ResponseQuality?: number | null, overallScore?: number | null, judgeEvaluation?: any | null, redundantCalls?: number | null, actualCallCount?: number | null, optimalCallCount?: number | null, sequenceMatchedOptimal?: boolean | null, response?: string | null } | null> };

export type AiSearchAutoEvalListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AiSearchAutoEval_Filter>;
  orderBy: AiSearchAutoEval_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AiSearchAutoEvalListWithCursorQuery = { __typename?: 'Query', aiSearchAutoEvalListWithCursor: Array<{ __typename?: 'AiSearchAutoEval', id: string, version_: string, runId: string, queryIndex: number, condition: string, includeSchema: boolean, includeExamples: boolean, query: string, pathType?: string | null, expectedTool: string, expectedEntity: string, actualTool?: string | null, actualEntity?: string | null, actualArgs?: any | null, l1Pass: boolean, l2Pass?: boolean | null, errorType?: string | null, totalTimeMs: number, llmCallCount: number, toolCallCount: number, tokenCount?: number | null, llmResponse?: string | null, toolCalls?: any | null, evaluatedAt: any, hadDisambiguation: boolean, disambiguationType?: string | null, disambiguationResponse?: string | null, patternsApplied?: Array<string> | null, l3Efficiency?: number | null, l4Redundancy?: number | null, l5Disambiguation?: number | null, l6ResponseQuality?: number | null, overallScore?: number | null, judgeEvaluation?: any | null, redundantCalls?: number | null, actualCallCount?: number | null, optimalCallCount?: number | null, sequenceMatchedOptimal?: boolean | null, response?: string | null } | null> };

export type AiSearchConversationDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchConversationDeleteMutation = { __typename?: 'Mutation', aiSearchConversationDelete: { __typename?: 'AiSearchConversation', id: string } };

export type AiSearchConversationOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchConversationOneQuery = { __typename?: 'Query', aiSearchConversationOne: { __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null } };

export type AiSearchConversationListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AiSearchConversation_Filter>;
  orderBy?: InputMaybe<Array<AiSearchConversation_OrderBy> | AiSearchConversation_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AiSearchConversationListWithOffsetQuery = { __typename?: 'Query', aiSearchConversationListWithOffset: Array<{ __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null } | null> };

export type AiSearchConversationListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AiSearchConversation_Filter>;
  orderBy: AiSearchConversation_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AiSearchConversationListWithCursorQuery = { __typename?: 'Query', aiSearchConversationListWithCursor: Array<{ __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null } | null> };

export type AiSearchPatternCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  pattern: Scalars['String']['input'];
  pathTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  tools?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  effectiveness?: InputMaybe<Scalars['Decimal']['input']>;
  evaluationCount: Scalars['Int']['input'];
  successCount: Scalars['Int']['input'];
  sourceEvalIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  proposedBy?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiSearchPatternCreateMutation = { __typename?: 'Mutation', aiSearchPatternCreate: { __typename?: 'AiSearchPattern', id: string } };

export type AiSearchPatternUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  pattern: Scalars['String']['input'];
  pathTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  tools?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  effectiveness?: InputMaybe<Scalars['Decimal']['input']>;
  evaluationCount: Scalars['Int']['input'];
  successCount: Scalars['Int']['input'];
  sourceEvalIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  proposedBy?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiSearchPatternUpdateMutation = { __typename?: 'Mutation', aiSearchPatternUpdate: { __typename?: 'AiSearchPattern', id: string, version_: string } };

export type AiSearchPatternDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchPatternDeleteMutation = { __typename?: 'Mutation', aiSearchPatternDelete: { __typename?: 'AiSearchPattern', id: string } };

export type AiSearchPatternOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchPatternOneQuery = { __typename?: 'Query', aiSearchPatternOne: { __typename?: 'AiSearchPattern', id: string, version_: string, name: string, description: string, pattern: string, pathTypes?: Array<string> | null, tools?: Array<string> | null, effectiveness?: any | null, evaluationCount: number, successCount: number, sourceEvalIds?: Array<string> | null, proposedBy?: string | null, active: boolean, priority: number } };

export type AiSearchPatternListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AiSearchPattern_Filter>;
  orderBy?: InputMaybe<Array<AiSearchPattern_OrderBy> | AiSearchPattern_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AiSearchPatternListWithOffsetQuery = { __typename?: 'Query', aiSearchPatternListWithOffset: Array<{ __typename?: 'AiSearchPattern', id: string, version_: string, name: string, description: string, pattern: string, pathTypes?: Array<string> | null, tools?: Array<string> | null, effectiveness?: any | null, evaluationCount: number, successCount: number, sourceEvalIds?: Array<string> | null, proposedBy?: string | null, active: boolean, priority: number } | null> };

export type AiSearchPatternListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AiSearchPattern_Filter>;
  orderBy: AiSearchPattern_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AiSearchPatternListWithCursorQuery = { __typename?: 'Query', aiSearchPatternListWithCursor: Array<{ __typename?: 'AiSearchPattern', id: string, version_: string, name: string, description: string, pattern: string, pathTypes?: Array<string> | null, tools?: Array<string> | null, effectiveness?: any | null, evaluationCount: number, successCount: number, sourceEvalIds?: Array<string> | null, proposedBy?: string | null, active: boolean, priority: number } | null> };

export type AiSearchResponseCreateMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
  query: Scalars['String']['input'];
  response: Scalars['String']['input'];
  sources?: InputMaybe<Scalars['Json']['input']>;
  explanation?: InputMaybe<Scalars['Json']['input']>;
  tokenUsage?: InputMaybe<Scalars['Json']['input']>;
  rating?: InputMaybe<EvaluationRating>;
  evaluatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  evaluatedById?: InputMaybe<Scalars['String']['input']>;
  toolCalls: Array<AiSearchToolCall_CreateInput> | AiSearchToolCall_CreateInput;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiSearchResponseCreateMutation = { __typename?: 'Mutation', aiSearchResponseCreate: { __typename?: 'AiSearchResponse', id: string } };

export type AiSearchResponseDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchResponseDeleteMutation = { __typename?: 'Mutation', aiSearchResponseDelete: { __typename?: 'AiSearchResponse', id: string } };

export type AiSearchResponseOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchResponseOneQuery = { __typename?: 'Query', aiSearchResponseOne: { __typename?: 'AiSearchResponse', id: string, version_: string, query: string, response: string, sources?: any | null, explanation?: any | null, tokenUsage?: any | null, createdAt: any, rating?: EvaluationRating | null, evaluatedAt?: any | null, conversation: { __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null }, evaluatedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, toolCalls: Array<{ __typename?: 'AiSearchToolCall', id: string, version_: string, sequence: number, toolName: string, pattern?: string | null, navigationPath?: string | null, toolArguments: any, result?: any | null, durationMs: number, success: boolean, errorMessage?: string | null }> } };

export type AiSearchResponseListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AiSearchResponse_Filter>;
  orderBy?: InputMaybe<Array<AiSearchResponse_OrderBy> | AiSearchResponse_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AiSearchResponseListWithOffsetQuery = { __typename?: 'Query', aiSearchResponseListWithOffset: Array<{ __typename?: 'AiSearchResponse', id: string, version_: string, query: string, response: string, sources?: any | null, explanation?: any | null, tokenUsage?: any | null, createdAt: any, rating?: EvaluationRating | null, evaluatedAt?: any | null, conversation: { __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null }, evaluatedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, toolCalls: Array<{ __typename?: 'AiSearchToolCall', id: string, version_: string, sequence: number, toolName: string, pattern?: string | null, navigationPath?: string | null, toolArguments: any, result?: any | null, durationMs: number, success: boolean, errorMessage?: string | null }> } | null> };

export type AiSearchResponseListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AiSearchResponse_Filter>;
  orderBy: AiSearchResponse_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AiSearchResponseListWithCursorQuery = { __typename?: 'Query', aiSearchResponseListWithCursor: Array<{ __typename?: 'AiSearchResponse', id: string, version_: string, query: string, response: string, sources?: any | null, explanation?: any | null, tokenUsage?: any | null, createdAt: any, rating?: EvaluationRating | null, evaluatedAt?: any | null, conversation: { __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null }, evaluatedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, toolCalls: Array<{ __typename?: 'AiSearchToolCall', id: string, version_: string, sequence: number, toolName: string, pattern?: string | null, navigationPath?: string | null, toolArguments: any, result?: any | null, durationMs: number, success: boolean, errorMessage?: string | null }> } | null> };

export type AiSearchToolCallOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiSearchToolCallOneQuery = { __typename?: 'Query', aiSearchToolCallOne: { __typename?: 'AiSearchToolCall', id: string, version_: string, sequence: number, toolName: string, pattern?: string | null, navigationPath?: string | null, toolArguments: any, result?: any | null, durationMs: number, success: boolean, errorMessage?: string | null } };

export type AiSearchToolCallListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AiSearchToolCall_Filter>;
  orderBy?: InputMaybe<Array<AiSearchToolCall_OrderBy> | AiSearchToolCall_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AiSearchToolCallListWithOffsetQuery = { __typename?: 'Query', aiSearchToolCallListWithOffset: Array<{ __typename?: 'AiSearchToolCall', id: string, version_: string, sequence: number, toolName: string, pattern?: string | null, navigationPath?: string | null, toolArguments: any, result?: any | null, durationMs: number, success: boolean, errorMessage?: string | null } | null> };

export type AiSearchToolCallListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AiSearchToolCall_Filter>;
  orderBy: AiSearchToolCall_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AiSearchToolCallListWithCursorQuery = { __typename?: 'Query', aiSearchToolCallListWithCursor: Array<{ __typename?: 'AiSearchToolCall', id: string, version_: string, sequence: number, toolName: string, pattern?: string | null, navigationPath?: string | null, toolArguments: any, result?: any | null, durationMs: number, success: boolean, errorMessage?: string | null } | null> };

export type AlertRuleCreateMutationVariables = Exact<{
  alertType: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  params?: InputMaybe<Scalars['Json']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlertRuleCreateMutation = { __typename?: 'Mutation', alertRuleCreate: { __typename?: 'AlertRule', id: string } };

export type AlertRuleUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  alertType: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  params?: InputMaybe<Scalars['Json']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlertRuleUpdateMutation = { __typename?: 'Mutation', alertRuleUpdate: { __typename?: 'AlertRule', id: string, version_: string } };

export type AlertRuleDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AlertRuleDeleteMutation = { __typename?: 'Mutation', alertRuleDelete: { __typename?: 'AlertRule', id: string } };

export type AlertRuleOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AlertRuleOneQuery = { __typename?: 'Query', alertRuleOne: { __typename?: 'AlertRule', id: string, version_: string, alertType: string, enabled: boolean, params?: any | null } };

export type AlertRuleListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AlertRule_Filter>;
  orderBy?: InputMaybe<Array<AlertRule_OrderBy> | AlertRule_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AlertRuleListWithOffsetQuery = { __typename?: 'Query', alertRuleListWithOffset: Array<{ __typename?: 'AlertRule', id: string, version_: string, alertType: string, enabled: boolean, params?: any | null } | null> };

export type AlertRuleListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AlertRule_Filter>;
  orderBy: AlertRule_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AlertRuleListWithCursorQuery = { __typename?: 'Query', alertRuleListWithCursor: Array<{ __typename?: 'AlertRule', id: string, version_: string, alertType: string, enabled: boolean, params?: any | null } | null> };

export type AlertSubscriptionCreateMutationVariables = Exact<{
  alertRuleId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlertSubscriptionCreateMutation = { __typename?: 'Mutation', alertSubscriptionCreate: { __typename?: 'AlertSubscription', id: string } };

export type AlertSubscriptionUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  alertRuleId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlertSubscriptionUpdateMutation = { __typename?: 'Mutation', alertSubscriptionUpdate: { __typename?: 'AlertSubscription', id: string, version_: string } };

export type AlertSubscriptionDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AlertSubscriptionDeleteMutation = { __typename?: 'Mutation', alertSubscriptionDelete: { __typename?: 'AlertSubscription', id: string } };

export type AlertSubscriptionOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AlertSubscriptionOneQuery = { __typename?: 'Query', alertSubscriptionOne: { __typename?: 'AlertSubscription', id: string, version_: string, enabled: boolean, alertRule: { __typename?: 'AlertRule', id: string, version_: string, alertType: string, enabled: boolean, params?: any | null } } };

export type AlertSubscriptionListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AlertSubscription_Filter>;
  orderBy?: InputMaybe<Array<AlertSubscription_OrderBy> | AlertSubscription_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AlertSubscriptionListWithOffsetQuery = { __typename?: 'Query', alertSubscriptionListWithOffset: Array<{ __typename?: 'AlertSubscription', id: string, version_: string, enabled: boolean, alertRule: { __typename?: 'AlertRule', id: string, version_: string, alertType: string, enabled: boolean, params?: any | null } } | null> };

export type AlertSubscriptionListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AlertSubscription_Filter>;
  orderBy: AlertSubscription_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AlertSubscriptionListWithCursorQuery = { __typename?: 'Query', alertSubscriptionListWithCursor: Array<{ __typename?: 'AlertSubscription', id: string, version_: string, enabled: boolean, alertRule: { __typename?: 'AlertRule', id: string, version_: string, alertType: string, enabled: boolean, params?: any | null } } | null> };

export type AssociatedDocumentEditionOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AssociatedDocumentEditionOneQuery = { __typename?: 'Query', associatedDocumentEditionOne: { __typename?: 'AssociatedDocumentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type?: { __typename?: 'EditionDocumentType', id: string, version_: string, name: string } | null } };

export type AssociatedDocumentEditionListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AssociatedDocumentEdition_Filter>;
  orderBy?: InputMaybe<Array<AssociatedDocumentEdition_OrderBy> | AssociatedDocumentEdition_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AssociatedDocumentEditionListWithOffsetQuery = { __typename?: 'Query', associatedDocumentEditionListWithOffset: Array<{ __typename?: 'AssociatedDocumentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type?: { __typename?: 'EditionDocumentType', id: string, version_: string, name: string } | null } | null> };

export type AssociatedDocumentEditionListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AssociatedDocumentEdition_Filter>;
  orderBy: AssociatedDocumentEdition_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AssociatedDocumentEditionListWithCursorQuery = { __typename?: 'Query', associatedDocumentEditionListWithCursor: Array<{ __typename?: 'AssociatedDocumentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type?: { __typename?: 'EditionDocumentType', id: string, version_: string, name: string } | null } | null> };

export type AssociatedDocumentSignedEditionOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AssociatedDocumentSignedEditionOneQuery = { __typename?: 'Query', associatedDocumentSignedEditionOne: { __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } };

export type AssociatedDocumentSignedEditionListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AssociatedDocumentSignedEdition_Filter>;
  orderBy?: InputMaybe<Array<AssociatedDocumentSignedEdition_OrderBy> | AssociatedDocumentSignedEdition_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AssociatedDocumentSignedEditionListWithOffsetQuery = { __typename?: 'Query', associatedDocumentSignedEditionListWithOffset: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } | null> };

export type AssociatedDocumentSignedEditionListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AssociatedDocumentSignedEdition_Filter>;
  orderBy: AssociatedDocumentSignedEdition_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AssociatedDocumentSignedEditionListWithCursorQuery = { __typename?: 'Query', associatedDocumentSignedEditionListWithCursor: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } | null> };

export type AuthorCollectingSocietyOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AuthorCollectingSocietyOneQuery = { __typename?: 'Query', authorCollectingSocietyOne: { __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> } };

export type AuthorCollectingSocietyListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AuthorCollectingSociety_Filter>;
  orderBy?: InputMaybe<Array<AuthorCollectingSociety_OrderBy> | AuthorCollectingSociety_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AuthorCollectingSocietyListWithOffsetQuery = { __typename?: 'Query', authorCollectingSocietyListWithOffset: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> } | null> };

export type AuthorCollectingSocietyListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AuthorCollectingSociety_Filter>;
  orderBy: AuthorCollectingSociety_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AuthorCollectingSocietyListWithCursorQuery = { __typename?: 'Query', authorCollectingSocietyListWithCursor: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> } | null> };

export type AuthorComposerCreateMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  taxIdType?: InputMaybe<TaxIdType>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  aka?: InputMaybe<Scalars['String']['input']>;
  ipi?: InputMaybe<Scalars['String']['input']>;
  managementSocieties?: InputMaybe<Array<AuthorCollectingSociety_CreateInput> | AuthorCollectingSociety_CreateInput>;
  publishers?: InputMaybe<Array<AuthorPublisher_CreateInput> | AuthorPublisher_CreateInput>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthorComposerCreateMutation = { __typename?: 'Mutation', authorComposerCreate: { __typename?: 'AuthorComposer', id: string } };

export type AuthorComposerUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  taxIdType?: InputMaybe<TaxIdType>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  aka?: InputMaybe<Scalars['String']['input']>;
  ipi?: InputMaybe<Scalars['String']['input']>;
  managementSocieties?: InputMaybe<AuthorComposer_ManagementSocieties_UpdateInput>;
  publishers?: InputMaybe<AuthorComposer_Publishers_UpdateInput>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthorComposerUpdateMutation = { __typename?: 'Mutation', authorComposerUpdate: { __typename?: 'AuthorComposer', id: string, version_: string } };

export type AuthorComposerDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AuthorComposerDeleteMutation = { __typename?: 'Mutation', authorComposerDelete: { __typename?: 'AuthorComposer', id: string } };

export type AuthorComposerOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AuthorComposerOneQuery = { __typename?: 'Query', authorComposerOne: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null } };

export type AuthorComposerListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AuthorComposer_Filter>;
  orderBy?: InputMaybe<Array<AuthorComposer_OrderBy> | AuthorComposer_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AuthorComposerListWithOffsetQuery = { __typename?: 'Query', authorComposerListWithOffset: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null } | null> };

export type AuthorComposerListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AuthorComposer_Filter>;
  orderBy: AuthorComposer_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AuthorComposerListWithCursorQuery = { __typename?: 'Query', authorComposerListWithCursor: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null } | null> };

export type AuthorComposerPublicCreateMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  taxIdType?: InputMaybe<TaxIdType>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  aka?: InputMaybe<Scalars['String']['input']>;
  ipi?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthorComposerPublicCreateMutation = { __typename?: 'Mutation', authorComposerPublicCreate: { __typename?: 'AuthorComposerPublic', id: string } };

export type AuthorComposerPublicUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  taxIdType?: InputMaybe<TaxIdType>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  aka?: InputMaybe<Scalars['String']['input']>;
  ipi?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthorComposerPublicUpdateMutation = { __typename?: 'Mutation', authorComposerPublicUpdate: { __typename?: 'AuthorComposerPublic', id: string, version_: string } };

export type AuthorComposerPublicDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AuthorComposerPublicDeleteMutation = { __typename?: 'Mutation', authorComposerPublicDelete: { __typename?: 'AuthorComposerPublic', id: string } };

export type AuthorComposerPublicOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AuthorComposerPublicOneQuery = { __typename?: 'Query', authorComposerPublicOne: { __typename?: 'AuthorComposerPublic', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null } };

export type AuthorComposerPublicListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AuthorComposer_Filter>;
  orderBy?: InputMaybe<Array<AuthorComposer_OrderBy> | AuthorComposer_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AuthorComposerPublicListWithOffsetQuery = { __typename?: 'Query', authorComposerPublicListWithOffset: Array<{ __typename?: 'AuthorComposerPublic', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null } | null> };

export type AuthorComposerPublicListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AuthorComposer_Filter>;
  orderBy: AuthorComposer_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AuthorComposerPublicListWithCursorQuery = { __typename?: 'Query', authorComposerPublicListWithCursor: Array<{ __typename?: 'AuthorComposerPublic', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null } | null> };

export type AuthorPublisherOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AuthorPublisherOneQuery = { __typename?: 'Query', authorPublisherOne: { __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } };

export type AuthorPublisherListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<AuthorPublisher_Filter>;
  orderBy?: InputMaybe<Array<AuthorPublisher_OrderBy> | AuthorPublisher_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AuthorPublisherListWithOffsetQuery = { __typename?: 'Query', authorPublisherListWithOffset: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } | null> };

export type AuthorPublisherListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<AuthorPublisher_Filter>;
  orderBy: AuthorPublisher_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type AuthorPublisherListWithCursorQuery = { __typename?: 'Query', authorPublisherListWithCursor: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } | null> };

export type BotErrorOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BotErrorOneQuery = { __typename?: 'Query', botErrorOne: { __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } };

export type BotErrorListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<BotError_Filter>;
  orderBy?: InputMaybe<Array<BotError_OrderBy> | BotError_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type BotErrorListWithOffsetQuery = { __typename?: 'Query', botErrorListWithOffset: Array<{ __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type BotErrorListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<BotError_Filter>;
  orderBy: BotError_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type BotErrorListWithCursorQuery = { __typename?: 'Query', botErrorListWithCursor: Array<{ __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type BotPhaseOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BotPhaseOneQuery = { __typename?: 'Query', botPhaseOne: { __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } };

export type BotPhaseListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<BotPhase_Filter>;
  orderBy?: InputMaybe<Array<BotPhase_OrderBy> | BotPhase_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type BotPhaseListWithOffsetQuery = { __typename?: 'Query', botPhaseListWithOffset: Array<{ __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } | null> };

export type BotPhaseListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<BotPhase_Filter>;
  orderBy: BotPhase_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type BotPhaseListWithCursorQuery = { __typename?: 'Query', botPhaseListWithCursor: Array<{ __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } | null> };

export type BotRunCancelMutationVariables = Exact<{
  botRunId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BotRunCancelMutation = { __typename?: 'Mutation', botRunCancel: string };

export type BotRunDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BotRunDeleteMutation = { __typename?: 'Mutation', botRunDelete: { __typename?: 'BotRun', id: string } };

export type BotRunOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BotRunOneQuery = { __typename?: 'Query', botRunOne: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null, workerEvent?: { __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } } | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null }, cancellationRequestedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, phases?: Array<{ __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null }> | null, errors?: Array<{ __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } };

export type BotRunListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<BotRun_Filter>;
  orderBy?: InputMaybe<Array<BotRun_OrderBy> | BotRun_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type BotRunListWithOffsetQuery = { __typename?: 'Query', botRunListWithOffset: Array<{ __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null, workerEvent?: { __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } } | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null }, cancellationRequestedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, phases?: Array<{ __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null }> | null, errors?: Array<{ __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } | null> };

export type BotRunListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<BotRun_Filter>;
  orderBy: BotRun_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type BotRunListWithCursorQuery = { __typename?: 'Query', botRunListWithCursor: Array<{ __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null, workerEvent?: { __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } } | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null }, cancellationRequestedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, phases?: Array<{ __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null }> | null, errors?: Array<{ __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } | null> };

export type BotStepOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BotStepOneQuery = { __typename?: 'Query', botStepOne: { __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } };

export type BotStepListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<BotStep_Filter>;
  orderBy?: InputMaybe<Array<BotStep_OrderBy> | BotStep_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type BotStepListWithOffsetQuery = { __typename?: 'Query', botStepListWithOffset: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type BotStepListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<BotStep_Filter>;
  orderBy: BotStep_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type BotStepListWithCursorQuery = { __typename?: 'Query', botStepListWithCursor: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type CollectiveManagementSocietyCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  acronym: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CollectiveManagementSocietyCreateMutation = { __typename?: 'Mutation', collectiveManagementSocietyCreate: { __typename?: 'CollectiveManagementSociety', id: string } };

export type CollectiveManagementSocietyUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  acronym: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CollectiveManagementSocietyUpdateMutation = { __typename?: 'Mutation', collectiveManagementSocietyUpdate: { __typename?: 'CollectiveManagementSociety', id: string, version_: string } };

export type CollectiveManagementSocietyDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CollectiveManagementSocietyDeleteMutation = { __typename?: 'Mutation', collectiveManagementSocietyDelete: { __typename?: 'CollectiveManagementSociety', id: string } };

export type CollectiveManagementSocietyOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CollectiveManagementSocietyOneQuery = { __typename?: 'Query', collectiveManagementSocietyOne: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } };

export type CollectiveManagementSocietyListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<CollectiveManagementSociety_Filter>;
  orderBy?: InputMaybe<Array<CollectiveManagementSociety_OrderBy> | CollectiveManagementSociety_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type CollectiveManagementSocietyListWithOffsetQuery = { __typename?: 'Query', collectiveManagementSocietyListWithOffset: Array<{ __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null> };

export type CollectiveManagementSocietyListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<CollectiveManagementSociety_Filter>;
  orderBy: CollectiveManagementSociety_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type CollectiveManagementSocietyListWithCursorQuery = { __typename?: 'Query', collectiveManagementSocietyListWithCursor: Array<{ __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null> };

export type ContractObservationCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  observation: Scalars['String']['input'];
  requireAll?: InputMaybe<Scalars['Boolean']['input']>;
  authorsIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  publishersIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContractObservationCreateMutation = { __typename?: 'Mutation', contractObservationCreate: { __typename?: 'ContractObservation', id: string } };

export type ContractObservationUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  title: Scalars['String']['input'];
  observation: Scalars['String']['input'];
  requireAll?: InputMaybe<Scalars['Boolean']['input']>;
  authorsIds?: InputMaybe<InputMultipleRef>;
  publishersIds?: InputMaybe<InputMultipleRef>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContractObservationUpdateMutation = { __typename?: 'Mutation', contractObservationUpdate: { __typename?: 'ContractObservation', id: string, version_: string } };

export type ContractObservationDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ContractObservationDeleteMutation = { __typename?: 'Mutation', contractObservationDelete: { __typename?: 'ContractObservation', id: string } };

export type ContractObservationOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ContractObservationOneQuery = { __typename?: 'Query', contractObservationOne: { __typename?: 'ContractObservation', id: string, version_: string, title: string, observation: string, requireAll?: boolean | null, authors?: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }> | null, publishers?: Array<{ __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null }> | null } };

export type ContractObservationListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<ContractObservation_Filter>;
  orderBy?: InputMaybe<Array<ContractObservation_OrderBy> | ContractObservation_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type ContractObservationListWithOffsetQuery = { __typename?: 'Query', contractObservationListWithOffset: Array<{ __typename?: 'ContractObservation', id: string, version_: string, title: string, observation: string, requireAll?: boolean | null, authors?: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }> | null, publishers?: Array<{ __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null }> | null } | null> };

export type ContractObservationListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<ContractObservation_Filter>;
  orderBy: ContractObservation_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type ContractObservationListWithCursorQuery = { __typename?: 'Query', contractObservationListWithCursor: Array<{ __typename?: 'ContractObservation', id: string, version_: string, title: string, observation: string, requireAll?: boolean | null, authors?: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }> | null, publishers?: Array<{ __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null }> | null } | null> };

export type CountryCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  code: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  demonym_es?: InputMaybe<Scalars['String']['input']>;
  demonym_en?: InputMaybe<Scalars['String']['input']>;
  demonym_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CountryCreateMutation = { __typename?: 'Mutation', countryCreate: { __typename?: 'Country', id: string } };

export type CountryUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  code: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  demonym_es?: InputMaybe<Scalars['String']['input']>;
  demonym_en?: InputMaybe<Scalars['String']['input']>;
  demonym_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CountryUpdateMutation = { __typename?: 'Mutation', countryUpdate: { __typename?: 'Country', id: string, version_: string } };

export type CountryDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CountryDeleteMutation = { __typename?: 'Mutation', countryDelete: { __typename?: 'Country', id: string } };

export type CountryOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CountryOneQuery = { __typename?: 'Query', countryOne: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } };

export type CountryListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Country_Filter>;
  orderBy?: InputMaybe<Array<Country_OrderBy> | Country_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type CountryListWithOffsetQuery = { __typename?: 'Query', countryListWithOffset: Array<{ __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null> };

export type CountryListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Country_Filter>;
  orderBy: Country_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type CountryListWithCursorQuery = { __typename?: 'Query', countryListWithCursor: Array<{ __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null> };

export type CreditAccountUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  tierId?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreditAccountUpdateMutation = { __typename?: 'Mutation', creditAccountUpdate: { __typename?: 'CreditAccount', id: string, version_: string } };

export type CreditAccountOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreditAccountOneQuery = { __typename?: 'Query', creditAccountOne: { __typename?: 'CreditAccount', id: string, version_: string, balance: number, tier?: { __typename?: 'CreditTier', id: string, version_: string, name_es: string, name_en: string, name_pt: string, monthlyCredits: number, pricePerCredit: any, pricePerExtraCredit: any, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, movements?: Array<{ __typename?: 'CreditMovement', id: string, version_: string, type: CreditMovementType, delta: number, balanceAfter: number, movementAt: any, detail: string, editionKey?: string | null, editionName?: string | null, purchase?: { __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null } | null }> | null } };

export type CreditAccountListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<CreditAccount_Filter>;
  orderBy?: InputMaybe<Array<CreditAccount_OrderBy> | CreditAccount_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type CreditAccountListWithOffsetQuery = { __typename?: 'Query', creditAccountListWithOffset: Array<{ __typename?: 'CreditAccount', id: string, version_: string, balance: number, tier?: { __typename?: 'CreditTier', id: string, version_: string, name_es: string, name_en: string, name_pt: string, monthlyCredits: number, pricePerCredit: any, pricePerExtraCredit: any, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, movements?: Array<{ __typename?: 'CreditMovement', id: string, version_: string, type: CreditMovementType, delta: number, balanceAfter: number, movementAt: any, detail: string, editionKey?: string | null, editionName?: string | null, purchase?: { __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null } | null }> | null } | null> };

export type CreditAccountListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<CreditAccount_Filter>;
  orderBy: CreditAccount_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type CreditAccountListWithCursorQuery = { __typename?: 'Query', creditAccountListWithCursor: Array<{ __typename?: 'CreditAccount', id: string, version_: string, balance: number, tier?: { __typename?: 'CreditTier', id: string, version_: string, name_es: string, name_en: string, name_pt: string, monthlyCredits: number, pricePerCredit: any, pricePerExtraCredit: any, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, movements?: Array<{ __typename?: 'CreditMovement', id: string, version_: string, type: CreditMovementType, delta: number, balanceAfter: number, movementAt: any, detail: string, editionKey?: string | null, editionName?: string | null, purchase?: { __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null } | null }> | null } | null> };

export type CreditMovementOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreditMovementOneQuery = { __typename?: 'Query', creditMovementOne: { __typename?: 'CreditMovement', id: string, version_: string, type: CreditMovementType, delta: number, balanceAfter: number, movementAt: any, detail: string, editionKey?: string | null, editionName?: string | null, purchase?: { __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null, tenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null } };

export type CreditMovementListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<CreditMovement_Filter>;
  orderBy?: InputMaybe<Array<CreditMovement_OrderBy> | CreditMovement_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type CreditMovementListWithOffsetQuery = { __typename?: 'Query', creditMovementListWithOffset: Array<{ __typename?: 'CreditMovement', id: string, version_: string, type: CreditMovementType, delta: number, balanceAfter: number, movementAt: any, detail: string, editionKey?: string | null, editionName?: string | null, purchase?: { __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null, tenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null } | null> };

export type CreditMovementListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<CreditMovement_Filter>;
  orderBy: CreditMovement_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type CreditMovementListWithCursorQuery = { __typename?: 'Query', creditMovementListWithCursor: Array<{ __typename?: 'CreditMovement', id: string, version_: string, type: CreditMovementType, delta: number, balanceAfter: number, movementAt: any, detail: string, editionKey?: string | null, editionName?: string | null, purchase?: { __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null, tenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null } | null> };

export type CreditPurchaseCreateMutationVariables = Exact<{
  tenantId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  purchaseDate: Scalars['Date']['input'];
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreditPurchaseCreateMutation = { __typename?: 'Mutation', creditPurchaseCreate: { __typename?: 'CreditPurchase', id: string } };

export type CreditPurchaseDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreditPurchaseDeleteMutation = { __typename?: 'Mutation', creditPurchaseDelete: { __typename?: 'CreditPurchase', id: string } };

export type CreditPurchaseOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreditPurchaseOneQuery = { __typename?: 'Query', creditPurchaseOne: { __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null, tenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } };

export type CreditPurchaseListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<CreditPurchase_Filter>;
  orderBy?: InputMaybe<Array<CreditPurchase_OrderBy> | CreditPurchase_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type CreditPurchaseListWithOffsetQuery = { __typename?: 'Query', creditPurchaseListWithOffset: Array<{ __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null, tenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null> };

export type CreditPurchaseListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<CreditPurchase_Filter>;
  orderBy: CreditPurchase_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type CreditPurchaseListWithCursorQuery = { __typename?: 'Query', creditPurchaseListWithCursor: Array<{ __typename?: 'CreditPurchase', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null, tenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null> };

export type MyCreditPurchasesOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MyCreditPurchasesOneQuery = { __typename?: 'Query', myCreditPurchasesOne: { __typename?: 'MyCreditPurchases', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null } };

export type MyCreditPurchasesListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<CreditPurchase_Filter>;
  orderBy?: InputMaybe<Array<CreditPurchase_OrderBy> | CreditPurchase_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type MyCreditPurchasesListWithOffsetQuery = { __typename?: 'Query', myCreditPurchasesListWithOffset: Array<{ __typename?: 'MyCreditPurchases', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null } | null> };

export type MyCreditPurchasesListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<CreditPurchase_Filter>;
  orderBy: CreditPurchase_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type MyCreditPurchasesListWithCursorQuery = { __typename?: 'Query', myCreditPurchasesListWithCursor: Array<{ __typename?: 'MyCreditPurchases', id: string, version_: string, quantity: number, purchaseDate: string, expirationDate?: string | null, unitPrice?: any | null, notes?: string | null } | null> };

export type CreditTierCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  monthlyCredits: Scalars['Int']['input'];
  pricePerCredit: Scalars['Decimal']['input'];
  pricePerExtraCredit: Scalars['Decimal']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreditTierCreateMutation = { __typename?: 'Mutation', creditTierCreate: { __typename?: 'CreditTier', id: string } };

export type CreditTierUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  monthlyCredits: Scalars['Int']['input'];
  pricePerCredit: Scalars['Decimal']['input'];
  pricePerExtraCredit: Scalars['Decimal']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreditTierUpdateMutation = { __typename?: 'Mutation', creditTierUpdate: { __typename?: 'CreditTier', id: string, version_: string } };

export type CreditTierDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreditTierDeleteMutation = { __typename?: 'Mutation', creditTierDelete: { __typename?: 'CreditTier', id: string } };

export type CreditTierOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreditTierOneQuery = { __typename?: 'Query', creditTierOne: { __typename?: 'CreditTier', id: string, version_: string, name_es: string, name_en: string, name_pt: string, monthlyCredits: number, pricePerCredit: any, pricePerExtraCredit: any, description_es?: string | null, description_en?: string | null, description_pt?: string | null } };

export type CreditTierListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<CreditTier_Filter>;
  orderBy?: InputMaybe<Array<CreditTier_OrderBy> | CreditTier_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type CreditTierListWithOffsetQuery = { __typename?: 'Query', creditTierListWithOffset: Array<{ __typename?: 'CreditTier', id: string, version_: string, name_es: string, name_en: string, name_pt: string, monthlyCredits: number, pricePerCredit: any, pricePerExtraCredit: any, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null> };

export type CreditTierListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<CreditTier_Filter>;
  orderBy: CreditTier_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type CreditTierListWithCursorQuery = { __typename?: 'Query', creditTierListWithCursor: Array<{ __typename?: 'CreditTier', id: string, version_: string, name_es: string, name_en: string, name_pt: string, monthlyCredits: number, pricePerCredit: any, pricePerExtraCredit: any, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null> };

export type CurrencyCreateMutationVariables = Exact<{
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrencyCreateMutation = { __typename?: 'Mutation', currencyCreate: { __typename?: 'Currency', id: string } };

export type CurrencyUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrencyUpdateMutation = { __typename?: 'Mutation', currencyUpdate: { __typename?: 'Currency', id: string, version_: string } };

export type CurrencyDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CurrencyDeleteMutation = { __typename?: 'Mutation', currencyDelete: { __typename?: 'Currency', id: string } };

export type CurrencyOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CurrencyOneQuery = { __typename?: 'Query', currencyOne: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } };

export type CurrencyListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Currency_Filter>;
  orderBy?: InputMaybe<Array<Currency_OrderBy> | Currency_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type CurrencyListWithOffsetQuery = { __typename?: 'Query', currencyListWithOffset: Array<{ __typename?: 'Currency', id: string, version_: string, code: string, name: string } | null> };

export type CurrencyListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Currency_Filter>;
  orderBy: Currency_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type CurrencyListWithCursorQuery = { __typename?: 'Query', currencyListWithCursor: Array<{ __typename?: 'Currency', id: string, version_: string, code: string, name: string } | null> };

export type DashboardLayoutTemplateCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  forRole?: InputMaybe<Scalars['String']['input']>;
  widgets: Scalars['Json']['input'];
  isDefault: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  isForAllTenants: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardLayoutTemplateCreateMutation = { __typename?: 'Mutation', dashboardLayoutTemplateCreate: { __typename?: 'DashboardLayoutTemplate', id: string } };

export type DashboardLayoutTemplateUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  forRole?: InputMaybe<Scalars['String']['input']>;
  widgets: Scalars['Json']['input'];
  isDefault: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  isForAllTenants: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardLayoutTemplateUpdateMutation = { __typename?: 'Mutation', dashboardLayoutTemplateUpdate: { __typename?: 'DashboardLayoutTemplate', id: string, version_: string } };

export type DashboardLayoutTemplateDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DashboardLayoutTemplateDeleteMutation = { __typename?: 'Mutation', dashboardLayoutTemplateDelete: { __typename?: 'DashboardLayoutTemplate', id: string } };

export type DashboardLayoutTemplateOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DashboardLayoutTemplateOneQuery = { __typename?: 'Query', dashboardLayoutTemplateOne: { __typename?: 'DashboardLayoutTemplate', id: string, version_: string, name: string, forRole?: string | null, widgets: any, isDefault: boolean, enabled: boolean, isForAllTenants: boolean } };

export type DashboardLayoutTemplateListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<DashboardLayoutTemplate_Filter>;
  orderBy?: InputMaybe<Array<DashboardLayoutTemplate_OrderBy> | DashboardLayoutTemplate_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type DashboardLayoutTemplateListWithOffsetQuery = { __typename?: 'Query', dashboardLayoutTemplateListWithOffset: Array<{ __typename?: 'DashboardLayoutTemplate', id: string, version_: string, name: string, forRole?: string | null, widgets: any, isDefault: boolean, enabled: boolean, isForAllTenants: boolean } | null> };

export type DashboardLayoutTemplateListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<DashboardLayoutTemplate_Filter>;
  orderBy: DashboardLayoutTemplate_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type DashboardLayoutTemplateListWithCursorQuery = { __typename?: 'Query', dashboardLayoutTemplateListWithCursor: Array<{ __typename?: 'DashboardLayoutTemplate', id: string, version_: string, name: string, forRole?: string | null, widgets: any, isDefault: boolean, enabled: boolean, isForAllTenants: boolean } | null> };

export type DashboardWidgetOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DashboardWidgetOneQuery = { __typename?: 'Query', dashboardWidgetOne: { __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } };

export type DashboardWidgetListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<DashboardWidget_Filter>;
  orderBy?: InputMaybe<Array<DashboardWidget_OrderBy> | DashboardWidget_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type DashboardWidgetListWithOffsetQuery = { __typename?: 'Query', dashboardWidgetListWithOffset: Array<{ __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } | null> };

export type DashboardWidgetListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<DashboardWidget_Filter>;
  orderBy: DashboardWidget_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type DashboardWidgetListWithCursorQuery = { __typename?: 'Query', dashboardWidgetListWithCursor: Array<{ __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } | null> };

export type DesignShowcaseCreateMutationVariables = Exact<{
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  status: ShowcaseStatus;
  categoryId: Scalars['String']['input'];
  relatedCategoriesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  appliedStatuses?: InputMaybe<Array<ShowcaseStatus> | ShowcaseStatus>;
  quantity: Scalars['Int']['input'];
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  amount: Scalars['Decimal']['input'];
  ratio?: InputMaybe<Scalars['Decimal']['input']>;
  startDate: Scalars['Date']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  active: Scalars['Boolean']['input'];
  highlighted: Scalars['Boolean']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<UploadedFile>;
  anyFile?: InputMaybe<UploadedFile>;
  avatar?: InputMaybe<UploadedFile>;
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<ShowcaseLine_CreateInput> | ShowcaseLine_CreateInput>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type DesignShowcaseCreateMutation = { __typename?: 'Mutation', designShowcaseCreate: { __typename?: 'DesignShowcase', id: string } };

export type DesignShowcaseUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ShowcaseStatus>;
  categoryId: Scalars['String']['input'];
  relatedCategoriesIds?: InputMaybe<InputMultipleRef>;
  appliedStatuses?: InputMaybe<Array<ShowcaseStatus> | ShowcaseStatus>;
  quantity: Scalars['Int']['input'];
  durationInYears?: InputMaybe<Scalars['Int']['input']>;
  amount: Scalars['Decimal']['input'];
  ratio?: InputMaybe<Scalars['Decimal']['input']>;
  startDate: Scalars['Date']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  active: Scalars['Boolean']['input'];
  highlighted: Scalars['Boolean']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<UploadedFile>;
  anyFile?: InputMaybe<UploadedFile>;
  avatar?: InputMaybe<UploadedFile>;
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<DesignShowcase_Lines_UpdateInput>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type DesignShowcaseUpdateMutation = { __typename?: 'Mutation', designShowcaseUpdate: { __typename?: 'DesignShowcase', id: string, version_: string } };

export type DesignShowcaseDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DesignShowcaseDeleteMutation = { __typename?: 'Mutation', designShowcaseDelete: { __typename?: 'DesignShowcase', id: string } };

export type DesignShowcaseOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DesignShowcaseOneQuery = { __typename?: 'Query', designShowcaseOne: { __typename?: 'DesignShowcase', id: string, version_: string, code: string, name: string, summary?: string | null, status: ShowcaseStatus, appliedStatuses?: Array<ShowcaseStatus> | null, quantity: number, durationInYears?: number | null, amount: any, ratio?: any | null, startDate: string, expiresAt?: any | null, registeredAt?: any | null, active: boolean, highlighted: boolean, phone?: string | null, taxId?: string | null, attachment?: string | null, anyFile?: string | null, avatar?: string | null, keywords?: Array<string> | null, body?: string | null, metadata?: any | null, internalNote?: string | null, apiKeyHasValue: boolean, serverLabel?: string | null, lifecycle_transitions_: Array<string>, category: { __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string }, relatedCategories?: Array<{ __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string }> | null, lifecycle: { __typename?: 'ShowcaseWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, attachment_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, anyFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, lines?: Array<{ __typename?: 'ShowcaseLine', id: string, version_: string, concept: string, quantity: number, unitPrice: any, note?: string | null }> | null } };

export type DesignShowcaseListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<DesignShowcase_Filter>;
  orderBy?: InputMaybe<Array<DesignShowcase_OrderBy> | DesignShowcase_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type DesignShowcaseListWithOffsetQuery = { __typename?: 'Query', designShowcaseListWithOffset: Array<{ __typename?: 'DesignShowcase', id: string, version_: string, code: string, name: string, summary?: string | null, status: ShowcaseStatus, appliedStatuses?: Array<ShowcaseStatus> | null, quantity: number, durationInYears?: number | null, amount: any, ratio?: any | null, startDate: string, expiresAt?: any | null, registeredAt?: any | null, active: boolean, highlighted: boolean, phone?: string | null, taxId?: string | null, attachment?: string | null, anyFile?: string | null, avatar?: string | null, keywords?: Array<string> | null, body?: string | null, metadata?: any | null, internalNote?: string | null, serverLabel?: string | null, lifecycle_transitions_: Array<string>, category: { __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string }, relatedCategories?: Array<{ __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string }> | null, lifecycle: { __typename?: 'ShowcaseWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, attachment_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, anyFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, lines?: Array<{ __typename?: 'ShowcaseLine', id: string, version_: string, concept: string, quantity: number, unitPrice: any, note?: string | null }> | null } | null> };

export type DesignShowcaseListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<DesignShowcase_Filter>;
  orderBy: DesignShowcase_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type DesignShowcaseListWithCursorQuery = { __typename?: 'Query', designShowcaseListWithCursor: Array<{ __typename?: 'DesignShowcase', id: string, version_: string, code: string, name: string, summary?: string | null, status: ShowcaseStatus, appliedStatuses?: Array<ShowcaseStatus> | null, quantity: number, durationInYears?: number | null, amount: any, ratio?: any | null, startDate: string, expiresAt?: any | null, registeredAt?: any | null, active: boolean, highlighted: boolean, phone?: string | null, taxId?: string | null, attachment?: string | null, anyFile?: string | null, avatar?: string | null, keywords?: Array<string> | null, body?: string | null, metadata?: any | null, internalNote?: string | null, serverLabel?: string | null, lifecycle_transitions_: Array<string>, category: { __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string }, relatedCategories?: Array<{ __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string }> | null, lifecycle: { __typename?: 'ShowcaseWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, attachment_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, anyFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, lines?: Array<{ __typename?: 'ShowcaseLine', id: string, version_: string, concept: string, quantity: number, unitPrice: any, note?: string | null }> | null } | null> };

export type DocumentGenerationParamsCreateMutationVariables = Exact<{
  contractEffectiveDate: Scalars['Date']['input'];
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentGenerationParamsCreateMutation = { __typename?: 'Mutation', documentGenerationParamsCreate: { __typename?: 'DocumentGenerationParams', id: string } };

export type DocumentGenerationParamsUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  contractEffectiveDate: Scalars['Date']['input'];
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentGenerationParamsUpdateMutation = { __typename?: 'Mutation', documentGenerationParamsUpdate: { __typename?: 'DocumentGenerationParams', id: string, version_: string } };

export type DocumentGenerationParamsDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DocumentGenerationParamsDeleteMutation = { __typename?: 'Mutation', documentGenerationParamsDelete: { __typename?: 'DocumentGenerationParams', id: string } };

export type DocumentGenerationParamsOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DocumentGenerationParamsOneQuery = { __typename?: 'Query', documentGenerationParamsOne: { __typename?: 'DocumentGenerationParams', id: string, version_: string, contractEffectiveDate: string, contractEndDate?: string | null } };

export type DocumentGenerationParamsListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<DocumentGenerationParams_Filter>;
  orderBy?: InputMaybe<Array<DocumentGenerationParams_OrderBy> | DocumentGenerationParams_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type DocumentGenerationParamsListWithOffsetQuery = { __typename?: 'Query', documentGenerationParamsListWithOffset: Array<{ __typename?: 'DocumentGenerationParams', id: string, version_: string, contractEffectiveDate: string, contractEndDate?: string | null } | null> };

export type DocumentGenerationParamsListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<DocumentGenerationParams_Filter>;
  orderBy: DocumentGenerationParams_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type DocumentGenerationParamsListWithCursorQuery = { __typename?: 'Query', documentGenerationParamsListWithCursor: Array<{ __typename?: 'DocumentGenerationParams', id: string, version_: string, contractEffectiveDate: string, contractEndDate?: string | null } | null> };

export type EditionSignatureStatusQueryVariables = Exact<{
  editionId: Scalars['String']['input'];
}>;


export type EditionSignatureStatusQuery = { __typename?: 'Query', editionSignatureStatus: Array<{ __typename?: 'ContractSignatureStatus', editionDocumentationId: string, contractNumber: string, contractName: string, documentType?: string | null, documentStatus?: string | null, signaturePhase?: string | null, recipients: Array<{ __typename?: 'RecipientSignatureStatus', name: string, email: string, role: string, order?: number | null, status: string, signedAt?: any | null }> }> };

export type RecheckEditionSignaturesMutationVariables = Exact<{
  editionId: Scalars['ID']['input'];
}>;


export type RecheckEditionSignaturesMutation = { __typename?: 'Mutation', recheckEditionSignatures: { __typename?: 'EditionSignatureCheckResult', status: string, signedEditionId?: string | null, reason?: string | null, pendingDocs: Array<{ __typename?: 'EditionSignaturePendingDoc', contractNumber?: string | null, signatureFoundButUnlinked: boolean }> } };

export type ResendSignatureEmailMutationVariables = Exact<{
  editionDocumentationId: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
}>;


export type ResendSignatureEmailMutation = { __typename?: 'Mutation', resendSignatureEmail: boolean };

export type EditionCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  editionTypeId: Scalars['String']['input'];
  contentType: EditionContentType;
  publicationLink?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
  worksIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  userAttachments?: InputMaybe<Array<UserAttachmentEdition_CreateInput> | UserAttachmentEdition_CreateInput>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditionCreateMutation = { __typename?: 'Mutation', editionCreate: { __typename?: 'Edition', id: string } };

export type EditionUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  editionTypeId: Scalars['String']['input'];
  contentType?: InputMaybe<EditionContentType>;
  publicationLink?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
  worksIds?: InputMaybe<InputMultipleRef>;
  notes?: InputMaybe<Scalars['String']['input']>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  userAttachments?: InputMaybe<Edition_UserAttachments_UpdateInput>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditionUpdateMutation = { __typename?: 'Mutation', editionUpdate: { __typename?: 'Edition', id: string, version_: string } };

export type EditionDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionDeleteMutation = { __typename?: 'Mutation', editionDelete: { __typename?: 'Edition', id: string } };

export type EditionOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionOneQuery = { __typename?: 'Query', editionOne: { __typename?: 'Edition', id: string, version_: string, documentationLastOperationalError?: string | null, publicationDate?: string | null, ejemplarPdf?: string | null, name: string, contentType: EditionContentType, publicationLink?: string | null, editionNumber: number, price: any, notes?: string | null, dndaExpedienteNumber?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, documentationState_transitions_: Array<string>, documentationState: { __typename?: 'EditionDocumentationWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, editionType: { __typename?: 'EditionType', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, pseudonym?: string | null, name: string } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null }>, documentation?: Array<{ __typename?: 'EditionDocumentation', id: string, version_: string, authorsDisplay?: string | null, publisherConfiguration?: string | null, publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber: string, documentName?: string | null, finalDocumentPdf?: string | null, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }>, territories?: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null, authors?: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null, publishers?: Array<{ __typename?: 'EditionContractPublisher', id: string, version_: string, percentage: any, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null, finalDocumentPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null, associatedDocuments?: Array<{ __typename?: 'AssociatedDocumentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type?: { __typename?: 'EditionDocumentType', id: string, version_: string, name: string } | null }> | null, userAttachments?: Array<{ __typename?: 'UserAttachmentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null } };

export type EditionListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Edition_Filter>;
  orderBy?: InputMaybe<Array<Edition_OrderBy> | Edition_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EditionListWithOffsetQuery = { __typename?: 'Query', editionListWithOffset: Array<{ __typename?: 'Edition', id: string, version_: string, documentationLastOperationalError?: string | null, publicationDate?: string | null, ejemplarPdf?: string | null, name: string, contentType: EditionContentType, publicationLink?: string | null, editionNumber: number, price: any, notes?: string | null, dndaExpedienteNumber?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, documentationState_transitions_: Array<string>, documentationState: { __typename?: 'EditionDocumentationWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, editionType: { __typename?: 'EditionType', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, pseudonym?: string | null, name: string } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null }>, documentation?: Array<{ __typename?: 'EditionDocumentation', id: string, version_: string, authorsDisplay?: string | null, publisherConfiguration?: string | null, publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber: string, documentName?: string | null, finalDocumentPdf?: string | null, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }>, territories?: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null, authors?: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null, publishers?: Array<{ __typename?: 'EditionContractPublisher', id: string, version_: string, percentage: any, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null, finalDocumentPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null, associatedDocuments?: Array<{ __typename?: 'AssociatedDocumentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type?: { __typename?: 'EditionDocumentType', id: string, version_: string, name: string } | null }> | null, userAttachments?: Array<{ __typename?: 'UserAttachmentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null } | null> };

export type EditionListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Edition_Filter>;
  orderBy: Edition_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EditionListWithCursorQuery = { __typename?: 'Query', editionListWithCursor: Array<{ __typename?: 'Edition', id: string, version_: string, documentationLastOperationalError?: string | null, publicationDate?: string | null, ejemplarPdf?: string | null, name: string, contentType: EditionContentType, publicationLink?: string | null, editionNumber: number, price: any, notes?: string | null, dndaExpedienteNumber?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, documentationState_transitions_: Array<string>, documentationState: { __typename?: 'EditionDocumentationWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, editionType: { __typename?: 'EditionType', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, pseudonym?: string | null, name: string } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null }>, documentation?: Array<{ __typename?: 'EditionDocumentation', id: string, version_: string, authorsDisplay?: string | null, publisherConfiguration?: string | null, publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber: string, documentName?: string | null, finalDocumentPdf?: string | null, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }>, territories?: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null, authors?: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null, publishers?: Array<{ __typename?: 'EditionContractPublisher', id: string, version_: string, percentage: any, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null, finalDocumentPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null, associatedDocuments?: Array<{ __typename?: 'AssociatedDocumentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type?: { __typename?: 'EditionDocumentType', id: string, version_: string, name: string } | null }> | null, userAttachments?: Array<{ __typename?: 'UserAttachmentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null } | null> };

export type EditionContractPublisherOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionContractPublisherOneQuery = { __typename?: 'Query', editionContractPublisherOne: { __typename?: 'EditionContractPublisher', id: string, version_: string, percentage: any, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } };

export type EditionContractPublisherListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EditionContractPublisher_Filter>;
  orderBy?: InputMaybe<Array<EditionContractPublisher_OrderBy> | EditionContractPublisher_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EditionContractPublisherListWithOffsetQuery = { __typename?: 'Query', editionContractPublisherListWithOffset: Array<{ __typename?: 'EditionContractPublisher', id: string, version_: string, percentage: any, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } | null> };

export type EditionContractPublisherListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EditionContractPublisher_Filter>;
  orderBy: EditionContractPublisher_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EditionContractPublisherListWithCursorQuery = { __typename?: 'Query', editionContractPublisherListWithCursor: Array<{ __typename?: 'EditionContractPublisher', id: string, version_: string, percentage: any, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } | null> };

export type EditionDocumentTypeCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditionDocumentTypeCreateMutation = { __typename?: 'Mutation', editionDocumentTypeCreate: { __typename?: 'EditionDocumentType', id: string } };

export type EditionDocumentTypeUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditionDocumentTypeUpdateMutation = { __typename?: 'Mutation', editionDocumentTypeUpdate: { __typename?: 'EditionDocumentType', id: string, version_: string } };

export type EditionDocumentTypeDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionDocumentTypeDeleteMutation = { __typename?: 'Mutation', editionDocumentTypeDelete: { __typename?: 'EditionDocumentType', id: string } };

export type EditionDocumentTypeOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionDocumentTypeOneQuery = { __typename?: 'Query', editionDocumentTypeOne: { __typename?: 'EditionDocumentType', id: string, version_: string, name: string } };

export type EditionDocumentTypeListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EditionDocumentType_Filter>;
  orderBy?: InputMaybe<Array<EditionDocumentType_OrderBy> | EditionDocumentType_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EditionDocumentTypeListWithOffsetQuery = { __typename?: 'Query', editionDocumentTypeListWithOffset: Array<{ __typename?: 'EditionDocumentType', id: string, version_: string, name: string } | null> };

export type EditionDocumentTypeListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EditionDocumentType_Filter>;
  orderBy: EditionDocumentType_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EditionDocumentTypeListWithCursorQuery = { __typename?: 'Query', editionDocumentTypeListWithCursor: Array<{ __typename?: 'EditionDocumentType', id: string, version_: string, name: string } | null> };

export type EditionDocumentationOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionDocumentationOneQuery = { __typename?: 'Query', editionDocumentationOne: { __typename?: 'EditionDocumentation', id: string, version_: string, authorsDisplay?: string | null, publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber: string, documentName?: string | null, finalDocumentPdf?: string | null, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null }>, finalDocumentPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } };

export type EditionDocumentationListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EditionDocumentation_Filter>;
  orderBy?: InputMaybe<Array<EditionDocumentation_OrderBy> | EditionDocumentation_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EditionDocumentationListWithOffsetQuery = { __typename?: 'Query', editionDocumentationListWithOffset: Array<{ __typename?: 'EditionDocumentation', id: string, version_: string, authorsDisplay?: string | null, publisherConfiguration?: string | null, publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber: string, documentName?: string | null, finalDocumentPdf?: string | null, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, pseudonym?: string | null, name: string } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null }>, territories?: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null, authors?: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }> | null, publishers?: Array<{ __typename?: 'EditionContractPublisher', id: string, version_: string, percentage: any, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null, finalDocumentPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type EditionDocumentationListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EditionDocumentation_Filter>;
  orderBy: EditionDocumentation_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EditionDocumentationListWithCursorQuery = { __typename?: 'Query', editionDocumentationListWithCursor: Array<{ __typename?: 'EditionDocumentation', id: string, version_: string, authorsDisplay?: string | null, publisherConfiguration?: string | null, publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber: string, documentName?: string | null, finalDocumentPdf?: string | null, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, pseudonym?: string | null, name: string } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null }>, territories?: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null, authors?: Array<{ __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }> | null, publishers?: Array<{ __typename?: 'EditionContractPublisher', id: string, version_: string, percentage: any, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null, finalDocumentPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type EditionDocumentationWorkflowStateCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditionDocumentationWorkflowStateCreateMutation = { __typename?: 'Mutation', editionDocumentationWorkflowStateCreate: { __typename?: 'EditionDocumentationWorkflowState', id: string } };

export type EditionDocumentationWorkflowStateUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditionDocumentationWorkflowStateUpdateMutation = { __typename?: 'Mutation', editionDocumentationWorkflowStateUpdate: { __typename?: 'EditionDocumentationWorkflowState', id: string, version_: string } };

export type EditionDocumentationWorkflowStateDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflowStateDeleteMutation = { __typename?: 'Mutation', editionDocumentationWorkflowStateDelete: { __typename?: 'EditionDocumentationWorkflowState', id: string } };

export type EditionDocumentationWorkflowStateOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflowStateOneQuery = { __typename?: 'Query', editionDocumentationWorkflowStateOne: { __typename?: 'EditionDocumentationWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } };

export type EditionDocumentationWorkflowStateListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EditionDocumentationWorkflowState_Filter>;
  orderBy?: InputMaybe<Array<EditionDocumentationWorkflowState_OrderBy> | EditionDocumentationWorkflowState_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EditionDocumentationWorkflowStateListWithOffsetQuery = { __typename?: 'Query', editionDocumentationWorkflowStateListWithOffset: Array<{ __typename?: 'EditionDocumentationWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type EditionDocumentationWorkflowStateListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EditionDocumentationWorkflowState_Filter>;
  orderBy: EditionDocumentationWorkflowState_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EditionDocumentationWorkflowStateListWithCursorQuery = { __typename?: 'Query', editionDocumentationWorkflowStateListWithCursor: Array<{ __typename?: 'EditionDocumentationWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type EditionTypeCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditionTypeCreateMutation = { __typename?: 'Mutation', editionTypeCreate: { __typename?: 'EditionType', id: string } };

export type EditionTypeUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditionTypeUpdateMutation = { __typename?: 'Mutation', editionTypeUpdate: { __typename?: 'EditionType', id: string, version_: string } };

export type EditionTypeDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionTypeDeleteMutation = { __typename?: 'Mutation', editionTypeDelete: { __typename?: 'EditionType', id: string } };

export type EditionTypeOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditionTypeOneQuery = { __typename?: 'Query', editionTypeOne: { __typename?: 'EditionType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } };

export type EditionTypeListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EditionType_Filter>;
  orderBy?: InputMaybe<Array<EditionType_OrderBy> | EditionType_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EditionTypeListWithOffsetQuery = { __typename?: 'Query', editionTypeListWithOffset: Array<{ __typename?: 'EditionType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type EditionTypeListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EditionType_Filter>;
  orderBy: EditionType_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EditionTypeListWithCursorQuery = { __typename?: 'Query', editionTypeListWithCursor: Array<{ __typename?: 'EditionType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type EmailVerificationCreateMutationVariables = Exact<{
  email: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailVerificationCreateMutation = { __typename?: 'Mutation', emailVerificationCreate: { __typename?: 'EmailVerification', id: string } };

export type EmailVerificationUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  email: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailVerificationUpdateMutation = { __typename?: 'Mutation', emailVerificationUpdate: { __typename?: 'EmailVerification', id: string, version_: string } };

export type EmailVerificationDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmailVerificationDeleteMutation = { __typename?: 'Mutation', emailVerificationDelete: { __typename?: 'EmailVerification', id: string } };

export type EmailVerificationOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EmailVerificationOneQuery = { __typename?: 'Query', emailVerificationOne: { __typename?: 'EmailVerification', id: string, version_: string, email: string, status: EmailVerificationStatus, scope?: EmailVerificationScope | null, expiresAt: any, sentAt?: any | null, verifiedAt?: any | null, sentCount: number, lastSentAt?: any | null, sourceEntity?: string | null, sourceRecordId?: string | null, validationChanges?: any | null, validationSubmittedAt?: any | null, requestedBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } };

export type EmailVerificationListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EmailVerification_Filter>;
  orderBy?: InputMaybe<Array<EmailVerification_OrderBy> | EmailVerification_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EmailVerificationListWithOffsetQuery = { __typename?: 'Query', emailVerificationListWithOffset: Array<{ __typename?: 'EmailVerification', id: string, version_: string, email: string, status: EmailVerificationStatus, scope?: EmailVerificationScope | null, expiresAt: any, sentAt?: any | null, verifiedAt?: any | null, sentCount: number, lastSentAt?: any | null, sourceEntity?: string | null, sourceRecordId?: string | null, validationChanges?: any | null, validationSubmittedAt?: any | null, requestedBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } | null> };

export type EmailVerificationListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EmailVerification_Filter>;
  orderBy: EmailVerification_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EmailVerificationListWithCursorQuery = { __typename?: 'Query', emailVerificationListWithCursor: Array<{ __typename?: 'EmailVerification', id: string, version_: string, email: string, status: EmailVerificationStatus, scope?: EmailVerificationScope | null, expiresAt: any, sentAt?: any | null, verifiedAt?: any | null, sentCount: number, lastSentAt?: any | null, sourceEntity?: string | null, sourceRecordId?: string | null, validationChanges?: any | null, validationSubmittedAt?: any | null, requestedBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } | null> };

export type EsignatureConfigCreateMutationVariables = Exact<{
  provider: EsignatureProvider;
  credentials: Scalars['Json']['input'];
  sandboxMode: Scalars['Boolean']['input'];
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EsignatureConfigCreateMutation = { __typename?: 'Mutation', esignatureConfigCreate: { __typename?: 'EsignatureConfig', id: string } };

export type EsignatureConfigUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  provider?: InputMaybe<EsignatureProvider>;
  credentials: Scalars['Json']['input'];
  sandboxMode: Scalars['Boolean']['input'];
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EsignatureConfigUpdateMutation = { __typename?: 'Mutation', esignatureConfigUpdate: { __typename?: 'EsignatureConfig', id: string, version_: string } };

export type EsignatureConfigOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EsignatureConfigOneQuery = { __typename?: 'Query', esignatureConfigOne: { __typename?: 'EsignatureConfig', id: string, version_: string, provider: EsignatureProvider, credentials: any, sandboxMode: boolean, webhookSecret?: string | null, enabled: boolean } };

export type EsignatureConfigListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EsignatureConfig_Filter>;
  orderBy?: InputMaybe<Array<EsignatureConfig_OrderBy> | EsignatureConfig_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EsignatureConfigListWithOffsetQuery = { __typename?: 'Query', esignatureConfigListWithOffset: Array<{ __typename?: 'EsignatureConfig', id: string, version_: string, provider: EsignatureProvider, credentials: any, sandboxMode: boolean, webhookSecret?: string | null, enabled: boolean } | null> };

export type EsignatureConfigListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EsignatureConfig_Filter>;
  orderBy: EsignatureConfig_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EsignatureConfigListWithCursorQuery = { __typename?: 'Query', esignatureConfigListWithCursor: Array<{ __typename?: 'EsignatureConfig', id: string, version_: string, provider: EsignatureProvider, credentials: any, sandboxMode: boolean, webhookSecret?: string | null, enabled: boolean } | null> };

export type EsignatureDocumentOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EsignatureDocumentOneQuery = { __typename?: 'Query', esignatureDocumentOne: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, recipients: Array<{ __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } }> } };

export type EsignatureDocumentListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EsignatureDocument_Filter>;
  orderBy?: InputMaybe<Array<EsignatureDocument_OrderBy> | EsignatureDocument_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EsignatureDocumentListWithOffsetQuery = { __typename?: 'Query', esignatureDocumentListWithOffset: Array<{ __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, recipients: Array<{ __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } }> } | null> };

export type EsignatureDocumentListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EsignatureDocument_Filter>;
  orderBy: EsignatureDocument_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EsignatureDocumentListWithCursorQuery = { __typename?: 'Query', esignatureDocumentListWithCursor: Array<{ __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, recipients: Array<{ __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } }> } | null> };

export type EsignatureRecipientOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EsignatureRecipientOneQuery = { __typename?: 'Query', esignatureRecipientOne: { __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, recipients: Array<{ __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } }> } } };

export type EsignatureRecipientListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EsignatureRecipient_Filter>;
  orderBy?: InputMaybe<Array<EsignatureRecipient_OrderBy> | EsignatureRecipient_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EsignatureRecipientListWithOffsetQuery = { __typename?: 'Query', esignatureRecipientListWithOffset: Array<{ __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, recipients: Array<{ __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } }> } } | null> };

export type EsignatureRecipientListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EsignatureRecipient_Filter>;
  orderBy: EsignatureRecipient_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EsignatureRecipientListWithCursorQuery = { __typename?: 'Query', esignatureRecipientListWithCursor: Array<{ __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, recipients: Array<{ __typename?: 'EsignatureRecipient', id: string, version_: string, email: string, name: string, role: string, order: number, status: EsignatureRecipientStatus, signedAt?: any | null, document: { __typename?: 'EsignatureDocument', id: string, version_: string, externalId: string, provider: EsignatureProvider, name: string, status: EsignatureDocumentStatus, sentAt?: any | null, completedAt?: any | null, signedDocument?: string | null, sourceEntityType?: string | null, sourceEntityId?: string | null, signedDocument_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } }> } } | null> };

export type EsignatureWebhookEventOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EsignatureWebhookEventOneQuery = { __typename?: 'Query', esignatureWebhookEventOne: { __typename?: 'EsignatureWebhookEvent', id: string, version_: string, provider: EsignatureProvider, externalEventId: string, eventType: string, documentExternalId?: string | null, processedAt?: any | null, error?: string | null } };

export type EsignatureWebhookEventListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EsignatureWebhookEvent_Filter>;
  orderBy?: InputMaybe<Array<EsignatureWebhookEvent_OrderBy> | EsignatureWebhookEvent_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EsignatureWebhookEventListWithOffsetQuery = { __typename?: 'Query', esignatureWebhookEventListWithOffset: Array<{ __typename?: 'EsignatureWebhookEvent', id: string, version_: string, provider: EsignatureProvider, externalEventId: string, eventType: string, documentExternalId?: string | null, processedAt?: any | null, error?: string | null } | null> };

export type EsignatureWebhookEventListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EsignatureWebhookEvent_Filter>;
  orderBy: EsignatureWebhookEvent_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EsignatureWebhookEventListWithCursorQuery = { __typename?: 'Query', esignatureWebhookEventListWithCursor: Array<{ __typename?: 'EsignatureWebhookEvent', id: string, version_: string, provider: EsignatureProvider, externalEventId: string, eventType: string, documentExternalId?: string | null, processedAt?: any | null, error?: string | null } | null> };

export type EvaluationQueryCreateMutationVariables = Exact<{
  query: Scalars['String']['input'];
  pathType: EvaluationPathType;
  difficulty: EvaluationDifficulty;
  expectedTool: Scalars['String']['input'];
  expectedArgs: Scalars['Json']['input'];
  acceptableTools: Scalars['Json']['input'];
  expectedResponsePattern?: InputMaybe<Scalars['String']['input']>;
  generatedFrom: Scalars['Json']['input'];
  isAmbiguous: Scalars['Boolean']['input'];
  ambiguityType?: InputMaybe<EvaluationAmbiguityType>;
  disambiguationResponse?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EvaluationQueryCreateMutation = { __typename?: 'Mutation', evaluationQueryCreate: { __typename?: 'EvaluationQuery', id: string } };

export type EvaluationQueryUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  query: Scalars['String']['input'];
  pathType?: InputMaybe<EvaluationPathType>;
  difficulty?: InputMaybe<EvaluationDifficulty>;
  expectedTool: Scalars['String']['input'];
  expectedArgs: Scalars['Json']['input'];
  acceptableTools: Scalars['Json']['input'];
  expectedResponsePattern?: InputMaybe<Scalars['String']['input']>;
  generatedFrom: Scalars['Json']['input'];
  isAmbiguous: Scalars['Boolean']['input'];
  ambiguityType?: InputMaybe<EvaluationAmbiguityType>;
  disambiguationResponse?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type EvaluationQueryUpdateMutation = { __typename?: 'Mutation', evaluationQueryUpdate: { __typename?: 'EvaluationQuery', id: string, version_: string } };

export type EvaluationQueryDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EvaluationQueryDeleteMutation = { __typename?: 'Mutation', evaluationQueryDelete: { __typename?: 'EvaluationQuery', id: string } };

export type EvaluationQueryOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EvaluationQueryOneQuery = { __typename?: 'Query', evaluationQueryOne: { __typename?: 'EvaluationQuery', id: string, version_: string, query: string, pathType: EvaluationPathType, difficulty: EvaluationDifficulty, expectedTool: string, expectedArgs: any, acceptableTools: any, expectedResponsePattern?: string | null, generatedFrom: any, isAmbiguous: boolean, ambiguityType?: EvaluationAmbiguityType | null, disambiguationResponse?: string | null, notes?: string | null } };

export type EvaluationQueryListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<EvaluationQuery_Filter>;
  orderBy?: InputMaybe<Array<EvaluationQuery_OrderBy> | EvaluationQuery_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type EvaluationQueryListWithOffsetQuery = { __typename?: 'Query', evaluationQueryListWithOffset: Array<{ __typename?: 'EvaluationQuery', id: string, version_: string, query: string, pathType: EvaluationPathType, difficulty: EvaluationDifficulty, expectedTool: string, expectedArgs: any, acceptableTools: any, expectedResponsePattern?: string | null, generatedFrom: any, isAmbiguous: boolean, ambiguityType?: EvaluationAmbiguityType | null, disambiguationResponse?: string | null, notes?: string | null } | null> };

export type EvaluationQueryListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<EvaluationQuery_Filter>;
  orderBy: EvaluationQuery_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type EvaluationQueryListWithCursorQuery = { __typename?: 'Query', evaluationQueryListWithCursor: Array<{ __typename?: 'EvaluationQuery', id: string, version_: string, query: string, pathType: EvaluationPathType, difficulty: EvaluationDifficulty, expectedTool: string, expectedArgs: any, acceptableTools: any, expectedResponsePattern?: string | null, generatedFrom: any, isAmbiguous: boolean, ambiguityType?: EvaluationAmbiguityType | null, disambiguationResponse?: string | null, notes?: string | null } | null> };

export type GrossReceiptsStatusCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type GrossReceiptsStatusCreateMutation = { __typename?: 'Mutation', grossReceiptsStatusCreate: { __typename?: 'GrossReceiptsStatus', id: string } };

export type GrossReceiptsStatusUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type GrossReceiptsStatusUpdateMutation = { __typename?: 'Mutation', grossReceiptsStatusUpdate: { __typename?: 'GrossReceiptsStatus', id: string, version_: string } };

export type GrossReceiptsStatusDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GrossReceiptsStatusDeleteMutation = { __typename?: 'Mutation', grossReceiptsStatusDelete: { __typename?: 'GrossReceiptsStatus', id: string } };

export type GrossReceiptsStatusOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GrossReceiptsStatusOneQuery = { __typename?: 'Query', grossReceiptsStatusOne: { __typename?: 'GrossReceiptsStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } };

export type GrossReceiptsStatusListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<GrossReceiptsStatus_Filter>;
  orderBy?: InputMaybe<Array<GrossReceiptsStatus_OrderBy> | GrossReceiptsStatus_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type GrossReceiptsStatusListWithOffsetQuery = { __typename?: 'Query', grossReceiptsStatusListWithOffset: Array<{ __typename?: 'GrossReceiptsStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null> };

export type GrossReceiptsStatusListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<GrossReceiptsStatus_Filter>;
  orderBy: GrossReceiptsStatus_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type GrossReceiptsStatusListWithCursorQuery = { __typename?: 'Query', grossReceiptsStatusListWithCursor: Array<{ __typename?: 'GrossReceiptsStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null> };

export type InterpreterCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type InterpreterCreateMutation = { __typename?: 'Mutation', interpreterCreate: { __typename?: 'Interpreter', id: string } };

export type InterpreterUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type InterpreterUpdateMutation = { __typename?: 'Mutation', interpreterUpdate: { __typename?: 'Interpreter', id: string, version_: string } };

export type InterpreterDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type InterpreterDeleteMutation = { __typename?: 'Mutation', interpreterDelete: { __typename?: 'Interpreter', id: string } };

export type InterpreterOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type InterpreterOneQuery = { __typename?: 'Query', interpreterOne: { __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null } };

export type InterpreterListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Interpreter_Filter>;
  orderBy?: InputMaybe<Array<Interpreter_OrderBy> | Interpreter_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type InterpreterListWithOffsetQuery = { __typename?: 'Query', interpreterListWithOffset: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null } | null> };

export type InterpreterListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Interpreter_Filter>;
  orderBy: Interpreter_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type InterpreterListWithCursorQuery = { __typename?: 'Query', interpreterListWithCursor: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null } | null> };

export type LlmProviderCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
  requiresApiKey: Scalars['Boolean']['input'];
  requiresBaseUrl: Scalars['Boolean']['input'];
  defaultModels: Array<Scalars['String']['input']> | Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type LlmProviderCreateMutation = { __typename?: 'Mutation', llmProviderCreate: { __typename?: 'LlmProvider', id: string } };

export type LlmProviderUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
  requiresApiKey: Scalars['Boolean']['input'];
  requiresBaseUrl: Scalars['Boolean']['input'];
  defaultModels?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type LlmProviderUpdateMutation = { __typename?: 'Mutation', llmProviderUpdate: { __typename?: 'LlmProvider', id: string, version_: string } };

export type LlmProviderDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LlmProviderDeleteMutation = { __typename?: 'Mutation', llmProviderDelete: { __typename?: 'LlmProvider', id: string } };

export type LlmProviderOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LlmProviderOneQuery = { __typename?: 'Query', llmProviderOne: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } };

export type LlmProviderListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<LlmProvider_Filter>;
  orderBy?: InputMaybe<Array<LlmProvider_OrderBy> | LlmProvider_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type LlmProviderListWithOffsetQuery = { __typename?: 'Query', llmProviderListWithOffset: Array<{ __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null> };

export type LlmProviderListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<LlmProvider_Filter>;
  orderBy: LlmProvider_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type LlmProviderListWithCursorQuery = { __typename?: 'Query', llmProviderListWithCursor: Array<{ __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null> };

export type MusicalGenreCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type MusicalGenreCreateMutation = { __typename?: 'Mutation', musicalGenreCreate: { __typename?: 'MusicalGenre', id: string } };

export type MusicalGenreUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type MusicalGenreUpdateMutation = { __typename?: 'Mutation', musicalGenreUpdate: { __typename?: 'MusicalGenre', id: string, version_: string } };

export type MusicalGenreDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MusicalGenreDeleteMutation = { __typename?: 'Mutation', musicalGenreDelete: { __typename?: 'MusicalGenre', id: string } };

export type MusicalGenreOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MusicalGenreOneQuery = { __typename?: 'Query', musicalGenreOne: { __typename?: 'MusicalGenre', id: string, version_: string, name: string } };

export type MusicalGenreListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<MusicalGenre_Filter>;
  orderBy?: InputMaybe<Array<MusicalGenre_OrderBy> | MusicalGenre_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type MusicalGenreListWithOffsetQuery = { __typename?: 'Query', musicalGenreListWithOffset: Array<{ __typename?: 'MusicalGenre', id: string, version_: string, name: string } | null> };

export type MusicalGenreListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<MusicalGenre_Filter>;
  orderBy: MusicalGenre_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type MusicalGenreListWithCursorQuery = { __typename?: 'Query', musicalGenreListWithCursor: Array<{ __typename?: 'MusicalGenre', id: string, version_: string, name: string } | null> };

export type MusicalWorkCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  musicalGenreId: Scalars['String']['input'];
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  authors: Array<WorkAuthor_CreateInput> | WorkAuthor_CreateInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  performersIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  territoriesIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  iswc?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<UploadedFile>;
  phonograms?: InputMaybe<Array<Phonogram_CreateInput> | Phonogram_CreateInput>;
  originalLyrics?: InputMaybe<Scalars['String']['input']>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type MusicalWorkCreateMutation = { __typename?: 'Mutation', musicalWorkCreate: { __typename?: 'MusicalWork', id: string } };

export type MusicalWorkUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  title: Scalars['String']['input'];
  musicalGenreId: Scalars['String']['input'];
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  authors: MusicalWork_Authors_UpdateInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  performersIds?: InputMaybe<InputMultipleRef>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  territoriesIds?: InputMaybe<InputMultipleRef>;
  iswc?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<UploadedFile>;
  phonograms?: InputMaybe<MusicalWork_Phonograms_UpdateInput>;
  originalLyrics?: InputMaybe<Scalars['String']['input']>;
  contractObservation?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type MusicalWorkUpdateMutation = { __typename?: 'Mutation', musicalWorkUpdate: { __typename?: 'MusicalWork', id: string, version_: string } };

export type MusicalWorkDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MusicalWorkDeleteMutation = { __typename?: 'Mutation', musicalWorkDelete: { __typename?: 'MusicalWork', id: string } };

export type MusicalWorkOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MusicalWorkOneQuery = { __typename?: 'Query', musicalWorkOne: { __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null } };

export type MusicalWorkListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<MusicalWork_Filter>;
  orderBy?: InputMaybe<Array<MusicalWork_OrderBy> | MusicalWork_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type MusicalWorkListWithOffsetQuery = { __typename?: 'Query', musicalWorkListWithOffset: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null } | null> };

export type MusicalWorkListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<MusicalWork_Filter>;
  orderBy: MusicalWork_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type MusicalWorkListWithCursorQuery = { __typename?: 'Query', musicalWorkListWithCursor: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null } | null> };

export type MusicalWorkLinkOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MusicalWorkLinkOneQuery = { __typename?: 'Query', musicalWorkLinkOne: { __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null } };

export type MusicalWorkLinkListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<MusicalWorkLink_Filter>;
  orderBy?: InputMaybe<Array<MusicalWorkLink_OrderBy> | MusicalWorkLink_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type MusicalWorkLinkListWithOffsetQuery = { __typename?: 'Query', musicalWorkLinkListWithOffset: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null } | null> };

export type MusicalWorkLinkListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<MusicalWorkLink_Filter>;
  orderBy: MusicalWorkLink_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type MusicalWorkLinkListWithCursorQuery = { __typename?: 'Query', musicalWorkLinkListWithCursor: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null } | null> };

export type PaymentReceiptCreateMutationVariables = Exact<{
  paymentReceipt: UploadedFile;
  typeId: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  issueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentReceiptCreateMutation = { __typename?: 'Mutation', paymentReceiptCreate: { __typename?: 'PaymentReceipt', id: string } };

export type PaymentReceiptBatchCreateMutationVariables = Exact<{
  typeId: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  issueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  files: Array<UploadedFile> | UploadedFile;
}>;


export type PaymentReceiptBatchCreateMutation = { __typename?: 'Mutation', paymentReceiptBatchCreate: { __typename?: 'PaymentReceiptBatchCreateResult', created: number, results: Array<{ __typename?: 'PaymentReceipt', id: string }> } };

export type PaymentReceiptUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  paymentReceipt?: InputMaybe<UploadedFile>;
  issueDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentReceiptUpdateMutation = { __typename?: 'Mutation', paymentReceiptUpdate: { __typename?: 'PaymentReceipt', id: string, version_: string } };

export type PaymentReceiptDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PaymentReceiptDeleteMutation = { __typename?: 'Mutation', paymentReceiptDelete: { __typename?: 'PaymentReceipt', id: string } };

export type PaymentReceiptOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PaymentReceiptOneQuery = { __typename?: 'Query', paymentReceiptOne: { __typename?: 'PaymentReceipt', id: string, version_: string, paymentReceipt: string, crc: string, amount: any, issueDateTime?: any | null, status: PaymentReceiptStatus, totalUses: number, remainingUses: number, usedDate?: any | null, paymentReceipt_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type: { __typename?: 'PaymentReceiptType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, price: any, currency: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } }, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string }> | null }> | null }>, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null, uses?: Array<{ __typename?: 'PaymentReceiptUse', id: string, version_: string, detail: string, usedAt: any, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null }> | null } };

export type PaymentReceiptListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<PaymentReceipt_Filter>;
  orderBy?: InputMaybe<Array<PaymentReceipt_OrderBy> | PaymentReceipt_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PaymentReceiptListWithOffsetQuery = { __typename?: 'Query', paymentReceiptListWithOffset: Array<{ __typename?: 'PaymentReceipt', id: string, version_: string, paymentReceipt: string, crc: string, amount: any, issueDateTime?: any | null, status: PaymentReceiptStatus, totalUses: number, remainingUses: number, usedDate?: any | null, paymentReceipt_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type: { __typename?: 'PaymentReceiptType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, price: any, currency: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } }, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string }> | null }> | null }>, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null, uses?: Array<{ __typename?: 'PaymentReceiptUse', id: string, version_: string, detail: string, usedAt: any, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null }> | null } | null> };

export type PaymentReceiptListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<PaymentReceipt_Filter>;
  orderBy: PaymentReceipt_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PaymentReceiptListWithCursorQuery = { __typename?: 'Query', paymentReceiptListWithCursor: Array<{ __typename?: 'PaymentReceipt', id: string, version_: string, paymentReceipt: string, crc: string, amount: any, issueDateTime?: any | null, status: PaymentReceiptStatus, totalUses: number, remainingUses: number, usedDate?: any | null, paymentReceipt_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, type: { __typename?: 'PaymentReceiptType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, price: any, currency: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } }, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string }> | null }> | null }>, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null, uses?: Array<{ __typename?: 'PaymentReceiptUse', id: string, version_: string, detail: string, usedAt: any, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null }> | null } | null> };

export type PaymentReceiptTypeCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  currencyId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentReceiptTypeCreateMutation = { __typename?: 'Mutation', paymentReceiptTypeCreate: { __typename?: 'PaymentReceiptType', id: string } };

export type PaymentReceiptTypeUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  currencyId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaymentReceiptTypeUpdateMutation = { __typename?: 'Mutation', paymentReceiptTypeUpdate: { __typename?: 'PaymentReceiptType', id: string, version_: string } };

export type PaymentReceiptTypeDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PaymentReceiptTypeDeleteMutation = { __typename?: 'Mutation', paymentReceiptTypeDelete: { __typename?: 'PaymentReceiptType', id: string } };

export type PaymentReceiptTypeOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PaymentReceiptTypeOneQuery = { __typename?: 'Query', paymentReceiptTypeOne: { __typename?: 'PaymentReceiptType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, price: any, currency: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } } };

export type PaymentReceiptTypeListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<PaymentReceiptType_Filter>;
  orderBy?: InputMaybe<Array<PaymentReceiptType_OrderBy> | PaymentReceiptType_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PaymentReceiptTypeListWithOffsetQuery = { __typename?: 'Query', paymentReceiptTypeListWithOffset: Array<{ __typename?: 'PaymentReceiptType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, price: any, currency: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } } | null> };

export type PaymentReceiptTypeListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<PaymentReceiptType_Filter>;
  orderBy: PaymentReceiptType_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PaymentReceiptTypeListWithCursorQuery = { __typename?: 'Query', paymentReceiptTypeListWithCursor: Array<{ __typename?: 'PaymentReceiptType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, price: any, currency: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } } | null> };

export type PaymentReceiptUseOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PaymentReceiptUseOneQuery = { __typename?: 'Query', paymentReceiptUseOne: { __typename?: 'PaymentReceiptUse', id: string, version_: string, detail: string, usedAt: any, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string }> | null }> | null }>, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null } };

export type PaymentReceiptUseListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<PaymentReceiptUse_Filter>;
  orderBy?: InputMaybe<Array<PaymentReceiptUse_OrderBy> | PaymentReceiptUse_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PaymentReceiptUseListWithOffsetQuery = { __typename?: 'Query', paymentReceiptUseListWithOffset: Array<{ __typename?: 'PaymentReceiptUse', id: string, version_: string, detail: string, usedAt: any, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string }> | null }> | null }>, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null } | null> };

export type PaymentReceiptUseListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<PaymentReceiptUse_Filter>;
  orderBy: PaymentReceiptUse_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PaymentReceiptUseListWithCursorQuery = { __typename?: 'Query', paymentReceiptUseListWithCursor: Array<{ __typename?: 'PaymentReceiptUse', id: string, version_: string, detail: string, usedAt: any, signedEdition?: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, ejemplarGenerationAttempts: number, dndaRegistroAttempts: number, dndaUploadAttempts: number, dndaLastOperationalError?: string | null, sadaicLastPolledAt?: any | null, sadaicDeliveredAt?: any | null, sadaicUploadAttempts: number, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, name?: string | null, editionNumber?: number | null, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string }> | null }> | null }>, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null } | null> };

export type PermissionCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PermissionCreateMutation = { __typename?: 'Mutation', permissionCreate: { __typename?: 'Permission', id: string } };

export type PermissionUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PermissionUpdateMutation = { __typename?: 'Mutation', permissionUpdate: { __typename?: 'Permission', id: string, version_: string } };

export type PermissionDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PermissionDeleteMutation = { __typename?: 'Mutation', permissionDelete: { __typename?: 'Permission', id: string } };

export type PermissionOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PermissionOneQuery = { __typename?: 'Query', permissionOne: { __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string } };

export type PermissionListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Permission_Filter>;
  orderBy?: InputMaybe<Array<Permission_OrderBy> | Permission_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PermissionListWithOffsetQuery = { __typename?: 'Query', permissionListWithOffset: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type PermissionListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Permission_Filter>;
  orderBy: Permission_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PermissionListWithCursorQuery = { __typename?: 'Query', permissionListWithCursor: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type PhonogramOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PhonogramOneQuery = { __typename?: 'Query', phonogramOne: { __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null } };

export type PhonogramListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Phonogram_Filter>;
  orderBy?: InputMaybe<Array<Phonogram_OrderBy> | Phonogram_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PhonogramListWithOffsetQuery = { __typename?: 'Query', phonogramListWithOffset: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null } | null> };

export type PhonogramListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Phonogram_Filter>;
  orderBy: Phonogram_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PhonogramListWithCursorQuery = { __typename?: 'Query', phonogramListWithCursor: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null } | null> };

export type PlatformCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlatformCreateMutation = { __typename?: 'Mutation', platformCreate: { __typename?: 'Platform', id: string } };

export type PlatformUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlatformUpdateMutation = { __typename?: 'Mutation', platformUpdate: { __typename?: 'Platform', id: string, version_: string } };

export type PlatformDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PlatformDeleteMutation = { __typename?: 'Mutation', platformDelete: { __typename?: 'Platform', id: string } };

export type PlatformOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PlatformOneQuery = { __typename?: 'Query', platformOne: { __typename?: 'Platform', id: string, version_: string, name: string } };

export type PlatformListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Platform_Filter>;
  orderBy?: InputMaybe<Array<Platform_OrderBy> | Platform_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PlatformListWithOffsetQuery = { __typename?: 'Query', platformListWithOffset: Array<{ __typename?: 'Platform', id: string, version_: string, name: string } | null> };

export type PlatformListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Platform_Filter>;
  orderBy: Platform_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PlatformListWithCursorQuery = { __typename?: 'Query', platformListWithCursor: Array<{ __typename?: 'Platform', id: string, version_: string, name: string } | null> };

export type PlatformLinkTypeCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlatformLinkTypeCreateMutation = { __typename?: 'Mutation', platformLinkTypeCreate: { __typename?: 'PlatformLinkType', id: string } };

export type PlatformLinkTypeUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlatformLinkTypeUpdateMutation = { __typename?: 'Mutation', platformLinkTypeUpdate: { __typename?: 'PlatformLinkType', id: string, version_: string } };

export type PlatformLinkTypeDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PlatformLinkTypeDeleteMutation = { __typename?: 'Mutation', platformLinkTypeDelete: { __typename?: 'PlatformLinkType', id: string } };

export type PlatformLinkTypeOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PlatformLinkTypeOneQuery = { __typename?: 'Query', platformLinkTypeOne: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } };

export type PlatformLinkTypeListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<PlatformLinkType_Filter>;
  orderBy?: InputMaybe<Array<PlatformLinkType_OrderBy> | PlatformLinkType_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PlatformLinkTypeListWithOffsetQuery = { __typename?: 'Query', platformLinkTypeListWithOffset: Array<{ __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null> };

export type PlatformLinkTypeListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<PlatformLinkType_Filter>;
  orderBy: PlatformLinkType_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PlatformLinkTypeListWithCursorQuery = { __typename?: 'Query', platformLinkTypeListWithCursor: Array<{ __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null> };

export type ProvinceStateCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProvinceStateCreateMutation = { __typename?: 'Mutation', provinceStateCreate: { __typename?: 'ProvinceState', id: string } };

export type ProvinceStateUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProvinceStateUpdateMutation = { __typename?: 'Mutation', provinceStateUpdate: { __typename?: 'ProvinceState', id: string, version_: string } };

export type ProvinceStateDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProvinceStateDeleteMutation = { __typename?: 'Mutation', provinceStateDelete: { __typename?: 'ProvinceState', id: string } };

export type ProvinceStateOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProvinceStateOneQuery = { __typename?: 'Query', provinceStateOne: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } };

export type ProvinceStateListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<ProvinceState_Filter>;
  orderBy?: InputMaybe<Array<ProvinceState_OrderBy> | ProvinceState_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type ProvinceStateListWithOffsetQuery = { __typename?: 'Query', provinceStateListWithOffset: Array<{ __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null> };

export type ProvinceStateListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<ProvinceState_Filter>;
  orderBy: ProvinceState_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type ProvinceStateListWithCursorQuery = { __typename?: 'Query', provinceStateListWithCursor: Array<{ __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null> };

export type PublisherCreateMutationVariables = Exact<{
  personType: PersonType;
  name: Scalars['String']['input'];
  maritalStatus?: InputMaybe<MaritalStatus>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  pseudonym?: InputMaybe<Scalars['String']['input']>;
  taxId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  email: Scalars['String']['input'];
  streetAndNumber: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  provinceId: Scalars['String']['input'];
  city: Scalars['String']['input'];
  caeIpi: Scalars['String']['input'];
  representatives: Array<PublisherRepresentative_CreateInput> | PublisherRepresentative_CreateInput;
  managementSocieties?: InputMaybe<Array<PublisherCollectingSociety_CreateInput> | PublisherCollectingSociety_CreateInput>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublisherCreateMutation = { __typename?: 'Mutation', publisherCreate: { __typename?: 'Publisher', id: string } };

export type PublisherUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  personType?: InputMaybe<PersonType>;
  name: Scalars['String']['input'];
  maritalStatus?: InputMaybe<MaritalStatus>;
  nationalityId?: InputMaybe<Scalars['String']['input']>;
  pseudonym?: InputMaybe<Scalars['String']['input']>;
  taxId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  email: Scalars['String']['input'];
  streetAndNumber: Scalars['String']['input'];
  floor?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  provinceId: Scalars['String']['input'];
  city: Scalars['String']['input'];
  caeIpi: Scalars['String']['input'];
  representatives: Publisher_Representatives_UpdateInput;
  managementSocieties?: InputMaybe<Publisher_ManagementSocieties_UpdateInput>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublisherUpdateMutation = { __typename?: 'Mutation', publisherUpdate: { __typename?: 'Publisher', id: string, version_: string } };

export type PublisherDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublisherDeleteMutation = { __typename?: 'Mutation', publisherDelete: { __typename?: 'Publisher', id: string } };

export type PublisherOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublisherOneQuery = { __typename?: 'Query', publisherOne: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } };

export type PublisherListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Publisher_Filter>;
  orderBy?: InputMaybe<Array<Publisher_OrderBy> | Publisher_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PublisherListWithOffsetQuery = { __typename?: 'Query', publisherListWithOffset: Array<{ __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } | null> };

export type PublisherListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Publisher_Filter>;
  orderBy: Publisher_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PublisherListWithCursorQuery = { __typename?: 'Query', publisherListWithCursor: Array<{ __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } | null> };

export type PublisherCollectingSocietyOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublisherCollectingSocietyOneQuery = { __typename?: 'Query', publisherCollectingSocietyOne: { __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } } };

export type PublisherCollectingSocietyListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<PublisherCollectingSociety_Filter>;
  orderBy?: InputMaybe<Array<PublisherCollectingSociety_OrderBy> | PublisherCollectingSociety_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PublisherCollectingSocietyListWithOffsetQuery = { __typename?: 'Query', publisherCollectingSocietyListWithOffset: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } } | null> };

export type PublisherCollectingSocietyListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<PublisherCollectingSociety_Filter>;
  orderBy: PublisherCollectingSociety_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PublisherCollectingSocietyListWithCursorQuery = { __typename?: 'Query', publisherCollectingSocietyListWithCursor: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } } | null> };

export type PublisherRepresentativeOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublisherRepresentativeOneQuery = { __typename?: 'Query', publisherRepresentativeOne: { __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null } };

export type PublisherRepresentativeListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<PublisherRepresentative_Filter>;
  orderBy?: InputMaybe<Array<PublisherRepresentative_OrderBy> | PublisherRepresentative_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type PublisherRepresentativeListWithOffsetQuery = { __typename?: 'Query', publisherRepresentativeListWithOffset: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null } | null> };

export type PublisherRepresentativeListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<PublisherRepresentative_Filter>;
  orderBy: PublisherRepresentative_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type PublisherRepresentativeListWithCursorQuery = { __typename?: 'Query', publisherRepresentativeListWithCursor: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null } | null> };

export type QueryPatternCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  pattern: Scalars['String']['input'];
  pathType: EvaluationPathType;
  variables: Scalars['Json']['input'];
  toolTemplate: Scalars['String']['input'];
  argsTemplate: Scalars['Json']['input'];
  variations: Scalars['Json']['input'];
  exampleInstantiation: Scalars['String']['input'];
  source: QueryPatternSource;
  qualityScore: Scalars['Int']['input'];
  usageCount: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type QueryPatternCreateMutation = { __typename?: 'Mutation', queryPatternCreate: { __typename?: 'QueryPattern', id: string } };

export type QueryPatternUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pattern: Scalars['String']['input'];
  pathType?: InputMaybe<EvaluationPathType>;
  variables: Scalars['Json']['input'];
  toolTemplate: Scalars['String']['input'];
  argsTemplate: Scalars['Json']['input'];
  variations: Scalars['Json']['input'];
  exampleInstantiation: Scalars['String']['input'];
  source?: InputMaybe<QueryPatternSource>;
  qualityScore: Scalars['Int']['input'];
  usageCount: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type QueryPatternUpdateMutation = { __typename?: 'Mutation', queryPatternUpdate: { __typename?: 'QueryPattern', id: string, version_: string } };

export type QueryPatternDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QueryPatternDeleteMutation = { __typename?: 'Mutation', queryPatternDelete: { __typename?: 'QueryPattern', id: string } };

export type QueryPatternOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QueryPatternOneQuery = { __typename?: 'Query', queryPatternOne: { __typename?: 'QueryPattern', id: string, version_: string, name: string, pattern: string, pathType: EvaluationPathType, variables: any, toolTemplate: string, argsTemplate: any, variations: any, exampleInstantiation: string, source: QueryPatternSource, qualityScore: number, usageCount: number, isActive: boolean, notes?: string | null } };

export type QueryPatternListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<QueryPattern_Filter>;
  orderBy?: InputMaybe<Array<QueryPattern_OrderBy> | QueryPattern_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type QueryPatternListWithOffsetQuery = { __typename?: 'Query', queryPatternListWithOffset: Array<{ __typename?: 'QueryPattern', id: string, version_: string, name: string, pattern: string, pathType: EvaluationPathType, variables: any, toolTemplate: string, argsTemplate: any, variations: any, exampleInstantiation: string, source: QueryPatternSource, qualityScore: number, usageCount: number, isActive: boolean, notes?: string | null } | null> };

export type QueryPatternListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<QueryPattern_Filter>;
  orderBy: QueryPattern_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type QueryPatternListWithCursorQuery = { __typename?: 'Query', queryPatternListWithCursor: Array<{ __typename?: 'QueryPattern', id: string, version_: string, name: string, pattern: string, pathType: EvaluationPathType, variables: any, toolTemplate: string, argsTemplate: any, variations: any, exampleInstantiation: string, source: QueryPatternSource, qualityScore: number, usageCount: number, isActive: boolean, notes?: string | null } | null> };

export type ReportCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  reportTypeId: Scalars['String']['input'];
  template: Scalars['String']['input'];
  constants?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportCreateMutation = { __typename?: 'Mutation', reportCreate: { __typename?: 'Report', id: string } };

export type ReportUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reportTypeId: Scalars['String']['input'];
  template: Scalars['String']['input'];
  constants?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportUpdateMutation = { __typename?: 'Mutation', reportUpdate: { __typename?: 'Report', id: string, version_: string } };

export type ReportDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReportDeleteMutation = { __typename?: 'Mutation', reportDelete: { __typename?: 'Report', id: string } };

export type ReportOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReportOneQuery = { __typename?: 'Query', reportOne: { __typename?: 'Report', id: string, version_: string, name: string, template: string, constants?: string | null, description?: string | null, reportType: { __typename?: 'ReportType', id: string, version_: string, name: string, description?: string | null } } };

export type ReportListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Report_Filter>;
  orderBy?: InputMaybe<Array<Report_OrderBy> | Report_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type ReportListWithOffsetQuery = { __typename?: 'Query', reportListWithOffset: Array<{ __typename?: 'Report', id: string, version_: string, name: string, template: string, constants?: string | null, description?: string | null, reportType: { __typename?: 'ReportType', id: string, version_: string, name: string, description?: string | null } } | null> };

export type ReportListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Report_Filter>;
  orderBy: Report_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type ReportListWithCursorQuery = { __typename?: 'Query', reportListWithCursor: Array<{ __typename?: 'Report', id: string, version_: string, name: string, template: string, constants?: string | null, description?: string | null, reportType: { __typename?: 'ReportType', id: string, version_: string, name: string, description?: string | null } } | null> };

export type ReportTypeCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportTypeCreateMutation = { __typename?: 'Mutation', reportTypeCreate: { __typename?: 'ReportType', id: string } };

export type ReportTypeUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportTypeUpdateMutation = { __typename?: 'Mutation', reportTypeUpdate: { __typename?: 'ReportType', id: string, version_: string } };

export type ReportTypeDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReportTypeDeleteMutation = { __typename?: 'Mutation', reportTypeDelete: { __typename?: 'ReportType', id: string } };

export type ReportTypeOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReportTypeOneQuery = { __typename?: 'Query', reportTypeOne: { __typename?: 'ReportType', id: string, version_: string, name: string, description?: string | null } };

export type ReportTypeListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<ReportType_Filter>;
  orderBy?: InputMaybe<Array<ReportType_OrderBy> | ReportType_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type ReportTypeListWithOffsetQuery = { __typename?: 'Query', reportTypeListWithOffset: Array<{ __typename?: 'ReportType', id: string, version_: string, name: string, description?: string | null } | null> };

export type ReportTypeListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<ReportType_Filter>;
  orderBy: ReportType_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type ReportTypeListWithCursorQuery = { __typename?: 'Query', reportTypeListWithCursor: Array<{ __typename?: 'ReportType', id: string, version_: string, name: string, description?: string | null } | null> };

export type RoleCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  permissionsIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  audience: Scalars['String']['input'];
  isForAllTenants: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type RoleCreateMutation = { __typename?: 'Mutation', roleCreate: { __typename?: 'Role', id: string } };

export type RoleUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  permissionsIds?: InputMaybe<InputMultipleRef>;
  audience: Scalars['String']['input'];
  isForAllTenants: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type RoleUpdateMutation = { __typename?: 'Mutation', roleUpdate: { __typename?: 'Role', id: string, version_: string } };

export type RoleDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RoleDeleteMutation = { __typename?: 'Mutation', roleDelete: { __typename?: 'Role', id: string } };

export type RoleOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RoleOneQuery = { __typename?: 'Query', roleOne: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } };

export type RoleListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Role_Filter>;
  orderBy?: InputMaybe<Array<Role_OrderBy> | Role_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type RoleListWithOffsetQuery = { __typename?: 'Query', roleListWithOffset: Array<{ __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null> };

export type RoleListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Role_Filter>;
  orderBy: Role_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type RoleListWithCursorQuery = { __typename?: 'Query', roleListWithCursor: Array<{ __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null> };

export type SatelliteHeartbeatDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SatelliteHeartbeatDeleteMutation = { __typename?: 'Mutation', satelliteHeartbeatDelete: { __typename?: 'SatelliteHeartbeat', id: string } };

export type SatelliteHeartbeatOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SatelliteHeartbeatOneQuery = { __typename?: 'Query', satelliteHeartbeatOne: { __typename?: 'SatelliteHeartbeat', id: string, version_: string, receivedAt: any, publicIp: string, latency?: number | null, cpuUsage?: any | null, memoryUsage?: any | null, diskUsage?: any | null, activeTasksCount?: number | null, proxyStats?: any | null, systemInfo?: any | null, satelliteMachine: { __typename?: 'SatelliteMachine', id: string, version_: string, name: string, machineCode: string, satelliteType: string, region?: string | null, certificateFingerprintHasValue: boolean, certificateExpiresAt: any, authTokenHashHasValue: boolean, authTokenLastFour: string, authTokenCreatedAt: any, authTokenRotatedAt?: any | null, status: string, authorizedAt?: any | null, suspendedAt?: any | null, suspensionReason?: string | null, enabled: boolean, allowedTenantIds?: string | null, proxyEnabled: boolean, proxyPort?: number | null, proxyProtocols?: string | null, botEnabled: boolean, botMaxConcurrent?: number | null, workerEnabled: boolean, publicIp?: string | null, location?: string | null, countryCode?: string | null, lastHeartbeatAt?: any | null, lastHeartbeatMetrics?: any | null, connectedAt?: any | null, disconnectedAt?: any | null, tunnelConnectedAt?: any | null, authorizedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, suspendedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, tasks?: Array<{ __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null } | null }> | null } } };

export type SatelliteHeartbeatListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SatelliteHeartbeat_Filter>;
  orderBy?: InputMaybe<Array<SatelliteHeartbeat_OrderBy> | SatelliteHeartbeat_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SatelliteHeartbeatListWithOffsetQuery = { __typename?: 'Query', satelliteHeartbeatListWithOffset: Array<{ __typename?: 'SatelliteHeartbeat', id: string, version_: string, receivedAt: any, publicIp: string, latency?: number | null, cpuUsage?: any | null, memoryUsage?: any | null, diskUsage?: any | null, activeTasksCount?: number | null, proxyStats?: any | null, systemInfo?: any | null, satelliteMachine: { __typename?: 'SatelliteMachine', id: string, version_: string, name: string, machineCode: string, satelliteType: string, region?: string | null, certificateFingerprintHasValue: boolean, certificateExpiresAt: any, authTokenHashHasValue: boolean, authTokenLastFour: string, authTokenCreatedAt: any, authTokenRotatedAt?: any | null, status: string, authorizedAt?: any | null, suspendedAt?: any | null, suspensionReason?: string | null, enabled: boolean, allowedTenantIds?: string | null, proxyEnabled: boolean, proxyPort?: number | null, proxyProtocols?: string | null, botEnabled: boolean, botMaxConcurrent?: number | null, workerEnabled: boolean, publicIp?: string | null, location?: string | null, countryCode?: string | null, lastHeartbeatAt?: any | null, lastHeartbeatMetrics?: any | null, connectedAt?: any | null, disconnectedAt?: any | null, tunnelConnectedAt?: any | null, authorizedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, suspendedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, tasks?: Array<{ __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null } | null }> | null } } | null> };

export type SatelliteHeartbeatListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SatelliteHeartbeat_Filter>;
  orderBy: SatelliteHeartbeat_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SatelliteHeartbeatListWithCursorQuery = { __typename?: 'Query', satelliteHeartbeatListWithCursor: Array<{ __typename?: 'SatelliteHeartbeat', id: string, version_: string, receivedAt: any, publicIp: string, latency?: number | null, cpuUsage?: any | null, memoryUsage?: any | null, diskUsage?: any | null, activeTasksCount?: number | null, proxyStats?: any | null, systemInfo?: any | null, satelliteMachine: { __typename?: 'SatelliteMachine', id: string, version_: string, name: string, machineCode: string, satelliteType: string, region?: string | null, certificateFingerprintHasValue: boolean, certificateExpiresAt: any, authTokenHashHasValue: boolean, authTokenLastFour: string, authTokenCreatedAt: any, authTokenRotatedAt?: any | null, status: string, authorizedAt?: any | null, suspendedAt?: any | null, suspensionReason?: string | null, enabled: boolean, allowedTenantIds?: string | null, proxyEnabled: boolean, proxyPort?: number | null, proxyProtocols?: string | null, botEnabled: boolean, botMaxConcurrent?: number | null, workerEnabled: boolean, publicIp?: string | null, location?: string | null, countryCode?: string | null, lastHeartbeatAt?: any | null, lastHeartbeatMetrics?: any | null, connectedAt?: any | null, disconnectedAt?: any | null, tunnelConnectedAt?: any | null, authorizedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, suspendedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, tasks?: Array<{ __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null } | null }> | null } } | null> };

export type SatelliteMachineCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  machineCode: Scalars['String']['input'];
  satelliteType: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  certificateFingerprint: Scalars['String']['input'];
  certificateExpiresAt: Scalars['DateTime']['input'];
  authTokenHash: Scalars['String']['input'];
  authTokenLastFour: Scalars['String']['input'];
  authTokenCreatedAt: Scalars['DateTime']['input'];
  authTokenRotatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: Scalars['String']['input'];
  authorizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedById?: InputMaybe<Scalars['String']['input']>;
  suspendedAt?: InputMaybe<Scalars['DateTime']['input']>;
  suspendedById?: InputMaybe<Scalars['String']['input']>;
  suspensionReason?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  allowedTenantIds?: InputMaybe<Scalars['String']['input']>;
  proxyEnabled: Scalars['Boolean']['input'];
  proxyPort?: InputMaybe<Scalars['Int']['input']>;
  proxyProtocols?: InputMaybe<Scalars['String']['input']>;
  botEnabled: Scalars['Boolean']['input'];
  botMaxConcurrent?: InputMaybe<Scalars['Int']['input']>;
  workerEnabled: Scalars['Boolean']['input'];
  publicIp?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  lastHeartbeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastHeartbeatMetrics?: InputMaybe<Scalars['Json']['input']>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disconnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tunnelConnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type SatelliteMachineCreateMutation = { __typename?: 'Mutation', satelliteMachineCreate: { __typename?: 'SatelliteMachine', id: string } };

export type SatelliteMachineUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  machineCode: Scalars['String']['input'];
  satelliteType: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  certificateFingerprint?: InputMaybe<Scalars['String']['input']>;
  certificateExpiresAt: Scalars['DateTime']['input'];
  authTokenHash?: InputMaybe<Scalars['String']['input']>;
  authTokenLastFour: Scalars['String']['input'];
  authTokenCreatedAt: Scalars['DateTime']['input'];
  authTokenRotatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: Scalars['String']['input'];
  authorizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  authorizedById?: InputMaybe<Scalars['String']['input']>;
  suspendedAt?: InputMaybe<Scalars['DateTime']['input']>;
  suspendedById?: InputMaybe<Scalars['String']['input']>;
  suspensionReason?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  allowedTenantIds?: InputMaybe<Scalars['String']['input']>;
  proxyEnabled: Scalars['Boolean']['input'];
  proxyPort?: InputMaybe<Scalars['Int']['input']>;
  proxyProtocols?: InputMaybe<Scalars['String']['input']>;
  botEnabled: Scalars['Boolean']['input'];
  botMaxConcurrent?: InputMaybe<Scalars['Int']['input']>;
  workerEnabled: Scalars['Boolean']['input'];
  publicIp?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  lastHeartbeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastHeartbeatMetrics?: InputMaybe<Scalars['Json']['input']>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  disconnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tunnelConnectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type SatelliteMachineUpdateMutation = { __typename?: 'Mutation', satelliteMachineUpdate: { __typename?: 'SatelliteMachine', id: string, version_: string } };

export type SatelliteMachineDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SatelliteMachineDeleteMutation = { __typename?: 'Mutation', satelliteMachineDelete: { __typename?: 'SatelliteMachine', id: string } };

export type SatelliteMachineOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SatelliteMachineOneQuery = { __typename?: 'Query', satelliteMachineOne: { __typename?: 'SatelliteMachine', id: string, version_: string, name: string, machineCode: string, satelliteType: string, region?: string | null, certificateFingerprintHasValue: boolean, certificateExpiresAt: any, authTokenHashHasValue: boolean, authTokenLastFour: string, authTokenCreatedAt: any, authTokenRotatedAt?: any | null, status: string, authorizedAt?: any | null, suspendedAt?: any | null, suspensionReason?: string | null, enabled: boolean, allowedTenantIds?: string | null, proxyEnabled: boolean, proxyPort?: number | null, proxyProtocols?: string | null, botEnabled: boolean, botMaxConcurrent?: number | null, workerEnabled: boolean, publicIp?: string | null, location?: string | null, countryCode?: string | null, lastHeartbeatAt?: any | null, lastHeartbeatMetrics?: any | null, connectedAt?: any | null, disconnectedAt?: any | null, tunnelConnectedAt?: any | null, authorizedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, suspendedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, tasks?: Array<{ __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null } | null }> | null } };

export type SatelliteMachineListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SatelliteMachine_Filter>;
  orderBy?: InputMaybe<Array<SatelliteMachine_OrderBy> | SatelliteMachine_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SatelliteMachineListWithOffsetQuery = { __typename?: 'Query', satelliteMachineListWithOffset: Array<{ __typename?: 'SatelliteMachine', id: string, version_: string, name: string, machineCode: string, satelliteType: string, region?: string | null, certificateExpiresAt: any, authTokenLastFour: string, authTokenCreatedAt: any, authTokenRotatedAt?: any | null, status: string, authorizedAt?: any | null, suspendedAt?: any | null, suspensionReason?: string | null, enabled: boolean, allowedTenantIds?: string | null, proxyEnabled: boolean, proxyPort?: number | null, proxyProtocols?: string | null, botEnabled: boolean, botMaxConcurrent?: number | null, workerEnabled: boolean, publicIp?: string | null, location?: string | null, countryCode?: string | null, lastHeartbeatAt?: any | null, lastHeartbeatMetrics?: any | null, connectedAt?: any | null, disconnectedAt?: any | null, tunnelConnectedAt?: any | null, authorizedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, suspendedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, tasks?: Array<{ __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null } | null }> | null } | null> };

export type SatelliteMachineListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SatelliteMachine_Filter>;
  orderBy: SatelliteMachine_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SatelliteMachineListWithCursorQuery = { __typename?: 'Query', satelliteMachineListWithCursor: Array<{ __typename?: 'SatelliteMachine', id: string, version_: string, name: string, machineCode: string, satelliteType: string, region?: string | null, certificateExpiresAt: any, authTokenLastFour: string, authTokenCreatedAt: any, authTokenRotatedAt?: any | null, status: string, authorizedAt?: any | null, suspendedAt?: any | null, suspensionReason?: string | null, enabled: boolean, allowedTenantIds?: string | null, proxyEnabled: boolean, proxyPort?: number | null, proxyProtocols?: string | null, botEnabled: boolean, botMaxConcurrent?: number | null, workerEnabled: boolean, publicIp?: string | null, location?: string | null, countryCode?: string | null, lastHeartbeatAt?: any | null, lastHeartbeatMetrics?: any | null, connectedAt?: any | null, disconnectedAt?: any | null, tunnelConnectedAt?: any | null, authorizedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, suspendedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null, tasks?: Array<{ __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null } | null }> | null } | null> };

export type AuthorizeSatelliteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AuthorizeSatelliteMutation = { __typename?: 'Mutation', authorizeSatellite: { __typename?: 'SatelliteAdminResult', success: boolean, error?: string | null, satellite?: { __typename?: 'SatelliteMachine', id: string, status: string, authorizedAt?: any | null } | null } };

export type SuspendSatelliteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type SuspendSatelliteMutation = { __typename?: 'Mutation', suspendSatellite: { __typename?: 'SatelliteAdminResult', success: boolean, error?: string | null, satellite?: { __typename?: 'SatelliteMachine', id: string, status: string, suspendedAt?: any | null, suspensionReason?: string | null } | null } };

export type ReactivateSatelliteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReactivateSatelliteMutation = { __typename?: 'Mutation', reactivateSatellite: { __typename?: 'SatelliteAdminResult', success: boolean, error?: string | null, satellite?: { __typename?: 'SatelliteMachine', id: string, status: string } | null } };

export type RevokeSatelliteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type RevokeSatelliteMutation = { __typename?: 'Mutation', revokeSatellite: { __typename?: 'SatelliteAdminResult', success: boolean, error?: string | null, satellite?: { __typename?: 'SatelliteMachine', id: string, status: string } | null } };

export type SetSatelliteEnabledMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetSatelliteEnabledMutation = { __typename?: 'Mutation', setSatelliteEnabled: { __typename?: 'SatelliteAdminResult', success: boolean, error?: string | null, satellite?: { __typename?: 'SatelliteMachine', id: string, enabled: boolean } | null } };

export type RotateSatelliteTokenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RotateSatelliteTokenMutation = { __typename?: 'Mutation', rotateSatelliteToken: { __typename?: 'SatelliteAdminResult', success: boolean, error?: string | null, plainToken?: string | null, satellite?: { __typename?: 'SatelliteMachine', id: string, authTokenLastFour: string, authTokenRotatedAt?: any | null } | null } };

export type DisconnectSatelliteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisconnectSatelliteMutation = { __typename?: 'Mutation', disconnectSatellite: { __typename?: 'SatelliteAdminResult', success: boolean, error?: string | null } };

export type SatelliteConnectionInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SatelliteConnectionInfoQuery = { __typename?: 'Query', satelliteConnectionInfo?: { __typename?: 'SatelliteConnectionInfo', connected: boolean, connectedAt?: any | null, lastHeartbeat?: any | null, publicIp?: string | null, activeTasks?: number | null } | null };

export type ConnectedSatellitesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectedSatellitesQuery = { __typename?: 'Query', connectedSatellites: Array<{ __typename?: 'SatelliteMachine', id: string, name: string, machineCode: string, status: string, region?: string | null, satelliteType: string, enabled: boolean, lastHeartbeatAt?: any | null }> };

export type SatelliteTaskOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SatelliteTaskOneQuery = { __typename?: 'Query', satelliteTaskOne: { __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null, workerEvent?: { __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string } | null } } | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null }, cancellationRequestedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, phases?: Array<{ __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null }> | null, errors?: Array<{ __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } | null } };

export type SatelliteTaskListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SatelliteTask_Filter>;
  orderBy?: InputMaybe<Array<SatelliteTask_OrderBy> | SatelliteTask_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SatelliteTaskListWithOffsetQuery = { __typename?: 'Query', satelliteTaskListWithOffset: Array<{ __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null, workerEvent?: { __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string } | null } } | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null }, cancellationRequestedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, phases?: Array<{ __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null }> | null, errors?: Array<{ __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } | null } | null> };

export type SatelliteTaskListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SatelliteTask_Filter>;
  orderBy: SatelliteTask_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SatelliteTaskListWithCursorQuery = { __typename?: 'Query', satelliteTaskListWithCursor: Array<{ __typename?: 'SatelliteTask', id: string, version_: string, taskType: string, status: string, priority: number, input: any, output?: any | null, error?: any | null, correlationId: string, timeoutMs: number, retryCount: number, maxRetries: number, queuedAt: any, sentAt?: any | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, botRun?: { __typename?: 'BotRun', id: string, version_: string, botType: BotType, runNumber: number, status: string, currentPhase?: string | null, startedAt?: any | null, completedAt?: any | null, duration?: number | null, params: any, result?: any | null, error?: any | null, correlationId: string, totalPhases: number, completedPhases: number, requiresHumanIntervention: boolean, interventionReason?: string | null, logsPath?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, relatedEntityLabel?: string | null, cancellationRequestedAt?: any | null, cancellationReason?: string | null, workerEvent?: { __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string } | null } } | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null }, cancellationRequestedBy?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string } | null } | null } | null, phases?: Array<{ __typename?: 'BotPhase', id: string, version_: string, phaseNumber: number, phaseId: string, phaseName: string, status: string, stepsTotal: number, stepsCompleted: number, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, stepsLogPath?: string | null, screenshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, steps?: Array<{ __typename?: 'BotStep', id: string, version_: string, stepNumber: number, stepId: string, status: string, startedAt?: any | null, completedAt?: any | null, duration?: number | null, error?: any | null, downloadedFile?: string | null, downloadedFile_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null }> | null, errors?: Array<{ __typename?: 'BotError', id: string, version_: string, errorType: string, severity: string, message: string, stackTrace?: string | null, context: any, recoverable: boolean, requiresHumanIntervention: boolean, screenshot?: string | null, domSnapshot?: string | null, screenshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, domSnapshot_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }> | null } | null } | null> };

export type ShowcaseCategoryCreateMutationVariables = Exact<{
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShowcaseCategoryCreateMutation = { __typename?: 'Mutation', showcaseCategoryCreate: { __typename?: 'ShowcaseCategory', id: string } };

export type ShowcaseCategoryUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShowcaseCategoryUpdateMutation = { __typename?: 'Mutation', showcaseCategoryUpdate: { __typename?: 'ShowcaseCategory', id: string, version_: string } };

export type ShowcaseCategoryDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ShowcaseCategoryDeleteMutation = { __typename?: 'Mutation', showcaseCategoryDelete: { __typename?: 'ShowcaseCategory', id: string } };

export type ShowcaseCategoryOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ShowcaseCategoryOneQuery = { __typename?: 'Query', showcaseCategoryOne: { __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string } };

export type ShowcaseCategoryListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<ShowcaseCategory_Filter>;
  orderBy?: InputMaybe<Array<ShowcaseCategory_OrderBy> | ShowcaseCategory_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type ShowcaseCategoryListWithOffsetQuery = { __typename?: 'Query', showcaseCategoryListWithOffset: Array<{ __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string } | null> };

export type ShowcaseCategoryListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<ShowcaseCategory_Filter>;
  orderBy: ShowcaseCategory_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type ShowcaseCategoryListWithCursorQuery = { __typename?: 'Query', showcaseCategoryListWithCursor: Array<{ __typename?: 'ShowcaseCategory', id: string, version_: string, code: string, name: string } | null> };

export type ShowcaseLineOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ShowcaseLineOneQuery = { __typename?: 'Query', showcaseLineOne: { __typename?: 'ShowcaseLine', id: string, version_: string, concept: string, quantity: number, unitPrice: any, note?: string | null } };

export type ShowcaseLineListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<ShowcaseLine_Filter>;
  orderBy?: InputMaybe<Array<ShowcaseLine_OrderBy> | ShowcaseLine_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type ShowcaseLineListWithOffsetQuery = { __typename?: 'Query', showcaseLineListWithOffset: Array<{ __typename?: 'ShowcaseLine', id: string, version_: string, concept: string, quantity: number, unitPrice: any, note?: string | null } | null> };

export type ShowcaseLineListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<ShowcaseLine_Filter>;
  orderBy: ShowcaseLine_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type ShowcaseLineListWithCursorQuery = { __typename?: 'Query', showcaseLineListWithCursor: Array<{ __typename?: 'ShowcaseLine', id: string, version_: string, concept: string, quantity: number, unitPrice: any, note?: string | null } | null> };

export type ShowcaseWorkflowStateCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShowcaseWorkflowStateCreateMutation = { __typename?: 'Mutation', showcaseWorkflowStateCreate: { __typename?: 'ShowcaseWorkflowState', id: string } };

export type ShowcaseWorkflowStateUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShowcaseWorkflowStateUpdateMutation = { __typename?: 'Mutation', showcaseWorkflowStateUpdate: { __typename?: 'ShowcaseWorkflowState', id: string, version_: string } };

export type ShowcaseWorkflowStateDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ShowcaseWorkflowStateDeleteMutation = { __typename?: 'Mutation', showcaseWorkflowStateDelete: { __typename?: 'ShowcaseWorkflowState', id: string } };

export type ShowcaseWorkflowStateOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ShowcaseWorkflowStateOneQuery = { __typename?: 'Query', showcaseWorkflowStateOne: { __typename?: 'ShowcaseWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } };

export type ShowcaseWorkflowStateListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<ShowcaseWorkflowState_Filter>;
  orderBy?: InputMaybe<Array<ShowcaseWorkflowState_OrderBy> | ShowcaseWorkflowState_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type ShowcaseWorkflowStateListWithOffsetQuery = { __typename?: 'Query', showcaseWorkflowStateListWithOffset: Array<{ __typename?: 'ShowcaseWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type ShowcaseWorkflowStateListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<ShowcaseWorkflowState_Filter>;
  orderBy: ShowcaseWorkflowState_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type ShowcaseWorkflowStateListWithCursorQuery = { __typename?: 'Query', showcaseWorkflowStateListWithCursor: Array<{ __typename?: 'ShowcaseWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type SignedContractOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SignedContractOneQuery = { __typename?: 'Query', signedContractOne: { __typename?: 'SignedContract', id: string, version_: string, originalId_: string, data_: { __typename?: 'SignedContractData', contractNumber?: string | null, contractDuration?: number | null, contractRenewal?: number | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, territoriesDisplay?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedContractData_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedContractData_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, personType?: PersonType | null, caeIpi?: string | null, representatives: Array<{ __typename?: 'SignedContractData_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, isSigner?: boolean | null }> } | null }>, authors: Array<{ __typename?: 'SignedContractData_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, ipi?: string | null }>, works: Array<{ __typename?: 'SignedContractData_Works', title?: string | null }>, territories: Array<{ __typename?: 'SignedContractData_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }> } } };

export type SignedContractListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SignedContract_Filter>;
  orderBy?: InputMaybe<Array<SignedContract_OrderBy> | SignedContract_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SignedContractListWithOffsetQuery = { __typename?: 'Query', signedContractListWithOffset: Array<{ __typename?: 'SignedContract', id: string, version_: string, data_: { __typename?: 'SignedContractData', contractNumber?: string | null, contractDuration?: number | null, contractRenewal?: number | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, territoriesDisplay?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedContractData_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedContractData_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, personType?: PersonType | null, caeIpi?: string | null, representatives: Array<{ __typename?: 'SignedContractData_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, isSigner?: boolean | null }> } | null }>, authors: Array<{ __typename?: 'SignedContractData_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, ipi?: string | null }>, works: Array<{ __typename?: 'SignedContractData_Works', title?: string | null }>, territories: Array<{ __typename?: 'SignedContractData_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }> } } | null> };

export type SignedContractListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SignedContract_Filter>;
  orderBy: SignedContract_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SignedContractListWithCursorQuery = { __typename?: 'Query', signedContractListWithCursor: Array<{ __typename?: 'SignedContract', id: string, version_: string, data_: { __typename?: 'SignedContractData', contractNumber?: string | null, contractDuration?: number | null, contractRenewal?: number | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, territoriesDisplay?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedContractData_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedContractData_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, personType?: PersonType | null, caeIpi?: string | null, representatives: Array<{ __typename?: 'SignedContractData_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, isSigner?: boolean | null }> } | null }>, authors: Array<{ __typename?: 'SignedContractData_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, ipi?: string | null }>, works: Array<{ __typename?: 'SignedContractData_Works', title?: string | null }>, territories: Array<{ __typename?: 'SignedContractData_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }> } } | null> };

export type SignedEditionOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SignedEditionOneQuery = { __typename?: 'Query', signedEditionOne: { __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadPasswordHasValue: boolean, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, dndaLastOperationalError?: string | null, sadaicDeliveredAt?: any | null, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, originalId_: string, dndaState_transitions_: Array<string>, sadaicState_transitions_: Array<string>, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } };

export type SignedEditionListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SignedEdition_Filter>;
  orderBy?: InputMaybe<Array<SignedEdition_OrderBy> | SignedEdition_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SignedEditionListWithOffsetQuery = { __typename?: 'Query', signedEditionListWithOffset: Array<{ __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, dndaLastOperationalError?: string | null, sadaicDeliveredAt?: any | null, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, name?: string | null, editionNumber?: number | null, dndaState_transitions_: Array<string>, sadaicState_transitions_: Array<string>, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, pseudonym?: string | null, name: string } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null }>, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null> };

export type SignedEditionListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SignedEdition_Filter>;
  orderBy: SignedEdition_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SignedEditionListWithCursorQuery = { __typename?: 'Query', signedEditionListWithCursor: Array<{ __typename?: 'SignedEdition', id: string, version_: string, publicationDate?: string | null, dndaExpedienteNumber?: string | null, ejemplarPdf?: string | null, dndaComprobantePdf?: string | null, dndaUploadLink?: string | null, dndaUploadKeyReceivedAt?: any | null, dndaUploadKeyExpiresAt?: any | null, dndaComprobanteReceivedAt?: any | null, dndaLastComprobantePollAt?: any | null, dndaLastOperationalError?: string | null, sadaicDeliveredAt?: any | null, sadaicLastOperationalError?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, name?: string | null, editionNumber?: number | null, dndaState_transitions_: Array<string>, sadaicState_transitions_: Array<string>, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string }, works: Array<{ __typename?: 'MusicalWork', id: string, version_: string, title: string, alternativeTitles?: Array<string> | null, notes?: string | null, cmsId?: string | null, iswc?: string | null, workNumber: number, score?: string | null, originalLyrics?: string | null, contractObservation?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, musicalGenre: { __typename?: 'MusicalGenre', id: string, version_: string, name: string }, authors: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, pseudonym?: string | null, name: string } }> | null }>, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }>, score_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, phonograms?: Array<{ __typename?: 'Phonogram', id: string, version_: string, trackName: string, albumName?: string | null, publicationYear?: number | null, isrc?: string | null, originalProducer?: string | null, audioFile: string, mainAudio: boolean, notes?: string | null, performers?: Array<{ __typename?: 'Interpreter', id: string, version_: string, name: string, createdAt_: any, lastUpdatedAt_?: any | null }> | null, audioFile_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null }, links?: Array<{ __typename?: 'MusicalWorkLink', id: string, version_: string, url: string, platform?: { __typename?: 'Platform', id: string, version_: string, name: string } | null, type?: { __typename?: 'PlatformLinkType', id: string, version_: string, name: string } | null }> | null }> | null }>, dndaDocuments?: Array<{ __typename?: 'AssociatedDocumentSignedEdition', id: string, version_: string, name: string, file: string, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, ejemplarPdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, dndaComprobantePdf_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, blockchainCertificates?: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } }> | null, data_: { __typename?: 'SignedEditionData', name?: string | null, editionNumber?: number | null, price?: number | null, contentType?: EditionContentType | null, publicationLink?: string | null, editionType?: { __typename?: 'SignedEditionData_EditionType', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, works: Array<{ __typename?: 'SignedEditionData_Works', title?: string | null, cmsId?: string | null, iswc?: string | null, originalLyrics?: string | null, notes?: string | null, score?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, phonograms: Array<{ __typename?: 'SignedEditionData_Works_Phonograms', trackName?: string | null, isrc?: string | null, albumName?: string | null, publicationYear?: number | null, mainAudio?: boolean | null, audioFile?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, links: Array<{ __typename?: 'SignedEditionData_Works_Phonograms_Links', url?: string | null, platform?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Platform', name?: string | null } | null, type?: { __typename?: 'SignedEditionData_Works_Phonograms_Links_Type', name?: string | null } | null }> }>, musicalGenre?: { __typename?: 'SignedEditionData_Works_MusicalGenre', name?: string | null } | null, performers: Array<{ __typename?: 'SignedEditionData_Works_Performers', name?: string | null }>, territories: Array<{ __typename?: 'SignedEditionData_Works_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Works_Authors', lyricsPercentage?: number | null, musicPercentage?: number | null, author?: { __typename?: 'SignedEditionData_Works_Authors_Author', firstName?: string | null, lastName?: string | null, taxId?: string | null, taxIdType?: TaxIdType | null, email?: string | null, phone?: string | null, dateOfBirth?: string | null, aka?: string | null, ipi?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Author_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Author_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Author_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties', memberNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Author_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null, publishers: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers', percentage?: number | null, durationInYears?: number | null, autoRenewalYears?: number | null, publisher?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null, caeIpi?: string | null, phone?: string | null, email?: string | null, personType?: PersonType | null, maritalStatus?: MaritalStatus | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, city?: string | null, postalCode?: string | null, country?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Country', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, province?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Province', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, nationality?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Nationality', name_es?: string | null, name_en?: string | null, name_pt?: string | null } | null, representatives: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_Representatives', name?: string | null, role?: string | null, email?: string | null, phone?: string | null, isSigner?: boolean | null }>, managementSocieties: Array<{ __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties', cmsAccountNumber?: string | null, collectingSociety?: { __typename?: 'SignedEditionData_Works_Authors_Publishers_Publisher_ManagementSocieties_CollectingSociety', name?: string | null, acronym?: string | null } | null }> } | null }> }> }>, documentation: Array<{ __typename?: 'SignedEditionData_Documentation', publisherConfigurationDisplay?: string | null, territoriesDisplay?: string | null, authorsDisplay?: string | null, contractDuration?: number | null, contractRenewal?: number | null, contractNumber?: string | null, finalDocumentPdf?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, publishers: Array<{ __typename?: 'SignedEditionData_Documentation_Publishers', percentage?: number | null, publisher?: { __typename?: 'SignedEditionData_Documentation_Publishers_Publisher', name?: string | null, pseudonym?: string | null, taxId?: string | null } | null }>, territories: Array<{ __typename?: 'SignedEditionData_Documentation_Territories', name_es?: string | null, name_en?: string | null, name_pt?: string | null }>, authors: Array<{ __typename?: 'SignedEditionData_Documentation_Authors', firstName?: string | null, lastName?: string | null, taxId?: string | null }> }>, associatedDocuments: Array<{ __typename?: 'SignedEditionData_AssociatedDocuments', name?: string | null, publisherConfigurationDisplay?: string | null, authorsDisplay?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null, type?: { __typename?: 'SignedEditionData_AssociatedDocuments_Type', name?: string | null } | null }>, userAttachments: Array<{ __typename?: 'SignedEditionData_UserAttachments', name?: string | null, notes?: string | null, file?: { __typename?: 'SnapshotFileData', filename?: string | null, mimetype?: string | null, size?: number | null, baseName?: string | null, uuid?: string | null } | null }> } } | null> };

export type SignedEditionBlockchainCertOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SignedEditionBlockchainCertOneQuery = { __typename?: 'Query', signedEditionBlockchainCertOne: { __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } };

export type SignedEditionBlockchainCertListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SignedEditionBlockchainCert_Filter>;
  orderBy?: InputMaybe<Array<SignedEditionBlockchainCert_OrderBy> | SignedEditionBlockchainCert_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SignedEditionBlockchainCertListWithOffsetQuery = { __typename?: 'Query', signedEditionBlockchainCertListWithOffset: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } | null> };

export type SignedEditionBlockchainCertListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SignedEditionBlockchainCert_Filter>;
  orderBy: SignedEditionBlockchainCert_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SignedEditionBlockchainCertListWithCursorQuery = { __typename?: 'Query', signedEditionBlockchainCertListWithCursor: Array<{ __typename?: 'SignedEditionBlockchainCert', id: string, version_: string, name: string, contractNumber: string, file: string, confirmedAt: any, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } | null> };

export type SignedEditionDndaWorkflowStateCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignedEditionDndaWorkflowStateCreateMutation = { __typename?: 'Mutation', signedEditionDndaWorkflowStateCreate: { __typename?: 'SignedEditionDndaWorkflowState', id: string } };

export type SignedEditionDndaWorkflowStateUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignedEditionDndaWorkflowStateUpdateMutation = { __typename?: 'Mutation', signedEditionDndaWorkflowStateUpdate: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string } };

export type SignedEditionDndaWorkflowStateDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SignedEditionDndaWorkflowStateDeleteMutation = { __typename?: 'Mutation', signedEditionDndaWorkflowStateDelete: { __typename?: 'SignedEditionDndaWorkflowState', id: string } };

export type SignedEditionDndaWorkflowStateOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SignedEditionDndaWorkflowStateOneQuery = { __typename?: 'Query', signedEditionDndaWorkflowStateOne: { __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } };

export type SignedEditionDndaWorkflowStateListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SignedEditionDndaWorkflowState_Filter>;
  orderBy?: InputMaybe<Array<SignedEditionDndaWorkflowState_OrderBy> | SignedEditionDndaWorkflowState_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SignedEditionDndaWorkflowStateListWithOffsetQuery = { __typename?: 'Query', signedEditionDndaWorkflowStateListWithOffset: Array<{ __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type SignedEditionDndaWorkflowStateListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SignedEditionDndaWorkflowState_Filter>;
  orderBy: SignedEditionDndaWorkflowState_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SignedEditionDndaWorkflowStateListWithCursorQuery = { __typename?: 'Query', signedEditionDndaWorkflowStateListWithCursor: Array<{ __typename?: 'SignedEditionDndaWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type SignedEditionSadaicWorkflowStateCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignedEditionSadaicWorkflowStateCreateMutation = { __typename?: 'Mutation', signedEditionSadaicWorkflowStateCreate: { __typename?: 'SignedEditionSadaicWorkflowState', id: string } };

export type SignedEditionSadaicWorkflowStateUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignedEditionSadaicWorkflowStateUpdateMutation = { __typename?: 'Mutation', signedEditionSadaicWorkflowStateUpdate: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string } };

export type SignedEditionSadaicWorkflowStateDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SignedEditionSadaicWorkflowStateDeleteMutation = { __typename?: 'Mutation', signedEditionSadaicWorkflowStateDelete: { __typename?: 'SignedEditionSadaicWorkflowState', id: string } };

export type SignedEditionSadaicWorkflowStateOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SignedEditionSadaicWorkflowStateOneQuery = { __typename?: 'Query', signedEditionSadaicWorkflowStateOne: { __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } };

export type SignedEditionSadaicWorkflowStateListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SignedEditionSadaicWorkflowState_Filter>;
  orderBy?: InputMaybe<Array<SignedEditionSadaicWorkflowState_OrderBy> | SignedEditionSadaicWorkflowState_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SignedEditionSadaicWorkflowStateListWithOffsetQuery = { __typename?: 'Query', signedEditionSadaicWorkflowStateListWithOffset: Array<{ __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type SignedEditionSadaicWorkflowStateListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SignedEditionSadaicWorkflowState_Filter>;
  orderBy: SignedEditionSadaicWorkflowState_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SignedEditionSadaicWorkflowStateListWithCursorQuery = { __typename?: 'Query', signedEditionSadaicWorkflowStateListWithCursor: Array<{ __typename?: 'SignedEditionSadaicWorkflowState', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type SimulationSessionDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SimulationSessionDeleteMutation = { __typename?: 'Mutation', simulationSessionDelete: { __typename?: 'SimulationSession', id: string } };

export type SimulationSessionOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SimulationSessionOneQuery = { __typename?: 'Query', simulationSessionOne: { __typename?: 'SimulationSession', id: string, version_: string, status: string, mode: string, label?: string | null, entryPipeline: string, scenario?: any | null, resolvedGates?: any | null, currentGate?: string | null, correlationId: string, relatedEntityType?: string | null, relatedEntityId?: string | null, startedAt: any, completedAt?: any | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } };

export type SimulationSessionListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SimulationSession_Filter>;
  orderBy?: InputMaybe<Array<SimulationSession_OrderBy> | SimulationSession_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SimulationSessionListWithOffsetQuery = { __typename?: 'Query', simulationSessionListWithOffset: Array<{ __typename?: 'SimulationSession', id: string, version_: string, status: string, mode: string, label?: string | null, entryPipeline: string, scenario?: any | null, resolvedGates?: any | null, currentGate?: string | null, correlationId: string, relatedEntityType?: string | null, relatedEntityId?: string | null, startedAt: any, completedAt?: any | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } | null> };

export type SimulationSessionListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SimulationSession_Filter>;
  orderBy: SimulationSession_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SimulationSessionListWithCursorQuery = { __typename?: 'Query', simulationSessionListWithCursor: Array<{ __typename?: 'SimulationSession', id: string, version_: string, status: string, mode: string, label?: string | null, entryPipeline: string, scenario?: any | null, resolvedGates?: any | null, currentGate?: string | null, correlationId: string, relatedEntityType?: string | null, relatedEntityId?: string | null, startedAt: any, completedAt?: any | null, triggeredBy: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } | null> };

export type SnapshotOverrideCreateMutationVariables = Exact<{
  relatedEntityType: Scalars['String']['input'];
  relatedEntityId: Scalars['String']['input'];
  path: Scalars['String']['input'];
  value: Scalars['Json']['input'];
  note: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type SnapshotOverrideCreateMutation = { __typename?: 'Mutation', snapshotOverrideCreate: { __typename?: 'SnapshotOverride', id: string } };

export type SnapshotOverrideUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  relatedEntityType: Scalars['String']['input'];
  relatedEntityId: Scalars['String']['input'];
  path: Scalars['String']['input'];
  value: Scalars['Json']['input'];
  note: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type SnapshotOverrideUpdateMutation = { __typename?: 'Mutation', snapshotOverrideUpdate: { __typename?: 'SnapshotOverride', id: string, version_: string } };

export type SnapshotOverrideDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SnapshotOverrideDeleteMutation = { __typename?: 'Mutation', snapshotOverrideDelete: { __typename?: 'SnapshotOverride', id: string } };

export type SnapshotOverrideOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SnapshotOverrideOneQuery = { __typename?: 'Query', snapshotOverrideOne: { __typename?: 'SnapshotOverride', id: string, version_: string, relatedEntityType: string, relatedEntityId: string, path: string, value: any, note: string, active: boolean } };

export type SnapshotOverrideListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<SnapshotOverride_Filter>;
  orderBy?: InputMaybe<Array<SnapshotOverride_OrderBy> | SnapshotOverride_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SnapshotOverrideListWithOffsetQuery = { __typename?: 'Query', snapshotOverrideListWithOffset: Array<{ __typename?: 'SnapshotOverride', id: string, version_: string, relatedEntityType: string, relatedEntityId: string, path: string, value: any, note: string, active: boolean } | null> };

export type SnapshotOverrideListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<SnapshotOverride_Filter>;
  orderBy: SnapshotOverride_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SnapshotOverrideListWithCursorQuery = { __typename?: 'Query', snapshotOverrideListWithCursor: Array<{ __typename?: 'SnapshotOverride', id: string, version_: string, relatedEntityType: string, relatedEntityId: string, path: string, value: any, note: string, active: boolean } | null> };

export type TadManagerConfigUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  authProvider?: InputMaybe<TadAuthProvider>;
  idCardType?: InputMaybe<IdCardType>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  procedureNumber?: InputMaybe<Scalars['String']['input']>;
  miArgentinaPassword?: InputMaybe<Scalars['String']['input']>;
  arcaPassword?: InputMaybe<Scalars['String']['input']>;
  ansesPassword?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TadManagerConfigUpdateMutation = { __typename?: 'Mutation', tadManagerConfigUpdate: { __typename?: 'TadManagerConfig', id: string, version_: string } };

export type TadManagerConfigOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TadManagerConfigOneQuery = { __typename?: 'Query', tadManagerConfigOne: { __typename?: 'TadManagerConfig', id: string, version_: string, authProvider?: TadAuthProvider | null, idCardType?: IdCardType | null, idCard?: string | null, procedureNumberHasValue: boolean, miArgentinaPasswordHasValue: boolean, arcaPasswordHasValue: boolean, ansesPasswordHasValue: boolean, gender?: Gender | null } };

export type TadManagerConfigListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TadManagerConfig_Filter>;
  orderBy?: InputMaybe<Array<TadManagerConfig_OrderBy> | TadManagerConfig_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TadManagerConfigListWithOffsetQuery = { __typename?: 'Query', tadManagerConfigListWithOffset: Array<{ __typename?: 'TadManagerConfig', id: string, version_: string, authProvider?: TadAuthProvider | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null } | null> };

export type TadManagerConfigListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TadManagerConfig_Filter>;
  orderBy: TadManagerConfig_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TadManagerConfigListWithCursorQuery = { __typename?: 'Query', tadManagerConfigListWithCursor: Array<{ __typename?: 'TadManagerConfig', id: string, version_: string, authProvider?: TadAuthProvider | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null } | null> };

export type TenantCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  tenantTypeId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<UploadedFile>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  idERP?: InputMaybe<Scalars['String']['input']>;
  idCRM?: InputMaybe<Scalars['String']['input']>;
  monthlyTokenLimit?: InputMaybe<Scalars['Int']['input']>;
  currentMonthTokens: Scalars['Int']['input'];
  tokenLimitResetDay: Scalars['Int']['input'];
  lastTokenResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  ragLlmProviderId?: InputMaybe<Scalars['String']['input']>;
  ragLlmModel?: InputMaybe<Scalars['String']['input']>;
  currentStorageBytes: Scalars['Int']['input'];
  storageByteLimit?: InputMaybe<Scalars['Int']['input']>;
  eSignatureProvider?: InputMaybe<EsignatureProvider>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantCreateMutation = { __typename?: 'Mutation', tenantCreate: { __typename?: 'Tenant', id: string } };

export type TenantUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenantTypeId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<UploadedFile>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  idERP?: InputMaybe<Scalars['String']['input']>;
  idCRM?: InputMaybe<Scalars['String']['input']>;
  monthlyTokenLimit?: InputMaybe<Scalars['Int']['input']>;
  currentMonthTokens: Scalars['Int']['input'];
  tokenLimitResetDay: Scalars['Int']['input'];
  lastTokenResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  ragLlmProviderId?: InputMaybe<Scalars['String']['input']>;
  ragLlmModel?: InputMaybe<Scalars['String']['input']>;
  currentStorageBytes: Scalars['Int']['input'];
  storageByteLimit?: InputMaybe<Scalars['Int']['input']>;
  eSignatureProvider?: InputMaybe<EsignatureProvider>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantUpdateMutation = { __typename?: 'Mutation', tenantUpdate: { __typename?: 'Tenant', id: string, version_: string } };

export type TenantDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantDeleteMutation = { __typename?: 'Mutation', tenantDelete: { __typename?: 'Tenant', id: string } };

export type TenantOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantOneQuery = { __typename?: 'Query', tenantOne: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } };

export type TenantListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Tenant_Filter>;
  orderBy?: InputMaybe<Array<Tenant_OrderBy> | Tenant_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantListWithOffsetQuery = { __typename?: 'Query', tenantListWithOffset: Array<{ __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null> };

export type TenantListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Tenant_Filter>;
  orderBy: Tenant_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantListWithCursorQuery = { __typename?: 'Query', tenantListWithCursor: Array<{ __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null> };

export type TenantDocumentCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  file: UploadedFile;
  processingError?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  chunkingStrategy: ChunkingStrategy;
  chunkingSeparatorRegex?: InputMaybe<Scalars['String']['input']>;
  chunkingMaxTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingOverlapTokens?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantDocumentCreateMutation = { __typename?: 'Mutation', tenantDocumentCreate: { __typename?: 'TenantDocument', id: string } };

export type TenantDocumentUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<UploadedFile>;
  processingError?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  chunkingStrategy?: InputMaybe<ChunkingStrategy>;
  chunkingSeparatorRegex?: InputMaybe<Scalars['String']['input']>;
  chunkingMaxTokens?: InputMaybe<Scalars['Int']['input']>;
  chunkingOverlapTokens?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantDocumentUpdateMutation = { __typename?: 'Mutation', tenantDocumentUpdate: { __typename?: 'TenantDocument', id: string, version_: string } };

export type TenantDocumentDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantDocumentDeleteMutation = { __typename?: 'Mutation', tenantDocumentDelete: { __typename?: 'TenantDocument', id: string } };

export type TenantDocumentOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantDocumentOneQuery = { __typename?: 'Query', tenantDocumentOne: { __typename?: 'TenantDocument', id: string, version_: string, name: string, description?: string | null, file: string, fileType: string, fileSize: number, status: DocumentProcessingStatus, chunkCount?: number | null, uploadedAt: any, processedAt?: any | null, processingError?: string | null, contentType?: string | null, chunkingStrategy: ChunkingStrategy, chunkingSeparatorRegex?: string | null, chunkingMaxTokens?: number | null, chunkingOverlapTokens?: number | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } };

export type TenantDocumentListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantDocument_Filter>;
  orderBy?: InputMaybe<Array<TenantDocument_OrderBy> | TenantDocument_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantDocumentListWithOffsetQuery = { __typename?: 'Query', tenantDocumentListWithOffset: Array<{ __typename?: 'TenantDocument', id: string, version_: string, name: string, description?: string | null, file: string, fileType: string, fileSize: number, status: DocumentProcessingStatus, chunkCount?: number | null, uploadedAt: any, processedAt?: any | null, processingError?: string | null, contentType?: string | null, chunkingStrategy: ChunkingStrategy, chunkingSeparatorRegex?: string | null, chunkingMaxTokens?: number | null, chunkingOverlapTokens?: number | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } | null> };

export type TenantDocumentListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantDocument_Filter>;
  orderBy: TenantDocument_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantDocumentListWithCursorQuery = { __typename?: 'Query', tenantDocumentListWithCursor: Array<{ __typename?: 'TenantDocument', id: string, version_: string, name: string, description?: string | null, file: string, fileType: string, fileSize: number, status: DocumentProcessingStatus, chunkCount?: number | null, uploadedAt: any, processedAt?: any | null, processingError?: string | null, contentType?: string | null, chunkingStrategy: ChunkingStrategy, chunkingSeparatorRegex?: string | null, chunkingMaxTokens?: number | null, chunkingOverlapTokens?: number | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } | null> };

export type TenantLlmConfigCreateMutationVariables = Exact<{
  providerId: Scalars['String']['input'];
  model: Scalars['String']['input'];
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  temperature?: InputMaybe<Scalars['Decimal']['input']>;
  debugFullMode: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantLlmConfigCreateMutation = { __typename?: 'Mutation', tenantLlmConfigCreate: { __typename?: 'TenantLlmConfig', id: string } };

export type TenantLlmConfigUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  model: Scalars['String']['input'];
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  temperature?: InputMaybe<Scalars['Decimal']['input']>;
  debugFullMode: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantLlmConfigUpdateMutation = { __typename?: 'Mutation', tenantLlmConfigUpdate: { __typename?: 'TenantLlmConfig', id: string, version_: string } };

export type TenantLlmConfigDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantLlmConfigDeleteMutation = { __typename?: 'Mutation', tenantLlmConfigDelete: { __typename?: 'TenantLlmConfig', id: string } };

export type TenantLlmConfigOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantLlmConfigOneQuery = { __typename?: 'Query', tenantLlmConfigOne: { __typename?: 'TenantLlmConfig', id: string, version_: string, model: string, apiKeyHasValue: boolean, baseUrl?: string | null, enabled: boolean, priority: number, maxTokens?: number | null, temperature?: any | null, debugFullMode: boolean, provider: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } } };

export type TenantLlmConfigListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantLlmConfig_Filter>;
  orderBy?: InputMaybe<Array<TenantLlmConfig_OrderBy> | TenantLlmConfig_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantLlmConfigListWithOffsetQuery = { __typename?: 'Query', tenantLlmConfigListWithOffset: Array<{ __typename?: 'TenantLlmConfig', id: string, version_: string, model: string, baseUrl?: string | null, enabled: boolean, priority: number, maxTokens?: number | null, temperature?: any | null, debugFullMode: boolean, provider: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } } | null> };

export type TenantLlmConfigListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantLlmConfig_Filter>;
  orderBy: TenantLlmConfig_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantLlmConfigListWithCursorQuery = { __typename?: 'Query', tenantLlmConfigListWithCursor: Array<{ __typename?: 'TenantLlmConfig', id: string, version_: string, model: string, baseUrl?: string | null, enabled: boolean, priority: number, maxTokens?: number | null, temperature?: any | null, debugFullMode: boolean, provider: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } } | null> };

export type TenantPlanCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<Scalars['Json']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantPlanCreateMutation = { __typename?: 'Mutation', tenantPlanCreate: { __typename?: 'TenantPlan', id: string } };

export type TenantPlanUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<Scalars['Json']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantPlanUpdateMutation = { __typename?: 'Mutation', tenantPlanUpdate: { __typename?: 'TenantPlan', id: string, version_: string } };

export type TenantPlanDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantPlanDeleteMutation = { __typename?: 'Mutation', tenantPlanDelete: { __typename?: 'TenantPlan', id: string } };

export type TenantPlanOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantPlanOneQuery = { __typename?: 'Query', tenantPlanOne: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } };

export type TenantPlanListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantPlan_Filter>;
  orderBy?: InputMaybe<Array<TenantPlan_OrderBy> | TenantPlan_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantPlanListWithOffsetQuery = { __typename?: 'Query', tenantPlanListWithOffset: Array<{ __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null> };

export type TenantPlanListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantPlan_Filter>;
  orderBy: TenantPlan_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantPlanListWithCursorQuery = { __typename?: 'Query', tenantPlanListWithCursor: Array<{ __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null> };

export type TenantProfileCreateMutationVariables = Exact<{
  personType?: InputMaybe<PersonType>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownPublisherId?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  legalEmail?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  vatStatusId?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsStatusId?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsId?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingCurrencyId?: InputMaybe<Scalars['String']['input']>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  printerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  printerFloor?: InputMaybe<Scalars['String']['input']>;
  printerSuite?: InputMaybe<Scalars['String']['input']>;
  printerPostalCode?: InputMaybe<Scalars['String']['input']>;
  printerCountryId?: InputMaybe<Scalars['String']['input']>;
  printerProvinceId?: InputMaybe<Scalars['String']['input']>;
  printerCity?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUrl?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUser?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpPassword?: InputMaybe<Scalars['String']['input']>;
  sadaicEmail?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantProfileCreateMutation = { __typename?: 'Mutation', tenantProfileCreate: { __typename?: 'TenantProfile', id: string } };

export type TenantProfileUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  personType?: InputMaybe<PersonType>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownPublisherId?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['String']['input']>;
  legalEmail?: InputMaybe<Scalars['String']['input']>;
  streetAndNumber?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  suite?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  vatStatusId?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsStatusId?: InputMaybe<Scalars['String']['input']>;
  grossReceiptsId?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingCurrencyId?: InputMaybe<Scalars['String']['input']>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  printerStreetAndNumber?: InputMaybe<Scalars['String']['input']>;
  printerFloor?: InputMaybe<Scalars['String']['input']>;
  printerSuite?: InputMaybe<Scalars['String']['input']>;
  printerPostalCode?: InputMaybe<Scalars['String']['input']>;
  printerCountryId?: InputMaybe<Scalars['String']['input']>;
  printerProvinceId?: InputMaybe<Scalars['String']['input']>;
  printerCity?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUrl?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpUser?: InputMaybe<Scalars['String']['input']>;
  sadaicFtpPassword?: InputMaybe<Scalars['String']['input']>;
  sadaicEmail?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantProfileUpdateMutation = { __typename?: 'Mutation', tenantProfileUpdate: { __typename?: 'TenantProfile', id: string, version_: string } };

export type TenantProfileDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantProfileDeleteMutation = { __typename?: 'Mutation', tenantProfileDelete: { __typename?: 'TenantProfile', id: string } };

export type TenantProfileOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantProfileOneQuery = { __typename?: 'Query', tenantProfileOne: { __typename?: 'TenantProfile', id: string, version_: string, personType?: PersonType | null, legalName?: string | null, businessId?: string | null, legalEmail?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, taxId?: string | null, grossReceiptsId?: string | null, billingEmail?: string | null, printerName?: string | null, printerStreetAndNumber?: string | null, printerFloor?: string | null, printerSuite?: string | null, printerPostalCode?: string | null, printerCity?: string | null, sadaicFtpUrl?: string | null, sadaicFtpUser?: string | null, sadaicFtpPasswordHasValue: boolean, sadaicEmail?: string | null, ownPublisher?: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, vatStatus?: { __typename?: 'VatStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, grossReceiptsStatus?: { __typename?: 'GrossReceiptsStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, billingCurrency?: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } | null, printerCountry?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, printerProvince?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null } };

export type TenantProfileListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantProfile_Filter>;
  orderBy?: InputMaybe<Array<TenantProfile_OrderBy> | TenantProfile_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantProfileListWithOffsetQuery = { __typename?: 'Query', tenantProfileListWithOffset: Array<{ __typename?: 'TenantProfile', id: string, version_: string, personType?: PersonType | null, legalName?: string | null, businessId?: string | null, legalEmail?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, taxId?: string | null, grossReceiptsId?: string | null, billingEmail?: string | null, printerName?: string | null, printerStreetAndNumber?: string | null, printerFloor?: string | null, printerSuite?: string | null, printerPostalCode?: string | null, printerCity?: string | null, sadaicFtpUrl?: string | null, sadaicFtpUser?: string | null, sadaicEmail?: string | null, ownPublisher?: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, vatStatus?: { __typename?: 'VatStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, grossReceiptsStatus?: { __typename?: 'GrossReceiptsStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, billingCurrency?: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } | null, printerCountry?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, printerProvince?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null } | null> };

export type TenantProfileListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantProfile_Filter>;
  orderBy: TenantProfile_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantProfileListWithCursorQuery = { __typename?: 'Query', tenantProfileListWithCursor: Array<{ __typename?: 'TenantProfile', id: string, version_: string, personType?: PersonType | null, legalName?: string | null, businessId?: string | null, legalEmail?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, taxId?: string | null, grossReceiptsId?: string | null, billingEmail?: string | null, printerName?: string | null, printerStreetAndNumber?: string | null, printerFloor?: string | null, printerSuite?: string | null, printerPostalCode?: string | null, printerCity?: string | null, sadaicFtpUrl?: string | null, sadaicFtpUser?: string | null, sadaicEmail?: string | null, ownPublisher?: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, vatStatus?: { __typename?: 'VatStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, grossReceiptsStatus?: { __typename?: 'GrossReceiptsStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, billingCurrency?: { __typename?: 'Currency', id: string, version_: string, code: string, name: string } | null, printerCountry?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, printerProvince?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null } | null> };

export type TenantStatusCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  blocksAccess: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantStatusCreateMutation = { __typename?: 'Mutation', tenantStatusCreate: { __typename?: 'TenantStatus', id: string } };

export type TenantStatusUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  blocksAccess: Scalars['Boolean']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantStatusUpdateMutation = { __typename?: 'Mutation', tenantStatusUpdate: { __typename?: 'TenantStatus', id: string, version_: string } };

export type TenantStatusDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantStatusDeleteMutation = { __typename?: 'Mutation', tenantStatusDelete: { __typename?: 'TenantStatus', id: string } };

export type TenantStatusOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantStatusOneQuery = { __typename?: 'Query', tenantStatusOne: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } };

export type TenantStatusListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantStatus_Filter>;
  orderBy?: InputMaybe<Array<TenantStatus_OrderBy> | TenantStatus_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantStatusListWithOffsetQuery = { __typename?: 'Query', tenantStatusListWithOffset: Array<{ __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null> };

export type TenantStatusListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantStatus_Filter>;
  orderBy: TenantStatus_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantStatusListWithCursorQuery = { __typename?: 'Query', tenantStatusListWithCursor: Array<{ __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null> };

export type TenantStorageUsageOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantStorageUsageOneQuery = { __typename?: 'Query', tenantStorageUsageOne: { __typename?: 'TenantStorageUsage', id: string, version_: string, operation: StorageOperation, bytes: number, documentName: string, documentId: string, fileType: string, timestamp: any, balanceAfter: number } };

export type TenantStorageUsageListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantStorageUsage_Filter>;
  orderBy?: InputMaybe<Array<TenantStorageUsage_OrderBy> | TenantStorageUsage_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantStorageUsageListWithOffsetQuery = { __typename?: 'Query', tenantStorageUsageListWithOffset: Array<{ __typename?: 'TenantStorageUsage', id: string, version_: string, operation: StorageOperation, bytes: number, documentName: string, documentId: string, fileType: string, timestamp: any, balanceAfter: number } | null> };

export type TenantStorageUsageListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantStorageUsage_Filter>;
  orderBy: TenantStorageUsage_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantStorageUsageListWithCursorQuery = { __typename?: 'Query', tenantStorageUsageListWithCursor: Array<{ __typename?: 'TenantStorageUsage', id: string, version_: string, operation: StorageOperation, bytes: number, documentName: string, documentId: string, fileType: string, timestamp: any, balanceAfter: number } | null> };

export type TenantTokenUsageOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantTokenUsageOneQuery = { __typename?: 'Query', tenantTokenUsageOne: { __typename?: 'TenantTokenUsage', id: string, version_: string, provider: string, model: string, promptTokens: number, completionTokens: number, totalTokens: number, timestamp: any, totalTimeMs: number, llmTimeMs: number, toolsTimeMs: number, ragTimeMs?: number | null, firstTokenMs?: number | null, llmCallCount: number, toolCallCount: number, ragChunksCount?: number | null, abTestCondition?: string | null, conversation?: { __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null } | null, conversationUser: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } };

export type TenantTokenUsageListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantTokenUsage_Filter>;
  orderBy?: InputMaybe<Array<TenantTokenUsage_OrderBy> | TenantTokenUsage_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantTokenUsageListWithOffsetQuery = { __typename?: 'Query', tenantTokenUsageListWithOffset: Array<{ __typename?: 'TenantTokenUsage', id: string, version_: string, provider: string, model: string, promptTokens: number, completionTokens: number, totalTokens: number, timestamp: any, totalTimeMs: number, llmTimeMs: number, toolsTimeMs: number, ragTimeMs?: number | null, firstTokenMs?: number | null, llmCallCount: number, toolCallCount: number, ragChunksCount?: number | null, abTestCondition?: string | null, conversation?: { __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null } | null, conversationUser: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } | null> };

export type TenantTokenUsageListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantTokenUsage_Filter>;
  orderBy: TenantTokenUsage_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantTokenUsageListWithCursorQuery = { __typename?: 'Query', tenantTokenUsageListWithCursor: Array<{ __typename?: 'TenantTokenUsage', id: string, version_: string, provider: string, model: string, promptTokens: number, completionTokens: number, totalTokens: number, timestamp: any, totalTimeMs: number, llmTimeMs: number, toolsTimeMs: number, ragTimeMs?: number | null, firstTokenMs?: number | null, llmCallCount: number, toolCallCount: number, ragChunksCount?: number | null, abTestCondition?: string | null, conversation?: { __typename?: 'AiSearchConversation', id: string, version_: string, startedAt: any, lastMessageAt: any, messageCount: number, messages: any, context?: any | null } | null, conversationUser: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } | null> };

export type TenantTypeCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantTypeCreateMutation = { __typename?: 'Mutation', tenantTypeCreate: { __typename?: 'TenantType', id: string } };

export type TenantTypeUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantTypeUpdateMutation = { __typename?: 'Mutation', tenantTypeUpdate: { __typename?: 'TenantType', id: string, version_: string } };

export type TenantTypeDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantTypeDeleteMutation = { __typename?: 'Mutation', tenantTypeDelete: { __typename?: 'TenantType', id: string } };

export type TenantTypeOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantTypeOneQuery = { __typename?: 'Query', tenantTypeOne: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } };

export type TenantTypeListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantType_Filter>;
  orderBy?: InputMaybe<Array<TenantType_OrderBy> | TenantType_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantTypeListWithOffsetQuery = { __typename?: 'Query', tenantTypeListWithOffset: Array<{ __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null> };

export type TenantTypeListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantType_Filter>;
  orderBy: TenantType_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantTypeListWithCursorQuery = { __typename?: 'Query', tenantTypeListWithCursor: Array<{ __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null> };

export type TenantWidgetAccessCreateMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantWidgetAccessCreateMutation = { __typename?: 'Mutation', tenantWidgetAccessCreate: { __typename?: 'TenantWidgetAccess', id: string } };

export type TenantWidgetAccessUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantWidgetAccessUpdateMutation = { __typename?: 'Mutation', tenantWidgetAccessUpdate: { __typename?: 'TenantWidgetAccess', id: string, version_: string } };

export type TenantWidgetAccessDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantWidgetAccessDeleteMutation = { __typename?: 'Mutation', tenantWidgetAccessDelete: { __typename?: 'TenantWidgetAccess', id: string } };

export type TenantWidgetAccessOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TenantWidgetAccessOneQuery = { __typename?: 'Query', tenantWidgetAccessOne: { __typename?: 'TenantWidgetAccess', id: string, version_: string, enabled: boolean, configOverride?: any | null, tenant: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null }, widget: { __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } } };

export type TenantWidgetAccessListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<TenantWidgetAccess_Filter>;
  orderBy?: InputMaybe<Array<TenantWidgetAccess_OrderBy> | TenantWidgetAccess_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TenantWidgetAccessListWithOffsetQuery = { __typename?: 'Query', tenantWidgetAccessListWithOffset: Array<{ __typename?: 'TenantWidgetAccess', id: string, version_: string, enabled: boolean, configOverride?: any | null, tenant: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null }, widget: { __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } } | null> };

export type TenantWidgetAccessListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<TenantWidgetAccess_Filter>;
  orderBy: TenantWidgetAccess_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TenantWidgetAccessListWithCursorQuery = { __typename?: 'Query', tenantWidgetAccessListWithCursor: Array<{ __typename?: 'TenantWidgetAccess', id: string, version_: string, enabled: boolean, configOverride?: any | null, tenant: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null }, widget: { __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } } | null> };

export type TerritoryCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TerritoryCreateMutation = { __typename?: 'Mutation', territoryCreate: { __typename?: 'Territory', id: string } };

export type TerritoryUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type TerritoryUpdateMutation = { __typename?: 'Mutation', territoryUpdate: { __typename?: 'Territory', id: string, version_: string } };

export type TerritoryDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TerritoryDeleteMutation = { __typename?: 'Mutation', territoryDelete: { __typename?: 'Territory', id: string } };

export type TerritoryOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TerritoryOneQuery = { __typename?: 'Query', territoryOne: { __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string } };

export type TerritoryListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Territory_Filter>;
  orderBy?: InputMaybe<Array<Territory_OrderBy> | Territory_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type TerritoryListWithOffsetQuery = { __typename?: 'Query', territoryListWithOffset: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type TerritoryListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Territory_Filter>;
  orderBy: Territory_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type TerritoryListWithCursorQuery = { __typename?: 'Query', territoryListWithCursor: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string } | null> };

export type ThemeOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ThemeOneQuery = { __typename?: 'Query', themeOne: { __typename?: 'Theme', id: string, version_: string, name: string, active: boolean, authoring: any, resolved: any } };

export type ThemeListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<Theme_Filter>;
  orderBy?: InputMaybe<Array<Theme_OrderBy> | Theme_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type ThemeListWithOffsetQuery = { __typename?: 'Query', themeListWithOffset: Array<{ __typename?: 'Theme', id: string, version_: string, name: string, active: boolean, authoring: any, resolved: any } | null> };

export type ThemeListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<Theme_Filter>;
  orderBy: Theme_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type ThemeListWithCursorQuery = { __typename?: 'Query', themeListWithCursor: Array<{ __typename?: 'Theme', id: string, version_: string, name: string, active: boolean, authoring: any, resolved: any } | null> };

export type SiteUserCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  language: Language;
  avatar?: InputMaybe<UploadedFile>;
  active: Scalars['Boolean']['input'];
  cellphone?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
}>;


export type SiteUserCreateMutation = { __typename?: 'Mutation', siteUserCreate: { __typename?: 'SiteUser', id: string } };

export type SiteUserUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  avatar?: InputMaybe<UploadedFile>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
}>;


export type SiteUserUpdateMutation = { __typename?: 'Mutation', siteUserUpdate: { __typename?: 'SiteUser', id: string, version_: string } };

export type SiteUserDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SiteUserDeleteMutation = { __typename?: 'Mutation', siteUserDelete: { __typename?: 'SiteUser', id: string } };

export type SiteUserOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SiteUserOneQuery = { __typename?: 'Query', siteUserOne: { __typename?: 'SiteUser', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } };

export type SiteUserListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<User_Filter>;
  orderBy?: InputMaybe<Array<User_OrderBy> | User_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SiteUserListWithOffsetQuery = { __typename?: 'Query', siteUserListWithOffset: Array<{ __typename?: 'SiteUser', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type SiteUserListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<User_Filter>;
  orderBy: User_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type SiteUserListWithCursorQuery = { __typename?: 'Query', siteUserListWithCursor: Array<{ __typename?: 'SiteUser', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type UserCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  language: Language;
  avatar?: InputMaybe<UploadedFile>;
  targetTenantId?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
  cellphone?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate: { __typename?: 'User', id: string } };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  avatar?: InputMaybe<UploadedFile>;
  active: Scalars['Boolean']['input'];
  cellphone?: InputMaybe<Scalars['String']['input']>;
  twoFaseAuth?: InputMaybe<Scalars['Boolean']['input']>;
  idCardType?: InputMaybe<IdCardType>;
  idCard?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', id: string, version_: string } };

export type UserDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserDeleteMutation = { __typename?: 'Mutation', userDelete: { __typename?: 'User', id: string } };

export type UserOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserOneQuery = { __typename?: 'Query', userOne: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } };

export type UserListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<User_Filter>;
  orderBy?: InputMaybe<Array<User_OrderBy> | User_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type UserListWithOffsetQuery = { __typename?: 'Query', userListWithOffset: Array<{ __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type UserListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<User_Filter>;
  orderBy: User_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type UserListWithCursorQuery = { __typename?: 'Query', userListWithCursor: Array<{ __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null } | null> };

export type UserAttachmentEditionOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserAttachmentEditionOneQuery = { __typename?: 'Query', userAttachmentEditionOne: { __typename?: 'UserAttachmentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } };

export type UserAttachmentEditionListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<UserAttachmentEdition_Filter>;
  orderBy?: InputMaybe<Array<UserAttachmentEdition_OrderBy> | UserAttachmentEdition_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type UserAttachmentEditionListWithOffsetQuery = { __typename?: 'Query', userAttachmentEditionListWithOffset: Array<{ __typename?: 'UserAttachmentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } | null> };

export type UserAttachmentEditionListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<UserAttachmentEdition_Filter>;
  orderBy: UserAttachmentEdition_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type UserAttachmentEditionListWithCursorQuery = { __typename?: 'Query', userAttachmentEditionListWithCursor: Array<{ __typename?: 'UserAttachmentEdition', id: string, version_: string, name: string, file: string, notes?: string | null, file_data: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } } | null> };

export type UserNotificationDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserNotificationDeleteMutation = { __typename?: 'Mutation', userNotificationDelete: { __typename?: 'UserNotification', id: string } };

export type UserNotificationOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserNotificationOneQuery = { __typename?: 'Query', userNotificationOne: { __typename?: 'UserNotification', id: string, version_: string, type: NotificationType, priority?: NotificationPriority | null, title: string, body?: string | null, objectType?: string | null, objectId?: string | null, actionUrl?: string | null, readAt?: any | null, notificationCreatedAt?: any | null, archivedAt?: any | null, metadata?: any | null, actorUser?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null } };

export type UserNotificationListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<UserNotification_Filter>;
  orderBy?: InputMaybe<Array<UserNotification_OrderBy> | UserNotification_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type UserNotificationListWithOffsetQuery = { __typename?: 'Query', userNotificationListWithOffset: Array<{ __typename?: 'UserNotification', id: string, version_: string, type: NotificationType, priority?: NotificationPriority | null, title: string, body?: string | null, objectType?: string | null, objectId?: string | null, actionUrl?: string | null, readAt?: any | null, notificationCreatedAt?: any | null, archivedAt?: any | null, metadata?: any | null, actorUser?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null } | null> };

export type UserNotificationListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<UserNotification_Filter>;
  orderBy: UserNotification_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type UserNotificationListWithCursorQuery = { __typename?: 'Query', userNotificationListWithCursor: Array<{ __typename?: 'UserNotification', id: string, version_: string, type: NotificationType, priority?: NotificationPriority | null, title: string, body?: string | null, objectType?: string | null, objectId?: string | null, actionUrl?: string | null, readAt?: any | null, notificationCreatedAt?: any | null, archivedAt?: any | null, metadata?: any | null, actorUser?: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } | null } | null> };

export type UserNotificationPreferenceCreateMutationVariables = Exact<{
  notificationType: NotificationType;
  inAppEnabled: Scalars['Boolean']['input'];
  emailEnabled: Scalars['Boolean']['input'];
  emailFrequency: EmailFrequency;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserNotificationPreferenceCreateMutation = { __typename?: 'Mutation', userNotificationPreferenceCreate: { __typename?: 'UserNotificationPreference', id: string } };

export type UserNotificationPreferenceUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  notificationType?: InputMaybe<NotificationType>;
  inAppEnabled: Scalars['Boolean']['input'];
  emailEnabled: Scalars['Boolean']['input'];
  emailFrequency?: InputMaybe<EmailFrequency>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserNotificationPreferenceUpdateMutation = { __typename?: 'Mutation', userNotificationPreferenceUpdate: { __typename?: 'UserNotificationPreference', id: string, version_: string } };

export type UserNotificationPreferenceDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserNotificationPreferenceDeleteMutation = { __typename?: 'Mutation', userNotificationPreferenceDelete: { __typename?: 'UserNotificationPreference', id: string } };

export type UserNotificationPreferenceOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserNotificationPreferenceOneQuery = { __typename?: 'Query', userNotificationPreferenceOne: { __typename?: 'UserNotificationPreference', id: string, version_: string, notificationType: NotificationType, inAppEnabled: boolean, emailEnabled: boolean, emailFrequency: EmailFrequency } };

export type UserNotificationPreferenceListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<UserNotificationPreference_Filter>;
  orderBy?: InputMaybe<Array<UserNotificationPreference_OrderBy> | UserNotificationPreference_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type UserNotificationPreferenceListWithOffsetQuery = { __typename?: 'Query', userNotificationPreferenceListWithOffset: Array<{ __typename?: 'UserNotificationPreference', id: string, version_: string, notificationType: NotificationType, inAppEnabled: boolean, emailEnabled: boolean, emailFrequency: EmailFrequency } | null> };

export type UserNotificationPreferenceListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<UserNotificationPreference_Filter>;
  orderBy: UserNotificationPreference_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type UserNotificationPreferenceListWithCursorQuery = { __typename?: 'Query', userNotificationPreferenceListWithCursor: Array<{ __typename?: 'UserNotificationPreference', id: string, version_: string, notificationType: NotificationType, inAppEnabled: boolean, emailEnabled: boolean, emailFrequency: EmailFrequency } | null> };

export type UserWidgetConfigCreateMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  position: Scalars['Json']['input'];
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserWidgetConfigCreateMutation = { __typename?: 'Mutation', userWidgetConfigCreate: { __typename?: 'UserWidgetConfig', id: string } };

export type UserWidgetConfigUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  position: Scalars['Json']['input'];
  configOverride?: InputMaybe<Scalars['Json']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserWidgetConfigUpdateMutation = { __typename?: 'Mutation', userWidgetConfigUpdate: { __typename?: 'UserWidgetConfig', id: string, version_: string } };

export type UserWidgetConfigDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserWidgetConfigDeleteMutation = { __typename?: 'Mutation', userWidgetConfigDelete: { __typename?: 'UserWidgetConfig', id: string } };

export type UserWidgetConfigOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserWidgetConfigOneQuery = { __typename?: 'Query', userWidgetConfigOne: { __typename?: 'UserWidgetConfig', id: string, version_: string, enabled: boolean, position: any, configOverride?: any | null, displayOrder?: number | null, user: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null }, widget: { __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } } };

export type UserWidgetConfigListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<UserWidgetConfig_Filter>;
  orderBy?: InputMaybe<Array<UserWidgetConfig_OrderBy> | UserWidgetConfig_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type UserWidgetConfigListWithOffsetQuery = { __typename?: 'Query', userWidgetConfigListWithOffset: Array<{ __typename?: 'UserWidgetConfig', id: string, version_: string, enabled: boolean, position: any, configOverride?: any | null, displayOrder?: number | null, user: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null }, widget: { __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } } | null> };

export type UserWidgetConfigListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<UserWidgetConfig_Filter>;
  orderBy: UserWidgetConfig_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type UserWidgetConfigListWithCursorQuery = { __typename?: 'Query', userWidgetConfigListWithCursor: Array<{ __typename?: 'UserWidgetConfig', id: string, version_: string, enabled: boolean, position: any, configOverride?: any | null, displayOrder?: number | null, user: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null }, widget: { __typename?: 'DashboardWidget', id: string, version_: string, widgetKey: string, title: string, description?: string | null, category: string, component: string, dataFetcherKey: string, defaultConfig: any, icon?: string | null, minWidth: number, minHeight: number, refreshInterval?: number | null, requiredPermissions: string, enabled: boolean } } | null> };

export type VatStatusCreateMutationVariables = Exact<{
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type VatStatusCreateMutation = { __typename?: 'Mutation', vatStatusCreate: { __typename?: 'VatStatus', id: string } };

export type VatStatusUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  name_es: Scalars['String']['input'];
  name_en: Scalars['String']['input'];
  name_pt: Scalars['String']['input'];
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_?: InputMaybe<Scalars['String']['input']>;
}>;


export type VatStatusUpdateMutation = { __typename?: 'Mutation', vatStatusUpdate: { __typename?: 'VatStatus', id: string, version_: string } };

export type VatStatusDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type VatStatusDeleteMutation = { __typename?: 'Mutation', vatStatusDelete: { __typename?: 'VatStatus', id: string } };

export type VatStatusOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type VatStatusOneQuery = { __typename?: 'Query', vatStatusOne: { __typename?: 'VatStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } };

export type VatStatusListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<VatStatus_Filter>;
  orderBy?: InputMaybe<Array<VatStatus_OrderBy> | VatStatus_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type VatStatusListWithOffsetQuery = { __typename?: 'Query', vatStatusListWithOffset: Array<{ __typename?: 'VatStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null> };

export type VatStatusListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<VatStatus_Filter>;
  orderBy: VatStatus_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type VatStatusListWithCursorQuery = { __typename?: 'Query', vatStatusListWithCursor: Array<{ __typename?: 'VatStatus', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null> };

export type WorkAuthorOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type WorkAuthorOneQuery = { __typename?: 'Query', workAuthorOne: { __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null } };

export type WorkAuthorListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<WorkAuthor_Filter>;
  orderBy?: InputMaybe<Array<WorkAuthor_OrderBy> | WorkAuthor_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type WorkAuthorListWithOffsetQuery = { __typename?: 'Query', workAuthorListWithOffset: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null } | null> };

export type WorkAuthorListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<WorkAuthor_Filter>;
  orderBy: WorkAuthor_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type WorkAuthorListWithCursorQuery = { __typename?: 'Query', workAuthorListWithCursor: Array<{ __typename?: 'WorkAuthor', id: string, version_: string, lyricsPercentage: any, musicPercentage: any, author: { __typename?: 'AuthorComposer', id: string, version_: string, firstName: string, lastName: string, gender?: Gender | null, taxIdType?: TaxIdType | null, taxId?: string | null, cuitCertificate?: string | null, cuitCertificateIssuedAt?: any | null, cuitCertificateError?: string | null, cuitCertificateErrorType?: CuitCertificateErrorType | null, dniDeliveredToSadaicAt?: any | null, dniValidatedAt?: any | null, dniValidatedFields?: any | null, email: string, phone?: string | null, dateOfBirth?: string | null, streetAndNumber?: string | null, floor?: string | null, suite?: string | null, postalCode?: string | null, city?: string | null, aka?: string | null, ipi?: string | null, createdAt_: any, lastUpdatedAt_?: any | null, cuitCertificate_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, province?: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } } | null, managementSocieties?: Array<{ __typename?: 'AuthorCollectingSociety', id: string, version_: string, memberNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string }, territories: Array<{ __typename?: 'Territory', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> }> | null, publishers?: Array<{ __typename?: 'AuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null }, publishers?: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null } }> | null } | null> };

export type WorkAuthorPublisherOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type WorkAuthorPublisherOneQuery = { __typename?: 'Query', workAuthorPublisherOne: { __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } };

export type WorkAuthorPublisherListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<WorkAuthorPublisher_Filter>;
  orderBy?: InputMaybe<Array<WorkAuthorPublisher_OrderBy> | WorkAuthorPublisher_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type WorkAuthorPublisherListWithOffsetQuery = { __typename?: 'Query', workAuthorPublisherListWithOffset: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } | null> };

export type WorkAuthorPublisherListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<WorkAuthorPublisher_Filter>;
  orderBy: WorkAuthorPublisher_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type WorkAuthorPublisherListWithCursorQuery = { __typename?: 'Query', workAuthorPublisherListWithCursor: Array<{ __typename?: 'WorkAuthorPublisher', id: string, version_: string, percentage: any, durationInYears?: number | null, autoRenewalYears?: number | null, publisher: { __typename?: 'Publisher', id: string, version_: string, personType: PersonType, name: string, maritalStatus?: MaritalStatus | null, pseudonym?: string | null, taxId: string, phone: string, email: string, streetAndNumber: string, floor?: string | null, suite?: string | null, postalCode: string, city: string, caeIpi: string, createdAt_: any, lastUpdatedAt_?: any | null, nationality?: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } | null, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null }, province: { __typename?: 'ProvinceState', id: string, version_: string, name_es: string, name_en: string, name_pt: string, country: { __typename?: 'Country', id: string, version_: string, name_es: string, name_en: string, name_pt: string, code: string, currency: string, demonym_es?: string | null, demonym_en?: string | null, demonym_pt?: string | null } }, representatives: Array<{ __typename?: 'PublisherRepresentative', id: string, version_: string, name: string, role?: string | null, email: string, phone?: string | null, isSigner?: boolean | null }>, managementSocieties?: Array<{ __typename?: 'PublisherCollectingSociety', id: string, version_: string, cmsAccountNumber: string, collectingSociety: { __typename?: 'CollectiveManagementSociety', id: string, version_: string, name: string, acronym: string } }> | null } } | null> };

export type WorkerEventDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type WorkerEventDeleteMutation = { __typename?: 'Mutation', workerEventDelete: { __typename?: 'WorkerEvent', id: string } };

export type WorkerEventOneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type WorkerEventOneQuery = { __typename?: 'Query', workerEventOne: { __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } };

export type WorkerEventListWithOffsetQueryVariables = Exact<{
  where?: InputMaybe<WorkerEvent_Filter>;
  orderBy?: InputMaybe<Array<WorkerEvent_OrderBy> | WorkerEvent_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type WorkerEventListWithOffsetQuery = { __typename?: 'Query', workerEventListWithOffset: Array<{ __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } | null> };

export type WorkerEventListWithCursorQueryVariables = Exact<{
  where?: InputMaybe<WorkerEvent_Filter>;
  orderBy: WorkerEvent_OrderByCursor;
  cursorKey?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
}>;


export type WorkerEventListWithCursorQuery = { __typename?: 'Query', workerEventListWithCursor: Array<{ __typename?: 'WorkerEvent', id: string, version_: string, queueName: string, jobType: string, status: string, enqueuedAt: any, startedAt?: any | null, completedAt?: any | null, payload: any, result?: any | null, error?: any | null, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, duration?: number | null, correlationId?: string | null, triggerUserId: { __typename?: 'User', id: string, version_: string, name: string, email: string, language: Language, avatar?: string | null, tenantDisplayName?: string | null, active: boolean, cellphone?: string | null, twoFaseAuth?: boolean | null, profile?: any | null, idCardType?: IdCardType | null, idCard?: string | null, gender?: Gender | null, role?: { __typename?: 'Role', id: string, version_: string, name_es: string, name_en: string, name_pt: string, audience: string, isForAllTenants: boolean, permissions?: Array<{ __typename?: 'Permission', id: string, version_: string, name_es: string, name_en: string, name_pt: string }> | null } | null, avatar_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, targetTenant?: { __typename?: 'Tenant', id: string, version_: string, name: string, logo?: string | null, publicUrl?: string | null, idERP?: string | null, idCRM?: string | null, monthlyTokenLimit?: number | null, currentMonthTokens: number, tokenLimitResetDay: number, lastTokenResetDate?: any | null, ragLlmModel?: string | null, currentStorageBytes: number, storageByteLimit?: number | null, eSignatureProvider?: EsignatureProvider | null, tenantType?: { __typename?: 'TenantType', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null } | null, status?: { __typename?: 'TenantStatus', id: string, version_: string, name: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, blocksAccess: boolean } | null, plan?: { __typename?: 'TenantPlan', id: string, version_: string, name_es: string, name_en: string, name_pt: string, description_es?: string | null, description_en?: string | null, description_pt?: string | null, limits?: any | null } | null, logo_data?: { __typename?: 'FileData', name: string, mimetype: string, url: string, size?: number | null, description?: string | null, thumbnails?: Array<{ __typename?: 'Thumbnail', url: string, size: ThumbnailSize } | null> | null } | null, ragLlmProvider?: { __typename?: 'LlmProvider', id: string, version_: string, name: string, code: string, requiresApiKey: boolean, requiresBaseUrl: boolean, defaultModels: Array<string>, logoUrl?: string | null } | null } | null } } | null> };

export type AutomationEditionsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AutomationEditionsQuery = { __typename?: 'Query', signedEditionListWithOffset: Array<{ __typename?: 'SignedEdition', id: string, displayId: string, version_: string, tenant_id_?: string | null, lastUpdatedAt_?: any | null, dndaLastOperationalError?: string | null, sadaicLastOperationalError?: string | null, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string }, data_: { __typename?: 'SignedEditionData', name?: string | null } } | null> };

export type AutomationBotRunsQueryVariables = Exact<{
  where?: InputMaybe<BotRun_Filter>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AutomationBotRunsQuery = { __typename?: 'Query', botRunListWithOffset: Array<{ __typename?: 'BotRun', id: string, displayId: string, botType: BotType, status: string, currentPhase?: string | null, relatedEntityType?: string | null, relatedEntityId?: string | null, startedAt?: any | null, interventionReason?: string | null, workerEvent?: { __typename?: 'WorkerEvent', id: string, displayId: string, jobType: string, status: string } | null } | null> };

export type AutomationOverridesQueryVariables = Exact<{
  where?: InputMaybe<SnapshotOverride_Filter>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AutomationOverridesQuery = { __typename?: 'Query', snapshotOverrideListWithOffset: Array<{ __typename?: 'SnapshotOverride', id: string, version_: string, path: string, value: any, note: string, active: boolean, createdAt_: any, createdBy_: { __typename?: 'User', email: string } } | null> };

export type AutomationOverrideCreateMutationVariables = Exact<{
  relatedEntityType: Scalars['String']['input'];
  relatedEntityId: Scalars['String']['input'];
  path: Scalars['String']['input'];
  value: Scalars['Json']['input'];
  note: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type AutomationOverrideCreateMutation = { __typename?: 'Mutation', snapshotOverrideCreate: { __typename?: 'SnapshotOverride', id: string } };

export type AutomationOverrideSetActiveMutationVariables = Exact<{
  id: Scalars['String']['input'];
  version_: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type AutomationOverrideSetActiveMutation = { __typename?: 'Mutation', snapshotOverrideUpdate: { __typename?: 'SnapshotOverride', id: string, version_: string, active: boolean } };

export type AutomationHistoryQueryVariables = Exact<{
  since: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AutomationHistoryQuery = { __typename?: 'Query', workerEventListWithOffset: Array<{ __typename?: 'WorkerEvent', id: string, jobType: string, status: string, enqueuedAt: any, retryCount: number } | null> };

export type EditionsPendingSignatureCompletionQueryVariables = Exact<{ [key: string]: never; }>;


export type EditionsPendingSignatureCompletionQuery = { __typename?: 'Query', editionsPendingSignatureCompletion: Array<{ __typename?: 'EditionPendingCompletion', editionId: string, name?: string | null, version: number, totalDocs: number, completedDocs: number, allComplete: boolean, unlinkedSignatures: number }> };

export type SimulationStartMutationVariables = Exact<{
  relatedEntityType: Scalars['String']['input'];
  relatedEntityId: Scalars['ID']['input'];
  mode: Scalars['String']['input'];
  scenario?: InputMaybe<Scalars['Json']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
}>;


export type SimulationStartMutation = { __typename?: 'Mutation', simulationStart: { __typename?: 'SimulationStartResult', sessionId: string } };

export type SimulationResetMutationVariables = Exact<{
  relatedEntityType: Scalars['String']['input'];
  relatedEntityId: Scalars['ID']['input'];
}>;


export type SimulationResetMutation = { __typename?: 'Mutation', simulationReset: { __typename?: 'SimulationResetResult', ok: boolean } };

export type SimulationControlMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  gate?: InputMaybe<Scalars['String']['input']>;
  action: Scalars['String']['input'];
  faultType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SimulationControlMutation = { __typename?: 'Mutation', simulationControl: { __typename?: 'SimulationControlResult', ok: boolean } };

export type SimSessionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SimSessionQuery = { __typename?: 'Query', simulationSessionOne: { __typename?: 'SimulationSession', id: string, status: string, mode: string, label?: string | null, currentGate?: string | null, resolvedGates?: any | null, relatedEntityId?: string | null, relatedEntityType?: string | null } };

export type SimActiveSessionsQueryVariables = Exact<{
  where?: InputMaybe<SimulationSession_Filter>;
  orderBy?: InputMaybe<Array<SimulationSession_OrderBy> | SimulationSession_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SimActiveSessionsQuery = { __typename?: 'Query', simulationSessionListWithOffset: Array<{ __typename?: 'SimulationSession', id: string, status: string, mode: string, currentGate?: string | null, relatedEntityId?: string | null } | null> };

export type SimEditionsQueryVariables = Exact<{
  where?: InputMaybe<SignedEdition_Filter>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SimEditionsQuery = { __typename?: 'Query', signedEditionListWithOffset: Array<{ __typename?: 'SignedEdition', id: string, displayId: string, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string }, data_: { __typename?: 'SignedEditionData', name?: string | null } } | null> };

export type SimEditionStateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SimEditionStateQuery = { __typename?: 'Query', signedEditionOne: { __typename?: 'SignedEdition', id: string, dndaState: { __typename?: 'SignedEditionDndaWorkflowState', id: string }, sadaicState: { __typename?: 'SignedEditionSadaicWorkflowState', id: string }, data_: { __typename?: 'SignedEditionData', name?: string | null } } };

export type SimWorkerEventsQueryVariables = Exact<{
  where?: InputMaybe<WorkerEvent_Filter>;
  orderBy?: InputMaybe<Array<WorkerEvent_OrderBy> | WorkerEvent_OrderBy>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SimWorkerEventsQuery = { __typename?: 'Query', workerEventListWithOffset: Array<{ __typename?: 'WorkerEvent', id: string, displayId: string, jobType: string, status: string, retryCount: number, manualRetryCount: number, nextRetryAt?: any | null, error?: any | null, enqueuedAt: any, payload: any } | null> };

export type SimBotRunsQueryVariables = Exact<{
  where?: InputMaybe<BotRun_Filter>;
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type SimBotRunsQuery = { __typename?: 'Query', botRunListWithOffset: Array<{ __typename?: 'BotRun', id: string, status: string, botType: BotType, currentPhase?: string | null, displayId: string } | null> };

export type EditionDocumentationWorkflow_GenerateDocumentationMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_GenerateDocumentationMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_GenerateDocumentation: { __typename?: 'EditionDocumentationWorkflow_GenerateDocumentationResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_DeleteAndRestartFromSignatureMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_DeleteAndRestartFromSignatureMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_DeleteAndRestartFromSignature: { __typename?: 'EditionDocumentationWorkflow_DeleteAndRestartFromSignatureResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_CancelGenerationMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_CancelGenerationMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_CancelGeneration: { __typename?: 'EditionDocumentationWorkflow_CancelGenerationResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_DeleteAndRestartFromGenerated: { __typename?: 'EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_DeleteAndRestartFromFailedMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_DeleteAndRestartFromFailedMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_DeleteAndRestartFromFailed: { __typename?: 'EditionDocumentationWorkflow_DeleteAndRestartFromFailedResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_RetryGenerateDocumentationMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_RetryGenerateDocumentationMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_RetryGenerateDocumentation: { __typename?: 'EditionDocumentationWorkflow_RetryGenerateDocumentationResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_SendForSignatureMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_SendForSignatureMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_SendForSignature: { __typename?: 'EditionDocumentationWorkflow_SendForSignatureResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_CancelSendingMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_CancelSendingMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_CancelSending: { __typename?: 'EditionDocumentationWorkflow_CancelSendingResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_RetrySendForSignatureMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_RetrySendForSignatureMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_RetrySendForSignature: { __typename?: 'EditionDocumentationWorkflow_RetrySendForSignatureResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_BackToDocsFromSignatureFailedMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_BackToDocsFromSignatureFailedMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_BackToDocsFromSignatureFailed: { __typename?: 'EditionDocumentationWorkflow_BackToDocsFromSignatureFailedResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_BorrarDocumentacionFromFalloMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_BorrarDocumentacionFromFalloMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_BorrarDocumentacionFromFallo: { __typename?: 'EditionDocumentationWorkflow_BorrarDocumentacionFromFalloResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_ReintentarCierreFirmasMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_ReintentarCierreFirmasMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_ReintentarCierreFirmas: { __typename?: 'EditionDocumentationWorkflow_ReintentarCierreFirmasResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct: { __typename?: 'EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarMutation = { __typename?: 'Mutation', editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar: { __typename?: 'EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type ShowcaseWorkflow_SubmitMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type ShowcaseWorkflow_SubmitMutation = { __typename?: 'Mutation', showcaseWorkflow_Submit: { __typename?: 'ShowcaseWorkflow_SubmitResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type ShowcaseWorkflow_ApproveMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type ShowcaseWorkflow_ApproveMutation = { __typename?: 'Mutation', showcaseWorkflow_Approve: { __typename?: 'ShowcaseWorkflow_ApproveResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type ShowcaseWorkflow_RejectMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type ShowcaseWorkflow_RejectMutation = { __typename?: 'Mutation', showcaseWorkflow_Reject: { __typename?: 'ShowcaseWorkflow_RejectResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type ShowcaseWorkflow_FailMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type ShowcaseWorkflow_FailMutation = { __typename?: 'Mutation', showcaseWorkflow_Fail: { __typename?: 'ShowcaseWorkflow_FailResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type ShowcaseWorkflow_RetryMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type ShowcaseWorkflow_RetryMutation = { __typename?: 'Mutation', showcaseWorkflow_Retry: { __typename?: 'ShowcaseWorkflow_RetryResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type ShowcaseWorkflow_CloseMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type ShowcaseWorkflow_CloseMutation = { __typename?: 'Mutation', showcaseWorkflow_Close: { __typename?: 'ShowcaseWorkflow_CloseResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type ShowcaseWorkflow_ReopenMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type ShowcaseWorkflow_ReopenMutation = { __typename?: 'Mutation', showcaseWorkflow_Reopen: { __typename?: 'ShowcaseWorkflow_ReopenResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadMutation = { __typename?: 'Mutation', signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload: { __typename?: 'SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarMutation = { __typename?: 'Mutation', signedEditionDndaWorkflow_ReintentarGeneracionEjemplar: { __typename?: 'SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type SignedEditionDndaWorkflow_ReintentarRegistroDndaMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type SignedEditionDndaWorkflow_ReintentarRegistroDndaMutation = { __typename?: 'Mutation', signedEditionDndaWorkflow_ReintentarRegistroDnda: { __typename?: 'SignedEditionDndaWorkflow_ReintentarRegistroDndaResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type SignedEditionDndaWorkflow_ReintentarUploadEjemplarMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type SignedEditionDndaWorkflow_ReintentarUploadEjemplarMutation = { __typename?: 'Mutation', signedEditionDndaWorkflow_ReintentarUploadEjemplar: { __typename?: 'SignedEditionDndaWorkflow_ReintentarUploadEjemplarResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type SignedEditionDndaWorkflow_ReintentarAvanceRegistroMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type SignedEditionDndaWorkflow_ReintentarAvanceRegistroMutation = { __typename?: 'Mutation', signedEditionDndaWorkflow_ReintentarAvanceRegistro: { __typename?: 'SignedEditionDndaWorkflow_ReintentarAvanceRegistroResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type SignedEditionDndaWorkflow_ReintentarAvanceUploadMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type SignedEditionDndaWorkflow_ReintentarAvanceUploadMutation = { __typename?: 'Mutation', signedEditionDndaWorkflow_ReintentarAvanceUpload: { __typename?: 'SignedEditionDndaWorkflow_ReintentarAvanceUploadResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };

export type SignedEditionSadaicWorkflow_ReintentarSubidaSadaicMutationVariables = Exact<{
  instanceId: Scalars['String']['input'];
  instanceVersion: Scalars['String']['input'];
  instanceEntity: Scalars['String']['input'];
}>;


export type SignedEditionSadaicWorkflow_ReintentarSubidaSadaicMutation = { __typename?: 'Mutation', signedEditionSadaicWorkflow_ReintentarSubidaSadaic: { __typename?: 'SignedEditionSadaicWorkflow_ReintentarSubidaSadaicResult', instanceId: string, instanceVersion: string, instanceState: string, nextTransitions: Array<string | null> } };


export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    accessToken
    refreshToken
    accessExpiresIn
    refreshExpiresIn
    twoFaRequired
    twoFaAction
    tempToken
  }
}
    `;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    accessToken
    refreshToken
    accessExpiresIn
    refreshExpiresIn
  }
}
    `;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export const SaveProfileDocument = gql`
    mutation SaveProfile($key: [String!]!, $value: Json!) {
  saveProfile(key: $key, value: $value)
}
    `;
export const SetMyLanguageDocument = gql`
    mutation SetMyLanguage($language: Language!) {
  setMyLanguage(language: $language) {
    id
    language
  }
}
    `;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  userChangePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    id
  }
}
    `;
export const UserResetPasswordDocument = gql`
    mutation UserResetPassword($email: String!) {
  userResetPassword(email: $email) {
    id
  }
}
    `;
export const SetupTwoFaDocument = gql`
    mutation SetupTwoFa($tempToken: String!) {
  setupTwoFa(tempToken: $tempToken) {
    qrCodeDataUrl
    secret
    backupCodes
  }
}
    `;
export const ConfirmTwoFaSetupDocument = gql`
    mutation ConfirmTwoFaSetup($tempToken: String!, $code: String!, $rememberDevice: Boolean) {
  confirmTwoFaSetup(
    tempToken: $tempToken
    code: $code
    rememberDevice: $rememberDevice
  ) {
    accessToken
    refreshToken
    accessExpiresIn
    refreshExpiresIn
  }
}
    `;
export const VerifyTwoFaDocument = gql`
    mutation VerifyTwoFa($tempToken: String!, $code: String!, $rememberDevice: Boolean) {
  verifyTwoFa(tempToken: $tempToken, code: $code, rememberDevice: $rememberDevice) {
    accessToken
    refreshToken
    accessExpiresIn
    refreshExpiresIn
  }
}
    `;
export const VerifyTwoFaBackupCodeDocument = gql`
    mutation VerifyTwoFaBackupCode($tempToken: String!, $code: String!, $rememberDevice: Boolean) {
  verifyTwoFaBackupCode(
    tempToken: $tempToken
    code: $code
    rememberDevice: $rememberDevice
  ) {
    accessToken
    refreshToken
    accessExpiresIn
    refreshExpiresIn
  }
}
    `;
export const UpdateMyAvatarDocument = gql`
    mutation UpdateMyAvatar($avatar: UploadedFile) {
  updateMyAvatar(avatar: $avatar) {
    id
    avatar
    avatar_data {
      name
      mimetype
      url
      size
    }
  }
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    id
    name
    email
    language
    role {
      id
      audience
      name_es
      name_en
      name_pt
      permissions {
        id
        name_es
        name_en
        name_pt
      }
    }
    profile
    avatar
    avatar_data {
      name
      mimetype
      url
      size
    }
    company {
      id
      name
      logo
      logo_data {
        name
        mimetype
        url
        size
      }
      extra
    }
  }
}
    `;
export const MyTrustedDevicesDocument = gql`
    query MyTrustedDevices {
  myTrustedDevices {
    id
    browserName
    browserVersion
    osName
    deviceType
    ipAddress
    lastUsedAt
    createdAt
    expiresAt
  }
}
    `;
export const RevokeTrustedDeviceDocument = gql`
    mutation RevokeTrustedDevice($id: String!) {
  revokeTrustedDevice(id: $id)
}
    `;
export const RevokeAllTrustedDevicesDocument = gql`
    mutation RevokeAllTrustedDevices {
  revokeAllTrustedDevices
}
    `;
export const DeletionBlockersDocument = gql`
    query deletionBlockers($entity: String!, $id: ID!) {
  deletionBlockers(entity: $entity, id: $id) {
    entity
    id
    blocked
    reasons {
      kind
      rootEntity
      relations
      visible {
        count
        items {
          id
          nameText
          nameI18n
        }
      }
      hiddenInTenant
      otherTenants
    }
  }
}
    `;
export const FileUploadDocument = gql`
    mutation fileUpload($file: Upload!) {
  singleUpload(file: $file) {
    ticket
    filename
    mimetype
    encoding
  }
}
    `;
export const DeleteUploadedFileDocument = gql`
    mutation deleteUploadedFile($ticket: String!) {
  deleteUploadedFile(ticket: $ticket)
}
    `;
export const MarkNotificationReadDocument = gql`
    mutation markNotificationRead($id: ID!) {
  markNotificationRead(id: $id) {
    success
    error
  }
}
    `;
export const MarkAllNotificationsReadDocument = gql`
    mutation markAllNotificationsRead {
  markAllNotificationsRead
}
    `;
export const ArchiveNotificationDocument = gql`
    mutation archiveNotification($id: ID!) {
  archiveNotification(id: $id) {
    success
    error
  }
}
    `;
export const PreviewThemeDocument = gql`
    mutation previewTheme($authoring: Json!) {
  previewTheme(authoring: $authoring) {
    warnings
  }
}
    `;
export const ApplyThemeDocument = gql`
    mutation applyTheme($authoring: Json!, $name: String!) {
  applyTheme(authoring: $authoring, name: $name) {
    id
    name
    active
  }
}
    `;
export const DeactivateThemeDocument = gql`
    mutation deactivateTheme {
  deactivateTheme
}
    `;
export const ListThemesDocument = gql`
    query listThemes {
  listThemes {
    id
    name
    active
    authoring
  }
}
    `;
export const SaveThemeDocument = gql`
    mutation saveTheme($authoring: Json!, $name: String!) {
  saveTheme(authoring: $authoring, name: $name) {
    id
    name
    active
  }
}
    `;
export const DeleteThemeDocument = gql`
    mutation deleteTheme($name: String!) {
  deleteTheme(name: $name)
}
    `;
export const WorkerEventRetryDocument = gql`
    mutation workerEventRetry($id: ID!, $mode: String, $overrides: Json) {
  workerEventRetry(id: $id, mode: $mode, overrides: $overrides) {
    newWorkerEventId
  }
}
    `;
export const WorkerEventRetryInfoDocument = gql`
    query workerEventRetryInfo($id: ID!) {
  workerEventRetryInfo(id: $id) {
    canRetry
    reason
    modes
    editableFields
    currentValues
  }
}
    `;
export const AiSearchAutoEvalDeleteDocument = gql`
    mutation aiSearchAutoEvalDelete($id: String!) {
  aiSearchAutoEvalDelete(id: $id) {
    id
  }
}
    `;
export const AiSearchAutoEvalOneDocument = gql`
    query aiSearchAutoEvalOne($id: String!) {
  aiSearchAutoEvalOne(id: $id) {
    id
    version_
    runId
    queryIndex
    condition
    includeSchema
    includeExamples
    query
    pathType
    expectedTool
    expectedEntity
    actualTool
    actualEntity
    actualArgs
    l1Pass
    l2Pass
    errorType
    totalTimeMs
    llmCallCount
    toolCallCount
    tokenCount
    llmResponse
    toolCalls
    evaluatedAt
    hadDisambiguation
    disambiguationType
    disambiguationResponse
    patternsApplied
    l3Efficiency
    l4Redundancy
    l5Disambiguation
    l6ResponseQuality
    overallScore
    judgeEvaluation
    redundantCalls
    actualCallCount
    optimalCallCount
    sequenceMatchedOptimal
    response
  }
}
    `;
export const AiSearchAutoEvalListWithOffsetDocument = gql`
    query aiSearchAutoEvalListWithOffset($where: AiSearchAutoEval_Filter, $orderBy: [AiSearchAutoEval_OrderBy!], $offset: Int!, $take: Int!) {
  aiSearchAutoEvalListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    runId
    queryIndex
    condition
    includeSchema
    includeExamples
    query
    pathType
    expectedTool
    expectedEntity
    actualTool
    actualEntity
    actualArgs
    l1Pass
    l2Pass
    errorType
    totalTimeMs
    llmCallCount
    toolCallCount
    tokenCount
    llmResponse
    toolCalls
    evaluatedAt
    hadDisambiguation
    disambiguationType
    disambiguationResponse
    patternsApplied
    l3Efficiency
    l4Redundancy
    l5Disambiguation
    l6ResponseQuality
    overallScore
    judgeEvaluation
    redundantCalls
    actualCallCount
    optimalCallCount
    sequenceMatchedOptimal
    response
  }
}
    `;
export const AiSearchAutoEvalListWithCursorDocument = gql`
    query aiSearchAutoEvalListWithCursor($where: AiSearchAutoEval_Filter, $orderBy: AiSearchAutoEval_OrderByCursor!, $cursorKey: String, $take: Int!) {
  aiSearchAutoEvalListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    runId
    queryIndex
    condition
    includeSchema
    includeExamples
    query
    pathType
    expectedTool
    expectedEntity
    actualTool
    actualEntity
    actualArgs
    l1Pass
    l2Pass
    errorType
    totalTimeMs
    llmCallCount
    toolCallCount
    tokenCount
    llmResponse
    toolCalls
    evaluatedAt
    hadDisambiguation
    disambiguationType
    disambiguationResponse
    patternsApplied
    l3Efficiency
    l4Redundancy
    l5Disambiguation
    l6ResponseQuality
    overallScore
    judgeEvaluation
    redundantCalls
    actualCallCount
    optimalCallCount
    sequenceMatchedOptimal
    response
  }
}
    `;
export const AiSearchConversationDeleteDocument = gql`
    mutation aiSearchConversationDelete($id: String!) {
  aiSearchConversationDelete(id: $id) {
    id
  }
}
    `;
export const AiSearchConversationOneDocument = gql`
    query aiSearchConversationOne($id: String!) {
  aiSearchConversationOne(id: $id) {
    id
    version_
    startedAt
    lastMessageAt
    messageCount
    messages
    context
  }
}
    `;
export const AiSearchConversationListWithOffsetDocument = gql`
    query aiSearchConversationListWithOffset($where: AiSearchConversation_Filter, $orderBy: [AiSearchConversation_OrderBy!], $offset: Int!, $take: Int!) {
  aiSearchConversationListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    startedAt
    lastMessageAt
    messageCount
    messages
    context
  }
}
    `;
export const AiSearchConversationListWithCursorDocument = gql`
    query aiSearchConversationListWithCursor($where: AiSearchConversation_Filter, $orderBy: AiSearchConversation_OrderByCursor!, $cursorKey: String, $take: Int!) {
  aiSearchConversationListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    startedAt
    lastMessageAt
    messageCount
    messages
    context
  }
}
    `;
export const AiSearchPatternCreateDocument = gql`
    mutation aiSearchPatternCreate($name: String!, $description: String!, $pattern: String!, $pathTypes: [String!], $tools: [String!], $effectiveness: Decimal, $evaluationCount: Int!, $successCount: Int!, $sourceEvalIds: [String!], $proposedBy: String, $active: Boolean!, $priority: Int!, $idempotencyKey_: String) {
  aiSearchPatternCreate(
    name: $name
    description: $description
    pattern: $pattern
    pathTypes: $pathTypes
    tools: $tools
    effectiveness: $effectiveness
    evaluationCount: $evaluationCount
    successCount: $successCount
    sourceEvalIds: $sourceEvalIds
    proposedBy: $proposedBy
    active: $active
    priority: $priority
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const AiSearchPatternUpdateDocument = gql`
    mutation aiSearchPatternUpdate($id: String!, $version_: String!, $name: String!, $description: String!, $pattern: String!, $pathTypes: [String!], $tools: [String!], $effectiveness: Decimal, $evaluationCount: Int!, $successCount: Int!, $sourceEvalIds: [String!], $proposedBy: String, $active: Boolean!, $priority: Int!, $idempotencyKey_: String) {
  aiSearchPatternUpdate(
    id: $id
    version_: $version_
    name: $name
    description: $description
    pattern: $pattern
    pathTypes: $pathTypes
    tools: $tools
    effectiveness: $effectiveness
    evaluationCount: $evaluationCount
    successCount: $successCount
    sourceEvalIds: $sourceEvalIds
    proposedBy: $proposedBy
    active: $active
    priority: $priority
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const AiSearchPatternDeleteDocument = gql`
    mutation aiSearchPatternDelete($id: String!) {
  aiSearchPatternDelete(id: $id) {
    id
  }
}
    `;
export const AiSearchPatternOneDocument = gql`
    query aiSearchPatternOne($id: String!) {
  aiSearchPatternOne(id: $id) {
    id
    version_
    name
    description
    pattern
    pathTypes
    tools
    effectiveness
    evaluationCount
    successCount
    sourceEvalIds
    proposedBy
    active
    priority
  }
}
    `;
export const AiSearchPatternListWithOffsetDocument = gql`
    query aiSearchPatternListWithOffset($where: AiSearchPattern_Filter, $orderBy: [AiSearchPattern_OrderBy!], $offset: Int!, $take: Int!) {
  aiSearchPatternListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    description
    pattern
    pathTypes
    tools
    effectiveness
    evaluationCount
    successCount
    sourceEvalIds
    proposedBy
    active
    priority
  }
}
    `;
export const AiSearchPatternListWithCursorDocument = gql`
    query aiSearchPatternListWithCursor($where: AiSearchPattern_Filter, $orderBy: AiSearchPattern_OrderByCursor!, $cursorKey: String, $take: Int!) {
  aiSearchPatternListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    description
    pattern
    pathTypes
    tools
    effectiveness
    evaluationCount
    successCount
    sourceEvalIds
    proposedBy
    active
    priority
  }
}
    `;
export const AiSearchResponseCreateDocument = gql`
    mutation aiSearchResponseCreate($conversationId: String!, $query: String!, $response: String!, $sources: Json, $explanation: Json, $tokenUsage: Json, $rating: EvaluationRating, $evaluatedAt: DateTime, $evaluatedById: String, $toolCalls: [AiSearchToolCall_CreateInput!]!, $idempotencyKey_: String) {
  aiSearchResponseCreate(
    conversationId: $conversationId
    query: $query
    response: $response
    sources: $sources
    explanation: $explanation
    tokenUsage: $tokenUsage
    rating: $rating
    evaluatedAt: $evaluatedAt
    evaluatedById: $evaluatedById
    toolCalls: $toolCalls
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const AiSearchResponseDeleteDocument = gql`
    mutation aiSearchResponseDelete($id: String!) {
  aiSearchResponseDelete(id: $id) {
    id
  }
}
    `;
export const AiSearchResponseOneDocument = gql`
    query aiSearchResponseOne($id: String!) {
  aiSearchResponseOne(id: $id) {
    id
    version_
    conversation {
      id
      version_
      startedAt
      lastMessageAt
      messageCount
      messages
      context
    }
    query
    response
    sources
    explanation
    tokenUsage
    createdAt
    rating
    evaluatedAt
    evaluatedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    toolCalls {
      id
      version_
      sequence
      toolName
      pattern
      navigationPath
      toolArguments
      result
      durationMs
      success
      errorMessage
    }
  }
}
    `;
export const AiSearchResponseListWithOffsetDocument = gql`
    query aiSearchResponseListWithOffset($where: AiSearchResponse_Filter, $orderBy: [AiSearchResponse_OrderBy!], $offset: Int!, $take: Int!) {
  aiSearchResponseListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    conversation {
      id
      version_
      startedAt
      lastMessageAt
      messageCount
      messages
      context
    }
    query
    response
    sources
    explanation
    tokenUsage
    createdAt
    rating
    evaluatedAt
    evaluatedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    toolCalls {
      id
      version_
      sequence
      toolName
      pattern
      navigationPath
      toolArguments
      result
      durationMs
      success
      errorMessage
    }
  }
}
    `;
export const AiSearchResponseListWithCursorDocument = gql`
    query aiSearchResponseListWithCursor($where: AiSearchResponse_Filter, $orderBy: AiSearchResponse_OrderByCursor!, $cursorKey: String, $take: Int!) {
  aiSearchResponseListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    conversation {
      id
      version_
      startedAt
      lastMessageAt
      messageCount
      messages
      context
    }
    query
    response
    sources
    explanation
    tokenUsage
    createdAt
    rating
    evaluatedAt
    evaluatedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    toolCalls {
      id
      version_
      sequence
      toolName
      pattern
      navigationPath
      toolArguments
      result
      durationMs
      success
      errorMessage
    }
  }
}
    `;
export const AiSearchToolCallOneDocument = gql`
    query aiSearchToolCallOne($id: String!) {
  aiSearchToolCallOne(id: $id) {
    id
    version_
    sequence
    toolName
    pattern
    navigationPath
    toolArguments
    result
    durationMs
    success
    errorMessage
  }
}
    `;
export const AiSearchToolCallListWithOffsetDocument = gql`
    query aiSearchToolCallListWithOffset($where: AiSearchToolCall_Filter, $orderBy: [AiSearchToolCall_OrderBy!], $offset: Int!, $take: Int!) {
  aiSearchToolCallListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    sequence
    toolName
    pattern
    navigationPath
    toolArguments
    result
    durationMs
    success
    errorMessage
  }
}
    `;
export const AiSearchToolCallListWithCursorDocument = gql`
    query aiSearchToolCallListWithCursor($where: AiSearchToolCall_Filter, $orderBy: AiSearchToolCall_OrderByCursor!, $cursorKey: String, $take: Int!) {
  aiSearchToolCallListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    sequence
    toolName
    pattern
    navigationPath
    toolArguments
    result
    durationMs
    success
    errorMessage
  }
}
    `;
export const AlertRuleCreateDocument = gql`
    mutation alertRuleCreate($alertType: String!, $enabled: Boolean!, $params: Json, $idempotencyKey_: String) {
  alertRuleCreate(
    alertType: $alertType
    enabled: $enabled
    params: $params
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const AlertRuleUpdateDocument = gql`
    mutation alertRuleUpdate($id: String!, $version_: String!, $alertType: String!, $enabled: Boolean!, $params: Json, $idempotencyKey_: String) {
  alertRuleUpdate(
    id: $id
    version_: $version_
    alertType: $alertType
    enabled: $enabled
    params: $params
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const AlertRuleDeleteDocument = gql`
    mutation alertRuleDelete($id: String!) {
  alertRuleDelete(id: $id) {
    id
  }
}
    `;
export const AlertRuleOneDocument = gql`
    query alertRuleOne($id: String!) {
  alertRuleOne(id: $id) {
    id
    version_
    alertType
    enabled
    params
  }
}
    `;
export const AlertRuleListWithOffsetDocument = gql`
    query alertRuleListWithOffset($where: AlertRule_Filter, $orderBy: [AlertRule_OrderBy!], $offset: Int!, $take: Int!) {
  alertRuleListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    alertType
    enabled
    params
  }
}
    `;
export const AlertRuleListWithCursorDocument = gql`
    query alertRuleListWithCursor($where: AlertRule_Filter, $orderBy: AlertRule_OrderByCursor!, $cursorKey: String, $take: Int!) {
  alertRuleListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    alertType
    enabled
    params
  }
}
    `;
export const AlertSubscriptionCreateDocument = gql`
    mutation alertSubscriptionCreate($alertRuleId: String!, $enabled: Boolean!, $idempotencyKey_: String) {
  alertSubscriptionCreate(
    alertRuleId: $alertRuleId
    enabled: $enabled
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const AlertSubscriptionUpdateDocument = gql`
    mutation alertSubscriptionUpdate($id: String!, $version_: String!, $alertRuleId: String!, $enabled: Boolean!, $idempotencyKey_: String) {
  alertSubscriptionUpdate(
    id: $id
    version_: $version_
    alertRuleId: $alertRuleId
    enabled: $enabled
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const AlertSubscriptionDeleteDocument = gql`
    mutation alertSubscriptionDelete($id: String!) {
  alertSubscriptionDelete(id: $id) {
    id
  }
}
    `;
export const AlertSubscriptionOneDocument = gql`
    query alertSubscriptionOne($id: String!) {
  alertSubscriptionOne(id: $id) {
    id
    version_
    alertRule {
      id
      version_
      alertType
      enabled
      params
    }
    enabled
  }
}
    `;
export const AlertSubscriptionListWithOffsetDocument = gql`
    query alertSubscriptionListWithOffset($where: AlertSubscription_Filter, $orderBy: [AlertSubscription_OrderBy!], $offset: Int!, $take: Int!) {
  alertSubscriptionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    alertRule {
      id
      version_
      alertType
      enabled
      params
    }
    enabled
  }
}
    `;
export const AlertSubscriptionListWithCursorDocument = gql`
    query alertSubscriptionListWithCursor($where: AlertSubscription_Filter, $orderBy: AlertSubscription_OrderByCursor!, $cursorKey: String, $take: Int!) {
  alertSubscriptionListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    alertRule {
      id
      version_
      alertType
      enabled
      params
    }
    enabled
  }
}
    `;
export const AssociatedDocumentEditionOneDocument = gql`
    query associatedDocumentEditionOne($id: String!) {
  associatedDocumentEditionOne(id: $id) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    type {
      id
      version_
      name
    }
    notes
    publisherConfigurationDisplay
    authorsDisplay
  }
}
    `;
export const AssociatedDocumentEditionListWithOffsetDocument = gql`
    query associatedDocumentEditionListWithOffset($where: AssociatedDocumentEdition_Filter, $orderBy: [AssociatedDocumentEdition_OrderBy!], $offset: Int!, $take: Int!) {
  associatedDocumentEditionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    type {
      id
      version_
      name
    }
    notes
    publisherConfigurationDisplay
    authorsDisplay
  }
}
    `;
export const AssociatedDocumentEditionListWithCursorDocument = gql`
    query associatedDocumentEditionListWithCursor($where: AssociatedDocumentEdition_Filter, $orderBy: AssociatedDocumentEdition_OrderByCursor!, $cursorKey: String, $take: Int!) {
  associatedDocumentEditionListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    type {
      id
      version_
      name
    }
    notes
    publisherConfigurationDisplay
    authorsDisplay
  }
}
    `;
export const AssociatedDocumentSignedEditionOneDocument = gql`
    query associatedDocumentSignedEditionOne($id: String!) {
  associatedDocumentSignedEditionOne(id: $id) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const AssociatedDocumentSignedEditionListWithOffsetDocument = gql`
    query associatedDocumentSignedEditionListWithOffset($where: AssociatedDocumentSignedEdition_Filter, $orderBy: [AssociatedDocumentSignedEdition_OrderBy!], $offset: Int!, $take: Int!) {
  associatedDocumentSignedEditionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const AssociatedDocumentSignedEditionListWithCursorDocument = gql`
    query associatedDocumentSignedEditionListWithCursor($where: AssociatedDocumentSignedEdition_Filter, $orderBy: AssociatedDocumentSignedEdition_OrderByCursor!, $cursorKey: String, $take: Int!) {
  associatedDocumentSignedEditionListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const AuthorCollectingSocietyOneDocument = gql`
    query authorCollectingSocietyOne($id: String!) {
  authorCollectingSocietyOne(id: $id) {
    id
    version_
    collectingSociety {
      id
      version_
      name
      acronym
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    memberNumber
    territories {
      id
      version_
      name_es
      name_en
      name_pt
    }
  }
}
    `;
export const AuthorCollectingSocietyListWithOffsetDocument = gql`
    query authorCollectingSocietyListWithOffset($where: AuthorCollectingSociety_Filter, $orderBy: [AuthorCollectingSociety_OrderBy!], $offset: Int!, $take: Int!) {
  authorCollectingSocietyListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    collectingSociety {
      id
      version_
      name
      acronym
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    memberNumber
    territories {
      id
      version_
      name_es
      name_en
      name_pt
    }
  }
}
    `;
export const AuthorCollectingSocietyListWithCursorDocument = gql`
    query authorCollectingSocietyListWithCursor($where: AuthorCollectingSociety_Filter, $orderBy: AuthorCollectingSociety_OrderByCursor!, $cursorKey: String, $take: Int!) {
  authorCollectingSocietyListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    collectingSociety {
      id
      version_
      name
      acronym
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    memberNumber
    territories {
      id
      version_
      name_es
      name_en
      name_pt
    }
  }
}
    `;
export const AuthorComposerCreateDocument = gql`
    mutation authorComposerCreate($firstName: String!, $lastName: String!, $gender: Gender, $taxIdType: TaxIdType, $taxId: String, $email: String!, $phone: String, $nationalityId: String, $dateOfBirth: Date, $streetAndNumber: String, $floor: String, $suite: String, $postalCode: String, $countryId: String, $provinceId: String, $city: String, $aka: String, $ipi: String, $managementSocieties: [AuthorCollectingSociety_CreateInput!], $publishers: [AuthorPublisher_CreateInput!], $idempotencyKey_: String) {
  authorComposerCreate(
    firstName: $firstName
    lastName: $lastName
    gender: $gender
    taxIdType: $taxIdType
    taxId: $taxId
    email: $email
    phone: $phone
    nationalityId: $nationalityId
    dateOfBirth: $dateOfBirth
    streetAndNumber: $streetAndNumber
    floor: $floor
    suite: $suite
    postalCode: $postalCode
    countryId: $countryId
    provinceId: $provinceId
    city: $city
    aka: $aka
    ipi: $ipi
    managementSocieties: $managementSocieties
    publishers: $publishers
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const AuthorComposerUpdateDocument = gql`
    mutation authorComposerUpdate($id: String!, $version_: String!, $firstName: String!, $lastName: String!, $gender: Gender, $taxIdType: TaxIdType, $taxId: String, $email: String!, $phone: String, $nationalityId: String, $dateOfBirth: Date, $streetAndNumber: String, $floor: String, $suite: String, $postalCode: String, $countryId: String, $provinceId: String, $city: String, $aka: String, $ipi: String, $managementSocieties: AuthorComposer_managementSocieties_UpdateInput, $publishers: AuthorComposer_publishers_UpdateInput, $idempotencyKey_: String) {
  authorComposerUpdate(
    id: $id
    version_: $version_
    firstName: $firstName
    lastName: $lastName
    gender: $gender
    taxIdType: $taxIdType
    taxId: $taxId
    email: $email
    phone: $phone
    nationalityId: $nationalityId
    dateOfBirth: $dateOfBirth
    streetAndNumber: $streetAndNumber
    floor: $floor
    suite: $suite
    postalCode: $postalCode
    countryId: $countryId
    provinceId: $provinceId
    city: $city
    aka: $aka
    ipi: $ipi
    managementSocieties: $managementSocieties
    publishers: $publishers
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const AuthorComposerDeleteDocument = gql`
    mutation authorComposerDelete($id: String!) {
  authorComposerDelete(id: $id) {
    id
  }
}
    `;
export const AuthorComposerOneDocument = gql`
    query authorComposerOne($id: String!) {
  authorComposerOne(id: $id) {
    id
    version_
    firstName
    lastName
    gender
    taxIdType
    taxId
    cuitCertificate
    cuitCertificate_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    cuitCertificateIssuedAt
    cuitCertificateError
    cuitCertificateErrorType
    dniDeliveredToSadaicAt
    dniValidatedAt
    dniValidatedFields
    email
    phone
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    dateOfBirth
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    aka
    ipi
    managementSocieties {
      id
      version_
      collectingSociety {
        id
        version_
        name
        acronym
      }
      memberNumber
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
    }
    publishers {
      id
      version_
      publisher {
        id
        version_
        personType
        name
        maritalStatus
        pseudonym
        taxId
        phone
        email
        streetAndNumber
        floor
        suite
        postalCode
        city
        caeIpi
        createdAt_
        lastUpdatedAt_
      }
      percentage
      durationInYears
      autoRenewalYears
    }
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const AuthorComposerListWithOffsetDocument = gql`
    query authorComposerListWithOffset($where: AuthorComposer_Filter, $orderBy: [AuthorComposer_OrderBy!], $offset: Int!, $take: Int!) {
  authorComposerListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    firstName
    lastName
    gender
    taxIdType
    taxId
    cuitCertificate
    cuitCertificate_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    cuitCertificateIssuedAt
    cuitCertificateError
    cuitCertificateErrorType
    dniDeliveredToSadaicAt
    dniValidatedAt
    email
    phone
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    dateOfBirth
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    aka
    ipi
    managementSocieties {
      id
      version_
      collectingSociety {
        id
        version_
        name
        acronym
      }
      memberNumber
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
    }
    publishers {
      id
      version_
      publisher {
        id
        version_
        personType
        name
        maritalStatus
        pseudonym
        taxId
        phone
        email
        streetAndNumber
        floor
        suite
        postalCode
        city
        caeIpi
        createdAt_
        lastUpdatedAt_
      }
      percentage
      durationInYears
      autoRenewalYears
    }
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const AuthorComposerListWithCursorDocument = gql`
    query authorComposerListWithCursor($where: AuthorComposer_Filter, $orderBy: AuthorComposer_OrderByCursor!, $cursorKey: String, $take: Int!) {
  authorComposerListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    firstName
    lastName
    gender
    taxIdType
    taxId
    cuitCertificate
    cuitCertificate_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    cuitCertificateIssuedAt
    cuitCertificateError
    cuitCertificateErrorType
    dniDeliveredToSadaicAt
    dniValidatedAt
    email
    phone
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    dateOfBirth
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    aka
    ipi
    managementSocieties {
      id
      version_
      collectingSociety {
        id
        version_
        name
        acronym
      }
      memberNumber
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
    }
    publishers {
      id
      version_
      publisher {
        id
        version_
        personType
        name
        maritalStatus
        pseudonym
        taxId
        phone
        email
        streetAndNumber
        floor
        suite
        postalCode
        city
        caeIpi
        createdAt_
        lastUpdatedAt_
      }
      percentage
      durationInYears
      autoRenewalYears
    }
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const AuthorComposerPublicCreateDocument = gql`
    mutation authorComposerPublicCreate($firstName: String!, $lastName: String!, $gender: Gender, $taxIdType: TaxIdType, $taxId: String, $email: String!, $phone: String, $nationalityId: String, $dateOfBirth: Date, $streetAndNumber: String, $floor: String, $suite: String, $postalCode: String, $countryId: String, $provinceId: String, $city: String, $aka: String, $ipi: String) {
  authorComposerPublicCreate(
    firstName: $firstName
    lastName: $lastName
    gender: $gender
    taxIdType: $taxIdType
    taxId: $taxId
    email: $email
    phone: $phone
    nationalityId: $nationalityId
    dateOfBirth: $dateOfBirth
    streetAndNumber: $streetAndNumber
    floor: $floor
    suite: $suite
    postalCode: $postalCode
    countryId: $countryId
    provinceId: $provinceId
    city: $city
    aka: $aka
    ipi: $ipi
  ) {
    id
  }
}
    `;
export const AuthorComposerPublicUpdateDocument = gql`
    mutation authorComposerPublicUpdate($id: String!, $version_: String!, $firstName: String, $lastName: String, $gender: Gender, $taxIdType: TaxIdType, $taxId: String, $email: String, $phone: String, $nationalityId: String, $dateOfBirth: Date, $streetAndNumber: String, $floor: String, $suite: String, $postalCode: String, $countryId: String, $provinceId: String, $city: String, $aka: String, $ipi: String) {
  authorComposerPublicUpdate(
    id: $id
    version_: $version_
    firstName: $firstName
    lastName: $lastName
    gender: $gender
    taxIdType: $taxIdType
    taxId: $taxId
    email: $email
    phone: $phone
    nationalityId: $nationalityId
    dateOfBirth: $dateOfBirth
    streetAndNumber: $streetAndNumber
    floor: $floor
    suite: $suite
    postalCode: $postalCode
    countryId: $countryId
    provinceId: $provinceId
    city: $city
    aka: $aka
    ipi: $ipi
  ) {
    id
    version_
  }
}
    `;
export const AuthorComposerPublicDeleteDocument = gql`
    mutation authorComposerPublicDelete($id: String!) {
  authorComposerPublicDelete(id: $id) {
    id
  }
}
    `;
export const AuthorComposerPublicOneDocument = gql`
    query authorComposerPublicOne($id: String!) {
  authorComposerPublicOne(id: $id) {
    id
    version_
    firstName
    lastName
    gender
    taxIdType
    taxId
    email
    phone
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    dateOfBirth
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    aka
    ipi
  }
}
    `;
export const AuthorComposerPublicListWithOffsetDocument = gql`
    query authorComposerPublicListWithOffset($where: AuthorComposer_Filter, $orderBy: [AuthorComposer_OrderBy!], $offset: Int!, $take: Int!) {
  authorComposerPublicListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    firstName
    lastName
    gender
    taxIdType
    taxId
    email
    phone
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    dateOfBirth
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    aka
    ipi
  }
}
    `;
export const AuthorComposerPublicListWithCursorDocument = gql`
    query authorComposerPublicListWithCursor($where: AuthorComposer_Filter, $orderBy: AuthorComposer_OrderByCursor!, $cursorKey: String, $take: Int!) {
  authorComposerPublicListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    firstName
    lastName
    gender
    taxIdType
    taxId
    email
    phone
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    dateOfBirth
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    aka
    ipi
  }
}
    `;
export const AuthorPublisherOneDocument = gql`
    query authorPublisherOne($id: String!) {
  authorPublisherOne(id: $id) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
    durationInYears
    autoRenewalYears
  }
}
    `;
export const AuthorPublisherListWithOffsetDocument = gql`
    query authorPublisherListWithOffset($where: AuthorPublisher_Filter, $orderBy: [AuthorPublisher_OrderBy!], $offset: Int!, $take: Int!) {
  authorPublisherListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
    durationInYears
    autoRenewalYears
  }
}
    `;
export const AuthorPublisherListWithCursorDocument = gql`
    query authorPublisherListWithCursor($where: AuthorPublisher_Filter, $orderBy: AuthorPublisher_OrderByCursor!, $cursorKey: String, $take: Int!) {
  authorPublisherListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
    durationInYears
    autoRenewalYears
  }
}
    `;
export const BotErrorOneDocument = gql`
    query botErrorOne($id: String!) {
  botErrorOne(id: $id) {
    id
    version_
    errorType
    severity
    message
    stackTrace
    context
    recoverable
    requiresHumanIntervention
    screenshot
    screenshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    domSnapshot
    domSnapshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const BotErrorListWithOffsetDocument = gql`
    query botErrorListWithOffset($where: BotError_Filter, $orderBy: [BotError_OrderBy!], $offset: Int!, $take: Int!) {
  botErrorListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    errorType
    severity
    message
    stackTrace
    context
    recoverable
    requiresHumanIntervention
    screenshot
    screenshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    domSnapshot
    domSnapshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const BotErrorListWithCursorDocument = gql`
    query botErrorListWithCursor($where: BotError_Filter, $orderBy: BotError_OrderByCursor!, $cursorKey: String, $take: Int!) {
  botErrorListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    errorType
    severity
    message
    stackTrace
    context
    recoverable
    requiresHumanIntervention
    screenshot
    screenshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    domSnapshot
    domSnapshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const BotPhaseOneDocument = gql`
    query botPhaseOne($id: String!) {
  botPhaseOne(id: $id) {
    id
    version_
    phaseNumber
    phaseId
    phaseName
    status
    stepsTotal
    stepsCompleted
    startedAt
    completedAt
    duration
    error
    stepsLogPath
    screenshot
    screenshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    steps {
      id
      version_
      stepNumber
      stepId
      status
      startedAt
      completedAt
      duration
      error
      downloadedFile
      downloadedFile_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
  }
}
    `;
export const BotPhaseListWithOffsetDocument = gql`
    query botPhaseListWithOffset($where: BotPhase_Filter, $orderBy: [BotPhase_OrderBy!], $offset: Int!, $take: Int!) {
  botPhaseListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    phaseNumber
    phaseId
    phaseName
    status
    stepsTotal
    stepsCompleted
    startedAt
    completedAt
    duration
    error
    stepsLogPath
    screenshot
    screenshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    steps {
      id
      version_
      stepNumber
      stepId
      status
      startedAt
      completedAt
      duration
      error
      downloadedFile
      downloadedFile_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
  }
}
    `;
export const BotPhaseListWithCursorDocument = gql`
    query botPhaseListWithCursor($where: BotPhase_Filter, $orderBy: BotPhase_OrderByCursor!, $cursorKey: String, $take: Int!) {
  botPhaseListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    phaseNumber
    phaseId
    phaseName
    status
    stepsTotal
    stepsCompleted
    startedAt
    completedAt
    duration
    error
    stepsLogPath
    screenshot
    screenshot_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    steps {
      id
      version_
      stepNumber
      stepId
      status
      startedAt
      completedAt
      duration
      error
      downloadedFile
      downloadedFile_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
  }
}
    `;
export const BotRunCancelDocument = gql`
    mutation botRunCancel($botRunId: String!, $force: Boolean) {
  botRunCancel(botRunId: $botRunId, force: $force)
}
    `;
export const BotRunDeleteDocument = gql`
    mutation botRunDelete($id: String!) {
  botRunDelete(id: $id) {
    id
  }
}
    `;
export const BotRunOneDocument = gql`
    query botRunOne($id: String!) {
  botRunOne(id: $id) {
    id
    version_
    botType
    runNumber
    status
    currentPhase
    startedAt
    completedAt
    duration
    params
    result
    error
    correlationId
    totalPhases
    completedPhases
    requiresHumanIntervention
    interventionReason
    logsPath
    workerEvent {
      id
      version_
      queueName
      jobType
      status
      enqueuedAt
      startedAt
      completedAt
      payload
      result
      error
      retryCount
      manualRetryCount
      nextRetryAt
      duration
      correlationId
      triggerUserId {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
    }
    triggeredBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    relatedEntityType
    relatedEntityId
    relatedEntityLabel
    cancellationRequestedAt
    cancellationRequestedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    cancellationReason
    phases {
      id
      version_
      phaseNumber
      phaseId
      phaseName
      status
      stepsTotal
      stepsCompleted
      startedAt
      completedAt
      duration
      error
      stepsLogPath
      screenshot
      screenshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      steps {
        id
        version_
        stepNumber
        stepId
        status
        startedAt
        completedAt
        duration
        error
        downloadedFile
        downloadedFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
    }
    errors {
      id
      version_
      errorType
      severity
      message
      stackTrace
      context
      recoverable
      requiresHumanIntervention
      screenshot
      screenshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      domSnapshot
      domSnapshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
  }
}
    `;
export const BotRunListWithOffsetDocument = gql`
    query botRunListWithOffset($where: BotRun_Filter, $orderBy: [BotRun_OrderBy!], $offset: Int!, $take: Int!) {
  botRunListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    botType
    runNumber
    status
    currentPhase
    startedAt
    completedAt
    duration
    params
    result
    error
    correlationId
    totalPhases
    completedPhases
    requiresHumanIntervention
    interventionReason
    logsPath
    workerEvent {
      id
      version_
      queueName
      jobType
      status
      enqueuedAt
      startedAt
      completedAt
      payload
      result
      error
      retryCount
      manualRetryCount
      nextRetryAt
      duration
      correlationId
      triggerUserId {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
    }
    triggeredBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    relatedEntityType
    relatedEntityId
    relatedEntityLabel
    cancellationRequestedAt
    cancellationRequestedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    cancellationReason
    phases {
      id
      version_
      phaseNumber
      phaseId
      phaseName
      status
      stepsTotal
      stepsCompleted
      startedAt
      completedAt
      duration
      error
      stepsLogPath
      screenshot
      screenshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      steps {
        id
        version_
        stepNumber
        stepId
        status
        startedAt
        completedAt
        duration
        error
        downloadedFile
        downloadedFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
    }
    errors {
      id
      version_
      errorType
      severity
      message
      stackTrace
      context
      recoverable
      requiresHumanIntervention
      screenshot
      screenshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      domSnapshot
      domSnapshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
  }
}
    `;
export const BotRunListWithCursorDocument = gql`
    query botRunListWithCursor($where: BotRun_Filter, $orderBy: BotRun_OrderByCursor!, $cursorKey: String, $take: Int!) {
  botRunListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    botType
    runNumber
    status
    currentPhase
    startedAt
    completedAt
    duration
    params
    result
    error
    correlationId
    totalPhases
    completedPhases
    requiresHumanIntervention
    interventionReason
    logsPath
    workerEvent {
      id
      version_
      queueName
      jobType
      status
      enqueuedAt
      startedAt
      completedAt
      payload
      result
      error
      retryCount
      manualRetryCount
      nextRetryAt
      duration
      correlationId
      triggerUserId {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
    }
    triggeredBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    relatedEntityType
    relatedEntityId
    relatedEntityLabel
    cancellationRequestedAt
    cancellationRequestedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    cancellationReason
    phases {
      id
      version_
      phaseNumber
      phaseId
      phaseName
      status
      stepsTotal
      stepsCompleted
      startedAt
      completedAt
      duration
      error
      stepsLogPath
      screenshot
      screenshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      steps {
        id
        version_
        stepNumber
        stepId
        status
        startedAt
        completedAt
        duration
        error
        downloadedFile
        downloadedFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
    }
    errors {
      id
      version_
      errorType
      severity
      message
      stackTrace
      context
      recoverable
      requiresHumanIntervention
      screenshot
      screenshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      domSnapshot
      domSnapshot_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
  }
}
    `;
export const BotStepOneDocument = gql`
    query botStepOne($id: String!) {
  botStepOne(id: $id) {
    id
    version_
    stepNumber
    stepId
    status
    startedAt
    completedAt
    duration
    error
    downloadedFile
    downloadedFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const BotStepListWithOffsetDocument = gql`
    query botStepListWithOffset($where: BotStep_Filter, $orderBy: [BotStep_OrderBy!], $offset: Int!, $take: Int!) {
  botStepListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    stepNumber
    stepId
    status
    startedAt
    completedAt
    duration
    error
    downloadedFile
    downloadedFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const BotStepListWithCursorDocument = gql`
    query botStepListWithCursor($where: BotStep_Filter, $orderBy: BotStep_OrderByCursor!, $cursorKey: String, $take: Int!) {
  botStepListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    stepNumber
    stepId
    status
    startedAt
    completedAt
    duration
    error
    downloadedFile
    downloadedFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const CollectiveManagementSocietyCreateDocument = gql`
    mutation collectiveManagementSocietyCreate($name: String!, $acronym: String!, $countryId: String!, $idempotencyKey_: String) {
  collectiveManagementSocietyCreate(
    name: $name
    acronym: $acronym
    countryId: $countryId
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const CollectiveManagementSocietyUpdateDocument = gql`
    mutation collectiveManagementSocietyUpdate($id: String!, $version_: String!, $name: String!, $acronym: String!, $countryId: String!, $idempotencyKey_: String) {
  collectiveManagementSocietyUpdate(
    id: $id
    version_: $version_
    name: $name
    acronym: $acronym
    countryId: $countryId
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const CollectiveManagementSocietyDeleteDocument = gql`
    mutation collectiveManagementSocietyDelete($id: String!) {
  collectiveManagementSocietyDelete(id: $id) {
    id
  }
}
    `;
export const CollectiveManagementSocietyOneDocument = gql`
    query collectiveManagementSocietyOne($id: String!) {
  collectiveManagementSocietyOne(id: $id) {
    id
    version_
    name
    acronym
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
  }
}
    `;
export const CollectiveManagementSocietyListWithOffsetDocument = gql`
    query collectiveManagementSocietyListWithOffset($where: CollectiveManagementSociety_Filter, $orderBy: [CollectiveManagementSociety_OrderBy!], $offset: Int!, $take: Int!) {
  collectiveManagementSocietyListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    acronym
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
  }
}
    `;
export const CollectiveManagementSocietyListWithCursorDocument = gql`
    query collectiveManagementSocietyListWithCursor($where: CollectiveManagementSociety_Filter, $orderBy: CollectiveManagementSociety_OrderByCursor!, $cursorKey: String, $take: Int!) {
  collectiveManagementSocietyListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    acronym
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
  }
}
    `;
export const ContractObservationCreateDocument = gql`
    mutation contractObservationCreate($title: String!, $observation: String!, $requireAll: Boolean, $authorsIds: [String!], $publishersIds: [String!], $idempotencyKey_: String) {
  contractObservationCreate(
    title: $title
    observation: $observation
    requireAll: $requireAll
    authorsIds: $authorsIds
    publishersIds: $publishersIds
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const ContractObservationUpdateDocument = gql`
    mutation contractObservationUpdate($id: String!, $version_: String!, $title: String!, $observation: String!, $requireAll: Boolean, $authorsIds: InputMultipleRef, $publishersIds: InputMultipleRef, $idempotencyKey_: String) {
  contractObservationUpdate(
    id: $id
    version_: $version_
    title: $title
    observation: $observation
    requireAll: $requireAll
    authorsIds: $authorsIds
    publishersIds: $publishersIds
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const ContractObservationDeleteDocument = gql`
    mutation contractObservationDelete($id: String!) {
  contractObservationDelete(id: $id) {
    id
  }
}
    `;
export const ContractObservationOneDocument = gql`
    query contractObservationOne($id: String!) {
  contractObservationOne(id: $id) {
    id
    version_
    title
    observation
    requireAll
    authors {
      id
      version_
      firstName
      lastName
      gender
      taxIdType
      taxId
      cuitCertificate
      cuitCertificate_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      cuitCertificateIssuedAt
      cuitCertificateError
      cuitCertificateErrorType
      dniDeliveredToSadaicAt
      dniValidatedAt
      dniValidatedFields
      email
      phone
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      dateOfBirth
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      aka
      ipi
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        memberNumber
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
      }
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
      createdAt_
      lastUpdatedAt_
    }
    publishers {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
  }
}
    `;
export const ContractObservationListWithOffsetDocument = gql`
    query contractObservationListWithOffset($where: ContractObservation_Filter, $orderBy: [ContractObservation_OrderBy!], $offset: Int!, $take: Int!) {
  contractObservationListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    title
    observation
    requireAll
    authors {
      id
      version_
      firstName
      lastName
      gender
      taxIdType
      taxId
      cuitCertificate
      cuitCertificate_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      cuitCertificateIssuedAt
      cuitCertificateError
      cuitCertificateErrorType
      dniDeliveredToSadaicAt
      dniValidatedAt
      dniValidatedFields
      email
      phone
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      dateOfBirth
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      aka
      ipi
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        memberNumber
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
      }
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
      createdAt_
      lastUpdatedAt_
    }
    publishers {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
  }
}
    `;
export const ContractObservationListWithCursorDocument = gql`
    query contractObservationListWithCursor($where: ContractObservation_Filter, $orderBy: ContractObservation_OrderByCursor!, $cursorKey: String, $take: Int!) {
  contractObservationListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    title
    observation
    requireAll
    authors {
      id
      version_
      firstName
      lastName
      gender
      taxIdType
      taxId
      cuitCertificate
      cuitCertificate_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      cuitCertificateIssuedAt
      cuitCertificateError
      cuitCertificateErrorType
      dniDeliveredToSadaicAt
      dniValidatedAt
      dniValidatedFields
      email
      phone
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      dateOfBirth
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      aka
      ipi
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        memberNumber
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
      }
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
      createdAt_
      lastUpdatedAt_
    }
    publishers {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
  }
}
    `;
export const CountryCreateDocument = gql`
    mutation countryCreate($name_es: String!, $name_en: String!, $name_pt: String!, $code: String!, $currency: String!, $demonym_es: String, $demonym_en: String, $demonym_pt: String, $idempotencyKey_: String) {
  countryCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    code: $code
    currency: $currency
    demonym_es: $demonym_es
    demonym_en: $demonym_en
    demonym_pt: $demonym_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const CountryUpdateDocument = gql`
    mutation countryUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $code: String!, $currency: String!, $demonym_es: String, $demonym_en: String, $demonym_pt: String, $idempotencyKey_: String) {
  countryUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    code: $code
    currency: $currency
    demonym_es: $demonym_es
    demonym_en: $demonym_en
    demonym_pt: $demonym_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const CountryDeleteDocument = gql`
    mutation countryDelete($id: String!) {
  countryDelete(id: $id) {
    id
  }
}
    `;
export const CountryOneDocument = gql`
    query countryOne($id: String!) {
  countryOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    code
    currency
    demonym_es
    demonym_en
    demonym_pt
  }
}
    `;
export const CountryListWithOffsetDocument = gql`
    query countryListWithOffset($where: Country_Filter, $orderBy: [Country_OrderBy!], $offset: Int!, $take: Int!) {
  countryListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    code
    currency
    demonym_es
    demonym_en
    demonym_pt
  }
}
    `;
export const CountryListWithCursorDocument = gql`
    query countryListWithCursor($where: Country_Filter, $orderBy: Country_OrderByCursor!, $cursorKey: String, $take: Int!) {
  countryListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    code
    currency
    demonym_es
    demonym_en
    demonym_pt
  }
}
    `;
export const CreditAccountUpdateDocument = gql`
    mutation creditAccountUpdate($id: String!, $version_: String!, $tierId: String, $idempotencyKey_: String) {
  creditAccountUpdate(
    id: $id
    version_: $version_
    tierId: $tierId
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const CreditAccountOneDocument = gql`
    query creditAccountOne($id: String!) {
  creditAccountOne(id: $id) {
    id
    version_
    balance
    tier {
      id
      version_
      name_es
      name_en
      name_pt
      monthlyCredits
      pricePerCredit
      pricePerExtraCredit
      description_es
      description_en
      description_pt
    }
    movements {
      id
      version_
      type
      delta
      balanceAfter
      movementAt
      detail
      editionKey
      editionName
      purchase {
        id
        version_
        quantity
        purchaseDate
        expirationDate
        unitPrice
        notes
      }
    }
  }
}
    `;
export const CreditAccountListWithOffsetDocument = gql`
    query creditAccountListWithOffset($where: CreditAccount_Filter, $orderBy: [CreditAccount_OrderBy!], $offset: Int!, $take: Int!) {
  creditAccountListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    balance
    tier {
      id
      version_
      name_es
      name_en
      name_pt
      monthlyCredits
      pricePerCredit
      pricePerExtraCredit
      description_es
      description_en
      description_pt
    }
    movements {
      id
      version_
      type
      delta
      balanceAfter
      movementAt
      detail
      editionKey
      editionName
      purchase {
        id
        version_
        quantity
        purchaseDate
        expirationDate
        unitPrice
        notes
      }
    }
  }
}
    `;
export const CreditAccountListWithCursorDocument = gql`
    query creditAccountListWithCursor($where: CreditAccount_Filter, $orderBy: CreditAccount_OrderByCursor!, $cursorKey: String, $take: Int!) {
  creditAccountListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    balance
    tier {
      id
      version_
      name_es
      name_en
      name_pt
      monthlyCredits
      pricePerCredit
      pricePerExtraCredit
      description_es
      description_en
      description_pt
    }
    movements {
      id
      version_
      type
      delta
      balanceAfter
      movementAt
      detail
      editionKey
      editionName
      purchase {
        id
        version_
        quantity
        purchaseDate
        expirationDate
        unitPrice
        notes
      }
    }
  }
}
    `;
export const CreditMovementOneDocument = gql`
    query creditMovementOne($id: String!) {
  creditMovementOne(id: $id) {
    id
    version_
    type
    delta
    balanceAfter
    movementAt
    detail
    editionKey
    editionName
    purchase {
      id
      version_
      tenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      quantity
      purchaseDate
      expirationDate
      unitPrice
      notes
    }
  }
}
    `;
export const CreditMovementListWithOffsetDocument = gql`
    query creditMovementListWithOffset($where: CreditMovement_Filter, $orderBy: [CreditMovement_OrderBy!], $offset: Int!, $take: Int!) {
  creditMovementListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    type
    delta
    balanceAfter
    movementAt
    detail
    editionKey
    editionName
    purchase {
      id
      version_
      tenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      quantity
      purchaseDate
      expirationDate
      unitPrice
      notes
    }
  }
}
    `;
export const CreditMovementListWithCursorDocument = gql`
    query creditMovementListWithCursor($where: CreditMovement_Filter, $orderBy: CreditMovement_OrderByCursor!, $cursorKey: String, $take: Int!) {
  creditMovementListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    type
    delta
    balanceAfter
    movementAt
    detail
    editionKey
    editionName
    purchase {
      id
      version_
      tenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      quantity
      purchaseDate
      expirationDate
      unitPrice
      notes
    }
  }
}
    `;
export const CreditPurchaseCreateDocument = gql`
    mutation creditPurchaseCreate($tenantId: String, $quantity: Int!, $purchaseDate: Date!, $expirationDate: Date, $unitPrice: Decimal, $notes: String, $idempotencyKey_: String) {
  creditPurchaseCreate(
    tenantId: $tenantId
    quantity: $quantity
    purchaseDate: $purchaseDate
    expirationDate: $expirationDate
    unitPrice: $unitPrice
    notes: $notes
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const CreditPurchaseDeleteDocument = gql`
    mutation creditPurchaseDelete($id: String!) {
  creditPurchaseDelete(id: $id) {
    id
  }
}
    `;
export const CreditPurchaseOneDocument = gql`
    query creditPurchaseOne($id: String!) {
  creditPurchaseOne(id: $id) {
    id
    version_
    tenant {
      id
      version_
      name
      tenantType {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
      }
      status {
        id
        version_
        name
        description_es
        description_en
        description_pt
        blocksAccess
      }
      plan {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
        limits
      }
      logo
      logo_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      publicUrl
      idERP
      idCRM
      monthlyTokenLimit
      currentMonthTokens
      tokenLimitResetDay
      lastTokenResetDate
      ragLlmProvider {
        id
        version_
        name
        code
        requiresApiKey
        requiresBaseUrl
        defaultModels
        logoUrl
      }
      ragLlmModel
      currentStorageBytes
      storageByteLimit
      eSignatureProvider
    }
    quantity
    purchaseDate
    expirationDate
    unitPrice
    notes
  }
}
    `;
export const CreditPurchaseListWithOffsetDocument = gql`
    query creditPurchaseListWithOffset($where: CreditPurchase_Filter, $orderBy: [CreditPurchase_OrderBy!], $offset: Int!, $take: Int!) {
  creditPurchaseListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    tenant {
      id
      version_
      name
      tenantType {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
      }
      status {
        id
        version_
        name
        description_es
        description_en
        description_pt
        blocksAccess
      }
      plan {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
        limits
      }
      logo
      logo_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      publicUrl
      idERP
      idCRM
      monthlyTokenLimit
      currentMonthTokens
      tokenLimitResetDay
      lastTokenResetDate
      ragLlmProvider {
        id
        version_
        name
        code
        requiresApiKey
        requiresBaseUrl
        defaultModels
        logoUrl
      }
      ragLlmModel
      currentStorageBytes
      storageByteLimit
      eSignatureProvider
    }
    quantity
    purchaseDate
    expirationDate
    unitPrice
    notes
  }
}
    `;
export const CreditPurchaseListWithCursorDocument = gql`
    query creditPurchaseListWithCursor($where: CreditPurchase_Filter, $orderBy: CreditPurchase_OrderByCursor!, $cursorKey: String, $take: Int!) {
  creditPurchaseListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    tenant {
      id
      version_
      name
      tenantType {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
      }
      status {
        id
        version_
        name
        description_es
        description_en
        description_pt
        blocksAccess
      }
      plan {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
        limits
      }
      logo
      logo_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      publicUrl
      idERP
      idCRM
      monthlyTokenLimit
      currentMonthTokens
      tokenLimitResetDay
      lastTokenResetDate
      ragLlmProvider {
        id
        version_
        name
        code
        requiresApiKey
        requiresBaseUrl
        defaultModels
        logoUrl
      }
      ragLlmModel
      currentStorageBytes
      storageByteLimit
      eSignatureProvider
    }
    quantity
    purchaseDate
    expirationDate
    unitPrice
    notes
  }
}
    `;
export const MyCreditPurchasesOneDocument = gql`
    query myCreditPurchasesOne($id: String!) {
  myCreditPurchasesOne(id: $id) {
    id
    version_
    quantity
    purchaseDate
    expirationDate
    unitPrice
    notes
  }
}
    `;
export const MyCreditPurchasesListWithOffsetDocument = gql`
    query myCreditPurchasesListWithOffset($where: CreditPurchase_Filter, $orderBy: [CreditPurchase_OrderBy!], $offset: Int!, $take: Int!) {
  myCreditPurchasesListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    quantity
    purchaseDate
    expirationDate
    unitPrice
    notes
  }
}
    `;
export const MyCreditPurchasesListWithCursorDocument = gql`
    query myCreditPurchasesListWithCursor($where: CreditPurchase_Filter, $orderBy: CreditPurchase_OrderByCursor!, $cursorKey: String, $take: Int!) {
  myCreditPurchasesListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    quantity
    purchaseDate
    expirationDate
    unitPrice
    notes
  }
}
    `;
export const CreditTierCreateDocument = gql`
    mutation creditTierCreate($name_es: String!, $name_en: String!, $name_pt: String!, $monthlyCredits: Int!, $pricePerCredit: Decimal!, $pricePerExtraCredit: Decimal!, $description_es: String, $description_en: String, $description_pt: String, $idempotencyKey_: String) {
  creditTierCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    monthlyCredits: $monthlyCredits
    pricePerCredit: $pricePerCredit
    pricePerExtraCredit: $pricePerExtraCredit
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const CreditTierUpdateDocument = gql`
    mutation creditTierUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $monthlyCredits: Int!, $pricePerCredit: Decimal!, $pricePerExtraCredit: Decimal!, $description_es: String, $description_en: String, $description_pt: String, $idempotencyKey_: String) {
  creditTierUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    monthlyCredits: $monthlyCredits
    pricePerCredit: $pricePerCredit
    pricePerExtraCredit: $pricePerExtraCredit
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const CreditTierDeleteDocument = gql`
    mutation creditTierDelete($id: String!) {
  creditTierDelete(id: $id) {
    id
  }
}
    `;
export const CreditTierOneDocument = gql`
    query creditTierOne($id: String!) {
  creditTierOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    monthlyCredits
    pricePerCredit
    pricePerExtraCredit
    description_es
    description_en
    description_pt
  }
}
    `;
export const CreditTierListWithOffsetDocument = gql`
    query creditTierListWithOffset($where: CreditTier_Filter, $orderBy: [CreditTier_OrderBy!], $offset: Int!, $take: Int!) {
  creditTierListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    monthlyCredits
    pricePerCredit
    pricePerExtraCredit
    description_es
    description_en
    description_pt
  }
}
    `;
export const CreditTierListWithCursorDocument = gql`
    query creditTierListWithCursor($where: CreditTier_Filter, $orderBy: CreditTier_OrderByCursor!, $cursorKey: String, $take: Int!) {
  creditTierListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    monthlyCredits
    pricePerCredit
    pricePerExtraCredit
    description_es
    description_en
    description_pt
  }
}
    `;
export const CurrencyCreateDocument = gql`
    mutation currencyCreate($code: String!, $name: String!, $idempotencyKey_: String) {
  currencyCreate(code: $code, name: $name, idempotencyKey_: $idempotencyKey_) {
    id
  }
}
    `;
export const CurrencyUpdateDocument = gql`
    mutation currencyUpdate($id: String!, $version_: String!, $code: String!, $name: String!, $idempotencyKey_: String) {
  currencyUpdate(
    id: $id
    version_: $version_
    code: $code
    name: $name
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const CurrencyDeleteDocument = gql`
    mutation currencyDelete($id: String!) {
  currencyDelete(id: $id) {
    id
  }
}
    `;
export const CurrencyOneDocument = gql`
    query currencyOne($id: String!) {
  currencyOne(id: $id) {
    id
    version_
    code
    name
  }
}
    `;
export const CurrencyListWithOffsetDocument = gql`
    query currencyListWithOffset($where: Currency_Filter, $orderBy: [Currency_OrderBy!], $offset: Int!, $take: Int!) {
  currencyListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    code
    name
  }
}
    `;
export const CurrencyListWithCursorDocument = gql`
    query currencyListWithCursor($where: Currency_Filter, $orderBy: Currency_OrderByCursor!, $cursorKey: String, $take: Int!) {
  currencyListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    code
    name
  }
}
    `;
export const DashboardLayoutTemplateCreateDocument = gql`
    mutation dashboardLayoutTemplateCreate($name: String!, $forRole: String, $widgets: Json!, $isDefault: Boolean!, $enabled: Boolean!, $isForAllTenants: Boolean!, $idempotencyKey_: String) {
  dashboardLayoutTemplateCreate(
    name: $name
    forRole: $forRole
    widgets: $widgets
    isDefault: $isDefault
    enabled: $enabled
    isForAllTenants: $isForAllTenants
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const DashboardLayoutTemplateUpdateDocument = gql`
    mutation dashboardLayoutTemplateUpdate($id: String!, $version_: String!, $name: String!, $forRole: String, $widgets: Json!, $isDefault: Boolean!, $enabled: Boolean!, $isForAllTenants: Boolean!, $idempotencyKey_: String) {
  dashboardLayoutTemplateUpdate(
    id: $id
    version_: $version_
    name: $name
    forRole: $forRole
    widgets: $widgets
    isDefault: $isDefault
    enabled: $enabled
    isForAllTenants: $isForAllTenants
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const DashboardLayoutTemplateDeleteDocument = gql`
    mutation dashboardLayoutTemplateDelete($id: String!) {
  dashboardLayoutTemplateDelete(id: $id) {
    id
  }
}
    `;
export const DashboardLayoutTemplateOneDocument = gql`
    query dashboardLayoutTemplateOne($id: String!) {
  dashboardLayoutTemplateOne(id: $id) {
    id
    version_
    name
    forRole
    widgets
    isDefault
    enabled
    isForAllTenants
  }
}
    `;
export const DashboardLayoutTemplateListWithOffsetDocument = gql`
    query dashboardLayoutTemplateListWithOffset($where: DashboardLayoutTemplate_Filter, $orderBy: [DashboardLayoutTemplate_OrderBy!], $offset: Int!, $take: Int!) {
  dashboardLayoutTemplateListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    forRole
    widgets
    isDefault
    enabled
    isForAllTenants
  }
}
    `;
export const DashboardLayoutTemplateListWithCursorDocument = gql`
    query dashboardLayoutTemplateListWithCursor($where: DashboardLayoutTemplate_Filter, $orderBy: DashboardLayoutTemplate_OrderByCursor!, $cursorKey: String, $take: Int!) {
  dashboardLayoutTemplateListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    forRole
    widgets
    isDefault
    enabled
    isForAllTenants
  }
}
    `;
export const DashboardWidgetOneDocument = gql`
    query dashboardWidgetOne($id: String!) {
  dashboardWidgetOne(id: $id) {
    id
    version_
    widgetKey
    title
    description
    category
    component
    dataFetcherKey
    defaultConfig
    icon
    minWidth
    minHeight
    refreshInterval
    requiredPermissions
    enabled
  }
}
    `;
export const DashboardWidgetListWithOffsetDocument = gql`
    query dashboardWidgetListWithOffset($where: DashboardWidget_Filter, $orderBy: [DashboardWidget_OrderBy!], $offset: Int!, $take: Int!) {
  dashboardWidgetListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    widgetKey
    title
    description
    category
    component
    dataFetcherKey
    defaultConfig
    icon
    minWidth
    minHeight
    refreshInterval
    requiredPermissions
    enabled
  }
}
    `;
export const DashboardWidgetListWithCursorDocument = gql`
    query dashboardWidgetListWithCursor($where: DashboardWidget_Filter, $orderBy: DashboardWidget_OrderByCursor!, $cursorKey: String, $take: Int!) {
  dashboardWidgetListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    widgetKey
    title
    description
    category
    component
    dataFetcherKey
    defaultConfig
    icon
    minWidth
    minHeight
    refreshInterval
    requiredPermissions
    enabled
  }
}
    `;
export const DesignShowcaseCreateDocument = gql`
    mutation designShowcaseCreate($code: String!, $name: String!, $summary: String, $status: ShowcaseStatus!, $categoryId: String!, $relatedCategoriesIds: [String!], $appliedStatuses: [ShowcaseStatus!], $quantity: Int!, $durationInYears: Int, $amount: Decimal!, $ratio: Decimal, $startDate: Date!, $expiresAt: DateTime, $registeredAt: DateTime, $active: Boolean!, $highlighted: Boolean!, $phone: String, $taxId: String, $attachment: UploadedFile, $anyFile: UploadedFile, $avatar: UploadedFile, $keywords: [String!], $body: String, $metadata: Json, $internalNote: String, $apiKey: String, $lines: [ShowcaseLine_CreateInput!], $idempotencyKey_: String) {
  designShowcaseCreate(
    code: $code
    name: $name
    summary: $summary
    status: $status
    categoryId: $categoryId
    relatedCategoriesIds: $relatedCategoriesIds
    appliedStatuses: $appliedStatuses
    quantity: $quantity
    durationInYears: $durationInYears
    amount: $amount
    ratio: $ratio
    startDate: $startDate
    expiresAt: $expiresAt
    registeredAt: $registeredAt
    active: $active
    highlighted: $highlighted
    phone: $phone
    taxId: $taxId
    attachment: $attachment
    anyFile: $anyFile
    avatar: $avatar
    keywords: $keywords
    body: $body
    metadata: $metadata
    internalNote: $internalNote
    apiKey: $apiKey
    lines: $lines
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const DesignShowcaseUpdateDocument = gql`
    mutation designShowcaseUpdate($id: String!, $version_: String!, $code: String!, $name: String!, $summary: String, $status: ShowcaseStatus, $categoryId: String!, $relatedCategoriesIds: InputMultipleRef, $appliedStatuses: [ShowcaseStatus!], $quantity: Int!, $durationInYears: Int, $amount: Decimal!, $ratio: Decimal, $startDate: Date!, $expiresAt: DateTime, $registeredAt: DateTime, $active: Boolean!, $highlighted: Boolean!, $phone: String, $taxId: String, $attachment: UploadedFile, $anyFile: UploadedFile, $avatar: UploadedFile, $keywords: [String!], $body: String, $metadata: Json, $internalNote: String, $apiKey: String, $lines: DesignShowcase_lines_UpdateInput, $idempotencyKey_: String) {
  designShowcaseUpdate(
    id: $id
    version_: $version_
    code: $code
    name: $name
    summary: $summary
    status: $status
    categoryId: $categoryId
    relatedCategoriesIds: $relatedCategoriesIds
    appliedStatuses: $appliedStatuses
    quantity: $quantity
    durationInYears: $durationInYears
    amount: $amount
    ratio: $ratio
    startDate: $startDate
    expiresAt: $expiresAt
    registeredAt: $registeredAt
    active: $active
    highlighted: $highlighted
    phone: $phone
    taxId: $taxId
    attachment: $attachment
    anyFile: $anyFile
    avatar: $avatar
    keywords: $keywords
    body: $body
    metadata: $metadata
    internalNote: $internalNote
    apiKey: $apiKey
    lines: $lines
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const DesignShowcaseDeleteDocument = gql`
    mutation designShowcaseDelete($id: String!) {
  designShowcaseDelete(id: $id) {
    id
  }
}
    `;
export const DesignShowcaseOneDocument = gql`
    query designShowcaseOne($id: String!) {
  designShowcaseOne(id: $id) {
    id
    version_
    code
    name
    summary
    status
    category {
      id
      version_
      code
      name
    }
    relatedCategories {
      id
      version_
      code
      name
    }
    appliedStatuses
    lifecycle {
      id
      version_
      name_es
      name_en
      name_pt
    }
    quantity
    durationInYears
    amount
    ratio
    startDate
    expiresAt
    registeredAt
    active
    highlighted
    phone
    taxId
    attachment
    attachment_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    anyFile
    anyFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    keywords
    body
    metadata
    internalNote
    apiKeyHasValue
    serverLabel
    lines {
      id
      version_
      concept
      quantity
      unitPrice
      note
    }
    lifecycle_transitions_
  }
}
    `;
export const DesignShowcaseListWithOffsetDocument = gql`
    query designShowcaseListWithOffset($where: DesignShowcase_Filter, $orderBy: [DesignShowcase_OrderBy!], $offset: Int!, $take: Int!) {
  designShowcaseListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    code
    name
    summary
    status
    category {
      id
      version_
      code
      name
    }
    relatedCategories {
      id
      version_
      code
      name
    }
    appliedStatuses
    lifecycle {
      id
      version_
      name_es
      name_en
      name_pt
    }
    quantity
    durationInYears
    amount
    ratio
    startDate
    expiresAt
    registeredAt
    active
    highlighted
    phone
    taxId
    attachment
    attachment_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    anyFile
    anyFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    keywords
    body
    metadata
    internalNote
    serverLabel
    lines {
      id
      version_
      concept
      quantity
      unitPrice
      note
    }
    lifecycle_transitions_
  }
}
    `;
export const DesignShowcaseListWithCursorDocument = gql`
    query designShowcaseListWithCursor($where: DesignShowcase_Filter, $orderBy: DesignShowcase_OrderByCursor!, $cursorKey: String, $take: Int!) {
  designShowcaseListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    code
    name
    summary
    status
    category {
      id
      version_
      code
      name
    }
    relatedCategories {
      id
      version_
      code
      name
    }
    appliedStatuses
    lifecycle {
      id
      version_
      name_es
      name_en
      name_pt
    }
    quantity
    durationInYears
    amount
    ratio
    startDate
    expiresAt
    registeredAt
    active
    highlighted
    phone
    taxId
    attachment
    attachment_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    anyFile
    anyFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    keywords
    body
    metadata
    internalNote
    serverLabel
    lines {
      id
      version_
      concept
      quantity
      unitPrice
      note
    }
    lifecycle_transitions_
  }
}
    `;
export const DocumentGenerationParamsCreateDocument = gql`
    mutation documentGenerationParamsCreate($contractEffectiveDate: Date!, $contractEndDate: Date, $idempotencyKey_: String) {
  documentGenerationParamsCreate(
    contractEffectiveDate: $contractEffectiveDate
    contractEndDate: $contractEndDate
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const DocumentGenerationParamsUpdateDocument = gql`
    mutation documentGenerationParamsUpdate($id: String!, $version_: String!, $contractEffectiveDate: Date!, $contractEndDate: Date, $idempotencyKey_: String) {
  documentGenerationParamsUpdate(
    id: $id
    version_: $version_
    contractEffectiveDate: $contractEffectiveDate
    contractEndDate: $contractEndDate
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const DocumentGenerationParamsDeleteDocument = gql`
    mutation documentGenerationParamsDelete($id: String!) {
  documentGenerationParamsDelete(id: $id) {
    id
  }
}
    `;
export const DocumentGenerationParamsOneDocument = gql`
    query documentGenerationParamsOne($id: String!) {
  documentGenerationParamsOne(id: $id) {
    id
    version_
    contractEffectiveDate
    contractEndDate
  }
}
    `;
export const DocumentGenerationParamsListWithOffsetDocument = gql`
    query documentGenerationParamsListWithOffset($where: DocumentGenerationParams_Filter, $orderBy: [DocumentGenerationParams_OrderBy!], $offset: Int!, $take: Int!) {
  documentGenerationParamsListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    contractEffectiveDate
    contractEndDate
  }
}
    `;
export const DocumentGenerationParamsListWithCursorDocument = gql`
    query documentGenerationParamsListWithCursor($where: DocumentGenerationParams_Filter, $orderBy: DocumentGenerationParams_OrderByCursor!, $cursorKey: String, $take: Int!) {
  documentGenerationParamsListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    contractEffectiveDate
    contractEndDate
  }
}
    `;
export const EditionSignatureStatusDocument = gql`
    query editionSignatureStatus($editionId: String!) {
  editionSignatureStatus(editionId: $editionId) {
    editionDocumentationId
    contractNumber
    contractName
    documentType
    documentStatus
    signaturePhase
    recipients {
      name
      email
      role
      order
      status
      signedAt
    }
  }
}
    `;
export const RecheckEditionSignaturesDocument = gql`
    mutation recheckEditionSignatures($editionId: ID!) {
  recheckEditionSignatures(editionId: $editionId) {
    status
    signedEditionId
    reason
    pendingDocs {
      contractNumber
      signatureFoundButUnlinked
    }
  }
}
    `;
export const ResendSignatureEmailDocument = gql`
    mutation resendSignatureEmail($editionDocumentationId: String!, $recipientEmail: String!) {
  resendSignatureEmail(
    editionDocumentationId: $editionDocumentationId
    recipientEmail: $recipientEmail
  )
}
    `;
export const EditionCreateDocument = gql`
    mutation editionCreate($name: String!, $editionTypeId: String!, $contentType: EditionContentType!, $publicationLink: String, $price: Decimal!, $worksIds: [String!]!, $notes: String, $contractObservation: String, $userAttachments: [UserAttachmentEdition_CreateInput!], $idempotencyKey_: String) {
  editionCreate(
    name: $name
    editionTypeId: $editionTypeId
    contentType: $contentType
    publicationLink: $publicationLink
    price: $price
    worksIds: $worksIds
    notes: $notes
    contractObservation: $contractObservation
    userAttachments: $userAttachments
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const EditionUpdateDocument = gql`
    mutation editionUpdate($id: String!, $version_: String!, $name: String!, $editionTypeId: String!, $contentType: EditionContentType, $publicationLink: String, $price: Decimal!, $worksIds: InputMultipleRef, $notes: String, $contractObservation: String, $userAttachments: Edition_userAttachments_UpdateInput, $idempotencyKey_: String) {
  editionUpdate(
    id: $id
    version_: $version_
    name: $name
    editionTypeId: $editionTypeId
    contentType: $contentType
    publicationLink: $publicationLink
    price: $price
    worksIds: $worksIds
    notes: $notes
    contractObservation: $contractObservation
    userAttachments: $userAttachments
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const EditionDeleteDocument = gql`
    mutation editionDelete($id: String!) {
  editionDelete(id: $id) {
    id
  }
}
    `;
export const EditionOneDocument = gql`
    query editionOne($id: String!) {
  editionOne(id: $id) {
    id
    version_
    documentationState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    documentationLastOperationalError
    publicationDate
    ejemplarPdf
    ejemplarPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    name
    editionType {
      id
      version_
      name_es
      name_en
      name_pt
    }
    contentType
    publicationLink
    editionNumber
    price
    works {
      id
      version_
      title
      musicalGenre {
        id
        version_
        name
      }
      alternativeTitles
      authors {
        id
        version_
        author {
          id
          version_
          firstName
          lastName
          gender
          taxIdType
          taxId
          cuitCertificate
          cuitCertificate_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          cuitCertificateIssuedAt
          cuitCertificateError
          cuitCertificateErrorType
          dniDeliveredToSadaicAt
          dniValidatedAt
          dniValidatedFields
          email
          phone
          dateOfBirth
          streetAndNumber
          floor
          suite
          postalCode
          city
          aka
          ipi
          createdAt_
          lastUpdatedAt_
        }
        lyricsPercentage
        musicPercentage
        publishers {
          id
          version_
          publisher {
            id
            version_
            pseudonym
            name
          }
          percentage
          durationInYears
          autoRenewalYears
        }
      }
      notes
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      cmsId
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      iswc
      workNumber
      score
      score_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      phonograms {
        id
        version_
        trackName
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        albumName
        publicationYear
        isrc
        originalProducer
        audioFile
        audioFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        mainAudio
        links {
          id
          version_
          url
          platform {
            id
            version_
            name
          }
          type {
            id
            version_
            name
          }
        }
        notes
      }
      originalLyrics
      contractObservation
      createdAt_
      lastUpdatedAt_
    }
    notes
    dndaExpedienteNumber
    contractObservation
    documentation {
      id
      version_
      works {
        id
        version_
        title
        alternativeTitles
        notes
        cmsId
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      authors {
        id
        version_
        firstName
        lastName
        gender
        taxIdType
        taxId
        cuitCertificate
        cuitCertificate_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        cuitCertificateIssuedAt
        cuitCertificateError
        cuitCertificateErrorType
        dniDeliveredToSadaicAt
        dniValidatedAt
        dniValidatedFields
        email
        phone
        dateOfBirth
        streetAndNumber
        floor
        suite
        postalCode
        city
        aka
        ipi
        createdAt_
        lastUpdatedAt_
      }
      authorsDisplay
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
      }
      publisherConfiguration
      publisherConfigurationDisplay
      territoriesDisplay
      contractDuration
      contractRenewal
      contractNumber
      documentName
      finalDocumentPdf
      finalDocumentPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
    associatedDocuments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      type {
        id
        version_
        name
      }
      notes
      publisherConfigurationDisplay
      authorsDisplay
    }
    userAttachments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      notes
    }
    createdAt_
    lastUpdatedAt_
    documentationState_transitions_
  }
}
    `;
export const EditionListWithOffsetDocument = gql`
    query editionListWithOffset($where: Edition_Filter, $orderBy: [Edition_OrderBy!], $offset: Int!, $take: Int!) {
  editionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    documentationState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    documentationLastOperationalError
    publicationDate
    ejemplarPdf
    ejemplarPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    name
    editionType {
      id
      version_
      name_es
      name_en
      name_pt
    }
    contentType
    publicationLink
    editionNumber
    price
    works {
      id
      version_
      title
      musicalGenre {
        id
        version_
        name
      }
      alternativeTitles
      authors {
        id
        version_
        author {
          id
          version_
          firstName
          lastName
          gender
          taxIdType
          taxId
          cuitCertificate
          cuitCertificate_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          cuitCertificateIssuedAt
          cuitCertificateError
          cuitCertificateErrorType
          dniDeliveredToSadaicAt
          dniValidatedAt
          dniValidatedFields
          email
          phone
          dateOfBirth
          streetAndNumber
          floor
          suite
          postalCode
          city
          aka
          ipi
          createdAt_
          lastUpdatedAt_
        }
        lyricsPercentage
        musicPercentage
        publishers {
          id
          version_
          publisher {
            id
            version_
            pseudonym
            name
          }
          percentage
          durationInYears
          autoRenewalYears
        }
      }
      notes
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      cmsId
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      iswc
      workNumber
      score
      score_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      phonograms {
        id
        version_
        trackName
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        albumName
        publicationYear
        isrc
        originalProducer
        audioFile
        audioFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        mainAudio
        links {
          id
          version_
          url
          platform {
            id
            version_
            name
          }
          type {
            id
            version_
            name
          }
        }
        notes
      }
      originalLyrics
      contractObservation
      createdAt_
      lastUpdatedAt_
    }
    notes
    dndaExpedienteNumber
    contractObservation
    documentation {
      id
      version_
      works {
        id
        version_
        title
        alternativeTitles
        notes
        cmsId
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      authors {
        id
        version_
        firstName
        lastName
        gender
        taxIdType
        taxId
        cuitCertificate
        cuitCertificate_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        cuitCertificateIssuedAt
        cuitCertificateError
        cuitCertificateErrorType
        dniDeliveredToSadaicAt
        dniValidatedAt
        dniValidatedFields
        email
        phone
        dateOfBirth
        streetAndNumber
        floor
        suite
        postalCode
        city
        aka
        ipi
        createdAt_
        lastUpdatedAt_
      }
      authorsDisplay
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
      }
      publisherConfiguration
      publisherConfigurationDisplay
      territoriesDisplay
      contractDuration
      contractRenewal
      contractNumber
      documentName
      finalDocumentPdf
      finalDocumentPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
    associatedDocuments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      type {
        id
        version_
        name
      }
      notes
      publisherConfigurationDisplay
      authorsDisplay
    }
    userAttachments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      notes
    }
    createdAt_
    lastUpdatedAt_
    documentationState_transitions_
  }
}
    `;
export const EditionListWithCursorDocument = gql`
    query editionListWithCursor($where: Edition_Filter, $orderBy: Edition_OrderByCursor!, $cursorKey: String, $take: Int!) {
  editionListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    documentationState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    documentationLastOperationalError
    publicationDate
    ejemplarPdf
    ejemplarPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    name
    editionType {
      id
      version_
      name_es
      name_en
      name_pt
    }
    contentType
    publicationLink
    editionNumber
    price
    works {
      id
      version_
      title
      musicalGenre {
        id
        version_
        name
      }
      alternativeTitles
      authors {
        id
        version_
        author {
          id
          version_
          firstName
          lastName
          gender
          taxIdType
          taxId
          cuitCertificate
          cuitCertificate_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          cuitCertificateIssuedAt
          cuitCertificateError
          cuitCertificateErrorType
          dniDeliveredToSadaicAt
          dniValidatedAt
          dniValidatedFields
          email
          phone
          dateOfBirth
          streetAndNumber
          floor
          suite
          postalCode
          city
          aka
          ipi
          createdAt_
          lastUpdatedAt_
        }
        lyricsPercentage
        musicPercentage
        publishers {
          id
          version_
          publisher {
            id
            version_
            pseudonym
            name
          }
          percentage
          durationInYears
          autoRenewalYears
        }
      }
      notes
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      cmsId
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      iswc
      workNumber
      score
      score_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      phonograms {
        id
        version_
        trackName
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        albumName
        publicationYear
        isrc
        originalProducer
        audioFile
        audioFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        mainAudio
        links {
          id
          version_
          url
          platform {
            id
            version_
            name
          }
          type {
            id
            version_
            name
          }
        }
        notes
      }
      originalLyrics
      contractObservation
      createdAt_
      lastUpdatedAt_
    }
    notes
    dndaExpedienteNumber
    contractObservation
    documentation {
      id
      version_
      works {
        id
        version_
        title
        alternativeTitles
        notes
        cmsId
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      authors {
        id
        version_
        firstName
        lastName
        gender
        taxIdType
        taxId
        cuitCertificate
        cuitCertificate_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        cuitCertificateIssuedAt
        cuitCertificateError
        cuitCertificateErrorType
        dniDeliveredToSadaicAt
        dniValidatedAt
        dniValidatedFields
        email
        phone
        dateOfBirth
        streetAndNumber
        floor
        suite
        postalCode
        city
        aka
        ipi
        createdAt_
        lastUpdatedAt_
      }
      authorsDisplay
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
      }
      publisherConfiguration
      publisherConfigurationDisplay
      territoriesDisplay
      contractDuration
      contractRenewal
      contractNumber
      documentName
      finalDocumentPdf
      finalDocumentPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
    associatedDocuments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      type {
        id
        version_
        name
      }
      notes
      publisherConfigurationDisplay
      authorsDisplay
    }
    userAttachments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      notes
    }
    createdAt_
    lastUpdatedAt_
    documentationState_transitions_
  }
}
    `;
export const EditionContractPublisherOneDocument = gql`
    query editionContractPublisherOne($id: String!) {
  editionContractPublisherOne(id: $id) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
  }
}
    `;
export const EditionContractPublisherListWithOffsetDocument = gql`
    query editionContractPublisherListWithOffset($where: EditionContractPublisher_Filter, $orderBy: [EditionContractPublisher_OrderBy!], $offset: Int!, $take: Int!) {
  editionContractPublisherListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
  }
}
    `;
export const EditionContractPublisherListWithCursorDocument = gql`
    query editionContractPublisherListWithCursor($where: EditionContractPublisher_Filter, $orderBy: EditionContractPublisher_OrderByCursor!, $cursorKey: String, $take: Int!) {
  editionContractPublisherListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
  }
}
    `;
export const EditionDocumentTypeCreateDocument = gql`
    mutation editionDocumentTypeCreate($name: String!, $idempotencyKey_: String) {
  editionDocumentTypeCreate(name: $name, idempotencyKey_: $idempotencyKey_) {
    id
  }
}
    `;
export const EditionDocumentTypeUpdateDocument = gql`
    mutation editionDocumentTypeUpdate($id: String!, $version_: String!, $name: String!, $idempotencyKey_: String) {
  editionDocumentTypeUpdate(
    id: $id
    version_: $version_
    name: $name
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const EditionDocumentTypeDeleteDocument = gql`
    mutation editionDocumentTypeDelete($id: String!) {
  editionDocumentTypeDelete(id: $id) {
    id
  }
}
    `;
export const EditionDocumentTypeOneDocument = gql`
    query editionDocumentTypeOne($id: String!) {
  editionDocumentTypeOne(id: $id) {
    id
    version_
    name
  }
}
    `;
export const EditionDocumentTypeListWithOffsetDocument = gql`
    query editionDocumentTypeListWithOffset($where: EditionDocumentType_Filter, $orderBy: [EditionDocumentType_OrderBy!], $offset: Int!, $take: Int!) {
  editionDocumentTypeListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
  }
}
    `;
export const EditionDocumentTypeListWithCursorDocument = gql`
    query editionDocumentTypeListWithCursor($where: EditionDocumentType_Filter, $orderBy: EditionDocumentType_OrderByCursor!, $cursorKey: String, $take: Int!) {
  editionDocumentTypeListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
  }
}
    `;
export const EditionDocumentationOneDocument = gql`
    query editionDocumentationOne($id: String!) {
  editionDocumentationOne(id: $id) {
    id
    version_
    works {
      id
      version_
      title
      musicalGenre {
        id
        version_
        name
      }
      alternativeTitles
      notes
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      cmsId
      iswc
      workNumber
      score
      score_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      phonograms {
        id
        version_
        trackName
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        albumName
        publicationYear
        isrc
        originalProducer
        audioFile
        audioFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        mainAudio
        links {
          id
          version_
          url
          platform {
            id
            version_
            name
          }
          type {
            id
            version_
            name
          }
        }
        notes
      }
      originalLyrics
      contractObservation
      createdAt_
      lastUpdatedAt_
    }
    authorsDisplay
    publisherConfigurationDisplay
    territoriesDisplay
    contractDuration
    contractRenewal
    contractNumber
    documentName
    finalDocumentPdf
    finalDocumentPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const EditionDocumentationListWithOffsetDocument = gql`
    query editionDocumentationListWithOffset($where: EditionDocumentation_Filter, $orderBy: [EditionDocumentation_OrderBy!], $offset: Int!, $take: Int!) {
  editionDocumentationListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    works {
      id
      version_
      title
      musicalGenre {
        id
        version_
        name
      }
      alternativeTitles
      authors {
        id
        version_
        author {
          id
          version_
          firstName
          lastName
          gender
          taxIdType
          taxId
          cuitCertificate
          cuitCertificate_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          cuitCertificateIssuedAt
          cuitCertificateError
          cuitCertificateErrorType
          dniDeliveredToSadaicAt
          dniValidatedAt
          dniValidatedFields
          email
          phone
          dateOfBirth
          streetAndNumber
          floor
          suite
          postalCode
          city
          aka
          ipi
          createdAt_
          lastUpdatedAt_
        }
        lyricsPercentage
        musicPercentage
        publishers {
          id
          version_
          publisher {
            id
            version_
            pseudonym
            name
          }
          percentage
          durationInYears
          autoRenewalYears
        }
      }
      notes
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      cmsId
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      iswc
      workNumber
      score
      score_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      phonograms {
        id
        version_
        trackName
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        albumName
        publicationYear
        isrc
        originalProducer
        audioFile
        audioFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        mainAudio
        links {
          id
          version_
          url
          platform {
            id
            version_
            name
          }
          type {
            id
            version_
            name
          }
        }
        notes
      }
      originalLyrics
      contractObservation
      createdAt_
      lastUpdatedAt_
    }
    territories {
      id
      version_
      name_es
      name_en
      name_pt
    }
    authors {
      id
      version_
      firstName
      lastName
      gender
      taxIdType
      taxId
      cuitCertificate
      cuitCertificate_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      cuitCertificateIssuedAt
      cuitCertificateError
      cuitCertificateErrorType
      dniDeliveredToSadaicAt
      dniValidatedAt
      dniValidatedFields
      email
      phone
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      dateOfBirth
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      aka
      ipi
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        memberNumber
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
      }
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
      createdAt_
      lastUpdatedAt_
    }
    authorsDisplay
    publishers {
      id
      version_
      publisher {
        id
        version_
        personType
        name
        maritalStatus
        pseudonym
        taxId
        phone
        email
        streetAndNumber
        floor
        suite
        postalCode
        city
        caeIpi
        createdAt_
        lastUpdatedAt_
      }
      percentage
    }
    publisherConfiguration
    publisherConfigurationDisplay
    territoriesDisplay
    contractDuration
    contractRenewal
    contractNumber
    documentName
    finalDocumentPdf
    finalDocumentPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const EditionDocumentationListWithCursorDocument = gql`
    query editionDocumentationListWithCursor($where: EditionDocumentation_Filter, $orderBy: EditionDocumentation_OrderByCursor!, $cursorKey: String, $take: Int!) {
  editionDocumentationListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    works {
      id
      version_
      title
      musicalGenre {
        id
        version_
        name
      }
      alternativeTitles
      authors {
        id
        version_
        author {
          id
          version_
          firstName
          lastName
          gender
          taxIdType
          taxId
          cuitCertificate
          cuitCertificate_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          cuitCertificateIssuedAt
          cuitCertificateError
          cuitCertificateErrorType
          dniDeliveredToSadaicAt
          dniValidatedAt
          dniValidatedFields
          email
          phone
          dateOfBirth
          streetAndNumber
          floor
          suite
          postalCode
          city
          aka
          ipi
          createdAt_
          lastUpdatedAt_
        }
        lyricsPercentage
        musicPercentage
        publishers {
          id
          version_
          publisher {
            id
            version_
            pseudonym
            name
          }
          percentage
          durationInYears
          autoRenewalYears
        }
      }
      notes
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      cmsId
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      iswc
      workNumber
      score
      score_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      phonograms {
        id
        version_
        trackName
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        albumName
        publicationYear
        isrc
        originalProducer
        audioFile
        audioFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        mainAudio
        links {
          id
          version_
          url
          platform {
            id
            version_
            name
          }
          type {
            id
            version_
            name
          }
        }
        notes
      }
      originalLyrics
      contractObservation
      createdAt_
      lastUpdatedAt_
    }
    territories {
      id
      version_
      name_es
      name_en
      name_pt
    }
    authors {
      id
      version_
      firstName
      lastName
      gender
      taxIdType
      taxId
      cuitCertificate
      cuitCertificate_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      cuitCertificateIssuedAt
      cuitCertificateError
      cuitCertificateErrorType
      dniDeliveredToSadaicAt
      dniValidatedAt
      dniValidatedFields
      email
      phone
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      dateOfBirth
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      aka
      ipi
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        memberNumber
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
      }
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
      createdAt_
      lastUpdatedAt_
    }
    authorsDisplay
    publishers {
      id
      version_
      publisher {
        id
        version_
        personType
        name
        maritalStatus
        pseudonym
        taxId
        phone
        email
        streetAndNumber
        floor
        suite
        postalCode
        city
        caeIpi
        createdAt_
        lastUpdatedAt_
      }
      percentage
    }
    publisherConfiguration
    publisherConfigurationDisplay
    territoriesDisplay
    contractDuration
    contractRenewal
    contractNumber
    documentName
    finalDocumentPdf
    finalDocumentPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
  }
}
    `;
export const EditionDocumentationWorkflowStateCreateDocument = gql`
    mutation editionDocumentationWorkflowStateCreate($name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  editionDocumentationWorkflowStateCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const EditionDocumentationWorkflowStateUpdateDocument = gql`
    mutation editionDocumentationWorkflowStateUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  editionDocumentationWorkflowStateUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const EditionDocumentationWorkflowStateDeleteDocument = gql`
    mutation editionDocumentationWorkflowStateDelete($id: String!) {
  editionDocumentationWorkflowStateDelete(id: $id) {
    id
  }
}
    `;
export const EditionDocumentationWorkflowStateOneDocument = gql`
    query editionDocumentationWorkflowStateOne($id: String!) {
  editionDocumentationWorkflowStateOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const EditionDocumentationWorkflowStateListWithOffsetDocument = gql`
    query editionDocumentationWorkflowStateListWithOffset($where: EditionDocumentationWorkflowState_Filter, $orderBy: [EditionDocumentationWorkflowState_OrderBy!], $offset: Int!, $take: Int!) {
  editionDocumentationWorkflowStateListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const EditionDocumentationWorkflowStateListWithCursorDocument = gql`
    query editionDocumentationWorkflowStateListWithCursor($where: EditionDocumentationWorkflowState_Filter, $orderBy: EditionDocumentationWorkflowState_OrderByCursor!, $cursorKey: String, $take: Int!) {
  editionDocumentationWorkflowStateListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const EditionTypeCreateDocument = gql`
    mutation editionTypeCreate($name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  editionTypeCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const EditionTypeUpdateDocument = gql`
    mutation editionTypeUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  editionTypeUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const EditionTypeDeleteDocument = gql`
    mutation editionTypeDelete($id: String!) {
  editionTypeDelete(id: $id) {
    id
  }
}
    `;
export const EditionTypeOneDocument = gql`
    query editionTypeOne($id: String!) {
  editionTypeOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const EditionTypeListWithOffsetDocument = gql`
    query editionTypeListWithOffset($where: EditionType_Filter, $orderBy: [EditionType_OrderBy!], $offset: Int!, $take: Int!) {
  editionTypeListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const EditionTypeListWithCursorDocument = gql`
    query editionTypeListWithCursor($where: EditionType_Filter, $orderBy: EditionType_OrderByCursor!, $cursorKey: String, $take: Int!) {
  editionTypeListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const EmailVerificationCreateDocument = gql`
    mutation emailVerificationCreate($email: String!, $idempotencyKey_: String) {
  emailVerificationCreate(email: $email, idempotencyKey_: $idempotencyKey_) {
    id
  }
}
    `;
export const EmailVerificationUpdateDocument = gql`
    mutation emailVerificationUpdate($id: String!, $version_: String!, $email: String!, $idempotencyKey_: String) {
  emailVerificationUpdate(
    id: $id
    version_: $version_
    email: $email
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const EmailVerificationDeleteDocument = gql`
    mutation emailVerificationDelete($id: String!) {
  emailVerificationDelete(id: $id) {
    id
  }
}
    `;
export const EmailVerificationOneDocument = gql`
    query emailVerificationOne($id: String!) {
  emailVerificationOne(id: $id) {
    id
    version_
    email
    status
    scope
    expiresAt
    sentAt
    verifiedAt
    sentCount
    lastSentAt
    requestedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    sourceEntity
    sourceRecordId
    validationChanges
    validationSubmittedAt
  }
}
    `;
export const EmailVerificationListWithOffsetDocument = gql`
    query emailVerificationListWithOffset($where: EmailVerification_Filter, $orderBy: [EmailVerification_OrderBy!], $offset: Int!, $take: Int!) {
  emailVerificationListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    email
    status
    scope
    expiresAt
    sentAt
    verifiedAt
    sentCount
    lastSentAt
    requestedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    sourceEntity
    sourceRecordId
    validationChanges
    validationSubmittedAt
  }
}
    `;
export const EmailVerificationListWithCursorDocument = gql`
    query emailVerificationListWithCursor($where: EmailVerification_Filter, $orderBy: EmailVerification_OrderByCursor!, $cursorKey: String, $take: Int!) {
  emailVerificationListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    email
    status
    scope
    expiresAt
    sentAt
    verifiedAt
    sentCount
    lastSentAt
    requestedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    sourceEntity
    sourceRecordId
    validationChanges
    validationSubmittedAt
  }
}
    `;
export const EsignatureConfigCreateDocument = gql`
    mutation esignatureConfigCreate($provider: EsignatureProvider!, $credentials: Json!, $sandboxMode: Boolean!, $webhookSecret: String, $enabled: Boolean!, $idempotencyKey_: String) {
  esignatureConfigCreate(
    provider: $provider
    credentials: $credentials
    sandboxMode: $sandboxMode
    webhookSecret: $webhookSecret
    enabled: $enabled
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const EsignatureConfigUpdateDocument = gql`
    mutation esignatureConfigUpdate($id: String!, $version_: String!, $provider: EsignatureProvider, $credentials: Json!, $sandboxMode: Boolean!, $webhookSecret: String, $enabled: Boolean!, $idempotencyKey_: String) {
  esignatureConfigUpdate(
    id: $id
    version_: $version_
    provider: $provider
    credentials: $credentials
    sandboxMode: $sandboxMode
    webhookSecret: $webhookSecret
    enabled: $enabled
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const EsignatureConfigOneDocument = gql`
    query esignatureConfigOne($id: String!) {
  esignatureConfigOne(id: $id) {
    id
    version_
    provider
    credentials
    sandboxMode
    webhookSecret
    enabled
  }
}
    `;
export const EsignatureConfigListWithOffsetDocument = gql`
    query esignatureConfigListWithOffset($where: EsignatureConfig_Filter, $orderBy: [EsignatureConfig_OrderBy!], $offset: Int!, $take: Int!) {
  esignatureConfigListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    provider
    credentials
    sandboxMode
    webhookSecret
    enabled
  }
}
    `;
export const EsignatureConfigListWithCursorDocument = gql`
    query esignatureConfigListWithCursor($where: EsignatureConfig_Filter, $orderBy: EsignatureConfig_OrderByCursor!, $cursorKey: String, $take: Int!) {
  esignatureConfigListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    provider
    credentials
    sandboxMode
    webhookSecret
    enabled
  }
}
    `;
export const EsignatureDocumentOneDocument = gql`
    query esignatureDocumentOne($id: String!) {
  esignatureDocumentOne(id: $id) {
    id
    version_
    externalId
    provider
    name
    status
    sentAt
    completedAt
    signedDocument
    signedDocument_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    sourceEntityType
    sourceEntityId
    recipients {
      id
      version_
      document {
        id
        version_
        externalId
        provider
        name
        status
        sentAt
        completedAt
        signedDocument
        signedDocument_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        sourceEntityType
        sourceEntityId
      }
      email
      name
      role
      order
      status
      signedAt
    }
  }
}
    `;
export const EsignatureDocumentListWithOffsetDocument = gql`
    query esignatureDocumentListWithOffset($where: EsignatureDocument_Filter, $orderBy: [EsignatureDocument_OrderBy!], $offset: Int!, $take: Int!) {
  esignatureDocumentListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    externalId
    provider
    name
    status
    sentAt
    completedAt
    signedDocument
    signedDocument_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    sourceEntityType
    sourceEntityId
    recipients {
      id
      version_
      document {
        id
        version_
        externalId
        provider
        name
        status
        sentAt
        completedAt
        signedDocument
        signedDocument_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        sourceEntityType
        sourceEntityId
      }
      email
      name
      role
      order
      status
      signedAt
    }
  }
}
    `;
export const EsignatureDocumentListWithCursorDocument = gql`
    query esignatureDocumentListWithCursor($where: EsignatureDocument_Filter, $orderBy: EsignatureDocument_OrderByCursor!, $cursorKey: String, $take: Int!) {
  esignatureDocumentListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    externalId
    provider
    name
    status
    sentAt
    completedAt
    signedDocument
    signedDocument_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    sourceEntityType
    sourceEntityId
    recipients {
      id
      version_
      document {
        id
        version_
        externalId
        provider
        name
        status
        sentAt
        completedAt
        signedDocument
        signedDocument_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        sourceEntityType
        sourceEntityId
      }
      email
      name
      role
      order
      status
      signedAt
    }
  }
}
    `;
export const EsignatureRecipientOneDocument = gql`
    query esignatureRecipientOne($id: String!) {
  esignatureRecipientOne(id: $id) {
    id
    version_
    document {
      id
      version_
      externalId
      provider
      name
      status
      sentAt
      completedAt
      signedDocument
      signedDocument_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      sourceEntityType
      sourceEntityId
      recipients {
        id
        version_
        document {
          id
          version_
          externalId
          provider
          name
          status
          sentAt
          completedAt
          signedDocument
          signedDocument_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          sourceEntityType
          sourceEntityId
        }
        email
        name
        role
        order
        status
        signedAt
      }
    }
    email
    name
    role
    order
    status
    signedAt
  }
}
    `;
export const EsignatureRecipientListWithOffsetDocument = gql`
    query esignatureRecipientListWithOffset($where: EsignatureRecipient_Filter, $orderBy: [EsignatureRecipient_OrderBy!], $offset: Int!, $take: Int!) {
  esignatureRecipientListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    document {
      id
      version_
      externalId
      provider
      name
      status
      sentAt
      completedAt
      signedDocument
      signedDocument_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      sourceEntityType
      sourceEntityId
      recipients {
        id
        version_
        document {
          id
          version_
          externalId
          provider
          name
          status
          sentAt
          completedAt
          signedDocument
          signedDocument_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          sourceEntityType
          sourceEntityId
        }
        email
        name
        role
        order
        status
        signedAt
      }
    }
    email
    name
    role
    order
    status
    signedAt
  }
}
    `;
export const EsignatureRecipientListWithCursorDocument = gql`
    query esignatureRecipientListWithCursor($where: EsignatureRecipient_Filter, $orderBy: EsignatureRecipient_OrderByCursor!, $cursorKey: String, $take: Int!) {
  esignatureRecipientListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    document {
      id
      version_
      externalId
      provider
      name
      status
      sentAt
      completedAt
      signedDocument
      signedDocument_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      sourceEntityType
      sourceEntityId
      recipients {
        id
        version_
        document {
          id
          version_
          externalId
          provider
          name
          status
          sentAt
          completedAt
          signedDocument
          signedDocument_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          sourceEntityType
          sourceEntityId
        }
        email
        name
        role
        order
        status
        signedAt
      }
    }
    email
    name
    role
    order
    status
    signedAt
  }
}
    `;
export const EsignatureWebhookEventOneDocument = gql`
    query esignatureWebhookEventOne($id: String!) {
  esignatureWebhookEventOne(id: $id) {
    id
    version_
    provider
    externalEventId
    eventType
    documentExternalId
    processedAt
    error
  }
}
    `;
export const EsignatureWebhookEventListWithOffsetDocument = gql`
    query esignatureWebhookEventListWithOffset($where: EsignatureWebhookEvent_Filter, $orderBy: [EsignatureWebhookEvent_OrderBy!], $offset: Int!, $take: Int!) {
  esignatureWebhookEventListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    provider
    externalEventId
    eventType
    documentExternalId
    processedAt
    error
  }
}
    `;
export const EsignatureWebhookEventListWithCursorDocument = gql`
    query esignatureWebhookEventListWithCursor($where: EsignatureWebhookEvent_Filter, $orderBy: EsignatureWebhookEvent_OrderByCursor!, $cursorKey: String, $take: Int!) {
  esignatureWebhookEventListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    provider
    externalEventId
    eventType
    documentExternalId
    processedAt
    error
  }
}
    `;
export const EvaluationQueryCreateDocument = gql`
    mutation evaluationQueryCreate($query: String!, $pathType: EvaluationPathType!, $difficulty: EvaluationDifficulty!, $expectedTool: String!, $expectedArgs: Json!, $acceptableTools: Json!, $expectedResponsePattern: String, $generatedFrom: Json!, $isAmbiguous: Boolean!, $ambiguityType: EvaluationAmbiguityType, $disambiguationResponse: String, $notes: String, $idempotencyKey_: String) {
  evaluationQueryCreate(
    query: $query
    pathType: $pathType
    difficulty: $difficulty
    expectedTool: $expectedTool
    expectedArgs: $expectedArgs
    acceptableTools: $acceptableTools
    expectedResponsePattern: $expectedResponsePattern
    generatedFrom: $generatedFrom
    isAmbiguous: $isAmbiguous
    ambiguityType: $ambiguityType
    disambiguationResponse: $disambiguationResponse
    notes: $notes
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const EvaluationQueryUpdateDocument = gql`
    mutation evaluationQueryUpdate($id: String!, $version_: String!, $query: String!, $pathType: EvaluationPathType, $difficulty: EvaluationDifficulty, $expectedTool: String!, $expectedArgs: Json!, $acceptableTools: Json!, $expectedResponsePattern: String, $generatedFrom: Json!, $isAmbiguous: Boolean!, $ambiguityType: EvaluationAmbiguityType, $disambiguationResponse: String, $notes: String, $idempotencyKey_: String) {
  evaluationQueryUpdate(
    id: $id
    version_: $version_
    query: $query
    pathType: $pathType
    difficulty: $difficulty
    expectedTool: $expectedTool
    expectedArgs: $expectedArgs
    acceptableTools: $acceptableTools
    expectedResponsePattern: $expectedResponsePattern
    generatedFrom: $generatedFrom
    isAmbiguous: $isAmbiguous
    ambiguityType: $ambiguityType
    disambiguationResponse: $disambiguationResponse
    notes: $notes
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const EvaluationQueryDeleteDocument = gql`
    mutation evaluationQueryDelete($id: String!) {
  evaluationQueryDelete(id: $id) {
    id
  }
}
    `;
export const EvaluationQueryOneDocument = gql`
    query evaluationQueryOne($id: String!) {
  evaluationQueryOne(id: $id) {
    id
    version_
    query
    pathType
    difficulty
    expectedTool
    expectedArgs
    acceptableTools
    expectedResponsePattern
    generatedFrom
    isAmbiguous
    ambiguityType
    disambiguationResponse
    notes
  }
}
    `;
export const EvaluationQueryListWithOffsetDocument = gql`
    query evaluationQueryListWithOffset($where: EvaluationQuery_Filter, $orderBy: [EvaluationQuery_OrderBy!], $offset: Int!, $take: Int!) {
  evaluationQueryListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    query
    pathType
    difficulty
    expectedTool
    expectedArgs
    acceptableTools
    expectedResponsePattern
    generatedFrom
    isAmbiguous
    ambiguityType
    disambiguationResponse
    notes
  }
}
    `;
export const EvaluationQueryListWithCursorDocument = gql`
    query evaluationQueryListWithCursor($where: EvaluationQuery_Filter, $orderBy: EvaluationQuery_OrderByCursor!, $cursorKey: String, $take: Int!) {
  evaluationQueryListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    query
    pathType
    difficulty
    expectedTool
    expectedArgs
    acceptableTools
    expectedResponsePattern
    generatedFrom
    isAmbiguous
    ambiguityType
    disambiguationResponse
    notes
  }
}
    `;
export const GrossReceiptsStatusCreateDocument = gql`
    mutation grossReceiptsStatusCreate($name_es: String!, $name_en: String!, $name_pt: String!, $description_es: String, $description_en: String, $description_pt: String, $idempotencyKey_: String) {
  grossReceiptsStatusCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const GrossReceiptsStatusUpdateDocument = gql`
    mutation grossReceiptsStatusUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $description_es: String, $description_en: String, $description_pt: String, $idempotencyKey_: String) {
  grossReceiptsStatusUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const GrossReceiptsStatusDeleteDocument = gql`
    mutation grossReceiptsStatusDelete($id: String!) {
  grossReceiptsStatusDelete(id: $id) {
    id
  }
}
    `;
export const GrossReceiptsStatusOneDocument = gql`
    query grossReceiptsStatusOne($id: String!) {
  grossReceiptsStatusOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const GrossReceiptsStatusListWithOffsetDocument = gql`
    query grossReceiptsStatusListWithOffset($where: GrossReceiptsStatus_Filter, $orderBy: [GrossReceiptsStatus_OrderBy!], $offset: Int!, $take: Int!) {
  grossReceiptsStatusListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const GrossReceiptsStatusListWithCursorDocument = gql`
    query grossReceiptsStatusListWithCursor($where: GrossReceiptsStatus_Filter, $orderBy: GrossReceiptsStatus_OrderByCursor!, $cursorKey: String, $take: Int!) {
  grossReceiptsStatusListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const InterpreterCreateDocument = gql`
    mutation interpreterCreate($name: String!, $idempotencyKey_: String) {
  interpreterCreate(name: $name, idempotencyKey_: $idempotencyKey_) {
    id
  }
}
    `;
export const InterpreterUpdateDocument = gql`
    mutation interpreterUpdate($id: String!, $version_: String!, $name: String!, $idempotencyKey_: String) {
  interpreterUpdate(
    id: $id
    version_: $version_
    name: $name
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const InterpreterDeleteDocument = gql`
    mutation interpreterDelete($id: String!) {
  interpreterDelete(id: $id) {
    id
  }
}
    `;
export const InterpreterOneDocument = gql`
    query interpreterOne($id: String!) {
  interpreterOne(id: $id) {
    id
    version_
    name
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const InterpreterListWithOffsetDocument = gql`
    query interpreterListWithOffset($where: Interpreter_Filter, $orderBy: [Interpreter_OrderBy!], $offset: Int!, $take: Int!) {
  interpreterListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const InterpreterListWithCursorDocument = gql`
    query interpreterListWithCursor($where: Interpreter_Filter, $orderBy: Interpreter_OrderByCursor!, $cursorKey: String, $take: Int!) {
  interpreterListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const LlmProviderCreateDocument = gql`
    mutation llmProviderCreate($name: String!, $code: String!, $requiresApiKey: Boolean!, $requiresBaseUrl: Boolean!, $defaultModels: [String!]!, $logoUrl: String, $idempotencyKey_: String) {
  llmProviderCreate(
    name: $name
    code: $code
    requiresApiKey: $requiresApiKey
    requiresBaseUrl: $requiresBaseUrl
    defaultModels: $defaultModels
    logoUrl: $logoUrl
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const LlmProviderUpdateDocument = gql`
    mutation llmProviderUpdate($id: String!, $version_: String!, $name: String!, $code: String!, $requiresApiKey: Boolean!, $requiresBaseUrl: Boolean!, $defaultModels: [String!], $logoUrl: String, $idempotencyKey_: String) {
  llmProviderUpdate(
    id: $id
    version_: $version_
    name: $name
    code: $code
    requiresApiKey: $requiresApiKey
    requiresBaseUrl: $requiresBaseUrl
    defaultModels: $defaultModels
    logoUrl: $logoUrl
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const LlmProviderDeleteDocument = gql`
    mutation llmProviderDelete($id: String!) {
  llmProviderDelete(id: $id) {
    id
  }
}
    `;
export const LlmProviderOneDocument = gql`
    query llmProviderOne($id: String!) {
  llmProviderOne(id: $id) {
    id
    version_
    name
    code
    requiresApiKey
    requiresBaseUrl
    defaultModels
    logoUrl
  }
}
    `;
export const LlmProviderListWithOffsetDocument = gql`
    query llmProviderListWithOffset($where: LlmProvider_Filter, $orderBy: [LlmProvider_OrderBy!], $offset: Int!, $take: Int!) {
  llmProviderListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    code
    requiresApiKey
    requiresBaseUrl
    defaultModels
    logoUrl
  }
}
    `;
export const LlmProviderListWithCursorDocument = gql`
    query llmProviderListWithCursor($where: LlmProvider_Filter, $orderBy: LlmProvider_OrderByCursor!, $cursorKey: String, $take: Int!) {
  llmProviderListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    code
    requiresApiKey
    requiresBaseUrl
    defaultModels
    logoUrl
  }
}
    `;
export const MusicalGenreCreateDocument = gql`
    mutation musicalGenreCreate($name: String!, $idempotencyKey_: String) {
  musicalGenreCreate(name: $name, idempotencyKey_: $idempotencyKey_) {
    id
  }
}
    `;
export const MusicalGenreUpdateDocument = gql`
    mutation musicalGenreUpdate($id: String!, $version_: String!, $name: String!, $idempotencyKey_: String) {
  musicalGenreUpdate(
    id: $id
    version_: $version_
    name: $name
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const MusicalGenreDeleteDocument = gql`
    mutation musicalGenreDelete($id: String!) {
  musicalGenreDelete(id: $id) {
    id
  }
}
    `;
export const MusicalGenreOneDocument = gql`
    query musicalGenreOne($id: String!) {
  musicalGenreOne(id: $id) {
    id
    version_
    name
  }
}
    `;
export const MusicalGenreListWithOffsetDocument = gql`
    query musicalGenreListWithOffset($where: MusicalGenre_Filter, $orderBy: [MusicalGenre_OrderBy!], $offset: Int!, $take: Int!) {
  musicalGenreListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
  }
}
    `;
export const MusicalGenreListWithCursorDocument = gql`
    query musicalGenreListWithCursor($where: MusicalGenre_Filter, $orderBy: MusicalGenre_OrderByCursor!, $cursorKey: String, $take: Int!) {
  musicalGenreListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
  }
}
    `;
export const MusicalWorkCreateDocument = gql`
    mutation musicalWorkCreate($title: String!, $musicalGenreId: String!, $alternativeTitles: [String!], $authors: [WorkAuthor_CreateInput!]!, $notes: String, $performersIds: [String!], $cmsId: String, $territoriesIds: [String!]!, $iswc: String, $score: UploadedFile, $phonograms: [Phonogram_CreateInput!], $originalLyrics: String, $contractObservation: String, $idempotencyKey_: String) {
  musicalWorkCreate(
    title: $title
    musicalGenreId: $musicalGenreId
    alternativeTitles: $alternativeTitles
    authors: $authors
    notes: $notes
    performersIds: $performersIds
    cmsId: $cmsId
    territoriesIds: $territoriesIds
    iswc: $iswc
    score: $score
    phonograms: $phonograms
    originalLyrics: $originalLyrics
    contractObservation: $contractObservation
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const MusicalWorkUpdateDocument = gql`
    mutation musicalWorkUpdate($id: String!, $version_: String!, $title: String!, $musicalGenreId: String!, $alternativeTitles: [String!], $authors: MusicalWork_authors_UpdateInput!, $notes: String, $performersIds: InputMultipleRef, $cmsId: String, $territoriesIds: InputMultipleRef, $iswc: String, $score: UploadedFile, $phonograms: MusicalWork_phonograms_UpdateInput, $originalLyrics: String, $contractObservation: String, $idempotencyKey_: String) {
  musicalWorkUpdate(
    id: $id
    version_: $version_
    title: $title
    musicalGenreId: $musicalGenreId
    alternativeTitles: $alternativeTitles
    authors: $authors
    notes: $notes
    performersIds: $performersIds
    cmsId: $cmsId
    territoriesIds: $territoriesIds
    iswc: $iswc
    score: $score
    phonograms: $phonograms
    originalLyrics: $originalLyrics
    contractObservation: $contractObservation
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const MusicalWorkDeleteDocument = gql`
    mutation musicalWorkDelete($id: String!) {
  musicalWorkDelete(id: $id) {
    id
  }
}
    `;
export const MusicalWorkOneDocument = gql`
    query musicalWorkOne($id: String!) {
  musicalWorkOne(id: $id) {
    id
    version_
    title
    musicalGenre {
      id
      version_
      name
    }
    alternativeTitles
    authors {
      id
      version_
      author {
        id
        version_
        firstName
        lastName
        gender
        taxIdType
        taxId
        cuitCertificate
        cuitCertificate_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        cuitCertificateIssuedAt
        cuitCertificateError
        cuitCertificateErrorType
        dniDeliveredToSadaicAt
        dniValidatedAt
        dniValidatedFields
        email
        phone
        dateOfBirth
        streetAndNumber
        floor
        suite
        postalCode
        city
        aka
        ipi
        createdAt_
        lastUpdatedAt_
      }
      lyricsPercentage
      musicPercentage
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
    }
    notes
    performers {
      id
      version_
      name
      createdAt_
      lastUpdatedAt_
    }
    cmsId
    territories {
      id
      version_
      name_es
      name_en
      name_pt
    }
    iswc
    workNumber
    score
    score_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    phonograms {
      id
      version_
      trackName
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      albumName
      publicationYear
      isrc
      originalProducer
      audioFile
      audioFile_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      mainAudio
      links {
        id
        version_
        url
        platform {
          id
          version_
          name
        }
        type {
          id
          version_
          name
        }
      }
      notes
    }
    originalLyrics
    contractObservation
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const MusicalWorkListWithOffsetDocument = gql`
    query musicalWorkListWithOffset($where: MusicalWork_Filter, $orderBy: [MusicalWork_OrderBy!], $offset: Int!, $take: Int!) {
  musicalWorkListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    title
    musicalGenre {
      id
      version_
      name
    }
    alternativeTitles
    authors {
      id
      version_
      author {
        id
        version_
        firstName
        lastName
        gender
        taxIdType
        taxId
        cuitCertificate
        cuitCertificate_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        cuitCertificateIssuedAt
        cuitCertificateError
        cuitCertificateErrorType
        dniDeliveredToSadaicAt
        dniValidatedAt
        dniValidatedFields
        email
        phone
        dateOfBirth
        streetAndNumber
        floor
        suite
        postalCode
        city
        aka
        ipi
        createdAt_
        lastUpdatedAt_
      }
      lyricsPercentage
      musicPercentage
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
    }
    notes
    performers {
      id
      version_
      name
      createdAt_
      lastUpdatedAt_
    }
    cmsId
    territories {
      id
      version_
      name_es
      name_en
      name_pt
    }
    iswc
    workNumber
    score
    score_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    phonograms {
      id
      version_
      trackName
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      albumName
      publicationYear
      isrc
      originalProducer
      audioFile
      audioFile_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      mainAudio
      links {
        id
        version_
        url
        platform {
          id
          version_
          name
        }
        type {
          id
          version_
          name
        }
      }
      notes
    }
    originalLyrics
    contractObservation
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const MusicalWorkListWithCursorDocument = gql`
    query musicalWorkListWithCursor($where: MusicalWork_Filter, $orderBy: MusicalWork_OrderByCursor!, $cursorKey: String, $take: Int!) {
  musicalWorkListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    title
    musicalGenre {
      id
      version_
      name
    }
    alternativeTitles
    authors {
      id
      version_
      author {
        id
        version_
        firstName
        lastName
        gender
        taxIdType
        taxId
        cuitCertificate
        cuitCertificate_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        cuitCertificateIssuedAt
        cuitCertificateError
        cuitCertificateErrorType
        dniDeliveredToSadaicAt
        dniValidatedAt
        dniValidatedFields
        email
        phone
        dateOfBirth
        streetAndNumber
        floor
        suite
        postalCode
        city
        aka
        ipi
        createdAt_
        lastUpdatedAt_
      }
      lyricsPercentage
      musicPercentage
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
    }
    notes
    performers {
      id
      version_
      name
      createdAt_
      lastUpdatedAt_
    }
    cmsId
    territories {
      id
      version_
      name_es
      name_en
      name_pt
    }
    iswc
    workNumber
    score
    score_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    phonograms {
      id
      version_
      trackName
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      albumName
      publicationYear
      isrc
      originalProducer
      audioFile
      audioFile_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      mainAudio
      links {
        id
        version_
        url
        platform {
          id
          version_
          name
        }
        type {
          id
          version_
          name
        }
      }
      notes
    }
    originalLyrics
    contractObservation
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const MusicalWorkLinkOneDocument = gql`
    query musicalWorkLinkOne($id: String!) {
  musicalWorkLinkOne(id: $id) {
    id
    version_
    url
    platform {
      id
      version_
      name
    }
    type {
      id
      version_
      name
    }
  }
}
    `;
export const MusicalWorkLinkListWithOffsetDocument = gql`
    query musicalWorkLinkListWithOffset($where: MusicalWorkLink_Filter, $orderBy: [MusicalWorkLink_OrderBy!], $offset: Int!, $take: Int!) {
  musicalWorkLinkListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    url
    platform {
      id
      version_
      name
    }
    type {
      id
      version_
      name
    }
  }
}
    `;
export const MusicalWorkLinkListWithCursorDocument = gql`
    query musicalWorkLinkListWithCursor($where: MusicalWorkLink_Filter, $orderBy: MusicalWorkLink_OrderByCursor!, $cursorKey: String, $take: Int!) {
  musicalWorkLinkListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    url
    platform {
      id
      version_
      name
    }
    type {
      id
      version_
      name
    }
  }
}
    `;
export const PaymentReceiptCreateDocument = gql`
    mutation paymentReceiptCreate($paymentReceipt: UploadedFile!, $typeId: String!, $amount: Decimal!, $issueDateTime: DateTime, $idempotencyKey_: String) {
  paymentReceiptCreate(
    paymentReceipt: $paymentReceipt
    typeId: $typeId
    amount: $amount
    issueDateTime: $issueDateTime
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const PaymentReceiptBatchCreateDocument = gql`
    mutation paymentReceiptBatchCreate($typeId: String!, $amount: Decimal!, $issueDateTime: DateTime, $files: [UploadedFile!]!) {
  paymentReceiptBatchCreate(
    typeId: $typeId
    amount: $amount
    issueDateTime: $issueDateTime
    files: $files
  ) {
    created
    results {
      id
    }
  }
}
    `;
export const PaymentReceiptUpdateDocument = gql`
    mutation paymentReceiptUpdate($id: String!, $version_: String!, $paymentReceipt: UploadedFile, $issueDateTime: DateTime, $idempotencyKey_: String) {
  paymentReceiptUpdate(
    id: $id
    version_: $version_
    paymentReceipt: $paymentReceipt
    issueDateTime: $issueDateTime
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const PaymentReceiptDeleteDocument = gql`
    mutation paymentReceiptDelete($id: String!) {
  paymentReceiptDelete(id: $id) {
    id
  }
}
    `;
export const PaymentReceiptOneDocument = gql`
    query paymentReceiptOne($id: String!) {
  paymentReceiptOne(id: $id) {
    id
    version_
    paymentReceipt
    paymentReceipt_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    crc
    type {
      id
      version_
      name_es
      name_en
      name_pt
      price
      currency {
        id
        version_
        code
        name
      }
    }
    amount
    issueDateTime
    status
    totalUses
    remainingUses
    usedDate
    signedEdition {
      id
      version_
      dndaState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      sadaicState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      works {
        id
        version_
        title
        musicalGenre {
          id
          version_
          name
        }
        alternativeTitles
        authors {
          id
          version_
          author {
            id
            version_
            firstName
            lastName
          }
          lyricsPercentage
          musicPercentage
          publishers {
            id
            version_
            percentage
          }
        }
        notes
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        cmsId
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        phonograms {
          id
          version_
          trackName
          performers {
            id
            version_
            name
          }
          albumName
          publicationYear
          isrc
          originalProducer
          audioFile
          audioFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          mainAudio
          links {
            id
            version_
          }
          notes
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      publicationDate
      dndaExpedienteNumber
      dndaDocuments {
        id
        version_
        name
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
      ejemplarPdf
      ejemplarPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      dndaComprobantePdf
      dndaComprobantePdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      blockchainCertificates {
        id
        version_
        name
        contractNumber
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        confirmedAt
      }
      dndaUploadLink
      dndaUploadPasswordHasValue
      dndaUploadKeyReceivedAt
      dndaUploadKeyExpiresAt
      dndaComprobanteReceivedAt
      dndaLastComprobantePollAt
      ejemplarGenerationAttempts
      dndaRegistroAttempts
      dndaUploadAttempts
      dndaLastOperationalError
      sadaicLastPolledAt
      sadaicDeliveredAt
      sadaicUploadAttempts
      sadaicLastOperationalError
      createdAt_
      lastUpdatedAt_
      data_ {
        name
        editionNumber
        price
        contentType
        publicationLink
        editionType {
          name_es
          name_en
          name_pt
        }
        works {
          title
          cmsId
          iswc
          originalLyrics
          notes
          score {
            filename
            mimetype
            size
            baseName
            uuid
          }
          phonograms {
            trackName
            isrc
            albumName
            publicationYear
            audioFile {
              filename
              mimetype
              size
              baseName
              uuid
            }
            mainAudio
            links {
              url
              platform {
                name
              }
              type {
                name
              }
            }
          }
          musicalGenre {
            name
          }
          performers {
            name
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            lyricsPercentage
            musicPercentage
            author {
              firstName
              lastName
              taxId
              taxIdType
              email
              phone
              dateOfBirth
              aka
              ipi
              streetAndNumber
              floor
              suite
              city
              postalCode
              nationality {
                name_es
                name_en
                name_pt
              }
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              managementSocieties {
                memberNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
            publishers {
              percentage
              durationInYears
              autoRenewalYears
              publisher {
                name
                pseudonym
                taxId
                caeIpi
                phone
                email
                personType
                maritalStatus
                streetAndNumber
                floor
                suite
                city
                postalCode
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                representatives {
                  name
                  role
                  email
                  phone
                  isSigner
                }
                managementSocieties {
                  cmsAccountNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
            }
          }
        }
        documentation {
          finalDocumentPdf {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          territoriesDisplay
          authorsDisplay
          contractDuration
          contractRenewal
          contractNumber
          publishers {
            percentage
            publisher {
              name
              pseudonym
              taxId
            }
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            firstName
            lastName
            taxId
          }
        }
        associatedDocuments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          authorsDisplay
          notes
          type {
            name
          }
        }
        userAttachments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          notes
        }
      }
      originalId_
      name
      editionNumber
    }
    uses {
      id
      version_
      detail
      usedAt
      signedEdition {
        id
        version_
        publicationDate
        dndaExpedienteNumber
        ejemplarPdf
        ejemplarPdf_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        dndaComprobantePdf
        dndaComprobantePdf_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        dndaUploadLink
        dndaUploadPasswordHasValue
        dndaUploadKeyReceivedAt
        dndaUploadKeyExpiresAt
        dndaComprobanteReceivedAt
        dndaLastComprobantePollAt
        ejemplarGenerationAttempts
        dndaRegistroAttempts
        dndaUploadAttempts
        dndaLastOperationalError
        sadaicLastPolledAt
        sadaicDeliveredAt
        sadaicUploadAttempts
        sadaicLastOperationalError
        createdAt_
        lastUpdatedAt_
        data_ {
          name
          editionNumber
          price
          contentType
          publicationLink
          editionType {
            name_es
            name_en
            name_pt
          }
          works {
            title
            cmsId
            iswc
            originalLyrics
            notes
            score {
              filename
              mimetype
              size
              baseName
              uuid
            }
            phonograms {
              trackName
              isrc
              albumName
              publicationYear
              audioFile {
                filename
                mimetype
                size
                baseName
                uuid
              }
              mainAudio
              links {
                url
                platform {
                  name
                }
                type {
                  name
                }
              }
            }
            musicalGenre {
              name
            }
            performers {
              name
            }
            territories {
              name_es
              name_en
              name_pt
            }
            authors {
              lyricsPercentage
              musicPercentage
              author {
                firstName
                lastName
                taxId
                taxIdType
                email
                phone
                dateOfBirth
                aka
                ipi
                streetAndNumber
                floor
                suite
                city
                postalCode
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                managementSocieties {
                  memberNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
              publishers {
                percentage
                durationInYears
                autoRenewalYears
                publisher {
                  name
                  pseudonym
                  taxId
                  caeIpi
                  phone
                  email
                  personType
                  maritalStatus
                  streetAndNumber
                  floor
                  suite
                  city
                  postalCode
                  country {
                    name_es
                    name_en
                    name_pt
                  }
                  province {
                    name_es
                    name_en
                    name_pt
                  }
                  nationality {
                    name_es
                    name_en
                    name_pt
                  }
                  representatives {
                    name
                    role
                    email
                    phone
                    isSigner
                  }
                  managementSocieties {
                    cmsAccountNumber
                    collectingSociety {
                      name
                      acronym
                    }
                  }
                }
              }
            }
          }
          documentation {
            finalDocumentPdf {
              filename
              mimetype
              size
              baseName
              uuid
            }
            publisherConfigurationDisplay
            territoriesDisplay
            authorsDisplay
            contractDuration
            contractRenewal
            contractNumber
            publishers {
              percentage
              publisher {
                name
                pseudonym
                taxId
              }
            }
            territories {
              name_es
              name_en
              name_pt
            }
            authors {
              firstName
              lastName
              taxId
            }
          }
          associatedDocuments {
            name
            file {
              filename
              mimetype
              size
              baseName
              uuid
            }
            publisherConfigurationDisplay
            authorsDisplay
            notes
            type {
              name
            }
          }
          userAttachments {
            name
            file {
              filename
              mimetype
              size
              baseName
              uuid
            }
            notes
          }
        }
        originalId_
        name
        editionNumber
      }
    }
  }
}
    `;
export const PaymentReceiptListWithOffsetDocument = gql`
    query paymentReceiptListWithOffset($where: PaymentReceipt_Filter, $orderBy: [PaymentReceipt_OrderBy!], $offset: Int!, $take: Int!) {
  paymentReceiptListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    paymentReceipt
    paymentReceipt_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    crc
    type {
      id
      version_
      name_es
      name_en
      name_pt
      price
      currency {
        id
        version_
        code
        name
      }
    }
    amount
    issueDateTime
    status
    totalUses
    remainingUses
    usedDate
    signedEdition {
      id
      version_
      dndaState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      sadaicState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      works {
        id
        version_
        title
        musicalGenre {
          id
          version_
          name
        }
        alternativeTitles
        authors {
          id
          version_
          author {
            id
            version_
            firstName
            lastName
          }
          lyricsPercentage
          musicPercentage
          publishers {
            id
            version_
            percentage
          }
        }
        notes
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        cmsId
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        phonograms {
          id
          version_
          trackName
          performers {
            id
            version_
            name
          }
          albumName
          publicationYear
          isrc
          originalProducer
          audioFile
          audioFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          mainAudio
          links {
            id
            version_
          }
          notes
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      publicationDate
      dndaExpedienteNumber
      dndaDocuments {
        id
        version_
        name
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
      ejemplarPdf
      ejemplarPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      dndaComprobantePdf
      dndaComprobantePdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      blockchainCertificates {
        id
        version_
        name
        contractNumber
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        confirmedAt
      }
      dndaUploadLink
      dndaUploadPasswordHasValue
      dndaUploadKeyReceivedAt
      dndaUploadKeyExpiresAt
      dndaComprobanteReceivedAt
      dndaLastComprobantePollAt
      ejemplarGenerationAttempts
      dndaRegistroAttempts
      dndaUploadAttempts
      dndaLastOperationalError
      sadaicLastPolledAt
      sadaicDeliveredAt
      sadaicUploadAttempts
      sadaicLastOperationalError
      createdAt_
      lastUpdatedAt_
      data_ {
        name
        editionNumber
        price
        contentType
        publicationLink
        editionType {
          name_es
          name_en
          name_pt
        }
        works {
          title
          cmsId
          iswc
          originalLyrics
          notes
          score {
            filename
            mimetype
            size
            baseName
            uuid
          }
          phonograms {
            trackName
            isrc
            albumName
            publicationYear
            audioFile {
              filename
              mimetype
              size
              baseName
              uuid
            }
            mainAudio
            links {
              url
              platform {
                name
              }
              type {
                name
              }
            }
          }
          musicalGenre {
            name
          }
          performers {
            name
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            lyricsPercentage
            musicPercentage
            author {
              firstName
              lastName
              taxId
              taxIdType
              email
              phone
              dateOfBirth
              aka
              ipi
              streetAndNumber
              floor
              suite
              city
              postalCode
              nationality {
                name_es
                name_en
                name_pt
              }
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              managementSocieties {
                memberNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
            publishers {
              percentage
              durationInYears
              autoRenewalYears
              publisher {
                name
                pseudonym
                taxId
                caeIpi
                phone
                email
                personType
                maritalStatus
                streetAndNumber
                floor
                suite
                city
                postalCode
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                representatives {
                  name
                  role
                  email
                  phone
                  isSigner
                }
                managementSocieties {
                  cmsAccountNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
            }
          }
        }
        documentation {
          finalDocumentPdf {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          territoriesDisplay
          authorsDisplay
          contractDuration
          contractRenewal
          contractNumber
          publishers {
            percentage
            publisher {
              name
              pseudonym
              taxId
            }
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            firstName
            lastName
            taxId
          }
        }
        associatedDocuments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          authorsDisplay
          notes
          type {
            name
          }
        }
        userAttachments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          notes
        }
      }
      originalId_
      name
      editionNumber
    }
    uses {
      id
      version_
      detail
      usedAt
      signedEdition {
        id
        version_
        publicationDate
        dndaExpedienteNumber
        ejemplarPdf
        ejemplarPdf_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        dndaComprobantePdf
        dndaComprobantePdf_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        dndaUploadLink
        dndaUploadPasswordHasValue
        dndaUploadKeyReceivedAt
        dndaUploadKeyExpiresAt
        dndaComprobanteReceivedAt
        dndaLastComprobantePollAt
        ejemplarGenerationAttempts
        dndaRegistroAttempts
        dndaUploadAttempts
        dndaLastOperationalError
        sadaicLastPolledAt
        sadaicDeliveredAt
        sadaicUploadAttempts
        sadaicLastOperationalError
        createdAt_
        lastUpdatedAt_
        data_ {
          name
          editionNumber
          price
          contentType
          publicationLink
          editionType {
            name_es
            name_en
            name_pt
          }
          works {
            title
            cmsId
            iswc
            originalLyrics
            notes
            score {
              filename
              mimetype
              size
              baseName
              uuid
            }
            phonograms {
              trackName
              isrc
              albumName
              publicationYear
              audioFile {
                filename
                mimetype
                size
                baseName
                uuid
              }
              mainAudio
              links {
                url
                platform {
                  name
                }
                type {
                  name
                }
              }
            }
            musicalGenre {
              name
            }
            performers {
              name
            }
            territories {
              name_es
              name_en
              name_pt
            }
            authors {
              lyricsPercentage
              musicPercentage
              author {
                firstName
                lastName
                taxId
                taxIdType
                email
                phone
                dateOfBirth
                aka
                ipi
                streetAndNumber
                floor
                suite
                city
                postalCode
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                managementSocieties {
                  memberNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
              publishers {
                percentage
                durationInYears
                autoRenewalYears
                publisher {
                  name
                  pseudonym
                  taxId
                  caeIpi
                  phone
                  email
                  personType
                  maritalStatus
                  streetAndNumber
                  floor
                  suite
                  city
                  postalCode
                  country {
                    name_es
                    name_en
                    name_pt
                  }
                  province {
                    name_es
                    name_en
                    name_pt
                  }
                  nationality {
                    name_es
                    name_en
                    name_pt
                  }
                  representatives {
                    name
                    role
                    email
                    phone
                    isSigner
                  }
                  managementSocieties {
                    cmsAccountNumber
                    collectingSociety {
                      name
                      acronym
                    }
                  }
                }
              }
            }
          }
          documentation {
            finalDocumentPdf {
              filename
              mimetype
              size
              baseName
              uuid
            }
            publisherConfigurationDisplay
            territoriesDisplay
            authorsDisplay
            contractDuration
            contractRenewal
            contractNumber
            publishers {
              percentage
              publisher {
                name
                pseudonym
                taxId
              }
            }
            territories {
              name_es
              name_en
              name_pt
            }
            authors {
              firstName
              lastName
              taxId
            }
          }
          associatedDocuments {
            name
            file {
              filename
              mimetype
              size
              baseName
              uuid
            }
            publisherConfigurationDisplay
            authorsDisplay
            notes
            type {
              name
            }
          }
          userAttachments {
            name
            file {
              filename
              mimetype
              size
              baseName
              uuid
            }
            notes
          }
        }
        originalId_
        name
        editionNumber
      }
    }
  }
}
    `;
export const PaymentReceiptListWithCursorDocument = gql`
    query paymentReceiptListWithCursor($where: PaymentReceipt_Filter, $orderBy: PaymentReceipt_OrderByCursor!, $cursorKey: String, $take: Int!) {
  paymentReceiptListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    paymentReceipt
    paymentReceipt_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    crc
    type {
      id
      version_
      name_es
      name_en
      name_pt
      price
      currency {
        id
        version_
        code
        name
      }
    }
    amount
    issueDateTime
    status
    totalUses
    remainingUses
    usedDate
    signedEdition {
      id
      version_
      dndaState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      sadaicState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      works {
        id
        version_
        title
        musicalGenre {
          id
          version_
          name
        }
        alternativeTitles
        authors {
          id
          version_
          author {
            id
            version_
            firstName
            lastName
          }
          lyricsPercentage
          musicPercentage
          publishers {
            id
            version_
            percentage
          }
        }
        notes
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        cmsId
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        phonograms {
          id
          version_
          trackName
          performers {
            id
            version_
            name
          }
          albumName
          publicationYear
          isrc
          originalProducer
          audioFile
          audioFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          mainAudio
          links {
            id
            version_
          }
          notes
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      publicationDate
      dndaExpedienteNumber
      dndaDocuments {
        id
        version_
        name
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
      ejemplarPdf
      ejemplarPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      dndaComprobantePdf
      dndaComprobantePdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      blockchainCertificates {
        id
        version_
        name
        contractNumber
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        confirmedAt
      }
      dndaUploadLink
      dndaUploadPasswordHasValue
      dndaUploadKeyReceivedAt
      dndaUploadKeyExpiresAt
      dndaComprobanteReceivedAt
      dndaLastComprobantePollAt
      ejemplarGenerationAttempts
      dndaRegistroAttempts
      dndaUploadAttempts
      dndaLastOperationalError
      sadaicLastPolledAt
      sadaicDeliveredAt
      sadaicUploadAttempts
      sadaicLastOperationalError
      createdAt_
      lastUpdatedAt_
      data_ {
        name
        editionNumber
        price
        contentType
        publicationLink
        editionType {
          name_es
          name_en
          name_pt
        }
        works {
          title
          cmsId
          iswc
          originalLyrics
          notes
          score {
            filename
            mimetype
            size
            baseName
            uuid
          }
          phonograms {
            trackName
            isrc
            albumName
            publicationYear
            audioFile {
              filename
              mimetype
              size
              baseName
              uuid
            }
            mainAudio
            links {
              url
              platform {
                name
              }
              type {
                name
              }
            }
          }
          musicalGenre {
            name
          }
          performers {
            name
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            lyricsPercentage
            musicPercentage
            author {
              firstName
              lastName
              taxId
              taxIdType
              email
              phone
              dateOfBirth
              aka
              ipi
              streetAndNumber
              floor
              suite
              city
              postalCode
              nationality {
                name_es
                name_en
                name_pt
              }
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              managementSocieties {
                memberNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
            publishers {
              percentage
              durationInYears
              autoRenewalYears
              publisher {
                name
                pseudonym
                taxId
                caeIpi
                phone
                email
                personType
                maritalStatus
                streetAndNumber
                floor
                suite
                city
                postalCode
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                representatives {
                  name
                  role
                  email
                  phone
                  isSigner
                }
                managementSocieties {
                  cmsAccountNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
            }
          }
        }
        documentation {
          finalDocumentPdf {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          territoriesDisplay
          authorsDisplay
          contractDuration
          contractRenewal
          contractNumber
          publishers {
            percentage
            publisher {
              name
              pseudonym
              taxId
            }
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            firstName
            lastName
            taxId
          }
        }
        associatedDocuments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          authorsDisplay
          notes
          type {
            name
          }
        }
        userAttachments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          notes
        }
      }
      originalId_
      name
      editionNumber
    }
    uses {
      id
      version_
      detail
      usedAt
      signedEdition {
        id
        version_
        publicationDate
        dndaExpedienteNumber
        ejemplarPdf
        ejemplarPdf_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        dndaComprobantePdf
        dndaComprobantePdf_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        dndaUploadLink
        dndaUploadPasswordHasValue
        dndaUploadKeyReceivedAt
        dndaUploadKeyExpiresAt
        dndaComprobanteReceivedAt
        dndaLastComprobantePollAt
        ejemplarGenerationAttempts
        dndaRegistroAttempts
        dndaUploadAttempts
        dndaLastOperationalError
        sadaicLastPolledAt
        sadaicDeliveredAt
        sadaicUploadAttempts
        sadaicLastOperationalError
        createdAt_
        lastUpdatedAt_
        data_ {
          name
          editionNumber
          price
          contentType
          publicationLink
          editionType {
            name_es
            name_en
            name_pt
          }
          works {
            title
            cmsId
            iswc
            originalLyrics
            notes
            score {
              filename
              mimetype
              size
              baseName
              uuid
            }
            phonograms {
              trackName
              isrc
              albumName
              publicationYear
              audioFile {
                filename
                mimetype
                size
                baseName
                uuid
              }
              mainAudio
              links {
                url
                platform {
                  name
                }
                type {
                  name
                }
              }
            }
            musicalGenre {
              name
            }
            performers {
              name
            }
            territories {
              name_es
              name_en
              name_pt
            }
            authors {
              lyricsPercentage
              musicPercentage
              author {
                firstName
                lastName
                taxId
                taxIdType
                email
                phone
                dateOfBirth
                aka
                ipi
                streetAndNumber
                floor
                suite
                city
                postalCode
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                managementSocieties {
                  memberNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
              publishers {
                percentage
                durationInYears
                autoRenewalYears
                publisher {
                  name
                  pseudonym
                  taxId
                  caeIpi
                  phone
                  email
                  personType
                  maritalStatus
                  streetAndNumber
                  floor
                  suite
                  city
                  postalCode
                  country {
                    name_es
                    name_en
                    name_pt
                  }
                  province {
                    name_es
                    name_en
                    name_pt
                  }
                  nationality {
                    name_es
                    name_en
                    name_pt
                  }
                  representatives {
                    name
                    role
                    email
                    phone
                    isSigner
                  }
                  managementSocieties {
                    cmsAccountNumber
                    collectingSociety {
                      name
                      acronym
                    }
                  }
                }
              }
            }
          }
          documentation {
            finalDocumentPdf {
              filename
              mimetype
              size
              baseName
              uuid
            }
            publisherConfigurationDisplay
            territoriesDisplay
            authorsDisplay
            contractDuration
            contractRenewal
            contractNumber
            publishers {
              percentage
              publisher {
                name
                pseudonym
                taxId
              }
            }
            territories {
              name_es
              name_en
              name_pt
            }
            authors {
              firstName
              lastName
              taxId
            }
          }
          associatedDocuments {
            name
            file {
              filename
              mimetype
              size
              baseName
              uuid
            }
            publisherConfigurationDisplay
            authorsDisplay
            notes
            type {
              name
            }
          }
          userAttachments {
            name
            file {
              filename
              mimetype
              size
              baseName
              uuid
            }
            notes
          }
        }
        originalId_
        name
        editionNumber
      }
    }
  }
}
    `;
export const PaymentReceiptTypeCreateDocument = gql`
    mutation paymentReceiptTypeCreate($name_es: String!, $name_en: String!, $name_pt: String!, $price: Decimal!, $currencyId: String!, $idempotencyKey_: String) {
  paymentReceiptTypeCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    price: $price
    currencyId: $currencyId
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const PaymentReceiptTypeUpdateDocument = gql`
    mutation paymentReceiptTypeUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $price: Decimal!, $currencyId: String!, $idempotencyKey_: String) {
  paymentReceiptTypeUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    price: $price
    currencyId: $currencyId
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const PaymentReceiptTypeDeleteDocument = gql`
    mutation paymentReceiptTypeDelete($id: String!) {
  paymentReceiptTypeDelete(id: $id) {
    id
  }
}
    `;
export const PaymentReceiptTypeOneDocument = gql`
    query paymentReceiptTypeOne($id: String!) {
  paymentReceiptTypeOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    price
    currency {
      id
      version_
      code
      name
    }
  }
}
    `;
export const PaymentReceiptTypeListWithOffsetDocument = gql`
    query paymentReceiptTypeListWithOffset($where: PaymentReceiptType_Filter, $orderBy: [PaymentReceiptType_OrderBy!], $offset: Int!, $take: Int!) {
  paymentReceiptTypeListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    price
    currency {
      id
      version_
      code
      name
    }
  }
}
    `;
export const PaymentReceiptTypeListWithCursorDocument = gql`
    query paymentReceiptTypeListWithCursor($where: PaymentReceiptType_Filter, $orderBy: PaymentReceiptType_OrderByCursor!, $cursorKey: String, $take: Int!) {
  paymentReceiptTypeListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    price
    currency {
      id
      version_
      code
      name
    }
  }
}
    `;
export const PaymentReceiptUseOneDocument = gql`
    query paymentReceiptUseOne($id: String!) {
  paymentReceiptUseOne(id: $id) {
    id
    version_
    detail
    usedAt
    signedEdition {
      id
      version_
      dndaState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      sadaicState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      works {
        id
        version_
        title
        musicalGenre {
          id
          version_
          name
        }
        alternativeTitles
        authors {
          id
          version_
          author {
            id
            version_
            firstName
            lastName
          }
          lyricsPercentage
          musicPercentage
          publishers {
            id
            version_
            percentage
          }
        }
        notes
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        cmsId
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        phonograms {
          id
          version_
          trackName
          performers {
            id
            version_
            name
          }
          albumName
          publicationYear
          isrc
          originalProducer
          audioFile
          audioFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          mainAudio
          links {
            id
            version_
          }
          notes
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      publicationDate
      dndaExpedienteNumber
      dndaDocuments {
        id
        version_
        name
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
      ejemplarPdf
      ejemplarPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      dndaComprobantePdf
      dndaComprobantePdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      blockchainCertificates {
        id
        version_
        name
        contractNumber
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        confirmedAt
      }
      dndaUploadLink
      dndaUploadPasswordHasValue
      dndaUploadKeyReceivedAt
      dndaUploadKeyExpiresAt
      dndaComprobanteReceivedAt
      dndaLastComprobantePollAt
      ejemplarGenerationAttempts
      dndaRegistroAttempts
      dndaUploadAttempts
      dndaLastOperationalError
      sadaicLastPolledAt
      sadaicDeliveredAt
      sadaicUploadAttempts
      sadaicLastOperationalError
      createdAt_
      lastUpdatedAt_
      data_ {
        name
        editionNumber
        price
        contentType
        publicationLink
        editionType {
          name_es
          name_en
          name_pt
        }
        works {
          title
          cmsId
          iswc
          originalLyrics
          notes
          score {
            filename
            mimetype
            size
            baseName
            uuid
          }
          phonograms {
            trackName
            isrc
            albumName
            publicationYear
            audioFile {
              filename
              mimetype
              size
              baseName
              uuid
            }
            mainAudio
            links {
              url
              platform {
                name
              }
              type {
                name
              }
            }
          }
          musicalGenre {
            name
          }
          performers {
            name
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            lyricsPercentage
            musicPercentage
            author {
              firstName
              lastName
              taxId
              taxIdType
              email
              phone
              dateOfBirth
              aka
              ipi
              streetAndNumber
              floor
              suite
              city
              postalCode
              nationality {
                name_es
                name_en
                name_pt
              }
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              managementSocieties {
                memberNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
            publishers {
              percentage
              durationInYears
              autoRenewalYears
              publisher {
                name
                pseudonym
                taxId
                caeIpi
                phone
                email
                personType
                maritalStatus
                streetAndNumber
                floor
                suite
                city
                postalCode
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                representatives {
                  name
                  role
                  email
                  phone
                  isSigner
                }
                managementSocieties {
                  cmsAccountNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
            }
          }
        }
        documentation {
          finalDocumentPdf {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          territoriesDisplay
          authorsDisplay
          contractDuration
          contractRenewal
          contractNumber
          publishers {
            percentage
            publisher {
              name
              pseudonym
              taxId
            }
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            firstName
            lastName
            taxId
          }
        }
        associatedDocuments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          authorsDisplay
          notes
          type {
            name
          }
        }
        userAttachments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          notes
        }
      }
      originalId_
      name
      editionNumber
    }
  }
}
    `;
export const PaymentReceiptUseListWithOffsetDocument = gql`
    query paymentReceiptUseListWithOffset($where: PaymentReceiptUse_Filter, $orderBy: [PaymentReceiptUse_OrderBy!], $offset: Int!, $take: Int!) {
  paymentReceiptUseListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    detail
    usedAt
    signedEdition {
      id
      version_
      dndaState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      sadaicState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      works {
        id
        version_
        title
        musicalGenre {
          id
          version_
          name
        }
        alternativeTitles
        authors {
          id
          version_
          author {
            id
            version_
            firstName
            lastName
          }
          lyricsPercentage
          musicPercentage
          publishers {
            id
            version_
            percentage
          }
        }
        notes
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        cmsId
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        phonograms {
          id
          version_
          trackName
          performers {
            id
            version_
            name
          }
          albumName
          publicationYear
          isrc
          originalProducer
          audioFile
          audioFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          mainAudio
          links {
            id
            version_
          }
          notes
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      publicationDate
      dndaExpedienteNumber
      dndaDocuments {
        id
        version_
        name
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
      ejemplarPdf
      ejemplarPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      dndaComprobantePdf
      dndaComprobantePdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      blockchainCertificates {
        id
        version_
        name
        contractNumber
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        confirmedAt
      }
      dndaUploadLink
      dndaUploadPasswordHasValue
      dndaUploadKeyReceivedAt
      dndaUploadKeyExpiresAt
      dndaComprobanteReceivedAt
      dndaLastComprobantePollAt
      ejemplarGenerationAttempts
      dndaRegistroAttempts
      dndaUploadAttempts
      dndaLastOperationalError
      sadaicLastPolledAt
      sadaicDeliveredAt
      sadaicUploadAttempts
      sadaicLastOperationalError
      createdAt_
      lastUpdatedAt_
      data_ {
        name
        editionNumber
        price
        contentType
        publicationLink
        editionType {
          name_es
          name_en
          name_pt
        }
        works {
          title
          cmsId
          iswc
          originalLyrics
          notes
          score {
            filename
            mimetype
            size
            baseName
            uuid
          }
          phonograms {
            trackName
            isrc
            albumName
            publicationYear
            audioFile {
              filename
              mimetype
              size
              baseName
              uuid
            }
            mainAudio
            links {
              url
              platform {
                name
              }
              type {
                name
              }
            }
          }
          musicalGenre {
            name
          }
          performers {
            name
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            lyricsPercentage
            musicPercentage
            author {
              firstName
              lastName
              taxId
              taxIdType
              email
              phone
              dateOfBirth
              aka
              ipi
              streetAndNumber
              floor
              suite
              city
              postalCode
              nationality {
                name_es
                name_en
                name_pt
              }
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              managementSocieties {
                memberNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
            publishers {
              percentage
              durationInYears
              autoRenewalYears
              publisher {
                name
                pseudonym
                taxId
                caeIpi
                phone
                email
                personType
                maritalStatus
                streetAndNumber
                floor
                suite
                city
                postalCode
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                representatives {
                  name
                  role
                  email
                  phone
                  isSigner
                }
                managementSocieties {
                  cmsAccountNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
            }
          }
        }
        documentation {
          finalDocumentPdf {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          territoriesDisplay
          authorsDisplay
          contractDuration
          contractRenewal
          contractNumber
          publishers {
            percentage
            publisher {
              name
              pseudonym
              taxId
            }
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            firstName
            lastName
            taxId
          }
        }
        associatedDocuments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          authorsDisplay
          notes
          type {
            name
          }
        }
        userAttachments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          notes
        }
      }
      originalId_
      name
      editionNumber
    }
  }
}
    `;
export const PaymentReceiptUseListWithCursorDocument = gql`
    query paymentReceiptUseListWithCursor($where: PaymentReceiptUse_Filter, $orderBy: PaymentReceiptUse_OrderByCursor!, $cursorKey: String, $take: Int!) {
  paymentReceiptUseListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    detail
    usedAt
    signedEdition {
      id
      version_
      dndaState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      sadaicState {
        id
        version_
        name_es
        name_en
        name_pt
      }
      works {
        id
        version_
        title
        musicalGenre {
          id
          version_
          name
        }
        alternativeTitles
        authors {
          id
          version_
          author {
            id
            version_
            firstName
            lastName
          }
          lyricsPercentage
          musicPercentage
          publishers {
            id
            version_
            percentage
          }
        }
        notes
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        cmsId
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
        iswc
        workNumber
        score
        score_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        phonograms {
          id
          version_
          trackName
          performers {
            id
            version_
            name
          }
          albumName
          publicationYear
          isrc
          originalProducer
          audioFile
          audioFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          mainAudio
          links {
            id
            version_
          }
          notes
        }
        originalLyrics
        contractObservation
        createdAt_
        lastUpdatedAt_
      }
      publicationDate
      dndaExpedienteNumber
      dndaDocuments {
        id
        version_
        name
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
      ejemplarPdf
      ejemplarPdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      dndaComprobantePdf
      dndaComprobantePdf_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      blockchainCertificates {
        id
        version_
        name
        contractNumber
        file
        file_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        confirmedAt
      }
      dndaUploadLink
      dndaUploadPasswordHasValue
      dndaUploadKeyReceivedAt
      dndaUploadKeyExpiresAt
      dndaComprobanteReceivedAt
      dndaLastComprobantePollAt
      ejemplarGenerationAttempts
      dndaRegistroAttempts
      dndaUploadAttempts
      dndaLastOperationalError
      sadaicLastPolledAt
      sadaicDeliveredAt
      sadaicUploadAttempts
      sadaicLastOperationalError
      createdAt_
      lastUpdatedAt_
      data_ {
        name
        editionNumber
        price
        contentType
        publicationLink
        editionType {
          name_es
          name_en
          name_pt
        }
        works {
          title
          cmsId
          iswc
          originalLyrics
          notes
          score {
            filename
            mimetype
            size
            baseName
            uuid
          }
          phonograms {
            trackName
            isrc
            albumName
            publicationYear
            audioFile {
              filename
              mimetype
              size
              baseName
              uuid
            }
            mainAudio
            links {
              url
              platform {
                name
              }
              type {
                name
              }
            }
          }
          musicalGenre {
            name
          }
          performers {
            name
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            lyricsPercentage
            musicPercentage
            author {
              firstName
              lastName
              taxId
              taxIdType
              email
              phone
              dateOfBirth
              aka
              ipi
              streetAndNumber
              floor
              suite
              city
              postalCode
              nationality {
                name_es
                name_en
                name_pt
              }
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              managementSocieties {
                memberNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
            publishers {
              percentage
              durationInYears
              autoRenewalYears
              publisher {
                name
                pseudonym
                taxId
                caeIpi
                phone
                email
                personType
                maritalStatus
                streetAndNumber
                floor
                suite
                city
                postalCode
                country {
                  name_es
                  name_en
                  name_pt
                }
                province {
                  name_es
                  name_en
                  name_pt
                }
                nationality {
                  name_es
                  name_en
                  name_pt
                }
                representatives {
                  name
                  role
                  email
                  phone
                  isSigner
                }
                managementSocieties {
                  cmsAccountNumber
                  collectingSociety {
                    name
                    acronym
                  }
                }
              }
            }
          }
        }
        documentation {
          finalDocumentPdf {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          territoriesDisplay
          authorsDisplay
          contractDuration
          contractRenewal
          contractNumber
          publishers {
            percentage
            publisher {
              name
              pseudonym
              taxId
            }
          }
          territories {
            name_es
            name_en
            name_pt
          }
          authors {
            firstName
            lastName
            taxId
          }
        }
        associatedDocuments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          publisherConfigurationDisplay
          authorsDisplay
          notes
          type {
            name
          }
        }
        userAttachments {
          name
          file {
            filename
            mimetype
            size
            baseName
            uuid
          }
          notes
        }
      }
      originalId_
      name
      editionNumber
    }
  }
}
    `;
export const PermissionCreateDocument = gql`
    mutation permissionCreate($name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  permissionCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const PermissionUpdateDocument = gql`
    mutation permissionUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  permissionUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const PermissionDeleteDocument = gql`
    mutation permissionDelete($id: String!) {
  permissionDelete(id: $id) {
    id
  }
}
    `;
export const PermissionOneDocument = gql`
    query permissionOne($id: String!) {
  permissionOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const PermissionListWithOffsetDocument = gql`
    query permissionListWithOffset($where: Permission_Filter, $orderBy: [Permission_OrderBy!], $offset: Int!, $take: Int!) {
  permissionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const PermissionListWithCursorDocument = gql`
    query permissionListWithCursor($where: Permission_Filter, $orderBy: Permission_OrderByCursor!, $cursorKey: String, $take: Int!) {
  permissionListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const PhonogramOneDocument = gql`
    query phonogramOne($id: String!) {
  phonogramOne(id: $id) {
    id
    version_
    trackName
    performers {
      id
      version_
      name
      createdAt_
      lastUpdatedAt_
    }
    albumName
    publicationYear
    isrc
    originalProducer
    audioFile
    audioFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    mainAudio
    links {
      id
      version_
      url
      platform {
        id
        version_
        name
      }
      type {
        id
        version_
        name
      }
    }
    notes
  }
}
    `;
export const PhonogramListWithOffsetDocument = gql`
    query phonogramListWithOffset($where: Phonogram_Filter, $orderBy: [Phonogram_OrderBy!], $offset: Int!, $take: Int!) {
  phonogramListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    trackName
    performers {
      id
      version_
      name
      createdAt_
      lastUpdatedAt_
    }
    albumName
    publicationYear
    isrc
    originalProducer
    audioFile
    audioFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    mainAudio
    links {
      id
      version_
      url
      platform {
        id
        version_
        name
      }
      type {
        id
        version_
        name
      }
    }
    notes
  }
}
    `;
export const PhonogramListWithCursorDocument = gql`
    query phonogramListWithCursor($where: Phonogram_Filter, $orderBy: Phonogram_OrderByCursor!, $cursorKey: String, $take: Int!) {
  phonogramListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    trackName
    performers {
      id
      version_
      name
      createdAt_
      lastUpdatedAt_
    }
    albumName
    publicationYear
    isrc
    originalProducer
    audioFile
    audioFile_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    mainAudio
    links {
      id
      version_
      url
      platform {
        id
        version_
        name
      }
      type {
        id
        version_
        name
      }
    }
    notes
  }
}
    `;
export const PlatformCreateDocument = gql`
    mutation platformCreate($name: String!, $idempotencyKey_: String) {
  platformCreate(name: $name, idempotencyKey_: $idempotencyKey_) {
    id
  }
}
    `;
export const PlatformUpdateDocument = gql`
    mutation platformUpdate($id: String!, $version_: String!, $name: String!, $idempotencyKey_: String) {
  platformUpdate(
    id: $id
    version_: $version_
    name: $name
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const PlatformDeleteDocument = gql`
    mutation platformDelete($id: String!) {
  platformDelete(id: $id) {
    id
  }
}
    `;
export const PlatformOneDocument = gql`
    query platformOne($id: String!) {
  platformOne(id: $id) {
    id
    version_
    name
  }
}
    `;
export const PlatformListWithOffsetDocument = gql`
    query platformListWithOffset($where: Platform_Filter, $orderBy: [Platform_OrderBy!], $offset: Int!, $take: Int!) {
  platformListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
  }
}
    `;
export const PlatformListWithCursorDocument = gql`
    query platformListWithCursor($where: Platform_Filter, $orderBy: Platform_OrderByCursor!, $cursorKey: String, $take: Int!) {
  platformListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
  }
}
    `;
export const PlatformLinkTypeCreateDocument = gql`
    mutation platformLinkTypeCreate($name: String!, $idempotencyKey_: String) {
  platformLinkTypeCreate(name: $name, idempotencyKey_: $idempotencyKey_) {
    id
  }
}
    `;
export const PlatformLinkTypeUpdateDocument = gql`
    mutation platformLinkTypeUpdate($id: String!, $version_: String!, $name: String!, $idempotencyKey_: String) {
  platformLinkTypeUpdate(
    id: $id
    version_: $version_
    name: $name
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const PlatformLinkTypeDeleteDocument = gql`
    mutation platformLinkTypeDelete($id: String!) {
  platformLinkTypeDelete(id: $id) {
    id
  }
}
    `;
export const PlatformLinkTypeOneDocument = gql`
    query platformLinkTypeOne($id: String!) {
  platformLinkTypeOne(id: $id) {
    id
    version_
    name
  }
}
    `;
export const PlatformLinkTypeListWithOffsetDocument = gql`
    query platformLinkTypeListWithOffset($where: PlatformLinkType_Filter, $orderBy: [PlatformLinkType_OrderBy!], $offset: Int!, $take: Int!) {
  platformLinkTypeListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
  }
}
    `;
export const PlatformLinkTypeListWithCursorDocument = gql`
    query platformLinkTypeListWithCursor($where: PlatformLinkType_Filter, $orderBy: PlatformLinkType_OrderByCursor!, $cursorKey: String, $take: Int!) {
  platformLinkTypeListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
  }
}
    `;
export const ProvinceStateCreateDocument = gql`
    mutation provinceStateCreate($name_es: String!, $name_en: String!, $name_pt: String!, $countryId: String!, $idempotencyKey_: String) {
  provinceStateCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    countryId: $countryId
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const ProvinceStateUpdateDocument = gql`
    mutation provinceStateUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $countryId: String!, $idempotencyKey_: String) {
  provinceStateUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    countryId: $countryId
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const ProvinceStateDeleteDocument = gql`
    mutation provinceStateDelete($id: String!) {
  provinceStateDelete(id: $id) {
    id
  }
}
    `;
export const ProvinceStateOneDocument = gql`
    query provinceStateOne($id: String!) {
  provinceStateOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
  }
}
    `;
export const ProvinceStateListWithOffsetDocument = gql`
    query provinceStateListWithOffset($where: ProvinceState_Filter, $orderBy: [ProvinceState_OrderBy!], $offset: Int!, $take: Int!) {
  provinceStateListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
  }
}
    `;
export const ProvinceStateListWithCursorDocument = gql`
    query provinceStateListWithCursor($where: ProvinceState_Filter, $orderBy: ProvinceState_OrderByCursor!, $cursorKey: String, $take: Int!) {
  provinceStateListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
  }
}
    `;
export const PublisherCreateDocument = gql`
    mutation publisherCreate($personType: PersonType!, $name: String!, $maritalStatus: MaritalStatus, $nationalityId: String, $pseudonym: String, $taxId: String!, $phone: String!, $email: String!, $streetAndNumber: String!, $floor: String, $suite: String, $postalCode: String!, $countryId: String!, $provinceId: String!, $city: String!, $caeIpi: String!, $representatives: [PublisherRepresentative_CreateInput!]!, $managementSocieties: [PublisherCollectingSociety_CreateInput!], $idempotencyKey_: String) {
  publisherCreate(
    personType: $personType
    name: $name
    maritalStatus: $maritalStatus
    nationalityId: $nationalityId
    pseudonym: $pseudonym
    taxId: $taxId
    phone: $phone
    email: $email
    streetAndNumber: $streetAndNumber
    floor: $floor
    suite: $suite
    postalCode: $postalCode
    countryId: $countryId
    provinceId: $provinceId
    city: $city
    caeIpi: $caeIpi
    representatives: $representatives
    managementSocieties: $managementSocieties
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const PublisherUpdateDocument = gql`
    mutation publisherUpdate($id: String!, $version_: String!, $personType: PersonType, $name: String!, $maritalStatus: MaritalStatus, $nationalityId: String, $pseudonym: String, $taxId: String!, $phone: String!, $email: String!, $streetAndNumber: String!, $floor: String, $suite: String, $postalCode: String!, $countryId: String!, $provinceId: String!, $city: String!, $caeIpi: String!, $representatives: Publisher_representatives_UpdateInput!, $managementSocieties: Publisher_managementSocieties_UpdateInput, $idempotencyKey_: String) {
  publisherUpdate(
    id: $id
    version_: $version_
    personType: $personType
    name: $name
    maritalStatus: $maritalStatus
    nationalityId: $nationalityId
    pseudonym: $pseudonym
    taxId: $taxId
    phone: $phone
    email: $email
    streetAndNumber: $streetAndNumber
    floor: $floor
    suite: $suite
    postalCode: $postalCode
    countryId: $countryId
    provinceId: $provinceId
    city: $city
    caeIpi: $caeIpi
    representatives: $representatives
    managementSocieties: $managementSocieties
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const PublisherDeleteDocument = gql`
    mutation publisherDelete($id: String!) {
  publisherDelete(id: $id) {
    id
  }
}
    `;
export const PublisherOneDocument = gql`
    query publisherOne($id: String!) {
  publisherOne(id: $id) {
    id
    version_
    personType
    name
    maritalStatus
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    pseudonym
    taxId
    phone
    email
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    caeIpi
    representatives {
      id
      version_
      name
      role
      email
      phone
      isSigner
    }
    managementSocieties {
      id
      version_
      collectingSociety {
        id
        version_
        name
        acronym
      }
      cmsAccountNumber
    }
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const PublisherListWithOffsetDocument = gql`
    query publisherListWithOffset($where: Publisher_Filter, $orderBy: [Publisher_OrderBy!], $offset: Int!, $take: Int!) {
  publisherListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    personType
    name
    maritalStatus
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    pseudonym
    taxId
    phone
    email
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    caeIpi
    representatives {
      id
      version_
      name
      role
      email
      phone
      isSigner
    }
    managementSocieties {
      id
      version_
      collectingSociety {
        id
        version_
        name
        acronym
      }
      cmsAccountNumber
    }
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const PublisherListWithCursorDocument = gql`
    query publisherListWithCursor($where: Publisher_Filter, $orderBy: Publisher_OrderByCursor!, $cursorKey: String, $take: Int!) {
  publisherListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    personType
    name
    maritalStatus
    nationality {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    pseudonym
    taxId
    phone
    email
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    caeIpi
    representatives {
      id
      version_
      name
      role
      email
      phone
      isSigner
    }
    managementSocieties {
      id
      version_
      collectingSociety {
        id
        version_
        name
        acronym
      }
      cmsAccountNumber
    }
    createdAt_
    lastUpdatedAt_
  }
}
    `;
export const PublisherCollectingSocietyOneDocument = gql`
    query publisherCollectingSocietyOne($id: String!) {
  publisherCollectingSocietyOne(id: $id) {
    id
    version_
    collectingSociety {
      id
      version_
      name
      acronym
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    cmsAccountNumber
  }
}
    `;
export const PublisherCollectingSocietyListWithOffsetDocument = gql`
    query publisherCollectingSocietyListWithOffset($where: PublisherCollectingSociety_Filter, $orderBy: [PublisherCollectingSociety_OrderBy!], $offset: Int!, $take: Int!) {
  publisherCollectingSocietyListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    collectingSociety {
      id
      version_
      name
      acronym
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    cmsAccountNumber
  }
}
    `;
export const PublisherCollectingSocietyListWithCursorDocument = gql`
    query publisherCollectingSocietyListWithCursor($where: PublisherCollectingSociety_Filter, $orderBy: PublisherCollectingSociety_OrderByCursor!, $cursorKey: String, $take: Int!) {
  publisherCollectingSocietyListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    collectingSociety {
      id
      version_
      name
      acronym
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    cmsAccountNumber
  }
}
    `;
export const PublisherRepresentativeOneDocument = gql`
    query publisherRepresentativeOne($id: String!) {
  publisherRepresentativeOne(id: $id) {
    id
    version_
    name
    role
    email
    phone
    isSigner
  }
}
    `;
export const PublisherRepresentativeListWithOffsetDocument = gql`
    query publisherRepresentativeListWithOffset($where: PublisherRepresentative_Filter, $orderBy: [PublisherRepresentative_OrderBy!], $offset: Int!, $take: Int!) {
  publisherRepresentativeListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    role
    email
    phone
    isSigner
  }
}
    `;
export const PublisherRepresentativeListWithCursorDocument = gql`
    query publisherRepresentativeListWithCursor($where: PublisherRepresentative_Filter, $orderBy: PublisherRepresentative_OrderByCursor!, $cursorKey: String, $take: Int!) {
  publisherRepresentativeListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    role
    email
    phone
    isSigner
  }
}
    `;
export const QueryPatternCreateDocument = gql`
    mutation queryPatternCreate($name: String!, $pattern: String!, $pathType: EvaluationPathType!, $variables: Json!, $toolTemplate: String!, $argsTemplate: Json!, $variations: Json!, $exampleInstantiation: String!, $source: QueryPatternSource!, $qualityScore: Int!, $usageCount: Int!, $isActive: Boolean!, $notes: String, $idempotencyKey_: String) {
  queryPatternCreate(
    name: $name
    pattern: $pattern
    pathType: $pathType
    variables: $variables
    toolTemplate: $toolTemplate
    argsTemplate: $argsTemplate
    variations: $variations
    exampleInstantiation: $exampleInstantiation
    source: $source
    qualityScore: $qualityScore
    usageCount: $usageCount
    isActive: $isActive
    notes: $notes
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const QueryPatternUpdateDocument = gql`
    mutation queryPatternUpdate($id: String!, $version_: String!, $name: String!, $pattern: String!, $pathType: EvaluationPathType, $variables: Json!, $toolTemplate: String!, $argsTemplate: Json!, $variations: Json!, $exampleInstantiation: String!, $source: QueryPatternSource, $qualityScore: Int!, $usageCount: Int!, $isActive: Boolean!, $notes: String, $idempotencyKey_: String) {
  queryPatternUpdate(
    id: $id
    version_: $version_
    name: $name
    pattern: $pattern
    pathType: $pathType
    variables: $variables
    toolTemplate: $toolTemplate
    argsTemplate: $argsTemplate
    variations: $variations
    exampleInstantiation: $exampleInstantiation
    source: $source
    qualityScore: $qualityScore
    usageCount: $usageCount
    isActive: $isActive
    notes: $notes
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const QueryPatternDeleteDocument = gql`
    mutation queryPatternDelete($id: String!) {
  queryPatternDelete(id: $id) {
    id
  }
}
    `;
export const QueryPatternOneDocument = gql`
    query queryPatternOne($id: String!) {
  queryPatternOne(id: $id) {
    id
    version_
    name
    pattern
    pathType
    variables
    toolTemplate
    argsTemplate
    variations
    exampleInstantiation
    source
    qualityScore
    usageCount
    isActive
    notes
  }
}
    `;
export const QueryPatternListWithOffsetDocument = gql`
    query queryPatternListWithOffset($where: QueryPattern_Filter, $orderBy: [QueryPattern_OrderBy!], $offset: Int!, $take: Int!) {
  queryPatternListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    pattern
    pathType
    variables
    toolTemplate
    argsTemplate
    variations
    exampleInstantiation
    source
    qualityScore
    usageCount
    isActive
    notes
  }
}
    `;
export const QueryPatternListWithCursorDocument = gql`
    query queryPatternListWithCursor($where: QueryPattern_Filter, $orderBy: QueryPattern_OrderByCursor!, $cursorKey: String, $take: Int!) {
  queryPatternListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    pattern
    pathType
    variables
    toolTemplate
    argsTemplate
    variations
    exampleInstantiation
    source
    qualityScore
    usageCount
    isActive
    notes
  }
}
    `;
export const ReportCreateDocument = gql`
    mutation reportCreate($name: String!, $reportTypeId: String!, $template: String!, $constants: String, $description: String, $idempotencyKey_: String) {
  reportCreate(
    name: $name
    reportTypeId: $reportTypeId
    template: $template
    constants: $constants
    description: $description
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const ReportUpdateDocument = gql`
    mutation reportUpdate($id: String!, $version_: String!, $name: String!, $reportTypeId: String!, $template: String!, $constants: String, $description: String, $idempotencyKey_: String) {
  reportUpdate(
    id: $id
    version_: $version_
    name: $name
    reportTypeId: $reportTypeId
    template: $template
    constants: $constants
    description: $description
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const ReportDeleteDocument = gql`
    mutation reportDelete($id: String!) {
  reportDelete(id: $id) {
    id
  }
}
    `;
export const ReportOneDocument = gql`
    query reportOne($id: String!) {
  reportOne(id: $id) {
    id
    version_
    name
    reportType {
      id
      version_
      name
      description
    }
    template
    constants
    description
  }
}
    `;
export const ReportListWithOffsetDocument = gql`
    query reportListWithOffset($where: Report_Filter, $orderBy: [Report_OrderBy!], $offset: Int!, $take: Int!) {
  reportListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    reportType {
      id
      version_
      name
      description
    }
    template
    constants
    description
  }
}
    `;
export const ReportListWithCursorDocument = gql`
    query reportListWithCursor($where: Report_Filter, $orderBy: Report_OrderByCursor!, $cursorKey: String, $take: Int!) {
  reportListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    reportType {
      id
      version_
      name
      description
    }
    template
    constants
    description
  }
}
    `;
export const ReportTypeCreateDocument = gql`
    mutation reportTypeCreate($name: String!, $description: String, $idempotencyKey_: String) {
  reportTypeCreate(
    name: $name
    description: $description
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const ReportTypeUpdateDocument = gql`
    mutation reportTypeUpdate($id: String!, $version_: String!, $name: String!, $description: String, $idempotencyKey_: String) {
  reportTypeUpdate(
    id: $id
    version_: $version_
    name: $name
    description: $description
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const ReportTypeDeleteDocument = gql`
    mutation reportTypeDelete($id: String!) {
  reportTypeDelete(id: $id) {
    id
  }
}
    `;
export const ReportTypeOneDocument = gql`
    query reportTypeOne($id: String!) {
  reportTypeOne(id: $id) {
    id
    version_
    name
    description
  }
}
    `;
export const ReportTypeListWithOffsetDocument = gql`
    query reportTypeListWithOffset($where: ReportType_Filter, $orderBy: [ReportType_OrderBy!], $offset: Int!, $take: Int!) {
  reportTypeListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    description
  }
}
    `;
export const ReportTypeListWithCursorDocument = gql`
    query reportTypeListWithCursor($where: ReportType_Filter, $orderBy: ReportType_OrderByCursor!, $cursorKey: String, $take: Int!) {
  reportTypeListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    description
  }
}
    `;
export const RoleCreateDocument = gql`
    mutation roleCreate($name_es: String!, $name_en: String!, $name_pt: String!, $permissionsIds: [String!], $audience: String!, $isForAllTenants: Boolean!, $idempotencyKey_: String) {
  roleCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    permissionsIds: $permissionsIds
    audience: $audience
    isForAllTenants: $isForAllTenants
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const RoleUpdateDocument = gql`
    mutation roleUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $permissionsIds: InputMultipleRef, $audience: String!, $isForAllTenants: Boolean!, $idempotencyKey_: String) {
  roleUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    permissionsIds: $permissionsIds
    audience: $audience
    isForAllTenants: $isForAllTenants
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const RoleDeleteDocument = gql`
    mutation roleDelete($id: String!) {
  roleDelete(id: $id) {
    id
  }
}
    `;
export const RoleOneDocument = gql`
    query roleOne($id: String!) {
  roleOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    permissions {
      id
      version_
      name_es
      name_en
      name_pt
    }
    audience
    isForAllTenants
  }
}
    `;
export const RoleListWithOffsetDocument = gql`
    query roleListWithOffset($where: Role_Filter, $orderBy: [Role_OrderBy!], $offset: Int!, $take: Int!) {
  roleListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    permissions {
      id
      version_
      name_es
      name_en
      name_pt
    }
    audience
    isForAllTenants
  }
}
    `;
export const RoleListWithCursorDocument = gql`
    query roleListWithCursor($where: Role_Filter, $orderBy: Role_OrderByCursor!, $cursorKey: String, $take: Int!) {
  roleListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    permissions {
      id
      version_
      name_es
      name_en
      name_pt
    }
    audience
    isForAllTenants
  }
}
    `;
export const SatelliteHeartbeatDeleteDocument = gql`
    mutation satelliteHeartbeatDelete($id: String!) {
  satelliteHeartbeatDelete(id: $id) {
    id
  }
}
    `;
export const SatelliteHeartbeatOneDocument = gql`
    query satelliteHeartbeatOne($id: String!) {
  satelliteHeartbeatOne(id: $id) {
    id
    version_
    receivedAt
    publicIp
    latency
    cpuUsage
    memoryUsage
    diskUsage
    activeTasksCount
    proxyStats
    systemInfo
    satelliteMachine {
      id
      version_
      name
      machineCode
      satelliteType
      region
      certificateFingerprintHasValue
      certificateExpiresAt
      authTokenHashHasValue
      authTokenLastFour
      authTokenCreatedAt
      authTokenRotatedAt
      status
      authorizedAt
      authorizedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      suspendedAt
      suspendedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      suspensionReason
      enabled
      allowedTenantIds
      proxyEnabled
      proxyPort
      proxyProtocols
      botEnabled
      botMaxConcurrent
      workerEnabled
      publicIp
      location
      countryCode
      lastHeartbeatAt
      lastHeartbeatMetrics
      connectedAt
      disconnectedAt
      tunnelConnectedAt
      tasks {
        id
        version_
        taskType
        status
        priority
        input
        output
        error
        correlationId
        timeoutMs
        retryCount
        maxRetries
        queuedAt
        sentAt
        startedAt
        completedAt
        duration
        botRun {
          id
          version_
          botType
          runNumber
          status
          currentPhase
          startedAt
          completedAt
          duration
          params
          result
          error
          correlationId
          totalPhases
          completedPhases
          requiresHumanIntervention
          interventionReason
          logsPath
          relatedEntityType
          relatedEntityId
          relatedEntityLabel
          cancellationRequestedAt
          cancellationReason
        }
      }
    }
  }
}
    `;
export const SatelliteHeartbeatListWithOffsetDocument = gql`
    query satelliteHeartbeatListWithOffset($where: SatelliteHeartbeat_Filter, $orderBy: [SatelliteHeartbeat_OrderBy!], $offset: Int!, $take: Int!) {
  satelliteHeartbeatListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    receivedAt
    publicIp
    latency
    cpuUsage
    memoryUsage
    diskUsage
    activeTasksCount
    proxyStats
    systemInfo
    satelliteMachine {
      id
      version_
      name
      machineCode
      satelliteType
      region
      certificateFingerprintHasValue
      certificateExpiresAt
      authTokenHashHasValue
      authTokenLastFour
      authTokenCreatedAt
      authTokenRotatedAt
      status
      authorizedAt
      authorizedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      suspendedAt
      suspendedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      suspensionReason
      enabled
      allowedTenantIds
      proxyEnabled
      proxyPort
      proxyProtocols
      botEnabled
      botMaxConcurrent
      workerEnabled
      publicIp
      location
      countryCode
      lastHeartbeatAt
      lastHeartbeatMetrics
      connectedAt
      disconnectedAt
      tunnelConnectedAt
      tasks {
        id
        version_
        taskType
        status
        priority
        input
        output
        error
        correlationId
        timeoutMs
        retryCount
        maxRetries
        queuedAt
        sentAt
        startedAt
        completedAt
        duration
        botRun {
          id
          version_
          botType
          runNumber
          status
          currentPhase
          startedAt
          completedAt
          duration
          params
          result
          error
          correlationId
          totalPhases
          completedPhases
          requiresHumanIntervention
          interventionReason
          logsPath
          relatedEntityType
          relatedEntityId
          relatedEntityLabel
          cancellationRequestedAt
          cancellationReason
        }
      }
    }
  }
}
    `;
export const SatelliteHeartbeatListWithCursorDocument = gql`
    query satelliteHeartbeatListWithCursor($where: SatelliteHeartbeat_Filter, $orderBy: SatelliteHeartbeat_OrderByCursor!, $cursorKey: String, $take: Int!) {
  satelliteHeartbeatListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    receivedAt
    publicIp
    latency
    cpuUsage
    memoryUsage
    diskUsage
    activeTasksCount
    proxyStats
    systemInfo
    satelliteMachine {
      id
      version_
      name
      machineCode
      satelliteType
      region
      certificateFingerprintHasValue
      certificateExpiresAt
      authTokenHashHasValue
      authTokenLastFour
      authTokenCreatedAt
      authTokenRotatedAt
      status
      authorizedAt
      authorizedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      suspendedAt
      suspendedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      suspensionReason
      enabled
      allowedTenantIds
      proxyEnabled
      proxyPort
      proxyProtocols
      botEnabled
      botMaxConcurrent
      workerEnabled
      publicIp
      location
      countryCode
      lastHeartbeatAt
      lastHeartbeatMetrics
      connectedAt
      disconnectedAt
      tunnelConnectedAt
      tasks {
        id
        version_
        taskType
        status
        priority
        input
        output
        error
        correlationId
        timeoutMs
        retryCount
        maxRetries
        queuedAt
        sentAt
        startedAt
        completedAt
        duration
        botRun {
          id
          version_
          botType
          runNumber
          status
          currentPhase
          startedAt
          completedAt
          duration
          params
          result
          error
          correlationId
          totalPhases
          completedPhases
          requiresHumanIntervention
          interventionReason
          logsPath
          relatedEntityType
          relatedEntityId
          relatedEntityLabel
          cancellationRequestedAt
          cancellationReason
        }
      }
    }
  }
}
    `;
export const SatelliteMachineCreateDocument = gql`
    mutation satelliteMachineCreate($name: String!, $machineCode: String!, $satelliteType: String!, $region: String, $certificateFingerprint: String!, $certificateExpiresAt: DateTime!, $authTokenHash: String!, $authTokenLastFour: String!, $authTokenCreatedAt: DateTime!, $authTokenRotatedAt: DateTime, $status: String!, $authorizedAt: DateTime, $authorizedById: String, $suspendedAt: DateTime, $suspendedById: String, $suspensionReason: String, $enabled: Boolean!, $allowedTenantIds: String, $proxyEnabled: Boolean!, $proxyPort: Int, $proxyProtocols: String, $botEnabled: Boolean!, $botMaxConcurrent: Int, $workerEnabled: Boolean!, $publicIp: String, $location: String, $countryCode: String, $lastHeartbeatAt: DateTime, $lastHeartbeatMetrics: Json, $connectedAt: DateTime, $disconnectedAt: DateTime, $tunnelConnectedAt: DateTime, $idempotencyKey_: String) {
  satelliteMachineCreate(
    name: $name
    machineCode: $machineCode
    satelliteType: $satelliteType
    region: $region
    certificateFingerprint: $certificateFingerprint
    certificateExpiresAt: $certificateExpiresAt
    authTokenHash: $authTokenHash
    authTokenLastFour: $authTokenLastFour
    authTokenCreatedAt: $authTokenCreatedAt
    authTokenRotatedAt: $authTokenRotatedAt
    status: $status
    authorizedAt: $authorizedAt
    authorizedById: $authorizedById
    suspendedAt: $suspendedAt
    suspendedById: $suspendedById
    suspensionReason: $suspensionReason
    enabled: $enabled
    allowedTenantIds: $allowedTenantIds
    proxyEnabled: $proxyEnabled
    proxyPort: $proxyPort
    proxyProtocols: $proxyProtocols
    botEnabled: $botEnabled
    botMaxConcurrent: $botMaxConcurrent
    workerEnabled: $workerEnabled
    publicIp: $publicIp
    location: $location
    countryCode: $countryCode
    lastHeartbeatAt: $lastHeartbeatAt
    lastHeartbeatMetrics: $lastHeartbeatMetrics
    connectedAt: $connectedAt
    disconnectedAt: $disconnectedAt
    tunnelConnectedAt: $tunnelConnectedAt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const SatelliteMachineUpdateDocument = gql`
    mutation satelliteMachineUpdate($id: String!, $version_: String!, $name: String!, $machineCode: String!, $satelliteType: String!, $region: String, $certificateFingerprint: String, $certificateExpiresAt: DateTime!, $authTokenHash: String, $authTokenLastFour: String!, $authTokenCreatedAt: DateTime!, $authTokenRotatedAt: DateTime, $status: String!, $authorizedAt: DateTime, $authorizedById: String, $suspendedAt: DateTime, $suspendedById: String, $suspensionReason: String, $enabled: Boolean!, $allowedTenantIds: String, $proxyEnabled: Boolean!, $proxyPort: Int, $proxyProtocols: String, $botEnabled: Boolean!, $botMaxConcurrent: Int, $workerEnabled: Boolean!, $publicIp: String, $location: String, $countryCode: String, $lastHeartbeatAt: DateTime, $lastHeartbeatMetrics: Json, $connectedAt: DateTime, $disconnectedAt: DateTime, $tunnelConnectedAt: DateTime, $idempotencyKey_: String) {
  satelliteMachineUpdate(
    id: $id
    version_: $version_
    name: $name
    machineCode: $machineCode
    satelliteType: $satelliteType
    region: $region
    certificateFingerprint: $certificateFingerprint
    certificateExpiresAt: $certificateExpiresAt
    authTokenHash: $authTokenHash
    authTokenLastFour: $authTokenLastFour
    authTokenCreatedAt: $authTokenCreatedAt
    authTokenRotatedAt: $authTokenRotatedAt
    status: $status
    authorizedAt: $authorizedAt
    authorizedById: $authorizedById
    suspendedAt: $suspendedAt
    suspendedById: $suspendedById
    suspensionReason: $suspensionReason
    enabled: $enabled
    allowedTenantIds: $allowedTenantIds
    proxyEnabled: $proxyEnabled
    proxyPort: $proxyPort
    proxyProtocols: $proxyProtocols
    botEnabled: $botEnabled
    botMaxConcurrent: $botMaxConcurrent
    workerEnabled: $workerEnabled
    publicIp: $publicIp
    location: $location
    countryCode: $countryCode
    lastHeartbeatAt: $lastHeartbeatAt
    lastHeartbeatMetrics: $lastHeartbeatMetrics
    connectedAt: $connectedAt
    disconnectedAt: $disconnectedAt
    tunnelConnectedAt: $tunnelConnectedAt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const SatelliteMachineDeleteDocument = gql`
    mutation satelliteMachineDelete($id: String!) {
  satelliteMachineDelete(id: $id) {
    id
  }
}
    `;
export const SatelliteMachineOneDocument = gql`
    query satelliteMachineOne($id: String!) {
  satelliteMachineOne(id: $id) {
    id
    version_
    name
    machineCode
    satelliteType
    region
    certificateFingerprintHasValue
    certificateExpiresAt
    authTokenHashHasValue
    authTokenLastFour
    authTokenCreatedAt
    authTokenRotatedAt
    status
    authorizedAt
    authorizedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    suspendedAt
    suspendedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    suspensionReason
    enabled
    allowedTenantIds
    proxyEnabled
    proxyPort
    proxyProtocols
    botEnabled
    botMaxConcurrent
    workerEnabled
    publicIp
    location
    countryCode
    lastHeartbeatAt
    lastHeartbeatMetrics
    connectedAt
    disconnectedAt
    tunnelConnectedAt
    tasks {
      id
      version_
      taskType
      status
      priority
      input
      output
      error
      correlationId
      timeoutMs
      retryCount
      maxRetries
      queuedAt
      sentAt
      startedAt
      completedAt
      duration
      botRun {
        id
        version_
        botType
        runNumber
        status
        currentPhase
        startedAt
        completedAt
        duration
        params
        result
        error
        correlationId
        totalPhases
        completedPhases
        requiresHumanIntervention
        interventionReason
        logsPath
        relatedEntityType
        relatedEntityId
        relatedEntityLabel
        cancellationRequestedAt
        cancellationReason
      }
    }
  }
}
    `;
export const SatelliteMachineListWithOffsetDocument = gql`
    query satelliteMachineListWithOffset($where: SatelliteMachine_Filter, $orderBy: [SatelliteMachine_OrderBy!], $offset: Int!, $take: Int!) {
  satelliteMachineListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    machineCode
    satelliteType
    region
    certificateExpiresAt
    authTokenLastFour
    authTokenCreatedAt
    authTokenRotatedAt
    status
    authorizedAt
    authorizedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    suspendedAt
    suspendedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    suspensionReason
    enabled
    allowedTenantIds
    proxyEnabled
    proxyPort
    proxyProtocols
    botEnabled
    botMaxConcurrent
    workerEnabled
    publicIp
    location
    countryCode
    lastHeartbeatAt
    lastHeartbeatMetrics
    connectedAt
    disconnectedAt
    tunnelConnectedAt
    tasks {
      id
      version_
      taskType
      status
      priority
      input
      output
      error
      correlationId
      timeoutMs
      retryCount
      maxRetries
      queuedAt
      sentAt
      startedAt
      completedAt
      duration
      botRun {
        id
        version_
        botType
        runNumber
        status
        currentPhase
        startedAt
        completedAt
        duration
        params
        result
        error
        correlationId
        totalPhases
        completedPhases
        requiresHumanIntervention
        interventionReason
        logsPath
        relatedEntityType
        relatedEntityId
        relatedEntityLabel
        cancellationRequestedAt
        cancellationReason
      }
    }
  }
}
    `;
export const SatelliteMachineListWithCursorDocument = gql`
    query satelliteMachineListWithCursor($where: SatelliteMachine_Filter, $orderBy: SatelliteMachine_OrderByCursor!, $cursorKey: String, $take: Int!) {
  satelliteMachineListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    machineCode
    satelliteType
    region
    certificateExpiresAt
    authTokenLastFour
    authTokenCreatedAt
    authTokenRotatedAt
    status
    authorizedAt
    authorizedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    suspendedAt
    suspendedBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    suspensionReason
    enabled
    allowedTenantIds
    proxyEnabled
    proxyPort
    proxyProtocols
    botEnabled
    botMaxConcurrent
    workerEnabled
    publicIp
    location
    countryCode
    lastHeartbeatAt
    lastHeartbeatMetrics
    connectedAt
    disconnectedAt
    tunnelConnectedAt
    tasks {
      id
      version_
      taskType
      status
      priority
      input
      output
      error
      correlationId
      timeoutMs
      retryCount
      maxRetries
      queuedAt
      sentAt
      startedAt
      completedAt
      duration
      botRun {
        id
        version_
        botType
        runNumber
        status
        currentPhase
        startedAt
        completedAt
        duration
        params
        result
        error
        correlationId
        totalPhases
        completedPhases
        requiresHumanIntervention
        interventionReason
        logsPath
        relatedEntityType
        relatedEntityId
        relatedEntityLabel
        cancellationRequestedAt
        cancellationReason
      }
    }
  }
}
    `;
export const AuthorizeSatelliteDocument = gql`
    mutation authorizeSatellite($id: ID!) {
  authorizeSatellite(id: $id) {
    success
    error
    satellite {
      id
      status
      authorizedAt
    }
  }
}
    `;
export const SuspendSatelliteDocument = gql`
    mutation suspendSatellite($id: ID!, $reason: String!) {
  suspendSatellite(id: $id, reason: $reason) {
    success
    error
    satellite {
      id
      status
      suspendedAt
      suspensionReason
    }
  }
}
    `;
export const ReactivateSatelliteDocument = gql`
    mutation reactivateSatellite($id: ID!) {
  reactivateSatellite(id: $id) {
    success
    error
    satellite {
      id
      status
    }
  }
}
    `;
export const RevokeSatelliteDocument = gql`
    mutation revokeSatellite($id: ID!, $reason: String!) {
  revokeSatellite(id: $id, reason: $reason) {
    success
    error
    satellite {
      id
      status
    }
  }
}
    `;
export const SetSatelliteEnabledDocument = gql`
    mutation setSatelliteEnabled($id: ID!, $enabled: Boolean!) {
  setSatelliteEnabled(id: $id, enabled: $enabled) {
    success
    error
    satellite {
      id
      enabled
    }
  }
}
    `;
export const RotateSatelliteTokenDocument = gql`
    mutation rotateSatelliteToken($id: ID!) {
  rotateSatelliteToken(id: $id) {
    success
    error
    plainToken
    satellite {
      id
      authTokenLastFour
      authTokenRotatedAt
    }
  }
}
    `;
export const DisconnectSatelliteDocument = gql`
    mutation disconnectSatellite($id: ID!) {
  disconnectSatellite(id: $id) {
    success
    error
  }
}
    `;
export const SatelliteConnectionInfoDocument = gql`
    query satelliteConnectionInfo($id: ID!) {
  satelliteConnectionInfo(id: $id) {
    connected
    connectedAt
    lastHeartbeat
    publicIp
    activeTasks
  }
}
    `;
export const ConnectedSatellitesDocument = gql`
    query connectedSatellites {
  connectedSatellites {
    id
    name
    machineCode
    status
    region
    satelliteType
    enabled
    lastHeartbeatAt
  }
}
    `;
export const SatelliteTaskOneDocument = gql`
    query satelliteTaskOne($id: String!) {
  satelliteTaskOne(id: $id) {
    id
    version_
    taskType
    status
    priority
    input
    output
    error
    correlationId
    timeoutMs
    retryCount
    maxRetries
    queuedAt
    sentAt
    startedAt
    completedAt
    duration
    botRun {
      id
      version_
      botType
      runNumber
      status
      currentPhase
      startedAt
      completedAt
      duration
      params
      result
      error
      correlationId
      totalPhases
      completedPhases
      requiresHumanIntervention
      interventionReason
      logsPath
      workerEvent {
        id
        version_
        queueName
        jobType
        status
        enqueuedAt
        startedAt
        completedAt
        payload
        result
        error
        retryCount
        manualRetryCount
        nextRetryAt
        duration
        correlationId
        triggerUserId {
          id
          version_
          name
          email
          role {
            id
            version_
            name_es
            name_en
            name_pt
          }
          language
          avatar
          avatar_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          targetTenant {
            id
            version_
            name
          }
          tenantDisplayName
          active
          cellphone
          twoFaseAuth
          profile
          idCardType
          idCard
          gender
        }
      }
      triggeredBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      relatedEntityType
      relatedEntityId
      relatedEntityLabel
      cancellationRequestedAt
      cancellationRequestedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      cancellationReason
      phases {
        id
        version_
        phaseNumber
        phaseId
        phaseName
        status
        stepsTotal
        stepsCompleted
        startedAt
        completedAt
        duration
        error
        stepsLogPath
        screenshot
        screenshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        steps {
          id
          version_
          stepNumber
          stepId
          status
          startedAt
          completedAt
          duration
          error
          downloadedFile
          downloadedFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
        }
      }
      errors {
        id
        version_
        errorType
        severity
        message
        stackTrace
        context
        recoverable
        requiresHumanIntervention
        screenshot
        screenshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        domSnapshot
        domSnapshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
    }
  }
}
    `;
export const SatelliteTaskListWithOffsetDocument = gql`
    query satelliteTaskListWithOffset($where: SatelliteTask_Filter, $orderBy: [SatelliteTask_OrderBy!], $offset: Int!, $take: Int!) {
  satelliteTaskListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    taskType
    status
    priority
    input
    output
    error
    correlationId
    timeoutMs
    retryCount
    maxRetries
    queuedAt
    sentAt
    startedAt
    completedAt
    duration
    botRun {
      id
      version_
      botType
      runNumber
      status
      currentPhase
      startedAt
      completedAt
      duration
      params
      result
      error
      correlationId
      totalPhases
      completedPhases
      requiresHumanIntervention
      interventionReason
      logsPath
      workerEvent {
        id
        version_
        queueName
        jobType
        status
        enqueuedAt
        startedAt
        completedAt
        payload
        result
        error
        retryCount
        manualRetryCount
        nextRetryAt
        duration
        correlationId
        triggerUserId {
          id
          version_
          name
          email
          role {
            id
            version_
            name_es
            name_en
            name_pt
          }
          language
          avatar
          avatar_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          targetTenant {
            id
            version_
            name
          }
          tenantDisplayName
          active
          cellphone
          twoFaseAuth
          profile
          idCardType
          idCard
          gender
        }
      }
      triggeredBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      relatedEntityType
      relatedEntityId
      relatedEntityLabel
      cancellationRequestedAt
      cancellationRequestedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      cancellationReason
      phases {
        id
        version_
        phaseNumber
        phaseId
        phaseName
        status
        stepsTotal
        stepsCompleted
        startedAt
        completedAt
        duration
        error
        stepsLogPath
        screenshot
        screenshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        steps {
          id
          version_
          stepNumber
          stepId
          status
          startedAt
          completedAt
          duration
          error
          downloadedFile
          downloadedFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
        }
      }
      errors {
        id
        version_
        errorType
        severity
        message
        stackTrace
        context
        recoverable
        requiresHumanIntervention
        screenshot
        screenshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        domSnapshot
        domSnapshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
    }
  }
}
    `;
export const SatelliteTaskListWithCursorDocument = gql`
    query satelliteTaskListWithCursor($where: SatelliteTask_Filter, $orderBy: SatelliteTask_OrderByCursor!, $cursorKey: String, $take: Int!) {
  satelliteTaskListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    taskType
    status
    priority
    input
    output
    error
    correlationId
    timeoutMs
    retryCount
    maxRetries
    queuedAt
    sentAt
    startedAt
    completedAt
    duration
    botRun {
      id
      version_
      botType
      runNumber
      status
      currentPhase
      startedAt
      completedAt
      duration
      params
      result
      error
      correlationId
      totalPhases
      completedPhases
      requiresHumanIntervention
      interventionReason
      logsPath
      workerEvent {
        id
        version_
        queueName
        jobType
        status
        enqueuedAt
        startedAt
        completedAt
        payload
        result
        error
        retryCount
        manualRetryCount
        nextRetryAt
        duration
        correlationId
        triggerUserId {
          id
          version_
          name
          email
          role {
            id
            version_
            name_es
            name_en
            name_pt
          }
          language
          avatar
          avatar_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          targetTenant {
            id
            version_
            name
          }
          tenantDisplayName
          active
          cellphone
          twoFaseAuth
          profile
          idCardType
          idCard
          gender
        }
      }
      triggeredBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      relatedEntityType
      relatedEntityId
      relatedEntityLabel
      cancellationRequestedAt
      cancellationRequestedBy {
        id
        version_
        name
        email
        role {
          id
          version_
          name_es
          name_en
          name_pt
          permissions {
            id
            version_
            name_es
            name_en
            name_pt
          }
          audience
          isForAllTenants
        }
        language
        avatar
        avatar_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        targetTenant {
          id
          version_
          name
          tenantType {
            id
            version_
            name_es
            name_en
            name_pt
          }
          status {
            id
            version_
            name
          }
          plan {
            id
            version_
            name_es
            name_en
            name_pt
          }
          logo
          logo_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          publicUrl
          idERP
          idCRM
          monthlyTokenLimit
          currentMonthTokens
          tokenLimitResetDay
          lastTokenResetDate
          ragLlmProvider {
            id
            version_
            name
          }
          ragLlmModel
          currentStorageBytes
          storageByteLimit
          eSignatureProvider
        }
        tenantDisplayName
        active
        cellphone
        twoFaseAuth
        profile
        idCardType
        idCard
        gender
      }
      cancellationReason
      phases {
        id
        version_
        phaseNumber
        phaseId
        phaseName
        status
        stepsTotal
        stepsCompleted
        startedAt
        completedAt
        duration
        error
        stepsLogPath
        screenshot
        screenshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        steps {
          id
          version_
          stepNumber
          stepId
          status
          startedAt
          completedAt
          duration
          error
          downloadedFile
          downloadedFile_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
        }
      }
      errors {
        id
        version_
        errorType
        severity
        message
        stackTrace
        context
        recoverable
        requiresHumanIntervention
        screenshot
        screenshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        domSnapshot
        domSnapshot_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
      }
    }
  }
}
    `;
export const ShowcaseCategoryCreateDocument = gql`
    mutation showcaseCategoryCreate($code: String!, $name: String!, $idempotencyKey_: String) {
  showcaseCategoryCreate(
    code: $code
    name: $name
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const ShowcaseCategoryUpdateDocument = gql`
    mutation showcaseCategoryUpdate($id: String!, $version_: String!, $code: String!, $name: String!, $idempotencyKey_: String) {
  showcaseCategoryUpdate(
    id: $id
    version_: $version_
    code: $code
    name: $name
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const ShowcaseCategoryDeleteDocument = gql`
    mutation showcaseCategoryDelete($id: String!) {
  showcaseCategoryDelete(id: $id) {
    id
  }
}
    `;
export const ShowcaseCategoryOneDocument = gql`
    query showcaseCategoryOne($id: String!) {
  showcaseCategoryOne(id: $id) {
    id
    version_
    code
    name
  }
}
    `;
export const ShowcaseCategoryListWithOffsetDocument = gql`
    query showcaseCategoryListWithOffset($where: ShowcaseCategory_Filter, $orderBy: [ShowcaseCategory_OrderBy!], $offset: Int!, $take: Int!) {
  showcaseCategoryListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    code
    name
  }
}
    `;
export const ShowcaseCategoryListWithCursorDocument = gql`
    query showcaseCategoryListWithCursor($where: ShowcaseCategory_Filter, $orderBy: ShowcaseCategory_OrderByCursor!, $cursorKey: String, $take: Int!) {
  showcaseCategoryListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    code
    name
  }
}
    `;
export const ShowcaseLineOneDocument = gql`
    query showcaseLineOne($id: String!) {
  showcaseLineOne(id: $id) {
    id
    version_
    concept
    quantity
    unitPrice
    note
  }
}
    `;
export const ShowcaseLineListWithOffsetDocument = gql`
    query showcaseLineListWithOffset($where: ShowcaseLine_Filter, $orderBy: [ShowcaseLine_OrderBy!], $offset: Int!, $take: Int!) {
  showcaseLineListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    concept
    quantity
    unitPrice
    note
  }
}
    `;
export const ShowcaseLineListWithCursorDocument = gql`
    query showcaseLineListWithCursor($where: ShowcaseLine_Filter, $orderBy: ShowcaseLine_OrderByCursor!, $cursorKey: String, $take: Int!) {
  showcaseLineListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    concept
    quantity
    unitPrice
    note
  }
}
    `;
export const ShowcaseWorkflowStateCreateDocument = gql`
    mutation showcaseWorkflowStateCreate($name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  showcaseWorkflowStateCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const ShowcaseWorkflowStateUpdateDocument = gql`
    mutation showcaseWorkflowStateUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  showcaseWorkflowStateUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const ShowcaseWorkflowStateDeleteDocument = gql`
    mutation showcaseWorkflowStateDelete($id: String!) {
  showcaseWorkflowStateDelete(id: $id) {
    id
  }
}
    `;
export const ShowcaseWorkflowStateOneDocument = gql`
    query showcaseWorkflowStateOne($id: String!) {
  showcaseWorkflowStateOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const ShowcaseWorkflowStateListWithOffsetDocument = gql`
    query showcaseWorkflowStateListWithOffset($where: ShowcaseWorkflowState_Filter, $orderBy: [ShowcaseWorkflowState_OrderBy!], $offset: Int!, $take: Int!) {
  showcaseWorkflowStateListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const ShowcaseWorkflowStateListWithCursorDocument = gql`
    query showcaseWorkflowStateListWithCursor($where: ShowcaseWorkflowState_Filter, $orderBy: ShowcaseWorkflowState_OrderByCursor!, $cursorKey: String, $take: Int!) {
  showcaseWorkflowStateListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const SignedContractOneDocument = gql`
    query signedContractOne($id: String!) {
  signedContractOne(id: $id) {
    id
    version_
    data_ {
      contractNumber
      contractDuration
      contractRenewal
      publisherConfigurationDisplay
      authorsDisplay
      territoriesDisplay
      finalDocumentPdf {
        filename
        mimetype
        size
        baseName
        uuid
      }
      publishers {
        percentage
        publisher {
          name
          pseudonym
          taxId
          personType
          caeIpi
          representatives {
            name
            role
            email
            isSigner
          }
        }
      }
      authors {
        firstName
        lastName
        taxId
        taxIdType
        ipi
      }
      works {
        title
      }
      territories {
        name_es
        name_en
        name_pt
      }
    }
    originalId_
  }
}
    `;
export const SignedContractListWithOffsetDocument = gql`
    query signedContractListWithOffset($where: SignedContract_Filter, $orderBy: [SignedContract_OrderBy!], $offset: Int!, $take: Int!) {
  signedContractListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    data_ {
      contractNumber
      contractDuration
      contractRenewal
      publisherConfigurationDisplay
      authorsDisplay
      territoriesDisplay
      finalDocumentPdf {
        filename
        mimetype
        size
        baseName
        uuid
      }
      publishers {
        percentage
        publisher {
          name
          pseudonym
          taxId
          personType
          caeIpi
          representatives {
            name
            role
            email
            isSigner
          }
        }
      }
      authors {
        firstName
        lastName
        taxId
        taxIdType
        ipi
      }
      works {
        title
      }
      territories {
        name_es
        name_en
        name_pt
      }
    }
  }
}
    `;
export const SignedContractListWithCursorDocument = gql`
    query signedContractListWithCursor($where: SignedContract_Filter, $orderBy: SignedContract_OrderByCursor!, $cursorKey: String, $take: Int!) {
  signedContractListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    data_ {
      contractNumber
      contractDuration
      contractRenewal
      publisherConfigurationDisplay
      authorsDisplay
      territoriesDisplay
      finalDocumentPdf {
        filename
        mimetype
        size
        baseName
        uuid
      }
      publishers {
        percentage
        publisher {
          name
          pseudonym
          taxId
          personType
          caeIpi
          representatives {
            name
            role
            email
            isSigner
          }
        }
      }
      authors {
        firstName
        lastName
        taxId
        taxIdType
        ipi
      }
      works {
        title
      }
      territories {
        name_es
        name_en
        name_pt
      }
    }
  }
}
    `;
export const SignedEditionOneDocument = gql`
    query signedEditionOne($id: String!) {
  signedEditionOne(id: $id) {
    id
    version_
    dndaState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    sadaicState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    publicationDate
    dndaExpedienteNumber
    dndaDocuments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
    ejemplarPdf
    ejemplarPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    dndaComprobantePdf
    dndaComprobantePdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    blockchainCertificates {
      id
      version_
      name
      contractNumber
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      confirmedAt
    }
    dndaUploadLink
    dndaUploadPasswordHasValue
    dndaUploadKeyReceivedAt
    dndaUploadKeyExpiresAt
    dndaComprobanteReceivedAt
    dndaLastComprobantePollAt
    dndaLastOperationalError
    sadaicDeliveredAt
    sadaicLastOperationalError
    createdAt_
    lastUpdatedAt_
    data_ {
      name
      editionNumber
      price
      contentType
      publicationLink
      editionType {
        name_es
        name_en
        name_pt
      }
      works {
        title
        cmsId
        iswc
        originalLyrics
        notes
        score {
          filename
          mimetype
          size
          baseName
          uuid
        }
        phonograms {
          trackName
          isrc
          albumName
          publicationYear
          audioFile {
            filename
            mimetype
            size
            baseName
            uuid
          }
          mainAudio
          links {
            url
            platform {
              name
            }
            type {
              name
            }
          }
        }
        musicalGenre {
          name
        }
        performers {
          name
        }
        territories {
          name_es
          name_en
          name_pt
        }
        authors {
          lyricsPercentage
          musicPercentage
          author {
            firstName
            lastName
            taxId
            taxIdType
            email
            phone
            dateOfBirth
            aka
            ipi
            streetAndNumber
            floor
            suite
            city
            postalCode
            nationality {
              name_es
              name_en
              name_pt
            }
            country {
              name_es
              name_en
              name_pt
            }
            province {
              name_es
              name_en
              name_pt
            }
            managementSocieties {
              memberNumber
              collectingSociety {
                name
                acronym
              }
            }
          }
          publishers {
            percentage
            durationInYears
            autoRenewalYears
            publisher {
              name
              pseudonym
              taxId
              caeIpi
              phone
              email
              personType
              maritalStatus
              streetAndNumber
              floor
              suite
              city
              postalCode
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              nationality {
                name_es
                name_en
                name_pt
              }
              representatives {
                name
                role
                email
                phone
                isSigner
              }
              managementSocieties {
                cmsAccountNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
          }
        }
      }
      documentation {
        finalDocumentPdf {
          filename
          mimetype
          size
          baseName
          uuid
        }
        publisherConfigurationDisplay
        territoriesDisplay
        authorsDisplay
        contractDuration
        contractRenewal
        contractNumber
        publishers {
          percentage
          publisher {
            name
            pseudonym
            taxId
          }
        }
        territories {
          name_es
          name_en
          name_pt
        }
        authors {
          firstName
          lastName
          taxId
        }
      }
      associatedDocuments {
        name
        file {
          filename
          mimetype
          size
          baseName
          uuid
        }
        publisherConfigurationDisplay
        authorsDisplay
        notes
        type {
          name
        }
      }
      userAttachments {
        name
        file {
          filename
          mimetype
          size
          baseName
          uuid
        }
        notes
      }
    }
    originalId_
    dndaState_transitions_
    sadaicState_transitions_
  }
}
    `;
export const SignedEditionListWithOffsetDocument = gql`
    query signedEditionListWithOffset($where: SignedEdition_Filter, $orderBy: [SignedEdition_OrderBy!], $offset: Int!, $take: Int!) {
  signedEditionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    dndaState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    sadaicState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    works {
      id
      version_
      title
      musicalGenre {
        id
        version_
        name
      }
      alternativeTitles
      authors {
        id
        version_
        author {
          id
          version_
          firstName
          lastName
          gender
          taxIdType
          taxId
          cuitCertificate
          cuitCertificate_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          cuitCertificateIssuedAt
          cuitCertificateError
          cuitCertificateErrorType
          dniDeliveredToSadaicAt
          dniValidatedAt
          dniValidatedFields
          email
          phone
          dateOfBirth
          streetAndNumber
          floor
          suite
          postalCode
          city
          aka
          ipi
          createdAt_
          lastUpdatedAt_
        }
        lyricsPercentage
        musicPercentage
        publishers {
          id
          version_
          publisher {
            id
            version_
            pseudonym
            name
          }
          percentage
          durationInYears
          autoRenewalYears
        }
      }
      notes
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      cmsId
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      iswc
      workNumber
      score
      score_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      phonograms {
        id
        version_
        trackName
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        albumName
        publicationYear
        isrc
        originalProducer
        audioFile
        audioFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        mainAudio
        links {
          id
          version_
          url
          platform {
            id
            version_
            name
          }
          type {
            id
            version_
            name
          }
        }
        notes
      }
      originalLyrics
      contractObservation
      createdAt_
      lastUpdatedAt_
    }
    publicationDate
    dndaExpedienteNumber
    dndaDocuments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
    ejemplarPdf
    ejemplarPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    dndaComprobantePdf
    dndaComprobantePdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    blockchainCertificates {
      id
      version_
      name
      contractNumber
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      confirmedAt
    }
    dndaUploadLink
    dndaUploadKeyReceivedAt
    dndaUploadKeyExpiresAt
    dndaComprobanteReceivedAt
    dndaLastComprobantePollAt
    dndaLastOperationalError
    sadaicDeliveredAt
    sadaicLastOperationalError
    createdAt_
    lastUpdatedAt_
    data_ {
      name
      editionNumber
      price
      contentType
      publicationLink
      editionType {
        name_es
        name_en
        name_pt
      }
      works {
        title
        cmsId
        iswc
        originalLyrics
        notes
        score {
          filename
          mimetype
          size
          baseName
          uuid
        }
        phonograms {
          trackName
          isrc
          albumName
          publicationYear
          audioFile {
            filename
            mimetype
            size
            baseName
            uuid
          }
          mainAudio
          links {
            url
            platform {
              name
            }
            type {
              name
            }
          }
        }
        musicalGenre {
          name
        }
        performers {
          name
        }
        territories {
          name_es
          name_en
          name_pt
        }
        authors {
          lyricsPercentage
          musicPercentage
          author {
            firstName
            lastName
            taxId
            taxIdType
            email
            phone
            dateOfBirth
            aka
            ipi
            streetAndNumber
            floor
            suite
            city
            postalCode
            nationality {
              name_es
              name_en
              name_pt
            }
            country {
              name_es
              name_en
              name_pt
            }
            province {
              name_es
              name_en
              name_pt
            }
            managementSocieties {
              memberNumber
              collectingSociety {
                name
                acronym
              }
            }
          }
          publishers {
            percentage
            durationInYears
            autoRenewalYears
            publisher {
              name
              pseudonym
              taxId
              caeIpi
              phone
              email
              personType
              maritalStatus
              streetAndNumber
              floor
              suite
              city
              postalCode
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              nationality {
                name_es
                name_en
                name_pt
              }
              representatives {
                name
                role
                email
                phone
                isSigner
              }
              managementSocieties {
                cmsAccountNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
          }
        }
      }
      documentation {
        finalDocumentPdf {
          filename
          mimetype
          size
          baseName
          uuid
        }
        publisherConfigurationDisplay
        territoriesDisplay
        authorsDisplay
        contractDuration
        contractRenewal
        contractNumber
        publishers {
          percentage
          publisher {
            name
            pseudonym
            taxId
          }
        }
        territories {
          name_es
          name_en
          name_pt
        }
        authors {
          firstName
          lastName
          taxId
        }
      }
      associatedDocuments {
        name
        file {
          filename
          mimetype
          size
          baseName
          uuid
        }
        publisherConfigurationDisplay
        authorsDisplay
        notes
        type {
          name
        }
      }
      userAttachments {
        name
        file {
          filename
          mimetype
          size
          baseName
          uuid
        }
        notes
      }
    }
    name
    editionNumber
    dndaState_transitions_
    sadaicState_transitions_
  }
}
    `;
export const SignedEditionListWithCursorDocument = gql`
    query signedEditionListWithCursor($where: SignedEdition_Filter, $orderBy: SignedEdition_OrderByCursor!, $cursorKey: String, $take: Int!) {
  signedEditionListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    dndaState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    sadaicState {
      id
      version_
      name_es
      name_en
      name_pt
    }
    works {
      id
      version_
      title
      musicalGenre {
        id
        version_
        name
      }
      alternativeTitles
      authors {
        id
        version_
        author {
          id
          version_
          firstName
          lastName
          gender
          taxIdType
          taxId
          cuitCertificate
          cuitCertificate_data {
            name
            mimetype
            url
            size
            description
            thumbnails {
              url
              size
            }
          }
          cuitCertificateIssuedAt
          cuitCertificateError
          cuitCertificateErrorType
          dniDeliveredToSadaicAt
          dniValidatedAt
          dniValidatedFields
          email
          phone
          dateOfBirth
          streetAndNumber
          floor
          suite
          postalCode
          city
          aka
          ipi
          createdAt_
          lastUpdatedAt_
        }
        lyricsPercentage
        musicPercentage
        publishers {
          id
          version_
          publisher {
            id
            version_
            pseudonym
            name
          }
          percentage
          durationInYears
          autoRenewalYears
        }
      }
      notes
      performers {
        id
        version_
        name
        createdAt_
        lastUpdatedAt_
      }
      cmsId
      territories {
        id
        version_
        name_es
        name_en
        name_pt
      }
      iswc
      workNumber
      score
      score_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      phonograms {
        id
        version_
        trackName
        performers {
          id
          version_
          name
          createdAt_
          lastUpdatedAt_
        }
        albumName
        publicationYear
        isrc
        originalProducer
        audioFile
        audioFile_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        mainAudio
        links {
          id
          version_
          url
          platform {
            id
            version_
            name
          }
          type {
            id
            version_
            name
          }
        }
        notes
      }
      originalLyrics
      contractObservation
      createdAt_
      lastUpdatedAt_
    }
    publicationDate
    dndaExpedienteNumber
    dndaDocuments {
      id
      version_
      name
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
    }
    ejemplarPdf
    ejemplarPdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    dndaComprobantePdf
    dndaComprobantePdf_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    blockchainCertificates {
      id
      version_
      name
      contractNumber
      file
      file_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      confirmedAt
    }
    dndaUploadLink
    dndaUploadKeyReceivedAt
    dndaUploadKeyExpiresAt
    dndaComprobanteReceivedAt
    dndaLastComprobantePollAt
    dndaLastOperationalError
    sadaicDeliveredAt
    sadaicLastOperationalError
    createdAt_
    lastUpdatedAt_
    data_ {
      name
      editionNumber
      price
      contentType
      publicationLink
      editionType {
        name_es
        name_en
        name_pt
      }
      works {
        title
        cmsId
        iswc
        originalLyrics
        notes
        score {
          filename
          mimetype
          size
          baseName
          uuid
        }
        phonograms {
          trackName
          isrc
          albumName
          publicationYear
          audioFile {
            filename
            mimetype
            size
            baseName
            uuid
          }
          mainAudio
          links {
            url
            platform {
              name
            }
            type {
              name
            }
          }
        }
        musicalGenre {
          name
        }
        performers {
          name
        }
        territories {
          name_es
          name_en
          name_pt
        }
        authors {
          lyricsPercentage
          musicPercentage
          author {
            firstName
            lastName
            taxId
            taxIdType
            email
            phone
            dateOfBirth
            aka
            ipi
            streetAndNumber
            floor
            suite
            city
            postalCode
            nationality {
              name_es
              name_en
              name_pt
            }
            country {
              name_es
              name_en
              name_pt
            }
            province {
              name_es
              name_en
              name_pt
            }
            managementSocieties {
              memberNumber
              collectingSociety {
                name
                acronym
              }
            }
          }
          publishers {
            percentage
            durationInYears
            autoRenewalYears
            publisher {
              name
              pseudonym
              taxId
              caeIpi
              phone
              email
              personType
              maritalStatus
              streetAndNumber
              floor
              suite
              city
              postalCode
              country {
                name_es
                name_en
                name_pt
              }
              province {
                name_es
                name_en
                name_pt
              }
              nationality {
                name_es
                name_en
                name_pt
              }
              representatives {
                name
                role
                email
                phone
                isSigner
              }
              managementSocieties {
                cmsAccountNumber
                collectingSociety {
                  name
                  acronym
                }
              }
            }
          }
        }
      }
      documentation {
        finalDocumentPdf {
          filename
          mimetype
          size
          baseName
          uuid
        }
        publisherConfigurationDisplay
        territoriesDisplay
        authorsDisplay
        contractDuration
        contractRenewal
        contractNumber
        publishers {
          percentage
          publisher {
            name
            pseudonym
            taxId
          }
        }
        territories {
          name_es
          name_en
          name_pt
        }
        authors {
          firstName
          lastName
          taxId
        }
      }
      associatedDocuments {
        name
        file {
          filename
          mimetype
          size
          baseName
          uuid
        }
        publisherConfigurationDisplay
        authorsDisplay
        notes
        type {
          name
        }
      }
      userAttachments {
        name
        file {
          filename
          mimetype
          size
          baseName
          uuid
        }
        notes
      }
    }
    name
    editionNumber
    dndaState_transitions_
    sadaicState_transitions_
  }
}
    `;
export const SignedEditionBlockchainCertOneDocument = gql`
    query signedEditionBlockchainCertOne($id: String!) {
  signedEditionBlockchainCertOne(id: $id) {
    id
    version_
    name
    contractNumber
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    confirmedAt
  }
}
    `;
export const SignedEditionBlockchainCertListWithOffsetDocument = gql`
    query signedEditionBlockchainCertListWithOffset($where: SignedEditionBlockchainCert_Filter, $orderBy: [SignedEditionBlockchainCert_OrderBy!], $offset: Int!, $take: Int!) {
  signedEditionBlockchainCertListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    contractNumber
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    confirmedAt
  }
}
    `;
export const SignedEditionBlockchainCertListWithCursorDocument = gql`
    query signedEditionBlockchainCertListWithCursor($where: SignedEditionBlockchainCert_Filter, $orderBy: SignedEditionBlockchainCert_OrderByCursor!, $cursorKey: String, $take: Int!) {
  signedEditionBlockchainCertListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    contractNumber
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    confirmedAt
  }
}
    `;
export const SignedEditionDndaWorkflowStateCreateDocument = gql`
    mutation signedEditionDndaWorkflowStateCreate($name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  signedEditionDndaWorkflowStateCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const SignedEditionDndaWorkflowStateUpdateDocument = gql`
    mutation signedEditionDndaWorkflowStateUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  signedEditionDndaWorkflowStateUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const SignedEditionDndaWorkflowStateDeleteDocument = gql`
    mutation signedEditionDndaWorkflowStateDelete($id: String!) {
  signedEditionDndaWorkflowStateDelete(id: $id) {
    id
  }
}
    `;
export const SignedEditionDndaWorkflowStateOneDocument = gql`
    query signedEditionDndaWorkflowStateOne($id: String!) {
  signedEditionDndaWorkflowStateOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const SignedEditionDndaWorkflowStateListWithOffsetDocument = gql`
    query signedEditionDndaWorkflowStateListWithOffset($where: SignedEditionDndaWorkflowState_Filter, $orderBy: [SignedEditionDndaWorkflowState_OrderBy!], $offset: Int!, $take: Int!) {
  signedEditionDndaWorkflowStateListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const SignedEditionDndaWorkflowStateListWithCursorDocument = gql`
    query signedEditionDndaWorkflowStateListWithCursor($where: SignedEditionDndaWorkflowState_Filter, $orderBy: SignedEditionDndaWorkflowState_OrderByCursor!, $cursorKey: String, $take: Int!) {
  signedEditionDndaWorkflowStateListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const SignedEditionSadaicWorkflowStateCreateDocument = gql`
    mutation signedEditionSadaicWorkflowStateCreate($name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  signedEditionSadaicWorkflowStateCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const SignedEditionSadaicWorkflowStateUpdateDocument = gql`
    mutation signedEditionSadaicWorkflowStateUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  signedEditionSadaicWorkflowStateUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const SignedEditionSadaicWorkflowStateDeleteDocument = gql`
    mutation signedEditionSadaicWorkflowStateDelete($id: String!) {
  signedEditionSadaicWorkflowStateDelete(id: $id) {
    id
  }
}
    `;
export const SignedEditionSadaicWorkflowStateOneDocument = gql`
    query signedEditionSadaicWorkflowStateOne($id: String!) {
  signedEditionSadaicWorkflowStateOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const SignedEditionSadaicWorkflowStateListWithOffsetDocument = gql`
    query signedEditionSadaicWorkflowStateListWithOffset($where: SignedEditionSadaicWorkflowState_Filter, $orderBy: [SignedEditionSadaicWorkflowState_OrderBy!], $offset: Int!, $take: Int!) {
  signedEditionSadaicWorkflowStateListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const SignedEditionSadaicWorkflowStateListWithCursorDocument = gql`
    query signedEditionSadaicWorkflowStateListWithCursor($where: SignedEditionSadaicWorkflowState_Filter, $orderBy: SignedEditionSadaicWorkflowState_OrderByCursor!, $cursorKey: String, $take: Int!) {
  signedEditionSadaicWorkflowStateListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const SimulationSessionDeleteDocument = gql`
    mutation simulationSessionDelete($id: String!) {
  simulationSessionDelete(id: $id) {
    id
  }
}
    `;
export const SimulationSessionOneDocument = gql`
    query simulationSessionOne($id: String!) {
  simulationSessionOne(id: $id) {
    id
    version_
    status
    mode
    label
    entryPipeline
    scenario
    resolvedGates
    currentGate
    correlationId
    relatedEntityType
    relatedEntityId
    startedAt
    completedAt
    triggeredBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
  }
}
    `;
export const SimulationSessionListWithOffsetDocument = gql`
    query simulationSessionListWithOffset($where: SimulationSession_Filter, $orderBy: [SimulationSession_OrderBy!], $offset: Int!, $take: Int!) {
  simulationSessionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    status
    mode
    label
    entryPipeline
    scenario
    resolvedGates
    currentGate
    correlationId
    relatedEntityType
    relatedEntityId
    startedAt
    completedAt
    triggeredBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
  }
}
    `;
export const SimulationSessionListWithCursorDocument = gql`
    query simulationSessionListWithCursor($where: SimulationSession_Filter, $orderBy: SimulationSession_OrderByCursor!, $cursorKey: String, $take: Int!) {
  simulationSessionListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    status
    mode
    label
    entryPipeline
    scenario
    resolvedGates
    currentGate
    correlationId
    relatedEntityType
    relatedEntityId
    startedAt
    completedAt
    triggeredBy {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
  }
}
    `;
export const SnapshotOverrideCreateDocument = gql`
    mutation snapshotOverrideCreate($relatedEntityType: String!, $relatedEntityId: String!, $path: String!, $value: Json!, $note: String!, $active: Boolean!, $idempotencyKey_: String) {
  snapshotOverrideCreate(
    relatedEntityType: $relatedEntityType
    relatedEntityId: $relatedEntityId
    path: $path
    value: $value
    note: $note
    active: $active
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const SnapshotOverrideUpdateDocument = gql`
    mutation snapshotOverrideUpdate($id: String!, $version_: String!, $relatedEntityType: String!, $relatedEntityId: String!, $path: String!, $value: Json!, $note: String!, $active: Boolean!, $idempotencyKey_: String) {
  snapshotOverrideUpdate(
    id: $id
    version_: $version_
    relatedEntityType: $relatedEntityType
    relatedEntityId: $relatedEntityId
    path: $path
    value: $value
    note: $note
    active: $active
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const SnapshotOverrideDeleteDocument = gql`
    mutation snapshotOverrideDelete($id: String!) {
  snapshotOverrideDelete(id: $id) {
    id
  }
}
    `;
export const SnapshotOverrideOneDocument = gql`
    query snapshotOverrideOne($id: String!) {
  snapshotOverrideOne(id: $id) {
    id
    version_
    relatedEntityType
    relatedEntityId
    path
    value
    note
    active
  }
}
    `;
export const SnapshotOverrideListWithOffsetDocument = gql`
    query snapshotOverrideListWithOffset($where: SnapshotOverride_Filter, $orderBy: [SnapshotOverride_OrderBy!], $offset: Int!, $take: Int!) {
  snapshotOverrideListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    relatedEntityType
    relatedEntityId
    path
    value
    note
    active
  }
}
    `;
export const SnapshotOverrideListWithCursorDocument = gql`
    query snapshotOverrideListWithCursor($where: SnapshotOverride_Filter, $orderBy: SnapshotOverride_OrderByCursor!, $cursorKey: String, $take: Int!) {
  snapshotOverrideListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    relatedEntityType
    relatedEntityId
    path
    value
    note
    active
  }
}
    `;
export const TadManagerConfigUpdateDocument = gql`
    mutation tadManagerConfigUpdate($id: String!, $version_: String!, $authProvider: TadAuthProvider, $idCardType: IdCardType, $idCard: String, $procedureNumber: String, $miArgentinaPassword: String, $arcaPassword: String, $ansesPassword: String, $gender: Gender, $idempotencyKey_: String) {
  tadManagerConfigUpdate(
    id: $id
    version_: $version_
    authProvider: $authProvider
    idCardType: $idCardType
    idCard: $idCard
    procedureNumber: $procedureNumber
    miArgentinaPassword: $miArgentinaPassword
    arcaPassword: $arcaPassword
    ansesPassword: $ansesPassword
    gender: $gender
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TadManagerConfigOneDocument = gql`
    query tadManagerConfigOne($id: String!) {
  tadManagerConfigOne(id: $id) {
    id
    version_
    authProvider
    idCardType
    idCard
    procedureNumberHasValue
    miArgentinaPasswordHasValue
    arcaPasswordHasValue
    ansesPasswordHasValue
    gender
  }
}
    `;
export const TadManagerConfigListWithOffsetDocument = gql`
    query tadManagerConfigListWithOffset($where: TadManagerConfig_Filter, $orderBy: [TadManagerConfig_OrderBy!], $offset: Int!, $take: Int!) {
  tadManagerConfigListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    authProvider
    idCardType
    idCard
    gender
  }
}
    `;
export const TadManagerConfigListWithCursorDocument = gql`
    query tadManagerConfigListWithCursor($where: TadManagerConfig_Filter, $orderBy: TadManagerConfig_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tadManagerConfigListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    authProvider
    idCardType
    idCard
    gender
  }
}
    `;
export const TenantCreateDocument = gql`
    mutation tenantCreate($name: String!, $tenantTypeId: String, $statusId: String, $planId: String, $logo: UploadedFile, $publicUrl: String, $idERP: String, $idCRM: String, $monthlyTokenLimit: Int, $currentMonthTokens: Int!, $tokenLimitResetDay: Int!, $lastTokenResetDate: DateTime, $ragLlmProviderId: String, $ragLlmModel: String, $currentStorageBytes: Int!, $storageByteLimit: Int, $eSignatureProvider: EsignatureProvider, $idempotencyKey_: String) {
  tenantCreate(
    name: $name
    tenantTypeId: $tenantTypeId
    statusId: $statusId
    planId: $planId
    logo: $logo
    publicUrl: $publicUrl
    idERP: $idERP
    idCRM: $idCRM
    monthlyTokenLimit: $monthlyTokenLimit
    currentMonthTokens: $currentMonthTokens
    tokenLimitResetDay: $tokenLimitResetDay
    lastTokenResetDate: $lastTokenResetDate
    ragLlmProviderId: $ragLlmProviderId
    ragLlmModel: $ragLlmModel
    currentStorageBytes: $currentStorageBytes
    storageByteLimit: $storageByteLimit
    eSignatureProvider: $eSignatureProvider
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TenantUpdateDocument = gql`
    mutation tenantUpdate($id: String!, $version_: String!, $name: String!, $tenantTypeId: String, $statusId: String, $planId: String, $logo: UploadedFile, $publicUrl: String, $idERP: String, $idCRM: String, $monthlyTokenLimit: Int, $currentMonthTokens: Int!, $tokenLimitResetDay: Int!, $lastTokenResetDate: DateTime, $ragLlmProviderId: String, $ragLlmModel: String, $currentStorageBytes: Int!, $storageByteLimit: Int, $eSignatureProvider: EsignatureProvider, $idempotencyKey_: String) {
  tenantUpdate(
    id: $id
    version_: $version_
    name: $name
    tenantTypeId: $tenantTypeId
    statusId: $statusId
    planId: $planId
    logo: $logo
    publicUrl: $publicUrl
    idERP: $idERP
    idCRM: $idCRM
    monthlyTokenLimit: $monthlyTokenLimit
    currentMonthTokens: $currentMonthTokens
    tokenLimitResetDay: $tokenLimitResetDay
    lastTokenResetDate: $lastTokenResetDate
    ragLlmProviderId: $ragLlmProviderId
    ragLlmModel: $ragLlmModel
    currentStorageBytes: $currentStorageBytes
    storageByteLimit: $storageByteLimit
    eSignatureProvider: $eSignatureProvider
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TenantDeleteDocument = gql`
    mutation tenantDelete($id: String!) {
  tenantDelete(id: $id) {
    id
  }
}
    `;
export const TenantOneDocument = gql`
    query tenantOne($id: String!) {
  tenantOne(id: $id) {
    id
    version_
    name
    tenantType {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    status {
      id
      version_
      name
      description_es
      description_en
      description_pt
      blocksAccess
    }
    plan {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
      limits
    }
    logo
    logo_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    publicUrl
    idERP
    idCRM
    monthlyTokenLimit
    currentMonthTokens
    tokenLimitResetDay
    lastTokenResetDate
    ragLlmProvider {
      id
      version_
      name
      code
      requiresApiKey
      requiresBaseUrl
      defaultModels
      logoUrl
    }
    ragLlmModel
    currentStorageBytes
    storageByteLimit
    eSignatureProvider
  }
}
    `;
export const TenantListWithOffsetDocument = gql`
    query tenantListWithOffset($where: Tenant_Filter, $orderBy: [Tenant_OrderBy!], $offset: Int!, $take: Int!) {
  tenantListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    tenantType {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    status {
      id
      version_
      name
      description_es
      description_en
      description_pt
      blocksAccess
    }
    plan {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
      limits
    }
    logo
    logo_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    publicUrl
    idERP
    idCRM
    monthlyTokenLimit
    currentMonthTokens
    tokenLimitResetDay
    lastTokenResetDate
    ragLlmProvider {
      id
      version_
      name
      code
      requiresApiKey
      requiresBaseUrl
      defaultModels
      logoUrl
    }
    ragLlmModel
    currentStorageBytes
    storageByteLimit
    eSignatureProvider
  }
}
    `;
export const TenantListWithCursorDocument = gql`
    query tenantListWithCursor($where: Tenant_Filter, $orderBy: Tenant_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    tenantType {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    status {
      id
      version_
      name
      description_es
      description_en
      description_pt
      blocksAccess
    }
    plan {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
      limits
    }
    logo
    logo_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    publicUrl
    idERP
    idCRM
    monthlyTokenLimit
    currentMonthTokens
    tokenLimitResetDay
    lastTokenResetDate
    ragLlmProvider {
      id
      version_
      name
      code
      requiresApiKey
      requiresBaseUrl
      defaultModels
      logoUrl
    }
    ragLlmModel
    currentStorageBytes
    storageByteLimit
    eSignatureProvider
  }
}
    `;
export const TenantDocumentCreateDocument = gql`
    mutation tenantDocumentCreate($name: String!, $description: String, $file: UploadedFile!, $processingError: String, $contentType: String, $chunkingStrategy: ChunkingStrategy!, $chunkingSeparatorRegex: String, $chunkingMaxTokens: Int, $chunkingOverlapTokens: Int, $idempotencyKey_: String) {
  tenantDocumentCreate(
    name: $name
    description: $description
    file: $file
    processingError: $processingError
    contentType: $contentType
    chunkingStrategy: $chunkingStrategy
    chunkingSeparatorRegex: $chunkingSeparatorRegex
    chunkingMaxTokens: $chunkingMaxTokens
    chunkingOverlapTokens: $chunkingOverlapTokens
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TenantDocumentUpdateDocument = gql`
    mutation tenantDocumentUpdate($id: String!, $version_: String!, $name: String!, $description: String, $file: UploadedFile, $processingError: String, $contentType: String, $chunkingStrategy: ChunkingStrategy, $chunkingSeparatorRegex: String, $chunkingMaxTokens: Int, $chunkingOverlapTokens: Int, $idempotencyKey_: String) {
  tenantDocumentUpdate(
    id: $id
    version_: $version_
    name: $name
    description: $description
    file: $file
    processingError: $processingError
    contentType: $contentType
    chunkingStrategy: $chunkingStrategy
    chunkingSeparatorRegex: $chunkingSeparatorRegex
    chunkingMaxTokens: $chunkingMaxTokens
    chunkingOverlapTokens: $chunkingOverlapTokens
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TenantDocumentDeleteDocument = gql`
    mutation tenantDocumentDelete($id: String!) {
  tenantDocumentDelete(id: $id) {
    id
  }
}
    `;
export const TenantDocumentOneDocument = gql`
    query tenantDocumentOne($id: String!) {
  tenantDocumentOne(id: $id) {
    id
    version_
    name
    description
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    fileType
    fileSize
    status
    chunkCount
    uploadedAt
    processedAt
    processingError
    contentType
    chunkingStrategy
    chunkingSeparatorRegex
    chunkingMaxTokens
    chunkingOverlapTokens
  }
}
    `;
export const TenantDocumentListWithOffsetDocument = gql`
    query tenantDocumentListWithOffset($where: TenantDocument_Filter, $orderBy: [TenantDocument_OrderBy!], $offset: Int!, $take: Int!) {
  tenantDocumentListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    description
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    fileType
    fileSize
    status
    chunkCount
    uploadedAt
    processedAt
    processingError
    contentType
    chunkingStrategy
    chunkingSeparatorRegex
    chunkingMaxTokens
    chunkingOverlapTokens
  }
}
    `;
export const TenantDocumentListWithCursorDocument = gql`
    query tenantDocumentListWithCursor($where: TenantDocument_Filter, $orderBy: TenantDocument_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantDocumentListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    description
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    fileType
    fileSize
    status
    chunkCount
    uploadedAt
    processedAt
    processingError
    contentType
    chunkingStrategy
    chunkingSeparatorRegex
    chunkingMaxTokens
    chunkingOverlapTokens
  }
}
    `;
export const TenantLlmConfigCreateDocument = gql`
    mutation tenantLlmConfigCreate($providerId: String!, $model: String!, $apiKey: String, $baseUrl: String, $enabled: Boolean!, $priority: Int!, $maxTokens: Int, $temperature: Decimal, $debugFullMode: Boolean!, $idempotencyKey_: String) {
  tenantLlmConfigCreate(
    providerId: $providerId
    model: $model
    apiKey: $apiKey
    baseUrl: $baseUrl
    enabled: $enabled
    priority: $priority
    maxTokens: $maxTokens
    temperature: $temperature
    debugFullMode: $debugFullMode
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TenantLlmConfigUpdateDocument = gql`
    mutation tenantLlmConfigUpdate($id: String!, $version_: String!, $providerId: String!, $model: String!, $apiKey: String, $baseUrl: String, $enabled: Boolean!, $priority: Int!, $maxTokens: Int, $temperature: Decimal, $debugFullMode: Boolean!, $idempotencyKey_: String) {
  tenantLlmConfigUpdate(
    id: $id
    version_: $version_
    providerId: $providerId
    model: $model
    apiKey: $apiKey
    baseUrl: $baseUrl
    enabled: $enabled
    priority: $priority
    maxTokens: $maxTokens
    temperature: $temperature
    debugFullMode: $debugFullMode
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TenantLlmConfigDeleteDocument = gql`
    mutation tenantLlmConfigDelete($id: String!) {
  tenantLlmConfigDelete(id: $id) {
    id
  }
}
    `;
export const TenantLlmConfigOneDocument = gql`
    query tenantLlmConfigOne($id: String!) {
  tenantLlmConfigOne(id: $id) {
    id
    version_
    provider {
      id
      version_
      name
      code
      requiresApiKey
      requiresBaseUrl
      defaultModels
      logoUrl
    }
    model
    apiKeyHasValue
    baseUrl
    enabled
    priority
    maxTokens
    temperature
    debugFullMode
  }
}
    `;
export const TenantLlmConfigListWithOffsetDocument = gql`
    query tenantLlmConfigListWithOffset($where: TenantLlmConfig_Filter, $orderBy: [TenantLlmConfig_OrderBy!], $offset: Int!, $take: Int!) {
  tenantLlmConfigListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    provider {
      id
      version_
      name
      code
      requiresApiKey
      requiresBaseUrl
      defaultModels
      logoUrl
    }
    model
    baseUrl
    enabled
    priority
    maxTokens
    temperature
    debugFullMode
  }
}
    `;
export const TenantLlmConfigListWithCursorDocument = gql`
    query tenantLlmConfigListWithCursor($where: TenantLlmConfig_Filter, $orderBy: TenantLlmConfig_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantLlmConfigListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    provider {
      id
      version_
      name
      code
      requiresApiKey
      requiresBaseUrl
      defaultModels
      logoUrl
    }
    model
    baseUrl
    enabled
    priority
    maxTokens
    temperature
    debugFullMode
  }
}
    `;
export const TenantPlanCreateDocument = gql`
    mutation tenantPlanCreate($name_es: String!, $name_en: String!, $name_pt: String!, $description_es: String, $description_en: String, $description_pt: String, $limits: Json, $idempotencyKey_: String) {
  tenantPlanCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    limits: $limits
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TenantPlanUpdateDocument = gql`
    mutation tenantPlanUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $description_es: String, $description_en: String, $description_pt: String, $limits: Json, $idempotencyKey_: String) {
  tenantPlanUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    limits: $limits
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TenantPlanDeleteDocument = gql`
    mutation tenantPlanDelete($id: String!) {
  tenantPlanDelete(id: $id) {
    id
  }
}
    `;
export const TenantPlanOneDocument = gql`
    query tenantPlanOne($id: String!) {
  tenantPlanOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
    limits
  }
}
    `;
export const TenantPlanListWithOffsetDocument = gql`
    query tenantPlanListWithOffset($where: TenantPlan_Filter, $orderBy: [TenantPlan_OrderBy!], $offset: Int!, $take: Int!) {
  tenantPlanListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
    limits
  }
}
    `;
export const TenantPlanListWithCursorDocument = gql`
    query tenantPlanListWithCursor($where: TenantPlan_Filter, $orderBy: TenantPlan_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantPlanListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
    limits
  }
}
    `;
export const TenantProfileCreateDocument = gql`
    mutation tenantProfileCreate($personType: PersonType, $legalName: String, $ownPublisherId: String, $businessId: String, $legalEmail: String, $streetAndNumber: String, $floor: String, $suite: String, $postalCode: String, $countryId: String, $provinceId: String, $city: String, $vatStatusId: String, $taxId: String, $grossReceiptsStatusId: String, $grossReceiptsId: String, $billingEmail: String, $billingCurrencyId: String, $printerName: String, $printerStreetAndNumber: String, $printerFloor: String, $printerSuite: String, $printerPostalCode: String, $printerCountryId: String, $printerProvinceId: String, $printerCity: String, $sadaicFtpUrl: String, $sadaicFtpUser: String, $sadaicFtpPassword: String, $sadaicEmail: String, $idempotencyKey_: String) {
  tenantProfileCreate(
    personType: $personType
    legalName: $legalName
    ownPublisherId: $ownPublisherId
    businessId: $businessId
    legalEmail: $legalEmail
    streetAndNumber: $streetAndNumber
    floor: $floor
    suite: $suite
    postalCode: $postalCode
    countryId: $countryId
    provinceId: $provinceId
    city: $city
    vatStatusId: $vatStatusId
    taxId: $taxId
    grossReceiptsStatusId: $grossReceiptsStatusId
    grossReceiptsId: $grossReceiptsId
    billingEmail: $billingEmail
    billingCurrencyId: $billingCurrencyId
    printerName: $printerName
    printerStreetAndNumber: $printerStreetAndNumber
    printerFloor: $printerFloor
    printerSuite: $printerSuite
    printerPostalCode: $printerPostalCode
    printerCountryId: $printerCountryId
    printerProvinceId: $printerProvinceId
    printerCity: $printerCity
    sadaicFtpUrl: $sadaicFtpUrl
    sadaicFtpUser: $sadaicFtpUser
    sadaicFtpPassword: $sadaicFtpPassword
    sadaicEmail: $sadaicEmail
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TenantProfileUpdateDocument = gql`
    mutation tenantProfileUpdate($id: String!, $version_: String!, $personType: PersonType, $legalName: String, $ownPublisherId: String, $businessId: String, $legalEmail: String, $streetAndNumber: String, $floor: String, $suite: String, $postalCode: String, $countryId: String, $provinceId: String, $city: String, $vatStatusId: String, $taxId: String, $grossReceiptsStatusId: String, $grossReceiptsId: String, $billingEmail: String, $billingCurrencyId: String, $printerName: String, $printerStreetAndNumber: String, $printerFloor: String, $printerSuite: String, $printerPostalCode: String, $printerCountryId: String, $printerProvinceId: String, $printerCity: String, $sadaicFtpUrl: String, $sadaicFtpUser: String, $sadaicFtpPassword: String, $sadaicEmail: String, $idempotencyKey_: String) {
  tenantProfileUpdate(
    id: $id
    version_: $version_
    personType: $personType
    legalName: $legalName
    ownPublisherId: $ownPublisherId
    businessId: $businessId
    legalEmail: $legalEmail
    streetAndNumber: $streetAndNumber
    floor: $floor
    suite: $suite
    postalCode: $postalCode
    countryId: $countryId
    provinceId: $provinceId
    city: $city
    vatStatusId: $vatStatusId
    taxId: $taxId
    grossReceiptsStatusId: $grossReceiptsStatusId
    grossReceiptsId: $grossReceiptsId
    billingEmail: $billingEmail
    billingCurrencyId: $billingCurrencyId
    printerName: $printerName
    printerStreetAndNumber: $printerStreetAndNumber
    printerFloor: $printerFloor
    printerSuite: $printerSuite
    printerPostalCode: $printerPostalCode
    printerCountryId: $printerCountryId
    printerProvinceId: $printerProvinceId
    printerCity: $printerCity
    sadaicFtpUrl: $sadaicFtpUrl
    sadaicFtpUser: $sadaicFtpUser
    sadaicFtpPassword: $sadaicFtpPassword
    sadaicEmail: $sadaicEmail
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TenantProfileDeleteDocument = gql`
    mutation tenantProfileDelete($id: String!) {
  tenantProfileDelete(id: $id) {
    id
  }
}
    `;
export const TenantProfileOneDocument = gql`
    query tenantProfileOne($id: String!) {
  tenantProfileOne(id: $id) {
    id
    version_
    personType
    legalName
    ownPublisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    businessId
    legalEmail
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    vatStatus {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    taxId
    grossReceiptsStatus {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    grossReceiptsId
    billingEmail
    billingCurrency {
      id
      version_
      code
      name
    }
    printerName
    printerStreetAndNumber
    printerFloor
    printerSuite
    printerPostalCode
    printerCountry {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    printerProvince {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    printerCity
    sadaicFtpUrl
    sadaicFtpUser
    sadaicFtpPasswordHasValue
    sadaicEmail
  }
}
    `;
export const TenantProfileListWithOffsetDocument = gql`
    query tenantProfileListWithOffset($where: TenantProfile_Filter, $orderBy: [TenantProfile_OrderBy!], $offset: Int!, $take: Int!) {
  tenantProfileListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    personType
    legalName
    ownPublisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    businessId
    legalEmail
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    vatStatus {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    taxId
    grossReceiptsStatus {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    grossReceiptsId
    billingEmail
    billingCurrency {
      id
      version_
      code
      name
    }
    printerName
    printerStreetAndNumber
    printerFloor
    printerSuite
    printerPostalCode
    printerCountry {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    printerProvince {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    printerCity
    sadaicFtpUrl
    sadaicFtpUser
    sadaicEmail
  }
}
    `;
export const TenantProfileListWithCursorDocument = gql`
    query tenantProfileListWithCursor($where: TenantProfile_Filter, $orderBy: TenantProfile_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantProfileListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    personType
    legalName
    ownPublisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    businessId
    legalEmail
    streetAndNumber
    floor
    suite
    postalCode
    country {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    province {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    city
    vatStatus {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    taxId
    grossReceiptsStatus {
      id
      version_
      name_es
      name_en
      name_pt
      description_es
      description_en
      description_pt
    }
    grossReceiptsId
    billingEmail
    billingCurrency {
      id
      version_
      code
      name
    }
    printerName
    printerStreetAndNumber
    printerFloor
    printerSuite
    printerPostalCode
    printerCountry {
      id
      version_
      name_es
      name_en
      name_pt
      code
      currency
      demonym_es
      demonym_en
      demonym_pt
    }
    printerProvince {
      id
      version_
      name_es
      name_en
      name_pt
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
    }
    printerCity
    sadaicFtpUrl
    sadaicFtpUser
    sadaicEmail
  }
}
    `;
export const TenantStatusCreateDocument = gql`
    mutation tenantStatusCreate($name: String!, $description_es: String, $description_en: String, $description_pt: String, $blocksAccess: Boolean!, $idempotencyKey_: String) {
  tenantStatusCreate(
    name: $name
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    blocksAccess: $blocksAccess
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TenantStatusUpdateDocument = gql`
    mutation tenantStatusUpdate($id: String!, $version_: String!, $name: String!, $description_es: String, $description_en: String, $description_pt: String, $blocksAccess: Boolean!, $idempotencyKey_: String) {
  tenantStatusUpdate(
    id: $id
    version_: $version_
    name: $name
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    blocksAccess: $blocksAccess
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TenantStatusDeleteDocument = gql`
    mutation tenantStatusDelete($id: String!) {
  tenantStatusDelete(id: $id) {
    id
  }
}
    `;
export const TenantStatusOneDocument = gql`
    query tenantStatusOne($id: String!) {
  tenantStatusOne(id: $id) {
    id
    version_
    name
    description_es
    description_en
    description_pt
    blocksAccess
  }
}
    `;
export const TenantStatusListWithOffsetDocument = gql`
    query tenantStatusListWithOffset($where: TenantStatus_Filter, $orderBy: [TenantStatus_OrderBy!], $offset: Int!, $take: Int!) {
  tenantStatusListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    description_es
    description_en
    description_pt
    blocksAccess
  }
}
    `;
export const TenantStatusListWithCursorDocument = gql`
    query tenantStatusListWithCursor($where: TenantStatus_Filter, $orderBy: TenantStatus_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantStatusListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    description_es
    description_en
    description_pt
    blocksAccess
  }
}
    `;
export const TenantStorageUsageOneDocument = gql`
    query tenantStorageUsageOne($id: String!) {
  tenantStorageUsageOne(id: $id) {
    id
    version_
    operation
    bytes
    documentName
    documentId
    fileType
    timestamp
    balanceAfter
  }
}
    `;
export const TenantStorageUsageListWithOffsetDocument = gql`
    query tenantStorageUsageListWithOffset($where: TenantStorageUsage_Filter, $orderBy: [TenantStorageUsage_OrderBy!], $offset: Int!, $take: Int!) {
  tenantStorageUsageListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    operation
    bytes
    documentName
    documentId
    fileType
    timestamp
    balanceAfter
  }
}
    `;
export const TenantStorageUsageListWithCursorDocument = gql`
    query tenantStorageUsageListWithCursor($where: TenantStorageUsage_Filter, $orderBy: TenantStorageUsage_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantStorageUsageListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    operation
    bytes
    documentName
    documentId
    fileType
    timestamp
    balanceAfter
  }
}
    `;
export const TenantTokenUsageOneDocument = gql`
    query tenantTokenUsageOne($id: String!) {
  tenantTokenUsageOne(id: $id) {
    id
    version_
    provider
    model
    promptTokens
    completionTokens
    totalTokens
    conversation {
      id
      version_
      startedAt
      lastMessageAt
      messageCount
      messages
      context
    }
    conversationUser {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    timestamp
    totalTimeMs
    llmTimeMs
    toolsTimeMs
    ragTimeMs
    firstTokenMs
    llmCallCount
    toolCallCount
    ragChunksCount
    abTestCondition
  }
}
    `;
export const TenantTokenUsageListWithOffsetDocument = gql`
    query tenantTokenUsageListWithOffset($where: TenantTokenUsage_Filter, $orderBy: [TenantTokenUsage_OrderBy!], $offset: Int!, $take: Int!) {
  tenantTokenUsageListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    provider
    model
    promptTokens
    completionTokens
    totalTokens
    conversation {
      id
      version_
      startedAt
      lastMessageAt
      messageCount
      messages
      context
    }
    conversationUser {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    timestamp
    totalTimeMs
    llmTimeMs
    toolsTimeMs
    ragTimeMs
    firstTokenMs
    llmCallCount
    toolCallCount
    ragChunksCount
    abTestCondition
  }
}
    `;
export const TenantTokenUsageListWithCursorDocument = gql`
    query tenantTokenUsageListWithCursor($where: TenantTokenUsage_Filter, $orderBy: TenantTokenUsage_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantTokenUsageListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    provider
    model
    promptTokens
    completionTokens
    totalTokens
    conversation {
      id
      version_
      startedAt
      lastMessageAt
      messageCount
      messages
      context
    }
    conversationUser {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    timestamp
    totalTimeMs
    llmTimeMs
    toolsTimeMs
    ragTimeMs
    firstTokenMs
    llmCallCount
    toolCallCount
    ragChunksCount
    abTestCondition
  }
}
    `;
export const TenantTypeCreateDocument = gql`
    mutation tenantTypeCreate($name_es: String!, $name_en: String!, $name_pt: String!, $description_es: String, $description_en: String, $description_pt: String, $idempotencyKey_: String) {
  tenantTypeCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TenantTypeUpdateDocument = gql`
    mutation tenantTypeUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $description_es: String, $description_en: String, $description_pt: String, $idempotencyKey_: String) {
  tenantTypeUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TenantTypeDeleteDocument = gql`
    mutation tenantTypeDelete($id: String!) {
  tenantTypeDelete(id: $id) {
    id
  }
}
    `;
export const TenantTypeOneDocument = gql`
    query tenantTypeOne($id: String!) {
  tenantTypeOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const TenantTypeListWithOffsetDocument = gql`
    query tenantTypeListWithOffset($where: TenantType_Filter, $orderBy: [TenantType_OrderBy!], $offset: Int!, $take: Int!) {
  tenantTypeListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const TenantTypeListWithCursorDocument = gql`
    query tenantTypeListWithCursor($where: TenantType_Filter, $orderBy: TenantType_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantTypeListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const TenantWidgetAccessCreateDocument = gql`
    mutation tenantWidgetAccessCreate($tenantId: String!, $widgetId: String!, $enabled: Boolean!, $configOverride: Json, $idempotencyKey_: String) {
  tenantWidgetAccessCreate(
    tenantId: $tenantId
    widgetId: $widgetId
    enabled: $enabled
    configOverride: $configOverride
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TenantWidgetAccessUpdateDocument = gql`
    mutation tenantWidgetAccessUpdate($id: String!, $version_: String!, $tenantId: String!, $widgetId: String!, $enabled: Boolean!, $configOverride: Json, $idempotencyKey_: String) {
  tenantWidgetAccessUpdate(
    id: $id
    version_: $version_
    tenantId: $tenantId
    widgetId: $widgetId
    enabled: $enabled
    configOverride: $configOverride
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TenantWidgetAccessDeleteDocument = gql`
    mutation tenantWidgetAccessDelete($id: String!) {
  tenantWidgetAccessDelete(id: $id) {
    id
  }
}
    `;
export const TenantWidgetAccessOneDocument = gql`
    query tenantWidgetAccessOne($id: String!) {
  tenantWidgetAccessOne(id: $id) {
    id
    version_
    tenant {
      id
      version_
      name
      tenantType {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
      }
      status {
        id
        version_
        name
        description_es
        description_en
        description_pt
        blocksAccess
      }
      plan {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
        limits
      }
      logo
      logo_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      publicUrl
      idERP
      idCRM
      monthlyTokenLimit
      currentMonthTokens
      tokenLimitResetDay
      lastTokenResetDate
      ragLlmProvider {
        id
        version_
        name
        code
        requiresApiKey
        requiresBaseUrl
        defaultModels
        logoUrl
      }
      ragLlmModel
      currentStorageBytes
      storageByteLimit
      eSignatureProvider
    }
    widget {
      id
      version_
      widgetKey
      title
      description
      category
      component
      dataFetcherKey
      defaultConfig
      icon
      minWidth
      minHeight
      refreshInterval
      requiredPermissions
      enabled
    }
    enabled
    configOverride
  }
}
    `;
export const TenantWidgetAccessListWithOffsetDocument = gql`
    query tenantWidgetAccessListWithOffset($where: TenantWidgetAccess_Filter, $orderBy: [TenantWidgetAccess_OrderBy!], $offset: Int!, $take: Int!) {
  tenantWidgetAccessListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    tenant {
      id
      version_
      name
      tenantType {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
      }
      status {
        id
        version_
        name
        description_es
        description_en
        description_pt
        blocksAccess
      }
      plan {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
        limits
      }
      logo
      logo_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      publicUrl
      idERP
      idCRM
      monthlyTokenLimit
      currentMonthTokens
      tokenLimitResetDay
      lastTokenResetDate
      ragLlmProvider {
        id
        version_
        name
        code
        requiresApiKey
        requiresBaseUrl
        defaultModels
        logoUrl
      }
      ragLlmModel
      currentStorageBytes
      storageByteLimit
      eSignatureProvider
    }
    widget {
      id
      version_
      widgetKey
      title
      description
      category
      component
      dataFetcherKey
      defaultConfig
      icon
      minWidth
      minHeight
      refreshInterval
      requiredPermissions
      enabled
    }
    enabled
    configOverride
  }
}
    `;
export const TenantWidgetAccessListWithCursorDocument = gql`
    query tenantWidgetAccessListWithCursor($where: TenantWidgetAccess_Filter, $orderBy: TenantWidgetAccess_OrderByCursor!, $cursorKey: String, $take: Int!) {
  tenantWidgetAccessListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    tenant {
      id
      version_
      name
      tenantType {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
      }
      status {
        id
        version_
        name
        description_es
        description_en
        description_pt
        blocksAccess
      }
      plan {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
        limits
      }
      logo
      logo_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      publicUrl
      idERP
      idCRM
      monthlyTokenLimit
      currentMonthTokens
      tokenLimitResetDay
      lastTokenResetDate
      ragLlmProvider {
        id
        version_
        name
        code
        requiresApiKey
        requiresBaseUrl
        defaultModels
        logoUrl
      }
      ragLlmModel
      currentStorageBytes
      storageByteLimit
      eSignatureProvider
    }
    widget {
      id
      version_
      widgetKey
      title
      description
      category
      component
      dataFetcherKey
      defaultConfig
      icon
      minWidth
      minHeight
      refreshInterval
      requiredPermissions
      enabled
    }
    enabled
    configOverride
  }
}
    `;
export const TerritoryCreateDocument = gql`
    mutation territoryCreate($name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  territoryCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const TerritoryUpdateDocument = gql`
    mutation territoryUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $idempotencyKey_: String) {
  territoryUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const TerritoryDeleteDocument = gql`
    mutation territoryDelete($id: String!) {
  territoryDelete(id: $id) {
    id
  }
}
    `;
export const TerritoryOneDocument = gql`
    query territoryOne($id: String!) {
  territoryOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const TerritoryListWithOffsetDocument = gql`
    query territoryListWithOffset($where: Territory_Filter, $orderBy: [Territory_OrderBy!], $offset: Int!, $take: Int!) {
  territoryListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const TerritoryListWithCursorDocument = gql`
    query territoryListWithCursor($where: Territory_Filter, $orderBy: Territory_OrderByCursor!, $cursorKey: String, $take: Int!) {
  territoryListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
  }
}
    `;
export const ThemeOneDocument = gql`
    query themeOne($id: String!) {
  themeOne(id: $id) {
    id
    version_
    name
    active
    authoring
    resolved
  }
}
    `;
export const ThemeListWithOffsetDocument = gql`
    query themeListWithOffset($where: Theme_Filter, $orderBy: [Theme_OrderBy!], $offset: Int!, $take: Int!) {
  themeListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    active
    authoring
    resolved
  }
}
    `;
export const ThemeListWithCursorDocument = gql`
    query themeListWithCursor($where: Theme_Filter, $orderBy: Theme_OrderByCursor!, $cursorKey: String, $take: Int!) {
  themeListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    active
    authoring
    resolved
  }
}
    `;
export const SiteUserCreateDocument = gql`
    mutation siteUserCreate($name: String!, $email: String!, $roleId: String, $language: Language!, $avatar: UploadedFile, $active: Boolean!, $cellphone: String, $twoFaseAuth: Boolean, $idCardType: IdCardType, $idCard: String, $gender: Gender) {
  siteUserCreate(
    name: $name
    email: $email
    roleId: $roleId
    language: $language
    avatar: $avatar
    active: $active
    cellphone: $cellphone
    twoFaseAuth: $twoFaseAuth
    idCardType: $idCardType
    idCard: $idCard
    gender: $gender
  ) {
    id
  }
}
    `;
export const SiteUserUpdateDocument = gql`
    mutation siteUserUpdate($id: String!, $version_: String!, $name: String, $email: String, $roleId: String, $language: Language, $avatar: UploadedFile, $active: Boolean, $cellphone: String, $twoFaseAuth: Boolean, $idCardType: IdCardType, $idCard: String, $gender: Gender) {
  siteUserUpdate(
    id: $id
    version_: $version_
    name: $name
    email: $email
    roleId: $roleId
    language: $language
    avatar: $avatar
    active: $active
    cellphone: $cellphone
    twoFaseAuth: $twoFaseAuth
    idCardType: $idCardType
    idCard: $idCard
    gender: $gender
  ) {
    id
    version_
  }
}
    `;
export const SiteUserDeleteDocument = gql`
    mutation siteUserDelete($id: String!) {
  siteUserDelete(id: $id) {
    id
  }
}
    `;
export const SiteUserOneDocument = gql`
    query siteUserOne($id: String!) {
  siteUserOne(id: $id) {
    id
    version_
    name
    email
    role {
      id
      version_
      name_es
      name_en
      name_pt
      permissions {
        id
        version_
        name_es
        name_en
        name_pt
      }
      audience
      isForAllTenants
    }
    language
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    active
    cellphone
    twoFaseAuth
    idCardType
    idCard
    gender
  }
}
    `;
export const SiteUserListWithOffsetDocument = gql`
    query siteUserListWithOffset($where: User_Filter, $orderBy: [User_OrderBy!], $offset: Int!, $take: Int!) {
  siteUserListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    email
    role {
      id
      version_
      name_es
      name_en
      name_pt
      permissions {
        id
        version_
        name_es
        name_en
        name_pt
      }
      audience
      isForAllTenants
    }
    language
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    active
    cellphone
    twoFaseAuth
    idCardType
    idCard
    gender
  }
}
    `;
export const SiteUserListWithCursorDocument = gql`
    query siteUserListWithCursor($where: User_Filter, $orderBy: User_OrderByCursor!, $cursorKey: String, $take: Int!) {
  siteUserListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    email
    role {
      id
      version_
      name_es
      name_en
      name_pt
      permissions {
        id
        version_
        name_es
        name_en
        name_pt
      }
      audience
      isForAllTenants
    }
    language
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    active
    cellphone
    twoFaseAuth
    idCardType
    idCard
    gender
  }
}
    `;
export const UserCreateDocument = gql`
    mutation userCreate($name: String!, $email: String!, $roleId: String, $language: Language!, $avatar: UploadedFile, $targetTenantId: String, $active: Boolean!, $cellphone: String, $twoFaseAuth: Boolean, $idCardType: IdCardType, $idCard: String, $gender: Gender, $idempotencyKey_: String) {
  userCreate(
    name: $name
    email: $email
    roleId: $roleId
    language: $language
    avatar: $avatar
    targetTenantId: $targetTenantId
    active: $active
    cellphone: $cellphone
    twoFaseAuth: $twoFaseAuth
    idCardType: $idCardType
    idCard: $idCard
    gender: $gender
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const UserUpdateDocument = gql`
    mutation userUpdate($id: String!, $version_: String!, $name: String!, $email: String!, $roleId: String, $language: Language, $avatar: UploadedFile, $active: Boolean!, $cellphone: String, $twoFaseAuth: Boolean, $idCardType: IdCardType, $idCard: String, $gender: Gender, $idempotencyKey_: String) {
  userUpdate(
    id: $id
    version_: $version_
    name: $name
    email: $email
    roleId: $roleId
    language: $language
    avatar: $avatar
    active: $active
    cellphone: $cellphone
    twoFaseAuth: $twoFaseAuth
    idCardType: $idCardType
    idCard: $idCard
    gender: $gender
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const UserDeleteDocument = gql`
    mutation userDelete($id: String!) {
  userDelete(id: $id) {
    id
  }
}
    `;
export const UserOneDocument = gql`
    query userOne($id: String!) {
  userOne(id: $id) {
    id
    version_
    name
    email
    role {
      id
      version_
      name_es
      name_en
      name_pt
      permissions {
        id
        version_
        name_es
        name_en
        name_pt
      }
      audience
      isForAllTenants
    }
    language
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    targetTenant {
      id
      version_
      name
      tenantType {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
      }
      status {
        id
        version_
        name
        description_es
        description_en
        description_pt
        blocksAccess
      }
      plan {
        id
        version_
        name_es
        name_en
        name_pt
        description_es
        description_en
        description_pt
        limits
      }
      logo
      logo_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      publicUrl
      idERP
      idCRM
      monthlyTokenLimit
      currentMonthTokens
      tokenLimitResetDay
      lastTokenResetDate
      ragLlmProvider {
        id
        version_
        name
        code
        requiresApiKey
        requiresBaseUrl
        defaultModels
        logoUrl
      }
      ragLlmModel
      currentStorageBytes
      storageByteLimit
      eSignatureProvider
    }
    tenantDisplayName
    active
    cellphone
    twoFaseAuth
    profile
    idCardType
    idCard
    gender
  }
}
    `;
export const UserListWithOffsetDocument = gql`
    query userListWithOffset($where: User_Filter, $orderBy: [User_OrderBy!], $offset: Int!, $take: Int!) {
  userListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    email
    role {
      id
      version_
      name_es
      name_en
      name_pt
      permissions {
        id
        version_
        name_es
        name_en
        name_pt
      }
      audience
      isForAllTenants
    }
    language
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    tenantDisplayName
    active
    cellphone
    twoFaseAuth
    idCardType
    idCard
    gender
  }
}
    `;
export const UserListWithCursorDocument = gql`
    query userListWithCursor($where: User_Filter, $orderBy: User_OrderByCursor!, $cursorKey: String, $take: Int!) {
  userListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    email
    role {
      id
      version_
      name_es
      name_en
      name_pt
      permissions {
        id
        version_
        name_es
        name_en
        name_pt
      }
      audience
      isForAllTenants
    }
    language
    avatar
    avatar_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    tenantDisplayName
    active
    cellphone
    twoFaseAuth
    idCardType
    idCard
    gender
  }
}
    `;
export const UserAttachmentEditionOneDocument = gql`
    query userAttachmentEditionOne($id: String!) {
  userAttachmentEditionOne(id: $id) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    notes
  }
}
    `;
export const UserAttachmentEditionListWithOffsetDocument = gql`
    query userAttachmentEditionListWithOffset($where: UserAttachmentEdition_Filter, $orderBy: [UserAttachmentEdition_OrderBy!], $offset: Int!, $take: Int!) {
  userAttachmentEditionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    notes
  }
}
    `;
export const UserAttachmentEditionListWithCursorDocument = gql`
    query userAttachmentEditionListWithCursor($where: UserAttachmentEdition_Filter, $orderBy: UserAttachmentEdition_OrderByCursor!, $cursorKey: String, $take: Int!) {
  userAttachmentEditionListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name
    file
    file_data {
      name
      mimetype
      url
      size
      description
      thumbnails {
        url
        size
      }
    }
    notes
  }
}
    `;
export const UserNotificationDeleteDocument = gql`
    mutation userNotificationDelete($id: String!) {
  userNotificationDelete(id: $id) {
    id
  }
}
    `;
export const UserNotificationOneDocument = gql`
    query userNotificationOne($id: String!) {
  userNotificationOne(id: $id) {
    id
    version_
    type
    priority
    title
    body
    actorUser {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    objectType
    objectId
    actionUrl
    readAt
    notificationCreatedAt
    archivedAt
    metadata
  }
}
    `;
export const UserNotificationListWithOffsetDocument = gql`
    query userNotificationListWithOffset($where: UserNotification_Filter, $orderBy: [UserNotification_OrderBy!], $offset: Int!, $take: Int!) {
  userNotificationListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    type
    priority
    title
    body
    actorUser {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    objectType
    objectId
    actionUrl
    readAt
    notificationCreatedAt
    archivedAt
    metadata
  }
}
    `;
export const UserNotificationListWithCursorDocument = gql`
    query userNotificationListWithCursor($where: UserNotification_Filter, $orderBy: UserNotification_OrderByCursor!, $cursorKey: String, $take: Int!) {
  userNotificationListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    type
    priority
    title
    body
    actorUser {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    objectType
    objectId
    actionUrl
    readAt
    notificationCreatedAt
    archivedAt
    metadata
  }
}
    `;
export const UserNotificationPreferenceCreateDocument = gql`
    mutation userNotificationPreferenceCreate($notificationType: NotificationType!, $inAppEnabled: Boolean!, $emailEnabled: Boolean!, $emailFrequency: EmailFrequency!, $idempotencyKey_: String) {
  userNotificationPreferenceCreate(
    notificationType: $notificationType
    inAppEnabled: $inAppEnabled
    emailEnabled: $emailEnabled
    emailFrequency: $emailFrequency
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const UserNotificationPreferenceUpdateDocument = gql`
    mutation userNotificationPreferenceUpdate($id: String!, $version_: String!, $notificationType: NotificationType, $inAppEnabled: Boolean!, $emailEnabled: Boolean!, $emailFrequency: EmailFrequency, $idempotencyKey_: String) {
  userNotificationPreferenceUpdate(
    id: $id
    version_: $version_
    notificationType: $notificationType
    inAppEnabled: $inAppEnabled
    emailEnabled: $emailEnabled
    emailFrequency: $emailFrequency
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const UserNotificationPreferenceDeleteDocument = gql`
    mutation userNotificationPreferenceDelete($id: String!) {
  userNotificationPreferenceDelete(id: $id) {
    id
  }
}
    `;
export const UserNotificationPreferenceOneDocument = gql`
    query userNotificationPreferenceOne($id: String!) {
  userNotificationPreferenceOne(id: $id) {
    id
    version_
    notificationType
    inAppEnabled
    emailEnabled
    emailFrequency
  }
}
    `;
export const UserNotificationPreferenceListWithOffsetDocument = gql`
    query userNotificationPreferenceListWithOffset($where: UserNotificationPreference_Filter, $orderBy: [UserNotificationPreference_OrderBy!], $offset: Int!, $take: Int!) {
  userNotificationPreferenceListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    notificationType
    inAppEnabled
    emailEnabled
    emailFrequency
  }
}
    `;
export const UserNotificationPreferenceListWithCursorDocument = gql`
    query userNotificationPreferenceListWithCursor($where: UserNotificationPreference_Filter, $orderBy: UserNotificationPreference_OrderByCursor!, $cursorKey: String, $take: Int!) {
  userNotificationPreferenceListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    notificationType
    inAppEnabled
    emailEnabled
    emailFrequency
  }
}
    `;
export const UserWidgetConfigCreateDocument = gql`
    mutation userWidgetConfigCreate($userId: String!, $widgetId: String!, $enabled: Boolean!, $position: Json!, $configOverride: Json, $displayOrder: Int, $idempotencyKey_: String) {
  userWidgetConfigCreate(
    userId: $userId
    widgetId: $widgetId
    enabled: $enabled
    position: $position
    configOverride: $configOverride
    displayOrder: $displayOrder
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const UserWidgetConfigUpdateDocument = gql`
    mutation userWidgetConfigUpdate($id: String!, $version_: String!, $userId: String!, $widgetId: String!, $enabled: Boolean!, $position: Json!, $configOverride: Json, $displayOrder: Int, $idempotencyKey_: String) {
  userWidgetConfigUpdate(
    id: $id
    version_: $version_
    userId: $userId
    widgetId: $widgetId
    enabled: $enabled
    position: $position
    configOverride: $configOverride
    displayOrder: $displayOrder
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const UserWidgetConfigDeleteDocument = gql`
    mutation userWidgetConfigDelete($id: String!) {
  userWidgetConfigDelete(id: $id) {
    id
  }
}
    `;
export const UserWidgetConfigOneDocument = gql`
    query userWidgetConfigOne($id: String!) {
  userWidgetConfigOne(id: $id) {
    id
    version_
    user {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    widget {
      id
      version_
      widgetKey
      title
      description
      category
      component
      dataFetcherKey
      defaultConfig
      icon
      minWidth
      minHeight
      refreshInterval
      requiredPermissions
      enabled
    }
    enabled
    position
    configOverride
    displayOrder
  }
}
    `;
export const UserWidgetConfigListWithOffsetDocument = gql`
    query userWidgetConfigListWithOffset($where: UserWidgetConfig_Filter, $orderBy: [UserWidgetConfig_OrderBy!], $offset: Int!, $take: Int!) {
  userWidgetConfigListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    user {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    widget {
      id
      version_
      widgetKey
      title
      description
      category
      component
      dataFetcherKey
      defaultConfig
      icon
      minWidth
      minHeight
      refreshInterval
      requiredPermissions
      enabled
    }
    enabled
    position
    configOverride
    displayOrder
  }
}
    `;
export const UserWidgetConfigListWithCursorDocument = gql`
    query userWidgetConfigListWithCursor($where: UserWidgetConfig_Filter, $orderBy: UserWidgetConfig_OrderByCursor!, $cursorKey: String, $take: Int!) {
  userWidgetConfigListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    user {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
    widget {
      id
      version_
      widgetKey
      title
      description
      category
      component
      dataFetcherKey
      defaultConfig
      icon
      minWidth
      minHeight
      refreshInterval
      requiredPermissions
      enabled
    }
    enabled
    position
    configOverride
    displayOrder
  }
}
    `;
export const VatStatusCreateDocument = gql`
    mutation vatStatusCreate($name_es: String!, $name_en: String!, $name_pt: String!, $description_es: String, $description_en: String, $description_pt: String, $idempotencyKey_: String) {
  vatStatusCreate(
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
  }
}
    `;
export const VatStatusUpdateDocument = gql`
    mutation vatStatusUpdate($id: String!, $version_: String!, $name_es: String!, $name_en: String!, $name_pt: String!, $description_es: String, $description_en: String, $description_pt: String, $idempotencyKey_: String) {
  vatStatusUpdate(
    id: $id
    version_: $version_
    name_es: $name_es
    name_en: $name_en
    name_pt: $name_pt
    description_es: $description_es
    description_en: $description_en
    description_pt: $description_pt
    idempotencyKey_: $idempotencyKey_
  ) {
    id
    version_
  }
}
    `;
export const VatStatusDeleteDocument = gql`
    mutation vatStatusDelete($id: String!) {
  vatStatusDelete(id: $id) {
    id
  }
}
    `;
export const VatStatusOneDocument = gql`
    query vatStatusOne($id: String!) {
  vatStatusOne(id: $id) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const VatStatusListWithOffsetDocument = gql`
    query vatStatusListWithOffset($where: VatStatus_Filter, $orderBy: [VatStatus_OrderBy!], $offset: Int!, $take: Int!) {
  vatStatusListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const VatStatusListWithCursorDocument = gql`
    query vatStatusListWithCursor($where: VatStatus_Filter, $orderBy: VatStatus_OrderByCursor!, $cursorKey: String, $take: Int!) {
  vatStatusListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    name_es
    name_en
    name_pt
    description_es
    description_en
    description_pt
  }
}
    `;
export const WorkAuthorOneDocument = gql`
    query workAuthorOne($id: String!) {
  workAuthorOne(id: $id) {
    id
    version_
    author {
      id
      version_
      firstName
      lastName
      gender
      taxIdType
      taxId
      cuitCertificate
      cuitCertificate_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      cuitCertificateIssuedAt
      cuitCertificateError
      cuitCertificateErrorType
      dniDeliveredToSadaicAt
      dniValidatedAt
      dniValidatedFields
      email
      phone
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      dateOfBirth
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      aka
      ipi
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        memberNumber
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
      }
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
      createdAt_
      lastUpdatedAt_
    }
    lyricsPercentage
    musicPercentage
    publishers {
      id
      version_
      publisher {
        id
        version_
        personType
        name
        maritalStatus
        pseudonym
        taxId
        phone
        email
        streetAndNumber
        floor
        suite
        postalCode
        city
        caeIpi
        createdAt_
        lastUpdatedAt_
      }
      percentage
      durationInYears
      autoRenewalYears
    }
  }
}
    `;
export const WorkAuthorListWithOffsetDocument = gql`
    query workAuthorListWithOffset($where: WorkAuthor_Filter, $orderBy: [WorkAuthor_OrderBy!], $offset: Int!, $take: Int!) {
  workAuthorListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    author {
      id
      version_
      firstName
      lastName
      gender
      taxIdType
      taxId
      cuitCertificate
      cuitCertificate_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      cuitCertificateIssuedAt
      cuitCertificateError
      cuitCertificateErrorType
      dniDeliveredToSadaicAt
      dniValidatedAt
      dniValidatedFields
      email
      phone
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      dateOfBirth
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      aka
      ipi
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        memberNumber
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
      }
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
      createdAt_
      lastUpdatedAt_
    }
    lyricsPercentage
    musicPercentage
    publishers {
      id
      version_
      publisher {
        id
        version_
        personType
        name
        maritalStatus
        pseudonym
        taxId
        phone
        email
        streetAndNumber
        floor
        suite
        postalCode
        city
        caeIpi
        createdAt_
        lastUpdatedAt_
      }
      percentage
      durationInYears
      autoRenewalYears
    }
  }
}
    `;
export const WorkAuthorListWithCursorDocument = gql`
    query workAuthorListWithCursor($where: WorkAuthor_Filter, $orderBy: WorkAuthor_OrderByCursor!, $cursorKey: String, $take: Int!) {
  workAuthorListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    author {
      id
      version_
      firstName
      lastName
      gender
      taxIdType
      taxId
      cuitCertificate
      cuitCertificate_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      cuitCertificateIssuedAt
      cuitCertificateError
      cuitCertificateErrorType
      dniDeliveredToSadaicAt
      dniValidatedAt
      dniValidatedFields
      email
      phone
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      dateOfBirth
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      aka
      ipi
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        memberNumber
        territories {
          id
          version_
          name_es
          name_en
          name_pt
        }
      }
      publishers {
        id
        version_
        publisher {
          id
          version_
          personType
          name
          maritalStatus
          pseudonym
          taxId
          phone
          email
          streetAndNumber
          floor
          suite
          postalCode
          city
          caeIpi
          createdAt_
          lastUpdatedAt_
        }
        percentage
        durationInYears
        autoRenewalYears
      }
      createdAt_
      lastUpdatedAt_
    }
    lyricsPercentage
    musicPercentage
    publishers {
      id
      version_
      publisher {
        id
        version_
        personType
        name
        maritalStatus
        pseudonym
        taxId
        phone
        email
        streetAndNumber
        floor
        suite
        postalCode
        city
        caeIpi
        createdAt_
        lastUpdatedAt_
      }
      percentage
      durationInYears
      autoRenewalYears
    }
  }
}
    `;
export const WorkAuthorPublisherOneDocument = gql`
    query workAuthorPublisherOne($id: String!) {
  workAuthorPublisherOne(id: $id) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
    durationInYears
    autoRenewalYears
  }
}
    `;
export const WorkAuthorPublisherListWithOffsetDocument = gql`
    query workAuthorPublisherListWithOffset($where: WorkAuthorPublisher_Filter, $orderBy: [WorkAuthorPublisher_OrderBy!], $offset: Int!, $take: Int!) {
  workAuthorPublisherListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
    durationInYears
    autoRenewalYears
  }
}
    `;
export const WorkAuthorPublisherListWithCursorDocument = gql`
    query workAuthorPublisherListWithCursor($where: WorkAuthorPublisher_Filter, $orderBy: WorkAuthorPublisher_OrderByCursor!, $cursorKey: String, $take: Int!) {
  workAuthorPublisherListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    publisher {
      id
      version_
      personType
      name
      maritalStatus
      nationality {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      pseudonym
      taxId
      phone
      email
      streetAndNumber
      floor
      suite
      postalCode
      country {
        id
        version_
        name_es
        name_en
        name_pt
        code
        currency
        demonym_es
        demonym_en
        demonym_pt
      }
      province {
        id
        version_
        name_es
        name_en
        name_pt
        country {
          id
          version_
          name_es
          name_en
          name_pt
          code
          currency
          demonym_es
          demonym_en
          demonym_pt
        }
      }
      city
      caeIpi
      representatives {
        id
        version_
        name
        role
        email
        phone
        isSigner
      }
      managementSocieties {
        id
        version_
        collectingSociety {
          id
          version_
          name
          acronym
        }
        cmsAccountNumber
      }
      createdAt_
      lastUpdatedAt_
    }
    percentage
    durationInYears
    autoRenewalYears
  }
}
    `;
export const WorkerEventDeleteDocument = gql`
    mutation workerEventDelete($id: String!) {
  workerEventDelete(id: $id) {
    id
  }
}
    `;
export const WorkerEventOneDocument = gql`
    query workerEventOne($id: String!) {
  workerEventOne(id: $id) {
    id
    version_
    queueName
    jobType
    status
    enqueuedAt
    startedAt
    completedAt
    payload
    result
    error
    retryCount
    manualRetryCount
    nextRetryAt
    duration
    correlationId
    triggerUserId {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
  }
}
    `;
export const WorkerEventListWithOffsetDocument = gql`
    query workerEventListWithOffset($where: WorkerEvent_Filter, $orderBy: [WorkerEvent_OrderBy!], $offset: Int!, $take: Int!) {
  workerEventListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
  ) {
    id
    version_
    queueName
    jobType
    status
    enqueuedAt
    startedAt
    completedAt
    payload
    result
    error
    retryCount
    manualRetryCount
    nextRetryAt
    duration
    correlationId
    triggerUserId {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
  }
}
    `;
export const WorkerEventListWithCursorDocument = gql`
    query workerEventListWithCursor($where: WorkerEvent_Filter, $orderBy: WorkerEvent_OrderByCursor!, $cursorKey: String, $take: Int!) {
  workerEventListWithCursor(
    where: $where
    orderBy: $orderBy
    cursorKey: $cursorKey
    take: $take
  ) {
    id
    version_
    queueName
    jobType
    status
    enqueuedAt
    startedAt
    completedAt
    payload
    result
    error
    retryCount
    manualRetryCount
    nextRetryAt
    duration
    correlationId
    triggerUserId {
      id
      version_
      name
      email
      role {
        id
        version_
        name_es
        name_en
        name_pt
        permissions {
          id
          version_
          name_es
          name_en
          name_pt
        }
        audience
        isForAllTenants
      }
      language
      avatar
      avatar_data {
        name
        mimetype
        url
        size
        description
        thumbnails {
          url
          size
        }
      }
      targetTenant {
        id
        version_
        name
        tenantType {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
        }
        status {
          id
          version_
          name
          description_es
          description_en
          description_pt
          blocksAccess
        }
        plan {
          id
          version_
          name_es
          name_en
          name_pt
          description_es
          description_en
          description_pt
          limits
        }
        logo
        logo_data {
          name
          mimetype
          url
          size
          description
          thumbnails {
            url
            size
          }
        }
        publicUrl
        idERP
        idCRM
        monthlyTokenLimit
        currentMonthTokens
        tokenLimitResetDay
        lastTokenResetDate
        ragLlmProvider {
          id
          version_
          name
          code
          requiresApiKey
          requiresBaseUrl
          defaultModels
          logoUrl
        }
        ragLlmModel
        currentStorageBytes
        storageByteLimit
        eSignatureProvider
      }
      tenantDisplayName
      active
      cellphone
      twoFaseAuth
      profile
      idCardType
      idCard
      gender
    }
  }
}
    `;
export const AutomationEditionsDocument = gql`
    query automationEditions($offset: Int!, $take: Int!) {
  signedEditionListWithOffset(offset: $offset, take: $take, allTenants: true) {
    id
    displayId
    version_
    tenant_id_
    lastUpdatedAt_
    dndaState {
      id
    }
    sadaicState {
      id
    }
    dndaLastOperationalError
    sadaicLastOperationalError
    data_ {
      name
    }
  }
}
    `;
export const AutomationBotRunsDocument = gql`
    query automationBotRuns($where: BotRun_Filter, $offset: Int!, $take: Int!) {
  botRunListWithOffset(where: $where, offset: $offset, take: $take) {
    id
    displayId
    botType
    status
    currentPhase
    relatedEntityType
    relatedEntityId
    startedAt
    interventionReason
    workerEvent {
      id
      displayId
      jobType
      status
    }
  }
}
    `;
export const AutomationOverridesDocument = gql`
    query automationOverrides($where: SnapshotOverride_Filter, $offset: Int!, $take: Int!) {
  snapshotOverrideListWithOffset(
    where: $where
    orderBy: [{createdAt_: asc}]
    offset: $offset
    take: $take
    allTenants: true
  ) {
    id
    version_
    path
    value
    note
    active
    createdAt_
    createdBy_ {
      email
    }
  }
}
    `;
export const AutomationOverrideCreateDocument = gql`
    mutation automationOverrideCreate($relatedEntityType: String!, $relatedEntityId: String!, $path: String!, $value: Json!, $note: String!, $active: Boolean!) {
  snapshotOverrideCreate(
    relatedEntityType: $relatedEntityType
    relatedEntityId: $relatedEntityId
    path: $path
    value: $value
    note: $note
    active: $active
  ) {
    id
  }
}
    `;
export const AutomationOverrideSetActiveDocument = gql`
    mutation automationOverrideSetActive($id: String!, $version_: String!, $active: Boolean!) {
  snapshotOverrideUpdate(id: $id, version_: $version_, active: $active) {
    id
    version_
    active
  }
}
    `;
export const AutomationHistoryDocument = gql`
    query automationHistory($since: String!, $offset: Int!, $take: Int!) {
  workerEventListWithOffset(
    where: {enqueuedAt: {gte: $since}}
    orderBy: [{enqueuedAt: desc}]
    offset: $offset
    take: $take
    allTenants: true
  ) {
    id
    jobType
    status
    enqueuedAt
    retryCount
  }
}
    `;
export const EditionsPendingSignatureCompletionDocument = gql`
    query editionsPendingSignatureCompletion {
  editionsPendingSignatureCompletion {
    editionId
    name
    version
    totalDocs
    completedDocs
    allComplete
    unlinkedSignatures
  }
}
    `;
export const SimulationStartDocument = gql`
    mutation simulationStart($relatedEntityType: String!, $relatedEntityId: ID!, $mode: String!, $scenario: Json, $label: String) {
  simulationStart(
    relatedEntityType: $relatedEntityType
    relatedEntityId: $relatedEntityId
    mode: $mode
    scenario: $scenario
    label: $label
  ) {
    sessionId
  }
}
    `;
export const SimulationResetDocument = gql`
    mutation simulationReset($relatedEntityType: String!, $relatedEntityId: ID!) {
  simulationReset(
    relatedEntityType: $relatedEntityType
    relatedEntityId: $relatedEntityId
  ) {
    ok
  }
}
    `;
export const SimulationControlDocument = gql`
    mutation simulationControl($sessionId: ID!, $gate: String, $action: String!, $faultType: String) {
  simulationControl(
    sessionId: $sessionId
    gate: $gate
    action: $action
    faultType: $faultType
  ) {
    ok
  }
}
    `;
export const SimSessionDocument = gql`
    query simSession($id: String!) {
  simulationSessionOne(id: $id, allTenants: true) {
    id
    status
    mode
    label
    currentGate
    resolvedGates
    relatedEntityId
    relatedEntityType
  }
}
    `;
export const SimActiveSessionsDocument = gql`
    query simActiveSessions($where: SimulationSession_Filter, $orderBy: [SimulationSession_OrderBy!], $offset: Int!, $take: Int!) {
  simulationSessionListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
    allTenants: true
  ) {
    id
    status
    mode
    currentGate
    relatedEntityId
  }
}
    `;
export const SimEditionsDocument = gql`
    query simEditions($where: SignedEdition_Filter, $offset: Int!, $take: Int!) {
  signedEditionListWithOffset(
    where: $where
    offset: $offset
    take: $take
    allTenants: true
  ) {
    id
    displayId
    dndaState {
      id
    }
    data_ {
      name
    }
  }
}
    `;
export const SimEditionStateDocument = gql`
    query simEditionState($id: String!) {
  signedEditionOne(id: $id, allTenants: true) {
    id
    dndaState {
      id
    }
    sadaicState {
      id
    }
    data_ {
      name
    }
  }
}
    `;
export const SimWorkerEventsDocument = gql`
    query simWorkerEvents($where: WorkerEvent_Filter, $orderBy: [WorkerEvent_OrderBy!], $offset: Int!, $take: Int!) {
  workerEventListWithOffset(
    where: $where
    orderBy: $orderBy
    offset: $offset
    take: $take
    allTenants: true
  ) {
    id
    displayId
    jobType
    status
    retryCount
    manualRetryCount
    nextRetryAt
    error
    enqueuedAt
    payload
  }
}
    `;
export const SimBotRunsDocument = gql`
    query simBotRuns($where: BotRun_Filter, $offset: Int!, $take: Int!) {
  botRunListWithOffset(where: $where, offset: $offset, take: $take) {
    id
    status
    botType
    currentPhase
    displayId
  }
}
    `;
export const EditionDocumentationWorkflow_GenerateDocumentationDocument = gql`
    mutation editionDocumentationWorkflow_GenerateDocumentation($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_GenerateDocumentation(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_DeleteAndRestartFromSignatureDocument = gql`
    mutation editionDocumentationWorkflow_DeleteAndRestartFromSignature($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_DeleteAndRestartFromSignature(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_CancelGenerationDocument = gql`
    mutation editionDocumentationWorkflow_CancelGeneration($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_CancelGeneration(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedDocument = gql`
    mutation editionDocumentationWorkflow_DeleteAndRestartFromGenerated($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_DeleteAndRestartFromGenerated(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_DeleteAndRestartFromFailedDocument = gql`
    mutation editionDocumentationWorkflow_DeleteAndRestartFromFailed($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_DeleteAndRestartFromFailed(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_RetryGenerateDocumentationDocument = gql`
    mutation editionDocumentationWorkflow_RetryGenerateDocumentation($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_RetryGenerateDocumentation(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_SendForSignatureDocument = gql`
    mutation editionDocumentationWorkflow_SendForSignature($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_SendForSignature(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_CancelSendingDocument = gql`
    mutation editionDocumentationWorkflow_CancelSending($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_CancelSending(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_RetrySendForSignatureDocument = gql`
    mutation editionDocumentationWorkflow_RetrySendForSignature($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_RetrySendForSignature(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_BackToDocsFromSignatureFailedDocument = gql`
    mutation editionDocumentationWorkflow_BackToDocsFromSignatureFailed($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_BackToDocsFromSignatureFailed(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_BorrarDocumentacionFromFalloDocument = gql`
    mutation editionDocumentationWorkflow_BorrarDocumentacionFromFallo($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_BorrarDocumentacionFromFallo(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_ReintentarCierreFirmasDocument = gql`
    mutation editionDocumentationWorkflow_ReintentarCierreFirmas($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_ReintentarCierreFirmas(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctDocument = gql`
    mutation editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarDocument = gql`
    mutation editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const ShowcaseWorkflow_SubmitDocument = gql`
    mutation showcaseWorkflow_Submit($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  showcaseWorkflow_Submit(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const ShowcaseWorkflow_ApproveDocument = gql`
    mutation showcaseWorkflow_Approve($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  showcaseWorkflow_Approve(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const ShowcaseWorkflow_RejectDocument = gql`
    mutation showcaseWorkflow_Reject($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  showcaseWorkflow_Reject(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const ShowcaseWorkflow_FailDocument = gql`
    mutation showcaseWorkflow_Fail($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  showcaseWorkflow_Fail(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const ShowcaseWorkflow_RetryDocument = gql`
    mutation showcaseWorkflow_Retry($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  showcaseWorkflow_Retry(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const ShowcaseWorkflow_CloseDocument = gql`
    mutation showcaseWorkflow_Close($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  showcaseWorkflow_Close(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const ShowcaseWorkflow_ReopenDocument = gql`
    mutation showcaseWorkflow_Reopen($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  showcaseWorkflow_Reopen(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadDocument = gql`
    mutation signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarDocument = gql`
    mutation signedEditionDndaWorkflow_ReintentarGeneracionEjemplar($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  signedEditionDndaWorkflow_ReintentarGeneracionEjemplar(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const SignedEditionDndaWorkflow_ReintentarRegistroDndaDocument = gql`
    mutation signedEditionDndaWorkflow_ReintentarRegistroDnda($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  signedEditionDndaWorkflow_ReintentarRegistroDnda(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const SignedEditionDndaWorkflow_ReintentarUploadEjemplarDocument = gql`
    mutation signedEditionDndaWorkflow_ReintentarUploadEjemplar($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  signedEditionDndaWorkflow_ReintentarUploadEjemplar(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const SignedEditionDndaWorkflow_ReintentarAvanceRegistroDocument = gql`
    mutation signedEditionDndaWorkflow_ReintentarAvanceRegistro($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  signedEditionDndaWorkflow_ReintentarAvanceRegistro(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const SignedEditionDndaWorkflow_ReintentarAvanceUploadDocument = gql`
    mutation signedEditionDndaWorkflow_ReintentarAvanceUpload($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  signedEditionDndaWorkflow_ReintentarAvanceUpload(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;
export const SignedEditionSadaicWorkflow_ReintentarSubidaSadaicDocument = gql`
    mutation signedEditionSadaicWorkflow_ReintentarSubidaSadaic($instanceId: String!, $instanceVersion: String!, $instanceEntity: String!) {
  signedEditionSadaicWorkflow_ReintentarSubidaSadaic(
    instanceId: $instanceId
    instanceVersion: $instanceVersion
    instanceEntity: $instanceEntity
  ) {
    instanceId
    instanceVersion
    instanceState
    nextTransitions
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>({ document: LoginDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Login', 'mutation', variables);
    },
    RefreshToken(variables: RefreshTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RefreshTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshTokenMutation>({ document: RefreshTokenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RefreshToken', 'mutation', variables);
    },
    Logout(variables?: LogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>({ document: LogoutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Logout', 'mutation', variables);
    },
    SaveProfile(variables: SaveProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SaveProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveProfileMutation>({ document: SaveProfileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SaveProfile', 'mutation', variables);
    },
    SetMyLanguage(variables: SetMyLanguageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetMyLanguageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetMyLanguageMutation>({ document: SetMyLanguageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetMyLanguage', 'mutation', variables);
    },
    ChangePassword(variables: ChangePasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChangePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangePasswordMutation>({ document: ChangePasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ChangePassword', 'mutation', variables);
    },
    UserResetPassword(variables: UserResetPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserResetPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserResetPasswordMutation>({ document: UserResetPasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UserResetPassword', 'mutation', variables);
    },
    SetupTwoFa(variables: SetupTwoFaMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetupTwoFaMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetupTwoFaMutation>({ document: SetupTwoFaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetupTwoFa', 'mutation', variables);
    },
    ConfirmTwoFaSetup(variables: ConfirmTwoFaSetupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfirmTwoFaSetupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmTwoFaSetupMutation>({ document: ConfirmTwoFaSetupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConfirmTwoFaSetup', 'mutation', variables);
    },
    VerifyTwoFa(variables: VerifyTwoFaMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VerifyTwoFaMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyTwoFaMutation>({ document: VerifyTwoFaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VerifyTwoFa', 'mutation', variables);
    },
    VerifyTwoFaBackupCode(variables: VerifyTwoFaBackupCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VerifyTwoFaBackupCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyTwoFaBackupCodeMutation>({ document: VerifyTwoFaBackupCodeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VerifyTwoFaBackupCode', 'mutation', variables);
    },
    UpdateMyAvatar(variables?: UpdateMyAvatarMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateMyAvatarMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyAvatarMutation>({ document: UpdateMyAvatarDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateMyAvatar', 'mutation', variables);
    },
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>({ document: MeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Me', 'query', variables);
    },
    MyTrustedDevices(variables?: MyTrustedDevicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyTrustedDevicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyTrustedDevicesQuery>({ document: MyTrustedDevicesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyTrustedDevices', 'query', variables);
    },
    RevokeTrustedDevice(variables: RevokeTrustedDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RevokeTrustedDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokeTrustedDeviceMutation>({ document: RevokeTrustedDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RevokeTrustedDevice', 'mutation', variables);
    },
    RevokeAllTrustedDevices(variables?: RevokeAllTrustedDevicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RevokeAllTrustedDevicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokeAllTrustedDevicesMutation>({ document: RevokeAllTrustedDevicesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RevokeAllTrustedDevices', 'mutation', variables);
    },
    deletionBlockers(variables: DeletionBlockersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeletionBlockersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletionBlockersQuery>({ document: DeletionBlockersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deletionBlockers', 'query', variables);
    },
    fileUpload(variables: FileUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FileUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FileUploadMutation>({ document: FileUploadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'fileUpload', 'mutation', variables);
    },
    deleteUploadedFile(variables: DeleteUploadedFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteUploadedFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUploadedFileMutation>({ document: DeleteUploadedFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteUploadedFile', 'mutation', variables);
    },
    markNotificationRead(variables: MarkNotificationReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkNotificationReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationReadMutation>({ document: MarkNotificationReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'markNotificationRead', 'mutation', variables);
    },
    markAllNotificationsRead(variables?: MarkAllNotificationsReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkAllNotificationsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAllNotificationsReadMutation>({ document: MarkAllNotificationsReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'markAllNotificationsRead', 'mutation', variables);
    },
    archiveNotification(variables: ArchiveNotificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ArchiveNotificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveNotificationMutation>({ document: ArchiveNotificationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'archiveNotification', 'mutation', variables);
    },
    previewTheme(variables: PreviewThemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PreviewThemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewThemeMutation>({ document: PreviewThemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'previewTheme', 'mutation', variables);
    },
    applyTheme(variables: ApplyThemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ApplyThemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyThemeMutation>({ document: ApplyThemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'applyTheme', 'mutation', variables);
    },
    deactivateTheme(variables?: DeactivateThemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeactivateThemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeactivateThemeMutation>({ document: DeactivateThemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deactivateTheme', 'mutation', variables);
    },
    listThemes(variables?: ListThemesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ListThemesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListThemesQuery>({ document: ListThemesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'listThemes', 'query', variables);
    },
    saveTheme(variables: SaveThemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SaveThemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveThemeMutation>({ document: SaveThemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'saveTheme', 'mutation', variables);
    },
    deleteTheme(variables: DeleteThemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteThemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteThemeMutation>({ document: DeleteThemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteTheme', 'mutation', variables);
    },
    workerEventRetry(variables: WorkerEventRetryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkerEventRetryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkerEventRetryMutation>({ document: WorkerEventRetryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workerEventRetry', 'mutation', variables);
    },
    workerEventRetryInfo(variables: WorkerEventRetryInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkerEventRetryInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkerEventRetryInfoQuery>({ document: WorkerEventRetryInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workerEventRetryInfo', 'query', variables);
    },
    aiSearchAutoEvalDelete(variables: AiSearchAutoEvalDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchAutoEvalDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchAutoEvalDeleteMutation>({ document: AiSearchAutoEvalDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchAutoEvalDelete', 'mutation', variables);
    },
    aiSearchAutoEvalOne(variables: AiSearchAutoEvalOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchAutoEvalOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchAutoEvalOneQuery>({ document: AiSearchAutoEvalOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchAutoEvalOne', 'query', variables);
    },
    aiSearchAutoEvalListWithOffset(variables: AiSearchAutoEvalListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchAutoEvalListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchAutoEvalListWithOffsetQuery>({ document: AiSearchAutoEvalListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchAutoEvalListWithOffset', 'query', variables);
    },
    aiSearchAutoEvalListWithCursor(variables: AiSearchAutoEvalListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchAutoEvalListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchAutoEvalListWithCursorQuery>({ document: AiSearchAutoEvalListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchAutoEvalListWithCursor', 'query', variables);
    },
    aiSearchConversationDelete(variables: AiSearchConversationDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchConversationDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchConversationDeleteMutation>({ document: AiSearchConversationDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchConversationDelete', 'mutation', variables);
    },
    aiSearchConversationOne(variables: AiSearchConversationOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchConversationOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchConversationOneQuery>({ document: AiSearchConversationOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchConversationOne', 'query', variables);
    },
    aiSearchConversationListWithOffset(variables: AiSearchConversationListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchConversationListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchConversationListWithOffsetQuery>({ document: AiSearchConversationListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchConversationListWithOffset', 'query', variables);
    },
    aiSearchConversationListWithCursor(variables: AiSearchConversationListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchConversationListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchConversationListWithCursorQuery>({ document: AiSearchConversationListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchConversationListWithCursor', 'query', variables);
    },
    aiSearchPatternCreate(variables: AiSearchPatternCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchPatternCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchPatternCreateMutation>({ document: AiSearchPatternCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchPatternCreate', 'mutation', variables);
    },
    aiSearchPatternUpdate(variables: AiSearchPatternUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchPatternUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchPatternUpdateMutation>({ document: AiSearchPatternUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchPatternUpdate', 'mutation', variables);
    },
    aiSearchPatternDelete(variables: AiSearchPatternDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchPatternDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchPatternDeleteMutation>({ document: AiSearchPatternDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchPatternDelete', 'mutation', variables);
    },
    aiSearchPatternOne(variables: AiSearchPatternOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchPatternOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchPatternOneQuery>({ document: AiSearchPatternOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchPatternOne', 'query', variables);
    },
    aiSearchPatternListWithOffset(variables: AiSearchPatternListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchPatternListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchPatternListWithOffsetQuery>({ document: AiSearchPatternListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchPatternListWithOffset', 'query', variables);
    },
    aiSearchPatternListWithCursor(variables: AiSearchPatternListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchPatternListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchPatternListWithCursorQuery>({ document: AiSearchPatternListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchPatternListWithCursor', 'query', variables);
    },
    aiSearchResponseCreate(variables: AiSearchResponseCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchResponseCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchResponseCreateMutation>({ document: AiSearchResponseCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchResponseCreate', 'mutation', variables);
    },
    aiSearchResponseDelete(variables: AiSearchResponseDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchResponseDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchResponseDeleteMutation>({ document: AiSearchResponseDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchResponseDelete', 'mutation', variables);
    },
    aiSearchResponseOne(variables: AiSearchResponseOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchResponseOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchResponseOneQuery>({ document: AiSearchResponseOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchResponseOne', 'query', variables);
    },
    aiSearchResponseListWithOffset(variables: AiSearchResponseListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchResponseListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchResponseListWithOffsetQuery>({ document: AiSearchResponseListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchResponseListWithOffset', 'query', variables);
    },
    aiSearchResponseListWithCursor(variables: AiSearchResponseListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchResponseListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchResponseListWithCursorQuery>({ document: AiSearchResponseListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchResponseListWithCursor', 'query', variables);
    },
    aiSearchToolCallOne(variables: AiSearchToolCallOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchToolCallOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchToolCallOneQuery>({ document: AiSearchToolCallOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchToolCallOne', 'query', variables);
    },
    aiSearchToolCallListWithOffset(variables: AiSearchToolCallListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchToolCallListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchToolCallListWithOffsetQuery>({ document: AiSearchToolCallListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchToolCallListWithOffset', 'query', variables);
    },
    aiSearchToolCallListWithCursor(variables: AiSearchToolCallListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AiSearchToolCallListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiSearchToolCallListWithCursorQuery>({ document: AiSearchToolCallListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'aiSearchToolCallListWithCursor', 'query', variables);
    },
    alertRuleCreate(variables: AlertRuleCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertRuleCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertRuleCreateMutation>({ document: AlertRuleCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertRuleCreate', 'mutation', variables);
    },
    alertRuleUpdate(variables: AlertRuleUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertRuleUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertRuleUpdateMutation>({ document: AlertRuleUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertRuleUpdate', 'mutation', variables);
    },
    alertRuleDelete(variables: AlertRuleDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertRuleDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertRuleDeleteMutation>({ document: AlertRuleDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertRuleDelete', 'mutation', variables);
    },
    alertRuleOne(variables: AlertRuleOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertRuleOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertRuleOneQuery>({ document: AlertRuleOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertRuleOne', 'query', variables);
    },
    alertRuleListWithOffset(variables: AlertRuleListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertRuleListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertRuleListWithOffsetQuery>({ document: AlertRuleListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertRuleListWithOffset', 'query', variables);
    },
    alertRuleListWithCursor(variables: AlertRuleListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertRuleListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertRuleListWithCursorQuery>({ document: AlertRuleListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertRuleListWithCursor', 'query', variables);
    },
    alertSubscriptionCreate(variables: AlertSubscriptionCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertSubscriptionCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertSubscriptionCreateMutation>({ document: AlertSubscriptionCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertSubscriptionCreate', 'mutation', variables);
    },
    alertSubscriptionUpdate(variables: AlertSubscriptionUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertSubscriptionUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertSubscriptionUpdateMutation>({ document: AlertSubscriptionUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertSubscriptionUpdate', 'mutation', variables);
    },
    alertSubscriptionDelete(variables: AlertSubscriptionDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertSubscriptionDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertSubscriptionDeleteMutation>({ document: AlertSubscriptionDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertSubscriptionDelete', 'mutation', variables);
    },
    alertSubscriptionOne(variables: AlertSubscriptionOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertSubscriptionOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertSubscriptionOneQuery>({ document: AlertSubscriptionOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertSubscriptionOne', 'query', variables);
    },
    alertSubscriptionListWithOffset(variables: AlertSubscriptionListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertSubscriptionListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertSubscriptionListWithOffsetQuery>({ document: AlertSubscriptionListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertSubscriptionListWithOffset', 'query', variables);
    },
    alertSubscriptionListWithCursor(variables: AlertSubscriptionListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertSubscriptionListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertSubscriptionListWithCursorQuery>({ document: AlertSubscriptionListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'alertSubscriptionListWithCursor', 'query', variables);
    },
    associatedDocumentEditionOne(variables: AssociatedDocumentEditionOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssociatedDocumentEditionOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssociatedDocumentEditionOneQuery>({ document: AssociatedDocumentEditionOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'associatedDocumentEditionOne', 'query', variables);
    },
    associatedDocumentEditionListWithOffset(variables: AssociatedDocumentEditionListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssociatedDocumentEditionListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssociatedDocumentEditionListWithOffsetQuery>({ document: AssociatedDocumentEditionListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'associatedDocumentEditionListWithOffset', 'query', variables);
    },
    associatedDocumentEditionListWithCursor(variables: AssociatedDocumentEditionListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssociatedDocumentEditionListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssociatedDocumentEditionListWithCursorQuery>({ document: AssociatedDocumentEditionListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'associatedDocumentEditionListWithCursor', 'query', variables);
    },
    associatedDocumentSignedEditionOne(variables: AssociatedDocumentSignedEditionOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssociatedDocumentSignedEditionOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssociatedDocumentSignedEditionOneQuery>({ document: AssociatedDocumentSignedEditionOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'associatedDocumentSignedEditionOne', 'query', variables);
    },
    associatedDocumentSignedEditionListWithOffset(variables: AssociatedDocumentSignedEditionListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssociatedDocumentSignedEditionListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssociatedDocumentSignedEditionListWithOffsetQuery>({ document: AssociatedDocumentSignedEditionListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'associatedDocumentSignedEditionListWithOffset', 'query', variables);
    },
    associatedDocumentSignedEditionListWithCursor(variables: AssociatedDocumentSignedEditionListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssociatedDocumentSignedEditionListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssociatedDocumentSignedEditionListWithCursorQuery>({ document: AssociatedDocumentSignedEditionListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'associatedDocumentSignedEditionListWithCursor', 'query', variables);
    },
    authorCollectingSocietyOne(variables: AuthorCollectingSocietyOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorCollectingSocietyOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorCollectingSocietyOneQuery>({ document: AuthorCollectingSocietyOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorCollectingSocietyOne', 'query', variables);
    },
    authorCollectingSocietyListWithOffset(variables: AuthorCollectingSocietyListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorCollectingSocietyListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorCollectingSocietyListWithOffsetQuery>({ document: AuthorCollectingSocietyListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorCollectingSocietyListWithOffset', 'query', variables);
    },
    authorCollectingSocietyListWithCursor(variables: AuthorCollectingSocietyListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorCollectingSocietyListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorCollectingSocietyListWithCursorQuery>({ document: AuthorCollectingSocietyListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorCollectingSocietyListWithCursor', 'query', variables);
    },
    authorComposerCreate(variables: AuthorComposerCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerCreateMutation>({ document: AuthorComposerCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerCreate', 'mutation', variables);
    },
    authorComposerUpdate(variables: AuthorComposerUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerUpdateMutation>({ document: AuthorComposerUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerUpdate', 'mutation', variables);
    },
    authorComposerDelete(variables: AuthorComposerDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerDeleteMutation>({ document: AuthorComposerDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerDelete', 'mutation', variables);
    },
    authorComposerOne(variables: AuthorComposerOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerOneQuery>({ document: AuthorComposerOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerOne', 'query', variables);
    },
    authorComposerListWithOffset(variables: AuthorComposerListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerListWithOffsetQuery>({ document: AuthorComposerListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerListWithOffset', 'query', variables);
    },
    authorComposerListWithCursor(variables: AuthorComposerListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerListWithCursorQuery>({ document: AuthorComposerListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerListWithCursor', 'query', variables);
    },
    authorComposerPublicCreate(variables: AuthorComposerPublicCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerPublicCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerPublicCreateMutation>({ document: AuthorComposerPublicCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerPublicCreate', 'mutation', variables);
    },
    authorComposerPublicUpdate(variables: AuthorComposerPublicUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerPublicUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerPublicUpdateMutation>({ document: AuthorComposerPublicUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerPublicUpdate', 'mutation', variables);
    },
    authorComposerPublicDelete(variables: AuthorComposerPublicDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerPublicDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerPublicDeleteMutation>({ document: AuthorComposerPublicDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerPublicDelete', 'mutation', variables);
    },
    authorComposerPublicOne(variables: AuthorComposerPublicOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerPublicOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerPublicOneQuery>({ document: AuthorComposerPublicOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerPublicOne', 'query', variables);
    },
    authorComposerPublicListWithOffset(variables: AuthorComposerPublicListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerPublicListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerPublicListWithOffsetQuery>({ document: AuthorComposerPublicListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerPublicListWithOffset', 'query', variables);
    },
    authorComposerPublicListWithCursor(variables: AuthorComposerPublicListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorComposerPublicListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorComposerPublicListWithCursorQuery>({ document: AuthorComposerPublicListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorComposerPublicListWithCursor', 'query', variables);
    },
    authorPublisherOne(variables: AuthorPublisherOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorPublisherOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorPublisherOneQuery>({ document: AuthorPublisherOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorPublisherOne', 'query', variables);
    },
    authorPublisherListWithOffset(variables: AuthorPublisherListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorPublisherListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorPublisherListWithOffsetQuery>({ document: AuthorPublisherListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorPublisherListWithOffset', 'query', variables);
    },
    authorPublisherListWithCursor(variables: AuthorPublisherListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorPublisherListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorPublisherListWithCursorQuery>({ document: AuthorPublisherListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorPublisherListWithCursor', 'query', variables);
    },
    botErrorOne(variables: BotErrorOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotErrorOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotErrorOneQuery>({ document: BotErrorOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botErrorOne', 'query', variables);
    },
    botErrorListWithOffset(variables: BotErrorListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotErrorListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotErrorListWithOffsetQuery>({ document: BotErrorListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botErrorListWithOffset', 'query', variables);
    },
    botErrorListWithCursor(variables: BotErrorListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotErrorListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotErrorListWithCursorQuery>({ document: BotErrorListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botErrorListWithCursor', 'query', variables);
    },
    botPhaseOne(variables: BotPhaseOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotPhaseOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotPhaseOneQuery>({ document: BotPhaseOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botPhaseOne', 'query', variables);
    },
    botPhaseListWithOffset(variables: BotPhaseListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotPhaseListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotPhaseListWithOffsetQuery>({ document: BotPhaseListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botPhaseListWithOffset', 'query', variables);
    },
    botPhaseListWithCursor(variables: BotPhaseListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotPhaseListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotPhaseListWithCursorQuery>({ document: BotPhaseListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botPhaseListWithCursor', 'query', variables);
    },
    botRunCancel(variables: BotRunCancelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotRunCancelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotRunCancelMutation>({ document: BotRunCancelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botRunCancel', 'mutation', variables);
    },
    botRunDelete(variables: BotRunDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotRunDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotRunDeleteMutation>({ document: BotRunDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botRunDelete', 'mutation', variables);
    },
    botRunOne(variables: BotRunOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotRunOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotRunOneQuery>({ document: BotRunOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botRunOne', 'query', variables);
    },
    botRunListWithOffset(variables: BotRunListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotRunListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotRunListWithOffsetQuery>({ document: BotRunListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botRunListWithOffset', 'query', variables);
    },
    botRunListWithCursor(variables: BotRunListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotRunListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotRunListWithCursorQuery>({ document: BotRunListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botRunListWithCursor', 'query', variables);
    },
    botStepOne(variables: BotStepOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotStepOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotStepOneQuery>({ document: BotStepOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botStepOne', 'query', variables);
    },
    botStepListWithOffset(variables: BotStepListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotStepListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotStepListWithOffsetQuery>({ document: BotStepListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botStepListWithOffset', 'query', variables);
    },
    botStepListWithCursor(variables: BotStepListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotStepListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotStepListWithCursorQuery>({ document: BotStepListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'botStepListWithCursor', 'query', variables);
    },
    collectiveManagementSocietyCreate(variables: CollectiveManagementSocietyCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CollectiveManagementSocietyCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectiveManagementSocietyCreateMutation>({ document: CollectiveManagementSocietyCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'collectiveManagementSocietyCreate', 'mutation', variables);
    },
    collectiveManagementSocietyUpdate(variables: CollectiveManagementSocietyUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CollectiveManagementSocietyUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectiveManagementSocietyUpdateMutation>({ document: CollectiveManagementSocietyUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'collectiveManagementSocietyUpdate', 'mutation', variables);
    },
    collectiveManagementSocietyDelete(variables: CollectiveManagementSocietyDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CollectiveManagementSocietyDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectiveManagementSocietyDeleteMutation>({ document: CollectiveManagementSocietyDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'collectiveManagementSocietyDelete', 'mutation', variables);
    },
    collectiveManagementSocietyOne(variables: CollectiveManagementSocietyOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CollectiveManagementSocietyOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectiveManagementSocietyOneQuery>({ document: CollectiveManagementSocietyOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'collectiveManagementSocietyOne', 'query', variables);
    },
    collectiveManagementSocietyListWithOffset(variables: CollectiveManagementSocietyListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CollectiveManagementSocietyListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectiveManagementSocietyListWithOffsetQuery>({ document: CollectiveManagementSocietyListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'collectiveManagementSocietyListWithOffset', 'query', variables);
    },
    collectiveManagementSocietyListWithCursor(variables: CollectiveManagementSocietyListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CollectiveManagementSocietyListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectiveManagementSocietyListWithCursorQuery>({ document: CollectiveManagementSocietyListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'collectiveManagementSocietyListWithCursor', 'query', variables);
    },
    contractObservationCreate(variables: ContractObservationCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ContractObservationCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContractObservationCreateMutation>({ document: ContractObservationCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'contractObservationCreate', 'mutation', variables);
    },
    contractObservationUpdate(variables: ContractObservationUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ContractObservationUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContractObservationUpdateMutation>({ document: ContractObservationUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'contractObservationUpdate', 'mutation', variables);
    },
    contractObservationDelete(variables: ContractObservationDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ContractObservationDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContractObservationDeleteMutation>({ document: ContractObservationDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'contractObservationDelete', 'mutation', variables);
    },
    contractObservationOne(variables: ContractObservationOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ContractObservationOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContractObservationOneQuery>({ document: ContractObservationOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'contractObservationOne', 'query', variables);
    },
    contractObservationListWithOffset(variables: ContractObservationListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ContractObservationListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContractObservationListWithOffsetQuery>({ document: ContractObservationListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'contractObservationListWithOffset', 'query', variables);
    },
    contractObservationListWithCursor(variables: ContractObservationListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ContractObservationListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContractObservationListWithCursorQuery>({ document: ContractObservationListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'contractObservationListWithCursor', 'query', variables);
    },
    countryCreate(variables: CountryCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CountryCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountryCreateMutation>({ document: CountryCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'countryCreate', 'mutation', variables);
    },
    countryUpdate(variables: CountryUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CountryUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountryUpdateMutation>({ document: CountryUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'countryUpdate', 'mutation', variables);
    },
    countryDelete(variables: CountryDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CountryDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountryDeleteMutation>({ document: CountryDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'countryDelete', 'mutation', variables);
    },
    countryOne(variables: CountryOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CountryOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountryOneQuery>({ document: CountryOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'countryOne', 'query', variables);
    },
    countryListWithOffset(variables: CountryListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CountryListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountryListWithOffsetQuery>({ document: CountryListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'countryListWithOffset', 'query', variables);
    },
    countryListWithCursor(variables: CountryListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CountryListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountryListWithCursorQuery>({ document: CountryListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'countryListWithCursor', 'query', variables);
    },
    creditAccountUpdate(variables: CreditAccountUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditAccountUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditAccountUpdateMutation>({ document: CreditAccountUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditAccountUpdate', 'mutation', variables);
    },
    creditAccountOne(variables: CreditAccountOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditAccountOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditAccountOneQuery>({ document: CreditAccountOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditAccountOne', 'query', variables);
    },
    creditAccountListWithOffset(variables: CreditAccountListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditAccountListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditAccountListWithOffsetQuery>({ document: CreditAccountListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditAccountListWithOffset', 'query', variables);
    },
    creditAccountListWithCursor(variables: CreditAccountListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditAccountListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditAccountListWithCursorQuery>({ document: CreditAccountListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditAccountListWithCursor', 'query', variables);
    },
    creditMovementOne(variables: CreditMovementOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditMovementOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditMovementOneQuery>({ document: CreditMovementOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditMovementOne', 'query', variables);
    },
    creditMovementListWithOffset(variables: CreditMovementListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditMovementListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditMovementListWithOffsetQuery>({ document: CreditMovementListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditMovementListWithOffset', 'query', variables);
    },
    creditMovementListWithCursor(variables: CreditMovementListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditMovementListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditMovementListWithCursorQuery>({ document: CreditMovementListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditMovementListWithCursor', 'query', variables);
    },
    creditPurchaseCreate(variables: CreditPurchaseCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditPurchaseCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditPurchaseCreateMutation>({ document: CreditPurchaseCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditPurchaseCreate', 'mutation', variables);
    },
    creditPurchaseDelete(variables: CreditPurchaseDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditPurchaseDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditPurchaseDeleteMutation>({ document: CreditPurchaseDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditPurchaseDelete', 'mutation', variables);
    },
    creditPurchaseOne(variables: CreditPurchaseOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditPurchaseOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditPurchaseOneQuery>({ document: CreditPurchaseOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditPurchaseOne', 'query', variables);
    },
    creditPurchaseListWithOffset(variables: CreditPurchaseListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditPurchaseListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditPurchaseListWithOffsetQuery>({ document: CreditPurchaseListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditPurchaseListWithOffset', 'query', variables);
    },
    creditPurchaseListWithCursor(variables: CreditPurchaseListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditPurchaseListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditPurchaseListWithCursorQuery>({ document: CreditPurchaseListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditPurchaseListWithCursor', 'query', variables);
    },
    myCreditPurchasesOne(variables: MyCreditPurchasesOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyCreditPurchasesOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyCreditPurchasesOneQuery>({ document: MyCreditPurchasesOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'myCreditPurchasesOne', 'query', variables);
    },
    myCreditPurchasesListWithOffset(variables: MyCreditPurchasesListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyCreditPurchasesListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyCreditPurchasesListWithOffsetQuery>({ document: MyCreditPurchasesListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'myCreditPurchasesListWithOffset', 'query', variables);
    },
    myCreditPurchasesListWithCursor(variables: MyCreditPurchasesListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyCreditPurchasesListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyCreditPurchasesListWithCursorQuery>({ document: MyCreditPurchasesListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'myCreditPurchasesListWithCursor', 'query', variables);
    },
    creditTierCreate(variables: CreditTierCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditTierCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditTierCreateMutation>({ document: CreditTierCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditTierCreate', 'mutation', variables);
    },
    creditTierUpdate(variables: CreditTierUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditTierUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditTierUpdateMutation>({ document: CreditTierUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditTierUpdate', 'mutation', variables);
    },
    creditTierDelete(variables: CreditTierDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditTierDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditTierDeleteMutation>({ document: CreditTierDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditTierDelete', 'mutation', variables);
    },
    creditTierOne(variables: CreditTierOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditTierOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditTierOneQuery>({ document: CreditTierOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditTierOne', 'query', variables);
    },
    creditTierListWithOffset(variables: CreditTierListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditTierListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditTierListWithOffsetQuery>({ document: CreditTierListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditTierListWithOffset', 'query', variables);
    },
    creditTierListWithCursor(variables: CreditTierListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreditTierListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditTierListWithCursorQuery>({ document: CreditTierListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'creditTierListWithCursor', 'query', variables);
    },
    currencyCreate(variables: CurrencyCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CurrencyCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrencyCreateMutation>({ document: CurrencyCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'currencyCreate', 'mutation', variables);
    },
    currencyUpdate(variables: CurrencyUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CurrencyUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrencyUpdateMutation>({ document: CurrencyUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'currencyUpdate', 'mutation', variables);
    },
    currencyDelete(variables: CurrencyDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CurrencyDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrencyDeleteMutation>({ document: CurrencyDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'currencyDelete', 'mutation', variables);
    },
    currencyOne(variables: CurrencyOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CurrencyOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrencyOneQuery>({ document: CurrencyOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'currencyOne', 'query', variables);
    },
    currencyListWithOffset(variables: CurrencyListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CurrencyListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrencyListWithOffsetQuery>({ document: CurrencyListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'currencyListWithOffset', 'query', variables);
    },
    currencyListWithCursor(variables: CurrencyListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CurrencyListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrencyListWithCursorQuery>({ document: CurrencyListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'currencyListWithCursor', 'query', variables);
    },
    dashboardLayoutTemplateCreate(variables: DashboardLayoutTemplateCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardLayoutTemplateCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardLayoutTemplateCreateMutation>({ document: DashboardLayoutTemplateCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardLayoutTemplateCreate', 'mutation', variables);
    },
    dashboardLayoutTemplateUpdate(variables: DashboardLayoutTemplateUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardLayoutTemplateUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardLayoutTemplateUpdateMutation>({ document: DashboardLayoutTemplateUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardLayoutTemplateUpdate', 'mutation', variables);
    },
    dashboardLayoutTemplateDelete(variables: DashboardLayoutTemplateDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardLayoutTemplateDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardLayoutTemplateDeleteMutation>({ document: DashboardLayoutTemplateDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardLayoutTemplateDelete', 'mutation', variables);
    },
    dashboardLayoutTemplateOne(variables: DashboardLayoutTemplateOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardLayoutTemplateOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardLayoutTemplateOneQuery>({ document: DashboardLayoutTemplateOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardLayoutTemplateOne', 'query', variables);
    },
    dashboardLayoutTemplateListWithOffset(variables: DashboardLayoutTemplateListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardLayoutTemplateListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardLayoutTemplateListWithOffsetQuery>({ document: DashboardLayoutTemplateListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardLayoutTemplateListWithOffset', 'query', variables);
    },
    dashboardLayoutTemplateListWithCursor(variables: DashboardLayoutTemplateListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardLayoutTemplateListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardLayoutTemplateListWithCursorQuery>({ document: DashboardLayoutTemplateListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardLayoutTemplateListWithCursor', 'query', variables);
    },
    dashboardWidgetOne(variables: DashboardWidgetOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardWidgetOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardWidgetOneQuery>({ document: DashboardWidgetOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardWidgetOne', 'query', variables);
    },
    dashboardWidgetListWithOffset(variables: DashboardWidgetListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardWidgetListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardWidgetListWithOffsetQuery>({ document: DashboardWidgetListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardWidgetListWithOffset', 'query', variables);
    },
    dashboardWidgetListWithCursor(variables: DashboardWidgetListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardWidgetListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardWidgetListWithCursorQuery>({ document: DashboardWidgetListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'dashboardWidgetListWithCursor', 'query', variables);
    },
    designShowcaseCreate(variables: DesignShowcaseCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DesignShowcaseCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesignShowcaseCreateMutation>({ document: DesignShowcaseCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'designShowcaseCreate', 'mutation', variables);
    },
    designShowcaseUpdate(variables: DesignShowcaseUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DesignShowcaseUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesignShowcaseUpdateMutation>({ document: DesignShowcaseUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'designShowcaseUpdate', 'mutation', variables);
    },
    designShowcaseDelete(variables: DesignShowcaseDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DesignShowcaseDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesignShowcaseDeleteMutation>({ document: DesignShowcaseDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'designShowcaseDelete', 'mutation', variables);
    },
    designShowcaseOne(variables: DesignShowcaseOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DesignShowcaseOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesignShowcaseOneQuery>({ document: DesignShowcaseOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'designShowcaseOne', 'query', variables);
    },
    designShowcaseListWithOffset(variables: DesignShowcaseListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DesignShowcaseListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesignShowcaseListWithOffsetQuery>({ document: DesignShowcaseListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'designShowcaseListWithOffset', 'query', variables);
    },
    designShowcaseListWithCursor(variables: DesignShowcaseListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DesignShowcaseListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DesignShowcaseListWithCursorQuery>({ document: DesignShowcaseListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'designShowcaseListWithCursor', 'query', variables);
    },
    documentGenerationParamsCreate(variables: DocumentGenerationParamsCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DocumentGenerationParamsCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentGenerationParamsCreateMutation>({ document: DocumentGenerationParamsCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'documentGenerationParamsCreate', 'mutation', variables);
    },
    documentGenerationParamsUpdate(variables: DocumentGenerationParamsUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DocumentGenerationParamsUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentGenerationParamsUpdateMutation>({ document: DocumentGenerationParamsUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'documentGenerationParamsUpdate', 'mutation', variables);
    },
    documentGenerationParamsDelete(variables: DocumentGenerationParamsDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DocumentGenerationParamsDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentGenerationParamsDeleteMutation>({ document: DocumentGenerationParamsDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'documentGenerationParamsDelete', 'mutation', variables);
    },
    documentGenerationParamsOne(variables: DocumentGenerationParamsOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DocumentGenerationParamsOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentGenerationParamsOneQuery>({ document: DocumentGenerationParamsOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'documentGenerationParamsOne', 'query', variables);
    },
    documentGenerationParamsListWithOffset(variables: DocumentGenerationParamsListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DocumentGenerationParamsListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentGenerationParamsListWithOffsetQuery>({ document: DocumentGenerationParamsListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'documentGenerationParamsListWithOffset', 'query', variables);
    },
    documentGenerationParamsListWithCursor(variables: DocumentGenerationParamsListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DocumentGenerationParamsListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentGenerationParamsListWithCursorQuery>({ document: DocumentGenerationParamsListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'documentGenerationParamsListWithCursor', 'query', variables);
    },
    editionSignatureStatus(variables: EditionSignatureStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionSignatureStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionSignatureStatusQuery>({ document: EditionSignatureStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionSignatureStatus', 'query', variables);
    },
    recheckEditionSignatures(variables: RecheckEditionSignaturesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RecheckEditionSignaturesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecheckEditionSignaturesMutation>({ document: RecheckEditionSignaturesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'recheckEditionSignatures', 'mutation', variables);
    },
    resendSignatureEmail(variables: ResendSignatureEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ResendSignatureEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendSignatureEmailMutation>({ document: ResendSignatureEmailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'resendSignatureEmail', 'mutation', variables);
    },
    editionCreate(variables: EditionCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionCreateMutation>({ document: EditionCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionCreate', 'mutation', variables);
    },
    editionUpdate(variables: EditionUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionUpdateMutation>({ document: EditionUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionUpdate', 'mutation', variables);
    },
    editionDelete(variables: EditionDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDeleteMutation>({ document: EditionDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDelete', 'mutation', variables);
    },
    editionOne(variables: EditionOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionOneQuery>({ document: EditionOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionOne', 'query', variables);
    },
    editionListWithOffset(variables: EditionListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionListWithOffsetQuery>({ document: EditionListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionListWithOffset', 'query', variables);
    },
    editionListWithCursor(variables: EditionListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionListWithCursorQuery>({ document: EditionListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionListWithCursor', 'query', variables);
    },
    editionContractPublisherOne(variables: EditionContractPublisherOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionContractPublisherOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionContractPublisherOneQuery>({ document: EditionContractPublisherOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionContractPublisherOne', 'query', variables);
    },
    editionContractPublisherListWithOffset(variables: EditionContractPublisherListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionContractPublisherListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionContractPublisherListWithOffsetQuery>({ document: EditionContractPublisherListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionContractPublisherListWithOffset', 'query', variables);
    },
    editionContractPublisherListWithCursor(variables: EditionContractPublisherListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionContractPublisherListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionContractPublisherListWithCursorQuery>({ document: EditionContractPublisherListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionContractPublisherListWithCursor', 'query', variables);
    },
    editionDocumentTypeCreate(variables: EditionDocumentTypeCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentTypeCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentTypeCreateMutation>({ document: EditionDocumentTypeCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentTypeCreate', 'mutation', variables);
    },
    editionDocumentTypeUpdate(variables: EditionDocumentTypeUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentTypeUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentTypeUpdateMutation>({ document: EditionDocumentTypeUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentTypeUpdate', 'mutation', variables);
    },
    editionDocumentTypeDelete(variables: EditionDocumentTypeDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentTypeDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentTypeDeleteMutation>({ document: EditionDocumentTypeDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentTypeDelete', 'mutation', variables);
    },
    editionDocumentTypeOne(variables: EditionDocumentTypeOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentTypeOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentTypeOneQuery>({ document: EditionDocumentTypeOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentTypeOne', 'query', variables);
    },
    editionDocumentTypeListWithOffset(variables: EditionDocumentTypeListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentTypeListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentTypeListWithOffsetQuery>({ document: EditionDocumentTypeListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentTypeListWithOffset', 'query', variables);
    },
    editionDocumentTypeListWithCursor(variables: EditionDocumentTypeListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentTypeListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentTypeListWithCursorQuery>({ document: EditionDocumentTypeListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentTypeListWithCursor', 'query', variables);
    },
    editionDocumentationOne(variables: EditionDocumentationOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationOneQuery>({ document: EditionDocumentationOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationOne', 'query', variables);
    },
    editionDocumentationListWithOffset(variables: EditionDocumentationListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationListWithOffsetQuery>({ document: EditionDocumentationListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationListWithOffset', 'query', variables);
    },
    editionDocumentationListWithCursor(variables: EditionDocumentationListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationListWithCursorQuery>({ document: EditionDocumentationListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationListWithCursor', 'query', variables);
    },
    editionDocumentationWorkflowStateCreate(variables: EditionDocumentationWorkflowStateCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflowStateCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflowStateCreateMutation>({ document: EditionDocumentationWorkflowStateCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflowStateCreate', 'mutation', variables);
    },
    editionDocumentationWorkflowStateUpdate(variables: EditionDocumentationWorkflowStateUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflowStateUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflowStateUpdateMutation>({ document: EditionDocumentationWorkflowStateUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflowStateUpdate', 'mutation', variables);
    },
    editionDocumentationWorkflowStateDelete(variables: EditionDocumentationWorkflowStateDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflowStateDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflowStateDeleteMutation>({ document: EditionDocumentationWorkflowStateDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflowStateDelete', 'mutation', variables);
    },
    editionDocumentationWorkflowStateOne(variables: EditionDocumentationWorkflowStateOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflowStateOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflowStateOneQuery>({ document: EditionDocumentationWorkflowStateOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflowStateOne', 'query', variables);
    },
    editionDocumentationWorkflowStateListWithOffset(variables: EditionDocumentationWorkflowStateListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflowStateListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflowStateListWithOffsetQuery>({ document: EditionDocumentationWorkflowStateListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflowStateListWithOffset', 'query', variables);
    },
    editionDocumentationWorkflowStateListWithCursor(variables: EditionDocumentationWorkflowStateListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflowStateListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflowStateListWithCursorQuery>({ document: EditionDocumentationWorkflowStateListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflowStateListWithCursor', 'query', variables);
    },
    editionTypeCreate(variables: EditionTypeCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionTypeCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionTypeCreateMutation>({ document: EditionTypeCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionTypeCreate', 'mutation', variables);
    },
    editionTypeUpdate(variables: EditionTypeUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionTypeUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionTypeUpdateMutation>({ document: EditionTypeUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionTypeUpdate', 'mutation', variables);
    },
    editionTypeDelete(variables: EditionTypeDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionTypeDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionTypeDeleteMutation>({ document: EditionTypeDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionTypeDelete', 'mutation', variables);
    },
    editionTypeOne(variables: EditionTypeOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionTypeOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionTypeOneQuery>({ document: EditionTypeOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionTypeOne', 'query', variables);
    },
    editionTypeListWithOffset(variables: EditionTypeListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionTypeListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionTypeListWithOffsetQuery>({ document: EditionTypeListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionTypeListWithOffset', 'query', variables);
    },
    editionTypeListWithCursor(variables: EditionTypeListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionTypeListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionTypeListWithCursorQuery>({ document: EditionTypeListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionTypeListWithCursor', 'query', variables);
    },
    emailVerificationCreate(variables: EmailVerificationCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EmailVerificationCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailVerificationCreateMutation>({ document: EmailVerificationCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'emailVerificationCreate', 'mutation', variables);
    },
    emailVerificationUpdate(variables: EmailVerificationUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EmailVerificationUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailVerificationUpdateMutation>({ document: EmailVerificationUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'emailVerificationUpdate', 'mutation', variables);
    },
    emailVerificationDelete(variables: EmailVerificationDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EmailVerificationDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailVerificationDeleteMutation>({ document: EmailVerificationDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'emailVerificationDelete', 'mutation', variables);
    },
    emailVerificationOne(variables: EmailVerificationOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EmailVerificationOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailVerificationOneQuery>({ document: EmailVerificationOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'emailVerificationOne', 'query', variables);
    },
    emailVerificationListWithOffset(variables: EmailVerificationListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EmailVerificationListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailVerificationListWithOffsetQuery>({ document: EmailVerificationListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'emailVerificationListWithOffset', 'query', variables);
    },
    emailVerificationListWithCursor(variables: EmailVerificationListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EmailVerificationListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailVerificationListWithCursorQuery>({ document: EmailVerificationListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'emailVerificationListWithCursor', 'query', variables);
    },
    esignatureConfigCreate(variables: EsignatureConfigCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureConfigCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureConfigCreateMutation>({ document: EsignatureConfigCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureConfigCreate', 'mutation', variables);
    },
    esignatureConfigUpdate(variables: EsignatureConfigUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureConfigUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureConfigUpdateMutation>({ document: EsignatureConfigUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureConfigUpdate', 'mutation', variables);
    },
    esignatureConfigOne(variables: EsignatureConfigOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureConfigOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureConfigOneQuery>({ document: EsignatureConfigOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureConfigOne', 'query', variables);
    },
    esignatureConfigListWithOffset(variables: EsignatureConfigListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureConfigListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureConfigListWithOffsetQuery>({ document: EsignatureConfigListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureConfigListWithOffset', 'query', variables);
    },
    esignatureConfigListWithCursor(variables: EsignatureConfigListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureConfigListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureConfigListWithCursorQuery>({ document: EsignatureConfigListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureConfigListWithCursor', 'query', variables);
    },
    esignatureDocumentOne(variables: EsignatureDocumentOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureDocumentOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureDocumentOneQuery>({ document: EsignatureDocumentOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureDocumentOne', 'query', variables);
    },
    esignatureDocumentListWithOffset(variables: EsignatureDocumentListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureDocumentListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureDocumentListWithOffsetQuery>({ document: EsignatureDocumentListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureDocumentListWithOffset', 'query', variables);
    },
    esignatureDocumentListWithCursor(variables: EsignatureDocumentListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureDocumentListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureDocumentListWithCursorQuery>({ document: EsignatureDocumentListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureDocumentListWithCursor', 'query', variables);
    },
    esignatureRecipientOne(variables: EsignatureRecipientOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureRecipientOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureRecipientOneQuery>({ document: EsignatureRecipientOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureRecipientOne', 'query', variables);
    },
    esignatureRecipientListWithOffset(variables: EsignatureRecipientListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureRecipientListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureRecipientListWithOffsetQuery>({ document: EsignatureRecipientListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureRecipientListWithOffset', 'query', variables);
    },
    esignatureRecipientListWithCursor(variables: EsignatureRecipientListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureRecipientListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureRecipientListWithCursorQuery>({ document: EsignatureRecipientListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureRecipientListWithCursor', 'query', variables);
    },
    esignatureWebhookEventOne(variables: EsignatureWebhookEventOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureWebhookEventOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureWebhookEventOneQuery>({ document: EsignatureWebhookEventOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureWebhookEventOne', 'query', variables);
    },
    esignatureWebhookEventListWithOffset(variables: EsignatureWebhookEventListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureWebhookEventListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureWebhookEventListWithOffsetQuery>({ document: EsignatureWebhookEventListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureWebhookEventListWithOffset', 'query', variables);
    },
    esignatureWebhookEventListWithCursor(variables: EsignatureWebhookEventListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EsignatureWebhookEventListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EsignatureWebhookEventListWithCursorQuery>({ document: EsignatureWebhookEventListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'esignatureWebhookEventListWithCursor', 'query', variables);
    },
    evaluationQueryCreate(variables: EvaluationQueryCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EvaluationQueryCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EvaluationQueryCreateMutation>({ document: EvaluationQueryCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'evaluationQueryCreate', 'mutation', variables);
    },
    evaluationQueryUpdate(variables: EvaluationQueryUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EvaluationQueryUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EvaluationQueryUpdateMutation>({ document: EvaluationQueryUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'evaluationQueryUpdate', 'mutation', variables);
    },
    evaluationQueryDelete(variables: EvaluationQueryDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EvaluationQueryDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EvaluationQueryDeleteMutation>({ document: EvaluationQueryDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'evaluationQueryDelete', 'mutation', variables);
    },
    evaluationQueryOne(variables: EvaluationQueryOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EvaluationQueryOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EvaluationQueryOneQuery>({ document: EvaluationQueryOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'evaluationQueryOne', 'query', variables);
    },
    evaluationQueryListWithOffset(variables: EvaluationQueryListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EvaluationQueryListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EvaluationQueryListWithOffsetQuery>({ document: EvaluationQueryListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'evaluationQueryListWithOffset', 'query', variables);
    },
    evaluationQueryListWithCursor(variables: EvaluationQueryListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EvaluationQueryListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EvaluationQueryListWithCursorQuery>({ document: EvaluationQueryListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'evaluationQueryListWithCursor', 'query', variables);
    },
    grossReceiptsStatusCreate(variables: GrossReceiptsStatusCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GrossReceiptsStatusCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrossReceiptsStatusCreateMutation>({ document: GrossReceiptsStatusCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'grossReceiptsStatusCreate', 'mutation', variables);
    },
    grossReceiptsStatusUpdate(variables: GrossReceiptsStatusUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GrossReceiptsStatusUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrossReceiptsStatusUpdateMutation>({ document: GrossReceiptsStatusUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'grossReceiptsStatusUpdate', 'mutation', variables);
    },
    grossReceiptsStatusDelete(variables: GrossReceiptsStatusDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GrossReceiptsStatusDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrossReceiptsStatusDeleteMutation>({ document: GrossReceiptsStatusDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'grossReceiptsStatusDelete', 'mutation', variables);
    },
    grossReceiptsStatusOne(variables: GrossReceiptsStatusOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GrossReceiptsStatusOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrossReceiptsStatusOneQuery>({ document: GrossReceiptsStatusOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'grossReceiptsStatusOne', 'query', variables);
    },
    grossReceiptsStatusListWithOffset(variables: GrossReceiptsStatusListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GrossReceiptsStatusListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrossReceiptsStatusListWithOffsetQuery>({ document: GrossReceiptsStatusListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'grossReceiptsStatusListWithOffset', 'query', variables);
    },
    grossReceiptsStatusListWithCursor(variables: GrossReceiptsStatusListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GrossReceiptsStatusListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GrossReceiptsStatusListWithCursorQuery>({ document: GrossReceiptsStatusListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'grossReceiptsStatusListWithCursor', 'query', variables);
    },
    interpreterCreate(variables: InterpreterCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InterpreterCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InterpreterCreateMutation>({ document: InterpreterCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'interpreterCreate', 'mutation', variables);
    },
    interpreterUpdate(variables: InterpreterUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InterpreterUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InterpreterUpdateMutation>({ document: InterpreterUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'interpreterUpdate', 'mutation', variables);
    },
    interpreterDelete(variables: InterpreterDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InterpreterDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InterpreterDeleteMutation>({ document: InterpreterDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'interpreterDelete', 'mutation', variables);
    },
    interpreterOne(variables: InterpreterOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InterpreterOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InterpreterOneQuery>({ document: InterpreterOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'interpreterOne', 'query', variables);
    },
    interpreterListWithOffset(variables: InterpreterListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InterpreterListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InterpreterListWithOffsetQuery>({ document: InterpreterListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'interpreterListWithOffset', 'query', variables);
    },
    interpreterListWithCursor(variables: InterpreterListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InterpreterListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InterpreterListWithCursorQuery>({ document: InterpreterListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'interpreterListWithCursor', 'query', variables);
    },
    llmProviderCreate(variables: LlmProviderCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LlmProviderCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LlmProviderCreateMutation>({ document: LlmProviderCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'llmProviderCreate', 'mutation', variables);
    },
    llmProviderUpdate(variables: LlmProviderUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LlmProviderUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LlmProviderUpdateMutation>({ document: LlmProviderUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'llmProviderUpdate', 'mutation', variables);
    },
    llmProviderDelete(variables: LlmProviderDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LlmProviderDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LlmProviderDeleteMutation>({ document: LlmProviderDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'llmProviderDelete', 'mutation', variables);
    },
    llmProviderOne(variables: LlmProviderOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LlmProviderOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LlmProviderOneQuery>({ document: LlmProviderOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'llmProviderOne', 'query', variables);
    },
    llmProviderListWithOffset(variables: LlmProviderListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LlmProviderListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LlmProviderListWithOffsetQuery>({ document: LlmProviderListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'llmProviderListWithOffset', 'query', variables);
    },
    llmProviderListWithCursor(variables: LlmProviderListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LlmProviderListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LlmProviderListWithCursorQuery>({ document: LlmProviderListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'llmProviderListWithCursor', 'query', variables);
    },
    musicalGenreCreate(variables: MusicalGenreCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalGenreCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalGenreCreateMutation>({ document: MusicalGenreCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalGenreCreate', 'mutation', variables);
    },
    musicalGenreUpdate(variables: MusicalGenreUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalGenreUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalGenreUpdateMutation>({ document: MusicalGenreUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalGenreUpdate', 'mutation', variables);
    },
    musicalGenreDelete(variables: MusicalGenreDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalGenreDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalGenreDeleteMutation>({ document: MusicalGenreDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalGenreDelete', 'mutation', variables);
    },
    musicalGenreOne(variables: MusicalGenreOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalGenreOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalGenreOneQuery>({ document: MusicalGenreOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalGenreOne', 'query', variables);
    },
    musicalGenreListWithOffset(variables: MusicalGenreListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalGenreListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalGenreListWithOffsetQuery>({ document: MusicalGenreListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalGenreListWithOffset', 'query', variables);
    },
    musicalGenreListWithCursor(variables: MusicalGenreListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalGenreListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalGenreListWithCursorQuery>({ document: MusicalGenreListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalGenreListWithCursor', 'query', variables);
    },
    musicalWorkCreate(variables: MusicalWorkCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkCreateMutation>({ document: MusicalWorkCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkCreate', 'mutation', variables);
    },
    musicalWorkUpdate(variables: MusicalWorkUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkUpdateMutation>({ document: MusicalWorkUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkUpdate', 'mutation', variables);
    },
    musicalWorkDelete(variables: MusicalWorkDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkDeleteMutation>({ document: MusicalWorkDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkDelete', 'mutation', variables);
    },
    musicalWorkOne(variables: MusicalWorkOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkOneQuery>({ document: MusicalWorkOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkOne', 'query', variables);
    },
    musicalWorkListWithOffset(variables: MusicalWorkListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkListWithOffsetQuery>({ document: MusicalWorkListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkListWithOffset', 'query', variables);
    },
    musicalWorkListWithCursor(variables: MusicalWorkListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkListWithCursorQuery>({ document: MusicalWorkListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkListWithCursor', 'query', variables);
    },
    musicalWorkLinkOne(variables: MusicalWorkLinkOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkLinkOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkLinkOneQuery>({ document: MusicalWorkLinkOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkLinkOne', 'query', variables);
    },
    musicalWorkLinkListWithOffset(variables: MusicalWorkLinkListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkLinkListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkLinkListWithOffsetQuery>({ document: MusicalWorkLinkListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkLinkListWithOffset', 'query', variables);
    },
    musicalWorkLinkListWithCursor(variables: MusicalWorkLinkListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MusicalWorkLinkListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MusicalWorkLinkListWithCursorQuery>({ document: MusicalWorkLinkListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'musicalWorkLinkListWithCursor', 'query', variables);
    },
    paymentReceiptCreate(variables: PaymentReceiptCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptCreateMutation>({ document: PaymentReceiptCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptCreate', 'mutation', variables);
    },
    paymentReceiptBatchCreate(variables: PaymentReceiptBatchCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptBatchCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptBatchCreateMutation>({ document: PaymentReceiptBatchCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptBatchCreate', 'mutation', variables);
    },
    paymentReceiptUpdate(variables: PaymentReceiptUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptUpdateMutation>({ document: PaymentReceiptUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptUpdate', 'mutation', variables);
    },
    paymentReceiptDelete(variables: PaymentReceiptDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptDeleteMutation>({ document: PaymentReceiptDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptDelete', 'mutation', variables);
    },
    paymentReceiptOne(variables: PaymentReceiptOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptOneQuery>({ document: PaymentReceiptOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptOne', 'query', variables);
    },
    paymentReceiptListWithOffset(variables: PaymentReceiptListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptListWithOffsetQuery>({ document: PaymentReceiptListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptListWithOffset', 'query', variables);
    },
    paymentReceiptListWithCursor(variables: PaymentReceiptListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptListWithCursorQuery>({ document: PaymentReceiptListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptListWithCursor', 'query', variables);
    },
    paymentReceiptTypeCreate(variables: PaymentReceiptTypeCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptTypeCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptTypeCreateMutation>({ document: PaymentReceiptTypeCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptTypeCreate', 'mutation', variables);
    },
    paymentReceiptTypeUpdate(variables: PaymentReceiptTypeUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptTypeUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptTypeUpdateMutation>({ document: PaymentReceiptTypeUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptTypeUpdate', 'mutation', variables);
    },
    paymentReceiptTypeDelete(variables: PaymentReceiptTypeDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptTypeDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptTypeDeleteMutation>({ document: PaymentReceiptTypeDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptTypeDelete', 'mutation', variables);
    },
    paymentReceiptTypeOne(variables: PaymentReceiptTypeOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptTypeOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptTypeOneQuery>({ document: PaymentReceiptTypeOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptTypeOne', 'query', variables);
    },
    paymentReceiptTypeListWithOffset(variables: PaymentReceiptTypeListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptTypeListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptTypeListWithOffsetQuery>({ document: PaymentReceiptTypeListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptTypeListWithOffset', 'query', variables);
    },
    paymentReceiptTypeListWithCursor(variables: PaymentReceiptTypeListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptTypeListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptTypeListWithCursorQuery>({ document: PaymentReceiptTypeListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptTypeListWithCursor', 'query', variables);
    },
    paymentReceiptUseOne(variables: PaymentReceiptUseOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptUseOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptUseOneQuery>({ document: PaymentReceiptUseOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptUseOne', 'query', variables);
    },
    paymentReceiptUseListWithOffset(variables: PaymentReceiptUseListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptUseListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptUseListWithOffsetQuery>({ document: PaymentReceiptUseListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptUseListWithOffset', 'query', variables);
    },
    paymentReceiptUseListWithCursor(variables: PaymentReceiptUseListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PaymentReceiptUseListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentReceiptUseListWithCursorQuery>({ document: PaymentReceiptUseListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentReceiptUseListWithCursor', 'query', variables);
    },
    permissionCreate(variables: PermissionCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PermissionCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PermissionCreateMutation>({ document: PermissionCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'permissionCreate', 'mutation', variables);
    },
    permissionUpdate(variables: PermissionUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PermissionUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PermissionUpdateMutation>({ document: PermissionUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'permissionUpdate', 'mutation', variables);
    },
    permissionDelete(variables: PermissionDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PermissionDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PermissionDeleteMutation>({ document: PermissionDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'permissionDelete', 'mutation', variables);
    },
    permissionOne(variables: PermissionOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PermissionOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PermissionOneQuery>({ document: PermissionOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'permissionOne', 'query', variables);
    },
    permissionListWithOffset(variables: PermissionListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PermissionListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PermissionListWithOffsetQuery>({ document: PermissionListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'permissionListWithOffset', 'query', variables);
    },
    permissionListWithCursor(variables: PermissionListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PermissionListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PermissionListWithCursorQuery>({ document: PermissionListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'permissionListWithCursor', 'query', variables);
    },
    phonogramOne(variables: PhonogramOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PhonogramOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PhonogramOneQuery>({ document: PhonogramOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'phonogramOne', 'query', variables);
    },
    phonogramListWithOffset(variables: PhonogramListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PhonogramListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PhonogramListWithOffsetQuery>({ document: PhonogramListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'phonogramListWithOffset', 'query', variables);
    },
    phonogramListWithCursor(variables: PhonogramListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PhonogramListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PhonogramListWithCursorQuery>({ document: PhonogramListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'phonogramListWithCursor', 'query', variables);
    },
    platformCreate(variables: PlatformCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformCreateMutation>({ document: PlatformCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformCreate', 'mutation', variables);
    },
    platformUpdate(variables: PlatformUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformUpdateMutation>({ document: PlatformUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformUpdate', 'mutation', variables);
    },
    platformDelete(variables: PlatformDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformDeleteMutation>({ document: PlatformDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformDelete', 'mutation', variables);
    },
    platformOne(variables: PlatformOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformOneQuery>({ document: PlatformOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformOne', 'query', variables);
    },
    platformListWithOffset(variables: PlatformListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformListWithOffsetQuery>({ document: PlatformListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformListWithOffset', 'query', variables);
    },
    platformListWithCursor(variables: PlatformListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformListWithCursorQuery>({ document: PlatformListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformListWithCursor', 'query', variables);
    },
    platformLinkTypeCreate(variables: PlatformLinkTypeCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformLinkTypeCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformLinkTypeCreateMutation>({ document: PlatformLinkTypeCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformLinkTypeCreate', 'mutation', variables);
    },
    platformLinkTypeUpdate(variables: PlatformLinkTypeUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformLinkTypeUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformLinkTypeUpdateMutation>({ document: PlatformLinkTypeUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformLinkTypeUpdate', 'mutation', variables);
    },
    platformLinkTypeDelete(variables: PlatformLinkTypeDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformLinkTypeDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformLinkTypeDeleteMutation>({ document: PlatformLinkTypeDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformLinkTypeDelete', 'mutation', variables);
    },
    platformLinkTypeOne(variables: PlatformLinkTypeOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformLinkTypeOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformLinkTypeOneQuery>({ document: PlatformLinkTypeOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformLinkTypeOne', 'query', variables);
    },
    platformLinkTypeListWithOffset(variables: PlatformLinkTypeListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformLinkTypeListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformLinkTypeListWithOffsetQuery>({ document: PlatformLinkTypeListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformLinkTypeListWithOffset', 'query', variables);
    },
    platformLinkTypeListWithCursor(variables: PlatformLinkTypeListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformLinkTypeListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformLinkTypeListWithCursorQuery>({ document: PlatformLinkTypeListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'platformLinkTypeListWithCursor', 'query', variables);
    },
    provinceStateCreate(variables: ProvinceStateCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProvinceStateCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProvinceStateCreateMutation>({ document: ProvinceStateCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'provinceStateCreate', 'mutation', variables);
    },
    provinceStateUpdate(variables: ProvinceStateUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProvinceStateUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProvinceStateUpdateMutation>({ document: ProvinceStateUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'provinceStateUpdate', 'mutation', variables);
    },
    provinceStateDelete(variables: ProvinceStateDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProvinceStateDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProvinceStateDeleteMutation>({ document: ProvinceStateDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'provinceStateDelete', 'mutation', variables);
    },
    provinceStateOne(variables: ProvinceStateOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProvinceStateOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProvinceStateOneQuery>({ document: ProvinceStateOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'provinceStateOne', 'query', variables);
    },
    provinceStateListWithOffset(variables: ProvinceStateListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProvinceStateListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProvinceStateListWithOffsetQuery>({ document: ProvinceStateListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'provinceStateListWithOffset', 'query', variables);
    },
    provinceStateListWithCursor(variables: ProvinceStateListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProvinceStateListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProvinceStateListWithCursorQuery>({ document: ProvinceStateListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'provinceStateListWithCursor', 'query', variables);
    },
    publisherCreate(variables: PublisherCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherCreateMutation>({ document: PublisherCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherCreate', 'mutation', variables);
    },
    publisherUpdate(variables: PublisherUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherUpdateMutation>({ document: PublisherUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherUpdate', 'mutation', variables);
    },
    publisherDelete(variables: PublisherDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherDeleteMutation>({ document: PublisherDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherDelete', 'mutation', variables);
    },
    publisherOne(variables: PublisherOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherOneQuery>({ document: PublisherOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherOne', 'query', variables);
    },
    publisherListWithOffset(variables: PublisherListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherListWithOffsetQuery>({ document: PublisherListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherListWithOffset', 'query', variables);
    },
    publisherListWithCursor(variables: PublisherListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherListWithCursorQuery>({ document: PublisherListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherListWithCursor', 'query', variables);
    },
    publisherCollectingSocietyOne(variables: PublisherCollectingSocietyOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherCollectingSocietyOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherCollectingSocietyOneQuery>({ document: PublisherCollectingSocietyOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherCollectingSocietyOne', 'query', variables);
    },
    publisherCollectingSocietyListWithOffset(variables: PublisherCollectingSocietyListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherCollectingSocietyListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherCollectingSocietyListWithOffsetQuery>({ document: PublisherCollectingSocietyListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherCollectingSocietyListWithOffset', 'query', variables);
    },
    publisherCollectingSocietyListWithCursor(variables: PublisherCollectingSocietyListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherCollectingSocietyListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherCollectingSocietyListWithCursorQuery>({ document: PublisherCollectingSocietyListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherCollectingSocietyListWithCursor', 'query', variables);
    },
    publisherRepresentativeOne(variables: PublisherRepresentativeOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherRepresentativeOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherRepresentativeOneQuery>({ document: PublisherRepresentativeOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherRepresentativeOne', 'query', variables);
    },
    publisherRepresentativeListWithOffset(variables: PublisherRepresentativeListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherRepresentativeListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherRepresentativeListWithOffsetQuery>({ document: PublisherRepresentativeListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherRepresentativeListWithOffset', 'query', variables);
    },
    publisherRepresentativeListWithCursor(variables: PublisherRepresentativeListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublisherRepresentativeListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublisherRepresentativeListWithCursorQuery>({ document: PublisherRepresentativeListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'publisherRepresentativeListWithCursor', 'query', variables);
    },
    queryPatternCreate(variables: QueryPatternCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QueryPatternCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryPatternCreateMutation>({ document: QueryPatternCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'queryPatternCreate', 'mutation', variables);
    },
    queryPatternUpdate(variables: QueryPatternUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QueryPatternUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryPatternUpdateMutation>({ document: QueryPatternUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'queryPatternUpdate', 'mutation', variables);
    },
    queryPatternDelete(variables: QueryPatternDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QueryPatternDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryPatternDeleteMutation>({ document: QueryPatternDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'queryPatternDelete', 'mutation', variables);
    },
    queryPatternOne(variables: QueryPatternOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QueryPatternOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryPatternOneQuery>({ document: QueryPatternOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'queryPatternOne', 'query', variables);
    },
    queryPatternListWithOffset(variables: QueryPatternListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QueryPatternListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryPatternListWithOffsetQuery>({ document: QueryPatternListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'queryPatternListWithOffset', 'query', variables);
    },
    queryPatternListWithCursor(variables: QueryPatternListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QueryPatternListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryPatternListWithCursorQuery>({ document: QueryPatternListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'queryPatternListWithCursor', 'query', variables);
    },
    reportCreate(variables: ReportCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportCreateMutation>({ document: ReportCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportCreate', 'mutation', variables);
    },
    reportUpdate(variables: ReportUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportUpdateMutation>({ document: ReportUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportUpdate', 'mutation', variables);
    },
    reportDelete(variables: ReportDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportDeleteMutation>({ document: ReportDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportDelete', 'mutation', variables);
    },
    reportOne(variables: ReportOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportOneQuery>({ document: ReportOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportOne', 'query', variables);
    },
    reportListWithOffset(variables: ReportListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportListWithOffsetQuery>({ document: ReportListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportListWithOffset', 'query', variables);
    },
    reportListWithCursor(variables: ReportListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportListWithCursorQuery>({ document: ReportListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportListWithCursor', 'query', variables);
    },
    reportTypeCreate(variables: ReportTypeCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportTypeCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportTypeCreateMutation>({ document: ReportTypeCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportTypeCreate', 'mutation', variables);
    },
    reportTypeUpdate(variables: ReportTypeUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportTypeUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportTypeUpdateMutation>({ document: ReportTypeUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportTypeUpdate', 'mutation', variables);
    },
    reportTypeDelete(variables: ReportTypeDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportTypeDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportTypeDeleteMutation>({ document: ReportTypeDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportTypeDelete', 'mutation', variables);
    },
    reportTypeOne(variables: ReportTypeOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportTypeOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportTypeOneQuery>({ document: ReportTypeOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportTypeOne', 'query', variables);
    },
    reportTypeListWithOffset(variables: ReportTypeListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportTypeListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportTypeListWithOffsetQuery>({ document: ReportTypeListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportTypeListWithOffset', 'query', variables);
    },
    reportTypeListWithCursor(variables: ReportTypeListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReportTypeListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportTypeListWithCursorQuery>({ document: ReportTypeListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reportTypeListWithCursor', 'query', variables);
    },
    roleCreate(variables: RoleCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RoleCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleCreateMutation>({ document: RoleCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'roleCreate', 'mutation', variables);
    },
    roleUpdate(variables: RoleUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RoleUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleUpdateMutation>({ document: RoleUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'roleUpdate', 'mutation', variables);
    },
    roleDelete(variables: RoleDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RoleDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleDeleteMutation>({ document: RoleDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'roleDelete', 'mutation', variables);
    },
    roleOne(variables: RoleOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RoleOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleOneQuery>({ document: RoleOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'roleOne', 'query', variables);
    },
    roleListWithOffset(variables: RoleListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RoleListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleListWithOffsetQuery>({ document: RoleListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'roleListWithOffset', 'query', variables);
    },
    roleListWithCursor(variables: RoleListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RoleListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleListWithCursorQuery>({ document: RoleListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'roleListWithCursor', 'query', variables);
    },
    satelliteHeartbeatDelete(variables: SatelliteHeartbeatDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteHeartbeatDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteHeartbeatDeleteMutation>({ document: SatelliteHeartbeatDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteHeartbeatDelete', 'mutation', variables);
    },
    satelliteHeartbeatOne(variables: SatelliteHeartbeatOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteHeartbeatOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteHeartbeatOneQuery>({ document: SatelliteHeartbeatOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteHeartbeatOne', 'query', variables);
    },
    satelliteHeartbeatListWithOffset(variables: SatelliteHeartbeatListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteHeartbeatListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteHeartbeatListWithOffsetQuery>({ document: SatelliteHeartbeatListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteHeartbeatListWithOffset', 'query', variables);
    },
    satelliteHeartbeatListWithCursor(variables: SatelliteHeartbeatListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteHeartbeatListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteHeartbeatListWithCursorQuery>({ document: SatelliteHeartbeatListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteHeartbeatListWithCursor', 'query', variables);
    },
    satelliteMachineCreate(variables: SatelliteMachineCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteMachineCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteMachineCreateMutation>({ document: SatelliteMachineCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteMachineCreate', 'mutation', variables);
    },
    satelliteMachineUpdate(variables: SatelliteMachineUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteMachineUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteMachineUpdateMutation>({ document: SatelliteMachineUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteMachineUpdate', 'mutation', variables);
    },
    satelliteMachineDelete(variables: SatelliteMachineDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteMachineDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteMachineDeleteMutation>({ document: SatelliteMachineDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteMachineDelete', 'mutation', variables);
    },
    satelliteMachineOne(variables: SatelliteMachineOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteMachineOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteMachineOneQuery>({ document: SatelliteMachineOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteMachineOne', 'query', variables);
    },
    satelliteMachineListWithOffset(variables: SatelliteMachineListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteMachineListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteMachineListWithOffsetQuery>({ document: SatelliteMachineListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteMachineListWithOffset', 'query', variables);
    },
    satelliteMachineListWithCursor(variables: SatelliteMachineListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteMachineListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteMachineListWithCursorQuery>({ document: SatelliteMachineListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteMachineListWithCursor', 'query', variables);
    },
    authorizeSatellite(variables: AuthorizeSatelliteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AuthorizeSatelliteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorizeSatelliteMutation>({ document: AuthorizeSatelliteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'authorizeSatellite', 'mutation', variables);
    },
    suspendSatellite(variables: SuspendSatelliteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuspendSatelliteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuspendSatelliteMutation>({ document: SuspendSatelliteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'suspendSatellite', 'mutation', variables);
    },
    reactivateSatellite(variables: ReactivateSatelliteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReactivateSatelliteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReactivateSatelliteMutation>({ document: ReactivateSatelliteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'reactivateSatellite', 'mutation', variables);
    },
    revokeSatellite(variables: RevokeSatelliteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RevokeSatelliteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokeSatelliteMutation>({ document: RevokeSatelliteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'revokeSatellite', 'mutation', variables);
    },
    setSatelliteEnabled(variables: SetSatelliteEnabledMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetSatelliteEnabledMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetSatelliteEnabledMutation>({ document: SetSatelliteEnabledDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'setSatelliteEnabled', 'mutation', variables);
    },
    rotateSatelliteToken(variables: RotateSatelliteTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RotateSatelliteTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RotateSatelliteTokenMutation>({ document: RotateSatelliteTokenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'rotateSatelliteToken', 'mutation', variables);
    },
    disconnectSatellite(variables: DisconnectSatelliteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DisconnectSatelliteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DisconnectSatelliteMutation>({ document: DisconnectSatelliteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'disconnectSatellite', 'mutation', variables);
    },
    satelliteConnectionInfo(variables: SatelliteConnectionInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteConnectionInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteConnectionInfoQuery>({ document: SatelliteConnectionInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteConnectionInfo', 'query', variables);
    },
    connectedSatellites(variables?: ConnectedSatellitesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConnectedSatellitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConnectedSatellitesQuery>({ document: ConnectedSatellitesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'connectedSatellites', 'query', variables);
    },
    satelliteTaskOne(variables: SatelliteTaskOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteTaskOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteTaskOneQuery>({ document: SatelliteTaskOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteTaskOne', 'query', variables);
    },
    satelliteTaskListWithOffset(variables: SatelliteTaskListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteTaskListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteTaskListWithOffsetQuery>({ document: SatelliteTaskListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteTaskListWithOffset', 'query', variables);
    },
    satelliteTaskListWithCursor(variables: SatelliteTaskListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SatelliteTaskListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SatelliteTaskListWithCursorQuery>({ document: SatelliteTaskListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'satelliteTaskListWithCursor', 'query', variables);
    },
    showcaseCategoryCreate(variables: ShowcaseCategoryCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseCategoryCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseCategoryCreateMutation>({ document: ShowcaseCategoryCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseCategoryCreate', 'mutation', variables);
    },
    showcaseCategoryUpdate(variables: ShowcaseCategoryUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseCategoryUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseCategoryUpdateMutation>({ document: ShowcaseCategoryUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseCategoryUpdate', 'mutation', variables);
    },
    showcaseCategoryDelete(variables: ShowcaseCategoryDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseCategoryDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseCategoryDeleteMutation>({ document: ShowcaseCategoryDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseCategoryDelete', 'mutation', variables);
    },
    showcaseCategoryOne(variables: ShowcaseCategoryOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseCategoryOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseCategoryOneQuery>({ document: ShowcaseCategoryOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseCategoryOne', 'query', variables);
    },
    showcaseCategoryListWithOffset(variables: ShowcaseCategoryListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseCategoryListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseCategoryListWithOffsetQuery>({ document: ShowcaseCategoryListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseCategoryListWithOffset', 'query', variables);
    },
    showcaseCategoryListWithCursor(variables: ShowcaseCategoryListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseCategoryListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseCategoryListWithCursorQuery>({ document: ShowcaseCategoryListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseCategoryListWithCursor', 'query', variables);
    },
    showcaseLineOne(variables: ShowcaseLineOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseLineOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseLineOneQuery>({ document: ShowcaseLineOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseLineOne', 'query', variables);
    },
    showcaseLineListWithOffset(variables: ShowcaseLineListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseLineListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseLineListWithOffsetQuery>({ document: ShowcaseLineListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseLineListWithOffset', 'query', variables);
    },
    showcaseLineListWithCursor(variables: ShowcaseLineListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseLineListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseLineListWithCursorQuery>({ document: ShowcaseLineListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseLineListWithCursor', 'query', variables);
    },
    showcaseWorkflowStateCreate(variables: ShowcaseWorkflowStateCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflowStateCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflowStateCreateMutation>({ document: ShowcaseWorkflowStateCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflowStateCreate', 'mutation', variables);
    },
    showcaseWorkflowStateUpdate(variables: ShowcaseWorkflowStateUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflowStateUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflowStateUpdateMutation>({ document: ShowcaseWorkflowStateUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflowStateUpdate', 'mutation', variables);
    },
    showcaseWorkflowStateDelete(variables: ShowcaseWorkflowStateDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflowStateDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflowStateDeleteMutation>({ document: ShowcaseWorkflowStateDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflowStateDelete', 'mutation', variables);
    },
    showcaseWorkflowStateOne(variables: ShowcaseWorkflowStateOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflowStateOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflowStateOneQuery>({ document: ShowcaseWorkflowStateOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflowStateOne', 'query', variables);
    },
    showcaseWorkflowStateListWithOffset(variables: ShowcaseWorkflowStateListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflowStateListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflowStateListWithOffsetQuery>({ document: ShowcaseWorkflowStateListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflowStateListWithOffset', 'query', variables);
    },
    showcaseWorkflowStateListWithCursor(variables: ShowcaseWorkflowStateListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflowStateListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflowStateListWithCursorQuery>({ document: ShowcaseWorkflowStateListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflowStateListWithCursor', 'query', variables);
    },
    signedContractOne(variables: SignedContractOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedContractOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedContractOneQuery>({ document: SignedContractOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedContractOne', 'query', variables);
    },
    signedContractListWithOffset(variables: SignedContractListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedContractListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedContractListWithOffsetQuery>({ document: SignedContractListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedContractListWithOffset', 'query', variables);
    },
    signedContractListWithCursor(variables: SignedContractListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedContractListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedContractListWithCursorQuery>({ document: SignedContractListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedContractListWithCursor', 'query', variables);
    },
    signedEditionOne(variables: SignedEditionOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionOneQuery>({ document: SignedEditionOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionOne', 'query', variables);
    },
    signedEditionListWithOffset(variables: SignedEditionListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionListWithOffsetQuery>({ document: SignedEditionListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionListWithOffset', 'query', variables);
    },
    signedEditionListWithCursor(variables: SignedEditionListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionListWithCursorQuery>({ document: SignedEditionListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionListWithCursor', 'query', variables);
    },
    signedEditionBlockchainCertOne(variables: SignedEditionBlockchainCertOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionBlockchainCertOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionBlockchainCertOneQuery>({ document: SignedEditionBlockchainCertOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionBlockchainCertOne', 'query', variables);
    },
    signedEditionBlockchainCertListWithOffset(variables: SignedEditionBlockchainCertListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionBlockchainCertListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionBlockchainCertListWithOffsetQuery>({ document: SignedEditionBlockchainCertListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionBlockchainCertListWithOffset', 'query', variables);
    },
    signedEditionBlockchainCertListWithCursor(variables: SignedEditionBlockchainCertListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionBlockchainCertListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionBlockchainCertListWithCursorQuery>({ document: SignedEditionBlockchainCertListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionBlockchainCertListWithCursor', 'query', variables);
    },
    signedEditionDndaWorkflowStateCreate(variables: SignedEditionDndaWorkflowStateCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflowStateCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflowStateCreateMutation>({ document: SignedEditionDndaWorkflowStateCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflowStateCreate', 'mutation', variables);
    },
    signedEditionDndaWorkflowStateUpdate(variables: SignedEditionDndaWorkflowStateUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflowStateUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflowStateUpdateMutation>({ document: SignedEditionDndaWorkflowStateUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflowStateUpdate', 'mutation', variables);
    },
    signedEditionDndaWorkflowStateDelete(variables: SignedEditionDndaWorkflowStateDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflowStateDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflowStateDeleteMutation>({ document: SignedEditionDndaWorkflowStateDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflowStateDelete', 'mutation', variables);
    },
    signedEditionDndaWorkflowStateOne(variables: SignedEditionDndaWorkflowStateOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflowStateOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflowStateOneQuery>({ document: SignedEditionDndaWorkflowStateOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflowStateOne', 'query', variables);
    },
    signedEditionDndaWorkflowStateListWithOffset(variables: SignedEditionDndaWorkflowStateListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflowStateListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflowStateListWithOffsetQuery>({ document: SignedEditionDndaWorkflowStateListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflowStateListWithOffset', 'query', variables);
    },
    signedEditionDndaWorkflowStateListWithCursor(variables: SignedEditionDndaWorkflowStateListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflowStateListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflowStateListWithCursorQuery>({ document: SignedEditionDndaWorkflowStateListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflowStateListWithCursor', 'query', variables);
    },
    signedEditionSadaicWorkflowStateCreate(variables: SignedEditionSadaicWorkflowStateCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionSadaicWorkflowStateCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionSadaicWorkflowStateCreateMutation>({ document: SignedEditionSadaicWorkflowStateCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionSadaicWorkflowStateCreate', 'mutation', variables);
    },
    signedEditionSadaicWorkflowStateUpdate(variables: SignedEditionSadaicWorkflowStateUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionSadaicWorkflowStateUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionSadaicWorkflowStateUpdateMutation>({ document: SignedEditionSadaicWorkflowStateUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionSadaicWorkflowStateUpdate', 'mutation', variables);
    },
    signedEditionSadaicWorkflowStateDelete(variables: SignedEditionSadaicWorkflowStateDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionSadaicWorkflowStateDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionSadaicWorkflowStateDeleteMutation>({ document: SignedEditionSadaicWorkflowStateDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionSadaicWorkflowStateDelete', 'mutation', variables);
    },
    signedEditionSadaicWorkflowStateOne(variables: SignedEditionSadaicWorkflowStateOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionSadaicWorkflowStateOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionSadaicWorkflowStateOneQuery>({ document: SignedEditionSadaicWorkflowStateOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionSadaicWorkflowStateOne', 'query', variables);
    },
    signedEditionSadaicWorkflowStateListWithOffset(variables: SignedEditionSadaicWorkflowStateListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionSadaicWorkflowStateListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionSadaicWorkflowStateListWithOffsetQuery>({ document: SignedEditionSadaicWorkflowStateListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionSadaicWorkflowStateListWithOffset', 'query', variables);
    },
    signedEditionSadaicWorkflowStateListWithCursor(variables: SignedEditionSadaicWorkflowStateListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionSadaicWorkflowStateListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionSadaicWorkflowStateListWithCursorQuery>({ document: SignedEditionSadaicWorkflowStateListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionSadaicWorkflowStateListWithCursor', 'query', variables);
    },
    simulationSessionDelete(variables: SimulationSessionDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimulationSessionDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimulationSessionDeleteMutation>({ document: SimulationSessionDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simulationSessionDelete', 'mutation', variables);
    },
    simulationSessionOne(variables: SimulationSessionOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimulationSessionOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimulationSessionOneQuery>({ document: SimulationSessionOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simulationSessionOne', 'query', variables);
    },
    simulationSessionListWithOffset(variables: SimulationSessionListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimulationSessionListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimulationSessionListWithOffsetQuery>({ document: SimulationSessionListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simulationSessionListWithOffset', 'query', variables);
    },
    simulationSessionListWithCursor(variables: SimulationSessionListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimulationSessionListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimulationSessionListWithCursorQuery>({ document: SimulationSessionListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simulationSessionListWithCursor', 'query', variables);
    },
    snapshotOverrideCreate(variables: SnapshotOverrideCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SnapshotOverrideCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SnapshotOverrideCreateMutation>({ document: SnapshotOverrideCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'snapshotOverrideCreate', 'mutation', variables);
    },
    snapshotOverrideUpdate(variables: SnapshotOverrideUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SnapshotOverrideUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SnapshotOverrideUpdateMutation>({ document: SnapshotOverrideUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'snapshotOverrideUpdate', 'mutation', variables);
    },
    snapshotOverrideDelete(variables: SnapshotOverrideDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SnapshotOverrideDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SnapshotOverrideDeleteMutation>({ document: SnapshotOverrideDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'snapshotOverrideDelete', 'mutation', variables);
    },
    snapshotOverrideOne(variables: SnapshotOverrideOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SnapshotOverrideOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SnapshotOverrideOneQuery>({ document: SnapshotOverrideOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'snapshotOverrideOne', 'query', variables);
    },
    snapshotOverrideListWithOffset(variables: SnapshotOverrideListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SnapshotOverrideListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SnapshotOverrideListWithOffsetQuery>({ document: SnapshotOverrideListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'snapshotOverrideListWithOffset', 'query', variables);
    },
    snapshotOverrideListWithCursor(variables: SnapshotOverrideListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SnapshotOverrideListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SnapshotOverrideListWithCursorQuery>({ document: SnapshotOverrideListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'snapshotOverrideListWithCursor', 'query', variables);
    },
    tadManagerConfigUpdate(variables: TadManagerConfigUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TadManagerConfigUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TadManagerConfigUpdateMutation>({ document: TadManagerConfigUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tadManagerConfigUpdate', 'mutation', variables);
    },
    tadManagerConfigOne(variables: TadManagerConfigOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TadManagerConfigOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TadManagerConfigOneQuery>({ document: TadManagerConfigOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tadManagerConfigOne', 'query', variables);
    },
    tadManagerConfigListWithOffset(variables: TadManagerConfigListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TadManagerConfigListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TadManagerConfigListWithOffsetQuery>({ document: TadManagerConfigListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tadManagerConfigListWithOffset', 'query', variables);
    },
    tadManagerConfigListWithCursor(variables: TadManagerConfigListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TadManagerConfigListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TadManagerConfigListWithCursorQuery>({ document: TadManagerConfigListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tadManagerConfigListWithCursor', 'query', variables);
    },
    tenantCreate(variables: TenantCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantCreateMutation>({ document: TenantCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantCreate', 'mutation', variables);
    },
    tenantUpdate(variables: TenantUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantUpdateMutation>({ document: TenantUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantUpdate', 'mutation', variables);
    },
    tenantDelete(variables: TenantDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDeleteMutation>({ document: TenantDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantDelete', 'mutation', variables);
    },
    tenantOne(variables: TenantOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantOneQuery>({ document: TenantOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantOne', 'query', variables);
    },
    tenantListWithOffset(variables: TenantListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantListWithOffsetQuery>({ document: TenantListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantListWithOffset', 'query', variables);
    },
    tenantListWithCursor(variables: TenantListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantListWithCursorQuery>({ document: TenantListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantListWithCursor', 'query', variables);
    },
    tenantDocumentCreate(variables: TenantDocumentCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDocumentCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDocumentCreateMutation>({ document: TenantDocumentCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantDocumentCreate', 'mutation', variables);
    },
    tenantDocumentUpdate(variables: TenantDocumentUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDocumentUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDocumentUpdateMutation>({ document: TenantDocumentUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantDocumentUpdate', 'mutation', variables);
    },
    tenantDocumentDelete(variables: TenantDocumentDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDocumentDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDocumentDeleteMutation>({ document: TenantDocumentDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantDocumentDelete', 'mutation', variables);
    },
    tenantDocumentOne(variables: TenantDocumentOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDocumentOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDocumentOneQuery>({ document: TenantDocumentOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantDocumentOne', 'query', variables);
    },
    tenantDocumentListWithOffset(variables: TenantDocumentListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDocumentListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDocumentListWithOffsetQuery>({ document: TenantDocumentListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantDocumentListWithOffset', 'query', variables);
    },
    tenantDocumentListWithCursor(variables: TenantDocumentListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDocumentListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDocumentListWithCursorQuery>({ document: TenantDocumentListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantDocumentListWithCursor', 'query', variables);
    },
    tenantLlmConfigCreate(variables: TenantLlmConfigCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantLlmConfigCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantLlmConfigCreateMutation>({ document: TenantLlmConfigCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantLlmConfigCreate', 'mutation', variables);
    },
    tenantLlmConfigUpdate(variables: TenantLlmConfigUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantLlmConfigUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantLlmConfigUpdateMutation>({ document: TenantLlmConfigUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantLlmConfigUpdate', 'mutation', variables);
    },
    tenantLlmConfigDelete(variables: TenantLlmConfigDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantLlmConfigDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantLlmConfigDeleteMutation>({ document: TenantLlmConfigDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantLlmConfigDelete', 'mutation', variables);
    },
    tenantLlmConfigOne(variables: TenantLlmConfigOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantLlmConfigOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantLlmConfigOneQuery>({ document: TenantLlmConfigOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantLlmConfigOne', 'query', variables);
    },
    tenantLlmConfigListWithOffset(variables: TenantLlmConfigListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantLlmConfigListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantLlmConfigListWithOffsetQuery>({ document: TenantLlmConfigListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantLlmConfigListWithOffset', 'query', variables);
    },
    tenantLlmConfigListWithCursor(variables: TenantLlmConfigListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantLlmConfigListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantLlmConfigListWithCursorQuery>({ document: TenantLlmConfigListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantLlmConfigListWithCursor', 'query', variables);
    },
    tenantPlanCreate(variables: TenantPlanCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantPlanCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantPlanCreateMutation>({ document: TenantPlanCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantPlanCreate', 'mutation', variables);
    },
    tenantPlanUpdate(variables: TenantPlanUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantPlanUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantPlanUpdateMutation>({ document: TenantPlanUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantPlanUpdate', 'mutation', variables);
    },
    tenantPlanDelete(variables: TenantPlanDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantPlanDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantPlanDeleteMutation>({ document: TenantPlanDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantPlanDelete', 'mutation', variables);
    },
    tenantPlanOne(variables: TenantPlanOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantPlanOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantPlanOneQuery>({ document: TenantPlanOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantPlanOne', 'query', variables);
    },
    tenantPlanListWithOffset(variables: TenantPlanListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantPlanListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantPlanListWithOffsetQuery>({ document: TenantPlanListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantPlanListWithOffset', 'query', variables);
    },
    tenantPlanListWithCursor(variables: TenantPlanListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantPlanListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantPlanListWithCursorQuery>({ document: TenantPlanListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantPlanListWithCursor', 'query', variables);
    },
    tenantProfileCreate(variables?: TenantProfileCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantProfileCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantProfileCreateMutation>({ document: TenantProfileCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantProfileCreate', 'mutation', variables);
    },
    tenantProfileUpdate(variables: TenantProfileUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantProfileUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantProfileUpdateMutation>({ document: TenantProfileUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantProfileUpdate', 'mutation', variables);
    },
    tenantProfileDelete(variables: TenantProfileDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantProfileDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantProfileDeleteMutation>({ document: TenantProfileDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantProfileDelete', 'mutation', variables);
    },
    tenantProfileOne(variables: TenantProfileOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantProfileOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantProfileOneQuery>({ document: TenantProfileOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantProfileOne', 'query', variables);
    },
    tenantProfileListWithOffset(variables: TenantProfileListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantProfileListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantProfileListWithOffsetQuery>({ document: TenantProfileListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantProfileListWithOffset', 'query', variables);
    },
    tenantProfileListWithCursor(variables: TenantProfileListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantProfileListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantProfileListWithCursorQuery>({ document: TenantProfileListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantProfileListWithCursor', 'query', variables);
    },
    tenantStatusCreate(variables: TenantStatusCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStatusCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStatusCreateMutation>({ document: TenantStatusCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStatusCreate', 'mutation', variables);
    },
    tenantStatusUpdate(variables: TenantStatusUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStatusUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStatusUpdateMutation>({ document: TenantStatusUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStatusUpdate', 'mutation', variables);
    },
    tenantStatusDelete(variables: TenantStatusDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStatusDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStatusDeleteMutation>({ document: TenantStatusDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStatusDelete', 'mutation', variables);
    },
    tenantStatusOne(variables: TenantStatusOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStatusOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStatusOneQuery>({ document: TenantStatusOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStatusOne', 'query', variables);
    },
    tenantStatusListWithOffset(variables: TenantStatusListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStatusListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStatusListWithOffsetQuery>({ document: TenantStatusListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStatusListWithOffset', 'query', variables);
    },
    tenantStatusListWithCursor(variables: TenantStatusListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStatusListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStatusListWithCursorQuery>({ document: TenantStatusListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStatusListWithCursor', 'query', variables);
    },
    tenantStorageUsageOne(variables: TenantStorageUsageOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStorageUsageOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStorageUsageOneQuery>({ document: TenantStorageUsageOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStorageUsageOne', 'query', variables);
    },
    tenantStorageUsageListWithOffset(variables: TenantStorageUsageListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStorageUsageListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStorageUsageListWithOffsetQuery>({ document: TenantStorageUsageListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStorageUsageListWithOffset', 'query', variables);
    },
    tenantStorageUsageListWithCursor(variables: TenantStorageUsageListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantStorageUsageListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantStorageUsageListWithCursorQuery>({ document: TenantStorageUsageListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantStorageUsageListWithCursor', 'query', variables);
    },
    tenantTokenUsageOne(variables: TenantTokenUsageOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTokenUsageOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTokenUsageOneQuery>({ document: TenantTokenUsageOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTokenUsageOne', 'query', variables);
    },
    tenantTokenUsageListWithOffset(variables: TenantTokenUsageListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTokenUsageListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTokenUsageListWithOffsetQuery>({ document: TenantTokenUsageListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTokenUsageListWithOffset', 'query', variables);
    },
    tenantTokenUsageListWithCursor(variables: TenantTokenUsageListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTokenUsageListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTokenUsageListWithCursorQuery>({ document: TenantTokenUsageListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTokenUsageListWithCursor', 'query', variables);
    },
    tenantTypeCreate(variables: TenantTypeCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTypeCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTypeCreateMutation>({ document: TenantTypeCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTypeCreate', 'mutation', variables);
    },
    tenantTypeUpdate(variables: TenantTypeUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTypeUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTypeUpdateMutation>({ document: TenantTypeUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTypeUpdate', 'mutation', variables);
    },
    tenantTypeDelete(variables: TenantTypeDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTypeDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTypeDeleteMutation>({ document: TenantTypeDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTypeDelete', 'mutation', variables);
    },
    tenantTypeOne(variables: TenantTypeOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTypeOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTypeOneQuery>({ document: TenantTypeOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTypeOne', 'query', variables);
    },
    tenantTypeListWithOffset(variables: TenantTypeListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTypeListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTypeListWithOffsetQuery>({ document: TenantTypeListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTypeListWithOffset', 'query', variables);
    },
    tenantTypeListWithCursor(variables: TenantTypeListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantTypeListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantTypeListWithCursorQuery>({ document: TenantTypeListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantTypeListWithCursor', 'query', variables);
    },
    tenantWidgetAccessCreate(variables: TenantWidgetAccessCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantWidgetAccessCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantWidgetAccessCreateMutation>({ document: TenantWidgetAccessCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantWidgetAccessCreate', 'mutation', variables);
    },
    tenantWidgetAccessUpdate(variables: TenantWidgetAccessUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantWidgetAccessUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantWidgetAccessUpdateMutation>({ document: TenantWidgetAccessUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantWidgetAccessUpdate', 'mutation', variables);
    },
    tenantWidgetAccessDelete(variables: TenantWidgetAccessDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantWidgetAccessDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantWidgetAccessDeleteMutation>({ document: TenantWidgetAccessDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantWidgetAccessDelete', 'mutation', variables);
    },
    tenantWidgetAccessOne(variables: TenantWidgetAccessOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantWidgetAccessOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantWidgetAccessOneQuery>({ document: TenantWidgetAccessOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantWidgetAccessOne', 'query', variables);
    },
    tenantWidgetAccessListWithOffset(variables: TenantWidgetAccessListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantWidgetAccessListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantWidgetAccessListWithOffsetQuery>({ document: TenantWidgetAccessListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantWidgetAccessListWithOffset', 'query', variables);
    },
    tenantWidgetAccessListWithCursor(variables: TenantWidgetAccessListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantWidgetAccessListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantWidgetAccessListWithCursorQuery>({ document: TenantWidgetAccessListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantWidgetAccessListWithCursor', 'query', variables);
    },
    territoryCreate(variables: TerritoryCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TerritoryCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerritoryCreateMutation>({ document: TerritoryCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'territoryCreate', 'mutation', variables);
    },
    territoryUpdate(variables: TerritoryUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TerritoryUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerritoryUpdateMutation>({ document: TerritoryUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'territoryUpdate', 'mutation', variables);
    },
    territoryDelete(variables: TerritoryDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TerritoryDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerritoryDeleteMutation>({ document: TerritoryDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'territoryDelete', 'mutation', variables);
    },
    territoryOne(variables: TerritoryOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TerritoryOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerritoryOneQuery>({ document: TerritoryOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'territoryOne', 'query', variables);
    },
    territoryListWithOffset(variables: TerritoryListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TerritoryListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerritoryListWithOffsetQuery>({ document: TerritoryListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'territoryListWithOffset', 'query', variables);
    },
    territoryListWithCursor(variables: TerritoryListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TerritoryListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerritoryListWithCursorQuery>({ document: TerritoryListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'territoryListWithCursor', 'query', variables);
    },
    themeOne(variables: ThemeOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ThemeOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThemeOneQuery>({ document: ThemeOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'themeOne', 'query', variables);
    },
    themeListWithOffset(variables: ThemeListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ThemeListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThemeListWithOffsetQuery>({ document: ThemeListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'themeListWithOffset', 'query', variables);
    },
    themeListWithCursor(variables: ThemeListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ThemeListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThemeListWithCursorQuery>({ document: ThemeListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'themeListWithCursor', 'query', variables);
    },
    siteUserCreate(variables: SiteUserCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SiteUserCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SiteUserCreateMutation>({ document: SiteUserCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'siteUserCreate', 'mutation', variables);
    },
    siteUserUpdate(variables: SiteUserUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SiteUserUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SiteUserUpdateMutation>({ document: SiteUserUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'siteUserUpdate', 'mutation', variables);
    },
    siteUserDelete(variables: SiteUserDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SiteUserDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SiteUserDeleteMutation>({ document: SiteUserDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'siteUserDelete', 'mutation', variables);
    },
    siteUserOne(variables: SiteUserOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SiteUserOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SiteUserOneQuery>({ document: SiteUserOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'siteUserOne', 'query', variables);
    },
    siteUserListWithOffset(variables: SiteUserListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SiteUserListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SiteUserListWithOffsetQuery>({ document: SiteUserListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'siteUserListWithOffset', 'query', variables);
    },
    siteUserListWithCursor(variables: SiteUserListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SiteUserListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SiteUserListWithCursorQuery>({ document: SiteUserListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'siteUserListWithCursor', 'query', variables);
    },
    userCreate(variables: UserCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserCreateMutation>({ document: UserCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userCreate', 'mutation', variables);
    },
    userUpdate(variables: UserUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserUpdateMutation>({ document: UserUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userUpdate', 'mutation', variables);
    },
    userDelete(variables: UserDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserDeleteMutation>({ document: UserDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userDelete', 'mutation', variables);
    },
    userOne(variables: UserOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserOneQuery>({ document: UserOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userOne', 'query', variables);
    },
    userListWithOffset(variables: UserListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserListWithOffsetQuery>({ document: UserListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userListWithOffset', 'query', variables);
    },
    userListWithCursor(variables: UserListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserListWithCursorQuery>({ document: UserListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userListWithCursor', 'query', variables);
    },
    userAttachmentEditionOne(variables: UserAttachmentEditionOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserAttachmentEditionOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAttachmentEditionOneQuery>({ document: UserAttachmentEditionOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userAttachmentEditionOne', 'query', variables);
    },
    userAttachmentEditionListWithOffset(variables: UserAttachmentEditionListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserAttachmentEditionListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAttachmentEditionListWithOffsetQuery>({ document: UserAttachmentEditionListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userAttachmentEditionListWithOffset', 'query', variables);
    },
    userAttachmentEditionListWithCursor(variables: UserAttachmentEditionListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserAttachmentEditionListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAttachmentEditionListWithCursorQuery>({ document: UserAttachmentEditionListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userAttachmentEditionListWithCursor', 'query', variables);
    },
    userNotificationDelete(variables: UserNotificationDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationDeleteMutation>({ document: UserNotificationDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationDelete', 'mutation', variables);
    },
    userNotificationOne(variables: UserNotificationOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationOneQuery>({ document: UserNotificationOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationOne', 'query', variables);
    },
    userNotificationListWithOffset(variables: UserNotificationListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationListWithOffsetQuery>({ document: UserNotificationListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationListWithOffset', 'query', variables);
    },
    userNotificationListWithCursor(variables: UserNotificationListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationListWithCursorQuery>({ document: UserNotificationListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationListWithCursor', 'query', variables);
    },
    userNotificationPreferenceCreate(variables: UserNotificationPreferenceCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationPreferenceCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationPreferenceCreateMutation>({ document: UserNotificationPreferenceCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationPreferenceCreate', 'mutation', variables);
    },
    userNotificationPreferenceUpdate(variables: UserNotificationPreferenceUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationPreferenceUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationPreferenceUpdateMutation>({ document: UserNotificationPreferenceUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationPreferenceUpdate', 'mutation', variables);
    },
    userNotificationPreferenceDelete(variables: UserNotificationPreferenceDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationPreferenceDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationPreferenceDeleteMutation>({ document: UserNotificationPreferenceDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationPreferenceDelete', 'mutation', variables);
    },
    userNotificationPreferenceOne(variables: UserNotificationPreferenceOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationPreferenceOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationPreferenceOneQuery>({ document: UserNotificationPreferenceOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationPreferenceOne', 'query', variables);
    },
    userNotificationPreferenceListWithOffset(variables: UserNotificationPreferenceListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationPreferenceListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationPreferenceListWithOffsetQuery>({ document: UserNotificationPreferenceListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationPreferenceListWithOffset', 'query', variables);
    },
    userNotificationPreferenceListWithCursor(variables: UserNotificationPreferenceListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserNotificationPreferenceListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserNotificationPreferenceListWithCursorQuery>({ document: UserNotificationPreferenceListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userNotificationPreferenceListWithCursor', 'query', variables);
    },
    userWidgetConfigCreate(variables: UserWidgetConfigCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserWidgetConfigCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserWidgetConfigCreateMutation>({ document: UserWidgetConfigCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userWidgetConfigCreate', 'mutation', variables);
    },
    userWidgetConfigUpdate(variables: UserWidgetConfigUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserWidgetConfigUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserWidgetConfigUpdateMutation>({ document: UserWidgetConfigUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userWidgetConfigUpdate', 'mutation', variables);
    },
    userWidgetConfigDelete(variables: UserWidgetConfigDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserWidgetConfigDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserWidgetConfigDeleteMutation>({ document: UserWidgetConfigDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userWidgetConfigDelete', 'mutation', variables);
    },
    userWidgetConfigOne(variables: UserWidgetConfigOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserWidgetConfigOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserWidgetConfigOneQuery>({ document: UserWidgetConfigOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userWidgetConfigOne', 'query', variables);
    },
    userWidgetConfigListWithOffset(variables: UserWidgetConfigListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserWidgetConfigListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserWidgetConfigListWithOffsetQuery>({ document: UserWidgetConfigListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userWidgetConfigListWithOffset', 'query', variables);
    },
    userWidgetConfigListWithCursor(variables: UserWidgetConfigListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserWidgetConfigListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserWidgetConfigListWithCursorQuery>({ document: UserWidgetConfigListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'userWidgetConfigListWithCursor', 'query', variables);
    },
    vatStatusCreate(variables: VatStatusCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VatStatusCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VatStatusCreateMutation>({ document: VatStatusCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'vatStatusCreate', 'mutation', variables);
    },
    vatStatusUpdate(variables: VatStatusUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VatStatusUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VatStatusUpdateMutation>({ document: VatStatusUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'vatStatusUpdate', 'mutation', variables);
    },
    vatStatusDelete(variables: VatStatusDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VatStatusDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VatStatusDeleteMutation>({ document: VatStatusDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'vatStatusDelete', 'mutation', variables);
    },
    vatStatusOne(variables: VatStatusOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VatStatusOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VatStatusOneQuery>({ document: VatStatusOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'vatStatusOne', 'query', variables);
    },
    vatStatusListWithOffset(variables: VatStatusListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VatStatusListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VatStatusListWithOffsetQuery>({ document: VatStatusListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'vatStatusListWithOffset', 'query', variables);
    },
    vatStatusListWithCursor(variables: VatStatusListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VatStatusListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VatStatusListWithCursorQuery>({ document: VatStatusListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'vatStatusListWithCursor', 'query', variables);
    },
    workAuthorOne(variables: WorkAuthorOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkAuthorOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkAuthorOneQuery>({ document: WorkAuthorOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workAuthorOne', 'query', variables);
    },
    workAuthorListWithOffset(variables: WorkAuthorListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkAuthorListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkAuthorListWithOffsetQuery>({ document: WorkAuthorListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workAuthorListWithOffset', 'query', variables);
    },
    workAuthorListWithCursor(variables: WorkAuthorListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkAuthorListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkAuthorListWithCursorQuery>({ document: WorkAuthorListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workAuthorListWithCursor', 'query', variables);
    },
    workAuthorPublisherOne(variables: WorkAuthorPublisherOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkAuthorPublisherOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkAuthorPublisherOneQuery>({ document: WorkAuthorPublisherOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workAuthorPublisherOne', 'query', variables);
    },
    workAuthorPublisherListWithOffset(variables: WorkAuthorPublisherListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkAuthorPublisherListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkAuthorPublisherListWithOffsetQuery>({ document: WorkAuthorPublisherListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workAuthorPublisherListWithOffset', 'query', variables);
    },
    workAuthorPublisherListWithCursor(variables: WorkAuthorPublisherListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkAuthorPublisherListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkAuthorPublisherListWithCursorQuery>({ document: WorkAuthorPublisherListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workAuthorPublisherListWithCursor', 'query', variables);
    },
    workerEventDelete(variables: WorkerEventDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkerEventDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkerEventDeleteMutation>({ document: WorkerEventDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workerEventDelete', 'mutation', variables);
    },
    workerEventOne(variables: WorkerEventOneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkerEventOneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkerEventOneQuery>({ document: WorkerEventOneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workerEventOne', 'query', variables);
    },
    workerEventListWithOffset(variables: WorkerEventListWithOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkerEventListWithOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkerEventListWithOffsetQuery>({ document: WorkerEventListWithOffsetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workerEventListWithOffset', 'query', variables);
    },
    workerEventListWithCursor(variables: WorkerEventListWithCursorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WorkerEventListWithCursorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WorkerEventListWithCursorQuery>({ document: WorkerEventListWithCursorDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'workerEventListWithCursor', 'query', variables);
    },
    automationEditions(variables: AutomationEditionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AutomationEditionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationEditionsQuery>({ document: AutomationEditionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'automationEditions', 'query', variables);
    },
    automationBotRuns(variables: AutomationBotRunsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AutomationBotRunsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationBotRunsQuery>({ document: AutomationBotRunsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'automationBotRuns', 'query', variables);
    },
    automationOverrides(variables: AutomationOverridesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AutomationOverridesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationOverridesQuery>({ document: AutomationOverridesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'automationOverrides', 'query', variables);
    },
    automationOverrideCreate(variables: AutomationOverrideCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AutomationOverrideCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationOverrideCreateMutation>({ document: AutomationOverrideCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'automationOverrideCreate', 'mutation', variables);
    },
    automationOverrideSetActive(variables: AutomationOverrideSetActiveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AutomationOverrideSetActiveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationOverrideSetActiveMutation>({ document: AutomationOverrideSetActiveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'automationOverrideSetActive', 'mutation', variables);
    },
    automationHistory(variables: AutomationHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AutomationHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutomationHistoryQuery>({ document: AutomationHistoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'automationHistory', 'query', variables);
    },
    editionsPendingSignatureCompletion(variables?: EditionsPendingSignatureCompletionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionsPendingSignatureCompletionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionsPendingSignatureCompletionQuery>({ document: EditionsPendingSignatureCompletionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionsPendingSignatureCompletion', 'query', variables);
    },
    simulationStart(variables: SimulationStartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimulationStartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimulationStartMutation>({ document: SimulationStartDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simulationStart', 'mutation', variables);
    },
    simulationReset(variables: SimulationResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimulationResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimulationResetMutation>({ document: SimulationResetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simulationReset', 'mutation', variables);
    },
    simulationControl(variables: SimulationControlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimulationControlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimulationControlMutation>({ document: SimulationControlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simulationControl', 'mutation', variables);
    },
    simSession(variables: SimSessionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimSessionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimSessionQuery>({ document: SimSessionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simSession', 'query', variables);
    },
    simActiveSessions(variables: SimActiveSessionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimActiveSessionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimActiveSessionsQuery>({ document: SimActiveSessionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simActiveSessions', 'query', variables);
    },
    simEditions(variables: SimEditionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimEditionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimEditionsQuery>({ document: SimEditionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simEditions', 'query', variables);
    },
    simEditionState(variables: SimEditionStateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimEditionStateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimEditionStateQuery>({ document: SimEditionStateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simEditionState', 'query', variables);
    },
    simWorkerEvents(variables: SimWorkerEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimWorkerEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimWorkerEventsQuery>({ document: SimWorkerEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simWorkerEvents', 'query', variables);
    },
    simBotRuns(variables: SimBotRunsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SimBotRunsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SimBotRunsQuery>({ document: SimBotRunsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'simBotRuns', 'query', variables);
    },
    editionDocumentationWorkflow_GenerateDocumentation(variables: EditionDocumentationWorkflow_GenerateDocumentationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_GenerateDocumentationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_GenerateDocumentationMutation>({ document: EditionDocumentationWorkflow_GenerateDocumentationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_GenerateDocumentation', 'mutation', variables);
    },
    editionDocumentationWorkflow_DeleteAndRestartFromSignature(variables: EditionDocumentationWorkflow_DeleteAndRestartFromSignatureMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_DeleteAndRestartFromSignatureMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_DeleteAndRestartFromSignatureMutation>({ document: EditionDocumentationWorkflow_DeleteAndRestartFromSignatureDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_DeleteAndRestartFromSignature', 'mutation', variables);
    },
    editionDocumentationWorkflow_CancelGeneration(variables: EditionDocumentationWorkflow_CancelGenerationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_CancelGenerationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_CancelGenerationMutation>({ document: EditionDocumentationWorkflow_CancelGenerationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_CancelGeneration', 'mutation', variables);
    },
    editionDocumentationWorkflow_DeleteAndRestartFromGenerated(variables: EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedMutation>({ document: EditionDocumentationWorkflow_DeleteAndRestartFromGeneratedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_DeleteAndRestartFromGenerated', 'mutation', variables);
    },
    editionDocumentationWorkflow_DeleteAndRestartFromFailed(variables: EditionDocumentationWorkflow_DeleteAndRestartFromFailedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_DeleteAndRestartFromFailedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_DeleteAndRestartFromFailedMutation>({ document: EditionDocumentationWorkflow_DeleteAndRestartFromFailedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_DeleteAndRestartFromFailed', 'mutation', variables);
    },
    editionDocumentationWorkflow_RetryGenerateDocumentation(variables: EditionDocumentationWorkflow_RetryGenerateDocumentationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_RetryGenerateDocumentationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_RetryGenerateDocumentationMutation>({ document: EditionDocumentationWorkflow_RetryGenerateDocumentationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_RetryGenerateDocumentation', 'mutation', variables);
    },
    editionDocumentationWorkflow_SendForSignature(variables: EditionDocumentationWorkflow_SendForSignatureMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_SendForSignatureMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_SendForSignatureMutation>({ document: EditionDocumentationWorkflow_SendForSignatureDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_SendForSignature', 'mutation', variables);
    },
    editionDocumentationWorkflow_CancelSending(variables: EditionDocumentationWorkflow_CancelSendingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_CancelSendingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_CancelSendingMutation>({ document: EditionDocumentationWorkflow_CancelSendingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_CancelSending', 'mutation', variables);
    },
    editionDocumentationWorkflow_RetrySendForSignature(variables: EditionDocumentationWorkflow_RetrySendForSignatureMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_RetrySendForSignatureMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_RetrySendForSignatureMutation>({ document: EditionDocumentationWorkflow_RetrySendForSignatureDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_RetrySendForSignature', 'mutation', variables);
    },
    editionDocumentationWorkflow_BackToDocsFromSignatureFailed(variables: EditionDocumentationWorkflow_BackToDocsFromSignatureFailedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_BackToDocsFromSignatureFailedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_BackToDocsFromSignatureFailedMutation>({ document: EditionDocumentationWorkflow_BackToDocsFromSignatureFailedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_BackToDocsFromSignatureFailed', 'mutation', variables);
    },
    editionDocumentationWorkflow_BorrarDocumentacionFromFallo(variables: EditionDocumentationWorkflow_BorrarDocumentacionFromFalloMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_BorrarDocumentacionFromFalloMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_BorrarDocumentacionFromFalloMutation>({ document: EditionDocumentationWorkflow_BorrarDocumentacionFromFalloDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_BorrarDocumentacionFromFallo', 'mutation', variables);
    },
    editionDocumentationWorkflow_ReintentarCierreFirmas(variables: EditionDocumentationWorkflow_ReintentarCierreFirmasMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_ReintentarCierreFirmasMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_ReintentarCierreFirmasMutation>({ document: EditionDocumentationWorkflow_ReintentarCierreFirmasDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_ReintentarCierreFirmas', 'mutation', variables);
    },
    editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct(variables: EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctMutation>({ document: EditionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjctDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct', 'mutation', variables);
    },
    editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar(variables: EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarMutation>({ document: EditionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplarDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar', 'mutation', variables);
    },
    showcaseWorkflow_Submit(variables: ShowcaseWorkflow_SubmitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflow_SubmitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflow_SubmitMutation>({ document: ShowcaseWorkflow_SubmitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflow_Submit', 'mutation', variables);
    },
    showcaseWorkflow_Approve(variables: ShowcaseWorkflow_ApproveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflow_ApproveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflow_ApproveMutation>({ document: ShowcaseWorkflow_ApproveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflow_Approve', 'mutation', variables);
    },
    showcaseWorkflow_Reject(variables: ShowcaseWorkflow_RejectMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflow_RejectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflow_RejectMutation>({ document: ShowcaseWorkflow_RejectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflow_Reject', 'mutation', variables);
    },
    showcaseWorkflow_Fail(variables: ShowcaseWorkflow_FailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflow_FailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflow_FailMutation>({ document: ShowcaseWorkflow_FailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflow_Fail', 'mutation', variables);
    },
    showcaseWorkflow_Retry(variables: ShowcaseWorkflow_RetryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflow_RetryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflow_RetryMutation>({ document: ShowcaseWorkflow_RetryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflow_Retry', 'mutation', variables);
    },
    showcaseWorkflow_Close(variables: ShowcaseWorkflow_CloseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflow_CloseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflow_CloseMutation>({ document: ShowcaseWorkflow_CloseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflow_Close', 'mutation', variables);
    },
    showcaseWorkflow_Reopen(variables: ShowcaseWorkflow_ReopenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShowcaseWorkflow_ReopenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShowcaseWorkflow_ReopenMutation>({ document: ShowcaseWorkflow_ReopenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'showcaseWorkflow_Reopen', 'mutation', variables);
    },
    signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload(variables: SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadMutation>({ document: SignedEditionDndaWorkflow_ExpirarUploadKeyDuranteUploadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflow_ExpirarUploadKeyDuranteUpload', 'mutation', variables);
    },
    signedEditionDndaWorkflow_ReintentarGeneracionEjemplar(variables: SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarMutation>({ document: SignedEditionDndaWorkflow_ReintentarGeneracionEjemplarDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflow_ReintentarGeneracionEjemplar', 'mutation', variables);
    },
    signedEditionDndaWorkflow_ReintentarRegistroDnda(variables: SignedEditionDndaWorkflow_ReintentarRegistroDndaMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflow_ReintentarRegistroDndaMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflow_ReintentarRegistroDndaMutation>({ document: SignedEditionDndaWorkflow_ReintentarRegistroDndaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflow_ReintentarRegistroDnda', 'mutation', variables);
    },
    signedEditionDndaWorkflow_ReintentarUploadEjemplar(variables: SignedEditionDndaWorkflow_ReintentarUploadEjemplarMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflow_ReintentarUploadEjemplarMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflow_ReintentarUploadEjemplarMutation>({ document: SignedEditionDndaWorkflow_ReintentarUploadEjemplarDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflow_ReintentarUploadEjemplar', 'mutation', variables);
    },
    signedEditionDndaWorkflow_ReintentarAvanceRegistro(variables: SignedEditionDndaWorkflow_ReintentarAvanceRegistroMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflow_ReintentarAvanceRegistroMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflow_ReintentarAvanceRegistroMutation>({ document: SignedEditionDndaWorkflow_ReintentarAvanceRegistroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflow_ReintentarAvanceRegistro', 'mutation', variables);
    },
    signedEditionDndaWorkflow_ReintentarAvanceUpload(variables: SignedEditionDndaWorkflow_ReintentarAvanceUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionDndaWorkflow_ReintentarAvanceUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionDndaWorkflow_ReintentarAvanceUploadMutation>({ document: SignedEditionDndaWorkflow_ReintentarAvanceUploadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionDndaWorkflow_ReintentarAvanceUpload', 'mutation', variables);
    },
    signedEditionSadaicWorkflow_ReintentarSubidaSadaic(variables: SignedEditionSadaicWorkflow_ReintentarSubidaSadaicMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignedEditionSadaicWorkflow_ReintentarSubidaSadaicMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignedEditionSadaicWorkflow_ReintentarSubidaSadaicMutation>({ document: SignedEditionSadaicWorkflow_ReintentarSubidaSadaicDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'signedEditionSadaicWorkflow_ReintentarSubidaSadaic', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;